(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.completion-bcf', [
//            'app.workflow-bidder.completion-bcf.pending-bcf',
            'app.workflow-bidder.completion-bcf.bcf-docs'
        ])
        .config(config);


    /** @ngInject */
    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
/*        
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-bidder.prepare-itb', {
            title : 'Prepare ITB',
            icon :  'icon-numeric-2-box',
            weight: 2
        });
*/        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.completion-bcf')
        .controller('AnswerBcfDialogController', AnswerBcfDialogController);

    /** @ngInject */
    function AnswerBcfDialogController($mdDialog,$firebaseObject,mailerService,selectedMail,type,FIREBASE_URL,itbStatusService,loginService)
    {
        //DECLARATION ****************
        var vm = this;

        //METHOD DECLARATION ****************
        vm.executeController = executeController;
        //vm.updatePendingBcf = updatePendingBcf;
        vm.sendMail = sendMail;
        vm.closeDialog = closeDialog;


        //START CONTROLLER *******************************
        vm.executeController();




        // METHODS ****************
        function executeController() 
        {
            vm.form = {
                from: selectedMail.toEmail
            };

            vm.hiddenCC = true;
            vm.hiddenBCC = true;
/*
            var CSSLfooter = '<p><br/><br/>Chart Shipping S.L.<br/>As brokers only<br/>-------------------------------------------<br/>Rambla Catalunya, 53-55, 6A<br/>08007  Barcelona - SPAIN<br/>+34 93 363 2854<br/><h5>This email and any files transmitted with it are confidential and intended solely for the use of the individual or entity to whom they are addressed. This message contains confidential information and is intended only for the individual named. If you are not the named addressee you should not disseminate, distribute or copy this e-mail. Please notify the sender immediately by e-mail if you have received this e-mail by mistake and delete this e-mail from your system. If you are not the intended recipient you are notified that disclosing, copying, distributing or taking any action in reliance on the contents of this information is strictly prohibited.</h5><br/></p>';
            vm.form.message = '<p><br/><br/><a href="https://app.chartbid.com/">You can access to Chartbid here</a></p>' + CSSLfooter;
*/            
            vm.form.message = '';  

            // If replying
            if ( angular.isDefined(selectedMail) )
            {
                vm.form.to = selectedMail.fromEmail;
                vm.form.subject = 'RE: ' + selectedMail.subject;
                
                //vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
                vm.form.message += '<br /><br /><blockquote>On [' + selectedMail.date + '  -  ' + selectedMail.time + ']  ' + selectedMail.fromName + " wrote this communication: <br /><br />" + selectedMail.message + '</blockquote>';

                vm.form.toKey = selectedMail.sender_key;
                vm.form.toName = selectedMail.fromName;
            }
        }


/*
        function updatePendingBcf(pMailKey,pPendingBcf) {

            //ACTUALIZAMOS EL VALOR DE "commencementDate" y "commencementTime" EN LA TABLA "itbs" DE FIREBASE
            var fbUrl = new Firebase(FIREBASE_URL + "/communications/" + pMailKey);
            //var result = $firebaseArray(fbUrl.orderByChild("itbKey").equalTo(pItbKey));
            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    //Assign administrators list to scope
                    var recordToUpdate = data;

                    recordToUpdate.pendingBcf = pPendingBcf;

                    result.$save(recordToUpdate)
                    .then(function(ref) {
                        //console.log("[AnswerBcfDialogController] updatePendingBcf() method => Updated record with pendingBcf = " + pPendingBcf);
                    })

                    .catch(function(error) {
                        //console.log("[AnswerBcfDialogController] updatePendingBcf() method => ERROR saving record: " + error);
                    });
                })

                .catch(function(error) {
                    //console.log("[AnswerBcfDialogController] updatePendingBcf() method => RECORD NOT LOADED: " + error);
                });
        }
*/


        function sendMail(pType) 
        {
            pType = "communication";

            var itbKey = itbStatusService.getItbKey();
            var senderKey = selectedMail.receiver_key;
            var itbSenderKey = itbKey + "&" + senderKey;
            var pendingBcf = false;


/*
            //In case of sending "communication" or "bcf"
            var destinationEmails = vm.form.to;
            var destinationKeys = vm.form.toKey;
            var destinationNames = vm.form.toName;

            if ( (destinationEmails == null) ||(destinationEmails == "") ) {

                alert("Addressee is empty. Please insert an e-mail.");
                return;
            }

            //If communication type is 'bcf' and is a reply => must assign pendingBcf=false (because the BCF has been replied by the Bidder)
            if ( (pType == 'bcf') && (vm.isReply)) {
                pendingBcf = false;
            } else {
                pendingBcf = true;
            }

            if (vm.form.subject.length == 0) {

                vm.form.subject = "Invitation to " + itbStatusService.getItbName();
            }
*/

            var receiverProfile = "administrator";
            var itbReceiverProfile = itbKey + "&" + receiverProfile;

            var dataToSend = {
                'user': 'developer@chartbid.com',
                'password': 'a-Syns6wSuqV4EajR6t7ig',

                //'arrayDestinationEmail': selectedMail.fromEmail,
                'arrayDestinationEmail': '',
                
                //'arrayDestinationKey': selectedMail.sender_key,
                'arrayDestinationKey': '',

                'arrayDestinationName': 'Chart Shipping',   //VERY IMPORTANT => We must to assign "Chart Shipping" if we want the API sends mail to all the Administrators.

                //'emailSender': selectedMail.toEmail,
                'emailSender': loginService.getEmail(),

                //'nameSender': selectedMail.toName,
                'nameSender': loginService.getName(),

                'subject': vm.form.subject,
                'body': vm.form.message,
                'itb_key': itbKey,
                'sender_key': senderKey,
                'itb_sender_key': itbSenderKey,
                'type': pType,
                'pendingBcf': pendingBcf,

                'senderProfile': '',
                'itb_senderProfile': '',

                'receiverProfile': receiverProfile,
                'itb_receiverProfile': itbReceiverProfile

//              'receiver_key': 'RECEIVER_KEY',
//              'itb_receiver_key': 'itbKey&RECEIVER_KEY'
            };


            //ENVIAMOS EL MAIL
            mailerService.processMail(dataToSend);

            //Update the pendingBcf=false for the selected mail
            //vm.updatePendingBcf(selectedMail.$id,false);

            //CERRAMOS LA VENTANA DE DIÁLOGO
            vm.closeDialog();
        }



        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.scrumboard', [])
        .config(config)
        .run(run);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $stateProvider
            .state('app.scrumboard', {
                abstract : true,
                url      : '/scrumboard',
                resolve  : {
                    BoardList: function (apiResolver)
                    {
                        return apiResolver.resolve('scrumboard.boardList@get');
                    }
                },
                bodyClass: 'scrumboard'
            })

            // Home
            .state('app.scrumboard.boards', {
                url    : '/boards',
                views  : {
                    'content@app'                           : {
                        templateUrl: 'app/main/apps/scrumboard/views/boards/boards-view.html',
                        controller : 'BoardsViewController as vm'
                    }
                }
            })

            // Board
            .state('app.scrumboard.boards.board', {
                    url    : '/:id/:uri',
                    views  : {
                        'content@app'                           : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.board': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, apiResolver, BoardService)
                        {
                            return BoardService.getBoardData($stateParams.id);
                        }
                    }
                }
            )

            // Add board
            .state('app.scrumboard.boards.addBoard', {
                    url    : '/add',
                    views  : {
                        'content@app'                           : {
                            templateUrl: 'app/main/apps/scrumboard/scrumboard.html',
                            controller : 'ScrumboardController as vm'
                        },
                        'scrumboardContent@app.scrumboard.boards.addBoard': {
                            templateUrl: 'app/main/apps/scrumboard/views/board/board-view.html',
                            controller : 'BoardViewController as vm'
                        }
                    },
                    resolve: {
                        BoardData: function ($stateParams, apiResolver, BoardService)
                        {
                            return BoardService.addNewBoard();
                        }
                    }
                }
            )

            // Calendar
            .state('app.scrumboard.boards.board.calendar', {
                url  : '/calendar',
                views: {
                    'scrumboardContent@app.scrumboard.boards.board': {
                        templateUrl: 'app/main/apps/scrumboard/views/calendar/calendar-view.html',
                        controller : 'CalendarViewController as vm'
                    }
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/scrumboard');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.scrumboard', {
            title : 'Scrumboard',
            icon  : 'icon-trello',
            state : 'app.scrumboard.boards',
            weight: 5
        });
    }

    /** @ngInject */
    function run(editableThemes)
    {
        /**
         * Inline Edit Configuration
         * @type {string}
         */
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('MembersMenuController', MembersMenuController);

    /** @ngInject */
    function MembersMenuController($document, $mdDialog, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.newMemberSearchInput = '';

        // Methods
        vm.addNewMember = addNewMember;
        vm.removeMember = removeMember;

        ////////

        /**
         * Add New Member
         */
        function addNewMember()
        {
            // Add new member
        }

        /**
         * Remove member
         *
         * @param ev
         * @param memberId
         */
        function removeMember(ev, memberId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Member',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove member?',
                ariaLabel          : 'remove member',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.members;
                arr.splice(arr.indexOf(arr.getById(memberId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idMembers && card.idMembers.indexOf(memberId) > -1 )
                    {
                        card.idMembers.splice(card.idMembers.indexOf(memberId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCalendarEventDialogController', ScrumboardCalendarEventDialogController);

    /** @ngInject */
    function ScrumboardCalendarEventDialogController($mdDialog, dueDate, BoardService, msUtils)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.dueDate = dueDate;
        vm.eventDate = moment(dueDate).toDate();
        vm.newCardName = '';
        vm.newCardListId = '';
        vm.selectedCards = [];

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.closeDialog = closeDialog;
        vm.addNewCard = addNewCard;
        vm.assignDueDate = assignDueDate;

        //////////

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Add New Card
         */
        function addNewCard()
        {
            if ( vm.newCardName === '' || vm.newCardListId === '' )
            {
                return;
            }

            var newCardId = msUtils.guidGenerator();

            vm.board.cards.push({
                "id"               : newCardId,
                "name"             : vm.newCardName,
                "description"      : '',
                "idAttachmentCover": '',
                "idMembers"        : [],
                "idLabels"         : [],
                "attachments"      : [],
                "subscribed"       : false,
                "checklists"       : [],
                "checkItems"       : 0,
                "checkItemsChecked": 0,
                "comments"         : [],
                "activities"       : [],
                "due"              : vm.eventDate
            });

            vm.board.lists.getById(vm.newCardListId).idCards.push(newCardId);

            vm.newCardName = vm.newCardListId = '';

            closeDialog();
        }

        /**
         * Assign Due Date
         */
        function assignDueDate()
        {
            angular.forEach(vm.selectedCards, function (cardId)
            {
                vm.board.cards.getById(cardId).due = vm.eventDate;
            });

            vm.selectedCards = [];

            closeDialog();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('LabelsMenuController', LabelsMenuController);

    /** @ngInject */
    function LabelsMenuController($document, $mdColorPalette, $mdDialog, fuseGenerator, msUtils, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.rgba = fuseGenerator.rgba;
        vm.hue = 500;
        vm.newLabelColor = 'red';
        vm.newLabelName = '';

        // Methods
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;

        ////////

        /**
         * Add New Label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                "id"   : msUtils.guidGenerator(),
                "name" : vm.newLabelName,
                "color": vm.newLabelColor
            });
            vm.newLabelName = '';
        }

        /**
         * Remove label
         *
         * @param ev
         * @param labelId
         */
        function removeLabel(ev, labelId)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Label',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove label?',
                ariaLabel          : 'remove label',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var arr = vm.board.labels;
                arr.splice(arr.indexOf(arr.getById(labelId)), 1);

                angular.forEach(vm.board.cards, function (card)
                {
                    if ( card.idLabels && card.idLabels.indexOf(labelId) > -1 )
                    {
                        card.idLabels.splice(card.idLabels.indexOf(labelId), 1);
                    }
                });
            }, function ()
            {
                // Canceled
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ColorMenuController', ColorMenuController);

    /** @ngInject */
    function ColorMenuController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;

        // Methods

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/pages/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth', {
            title : 'Authentication',
            icon  : 'icon-lock',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('pages.auth.login', {
            title : 'Login',
            state : 'app.pages_auth_login',
            weight: 1
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('SelectBiddersDialogController', SelectBiddersDialogController);

    /** @ngInject */
    function SelectBiddersDialogController($mdDialog,$document,$location,loginService,bidders,email)
    {

        // DECLARATIONS ***********************
        var vm = this;
        vm.bidders;
        vm.email;


        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.selectBidder = selectBidder;
        vm.closeDialog = closeDialog;



        //START CONTROLLER *******************************
        vm.executeController();



        // METHODS ****************
        function executeController() 
        {
            vm.bidders = bidders;
            vm.email = email;
        }



        function selectBidder(pBidder) {

//console.log("pBidder.$id = " + pBidder.$id);
//console.log("pBidder.name = " + pBidder.company);
//console.log("pBidder.email = " + vm.email);

            loginService.setUserKey(pBidder.$id);
            loginService.setName(pBidder.company);
            loginService.setEmail(vm.email);
            loginService.setUserProfile("bidder");

            $location.path("/workflow-bidder/select-itb");

            $mdDialog.hide();
        }

/*
        function getAdministrators() {

            //console.log("[ComposeMailDialogController]  Get administrators list ");

            //Get bidders list from Firebase        
            var fbUrl = new Firebase(FIREBASE_URL + "/administrators/");
            //vm.administrators = $firebaseArray(fbUrl.orderByChild("email"));
            vm.administrators = $firebaseArray(fbUrl);

            vm.administrators.$loaded()
                .then(function(data) {

                    //Assign bidders list to scope
                    vm.administrators = data;

                    //console.log("[ComposeMailDialogController] Administrators list LOADED with " + data.length + " elements.");

                    //Load the grid with de bidders list
                    //vm.loadGrid(vm.biddersOfItb)

                    vm.getAdministratorsList();
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[ComposeMailDialogController] ERROR in function getAdministrators(): " + error);
                });
        }
*/



        function closeDialog() 
        {
            $mdDialog.hide();
        }






    }
})();

angular.module('whiteframeBasicUsage', ['ngMaterial']);

(function () {
  'use strict';

    angular
      .module('virtualRepeatInfiniteScrollDemo', ['ngMaterial'])
      .controller('AppCtrl', function($timeout) {

        // In this example, we set up our model using a plain object.
        // Using a class works too. All that matters is that we implement
        // getItemAtIndex and getLength.
        this.infiniteItems = {
          numLoaded_: 0,
          toLoad_: 0,

          // Required.
          getItemAtIndex: function(index) {
            if (index > this.numLoaded_) {
              this.fetchMoreItems_(index);
              return null;
            }

            return index;
          },

          // Required.
          // For infinite scroll behavior, we always return a slightly higher
          // number than the previously loaded items.
          getLength: function() {
            return this.numLoaded_ + 5;
          },

          fetchMoreItems_: function(index) {
            // For demo purposes, we simulate loading more items with a timed
            // promise. In real code, this function would likely contain an
            // $http request.

            if (this.toLoad_ < index) {
              this.toLoad_ += 20;
              $timeout(angular.noop, 300).then(angular.bind(this, function() {
                this.numLoaded_ = this.toLoad_;
              }));
            }
          }
        };
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatVerticalDemo', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.items = [];
        for (var i = 0; i < 1000; i++) {
          this.items.push(i);
        }
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatScrollToDemo', ['ngMaterial'])
      .controller('AppCtrl', function($scope) {
        this.selectedYear = 0;
        this.years = [];
        this.items = [];
        var currentYear = new Date().getFullYear();
        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'];
        // Build a list of months over 20 years
        for (var y = currentYear; y >= (currentYear-20); y--) {
          this.years.push(y);
          this.items.push({year: y, text: y, header: true});
          for (var m = 11; m >= 0; m--) {
            this.items.push({year: y, month: m, text: monthNames[m]});
          }
        }
        // Whenever a different year is selected, scroll to that year
        $scope.$watch('ctrl.selectedYear', angular.bind(this, function(yearIndex) {
          var scrollYear = Math.floor(this.topIndex / 13);
          if(scrollYear !== yearIndex) {
            this.topIndex = yearIndex * 13;
          }
        }));
        // The selected year should follow the year that is at the top of the scroll container
        $scope.$watch('ctrl.topIndex', angular.bind(this, function(topIndex) {
          var scrollYear = Math.floor(topIndex / 13);
          this.selectedYear = scrollYear;
        }));
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatHorizontalDemo', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.items = [];
        for (var i = 0; i < 1000; i++) {
          this.items.push(i);
        }
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatDeferredLoadingDemo', ['ngMaterial'])
      .controller('AppCtrl', function($timeout) {

        // In this example, we set up our model using a class.
        // Using a plain object works too. All that matters
        // is that we implement getItemAtIndex and getLength.
        var DynamicItems = function() {
          /**
           * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
           */
          this.loadedPages = {};

          /** @type {number} Total number of items. */
          this.numItems = 0;

          /** @const {number} Number of items to fetch per request. */
          this.PAGE_SIZE = 50;

          this.fetchNumItems_();
        };

        // Required.
        DynamicItems.prototype.getItemAtIndex = function(index) {
          var pageNumber = Math.floor(index / this.PAGE_SIZE);
          var page = this.loadedPages[pageNumber];

          if (page) {
            return page[index % this.PAGE_SIZE];
          } else if (page !== null) {
            this.fetchPage_(pageNumber);
          }
        };

        // Required.
        DynamicItems.prototype.getLength = function() {
          return this.numItems;
        };

        DynamicItems.prototype.fetchPage_ = function(pageNumber) {
          // Set the page to null so we know it is already being fetched.
          this.loadedPages[pageNumber] = null;

          // For demo purposes, we simulate loading more items with a timed
          // promise. In real code, this function would likely contain an
          // $http request.
          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.loadedPages[pageNumber] = [];
            var pageOffset = pageNumber * this.PAGE_SIZE;
            for (var i = pageOffset; i < pageOffset + this.PAGE_SIZE; i++) {
              this.loadedPages[pageNumber].push(i);
            }
          }));
        };

        DynamicItems.prototype.fetchNumItems_ = function() {
          // For demo purposes, we simulate loading the item count with a timed
          // promise. In real code, this function would likely contain an
          // $http request.
          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.numItems = 50000;
          }));
        };
        
        this.dynamicItems = new DynamicItems();
      });
})();

angular.module('tooltipDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {
  $scope.demo = {
    showTooltip : false,
    tipDirection : ''
  };

  $scope.$watch('demo.tipDirection',function(val) {
    if (val && val.length ) {
      $scope.demo.showTooltip = true;
    }
  })
});


angular.module('toastDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdToast, $document) {
  var last = {
      bottom: false,
      top: true,
      left: false,
      right: true
    };

  $scope.toastPosition = angular.extend({},last);

  $scope.getToastPosition = function() {
    sanitizePosition();

    return Object.keys($scope.toastPosition)
      .filter(function(pos) { return $scope.toastPosition[pos]; })
      .join(' ');
  };

  function sanitizePosition() {
    var current = $scope.toastPosition;

    if ( current.bottom && last.top ) current.top = false;
    if ( current.top && last.bottom ) current.bottom = false;
    if ( current.right && last.left ) current.left = false;
    if ( current.left && last.right ) current.right = false;

    last = angular.extend({},current);
  }

  $scope.showCustomToast = function() {
    $mdToast.show({
      controller: 'ToastCtrl',
      templateUrl: 'toast-template.html',
      parent : $document[0].querySelector('#toastBounds'),
      hideDelay: 6000,
      position: $scope.getToastPosition()
    });
  };

  $scope.showSimpleToast = function() {
    $mdToast.show(
      $mdToast.simple()
        .textContent('Simple Toast!')
        .position($scope.getToastPosition())
        .hideDelay(3000)
    );
  };

  $scope.showActionToast = function() {
    var toast = $mdToast.simple()
          .textContent('Action Toast!')
          .action('OK')
          .highlightAction(false)
          .position($scope.getToastPosition());

    $mdToast.show(toast).then(function(response) {
      if ( response == 'ok' ) {
        alert('You clicked \'OK\'.');
      }
    });
  };

})

.controller('ToastCtrl', function($scope, $mdToast) {
  $scope.closeToast = function() {
    $mdToast.hide();
  };
});

var app = angular.module('toolbarDemo2', ['ngMaterial']);

app.controller('TitleController', function($scope) {
  $scope.title = 'My App Title';
});

app.controller('AppCtrl', function($scope) {
  var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';

  $scope.todos = [];
  for (var i = 0; i < 15; i++) {
    $scope.todos.push({
      face: imagePath,
      what: "Brunch this weekend?",
      who: "Min Li Chan",
      notes: "I'll be in your neighborhood doing errands."
    });
  }
});


angular.module('toolbarDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

});

(function () {
  'use strict';

  angular
      .module('tabsDemoStaticTabs', ['ngMaterial'] )
      .controller('AppCtrl', AppCtrl);

  function AppCtrl ( $scope ) {
    $scope.data = {
      selectedIndex: 0,
      secondLocked:  true,
      secondLabel:   "Item Two",
      bottom:        false
    };
    $scope.next = function() {
      $scope.data.selectedIndex = Math.min($scope.data.selectedIndex + 1, 2) ;
    };
    $scope.previous = function() {
      $scope.data.selectedIndex = Math.max($scope.data.selectedIndex - 1, 0);
    };
  }
})();

(function () {
  'use strict';
  angular
      .module('tabsDemoDynamicTabs', ['ngMaterial'])
      .controller('AppCtrl', AppCtrl);

  function AppCtrl ($scope, $log) {
    var tabs = [
          { title: 'One', content: "Tabs will become paginated if there isn't enough room for them."},
          { title: 'Two', content: "You can swipe left and right on a mobile device to change tabs."},
          { title: 'Three', content: "You can bind the selected tab via the selected attribute on the md-tabs element."},
          { title: 'Four', content: "If you set the selected tab binding to -1, it will leave no tab selected."},
          { title: 'Five', content: "If you remove a tab, it will try to select a new one."},
          { title: 'Six', content: "There's an ink bar that follows the selected tab, you can turn it off if you want."},
          { title: 'Seven', content: "If you set ng-disabled on a tab, it becomes unselectable. If the currently selected tab becomes disabled, it will try to select the next tab."},
          { title: 'Eight', content: "If you look at the source, you're using tabs to look at a demo for tabs. Recursion!"},
          { title: 'Nine', content: "If you set md-theme=\"green\" on the md-tabs element, you'll get green tabs."},
          { title: 'Ten', content: "If you're still reading this, you should just go check out the API docs for tabs!"}
        ],
        selected = null,
        previous = null;
    $scope.tabs = tabs;
    $scope.selectedIndex = 2;
    $scope.$watch('selectedIndex', function(current, old){
      previous = selected;
      selected = tabs[current];
      if ( old + 1 && (old != current)) $log.debug('Goodbye ' + previous.title + '!');
      if ( current + 1 )                $log.debug('Hello ' + selected.title + '!');
    });
    $scope.addTab = function (title, view) {
      view = view || title + " Content View";
      tabs.push({ title: title, content: view, disabled: false});
    };
    $scope.removeTab = function (tab) {
      var index = tabs.indexOf(tab);
      tabs.splice(index, 1);
    };
  }
})();


angular.module('switchDemo1', ['ngMaterial'])
.controller('SwitchDemoCtrl', function($scope) {
  $scope.data = {
    cb1: true,
    cb4: true,
    cb5: false
  };

  $scope.message = 'false';

  $scope.onChange = function(cbState) {
  	$scope.message = cbState;
  };
});


angular.module('subheaderBasicDemo', ['ngMaterial'])
.config(function($mdThemingProvider) {
  $mdThemingProvider.theme('altTheme')
    .primaryPalette('purple');
})
.controller('SubheaderAppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';
    $scope.messages = [
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});

angular.module('demoSwipe', ['ngMaterial'])
  .controller('demoSwipeCtrl', function($scope) {
    $scope.onSwipeLeft = function(ev) {
      alert('You swiped left!!');
    };

    $scope.onSwipeRight = function(ev) {
      alert('You swiped right!!');
    };
    $scope.onSwipeUp = function(ev) {
      alert('You swiped up!!');
    };

    $scope.onSwipeDown = function(ev) {
      alert('You swiped down!!');
    };
  });


angular.module('sliderDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

  $scope.color = {
    red: Math.floor(Math.random() * 255),
    green: Math.floor(Math.random() * 255),
    blue: Math.floor(Math.random() * 255)
  };

  $scope.rating1 = 3;
  $scope.rating2 = 2;
  $scope.rating3 = 4;

  $scope.disabled1 = 0;
  $scope.disabled2 = 70;

});

angular.module('selectDemoValidation', ['ngMaterial', 'ngMessages'])
.controller('AppCtrl', function($scope) {
  $scope.clearValue = function() {
    $scope.myModel = undefined;
  };
  $scope.save = function() {
    alert('Form was valid!');
  };
});

angular
  .module('sidenavDemo1', ['ngMaterial'])
  .controller('AppCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.toggleLeft = buildDelayedToggler('left');
    $scope.toggleRight = buildToggler('right');
    $scope.isOpenRight = function(){
      return $mdSidenav('right').isOpen();
    };

    /**
     * Supplies a function that will continue to operate until the
     * time is up.
     */
    function debounce(func, wait, context) {
      var timer;

      return function debounced() {
        var context = $scope,
            args = Array.prototype.slice.call(arguments);
        $timeout.cancel(timer);
        timer = $timeout(function() {
          timer = undefined;
          func.apply(context, args);
        }, wait || 10);
      };
    }

    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildDelayedToggler(navID) {
      return debounce(function() {
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      }, 200);
    }

    function buildToggler(navID) {
      return function() {
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      }
    }
  })
  .controller('LeftCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      $mdSidenav('left').close()
        .then(function () {
          $log.debug("close LEFT is done");
        });

    };
  })
  .controller('RightCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      $mdSidenav('right').close()
        .then(function () {
          $log.debug("close RIGHT is done");
        });
    };
  });

angular
    .module('selectDemoOptGroups', ['ngMaterial'])
    .controller('SelectOptGroupController', function($scope) {
      $scope.sizes = [
          "small (12-inch)",
          "medium (14-inch)",
          "large (16-inch)",
          "insane (42-inch)"
      ];
      $scope.toppings = [
        { category: 'meat', name: 'Pepperoni' },
        { category: 'meat', name: 'Sausage' },
        { category: 'meat', name: 'Ground Beef' },
        { category: 'meat', name: 'Bacon' },
        { category: 'veg', name: 'Mushrooms' },
        { category: 'veg', name: 'Onion' },
        { category: 'veg', name: 'Green Pepper' },
        { category: 'veg', name: 'Green Olives' }
      ];
    });

angular.module('selectDemoOptionsAsync', ['ngMaterial'])
.controller('SelectAsyncController', function($timeout, $scope) {
  $scope.user = null;
  $scope.users = null;

  $scope.loadUsers = function() {

    // Use timeout to simulate a 650ms request.
    return $timeout(function() {

      $scope.users =  $scope.users  || [
        { id: 1, name: 'Scooby Doo' },
        { id: 2, name: 'Shaggy Rodgers' },
        { id: 3, name: 'Fred Jones' },
        { id: 4, name: 'Daphne Blake' },
        { id: 5, name: 'Velma Dinkley' }
      ];

    }, 650);
  };
});

(function () {
  'use strict';
  angular
      .module('selectDemoBasic', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.userState = '';
        this.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
            'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
            'WY').split(' ').map(function (state) { return { abbrev: state }; });
      });
})();

angular
  .module('radioDemo2', ['ngMaterial'])
  .controller('ContactController', function($scope) {
    var self = this;

    self.contacts = [{
      'id': 1,
      'fullName': 'Maria Guadalupe',
      'lastName': 'Guadalupe',
      'title': "CEO, Found"
    }, {
      'id': 2,
      'fullName': 'Gabriel García Marquéz',
      'lastName': 'Marquéz',
      'title': "VP Sales & Marketing"
    }, {
      'id': 3,
      'fullName': 'Miguel de Cervantes',
      'lastName': 'Cervantes',
      'title': "Manager, Operations"
    }, {
      'id': 4,
      'fullName': 'Pacorro de Castel',
      'lastName': 'Castel',
      'title': "Security"
    }];
    self.selectedIndex = 2;
    self.selectedUser = function() {
      return self.contacts[self.selectedIndex].lastName;
    }
  });

angular.module('progressLinearDemo1', ['ngMaterial'])
  .config(function($mdThemingProvider) {
  })
  .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
    var self = this, j= 0, counter = 0;

    self.mode = 'query';
    self.activated = true;
    self.determinateValue = 30;
    self.determinateValue2 = 30;

    self.modes = [ ];

    /**
     * Turn off or on the 5 themed loaders
     */
    self.toggleActivation = function() {
        if ( !self.activated ) self.modes = [ ];
        if (  self.activated ) {
          j = counter = 0;
          self.determinateValue = 30;
          self.determinateValue2 = 30;
        }
    };

    $interval(function() {
      self.determinateValue += 1;
      self.determinateValue2 += 1.5;

      if (self.determinateValue > 100) self.determinateValue = 30;
      if (self.determinateValue2 > 100) self.determinateValue2 = 30;

        // Incrementally start animation the five (5) Indeterminate,
        // themed progress circular bars

        if ( (j < 2) && !self.modes[j] && self.activated ) {
          self.modes[j] = (j==0) ? 'buffer' : 'query';
        }
        if ( counter++ % 4 == 0 ) j++;

        // Show the indicator in the "Used within Containers" after 200ms delay
        if ( j == 2 ) self.contained = "indeterminate";

    }, 100, 0, true);

    $interval(function() {
      self.mode = (self.mode == 'query' ? 'determinate' : 'query');
    }, 7200, 0, true);
  }]);


angular
  .module('radioDemo1', ['ngMaterial'])
  .controller('AppCtrl', function($scope) {

    $scope.data = {
      group1 : 'Banana',
      group2 : '2',
      group3 : 'avatar-1'
    };

    $scope.avatarData = [{
        id: "avatars:svg-1",
        title: 'avatar 1',
        value: 'avatar-1'
      },{
        id: "avatars:svg-2",
        title: 'avatar 2',
        value: 'avatar-2'
      },{
        id: "avatars:svg-3",
        title: 'avatar 3',
        value: 'avatar-3'
    }];

    $scope.radioData = [
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: '3', isDisabled: true },
      { label: '4', value: '4' }
    ];


    $scope.submit = function() {
      alert('submit');
    };

    $scope.addItem = function() {
      var r = Math.ceil(Math.random() * 1000);
      $scope.radioData.push({ label: r, value: r });
    };

    $scope.removeItem = function() {
      $scope.radioData.pop();
    };

  })
  .config(function($mdIconProvider) {
    $mdIconProvider.iconSet("avatars", 'assets/angular-material-assets/icons/avatar-icons.svg',128);
  });

angular
  .module('menuBarDemoBasic', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
  })
  .filter('keyboardShortcut', function($window) {
    return function(str) {
      if (!str) return;
      var keys = str.split('-');
      var isOSX = /Mac OS X/.test($window.navigator.userAgent);

      var seperator = (!isOSX || keys.length > 2) ? '+' : '';

      var abbreviations = {
        M: isOSX ? '⌘' : 'Ctrl',
        A: isOSX ? 'Option' : 'Alt',
        S: 'Shift'
      };

      return keys.map(function(key, index) {
        var last = index == keys.length - 1;
        return last ? key : abbreviations[key];
      }).join(seperator);
    };
  })
  .controller('DemoBasicCtrl', function DemoCtrl($mdDialog) {
    this.settings = {
      printLayout: true,
      showRuler: true,
      showSpellingSuggestions: true,
      presentationMode: 'edit'
    };

    this.sampleAction = function(name, ev) {
      $mdDialog.show($mdDialog.alert()
        .title(name)
        .textContent('You triggered the "' + name + '" action')
        .ok('Great')
        .targetEvent(ev)
      );
    };
  });


angular
  .module('progressCircularDemo1', ['ngMaterial'])
  .controller('AppCtrl', ['$scope', '$interval',
    function($scope, $interval) {
      var self = this,  j= 0, counter = 0;

      self.modes = [ ];
      self.activated = true;
      self.determinateValue = 30;

      /**
       * Turn off or on the 5 themed loaders
       */
      self.toggleActivation = function() {
          if ( !self.activated ) self.modes = [ ];
          if (  self.activated ) j = counter = 0;
      };

      // Iterate every 100ms, non-stop
      $interval(function() {

        // Increment the Determinate loader

        self.determinateValue += 1;
        if (self.determinateValue > 100) {
          self.determinateValue = 30;
        }

        // Incrementally start animation the five (5) Indeterminate,
        // themed progress circular bars

        if ( (j < 5) && !self.modes[j] && self.activated ) {
          self.modes[j] = 'indeterminate';
        }
        if ( counter++ % 4 == 0 ) j++;

      }, 100, 0, true);
    }
  ]);

angular.module('menuDemoWidth', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
    .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
})
.controller('WidthDemoCtrl', DemoCtrl);

function DemoCtrl($mdDialog) {
  var vm = this;

  this.announceClick = function(index) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('You clicked!')
        .textContent('You clicked the menu item at index ' + index)
        .ok('Nice')
    );
  };
}


angular
  .module('menuDemoPosition', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
      .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .controller('PositionDemoCtrl', function DemoCtrl($mdDialog) {
    var originatorEv;

    this.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    this.announceClick = function(index) {
      $mdDialog.show(
        $mdDialog.alert()
          .title('You clicked!')
          .textContent('You clicked the menu item at index ' + index)
          .ok('Nice')
          .targetEvent(originatorEv)
      );
      originatorEv = null;
    };
  });



angular
  .module('menuDemoBasic', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
      .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .controller('BasicDemoCtrl', function DemoCtrl($mdDialog) {
    var originatorEv;

    this.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    this.notificationsEnabled = true;
    this.toggleNotifications = function() {
      this.notificationsEnabled = !this.notificationsEnabled;
    };

    this.redial = function() {
      $mdDialog.show(
        $mdDialog.alert()
          .targetEvent(originatorEv)
          .clickOutsideToClose(true)
          .parent('body')
          .title('Suddenly, a redial')
          .textContent('You just called a friend; who told you the most amazing story. Have a cookie!')
          .ok('That was easy')
      );

      originatorEv = null;
    };

    this.checkVoicemail = function() {
      // This never happens.
    };
  });

angular.module('listDemo2', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet('social', 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24)
    .iconSet('device', 'assets/angular-material-assets/img/icons/sets/device-icons.svg', 24)
    .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
    .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
})
.controller('ListCtrl', function($scope, $mdDialog) {
  $scope.toppings = [
    { name: 'Pepperoni', wanted: true },
    { name: 'Sausage', wanted: false },
    { name: 'Black Olives', wanted: true },
    { name: 'Green Peppers', wanted: false }
  ];

  $scope.settings = [
    { name: 'Wi-Fi', extraScreen: 'Wi-fi menu', icon: 'device:network-wifi', enabled: true },
    { name: 'Bluetooth', extraScreen: 'Bluetooth menu', icon: 'device:bluetooth', enabled: false },
  ];

  $scope.messages = [
    {id: 1, title: "Message A", selected: false},
    {id: 2, title: "Message B", selected: true},
    {id: 3, title: "Message C", selected: true},
  ];

  $scope.people = [
    { name: 'Janet Perkins', img: 'assets/angular-material-assets/img/100-0.jpeg', newMessage: true },
    { name: 'Mary Johnson', img: 'assets/angular-material-assets/img/100-1.jpeg', newMessage: false },
    { name: 'Peter Carlsson', img: 'assets/angular-material-assets/img/100-2.jpeg', newMessage: false }
  ];

  $scope.goToPerson = function(person, event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Navigating')
        .textContent('Inspect ' + person)
        .ariaLabel('Person inspect demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

  $scope.navigateTo = function(to, event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Navigating')
        .textContent('Imagine being taken to ' + to)
        .ariaLabel('Navigation demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

  $scope.doPrimaryAction = function(event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Primary Action')
        .textContent('Primary actions can be used for one click actions')
        .ariaLabel('Primary click demo')
        .ok('Awesome!')
        .targetEvent(event)
    );
  };

  $scope.doSecondaryAction = function(event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Secondary Action')
        .textContent('Secondary actions can be used for one click actions')
        .ariaLabel('Secondary click demo')
        .ok('Neat!')
        .targetEvent(event)
    );
  };

});


angular.module('listDemo1', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24);
})
.controller('AppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';

    $scope.phones = [
      { type: 'Home', number: '(555) 251-1234' },
      { type: 'Cell', number: '(555) 786-9841' },
      { type: 'Office', number: '(555) 314-1592' }
    ];
    $scope.todos = [
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});

angular
  .module('inputIconDemo', ['ngMaterial', 'ngMessages'])
  .controller('DemoCtrl', function($scope) {
    $scope.user = {
      name: 'John Doe',
      email: '',
      phone: '',
      address: 'Mountain View, CA',
      donation: 19.99
    };
  });

angular.module('inputErrorsApp', ['ngMaterial', 'ngMessages'])

.controller('AppCtrl', function($scope) {
  $scope.project = {
    description: 'Nuclear Missile Defense System',
    rate: 500
  };
});

angular.module('inputErrorsAdvancedApp', ['ngMaterial', 'ngMessages'])

  .controller('AppCtrl', function($scope) {
    $scope.showHints = true;

    $scope.user = {
      name: "",
      email: "",
      social: "123456789",
      phone: "N/A"
    };
  });

angular
  .module('inputBasicDemo', ['ngMaterial', 'ngMessages'])
  .controller('DemoCtrl', function($scope) {
    $scope.user = {
      title: 'Developer',
      email: 'ipsum@lorem.com',
      firstName: '',
      lastName: '',
      company: 'Google',
      address: '1600 Amphitheatre Pkwy',
      city: 'Mountain View',
      state: 'CA',
      biography: 'Loves kittens, snowboarding, and can type at 130 WPM.\n\nAnd rumor has it she bouldered up Castle Craig!',
      postalCode: '94043'
    };

    $scope.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
    'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
    'WY').split(' ').map(function(state) {
        return {abbrev: state};
      })
  })
  .config(function($mdThemingProvider) {

    // Configure a dark theme with primary foreground yellow

    $mdThemingProvider.theme('docs-dark', 'default')
      .primaryPalette('yellow')
      .dark();

  });


angular.module('appUsingTemplateCache', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(function($mdIconProvider) {

    // Register icon IDs with sources. Future $mdIcon( <id> ) lookups
    // will load by url and retrieve the data via the $http and $templateCache

    $mdIconProvider
      .iconSet('core', 'assets/angular-material-assets/img/icons/sets/core-icons.svg',24)
      .icon('social:cake', 'assets/angular-material-assets/img/icons/cake.svg',24);

  })
  .run(function($http, $templateCache) {

    var urls = [
      'assets/angular-material-assets/img/icons/sets/core-icons.svg',
      'assets/angular-material-assets/img/icons/cake.svg',
      'assets/angular-material-assets/img/icons/android.svg'
    ];

    // Pre-fetch icons sources by URL and cache in the $templateCache...
    // subsequent $http calls will look there first.

    angular.forEach(urls, function(url) {
      $http.get(url, {cache: $templateCache});
    });

  })
  ;


angular.module('appSvgIconSets', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(['$mdIconProvider', function($mdIconProvider) {
    $mdIconProvider
      .iconSet('social', 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24)
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
  }]);


angular
  .module('appDemoFontIconsWithLigatures', ['ngMaterial'])
  .controller('DemoCtrl', function( $scope ) {
      // Specify a list of font-icons with ligatures and color overrides
      var iconData = [
            {name: 'accessibility'  , color: "#777" },
            {name: 'question_answer', color: "rgb(89, 226, 168)" },
            {name: 'backup'         , color: "#A00" },
            {name: 'email'          , color: "#00A" }
          ];

      $scope.fonts = [].concat(iconData);

      // Create a set of sizes...
      $scope.sizes = [
        {size:"md-18",padding:0},
        {size:"md-24",padding:2},
        {size:"md-36",padding:6},
        {size:"md-48",padding:10}
      ];

  });


angular.module('appDemoSvgIcons', ['ngMaterial'])
.controller('DemoCtrl', function( $scope ) {

    $scope.insertDriveIconURL = 'assets/angular-material-assets/img/icons/ic_insert_drive_file_24px.svg';
    $scope.getAndroid = function() {
      return 'assets/angular-material-assets/img/icons/android.svg';
    }
});


angular
  .module('appDemoFontIconsWithClassnames', ['ngMaterial'])
  .controller('DemoCtrl', function( $scope ) {
      // Create list of font-icon names with color overrides
      var iconData = [
            {name: 'icon-home'        , color: "#777" },
            {name: 'icon-user-plus'   , color: "rgb(89, 226, 168)" },
            {name: 'icon-google-plus2', color: "#A00" },
            {name: 'icon-youtube4'    , color:"#00A" },
             // Use theming to color the font-icon
            {name: 'icon-settings'    , color:"#A00", theme:"md-warn md-hue-5"}
          ];

      // Create a set of sizes...
      $scope.sizes = [
        {size:48,padding:10},
        {size:36,padding:6},
        {size:24,padding:2},
        {size:12,padding:0}
      ];

      $scope.fonts = [].concat(iconData);



  })
  .config(function($mdThemingProvider){
    // Update the theme colors to use themes on font-icons
    $mdThemingProvider.theme('default')
          .primaryPalette("red")
          .accentPalette('green')
          .warnPalette('blue');
  });


angular.module('gridListDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {
  var COLORS = ['#ffebee', '#ffcdd2', '#ef9a9a', '#e57373', '#ef5350', '#f44336', '#e53935', '#d32f2f', '#c62828', '#b71c1c', '#ff8a80', '#ff5252', '#ff1744', '#d50000', '#f8bbd0', '#f48fb1', '#f06292', '#ec407a', '#e91e63', '#d81b60', '#c2185b', '#ad1457', '#880e4f', '#ff80ab', '#ff4081', '#f50057', '#c51162', '#e1bee7', '#ce93d8', '#ba68c8', '#ab47bc', '#9c27b0', '#8e24aa', '#7b1fa2', '#4a148c', '#ea80fc', '#e040fb', '#d500f9', '#aa00ff', '#ede7f6', '#d1c4e9', '#b39ddb', '#9575cd', '#7e57c2', '#673ab7', '#5e35b1', '#4527a0', '#311b92', '#b388ff', '#7c4dff', '#651fff', '#6200ea', '#c5cae9', '#9fa8da', '#7986cb', '#5c6bc0', '#3f51b5', '#3949ab', '#303f9f', '#283593', '#1a237e', '#8c9eff', '#536dfe', '#3d5afe', '#304ffe', '#e3f2fd', '#bbdefb', '#90caf9', '#64b5f6', '#42a5f5', '#2196f3', '#1e88e5', '#1976d2', '#1565c0', '#0d47a1', '#82b1ff', '#448aff', '#2979ff', '#2962ff', '#b3e5fc', '#81d4fa', '#4fc3f7', '#29b6f6', '#03a9f4', '#039be5', '#0288d1', '#0277bd', '#01579b', '#80d8ff', '#40c4ff', '#00b0ff', '#0091ea', '#e0f7fa', '#b2ebf2', '#80deea', '#4dd0e1', '#26c6da', '#00bcd4', '#00acc1', '#0097a7', '#00838f', '#006064', '#84ffff', '#18ffff', '#00e5ff', '#00b8d4', '#e0f2f1', '#b2dfdb', '#80cbc4', '#4db6ac', '#26a69a', '#009688', '#00897b', '#00796b', '#00695c', '#a7ffeb', '#64ffda', '#1de9b6', '#00bfa5', '#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784', '#66bb6a', '#4caf50', '#43a047', '#388e3c', '#2e7d32', '#1b5e20', '#b9f6ca', '#69f0ae', '#00e676', '#00c853', '#f1f8e9', '#dcedc8', '#c5e1a5', '#aed581', '#9ccc65', '#8bc34a', '#7cb342', '#689f38', '#558b2f', '#33691e', '#ccff90', '#b2ff59', '#76ff03', '#64dd17', '#f9fbe7', '#f0f4c3', '#e6ee9c', '#dce775', '#d4e157', '#cddc39', '#c0ca33', '#afb42b', '#9e9d24', '#827717', '#f4ff81', '#eeff41', '#c6ff00', '#aeea00', '#fffde7', '#fff9c4', '#fff59d', '#fff176', '#ffee58', '#ffeb3b', '#fdd835', '#fbc02d', '#f9a825', '#f57f17', '#ffff8d', '#ffff00', '#ffea00', '#ffd600', '#fff8e1', '#ffecb3', '#ffe082', '#ffd54f', '#ffca28', '#ffc107', '#ffb300', '#ffa000', '#ff8f00', '#ff6f00', '#ffe57f', '#ffd740', '#ffc400', '#ffab00', '#fff3e0', '#ffe0b2', '#ffcc80', '#ffb74d', '#ffa726', '#ff9800', '#fb8c00', '#f57c00', '#ef6c00', '#e65100', '#ffd180', '#ffab40', '#ff9100', '#ff6d00', '#fbe9e7', '#ffccbc', '#ffab91', '#ff8a65', '#ff7043', '#ff5722', '#f4511e', '#e64a19', '#d84315', '#bf360c', '#ff9e80', '#ff6e40', '#ff3d00', '#dd2c00', '#d7ccc8', '#bcaaa4', '#795548', '#d7ccc8', '#bcaaa4', '#8d6e63', '#eceff1', '#cfd8dc', '#b0bec5', '#90a4ae', '#78909c', '#607d8b', '#546e7a', '#cfd8dc', '#b0bec5', '#78909c'];

  this.colorTiles = (function() {
    var tiles = [];
    for (var i = 0; i < 46; i++) {
      tiles.push({
        color: randomColor(),
        colspan: randomSpan(),
        rowspan: randomSpan()
      });
    }
    return tiles;
  })();


  function randomColor() {
    return COLORS[Math.floor(Math.random() * COLORS.length)];
  }

  function randomSpan() {
    var r = Math.random();
    if (r < 0.8) {
      return 1;
    } else if (r < 0.9) {
      return 2;
    } else {
      return 3;
    }
  }
});


angular
  .module('gridListDemoApp', ['ngMaterial'])
  .controller('gridListDemoCtrl', function($scope) {

    this.tiles = buildGridModel({
            icon : "avatar:svg-",
            title: "Svg-",
            background: ""
          });

    function buildGridModel(tileTmpl){
      var it, results = [ ];

      for (var j=0; j<11; j++) {

        it = angular.extend({},tileTmpl);
        it.icon  = it.icon + (j+1);
        it.title = it.title + (j+1);
        it.span  = { row : 1, col : 1 };

        switch(j+1) {
          case 1:
            it.background = "red";
            it.span.row = it.span.col = 2;
            break;

          case 2: it.background = "green";         break;
          case 3: it.background = "darkBlue";      break;
          case 4:
            it.background = "blue";
            it.span.col = 2;
            break;

          case 5:
            it.background = "yellow";
            it.span.row = it.span.col = 2;
            break;

          case 6: it.background = "pink";          break;
          case 7: it.background = "darkBlue";      break;
          case 8: it.background = "purple";        break;
          case 9: it.background = "deepBlue";      break;
          case 10: it.background = "lightPurple";  break;
          case 11: it.background = "yellow";       break;
        }

        results.push(it);
      }
      return results;
    }
  })
  .config( function( $mdIconProvider ){
    $mdIconProvider.iconSet("avatar", 'assets/angular-material-assets/icons/avatar-icons.svg', 128);
  });


angular.module('gridListDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {});

(function() {
  'use strict';

  angular.module('fabToolbarBasicUsageDemo', ['ngMaterial'])
    .controller('AppCtrl', function($scope) {
      $scope.isOpen = false;

      $scope.demo = {
        isOpen: false,
        count: 0,
        selectedDirection: 'left'
      };
    });
})();
(function() {
  'use strict';

  angular.module('fabSpeedDialDemoMoreOptions', ['ngMaterial'])
    .controller('DemoCtrl', function($scope, $mdDialog, $timeout) {
      var self = this;

      self.hidden = false;
      self.isOpen = false;
      self.hover = false;

      // On opening, add a delayed property which shows tooltips after the speed dial has opened
      // so that they have the proper position; if closing, immediately hide the tooltips
      $scope.$watch('demo.isOpen', function(isOpen) {
        if (isOpen) {
          $timeout(function() {
            $scope.tooltipVisible = self.isOpen;
          }, 600);
        } else {
          $scope.tooltipVisible = self.isOpen;
        }
      });

      self.items = [
        { name: "Twitter", icon: "assets/angular-material-assets/img/icons/twitter.svg", direction: "bottom" },
        { name: "Facebook", icon: "assets/angular-material-assets/img/icons/facebook.svg", direction: "top" },
        { name: "Google Hangout", icon: "assets/angular-material-assets/img/icons/hangout.svg", direction: "bottom" }
      ];

      self.openDialog = function($event, item) {
        // Show the dialog
        $mdDialog.show({
          clickOutsideToClose: true,
          controller: function($mdDialog) {
            // Save the clicked item
            this.item = item;

            // Setup some handlers
            this.close = function() {
              $mdDialog.cancel();
            };
            this.submit = function() {
              $mdDialog.hide();
            };
          },
          controllerAs: 'dialog',
          templateUrl: 'dialog.html',
          targetEvent: $event
        });
      }
    });
})();

(function() {
  'use strict';

  angular.module('fabSpeedDialDemoBasicUsage', ['ngMaterial'])
    .controller('DemoCtrl', function() {
      this.topDirections = ['left', 'up'];
      this.bottomDirections = ['down', 'right'];

      this.isOpen = false;

      this.availableModes = ['md-fling', 'md-scale'];
      this.selectedMode = 'md-fling';

      this.availableDirections = ['up', 'down', 'left', 'right'];
      this.selectedDirection = 'up';
    });
})();

angular.module('dividerDemo1', ['ngMaterial'])
  .controller('AppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';
    $scope.messages = [{
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }];
  });

angular.module('dialogDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog) {
  $scope.openFromLeft = function() {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Opening from the left')
        .textContent('Closing to the right!')
        .ariaLabel('Left to right demo')
        .parent(angular.element(document.body))
        .ok('Nice!')
        // You can specify either sting with query selector
        .openFrom('#left')
        // or an element
        .closeTo(angular.element(document.querySelector('#right')))
    );
  };

  $scope.openOffscreen = function() {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Opening from offscreen')
        .textContent('Closing to offscreen')
        .ariaLabel('Offscreen Demo')
        .parent(angular.element(document.body))
        .ok('Amazing!')
        // Or you can specify the rect to do the transition from
        .openFrom({
          top: -50,
          width: 30,
          height: 80
        })
        .closeTo({
          left: 1500
        })
    );
  };
});

angular.module('dialogDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog, $mdMedia) {
  $scope.status = '  ';
  $scope.customFullscreen = $mdMedia('sm');

  $scope.showAlert = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    // Modal dialogs should fully cover application
    // to prevent interaction outside of dialog
    $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .title('This is an alert title')
        .textContent('You can specify some description text in here.')
        .ariaLabel('Alert Dialog Demo')
        .ok('Got it!')
        .targetEvent(ev)
    );
  };

  $scope.showConfirm = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.confirm()
          .title('Would you like to delete your debt?')
          .textContent('All of the banks have agreed to forgive you your debts.')
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .ok('Please do it!')
          .cancel('Sounds like a scam');

    $mdDialog.show(confirm).then(function() {
      $scope.status = 'You decided to get rid of your debt.';
    }, function() {
      $scope.status = 'You decided to keep your debt.';
    });
  };

  $scope.showAdvanced = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'dialog1.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: $mdMedia('sm') && $scope.customFullscreen
    })
    .then(function(answer) {
      $scope.status = 'You said the information was "' + answer + '".';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });



    $scope.$watch(function() {
      return $mdMedia('sm');
    }, function(sm) {
      $scope.customFullscreen = (sm === true);
    });

  };

  $scope.showTabDialog = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'tabDialog.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true
    })
        .then(function(answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function() {
          $scope.status = 'You cancelled the dialog.';
        });
  };
});

function DialogController($scope, $mdDialog) {
  $scope.hide = function() {
    $mdDialog.hide();
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };

  $scope.answer = function(answer) {
    $mdDialog.hide(answer);
  };
}

angular.module('datepickerBasicUsage',
    ['ngMaterial', 'ngMessages']).controller('AppCtrl', function($scope) {
  $scope.myDate = new Date();

  $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() - 2,
      $scope.myDate.getDate());

  $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 2,
      $scope.myDate.getDate());
  
  $scope.onlyWeekendsPredicate = function(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  }
});


angular.module('contentDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

});

(function () {
  'use strict';
  angular
      .module('staticChipsDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    this.chipText = 'Football';
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsCustomInputDemo', ['ngMaterial'])
      .controller('CustomInputDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.readonly = false;
    self.selectedItem = null;
    self.searchText = null;
    self.querySearch = querySearch;
    self.vegetables = loadVegetables();
    self.selectedVegetables = [];
    self.numberChips = [];
    self.numberChips2 = [];
    self.numberBuffer = '';
    self.autocompleteDemoRequireMatch = true;
    self.transformChip = transformChip;

    /**
     * Return the proper object when the append is called.
     */
    function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }

      // Otherwise, create a new one
      return { name: chip, type: 'new' }
    }

    /**
     * Search for vegetables.
     */
    function querySearch (query) {
      var results = query ? self.vegetables.filter(createFilterFor(query)) : [];
      return results;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(vegetable) {
        return (vegetable._lowername.indexOf(lowercaseQuery) === 0) ||
            (vegetable._lowertype.indexOf(lowercaseQuery) === 0);
      };

    }

    function loadVegetables() {
      var veggies = [
        {
          'name': 'Broccoli',
          'type': 'Brassica'
        },
        {
          'name': 'Cabbage',
          'type': 'Brassica'
        },
        {
          'name': 'Carrot',
          'type': 'Umbelliferous'
        },
        {
          'name': 'Lettuce',
          'type': 'Composite'
        },
        {
          'name': 'Spinach',
          'type': 'Goosefoot'
        }
      ];

      return veggies.map(function (veg) {
        veg._lowername = veg.name.toLowerCase();
        veg._lowertype = veg.type.toLowerCase();
        return veg;
      });
    }
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsDemo', ['ngMaterial'])
      .controller('BasicDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.readonly = false;

    // Lists of fruit names and Vegetable objects
    self.fruitNames = ['Apple', 'Banana', 'Orange'];
    self.roFruitNames = angular.copy(self.fruitNames);
    self.tags = [];
    self.vegObjs = [
      {
        'name' : 'Broccoli',
        'type' : 'Brassica'
      },
      {
        'name' : 'Cabbage',
        'type' : 'Brassica'
      },
      {
        'name' : 'Carrot',
        'type' : 'Umbelliferous'
      }
    ];

    self.newVeg = function(chip) {
      return {
        name: chip,
        type: 'unknown'
      };
    };
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsCustomSeparatorDemo', ['ngMaterial'])
      .controller('CustomSeparatorCtrl', DemoCtrl);

  function DemoCtrl ($mdConstant) {
    // Use common key codes found in $mdConstant.KEY_CODE...
    this.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    this.tags = [];

    // Any key code can be used to create a custom separator
    var semicolon = 186;
    this.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, semicolon];
    this.contacts = ['test@example.com'];
  }
})();

(function () {
  'use strict';
  angular
      .module('contactChipsDemo', ['ngMaterial'])
      .controller('ContactChipDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.querySearch = querySearch;
    self.allContacts = loadContacts();
    self.contacts = [self.allContacts[0]];
    self.filterSelected = true;

    /**
     * Search for contacts.
     */
    function querySearch (query) {
      var results = query ?
          self.allContacts.filter(createFilterFor(query)) : [];
      return results;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(contact) {
        return (contact._lowername.indexOf(lowercaseQuery) != -1);;
      };

    }

    function loadContacts() {
      var contacts = [
        'Marina Augustine',
        'Oddr Sarno',
        'Nick Giannopoulos',
        'Narayana Garner',
        'Anita Gros',
        'Megan Smith',
        'Tsvetko Metzger',
        'Hector Simek',
        'Some-guy withalongalastaname'
      ];

      return contacts.map(function (c, index) {
        var cParts = c.split(' ');
        var contact = {
          name: c,
          email: cParts[0][0].toLowerCase() + '.' + cParts[1].toLowerCase() + '@example.com',
          image: 'http://lorempixel.com/50/50/people?' + index
        };
        contact._lowername = contact.name.toLowerCase();
        return contact;
      });
    }
  }


})();


angular.module('cardDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('cardDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('cardDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('checkboxDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

    $scope.items = [1,2,3,4,5];
      $scope.selected = [];

      $scope.toggle = function (item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) list.splice(idx, 1);
        else list.push(item);
      };

      $scope.exists = function (item, list) {
        return list.indexOf(item) > -1;
      };
});


angular.module('checkboxDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

  $scope.data = {};
  $scope.data.cb1 = true;
  $scope.data.cb2 = false;
  $scope.data.cb3 = false;
  $scope.data.cb4 = false;
  $scope.data.cb5 = false;

});


angular.module('buttonsDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.title1 = 'Button';
  $scope.title4 = 'Warn';
  $scope.isDisabled = true;

  $scope.googleUrl = 'http://google.com';

});

angular.module('bottomSheetDemo1', ['ngMaterial'])
.config(function($mdIconProvider) {
    $mdIconProvider
      .icon('share-arrow', 'assets/angular-material-assets/img/icons/share-arrow.svg', 24)
      .icon('upload', 'assets/angular-material-assets/img/icons/upload.svg', 24)
      .icon('copy', 'assets/angular-material-assets/img/icons/copy.svg', 24)
      .icon('print', 'assets/angular-material-assets/img/icons/print.svg', 24)
      .icon('hangout', 'assets/angular-material-assets/img/icons/hangout.svg', 24)
      .icon('mail', 'assets/angular-material-assets/img/icons/mail.svg', 24)
      .icon('message', 'assets/angular-material-assets/img/icons/message.svg', 24)
      .icon('copy2', 'assets/angular-material-assets/img/icons/copy2.svg', 24)
      .icon('facebook', 'assets/angular-material-assets/img/icons/facebook.svg', 24)
      .icon('twitter', 'assets/angular-material-assets/img/icons/twitter.svg', 24);
  })
.controller('BottomSheetExample', function($scope, $timeout, $mdBottomSheet, $mdToast) {
  $scope.alert = '';

  $scope.showListBottomSheet = function($event) {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-list-template.html',
      controller: 'ListBottomSheetCtrl',
      targetEvent: $event
    }).then(function(clickedItem) {
      $scope.alert = clickedItem['name'] + ' clicked!';
    });
  };

  $scope.showGridBottomSheet = function($event) {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-grid-template.html',
      controller: 'GridBottomSheetCtrl',
      clickOutsideToClose: false,
      targetEvent: $event
    }).then(function(clickedItem) {
      $mdToast.show(
            $mdToast.simple()
              .textContent(clickedItem['name'] + ' clicked!')
              .position('top right')
              .hideDelay(1500)
          );
    });
  };
})

.controller('ListBottomSheetCtrl', function($scope, $mdBottomSheet) {

  $scope.items = [
    { name: 'Share', icon: 'share-arrow' },
    { name: 'Upload', icon: 'upload' },
    { name: 'Copy', icon: 'copy' },
    { name: 'Print this page', icon: 'print' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
})
.controller('GridBottomSheetCtrl', function($scope, $mdBottomSheet) {
  $scope.items = [
    { name: 'Hangout', icon: 'hangout' },
    { name: 'Mail', icon: 'mail' },
    { name: 'Message', icon: 'message' },
    { name: 'Copy', icon: 'copy2' },
    { name: 'Facebook', icon: 'facebook' },
    { name: 'Twitter', icon: 'twitter' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
})
.run(function($http, $templateCache) {

    var urls = [
      'assets/angular-material-assets/img/icons/share-arrow.svg',
      'assets/angular-material-assets/img/icons/upload.svg',
      'assets/angular-material-assets/img/icons/copy.svg',
      'assets/angular-material-assets/img/icons/print.svg',
      'assets/angular-material-assets/img/icons/hangout.svg',
      'assets/angular-material-assets/img/icons/mail.svg',
      'assets/angular-material-assets/img/icons/message.svg',
      'assets/angular-material-assets/img/icons/copy2.svg',
      'assets/angular-material-assets/img/icons/facebook.svg',
      'assets/angular-material-assets/img/icons/twitter.svg'
    ];

    angular.forEach(urls, function(url) {
      $http.get(url, {cache: $templateCache});
    });

  });

(function () {
  'use strict';
  angular
      .module('autocompleteDemoInsideDialog', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl($mdDialog) {
    var self = this;

    self.openDialog = function($event) {
      $mdDialog.show({
        controller: DialogCtrl,
        controllerAs: 'ctrl',
        templateUrl: 'dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose:true
      })
    }
  }

  function DialogCtrl ($timeout, $q, $scope, $mdDialog) {
    var self = this;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.querySearch   = querySearch;

    // ******************************
    // Template methods
    // ******************************

    self.cancel = function($event) {
      $mdDialog.cancel();
    };
    self.finish = function($event) {
      $mdDialog.hide();
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      return query ? self.states.filter( createFilterFor(query) ) : self.states;
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteCustomTemplateDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q, $log) {
    var self = this;

    self.simulateQuery = false;
    self.isDisabled    = false;

    self.repos         = loadAll();
    self.querySearch   = querySearch;
    self.selectedItemChange = selectedItemChange;
    self.searchTextChange   = searchTextChange;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.repos.filter( createFilterFor(query) ) : self.repos,
          deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Build `components` list of key/value pairs
     */
    function loadAll() {
      var repos = [
        {
          'name'      : 'Angular 1',
          'url'       : 'https://github.com/angular/angular.js',
          'watchers'  : '3,623',
          'forks'     : '16,175',
        },
        {
          'name'      : 'Angular 2',
          'url'       : 'https://github.com/angular/angular',
          'watchers'  : '469',
          'forks'     : '760',
        },
        {
          'name'      : 'Angular Material',
          'url'       : 'https://github.com/angular/material',
          'watchers'  : '727',
          'forks'     : '1,241',
        },
        {
          'name'      : 'Bower Material',
          'url'       : 'https://github.com/angular/bower-material',
          'watchers'  : '42',
          'forks'     : '84',
        },
        {
          'name'      : 'Material Start',
          'url'       : 'https://github.com/angular/material-start',
          'watchers'  : '81',
          'forks'     : '303',
        }
      ];
      return repos.map( function (repo) {
        repo.value = repo.name.toLowerCase();
        return repo;
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(item) {
        return (item.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteFloatingLabelDemo', ['ngMaterial', 'ngMessages'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.selectedItem  = null;
    self.searchText    = null;
    self.querySearch   = querySearch;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.states.filter( createFilterFor(query) ) : [];
      return results;
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q, $log) {
    var self = this;

    self.simulateQuery = false;
    self.isDisabled    = false;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.querySearch   = querySearch;
    self.selectedItemChange = selectedItemChange;
    self.searchTextChange   = searchTextChange;

    self.newState = newState;

    function newState(state) {
      alert("Sorry! You'll need to create a Constituion for " + state + " first!");
    }

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.states.filter( createFilterFor(query) ) : self.states,
          deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.select-itb', [])
        .config(config);

    /** @ngInject */
    //function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdDateLocaleProvider)
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
/*        
        $mdDateLocaleProvider.formatDate = formatDate;

        function formatDate(date) {

            return moment(date).format('DD-MM-YYYY');
        }
*/

        // State
        $stateProvider.state('app.workflow_bidder_select_itb', {
            url      : '/workflow-bidder/select-itb',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow-bidder/select-itb/select-itb.html',
                    controller : 'SelectItbController as vm'
                }
            },


            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'select-itb'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow-bidder/select-itb');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-bidder.select-itb', {
            title : 'Select ITB',
            state : 'app.workflow_bidder_select_itb',
            icon  : 'icon-numeric-1-box',
            weight: 1
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.select-itb')
        .controller('SelectDialogController', SelectDialogController);

    /** @ngInject */
    function SelectDialogController($mdDialog,itbStatusService)
    {
        // DECLARATIONS ***********************
        var vm = this;


        // METHODS DECLARATION ****************
        vm.closeDialog = closeDialog;


        // METHODS ****************
        function closeDialog()
        {
            itbStatusService.rejectReason = vm.rejectReason;
            itbStatusService.bidderStatus = "declined";

            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_theme-colors', {
            url      : '/ui/theme-colors',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/theme-colors/theme-colors.html',
                    controller : 'ThemeColorsController as vm'
                }
            },
            bodyClass: 'theme-colors'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('CustomThemeDialogController', CustomThemeDialogController);

    /** @ngInject */
    function CustomThemeDialogController(fuseTheming, $mdDialog, fuseGenerator, $cookies, $window)
    {
        // Data
        var vm = this;
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.themes = fuseTheming.getRegisteredThemes();

        // Delete Unnecessary hue value
        delete vm.palettes.grey['1000'];

        // Methods
        vm.rgba = fuseGenerator.rgba;
        vm.setTheme = setTheme;
        vm.closeDialog = closeDialog;

        //////////

        // If custom theme exist keep using it otherwise set default as a custom
        if ( !vm.themes.custom )
        {
            vm.theme = angular.copy(vm.themes['default'].colors);
        }
        else
        {
            vm.theme = vm.themes.custom.colors;
        }

        /**
         * Put custom theme into the cookies
         * and reload for generate styles
         */
        function setTheme()
        {
            $cookies.putObject('customTheme', vm.theme);
            $cookies.put('selectedTheme', 'custom');
            $window.location.reload();
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-ii', {
            url  : '/ui/page-layouts/simple/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'SimpleRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii')
        .controller('SimpleRightSidenavIIController', SimpleRightSidenavIIController);

    /** @ngInject */
    function SimpleRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_tabbed', {
            url  : '/ui/page-layouts/simple/tabbed',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/tabbed/tabbed.html',
                    controller : 'SimpleTabbedController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed')
        .controller('SimpleTabbedController', SimpleTabbedController);

    /** @ngInject */
    function SimpleTabbedController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav', {
            url  : '/ui/page-layouts/simple/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html',
                    controller : 'SimpleRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav')
        .controller('SimpleRightSidenavController', SimpleRightSidenavController);

    /** @ngInject */
    function SimpleRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-ii', {
            url  : '/ui/page-layouts/simple/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'SimpleLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii')
        .controller('SimpleLeftSidenavIIController', SimpleLeftSidenavIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav', {
            url  : '/ui/page-layouts/simple/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html',
                    controller : 'SimpleLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav')
        .controller('SimpleLeftSidenavController', SimpleLeftSidenavController);

    /** @ngInject */
    function SimpleLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_fullwidth', {
            url  : '/ui/page-layouts/simple/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/fullwidth/fullwidth.html',
                    controller : 'SimpleFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth')
        .controller('SimpleFullwidthController', SimpleFullwidthController);

    /** @ngInject */
    function SimpleFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav-ii', {
            url  : '/ui/page-layouts/carded/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'CardedRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii')
        .controller('CardedRightSidenavIIController', CardedRightSidenavIIController);

    /** @ngInject */
    function CardedRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav', {
            url  : '/ui/page-layouts/carded/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html',
                    controller : 'CardedRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav')
        .controller('CardedRightSidenavController', CardedRightSidenavController);

    /** @ngInject */
    function CardedRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav-ii', {
            url  : '/ui/page-layouts/carded/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'CardedLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii')
        .controller('CardedLeftSidenavIIController', CardedLeftSidenavIIController);

    /** @ngInject */
    function CardedLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav', {
            url  : '/ui/page-layouts/carded/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html',
                    controller : 'CardedLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav')
        .controller('CardedLeftSidenavController', CardedLeftSidenavController);

    /** @ngInject */
    function CardedLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth-ii', {
            url  : '/ui/page-layouts/carded/fullwidth-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html',
                    controller : 'CardedFullwidthIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii')
        .controller('CardedFullwidthIIController', CardedFullwidthIIController);

    /** @ngInject */
    function CardedFullwidthIIController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth', {
            url  : '/ui/page-layouts/carded/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth/fullwidth.html',
                    controller : 'CardedFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth')
        .controller('CardedFullwidthController', CardedFullwidthController);

    /** @ngInject */
    function CardedFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.required-technical-docs', ['ngSanitize'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.workflow_bidder_submission_bid_required_technical_docs', {
            url      : '/workflow-bidder/submission-bid/required-technical-docs',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow-bidder/submission-bid/required-technical-docs/required-technical-docs.html',
                    controller : 'RequiredTechnicalDocsController as vm'
                }
            },
            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'required-technical-docs'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow-bidder/submission-bid/required-technical-docs');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-bidder.submission-bid.required-docs', {
            title : 'Required Documents',
            state : 'app.workflow_bidder_submission_bid_required_docs',
            icon  : 'icon-numeric-1-box',
            weight: 1
        });
*/        
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.required-technical-docs')
        .controller('RequiredTechnicalDocsController', RequiredTechnicalDocsController);

    /** @ngInject */
    function RequiredTechnicalDocsController(firebaseDataService,$mdSidenav,$scope,$timeout,$location,$firebaseArray,itbStatusService,$http,traceabilityService,utilsService,loginService,$sce,$mdDialog,uiGridConstants,$filter,$mdToast,errorLogService)
    {
        // DECLARATIONS ***********************
        var vm = this;
        var ACCESS_TOKEN = 'lhge3xkLsbAAAAAAAAAA7F4mpQiGgjg_fD658SG5evJitCht2fsvP7D-ZfaSwEl-';  //Dropbox API version 2
        
        vm.technicalDocsPath;
        vm.commercialDocsPath;
        vm.generalDocsPath;

        vm.pendingTechnicalDocs;

        vm.technicalGridOptions;

        vm.technicalGridApi;

        vm.currentView = 'list';
        vm.selectedTechnicalDoc;

        vm.itbBidderKeySelected;
        vm.fileUploaded;

        vm.technicalDocsComments = "";

        vm.disableDropboxButtons = false;


        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.initTechnicalGrid = initTechnicalGrid;
        
        vm.getTechnicalDocs = getTechnicalDocs;

        vm.loadTechnicalGrid = loadTechnicalGrid;

        vm.redirectToAddVessel = redirectToAddVessel;
        
        vm.redirectToRequiredTechnicalDocs = redirectToRequiredTechnicalDocs;
        vm.redirectToRequiredCommercialDocs = redirectToRequiredCommercialDocs;
        vm.redirectToRequiredGeneralDocs = redirectToRequiredGeneralDocs;

        vm.redirectToOtherDocs = redirectToOtherDocs;
		vm.redirectToFinishUpload = redirectToFinishUpload;

        vm.showAlertDialog = showAlertDialog;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;
		vm.showConfirmWarningDialog = showConfirmWarningDialog;

        vm.toggleView = toggleView;
        vm.toggleSidenav = toggleSidenav;

        vm.viewTechnicalFile = viewTechnicalFile;

        vm.selectTechnicalFile = selectTechnicalFile;

        vm.uploadTechnicalFile = uploadTechnicalFile;

        vm.uploadFileToDropbox = uploadFileToDropbox;
        vm.deleteTechnicalDoc = deleteTechnicalDoc;
        vm.deleteFileFromDropbox = deleteFileFromDropbox;

        vm.updateFieldPendingDocsDownloaded = updateFieldPendingDocsDownloaded;

        vm.saveTechnicalDocs = saveTechnicalDocs;

        vm.reviewPendingTechnicalDocs = reviewPendingTechnicalDocs;
        vm.checkTechnicalDocExistsInPendingTechnicalDocs = checkTechnicalDocExistsInPendingTechnicalDocs;
		vm.checkDuplicateTechnicalDocInPendingTechnicalDocs = checkDuplicateTechnicalDocInPendingTechnicalDocs;
		
		vm.deleteVessels = deleteVessels;
		vm.deletePendingTechnicalDocsOfBidderForItb = deletePendingTechnicalDocsOfBidderForItb;

        //vm.getTraceabilityFromFirebaseByUser = getTraceabilityFromFirebaseByUser;
        vm.addTrace = addTrace;


        //START CONTROLLER *******************************
        vm.executeController();


        // METHODS ****************
        function executeController() {

            //We must retrieve itb_key of ITB selected in the workflow before execute the query.
            vm.itbKeySelected = itbStatusService.getItbKey();
            vm.bidderKeySelected = itbStatusService.getBidderKey();
            vm.itbBidderKeySelected = itbStatusService.getItbBidderKey();

            vm.technicalDocsComments = $sce.trustAsHtml(itbStatusService.getTechnicalDocsComments());

            //vm.technicalDocsPath = "cdn/itb/" + vm.itbKeySelected + "/technical_docs/" + vm.bidderKeySelected;
            var itbName = itbStatusService.getItbName();
            var bidderName = itbStatusService.getBidderName()
            vm.technicalDocsPath = "cdn/itb/" + vm.itbKeySelected + "_" + itbName + "/" + vm.bidderKeySelected + "_" + bidderName + "/technical_docs/";


            //IMPORTANT => Add pending technical docs to Firebase table "pending_technical_docs"
            vm.reviewPendingTechnicalDocs(vm.itbKeySelected,vm.bidderKeySelected,bidderName);  

            //Initialization of the Grids
            vm.initTechnicalGrid();

            //Technical and Commercial docs list obtained from FIREBASE
            vm.pendingTechnicalDocs = vm.getTechnicalDocs(vm.itbBidderKeySelected);

            //Get all the records of user_key from "traceability" table in Firebase
            //vm.traceability = vm.getTraceabilityFromFirebaseByUser(loginService.getUserKey());

            //console.log("[RequiredTechnicalDocsController] (1) Get Technical Docs list process START from ItbBidderKey '" + vm.itbBidderKeySelected + "'");
        }



		//************************************************************************************
        function initTechnicalGrid() {

            vm.technicalGridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: false,
                enableColumnMenus: false,


                onRegisterApi: function(gridApi) {
                    vm.technicalGridApi = gridApi;
                  
                    vm.technicalGridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedTechnicalDoc = row.entity;

                        //console.log("[RequiredTechnicalDocsController] Selected TECHNICAL DOC KEY = " + vm.selectedTechnicalDoc.$id);
                        //console.log("[RequiredTechnicalDocsController] Selected TECHNICAL DOC VESSEL = " + vm.selectedTechnicalDoc.vessel);
                        //console.log("[RequiredTechnicalDocsController] Selected TECHNICAL DOC NAME = " + vm.selectedTechnicalDoc.name);
                        //console.log("[RequiredTechnicalDocsController] Selected TECHNICAL DOC FILE = " + vm.selectedTechnicalDoc.file);
                        //console.log("[RequiredTechnicalDocsController] Selected TECHNICAL DOC URL = " + vm.selectedTechnicalDoc.url);
                        //console.log("************************************************************************");
                    });
                }
            };

            vm.technicalGridOptions.columnDefs = [
                { name:'Vessel', field: 'vessel', width: '30%', sort: {direction: uiGridConstants.ASC,priority: 0} },
                { name:'Document', field: 'name', width: '27%', sort: {direction: uiGridConstants.ASC,priority: 1} },
                { name:'File', field: 'file', width: '25%' },
                { name:'Date', field: 'dateTime', width: '18%' }
                /* ,{ name: 'Pending', field: 'pending', type: 'boolean',width: '12%', cellTemplate: '<input type="checkbox" disabled ="disabled" ng-model="row.entity.pending">'}, */
            ];
        }


		//************************************************************************************
        function getTechnicalDocs(pItbBidderKeySelected) {

            //Get list from 'pending_technical_docs' table
            var fbUrl = firebaseDataService.pending_technical_docs;
            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKeySelected));

            result.$loaded()
                .then(function(data) {

                    vm.pendingTechnicalDocs = data;
                    //console.log("[RequiredTechnicalDocsController] (2) Technical Docs list LOADED with " + data.length + " rows.");

					var arrayLength = data.length;
					
                    //Load the grid with de itbs list
                    if (arrayLength > 0) {
                        vm.loadTechnicalGrid(data);

						var duplicateDetected = false;
						
						//******************
						//VERY IMPORTANT => We check if there are duplicated rows for technical docs for each vessel of the Bidder in this ITB. 
						//					In that case, we delete those rows and show a showAlertDialog with a hint 
						//					(we also delete the vessels of the Bidder in table 'vessel_bidders').
						//******************
						//We iterate for each Vessel in 'pending_technical_docs'
						for (var i=0; i<arrayLength; i++) {  
							var itbBidderVesselKey = vm.pendingTechnicalDocs[i].itb_bidder_vessel_key;
							var itbBidderKey = vm.pendingTechnicalDocs[i].itb_bidder_key;

							//console.log("*******************");
							//console.log("Iteration #" + i + " for vessel '" + vm.pendingTechnicalDocs[i].vessel + "' and document '" + vm.pendingTechnicalDocs[i].name + "' with itb_bidder_vessel_key='" + itbBidderVesselKey + "'");
							//console.log("*******************");

							if (vm.checkDuplicateTechnicalDocInPendingTechnicalDocs(vm.pendingTechnicalDocs,itbBidderVesselKey)) {
								
								//console.log("Warning! The system has detected a duplicate in Technical documents. This problem sometimes occurs because the user is using 'ChartBid App' in different browsers at the same time. In this case, you must close all browsers except the recommend browser by Chart Shipping (Google Chrome).");
								
								if (!duplicateDetected) {
									duplicateDetected = true;
									
									//We delete (only for the first time is found a duplication) all the vessels in 'vessel_bidders' table for the ITB and Bidder and delete all the related rows in 'pending_technical_docs' table
									vm.deleteVessels(itbBidderKey);
								}
							}

						}
						
						//If duplicated row is detected the system will show an Alert and redirect to the prior page ('Add Vessel').
						if (duplicateDetected) {
							vm.showConfirmWarningDialog("The system has detected duplicate technical documents.</br></br> This has likely occurred by using ChartBid on multiple browsers or tabs concurrently. Please close all additional browsers or tabs except one (Chart Shipping recommends Google Chrome) and try again.</br></br> In order to fix the detected issue, all vessels will be deleted and you will be redirected back to the previous page.");
						}
					}
					
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[RequiredTechnicalDocsController] ERROR: " + error + "(Log Error: Controller: RequiredDocsController / Function: getTechnicalDocs())");

                    addError("[RequiredTechnicalDocsController] / getTechnicalDocs() function",error);
                });
        }
 

 
 		//************************************************************************************
        function checkDuplicateTechnicalDocInPendingTechnicalDocs(pPendingDocsArray,pItbBidderVesselKey) {

            var result = $filter('filter')(pPendingDocsArray, {itb_bidder_vessel_key: pItbBidderVesselKey});

            try {

				var numberOfDocsInPendingTechnicalDocs = result.length;
				
                if (numberOfDocsInPendingTechnicalDocs > 0) {
					
					for (var i=0;i<numberOfDocsInPendingTechnicalDocs; i++) {
					
						var docKey = result[i].doc_key;

						var result2 = $filter('filter')(result, {doc_key: docKey});
					
						if (result2.length > 1) {

							//console.log("[checkDuplicateTechnicalDocInPendingTechnicalDocs] => vessel = " + result[i].vessel);
							//console.log("[checkDuplicateTechnicalDocInPendingTechnicalDocs] => document name = " + result[i].name);
							//console.log("-------------------");
						
							return true;	
						}
					}
                    
                } else {
                    return false;
                }

            } catch(error) {
                return false;
            }
        }

		
		
		//********************************************************** 
        function deleteVessels(pItbBidderKey) {

            //Get Vessel list from "pending_technical_docs" table
            var fbUrl = firebaseDataService.vessel_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {

                    var vesselsToDelete = data;

                    var arrayLength = data.length;

                    for (var i=0;i<arrayLength;i++) {
                        var currentVessel = data[i];
						var currentItbBidderVesselKey = pItbBidderKey + "&" + currentVessel.$id;
						
						//console.log("vesselToDelete in 'vessels_bidders' => " + currentVessel.vessel_name);
						
						vesselsToDelete.$remove(currentVessel)
							.then(function(ref) {
								//console.log("[RequiredTechnicalDocsController] Delete record from 'vessel_bidders' with vessel_name = " + currentVessel.vessel_name);
							})

							.catch(function(error) {
								//vm.gridOptions.data = null;
								//console.log("[RequiredTechnicalDocsController] ERROR in deleteVessels() method: " + error);

								addError("[RequiredTechnicalDocsController] / deleteVessels() function",error);
							}
						);						
						
                    }
					
					//We delete all the records in 'pending_technical_docs' related to the ITB for all vessels of the current Bidder.
					vm.deletePendingTechnicalDocsOfBidderForItb(pItbBidderKey);
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[AddVesselController] ERROR in getVessels() method for 'pending_technical_docs' table: " + error);

                    addError("AddVesselController / getVessels() function",error);
                }
			);		
        }
		
 
		//**********************************************************
        function deletePendingTechnicalDocsOfBidderForItb(pItbBidderKey) {

            //Get Vessel list from "pending_technical_docs" table
            var fbUrl = firebaseDataService.pending_technical_docs;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {

					var rowsToDelete = data;
                    var dataLength = data.length;

                    for (var i=0;i<dataLength;i++) {

                        var recordToDelete = data[i];
						
						//console.log("recordToDelete in 'pending_technical_docs' => for vessel '" + recordToDelete.vessel + "' and document '" + recordToDelete.name + "' with itb_bidder_vessel_key='" + recordToDelete.itb_bidder_vessel_key + "'");
                        
						rowsToDelete.$remove(recordToDelete);
                        //console.log("[RequiredTechnicalDocsController] method deletePendingTechnicalDocsOfVessel() => Record with key=" + recordToDelete.$id + " DELETED");
                    }
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[RequiredTechnicalDocsController] ERROR in deletePendingTechnicalDocsOfVessel() method for 'pending_technical_docs' table: " + error);

                    addError("RequiredTechnicalDocsController / deletePendingTechnicalDocsOfVessel() function",error);
                });
        }
 
 
		//************************************************************************************
        function loadTechnicalGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.technicalGridOptions.data = data;
            });

            //console.log("[RequiredTechnicalDocsController] (3) LOAD Technical Grid DONE");
        }


		
		//************************************************************************************
        function viewTechnicalFile() {

            var key = "";
            var url = "";

            try {
                key = vm.selectedTechnicalDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            try {
                url = "/" + vm.selectedTechnicalDoc.url.trim();

                //VERY IMPORTANT => Due to an error when we insert document's URL through "Chartbid Bidder's App" => we must remove "//"" (doble slash) before the name of the file.
                //BEGIN OF THE CODE
                var correctURL = url.replace("//","/");
                url = correctURL;
                //END OF THE CODE

            } catch(e) {
                vm.showAlertDialog("There is not a document to show.");
                return;
            }

            if ( (url == null) || (url == "") || (url == undefined) ) {
                vm.showAlertDialog("There is not a document to show.");
                return;
            }

            ////console.log("url = " + url);
            var type = utilsService.getContentType(url);
            ////console.log("type = " + type);

            var urlPost = 'https://content.dropboxapi.com/2/files/download';

            var dataToSend = "";

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream;charset=utf-8',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + url + '"}'
                },
                responseType: 'blob'
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    ////console.log("DESCARGADO CORRECTAMENTE EL ARCHIVO.");

                    var blob = new Blob([responseData], {type: type});
                    blob.name = "downloadedFile";
                    var url = (window.URL || window.webkitURL).createObjectURL(blob);

                    window.open(url,"_blank");    

                })
                .error(function (responseData, status, header, config) {

                    ////console.log("ERROR AL DESCARGAR Y VISUALIZAR EL ARCHIVO: " + responseData);

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("RequiredTechnicalDocsController / viewTechnicalFile() function", error);
                }
            );
        }


		
		//************************************************************************************
        function selectTechnicalFile() {

            var key;

            try {
                key = vm.selectedTechnicalDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a vessel.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a vessel.");
                return;
            }
            
            //alert("EJECUTAMOS EL METODO 'selectFile()' ");
            angular.element(document.querySelector('#technicalFileInput')).click();
        }



		//************************************************************************************
        function saveTechnicalDocs() 
        {
            //console.log("START saveTechnicalDocs() method");

            var record = vm.selectedTechnicalDoc;

            if (record != null) {

                vm.pendingTechnicalDocs.$save(record)
                    .then(function(ref) {
                        //console.log("[RequiredTechnicalDocsController] 'saveTechnicalDocs()' method => Saved record with ID = " + ref.key);

                        //Update the fiel "pendingDocsDownloaded" from "itb_bidders" table
                        vm.updateFieldPendingDocsDownloaded(vm.itbBidderKeySelected,true);
                    })

                    .catch(function(error) {
                        //vm.gridOptions.data = null;
                        //console.log("[RequiredTechnicalDocsController] ERROR: " + error + "(Log Error: Controller: RequiredDocsController / Function: getTechnicalDocs())");

                        addError("RequiredTechnicalDocsController / saveTechnicalDocs() function",error);
                    }
                );
            }
        }


		//************************************************************************************
        function updateFieldPendingDocsDownloaded(pItbBidderKey,pStatus) {

//            var fbUrl = new Firebase(FIREBASE_URL + "/itb_bidders/");
            var fbUrl = firebaseDataService.itb_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {

                    var itbBidderRecord = data[0];

                    itbBidderRecord.pendingDocsDownloaded = pStatus;

                    data.$save(itbBidderRecord);
                })

                .catch(function(error) {
                    //console.log("[FileManagerController] ERROR in updateFieldPendingDocsDownloaded(): " + error);

                    addError("RequiredTechnicalDocsController / updateFieldPendingDocsDownloaded() function",error);

                    return true;
                });                
        }


// (24/03/2025) - INICIO
/*
		//************************************************************************************
        function uploadTechnicalFile(pFile) {
	
			//We check if the filename has non valid characters.
			//var general_special_invalids_characters_format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
			var format = /[`´'^\;':"\\|,<>\/?~]/;
			var filename = "";

			try {
				filename = pFile.name;
			} catch (error) {
                //vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredTechnicalDocsController / Function: uploadFileToDropbox())");
                return;
            }
			
			if( filename.match(format) ){
                vm.showAlertDialog("An invalid character ([ ` ´ ' ^ \ ; ' : \" \\ \| , \< \> \/ \? \~ ]) was found in file name. Please, change the name and try again. Thank you.");
				return;
			}
		
            utilsService.getCETdateTime()
                .success(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string for the uploading document = " + data);

                    //Upload the file to dropbox with the current CET DateTime
                    vm.uploadFileToDropbox(pFile, vm.technicalDocsPath,data);
                })
                .error(function () {
                    //console.log("ERROR => NOT POSSIBLE TO UPLOAD THE DOCUMENT BECAUSE IT HASN'T BEEN POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
					
					vm.showAlertDialog("There is a problem with the upload process. Please, try again later. Thank you.");
            });

        }
*/

		//  (NUEVA VERSION)
		//************************************************************************************
		function uploadTechnicalFile(pFile) {

			// We check if the filename has non valid characters.
			var format = /[`´'^\;':"\\|,<>\/?~]/;
			var filename = "";

			try {
				filename = pFile.name;
			} catch (error) {
				// vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredTechnicalDocsController / Function: uploadFileToDropbox())");
				return;
			}

			if (filename.match(format)) {
				vm.showAlertDialog("An invalid character ([ ` ´ ' ^ \\ ; ' : \" \\ | , < > / ? ~ ]) was found in file name. Please, change the name and try again. Thank you.");
				return;
			}

			utilsService.getCETdateTime()
				.then(function (data) {

					//console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string for the uploading document = " + data);

					// Upload the file to dropbox with the current CET DateTime
					vm.uploadFileToDropbox(pFile, vm.technicalDocsPath, data);
				})
				.catch(function () {
					//console.log("ERROR => NOT POSSIBLE TO UPLOAD THE DOCUMENT BECAUSE IT HASN'T BEEN POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
					
					vm.showAlertDialog("There is a problem with the upload process. Please, try again later. Thank you.");
				});
		}

// (24/03/2025) - FIN



		//************************************************************************************
        function uploadFileToDropbox(pFile, pPath, pDateTime) {

            var fileName = "";
            var vesselName = "";

            try {
                fileName = pFile.name;
                vesselName = vm.selectedTechnicalDoc.vessel;

                fileName = vesselName + "_" + fileName;
                
            } catch (error) {
                fileName = "";
                //vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredTechnicalDocsController / Function: uploadFileToDropbox())");
                return;
            }

            var fullPath = "/" + pPath + fileName;

            ////console.log("fullPath = " + fullPath);
            ////console.log("pFile = " + pFile);

            vm.disableDropboxButtons = true;

            var urlPost = 'https://content.dropboxapi.com/2/files/upload'; 

            var dataToSend = pFile;

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + fullPath + '", "mode": "add", "autorename": true, "mute": false}'
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log(responseData);
                    //console.log('file uploaded successfully');

                    vm.disableDropboxButtons = false;
                    showCustomToast("Document uploaded successfully.");                

                    //Save the record in "pending_technical_docs"
                    vm.selectedTechnicalDoc.url = vm.technicalDocsPath + fileName;
                    vm.selectedTechnicalDoc.file = fileName;
                    vm.selectedTechnicalDoc.uploaded = true;
                    vm.selectedTechnicalDoc.pending = false;
                    vm.selectedTechnicalDoc.dateTime = pDateTime;
                    vm.selectedTechnicalDoc.downloaded = false;
                    ////console.log("vm.selectedTechnicalDoc.url = " + vm.selectedTechnicalDoc.url);
                    vm.saveTechnicalDocs();

                    //Insert a record in "traceability" table
                    vm.addTrace("Technical document '" + fileName + "' uploaded.");

                })
                .error(function (responseData, status, header, config) {
                    //console.log('Error : ' + status);
                    //console.log('Error in upload file to Dropbox process');
                    vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredTechnicalDocsController / Function: uploadFileToDropbox())");

                    vm.disableDropboxButtons = false;

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("RequiredTechnicalDocsController / uploadFileToDropbox() function", error);
                }
            );

        }

		

		//************************************************************************************
        function deleteTechnicalDoc() {

            var key;
            var fileName;

            try {
                key = vm.selectedTechnicalDoc.$id;
                fileName = vm.selectedTechnicalDoc.file;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }


            vm.deleteFileFromDropbox(vm.selectedTechnicalDoc.url);

            vm.selectedTechnicalDoc.url = "";
            vm.selectedTechnicalDoc.file = "";
            vm.selectedTechnicalDoc.dateTime = "";
            vm.selectedTechnicalDoc.pending = true;
            vm.selectedTechnicalDoc.uploaded = false;

            vm.saveTechnicalDocs();

            //Insert a record in "traceability" table
            vm.addTrace("Technical document '" + fileName + "' deleted.");
        }


		//************************************************************************************
        function deleteFileFromDropbox(pPath) {

            try {
                pPath = pPath.trim();

            } catch(e) {
                vm.showAlertDialog("There is not a document to delete.");
                return;
            }


            if ( (pPath == null) || (pPath == "") || (pPath == undefined) ) {
                vm.showAlertDialog("There is not a document to delete.");
                return;
            }


            var filePath = "/" + pPath;
            
            vm.disableDropboxButtons = true;

            var urlPost = 'https://api.dropboxapi.com/2/files/delete_v2'; 

            var dataToSend = '{"path": "' + filePath + '"}';

            var config = {
                headers : {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log("File deleted successfully.");
                    vm.disableDropboxButtons = false;
                    showCustomToast("Document deleted successfully.");
                })
                .error(function (responseData, status, header, config) {

                    //console.log("dropbox DELETE ERROR => status: " + status);
                    //console.log('Error in deleting file from Dropbox process');
                    vm.showAlertDialog("There is a problem with the delete file process. Please, contact with the App administrator. (Log error: Controller: RequiredTechnicalDocsController / Function: deleteFileFromDropbox()");

                    vm.disableDropboxButtons = false;

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("RequiredTechnicalDocsController / deleteFileFromDropbox() function", error);
                }
            );
        }




		//***************************************************************************
        function reviewPendingTechnicalDocs(pItbKey,pBidderKey,pBidderCompany) 
        {

            if ( (pItbKey == null) || (pItbKey == "") ) {
                vm.showAlertDialog("Not possible to review pending Technical docs");
                return;
            }

            if ( (pBidderKey == null) || (pBidderKey == "") ) {
                vm.showAlertDialog("Not possible to review pending Technical docs");
                return;
            }

            var itbBidderKey = pItbKey + "&" + pBidderKey;

            var fbUrl = firebaseDataService.pending_technical_docs;

            vm.pendingTechnicalDocs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(itbBidderKey));

            vm.pendingTechnicalDocs.$loaded()
                .then(function(data) {

                    vm.pendingTechnicalDocs = data;


                    //We obtain from Firebase the records of "technical_docs"
                    var fbUrl2 = firebaseDataService.technical_docs;

                    var technicalDocs = $firebaseArray(fbUrl2.orderByChild("itb_key").equalTo(pItbKey));

                    technicalDocs.$loaded()
                        .then(function(data) {

                            technicalDocs = data;
                            //console.log("[RequiredTechnicalDocsController / reviewPendingTechnicalDocs] technical docs list LOADED with " + data.length + " rows.");

                            var generalDocsArrayLength = 0;
                            try {
                                generalDocsArrayLength = technicalDocs.length;
                            } catch (error) {
                                generalDocsArrayLength = 0;
                            }


                            if (generalDocsArrayLength > 0) 
                            {

                                for (var i=0; i<generalDocsArrayLength; i++) {                        

                                    var docKey = technicalDocs[i].$id;
                                    var docName = technicalDocs[i].name;

                                    if (!vm.checkTechnicalDocExistsInPendingTechnicalDocs(vm.pendingTechnicalDocs,docKey)) {

                                        //We obtain the list of Vessels for this Bidder
                                        var fbUrl3 = firebaseDataService.vessel_bidders;

                                        var vessels = $firebaseArray(fbUrl3.orderByChild("itb_bidder_key").equalTo(itbBidderKey));

                                        vessels.$loaded()
                                            .then(function(data) {

                                                vessels = data;

                                                var vesselsArrayLength = 0;
                                                try {
                                                    vesselsArrayLength = vessels.length;
                                                } catch (error) {
                                                    vesselsArrayLength = 0;
                                                }
                                

                                                for (var j=0;j<vesselsArrayLength;j++) {

                                                    var vesselKey = vessels[j].$id;
                                                    var itbBidderVesselKey = itbBidderKey + "&" + vesselKey;
                                                    var vesselName = vessels[j].vessel_name;

                                                    var stringJson = '{"itb_bidder_key": "' + itbBidderKey + '"'
                                                                  +  ',"itb_key": "' + pItbKey + '"' 
                                                                  +  ',"itb_bidder_vessel_key": "' + itbBidderVesselKey + '"' 
                                                                  +  ',"bidder_key": "' + pBidderKey + '"' 
                                                                  +  ',"bidderCompany": "' + pBidderCompany + '"' 
                                                                  +  ',"doc_key": "' + docKey + '"' 
                                                                  +  ',"name": "' + docName + '"' 
                                                                  +  ',"url": " "'
                                                                  +  ',"pending": true'
                                                                  +  ',"active": true'
                                                                  +  ',"vessel": "' + vesselName + '"'
                                                                  +  '}';

                                                    var jsonData = JSON.parse(stringJson);

                                                    vm.pendingTechnicalDocs.$add(jsonData)
                                                        .then(function(ref) {
                                                            //console.log("[SelectItbController] Added new record to 'reviewPendingTechnicalDocs' with KEY = " + ref.key);
                                                        })
                                                    
                                                        .catch(function(error) {
                                                            //console.log("[SelectItbController] ERROR in 'reviewPendingTechnicalDocs' function: " + error);
                                                    });
                                                }

                                            })
                                            .catch(function(error) {
                                                //console.log("[SelectItbController] ERROR in 'reviewPendingTechnicalDocs' function: " + error);
                                        });

                                    }
                                }

                            }

                        })

                        .catch(function(error) {
                            //console.log("[SelectItbController] ERROR in 'reviewPendingTechnicalDocs' function: " + error);
                    });


                })
                .catch(function(error) {
                    //console.log("[RequiredTechnicalDocsController] ERROR in 'reviewPendingTechnicalDocs' function: " + error);

                    addError("RequiredTechnicalDocsController / reviewPendingTechnicalDocs() function",error);
            });

        }


		
		//************************************************************************************
        function checkTechnicalDocExistsInPendingTechnicalDocs(pPendingDocsArray,pDocKey) {

            var result = $filter('filter')(pPendingDocsArray, {doc_key: pDocKey});

            try {

                if (result.length > 0) {
                    return true;
                } else {
                    return false;
                }

            } catch(error) {
                return false;
            }
        }

		
		//**********************************************************
        function showConfirmDeleteDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this document?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSH "YES" BUTTON
                    vm.deleteTechnicalDoc();
                }, 
                function() {
                    //YOU HAVE PUSH "NO" BUTTON
                });
        }


		//**********************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }

		
		//**********************************************************
		function showConfirmWarningDialog(pHtmlText) {
            
            var confirm = $mdDialog.confirm()
                .title('Warning')
                .htmlContent(pHtmlText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Go back")
                //.cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSH "YES" BUTTON
                    vm.redirectToAddVessel()
                }, 
                function() {
                    //YOU HAVE PUSH "NO" BUTTON
                });
        }		
		
		

        function showCustomToast(pMessage) {

            $mdToast.show(
                $mdToast.simple()
                    .textContent(pMessage)
                    .position('top right')
                    .hideDelay(3000)
            );
        }

/*
        function getTraceabilityFromFirebaseByUser(pUserKey) {

            if (pUserKey != null) {

//                var fbUrl = new Firebase(FIREBASE_URL + "/traceability/");
                var fbUrl = firebaseDataService.traceability;

                var result = $firebaseArray(fbUrl.orderByChild("user_key").equalTo(pUserKey));

                result.$loaded()
                    .then(function(data) {

                        traceabilityService.setTraceability(data);

                        //console.log("[traceabilityService] getTraceabilityByUser() method => Get all records of 'user_key' from 'traceability' table of Firebase.");

                        return data;
                    })
                    .catch(function(error) {
                        //console.log("[traceabilityService] getTraceabilityByUser() method => ERROR: " + error);
                    });

            } else {

                traceabilityService.setTraceability(null);
                return null;
            }
        }
*/

// (24/03/2025) - INICIO		
/*
		//***************************
        function addTrace(pAction) {

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'date': data,
                        'time': '',
                        'dateTime': utilsService.getDateTime(),
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'action': pAction
                    };

                    traceabilityService.addTrace(recordToAdd);

                })
                .error(function () {
                    //console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/

		//  (NUEVA VERSION)
		
		//******************************
		function addTrace(pAction) {

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {

					//console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'date': data,
						'time': '',
						'dateTime': utilsService.getDateTime(),
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'action': pAction
					};

					traceabilityService.addTrace(recordToAdd);

				})
				.catch(function () {
					//console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE EXTERNAL API.");
				});
		}
// (24/03/2025) - FIN		




// (24/03/2025) - INICIO		
/*
		//********************************************
        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/

		//  (NUEVA VERSION)
		//************************************
		function addError(pLocation, pError) {

			// We need to convert pError parameter to string
			var stringError = pError.toString();

			// Remove ' characters from the pError string
			var pattern = /'/g;
			stringError = stringError.replace(pattern, '');

			// Remove " characters from the pError string
			var pattern = /"/g;
			stringError = stringError.replace(pattern, '');

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {
					////console.log(">>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'dateTime': data,
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'location': pLocation,
						'error': stringError
					};

					errorLogService.addError(recordToAdd);

					//console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
				})
				.catch(function () {
					//console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
				});
		}
// (24/03/2025) - FIN		



        function redirectToAddVessel() {
            $location.path("/workflow-bidder/submission-bid/add-vessel");
        }


        function redirectToRequiredTechnicalDocs() {
            $location.path("/workflow-bidder/submission-bid/required-technical-docs");
        }


        function redirectToRequiredCommercialDocs() {
            $location.path("/workflow-bidder/submission-bid/required-commercial-docs");
        }


        function redirectToRequiredGeneralDocs() {
            $location.path("/workflow-bidder/submission-bid/required-general-docs");
        }

        function redirectToFinishUpload() {
            $location.path("/workflow-bidder/submission-bid/finish-upload");
        }


        function redirectToOtherDocs() {
            $location.path("/workflow-bidder/submission-bid/other-docs");
        }


        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

		
		
		

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.required-general-docs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.workflow_bidder_submission_bid_required_general_docs', {
            url      : '/workflow-bidder/submission-bid/required-general-docs',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow-bidder/submission-bid/required-general-docs/required-general-docs.html',
                    controller : 'RequiredGeneralDocsController as vm'
                }
            },
            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'required-general-docs'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow-bidder/submission-bid/required-general-docs');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-bidder.submission-bid.required-docs', {
            title : 'Required Documents',
            state : 'app.workflow_bidder_submission_bid_required_docs',
            icon  : 'icon-numeric-1-box',
            weight: 1
        });
*/        
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.required-general-docs')
        .controller('RequiredGeneralDocsController', RequiredGeneralDocsController);

    /** @ngInject */
    function RequiredGeneralDocsController(firebaseDataService,$mdSidenav,$scope,$timeout,$location,$firebaseArray,itbStatusService,$http,traceabilityService,errorLogService,utilsService,loginService,$sce,$mdDialog,$filter,$mdToast)
    {
        // DECLARATIONS ***********************
        var vm = this;
        var ACCESS_TOKEN = 'lhge3xkLsbAAAAAAAAAA7F4mpQiGgjg_fD658SG5evJitCht2fsvP7D-ZfaSwEl-';  //Dropbox API version 2
        
        vm.generalDocsPath;

        vm.pendingGeneralDocs;

        vm.generalGridOptions;

        vm.generalGridApi;

        vm.currentView = 'list';
        vm.selectedGeneralDoc;

        vm.itbBidderKeySelected;
        vm.fileUploaded;

        vm.generalDocsComments = "";

        vm.disableDropboxButtons = false;


        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.initGeneralGrid = initGeneralGrid;
        
        vm.getGeneralDocs = getGeneralDocs;

        vm.loadGeneralGrid = loadGeneralGrid;

        vm.redirectToAddVessel = redirectToAddVessel;
        
        vm.redirectToRequiredTechnicalDocs = redirectToRequiredTechnicalDocs;
        vm.redirectToRequiredCommercialDocs = redirectToRequiredCommercialDocs;
        vm.redirectToRequiredGeneralDocs = redirectToRequiredGeneralDocs;

        vm.redirectToOtherDocs = redirectToOtherDocs;
		vm.redirectToFinishUpload = redirectToFinishUpload;

        vm.showAlertDialog = showAlertDialog;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;

        vm.toggleView = toggleView;
        vm.toggleSidenav = toggleSidenav;

        vm.viewGeneralFile = viewGeneralFile;

        vm.selectGeneralFile = selectGeneralFile;

        vm.uploadGeneralFile = uploadGeneralFile;

        vm.uploadFileToDropbox = uploadFileToDropbox;

        vm.deleteGeneralDoc = deleteGeneralDoc;
        vm.deleteFileFromDropbox = deleteFileFromDropbox;

        vm.updateFieldPendingDocsDownloaded = updateFieldPendingDocsDownloaded;

        vm.saveGeneralDocs = saveGeneralDocs;

        vm.reviewPendingGeneralDocs = reviewPendingGeneralDocs;
        vm.checkGeneralDocExistsInPendingGeneralDocs = checkGeneralDocExistsInPendingGeneralDocs;

        //vm.getTraceabilityFromFirebaseByUser = getTraceabilityFromFirebaseByUser;
        vm.addTrace = addTrace;



        //START CONTROLLER *******************************
        vm.executeController();


        // METHODS ****************
        function executeController() {

            //We must retrieve itb_key of ITB selected in the workflow before execute the query.
            vm.itbKeySelected = itbStatusService.getItbKey();
            vm.bidderKeySelected = itbStatusService.getBidderKey();
            vm.itbBidderKeySelected = itbStatusService.getItbBidderKey();

            vm.generalDocsComments = $sce.trustAsHtml(itbStatusService.getGeneralDocsComments());

            //vm.generalDocsPath = "cdn/itb/" + vm.itbKeySelected + "/general_docs/" + vm.bidderKeySelected;
            var itbName = itbStatusService.getItbName();
            var bidderName = itbStatusService.getBidderName()
            vm.generalDocsPath = "cdn/itb/" + vm.itbKeySelected + "_" + itbName + "/" + vm.bidderKeySelected + "_" + bidderName + "/general_docs/";

            //IMPORTANT => Add pending general docs to Firebase table "pending_general_docs"
            vm.reviewPendingGeneralDocs(vm.itbKeySelected,vm.bidderKeySelected,bidderName);  

            //Initialization of the Grids
            vm.initGeneralGrid();

            //Technical and Commercial docs list obtained from FIREBASE
            vm.pendingGeneralDocs = vm.getGeneralDocs(vm.itbBidderKeySelected);

            //Get all the records of user_key from "traceability" table in Firebase
            //vm.traceability = vm.getTraceabilityFromFirebaseByUser(loginService.getUserKey());

            //console.log("[RequiredGeneralDocsController] (1) Get Technical and Commercial Docs list process START from ItbBidderKey '" + vm.itbBidderKeySelected + "'");
        }


/*
        function initTechnicalGrid() {

            vm.technicalGridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableColumnMenus: false,


                onRegisterApi: function(gridApi) {
                    vm.technicalGridApi = gridApi;
                  
                    vm.technicalGridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedTechnicalDoc = row.entity;

                        //console.log("[RequiredGeneralDocsController] Selected TECHNICAL DOC KEY = " + vm.selectedTechnicalDoc.$id);
                        //console.log("[RequiredGeneralDocsController] Selected TECHNICAL DOC NAME = " + vm.selectedTechnicalDoc.name);
                        //console.log("[RequiredGeneralDocsController] Selected TECHNICAL DOC URL = " + vm.selectedTechnicalDoc.url);
                        //console.log("************************************************************************");
                    });
                }
            };

            vm.technicalGridOptions.columnDefs = [
                { name:'Vessel', field: 'vessel', width: '28%' },
                { name:'Document', field: 'name', width: '35%' },
                { name:'File', field: 'url', width: '25%' },
                { name: 'Pending', field: 'pending', type: 'boolean',width: '12%', cellTemplate: '<input type="checkbox" disabled ="disabled" ng-model="row.entity.pending">'},
            ];
        }


        function initCommercialGrid() {

            vm.commercialGridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableColumnMenus: false,


                onRegisterApi: function(gridApi) {
                    vm.commercialGridApi = gridApi;
                  
                    vm.commercialGridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedCommercialDoc = row.entity;

                        //console.log("[RequiredGeneralDocsController] Selected COMMERCIAL DOC KEY = " + vm.selectedCommercialDoc.$id);
                        //console.log("[RequiredGeneralDocsController] Selected COMMERCIAL DOC NAME = " + vm.selectedCommercialDoc.name);
                        //console.log("[RequiredGeneralDocsController] Selected COMMERCIAL DOC URL = " + vm.selectedCommercialDoc.url);
                        //console.log("************************************************************************");
                    });
                }
            };

            vm.commercialGridOptions.columnDefs = [
                { name:'Document', field: 'name', width: '49%' },
                { name:'File', field: 'url', width: '39%' },
                { name: 'Pending', field: 'pending', type: 'boolean',width: '12%', cellTemplate: '<input type="checkbox" disabled ="disabled" ng-model="row.entity.pending">'},
            ];
        }
*/

        function initGeneralGrid() {

            vm.generalGridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: false,
                enableColumnMenus: false,


                onRegisterApi: function(gridApi) {
                    vm.generalGridApi = gridApi;
                  
                    vm.generalGridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedGeneralDoc = row.entity;

                        //console.log("[RequiredGeneralDocsController] Selected GENERAL DOC KEY = " + vm.selectedGeneralDoc.$id);
                        //console.log("[RequiredGeneralDocsController] Selected GENERAL DOC NAME = " + vm.selectedGeneralDoc.name);
                        //console.log("[RequiredGeneralDocsController] Selected GENERAL DOC URL = " + vm.selectedGeneralDoc.url);
                        //console.log("************************************************************************");
                    });
                }
            };

            vm.generalGridOptions.columnDefs = [
                /* { name:'Vessel', field: 'vessel', width: '28%' }, */
                { name:'Document', field: 'name', width: '51%' },
                { name:'File', field: 'file', width: '31%' },
                { name:'Date', field: 'dateTime', width: '18%' }
                /* ,{ name: 'Pending', field: 'pending', type: 'boolean',width: '12%', cellTemplate: '<input type="checkbox" disabled ="disabled" ng-model="row.entity.pending">'} */
            ];
        }


/*
        function getTechnicalDocs(pItbBidderKeySelected) {

            //Get Main Docs list from Firebase
            var fbUrl = new Firebase(FIREBASE_URL + "/pending_technical_docs/");
            vm.pendingTechnicalDocs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKeySelected));

            vm.pendingTechnicalDocs.$loaded()
                .then(function(data) {

                    vm.pendingTechnicalDocs = data;

                    //console.log("[RequiredGeneralDocsController] (2) Technical Docs list LOADED with " + data.length + " rows.");

                    //Load the grid with de itbs list
                    if (data.length > 0) {
                        vm.loadTechnicalGrid(data);
                    }
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[RequiredGeneralDocsController] ERROR: " + error + "(Log Error: Controller: RequiredGeneralDocsController / Function: getTechnicalDocs())");
                });
        }


        function getCommercialDocs(pItbBidderKeySelected) {

            //Get Main Docs list from Firebase
            var fbUrl = new Firebase(FIREBASE_URL + "/pending_commercial_docs/");
            vm.pendingCommercialDocs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKeySelected));

            vm.pendingCommercialDocs.$loaded()
                .then(function(data) {

                    vm.pendingCommercialDocs = data;

                    //console.log("[RequiredGeneralDocsController] (2) Commercial Docs list LOADED with " + data.length + " rows.");

                    //Load the grid with de itbs list
                    if (data.length > 0) {
                        vm.loadCommercialGrid(data);
                    }
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[RequiredGeneralDocsController] ERROR: " + error + "(Log Error: Controller: RequiredGeneralDocsController / Function: getCommercialDocs())");
                });
        }
*/

        function getGeneralDocs(pItbBidderKeySelected) {

            //Get Main Docs list from Firebase
//            var fbUrl = new Firebase(FIREBASE_URL + "/pending_general_docs/");
            var fbUrl = firebaseDataService.pending_general_docs;

            vm.pendingGeneralDocs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKeySelected));

            vm.pendingGeneralDocs.$loaded()
                .then(function(data) {

                    vm.pendingGeneralDocs = data;

                    //console.log("[RequiredGeneralDocsController] (2) General Docs list LOADED with " + data.length + " rows.");

                    //Load the grid with de itbs list
                    if (data.length > 0) {
                        vm.loadGeneralGrid(data);
                    }

/*
//TEST addError(location,error) method
var prueba = null;
prueba.trim();
*/
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[RequiredGeneralDocsController] ERROR: " + error + "(Log Error: Controller: RequiredGeneralDocsController / Function: getGeneralDocs())");

                    addError("RequiredGeneralDocsController / getGeneralDocs() function",error);
                });
        }

/*
        function loadTechnicalGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.technicalGridOptions.data = data;
            });

            //console.log("[RequiredGeneralDocsController] (3) LOAD Technical Grid DONE");
        }


        function loadCommercialGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.commercialGridOptions.data = data;
            });

            //console.log("[RequiredGeneralDocsController] (3) LOAD Commercial Grid DONE");
        }
*/

        function loadGeneralGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.generalGridOptions.data = data;
            });

            //console.log("[RequiredGeneralDocsController] (3) LOAD General Grid DONE");
        }



/*
        function viewGeneralFile() {

            var key = "";
            var url = "";

            try {
                key = vm.selectedGeneralDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            try {
                url = vm.selectedGeneralDoc.url.trim();

            } catch(e) {
                vm.showAlertDialog("There is not a file to show.");
                return;
            }

            if ( (url == null) || (url == "") ) {
                vm.showAlertDialog("There is not a file to show.");
                return;
            }

            //var url = "https://www.dropbox.com/" + vm.selectedDoc.url + "?access_token=" + ACCESS_TOKEN;
            var path = "https://content.dropboxapi.com/1/files/auto/" + url + "?access_token=" + ACCESS_TOKEN;

            //console.log("EXEC viewGeneralFile() method for url = " + path);

            window.open(path,"_blank");
        }
*/


        function viewGeneralFile() {

            var key = "";
            var url = "";

            try {
                key = vm.selectedGeneralDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            try {
                url = "/" + vm.selectedGeneralDoc.url.trim();

                //VERY IMPORTANT => Due to an error when we insert document's URL through "Chartbid Bidder's App" => we must remove "//"" (doble slash) before the name of the file.
                //BEGIN OF THE CODE
                var correctURL = url.replace("//","/");
                url = correctURL;
                //END OF THE CODE
                
            } catch(e) {
                vm.showAlertDialog("There is not a document to show.");
                return;
            }

            if ( (url == null) || (url == "") || (url == undefined) ) {
                vm.showAlertDialog("There is not a document to show.");
                return;
            }

//console.log("url = " + url);
            var type = utilsService.getContentType(url);
//console.log("type = " + type);

            var urlPost = 'https://content.dropboxapi.com/2/files/download'; 

            var dataToSend = "";

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream;charset=utf-8',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + url + '"}'
                },
                responseType: 'blob'
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    ////console.log("DESCARGADO CORRECTAMENTE EL ARCHIVO.");

                    var blob = new Blob([responseData], {type: type});
                    blob.name = "downloadedFile";
                    var url = (window.URL || window.webkitURL).createObjectURL(blob); 

                    window.open(url,"_blank");    

                })
                .error(function (responseData, status, header, config) {

                    ////console.log("ERROR AL DESCARGAR Y VISUALIZAR EL ARCHIVO: " + responseData);

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("RequiredGeneralDocsController / viewGeneralFile() function", error);
                }
            );

        }




        function selectGeneralFile() {

            var key;

            try {
                key = vm.selectedGeneralDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            //alert("EJECUTAMOS EL METODO 'selectFile()' ");
            angular.element(document.querySelector('#generalFileInput')).click();
        }

/*
        function saveTechnicalDocs() 
        {
            //console.log("START saveTechnicalDocs() method");

            var record = vm.selectedTechnicalDoc;

            if (record != null) {

                vm.pendingTechnicalDocs.$save(record)
                    .then(function(ref) {
                        //console.log("[RequiredGeneralDocsController] 'saveTechnicalDocs()' method => Saved record with ID = " + ref.key);
                    }
                );
            }
        }


        function saveCommercialDocs() 
        {
            //console.log("START saveCommercialDocs() method");

            var record = vm.selectedCommercialDoc;

            if (record != null) {

                vm.pendingCommercialDocs.$save(record)
                    .then(function(ref) {
                        //console.log("[RequiredGeneralDocsController] 'saveCommercialDocs()' method => Saved record with ID = " + ref.key);
                    }
                );
            }
        }
*/

        function saveGeneralDocs() 
        {
            //console.log("START saveGeneralDocs() method");

            var record = vm.selectedGeneralDoc;

            if (record != null) {

                vm.pendingGeneralDocs.$save(record)
                    .then(function(ref) {
                        //console.log("[RequiredGeneralDocsController] 'saveGeneralDocs()' method => Saved record with ID = " + ref.key);

                        //Update the fiel "pendingDocsDownloaded" from "itb_bidders" table
                        vm.updateFieldPendingDocsDownloaded(vm.itbBidderKeySelected,true);
                    })

                    .catch(function(error) {
                        //vm.gridOptions.data = null;
                        //console.log("[RequiredGeneralDocsController] ERROR: " + error + "(Log Error: Controller: RequiredGeneralDocsController / Function: saveGeneralDocs())");

                        addError("RequiredGeneralDocsController / saveGeneralDocs() function",error);
                    }
                );
            }
        }



        function updateFieldPendingDocsDownloaded(pItbBidderKey,pStatus) {

//            var fbUrl = new Firebase(FIREBASE_URL + "/itb_bidders/");
            var fbUrl = firebaseDataService.itb_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {

                    var itbBidderRecord = data[0];

                    itbBidderRecord.pendingDocsDownloaded = pStatus;

                    data.$save(itbBidderRecord);
                })

                .catch(function(error) {
                    //console.log("[RequiredGeneralDocsController] ERROR in updateFieldPendingDocsDownloaded(): " + error);

                    addError("RequiredGeneralDocsController / updateFieldPendingDocsDownloaded() function",error);

                    return true;
                });                
        }


		
		//************************************************
		function uploadGeneralFile(pFile) {
	
			//We check if the filename has non valid characters.
			//var general_special_invalids_characters_format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
			var format = /[`´'^\;':"\\|,<>\/?~]/;
			var filename = "";

			try {
				filename = pFile.name;
			} catch (error) {
                //vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredGeneralDocsController / Function: uploadFile())");
                return;
            }
			
			if( filename.match(format) ){
				vm.showAlertDialog("An invalid character ([ ` ´ ' ^ \ ; ' : \" \\ \| , \< \> \/ \? \~ ]) was found in file name. Please, change the name and try again. Thank you.");
				return;
			}
		
            utilsService.getCETdateTime()
                .then(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string for the uploading document = " + data);

                    //Upload the file to dropbox with the current CET DateTime
                    vm.uploadFileToDropbox(pFile, vm.generalDocsPath,data);
                })
                .catch(function () {
                    //console.log("ERROR => NOT POSSIBLE TO UPLOAD THE DOCUMENT BECAUSE IT HASN'T BEEN POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
					
					vm.showAlertDialog("There is a problem with the upload process. Please, try again later. Thank you.");
            });

        }


/*
        function uploadFileToDropbox(pFile, pPath,pDateTime) {

            var fileName = "";
            try {
                fileName = pFile.name;
            } catch (error) {
                fileName = "";
                return;
            }

            vm.disableDropboxButtons = true;

            $http({
                method: 'PUT',
                url: 'https://api-content.dropbox.com/1/files_put/dropbox/' + pPath + '/' + pFile.name + '?access_token=' + ACCESS_TOKEN,
                data: pFile
            })
            .success(function(data, status, headers, config) {
                //console.log(data);
                //console.log('file uploaded successfully');

                vm.disableDropboxButtons = false;
                showCustomToast("Document uploaded successfully.");                

                //Save the record in "pending_general_docs"
                vm.selectedGeneralDoc.url = vm.generalDocsPath + "/" + pFile.name;
                vm.selectedGeneralDoc.file = pFile.name;
                vm.selectedGeneralDoc.uploaded = true;
                vm.selectedGeneralDoc.pending = false;
                vm.selectedGeneralDoc.dateTime = pDateTime;
                vm.selectedGeneralDoc.downloaded = false;

                vm.saveGeneralDocs();

                //Insert a record in "traceability" table
                vm.addTrace("General document '" + fileName + "' uploaded.");
            })
            .error(function(data, status, headers, config) {
                //console.log('Error : ' + data);
                //console.log('Error in upload file to Dropbox process');
                vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredGeneralDocsController / Function: uploadFileToDropbox())");

                vm.disableDropboxButtons = false;

                var error = "DROPBOX error: " + data + " / status: " + status;
                addError("RequiredGeneralDocsController / uploadFileToDropbox() function", error);
            });
        }
*/


        function uploadFileToDropbox(pFile, pPath, pDateTime) {

            var fileName = "";

            try {
                fileName = pFile.name;
                
            } catch (error) {
                fileName = "";
                //vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredGeneralDocsController / Function: uploadFileToDropbox())");
                return;
            }

            var fullPath = "/" + pPath + fileName;

            ////console.log("fullPath = " + fullPath);
            ////console.log("pFile = " + pFile);

            vm.disableDropboxButtons = true;

            var urlPost = 'https://content.dropboxapi.com/2/files/upload'; 

            var dataToSend = pFile;

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + fullPath + '", "mode": "add", "autorename": true, "mute": false}'
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log(responseData);
                    //console.log('file uploaded successfully');

                    vm.disableDropboxButtons = false;
                    showCustomToast("Document uploaded successfully.");                

                    //Save the record in "pending_commercial_docs"
                    vm.selectedGeneralDoc.url = vm.generalDocsPath + fileName;
                    vm.selectedGeneralDoc.file = fileName;
                    vm.selectedGeneralDoc.uploaded = true;
                    vm.selectedGeneralDoc.pending = false;
                    vm.selectedGeneralDoc.dateTime = pDateTime;
                    vm.selectedGeneralDoc.downloaded = false;
                    ////console.log("vm.selectedGeneralDoc.url = " + vm.selectedGeneralDoc.url);
                    vm.saveGeneralDocs();

                    //Insert a record in "traceability" table
                    vm.addTrace("General document '" + fileName + "' uploaded.");

                })
                .error(function (responseData, status, header, config) {
                    //console.log('Error : ' + status);
                    //console.log('Error in upload file to Dropbox process');
                    vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredGeneralDocsController / Function: uploadFileToDropbox())");

                    vm.disableDropboxButtons = false;

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("RequiredGeneralDocsController / uploadFileToDropbox() function", error);
                }
            );
        }


        function deleteGeneralDoc() {

            var key;
            var fileName = vm.selectedGeneralDoc.file;

            try {
                key = vm.selectedGeneralDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            vm.deleteFileFromDropbox(vm.selectedGeneralDoc.url);

            vm.selectedGeneralDoc.url = "";
            vm.selectedGeneralDoc.file = "";
            vm.selectedGeneralDoc.dateTime = "";
            vm.selectedGeneralDoc.pending = true;
            vm.selectedGeneralDoc.uploaded = false;

            vm.saveGeneralDocs();

            //Insert a record in "traceability" table
            vm.addTrace("General document '" + fileName + "' deleted.");
        }



        function deleteFileFromDropbox(pPath) {

            try {
                pPath = pPath.trim();

            } catch(e) {
                vm.showAlertDialog("There is not a document to delete.");
                return;
            }


            if ( (pPath == null) || (pPath == "") || (pPath == undefined) ) {
                vm.showAlertDialog("There is not a document to delete.");
                return;
            }


            var filePath = "/" + pPath;
            
            vm.disableDropboxButtons = true;

            var urlPost = 'https://api.dropboxapi.com/2/files/delete_v2'; 

            var dataToSend = '{"path": "' + filePath + '"}';

            var config = {
                headers : {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log("File deleted successfully.");
                    vm.disableDropboxButtons = false;
                    showCustomToast("Document deleted successfully.");
                })
                .error(function (responseData, status, header, config) {

                    //console.log("dropbox DELETE ERROR => status: " + status);
                    //console.log('Error in deleting file from Dropbox process');
                    vm.showAlertDialog("There is a problem with the delete file process. Please, contact with the App administrator. (Log error: Controller: RequiredGeneralDocsController / Function: deleteFileFromDropbox()");

                    vm.disableDropboxButtons = false;

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("RequiredGeneralDocsController / deleteFileFromDropbox() function", error);
                }
            );
        }



        function reviewPendingGeneralDocs(pItbKey,pBidderKey,pBidderCompany) 
        {

            if ( (pItbKey == null) || (pItbKey == "") ) {
                vm.showAlertDialog("Not possible to review pending General docs");
                return;
            }

            if ( (pBidderKey == null) || (pBidderKey == "") ) {
                vm.showAlertDialog("Not possible to review pending General docs");
                return;
            }

            var itbBidderKey = pItbKey + "&" + pBidderKey;


//            var fbUrl = new Firebase(FIREBASE_URL + "/pending_general_docs/");
            var fbUrl = firebaseDataService.pending_general_docs;

            vm.pendingGeneralDocs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(itbBidderKey));

            vm.pendingGeneralDocs.$loaded()
                .then(function(data) {

                    vm.pendingGeneralDocs = data;


                    //We obtain from Firebase the records of "general_docs"
//                    var fbUrl2 = new Firebase(FIREBASE_URL + "/general_docs/");
                    var fbUrl2 = firebaseDataService.general_docs;

                    var generalDocs = $firebaseArray(fbUrl2.orderByChild("itb_key").equalTo(pItbKey));

                    generalDocs.$loaded()
                        .then(function(data) {

                            generalDocs = data;
                            //console.log("[SelectItbController] general docs list LOADED with " + data.length + " rows.");

                            var generalDocsArrayLength = 0;
                            try {
                                generalDocsArrayLength = generalDocs.length;
                            } catch (error) {
                                generalDocsArrayLength = 0;
                            }


                            if (generalDocsArrayLength > 0) 
                            {

                                for (var i=0; i<generalDocsArrayLength; i++) {                        

                                    var docKey = generalDocs[i].$id;
                                    var docName = generalDocs[i].name;

                                    if (!vm.checkGeneralDocExistsInPendingGeneralDocs(vm.pendingGeneralDocs,docKey)) {

                                        var stringJson = '{"itb_bidder_key": "' + itbBidderKey + '"'
                                                      +  ',"itb_key": "' + pItbKey + '"' 
                                                      +  ',"bidder_key": "' + pBidderKey + '"' 
                                                      +  ',"bidderCompany": "' + pBidderCompany + '"' 
                                                      +  ',"doc_key": "' + docKey + '"' 
                                                      +  ',"name": "' + docName + '"' 
                                                      +  ',"url": " "'
                                                      +  ',"pending": true'
                                                      +  ',"active": true'
                                                      +  '}';

                                        var jsonData = JSON.parse(stringJson);

                                        vm.pendingGeneralDocs.$add(jsonData)
                                            .then(function(ref) {
                                                //console.log("[SelectItbController] Added new record to 'reviewPendingGeneralDocs' with KEY = " + ref.key);
                                            })
                                        
                                            .catch(function(error) {
                                                //console.log("[SelectItbController] ERROR in 'reviewPendingGeneralDocs' function: " + error);
                                        });
                                    }
                                }

                            }

                        })

                        .catch(function(error) {
                            //console.log("[SelectItbController] ERROR in 'reviewPendingGeneralDocs' function: " + error);
                    });


                })
                .catch(function(error) {
                    //console.log("[SelectItbController] ERROR in 'reviewPendingGeneralDocs' function: " + error);

                    addError("RequiredGeneralDocsController / reviewPendingGeneralDocs() function",error);
            });

        }



        function checkGeneralDocExistsInPendingGeneralDocs(pPendingDocsArray,pDocKey) {

            var result = $filter('filter')(pPendingDocsArray, {doc_key: pDocKey});

            try {

                if (result.length > 0) {
                    return true;
                } else {
                    return false;
                }

            } catch(error) {
                return false;
            }
        }




        function showConfirmDeleteDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this document?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSH "YES" BUTTON
                    vm.deleteGeneralDoc();
                }, 
                function() {
                    //YOU HAVE PUSH "NO" BUTTON
                });
        }


        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }


        function showCustomToast(pMessage) {

            $mdToast.show(
                $mdToast.simple()
                    .textContent(pMessage)
                    .position('top right')
                    .hideDelay(3000)
            );
        }
        
/*
        function getTraceabilityFromFirebaseByUser(pUserKey) {

            if (pUserKey != null) {

//                var fbUrl = new Firebase(FIREBASE_URL + "/traceability/");
                var fbUrl = firebaseDataService.traceability;

                var result = $firebaseArray(fbUrl.orderByChild("user_key").equalTo(pUserKey));

                result.$loaded()
                    .then(function(data) {

                        traceabilityService.setTraceability(data);

                        //console.log("[traceabilityService] getTraceabilityByUser() method => Get all records of 'user_key' from 'traceability' table of Firebase.");

                        return data;
                    })
                    .catch(function(error) {
                        //console.log("[traceabilityService] getTraceabilityByUser() method => ERROR: " + error);
                    });

            } else {

                traceabilityService.setTraceability(null);
                return null;
            }
        }
*/


/*
// (24/03/2025) - INICIO		
		//****************************
        function addTrace(pAction) {

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'date': data,
                        'time': '',
                        'dateTime': utilsService.getDateTime(),
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'action': pAction
                    };

                    traceabilityService.addTrace(recordToAdd);                    

                })
                .error(function () {
                    //console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/

		//  (NUEVA VERSION)
		//******************************
		function addTrace(pAction) {

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {

					//console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'date': data,
						'time': '',
						'dateTime': utilsService.getDateTime(),
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'action': pAction
					};

					traceabilityService.addTrace(recordToAdd);

				})
				.catch(function () {
					//console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE EXTERNAL API.");
				});
		}
// (24/03/2025) - FIN				
		
		

// (24/03/2025) - INICIO
/*		
		//******************************************
        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/
		//  (NUEVA VERSION)
		//************************************
		function addError(pLocation, pError) {

			// We need to convert pError parameter to string
			var stringError = pError.toString();

			// Remove ' characters from the pError string
			var pattern = /'/g;
			stringError = stringError.replace(pattern, '');

			// Remove " characters from the pError string
			var pattern = /"/g;
			stringError = stringError.replace(pattern, '');

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {
					////console.log(">>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'dateTime': data,
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'location': pLocation,
						'error': stringError
					};

					errorLogService.addError(recordToAdd);

					//console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
				})
				.catch(function () {
					//console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
				});
		}
// (24/03/2025) - FIN


        function redirectToAddVessel() {
            $location.path("/workflow-bidder/submission-bid/add-vessel");
        }


        function redirectToRequiredTechnicalDocs() {
            $location.path("/workflow-bidder/submission-bid/required-technical-docs");
        }


        function redirectToRequiredCommercialDocs() {
            $location.path("/workflow-bidder/submission-bid/required-commercial-docs");
        }


        function redirectToRequiredGeneralDocs() {
            $location.path("/workflow-bidder/submission-bid/required-general-docs");
        }


        function redirectToOtherDocs() {
            $location.path("/workflow-bidder/submission-bid/other-docs");
        }

        function redirectToFinishUpload() {
            $location.path("/workflow-bidder/submission-bid/finish-upload");
        }


        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.required-commercial-docs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.workflow_bidder_submission_bid_required_commercial_docs', {
            url      : '/workflow-bidder/submission-bid/required-commercial-docs',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow-bidder/submission-bid/required-commercial-docs/required-commercial-docs.html',
                    controller : 'RequiredCommercialDocsController as vm'
                }
            },
            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'required-commercial-docs'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow-bidder/submission-bid/required-commercial-docs');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-bidder.submission-bid.required-docs', {
            title : 'Required Documents',
            state : 'app.workflow_bidder_submission_bid_required_docs',
            icon  : 'icon-numeric-1-box',
            weight: 1
        });
*/        
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.required-commercial-docs')
        .controller('RequiredCommercialDocsController', RequiredCommercialDocsController);

    /** @ngInject */
    function RequiredCommercialDocsController(firebaseDataService,$mdSidenav,$scope,$timeout,$location,$firebaseArray,itbStatusService,$http,traceabilityService,utilsService,loginService,errorLogService,$sce,$mdDialog,$filter,$mdToast)
    {
        // DECLARATIONS ***********************
        var vm = this;
        var ACCESS_TOKEN = 'lhge3xkLsbAAAAAAAAAA7F4mpQiGgjg_fD658SG5evJitCht2fsvP7D-ZfaSwEl-';  //Dropbox API version 2
        
        vm.commercialDocsPath;

        vm.pendingCommercialDocs;
        vm.commercialGridOptions;
        vm.commercialGridApi;
        vm.currentView = 'list';
        vm.selectedCommercialDoc;

        vm.itbBidderKeySelected;
        vm.fileUploaded;

        vm.commercialDocsComments = "";

        vm.disableDropboxButtons = false;


        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.initCommercialGrid = initCommercialGrid;
        
        vm.getCommercialDocs = getCommercialDocs;

        vm.loadCommercialGrid = loadCommercialGrid;

        vm.redirectToAddVessel = redirectToAddVessel;
        
        vm.redirectToRequiredTechnicalDocs = redirectToRequiredTechnicalDocs;
        vm.redirectToRequiredCommercialDocs = redirectToRequiredCommercialDocs;
        vm.redirectToRequiredGeneralDocs = redirectToRequiredGeneralDocs;

        vm.redirectToOtherDocs = redirectToOtherDocs;
		vm.redirectToFinishUpload = redirectToFinishUpload;

        vm.showAlertDialog = showAlertDialog;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;

        vm.toggleView = toggleView;
        vm.toggleSidenav = toggleSidenav;

        vm.viewCommercialFile = viewCommercialFile;

        vm.selectCommercialFile = selectCommercialFile;

        vm.uploadCommercialFile = uploadCommercialFile;

        vm.uploadFileToDropbox = uploadFileToDropbox;

        vm.deleteCommercialDoc = deleteCommercialDoc;
        vm.deleteFileFromDropbox = deleteFileFromDropbox;

        vm.updateFieldPendingDocsDownloaded = updateFieldPendingDocsDownloaded;

        vm.saveCommercialDocs = saveCommercialDocs;

        vm.reviewPendingCommercialDocs = reviewPendingCommercialDocs;
        vm.checkCommercialDocExistsInPendingCommercialDocs = checkCommercialDocExistsInPendingCommercialDocs;


        //vm.getTraceabilityFromFirebaseByUser = getTraceabilityFromFirebaseByUser;
        vm.addTrace = addTrace;



        //START CONTROLLER *******************************
        vm.executeController();


        // METHODS ****************
        function executeController() {

            //We must retrieve itb_key of ITB selected in the workflow before execute the query.
            vm.itbKeySelected = itbStatusService.getItbKey();
            vm.bidderKeySelected = itbStatusService.getBidderKey();
            vm.itbBidderKeySelected = itbStatusService.getItbBidderKey();

            vm.commercialDocsComments = $sce.trustAsHtml(itbStatusService.getCommercialDocsComments());

            //vm.commercialDocsPath = "cdn/itb/" + vm.itbKeySelected + "/commercial_docs/" + vm.bidderKeySelected;
            var itbName = itbStatusService.getItbName();
            var bidderName = itbStatusService.getBidderName()
            vm.commercialDocsPath = "cdn/itb/" + vm.itbKeySelected + "_" + itbName + "/" + vm.bidderKeySelected + "_" + bidderName + "/commercial_docs/";

            //IMPORTANT => Add pending commercial docs to Firebase table "pending_commercial_docs"
            vm.reviewPendingCommercialDocs(vm.itbKeySelected,vm.bidderKeySelected,bidderName);  

            //Initialization of the Grids
            vm.initCommercialGrid();

            //Commercial docs list obtained from FIREBASE
            vm.pendingCommercialDocs = vm.getCommercialDocs(vm.itbBidderKeySelected);

            //Get all the records of user_key from "traceability" table in Firebase
            //vm.traceability = vm.getTraceabilityFromFirebaseByUser(loginService.getUserKey());

            //console.log("[RequiredCommercialDocsController] (1) Get Technical and Commercial Docs list process START from ItbBidderKey '" + vm.itbBidderKeySelected + "'");
        }



        function initCommercialGrid() {

            vm.commercialGridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: false,
                enableColumnMenus: false,


                onRegisterApi: function(gridApi) {
                    vm.commercialGridApi = gridApi;
                  
                    vm.commercialGridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedCommercialDoc = row.entity;

                        //console.log("[RequiredCommercialDocsController] Selected COMMERCIAL DOC KEY = " + vm.selectedCommercialDoc.$id);
                        //console.log("[RequiredCommercialDocsController] Selected COMMERCIAL DOC NAME = " + vm.selectedCommercialDoc.name);
                        //console.log("[RequiredCommercialDocsController] Selected COMMERCIAL DOC URL = " + vm.selectedCommercialDoc.url);
                        //console.log("************************************************************************");
                    });
                }
            };

            vm.commercialGridOptions.columnDefs = [
                /* { name:'Vessel', field: 'vessel', width: '28%' }, */
                { name:'Document', field: 'name', width: '51%' },
                { name:'File', field: 'file', width: '31%' },
                { name:'Date', field: 'dateTime', width: '18%' }
                /* ,{ name: 'Pending', field: 'pending', type: 'boolean',width: '12%', cellTemplate: '<input type="checkbox" disabled ="disabled" ng-model="row.entity.pending">'}, */
            ];
        }



        function getCommercialDocs(pItbBidderKeySelected) {

            //Get Main Docs list from Firebase
//            var fbUrl = new Firebase(FIREBASE_URL + "/pending_commercial_docs/");
            var fbUrl = firebaseDataService.pending_commercial_docs;

            vm.pendingCommercialDocs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKeySelected));

            vm.pendingCommercialDocs.$loaded()
                .then(function(data) {

                    vm.pendingCommercialDocs = data;

                    //console.log("[RequiredCommercialDocsController] (2) Commercial Docs list LOADED with " + data.length + " rows.");

                    //Load the grid with de itbs list
                    if (data.length > 0) {
                        vm.loadCommercialGrid(data);
                    }
/*
//TEST addError(location,error) method
var prueba = null;
prueba.trim();
*/
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[RequiredCommercialDocsController] ERROR: " + error + "(Log Error: Controller: RequiredCommercialDocsController / Function: getCommercialDocs())");

                    addError("RequiredCommercialDocsController / getCommercialDocs() function",error);
                });
        }



        function loadCommercialGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.commercialGridOptions.data = data;
            });

            //console.log("[RequiredCommercialDocsController] (3) LOAD Commercial Grid DONE");
        }



        function viewCommercialFile() {

            var key = "";
            var url = "";

            try {
                key = vm.selectedCommercialDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            try {
                url = "/" + vm.selectedCommercialDoc.url.trim();

                //VERY IMPORTANT => Due to an error when we insert document's URL through "Chartbid Bidder's App" => we must remove "//"" (doble slash) before the name of the file.
                //BEGIN OF THE CODE
                var correctURL = url.replace("//","/");
                url = correctURL;
                //END OF THE CODE

            } catch(e) {
                vm.showAlertDialog("There is not a document to show.");
                return;
            }

            if ( (url == null) || (url == "") || (url == undefined) ) {
                vm.showAlertDialog("There is not a document to show.");
                return;
            }

//console.log("url = " + url);
            var type = utilsService.getContentType(url);
//console.log("type = " + type);

            var urlPost = 'https://content.dropboxapi.com/2/files/download'; 

            var dataToSend = "";

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream;charset=utf-8',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + url + '"}'
                },
                responseType: 'blob'
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    ////console.log("DESCARGADO CORRECTAMENTE EL ARCHIVO.");

                    var blob = new Blob([responseData], {type: type});
                    blob.name = "downloadedFile";
                    var url = (window.URL || window.webkitURL).createObjectURL(blob); 

                    window.open(url,"_blank");    

                })
                .error(function (responseData, status, header, config) {

                    ////console.log("ERROR AL DESCARGAR Y VISUALIZAR EL ARCHIVO: " + responseData);

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("RequiredCommercialDocsController / viewCommercialFile() function", error);
                }
            );

        }




        function selectCommercialFile() {

            var key;

            try {
                key = vm.selectedCommercialDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            //alert("EJECUTAMOS EL METODO 'selectFile()' ");
            angular.element(document.querySelector('#commercialFileInput')).click();
        }



        function saveCommercialDocs() 
        {
            //console.log("START saveCommercialDocs() method");

            var record = vm.selectedCommercialDoc;

            if (record != null) {

                vm.pendingCommercialDocs.$save(record)
                    .then(function(ref) {
                        //console.log("[RequiredCommercialDocsController] 'saveCommercialDocs()' method => Saved record with ID = " + ref.key);

                        //Update the fiel "pendingDocsDownloaded" from "itb_bidders" table
                        vm.updateFieldPendingDocsDownloaded(vm.itbBidderKeySelected,true);
                    })

                    .catch(function(error) {
                        //vm.gridOptions.data = null;
                        //console.log("[RequiredCommercialDocsController] ERROR: " + error + "(Log Error: Controller: RequiredCommercialDocsController / Function: saveCommercialDocs())");

                        addError("RequiredCommercialDocsController / saveCommercialDocs() function",error);
                    }
                );

            }
        }



        function updateFieldPendingDocsDownloaded(pItbBidderKey,pStatus) {

            var fbUrl = firebaseDataService.itb_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {

                    var itbBidderRecord = data[0];

                    itbBidderRecord.pendingDocsDownloaded = pStatus;

                    data.$save(itbBidderRecord);
                })

                .catch(function(error) {
                    //console.log("[RequiredCommercialDocsController] ERROR in updateFieldPendingDocsDownloaded(): " + error);

                    addError("RequiredCommercialDocsController / updateFieldPendingDocsDownloaded() function",error);

                    return true;
                });                
        }


/*
        function saveGeneralDocs() 
        {
            //console.log("START saveGeneralDocs() method");

            var record = vm.selectedGeneralDoc;

            if (record != null) {

                vm.pendingGeneralDocs.$save(record)
                    .then(function(ref) {
                        //console.log("[RequiredCommercialDocsController] 'saveGeneralDocs()' method => Saved record with ID = " + ref.key);
                    }
                );
            }
        }
*/

		//************************************************
		function uploadCommercialFile(pFile) {
	
			//We check if the filename has non valid characters.
			//var general_special_invalids_characters_format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
			var format = /[`´'^\;':"\\|,<>\/?~]/;
			var filename = "";

			try {
				filename = pFile.name;
			} catch (error) {
                //vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredCommercialDocsController / Function: uploadFile())");
                return;
            }
			
			if( filename.match(format) ){
				vm.showAlertDialog("An invalid character ([ ` ´ ' ^ \ ; ' : \" \\ \| , \< \> \/ \? \~ ]) was found in file name. Please, change the name and try again. Thank you.");
				return;
			}
		
            utilsService.getCETdateTime()
                .then(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string for the uploading document = " + data);

                    //Upload the file to dropbox with the current CET DateTime
                    vm.uploadFileToDropbox(pFile, vm.commercialDocsPath,data);
                })
                .catch(function () {
                    //console.log("ERROR => NOT POSSIBLE TO UPLOAD THE DOCUMENT BECAUSE IT HASN'T BEEN POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
					
					vm.showAlertDialog("There is a problem with the upload process. Please, try again later. Thank you.");
            });

        }




        function uploadFileToDropbox(pFile, pPath, pDateTime) {

            var fileName = "";

            try {
                fileName = pFile.name;
                
            } catch (error) {
                fileName = "";
                //vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredCommercialDocsController / Function: uploadFileToDropbox())");
                return;
            }

            var fullPath = "/" + pPath + fileName;

            ////console.log("fullPath = " + fullPath);
            ////console.log("pFile = " + pFile);

            vm.disableDropboxButtons = true;

            var urlPost = 'https://content.dropboxapi.com/2/files/upload'; 

            var dataToSend = pFile;

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + fullPath + '", "mode": "add", "autorename": true, "mute": false}'
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log(responseData);
                    //console.log('file uploaded successfully');

                    vm.disableDropboxButtons = false;
                    showCustomToast("Document uploaded successfully.");                

                    //Save the record in "pending_commercial_docs"
                    vm.selectedCommercialDoc.url = vm.commercialDocsPath + fileName;
                    vm.selectedCommercialDoc.file = fileName;
                    vm.selectedCommercialDoc.uploaded = true;
                    vm.selectedCommercialDoc.pending = false;
                    vm.selectedCommercialDoc.dateTime = pDateTime;
                    vm.selectedCommercialDoc.downloaded = false;
                    ////console.log("vm.selectedCommercialDoc.url = " + vm.selectedCommercialDoc.url);
                    vm.saveCommercialDocs();

                    //Insert a record in "traceability" table
                    vm.addTrace("Commercial document '" + fileName + "' uploaded.");

                })
                .error(function (responseData, status, header, config) {
                    //console.log('Error : ' + status);
                    //console.log('Error in upload file to Dropbox process');
                    vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredCommercialDocsController / Function: uploadFileToDropbox())");

                    vm.disableDropboxButtons = false;

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("RequiredCommercialDocsController / uploadFileToDropbox() function", error);
                }
            );
        }



        function deleteCommercialDoc() {

            var key;
            var fileName = vm.selectedCommercialDoc.file;

            try {
                key = vm.selectedCommercialDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            vm.deleteFileFromDropbox(vm.selectedCommercialDoc.url);

            vm.selectedCommercialDoc.url = "";
            vm.selectedCommercialDoc.file = "";
            vm.selectedCommercialDoc.dateTime = "";
            vm.selectedCommercialDoc.pending = true;
            vm.selectedCommercialDoc.uploaded = false;

            vm.saveCommercialDocs();

            //Insert a record in "traceability" table
            vm.addTrace("Commercial document '" + fileName + "' deleted.");
        }



        function deleteFileFromDropbox(pPath) {

            try {
                pPath = pPath.trim();

            } catch(e) {
                vm.showAlertDialog("There is not a document to delete.");
                return;
            }


            if ( (pPath == null) || (pPath == "") || (pPath == undefined) ) {
                vm.showAlertDialog("There is not a document to delete.");
                return;
            }


            var filePath = "/" + pPath;
            
            vm.disableDropboxButtons = true;

            var urlPost = 'https://api.dropboxapi.com/2/files/delete_v2'; 

            var dataToSend = '{"path": "' + filePath + '"}';

            var config = {
                headers : {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log("File deleted successfully.");
                    vm.disableDropboxButtons = false;
                    showCustomToast("Document deleted successfully.");
                })
                .error(function (responseData, status, header, config) {

                    //console.log("dropbox DELETE ERROR => status: " + status);
                    //console.log('Error in deleting file from Dropbox process');
                    vm.showAlertDialog("There is a problem with the delete file process. Please, contact with the App administrator. (Log error: Controller: RequiredCommercialDocsController / Function: deleteFileFromDropbox()");

                    vm.disableDropboxButtons = false;

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("RequiredCommercialDocsController / deleteFileFromDropbox() function", error);
                }
            );
        }



        function reviewPendingCommercialDocs(pItbKey,pBidderKey,pBidderCompany) 
        {

            if ( (pItbKey == null) || (pItbKey == "") ) {
                vm.showAlertDialog("Not possible to review pending Commercial docs");
                return;
            }

            if ( (pBidderKey == null) || (pBidderKey == "") ) {
                vm.showAlertDialog("Not possible to review pending Commercial docs");
                return;
            }

            var itbBidderKey = pItbKey + "&" + pBidderKey;


            var fbUrl = firebaseDataService.pending_commercial_docs;

            vm.pendingCommercialDocs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(itbBidderKey));

            vm.pendingCommercialDocs.$loaded()
                .then(function(data) {

                    vm.pendingCommercialDocs = data;


                    //We obtain from Firebase the records of "commercial_docs"
                    var fbUrl2 = firebaseDataService.commercial_docs;

                    var commercialDocs = $firebaseArray(fbUrl2.orderByChild("itb_key").equalTo(pItbKey));

                    commercialDocs.$loaded()
                        .then(function(data) {

                            commercialDocs = data;
                            //console.log("[RequiredCommercialDocsController] commercial docs list LOADED with " + data.length + " rows.");

                            var commercialDocsArrayLength = 0;
                            try {
                                commercialDocsArrayLength = commercialDocs.length;
                            } catch (error) {
                                commercialDocsArrayLength = 0;
                            }


                            if (commercialDocsArrayLength > 0) 
                            {

                                for (var i=0; i<commercialDocsArrayLength; i++) {                        

                                    var docKey = commercialDocs[i].$id;
                                    var docName = commercialDocs[i].name;

                                    if (!vm.checkCommercialDocExistsInPendingCommercialDocs(vm.pendingCommercialDocs,docKey)) {

                                        var stringJson = '{"itb_bidder_key": "' + itbBidderKey + '"'
                                                      +  ',"itb_key": "' + pItbKey + '"' 
                                                      +  ',"bidder_key": "' + pBidderKey + '"' 
                                                      +  ',"bidderCompany": "' + pBidderCompany + '"' 
                                                      +  ',"doc_key": "' + docKey + '"' 
                                                      +  ',"name": "' + docName + '"' 
                                                      +  ',"url": " "'
                                                      +  ',"pending": true'
                                                      +  ',"active": true'
                                                      +  '}';

                                        var jsonData = JSON.parse(stringJson);

                                        vm.pendingCommercialDocs.$add(jsonData)
                                            .then(function(ref) {
                                                //console.log("[RequiredCommercialDocsController] Added new record to 'pending_commercial_docs with KEY = " + ref.key);
                                            })
                                        
                                            .catch(function(error) {
                                                //console.log("[RequiredCommercialDocsController] ERROR in 'reviewPendingCommercialDocs' function: " + error);
                                        });
                                    }
                                }

                            }

                        })

                        .catch(function(error) {
                            //console.log("[RequiredCommercialDocsController] ERROR in 'reviewPendingCommercialDocs' function: " + error);
                    });


                })
                .catch(function(error) {
                    //console.log("[RequiredCommercialDocsController] ERROR in 'reviewPendingCommercialDocs' function: " + error);

                    addError("RequiredCommercialDocsController / reviewPendingCommercialDocs() function",error);
            });

        }



        function checkCommercialDocExistsInPendingCommercialDocs(pPendingDocsArray,pDocKey) {

            var result = $filter('filter')(pPendingDocsArray, {doc_key: pDocKey});

            try {

                if (result.length > 0) {
                    return true;
                } else {
                    return false;
                }

            } catch(error) {
                return false;
            }
        }



        function showConfirmDeleteDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this document?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSH "YES" BUTTON
                    vm.deleteCommercialDoc();
                }, 
                function() {
                    //YOU HAVE PUSH "NO" BUTTON
                });
        }


        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }


        function showCustomToast(pMessage) {

            $mdToast.show(
                $mdToast.simple()
                    .textContent(pMessage)
                    .position('top right')
                    .hideDelay(3000)
            );
        }

/*
        function getTraceabilityFromFirebaseByUser(pUserKey) {

            if (pUserKey != null) {

//                var fbUrl = new Firebase(FIREBASE_URL + "/traceability/");
                var fbUrl = firebaseDataService.traceability;

                var result = $firebaseArray(fbUrl.orderByChild("user_key").equalTo(pUserKey));

                result.$loaded()
                    .then(function(data) {

                        traceabilityService.setTraceability(data);

                        //console.log("[traceabilityService] getTraceabilityByUser() method => Get all records of 'user_key' from 'traceability' table of Firebase.");

                        return data;
                    })
                    .catch(function(error) {
                        //console.log("[traceabilityService] getTraceabilityByUser() method => ERROR: " + error);
                    });

            } else {

                traceabilityService.setTraceability(null);
                return null;
            }
        }
*/

// (24/03/2025) - INICIO
/*
		//***************************
        function addTrace(pAction) {

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'date': data,
                        'time': '',
                        'dateTime': utilsService.getDateTime(),
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'action': pAction
                    };

                    traceabilityService.addTrace(recordToAdd);                    

                })
                .error(function () {
                    //console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/

		//  (NUEVA VERSION)
		//******************************
		function addTrace(pAction) {

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {

					//console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'date': data,
						'time': '',
						'dateTime': utilsService.getDateTime(),
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'action': pAction
					};

					traceabilityService.addTrace(recordToAdd);

				})
				.catch(function () {
					//console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE EXTERNAL API.");
				});
		}
// (24/03/2025) - FIN			

		
// (24/03/2025) - INICIO
/*		
		//*******************************************
        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE API.");
                });
        }
*/

		//  (NUEVA VERSION)
		//************************************
		function addError(pLocation, pError) {

			// We need to convert pError parameter to string
			var stringError = pError.toString();

			// Remove ' characters from the pError string
			var pattern = /'/g;
			stringError = stringError.replace(pattern, '');

			// Remove " characters from the pError string
			var pattern = /"/g;
			stringError = stringError.replace(pattern, '');

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {
					////console.log(">>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'dateTime': data,
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'location': pLocation,
						'error': stringError
					};

					errorLogService.addError(recordToAdd);

					//console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
				})
				.catch(function () {
					//console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
				});
		}
// (24/03/2025) - FIN



        function redirectToAddVessel() {
            $location.path("/workflow-bidder/submission-bid/add-vessel");
        }


        function redirectToRequiredTechnicalDocs() {
            $location.path("/workflow-bidder/submission-bid/required-technical-docs");
        }


        function redirectToRequiredCommercialDocs() {
            $location.path("/workflow-bidder/submission-bid/required-commercial-docs");
        }


        function redirectToRequiredGeneralDocs() {
            $location.path("/workflow-bidder/submission-bid/required-general-docs");
        }


        function redirectToOtherDocs() {
            $location.path("/workflow-bidder/submission-bid/other-docs");
        }

        function redirectToFinishUpload() {
            $location.path("/workflow-bidder/submission-bid/finish-upload");
        }


        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.other-docs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.workflow_bidder_submission_bid_other_docs', {
            url      : '/workflow-bidder/submission-bid/other-docs',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow-bidder/submission-bid/other-docs/other-docs.html',
                    controller : 'OtherDocsController as vm'
                }
            },
            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'other-docs'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow-bidder/submission-bid/other-docs');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-bidder.submission-bid.required-docs', {
            title : 'Required Documents',
            state : 'app.workflow_bidder_submission_bid_required_docs',
            icon  : 'icon-numeric-1-box',
            weight: 1
        });
*/        
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.other-docs')
        .controller('OtherDocsController', OtherDocsController);

    /** @ngInject */
    function OtherDocsController(firebaseDataService,$mdSidenav,$scope,$timeout,$location,$firebaseArray,itbStatusService,$http,workflowService,$sce,utilsService,traceabilityService,errorLogService,loginService,$mdDialog,$mdToast)
    {
        // DECLARATIONS ***********************
        var vm = this;
        var ACCESS_TOKEN = 'lhge3xkLsbAAAAAAAAAA7F4mpQiGgjg_fD658SG5evJitCht2fsvP7D-ZfaSwEl-';  //Dropbox API version 2

        vm.docsPath;
        vm.otherDocs;
        vm.gridOptions;
        vm.gridApi;

        vm.currentView = 'list';
        vm.selectedDoc;
        vm.itbKeySelected;
        vm.bidderKeySelected;
        vm.itbBidderKeySelected;

        vm.fileUploaded;

        vm.otherDocsComments = "";      

        vm.disableDropboxButtons = false;  

        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.initGrid = initGrid;
        vm.getDocs = getDocs;
        vm.loadGrid = loadGrid;
        vm.refreshGrid = refreshGrid;

        vm.redirectToAddVessel = redirectToAddVessel;

        vm.redirectToRequiredTechnicalDocs = redirectToRequiredTechnicalDocs;
        vm.redirectToRequiredCommercialDocs = redirectToRequiredCommercialDocs;
        vm.redirectToRequiredGeneralDocs = redirectToRequiredGeneralDocs;
        
        vm.redirectToOtherDocs = redirectToOtherDocs;
        vm.redirectToPendingBcf = redirectToPendingBcf;
		vm.redirectToFinishUpload = redirectToFinishUpload;

        vm.showAlertDialog = showAlertDialog;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;

        vm.toggleView = toggleView;
        vm.toggleSidenav = toggleSidenav;

        vm.viewFile = viewFile;
        vm.selectFile = selectFile;
        vm.uploadFile = uploadFile;

        vm.uploadFileToDropbox = uploadFileToDropbox;
        vm.addDoc = addDoc;
        vm.deleteDoc = deleteDoc;
        vm.deleteFileFromDropbox = deleteFileFromDropbox;

        vm.updateFieldPendingDocsDownloaded = updateFieldPendingDocsDownloaded;


        //START CONTROLLER *******************************
        vm.executeController();


        // METHODS ****************
        function executeController() {

            //We must retrieve itb_key of ITB selected in the workflow before execute the query.
            vm.itbKeySelected = itbStatusService.getItbKey();
            vm.bidderKeySelected = itbStatusService.getBidderKey();
            vm.itbBidderKeySelected = vm.itbKeySelected + "&" + vm.bidderKeySelected;

            vm.otherDocsComments = $sce.trustAsHtml(itbStatusService.getOtherDocsComments());

            //vm.docsPath = "cdn/itb/" + vm.itbKeySelected + "/other_docs/" + vm.bidderKeySelected;
            var itbName = itbStatusService.getItbName();
            var bidderName = itbStatusService.getBidderName()
            vm.docsPath = "cdn/itb/" + vm.itbKeySelected + "_" + itbName + "/" + vm.bidderKeySelected + "_" + bidderName + "/other_docs/";

            //Initialization of the Grids
            vm.initGrid();

            //Technical and Commercial docs list obtained from FIREBASE
            vm.otherDocs = vm.getDocs(vm.itbBidderKeySelected);

            //console.log("[OtherDocsController] (1) Get Other Docs list process START from ItbBidderKey '" + vm.itbBidderKeySelected + "'");
        }



        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: false,
                enableColumnMenus: false,


                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedDoc = row.entity;

                        //console.log("[OtherDocsController] Selected TECHNICAL DOC KEY = " + vm.selectedDoc.$id);
                        //console.log("[OtherDocsController] Selected TECHNICAL DOC NAME = " + vm.selectedDoc.name);
                        //console.log("[OtherDocsController] Selected TECHNICAL DOC URL = " + vm.selectedDoc.url);
                        //console.log("************************************************************************");
                    });
                }
            };

            vm.gridOptions.columnDefs = [
                { name:'Document', field: 'name', width: '82%' },
                { name:'Date', field: 'dateTime', width: '18%' }
                /*,{ name:'File', field: 'url', width: '50%' } */
            ];
        }



        function getDocs(pItbBidderKeySelected) {

            //Get Main Docs list from Firebase
//            var fbUrl = new Firebase(FIREBASE_URL + "/other_docs/");
            var fbUrl = firebaseDataService.other_docs;

            var docs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKeySelected));

            docs.$loaded()
                .then(function(data) {

                    vm.otherDocs = data;
                    //console.log("[OtherDocsController] (2) Other Docs list LOADED with " + data.length + " rows.");

                    //Load the grid with de itbs list
                    if (data.length > 0) {
                        vm.loadGrid(data);
                    }
/*
//TEST addError(location,error) method
var prueba = null;
prueba.trim();
*/

                })
                .catch(function(error) {
                    //console.log("[OtherDocsController] ERROR: " + error + "(Log Error: Controller: OtherDocsController / Function: getDocs())");

                    addError("OtherDocsController / getDocs() function",error);
                });
        }



        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("[OtherDocsController] (3) LOAD Grid DONE");
        }



        function refreshGrid() {
            vm.gridApi.core.refresh();
        }




        function viewFile() {

            var key = "";
            var url = "";

            try {
                key = vm.selectedDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            try {
                url = "/" + vm.selectedDoc.url.trim();

                //VERY IMPORTANT => Due to an error when we insert document's URL through "Chartbid Bidder's App" => we must remove "//"" (doble slash) before the name of the file.
                //BEGIN OF THE CODE
                var correctURL = url.replace("//","/");
                url = correctURL;
                //END OF THE CODE

            } catch(e) {
                vm.showAlertDialog("There is not a document to show.");
                return;
            }

            if ( (url == null) || (url == "") || (url == undefined) ) {
                vm.showAlertDialog("There is not a document to show.");
                return;
            }

            ////console.log("url = " + url);
            var type = utilsService.getContentType(url);
            ////console.log("type = " + type);

            var urlPost = 'https://content.dropboxapi.com/2/files/download'; 

            var dataToSend = "";

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream;charset=utf-8',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + url + '"}'
                },
                responseType: 'blob'
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    ////console.log("DESCARGADO CORRECTAMENTE EL ARCHIVO.");

                    var blob = new Blob([responseData], {type: type});
                    blob.name = "downloadedFile";
                    var url = (window.URL || window.webkitURL).createObjectURL(blob); 

                    window.open(url,"_blank");    

                })
                .error(function (responseData, status, header, config) {

                    ////console.log("ERROR AL DESCARGAR Y VISUALIZAR EL ARCHIVO: " + responseData);

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("OtherDocsController / viewFile() function", error);
                }
            );

        }




        function selectFile() {
            //alert("EJECUTAMOS EL METODO 'selectFile()' ");
            angular.element(document.querySelector('#fileInput')).click();
        }



        function addDoc(pItbKey,pItbBidderKey,pName,pUrl,pDateTime) {

            var fbUrl = firebaseDataService.other_docs;

            var docs = $firebaseArray(fbUrl);

            var stringJson = '{"itb_key": "' + pItbKey + '", "itb_bidder_key": "' + pItbBidderKey + '", "name": "' + pName + '", "url": "' + pUrl  + '", "dateTime": "' + pDateTime + '", "downloaded": false}';
            var jsonData = JSON.parse(stringJson);

            docs.$add(jsonData)
                .then(function(ref) {
                    //console.log("[OtherDocsController] Added new document to 'other_docs' record with ID = " + ref.key);

                    //Refresh grid
                    vm.loadGrid(vm.otherDocs);

                    //Update the fiel "pendingDocsDownloaded" from "itb_bidders" table
                    vm.updateFieldPendingDocsDownloaded(pItbBidderKey,true);

                })
                .catch(function(error) {
                    //console.log("[OtherDocsController] ERROR: " + error + "(Log Error: Controller: OtherDocsController / Function: addDoc())");

                    addError("OtherDocsController / addDoc() function",error);
                }
            );
        }


        function updateFieldPendingDocsDownloaded(pItbBidderKey,pStatus) {

            var fbUrl = firebaseDataService.itb_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {

                    var itbBidderRecord = data[0];

                    itbBidderRecord.pendingDocsDownloaded = pStatus;

                    data.$save(itbBidderRecord);

                })
                .catch(function(error) {
                    //console.log("[OtherDocsController] ERROR: " + error + "(Log Error: Controller: OtherDocsController / Function: updateFieldPendingDocsDownloaded())");

                    addError("OtherDocsController / updateFieldPendingDocsDownloaded() function",error);

                    return true;
                }
            );


        }


        function deleteDoc() {

            var key;

            try {
                key = vm.selectedDoc.$id;

            } catch(e) {
                showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                showAlertDialog("Please select a document.");
                return;
            }

            var doc = vm.selectedDoc;
            var fileName = vm.selectedDoc.name;
            
            if (doc != null) {
                vm.otherDocs.$remove(doc)
                    .then(function(ref) {
                        //console.log("[OtherDocsController] Deleted record from 'other_docs' with KEY = " + ref.key);

                        //Delete the file in Dropbox
                        vm.deleteFileFromDropbox(vm.selectedDoc.url);

                        addTrace("Other document '" + fileName + "' deleted.");

                    })
                    .catch(function(error) {
                        //console.log("[OtherDocsController] ERROR: " + error + " (Log Error: Controller: OtherDocsController / Function: deleteDoc())");

                        addError("OtherDocsController / deleteDoc() function",error);
                    }
                );

            } else {
                //console.log("[OtherDocsController] We can´t remove the row because there isn´t a selected row.");
            }
        }



        function deleteFileFromDropbox(pPath) {

            try {
                pPath = pPath.trim();

            } catch(e) {
                vm.showAlertDialog("There is not a document to delete.");
                return;
            }


            if ( (pPath == null) || (pPath == "") || (pPath == undefined) ) {
                vm.showAlertDialog("There is not a document to delete.");
                return;
            }


            var filePath = "/" + pPath;
            
            vm.disableDropboxButtons = true;

            var urlPost = 'https://api.dropboxapi.com/2/files/delete_v2'; 

            var dataToSend = '{"path": "' + filePath + '"}';

            var config = {
                headers : {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log("File deleted successfully.");
                    vm.disableDropboxButtons = false;
                    showCustomToast("Document deleted successfully.");
                })
                .error(function (responseData, status, header, config) {

                    //console.log("dropbox DELETE ERROR => status: " + status);
                    //console.log('Error in deleting file from Dropbox process');
                    vm.showAlertDialog("There is a problem with the delete file process. Please, contact with the App administrator. (Log error: Controller: OtherDocsController / Function: deleteFileFromDropbox()");

                    vm.disableDropboxButtons = false;

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("OtherDocsController / deleteFileFromDropbox() function", error);
                }
            );
        }



		//************************************************
		function uploadFile(pFile) {
	
			//We check if the filename has non valid characters.
			//var general_special_invalids_characters_format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
			var format = /[`´'^\;':"\\|,<>\/?~]/;
			var filename = "";

			try {
				filename = pFile.name;
			} catch (error) {
                //vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: OtherDocsController / Function: uploadFile())");
                return;
            }
			
			if( filename.match(format) ){
				vm.showAlertDialog("An invalid character ([ ` ´ ' ^ \ ; ' : \" \\ \| , \< \> \/ \? \~ ]) was found in file name. Please, change the name and try again. Thank you.");
				return;
			}
		
            utilsService.getCETdateTime()
                .then(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string for the uploading document = " + data);

                    //Upload the file to dropbox with the current CET DateTime
                    vm.uploadFileToDropbox(pFile, vm.docsPath,data);
                })
                .catch(function () {
                    //console.log("ERROR => NOT POSSIBLE TO UPLOAD THE DOCUMENT BECAUSE IT HASN'T BEEN POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
					
					vm.showAlertDialog("There is a problem with the upload process. Please, try again later. Thank you.");
            });

        }
		
		

		//*******************************************************
        function uploadFileToDropbox(pFile, pPath, pDateTime) {

            var fileName = "";

            try {
                fileName = pFile.name;
                
            } catch (error) {
                fileName = "";
                //vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: OtherDocsController / Function: uploadFileToDropbox())");
                return;
            }

            var fullPath = "/" + pPath + fileName;

            ////console.log("fullPath = " + fullPath);
            ////console.log("pFile = " + pFile);

            vm.disableDropboxButtons = true;

            var urlPost = 'https://content.dropboxapi.com/2/files/upload'; 

            var dataToSend = pFile;

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + fullPath + '", "mode": "add", "autorename": true, "mute": false}'
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log(responseData);
                    //console.log('file uploaded successfully');

                    vm.disableDropboxButtons = false;
                    showCustomToast("Document uploaded successfully.");                

                    //Save the record in "other_docs"
                    var name = fileName;
                    var url = pPath + fileName;
                    var dateTime = pDateTime;
                    ////console.log("url = " + url);
                    vm.addDoc(vm.itbKeySelected,vm.itbBidderKeySelected,name,url,dateTime);

                    //Insert a record in "traceability" table
                    addTrace("Other document '" + fileName + "' uploaded.");

                })
                .error(function (responseData, status, header, config) {
                    //console.log('Error : ' + status);
                    //console.log('Error in upload file to Dropbox process');
                    vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: OtherDocsController / Function: uploadFileToDropbox())");

                    vm.disableDropboxButtons = false;

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("OtherDocsController / uploadFileToDropbox() function", error);
                }
            );
        }




        function showConfirmDeleteDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this document?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSH "YES" BUTTON
                    vm.deleteDoc();
                }, 
                function() {
                    //YOU HAVE PUSH "NO" BUTTON
                });
        }


        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }


        function showCustomToast(pMessage) {

            $mdToast.show(
                $mdToast.simple()
                    .textContent(pMessage)
                    .position('top right')
                    .hideDelay(3000)
            );
        }
        
		
// (24/03/2025) - INICIO	
/*
		//****************************		
        function addTrace(pAction) {

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'date': data,
                        'time': '',
                        'dateTime': utilsService.getDateTime(),
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'action': pAction
                    };

                    traceabilityService.addTrace(recordToAdd);           

                })
                .error(function () {
                    //console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/
		//  (NUEVA VERSION)
		//******************************
		function addTrace(pAction) {

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {

					//console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'date': data,
						'time': '',
						'dateTime': utilsService.getDateTime(),
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'action': pAction
					};

					traceabilityService.addTrace(recordToAdd);

				})
				.catch(function () {
					//console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE EXTERNAL API.");
				});
		}
// (24/03/2025) - FIN					
		
		
// (24/03/2025) - INICIO	
/*	
		//***************************************
        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/

		//  (NUEVA VERSION)
		//************************************
		function addError(pLocation, pError) {

			// We need to convert pError parameter to string
			var stringError = pError.toString();

			// Remove ' characters from the pError string
			var pattern = /'/g;
			stringError = stringError.replace(pattern, '');

			// Remove " characters from the pError string
			var pattern = /"/g;
			stringError = stringError.replace(pattern, '');

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {
					////console.log(">>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'dateTime': data,
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'location': pLocation,
						'error': stringError
					};

					errorLogService.addError(recordToAdd);

					//console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
				})
				.catch(function () {
					//console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
				});
		}
// (24/03/2025) - FIN


        function redirectToAddVessel() {
            $location.path("/workflow-bidder/submission-bid/add-vessel");
        }


        function redirectToRequiredTechnicalDocs() {
            $location.path("/workflow-bidder/submission-bid/required-technical-docs");
        }


        function redirectToRequiredCommercialDocs() {
            $location.path("/workflow-bidder/submission-bid/required-commercial-docs");
        }


        function redirectToRequiredGeneralDocs() {
            $location.path("/workflow-bidder/submission-bid/required-general-docs");
        }


        function redirectToOtherDocs() {
            $location.path("/workflow-bidder/submission-bid/other-docs");
        }


        function redirectToPendingBcf() {

            workflowService.setCompletionBcfStatus(true);
            $location.path("/workflow-bidder/completion-bcf/pending-bcf");
        }

        function redirectToFinishUpload() {
            $location.path("/workflow-bidder/submission-bid/finish-upload");
        }


        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.finish-upload', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.workflow_bidder_submission_bid_finish_upload', {
            url      : '/workflow-bidder/submission-bid/finish-upload',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow-bidder/submission-bid/finish-upload/finish-upload.html',
                    controller : 'FinishUploadController as vm'
                }
            },
            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'other-docs'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow-bidder/submission-bid/finish-upload');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-bidder.submission-bid.required-docs', {
            title : 'Required Documents',
            state : 'app.workflow_bidder_submission_bid_required_docs',
            icon  : 'icon-numeric-1-box',
            weight: 1
        });
*/        
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.finish-upload')
        .controller('FinishUploadController', FinishUploadController);

    /** @ngInject */
    function FinishUploadController(firebaseDataService,$mdSidenav,$scope,$timeout,$location,$firebaseArray,itbStatusService,$http,workflowService,$sce,utilsService,traceabilityService,errorLogService,loginService,$mdDialog,$mdToast)
    {
        // DECLARATIONS ***********************
        var vm = this;

        vm.currentView = 'list';

        vm.itbKeySelected;
        vm.bidderKeySelected;
        vm.itbBidderKeySelected;

		vm.commentsForThisPage = "Once all required documentation has been uploaded, please select “Complete upload of documents” to finalise bid submission";
		vm.finishUploadComments;
        vm.disableCompleteUploadDocumentsButton = false;


        // METHODS DECLARATION ****************
        vm.executeController = executeController;

/*
        vm.initGrid = initGrid;
        vm.getDocs = getDocs;
        vm.loadGrid = loadGrid;
        vm.refreshGrid = refreshGrid;
*/

        vm.redirectToAddVessel = redirectToAddVessel;
        vm.redirectToRequiredTechnicalDocs = redirectToRequiredTechnicalDocs;
        vm.redirectToRequiredCommercialDocs = redirectToRequiredCommercialDocs;
        vm.redirectToRequiredGeneralDocs = redirectToRequiredGeneralDocs;
        vm.redirectToOtherDocs = redirectToOtherDocs;
		vm.redirectToPendingBcf = redirectToPendingBcf;
		vm.redirectToFinishUpload = redirectToFinishUpload;

        vm.showAlertDialog = showAlertDialog;
        vm.showConfirmFinishUploadDialog = showConfirmFinishUploadDialog;

        vm.toggleView = toggleView;
        vm.toggleSidenav = toggleSidenav;

/*
        vm.viewFile = viewFile;
        vm.selectFile = selectFile;
        vm.uploadFile = uploadFile;

        vm.uploadFileToDropbox = uploadFileToDropbox;
        vm.addDoc = addDoc;
        vm.deleteDoc = deleteDoc;
        vm.deleteFileFromDropbox = deleteFileFromDropbox;
*/

        vm.updateFieldFinished = updateFieldFinished;


        //START CONTROLLER *******************************
        vm.executeController();


        // METHODS ****************
        function executeController() {

            //We must retrieve itb_key of ITB selected in the workflow before execute the query.
            vm.itbKeySelected = itbStatusService.getItbKey();
            vm.bidderKeySelected = itbStatusService.getBidderKey();
            vm.itbBidderKeySelected = vm.itbKeySelected + "&" + vm.bidderKeySelected;

            vm.finishUploadComments = $sce.trustAsHtml(vm.commentsForThisPage);

            var itbName = itbStatusService.getItbName();
            var bidderName = itbStatusService.getBidderName()

            //console.log("[FinishUploadController] (1) executeController() DONE for ItbBidderKey='" + vm.itbBidderKeySelected + "'");

		}


        function updateFieldFinished(pItbBidderKey,pStatus) {

            var fbUrl = firebaseDataService.itb_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {

                    var itbBidderRecord = data[0];

                    itbBidderRecord.finished = pStatus;

                    data.$save(itbBidderRecord);

                    vm.disableCompleteUploadDocumentsButton = true;

					addTrace("Completed upload of documents for this ITB");

                })
                .catch(function(error) {
                    //console.log("[FinishUploadController] ERROR: " + error + "(Log Error: Controller: FinishUploadController / Function: updateFieldFinished())");

                    addError("FinishUploadController / updateFieldFinished() function",error);

                    return true;
                }
            );
        }




        function showConfirmFinishUploadDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Thank you for your submission.')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Close");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSH "YES" BUTTON
                    vm.updateFieldFinished(vm.itbBidderKeySelected,true);
                },
                function() {
                    //YOU HAVE PUSH "NO" BUTTON
                });
        }


        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    //Do nothing
                });
        }


        function showCustomToast(pMessage) {

            $mdToast.show(
                $mdToast.simple()
                    .textContent(pMessage)
                    .position('top right')
                    .hideDelay(3000)
            );
        }

		
// (24/03/2025) - INICIO
/*
		//*****************************
        function addTrace(pAction) {

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);

                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(),
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'date': data,
                        'time': '',
                        'dateTime': utilsService.getDateTime(),
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'action': pAction
                    };

                    traceabilityService.addTrace(recordToAdd);

                })
                .error(function () {
                    //console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/
		//  (NUEVA VERSION)
		//******************************
		function addTrace(pAction) {

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {

					//console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'date': data,
						'time': '',
						'dateTime': utilsService.getDateTime(),
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'action': pAction
					};

					traceabilityService.addTrace(recordToAdd);

				})
				.catch(function () {
					//console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE EXTERNAL API.");
				});
		}
// (24/03/2025) - FIN					

		
// (24/03/2025) - INICIO	
/*	
		//***************************************
        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);

                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(),
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/
		
//  (NUEVA VERSION)
		//************************************
		function addError(pLocation, pError) {

			// We need to convert pError parameter to string
			var stringError = pError.toString();

			// Remove ' characters from the pError string
			var pattern = /'/g;
			stringError = stringError.replace(pattern, '');

			// Remove " characters from the pError string
			var pattern = /"/g;
			stringError = stringError.replace(pattern, '');

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {
					////console.log(">>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'dateTime': data,
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'location': pLocation,
						'error': stringError
					};

					errorLogService.addError(recordToAdd);

					//console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
				})
				.catch(function () {
					//console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
				});
		}
// (24/03/2025) - FIN
		

        function redirectToAddVessel() {
            $location.path("/workflow-bidder/submission-bid/add-vessel");
        }


        function redirectToRequiredTechnicalDocs() {
            $location.path("/workflow-bidder/submission-bid/required-technical-docs");
        }


        function redirectToRequiredCommercialDocs() {
            $location.path("/workflow-bidder/submission-bid/required-commercial-docs");
        }


        function redirectToRequiredGeneralDocs() {
            $location.path("/workflow-bidder/submission-bid/required-general-docs");
        }


        function redirectToOtherDocs() {
            $location.path("/workflow-bidder/submission-bid/other-docs");
        }

        function redirectToFinishUpload() {
            $location.path("/workflow-bidder/submission-bid/finish-upload");
        }

        function redirectToPendingBcf() {

            workflowService.setCompletionBcfStatus(true);
            $location.path("/workflow-bidder/completion-bcf/pending-bcf");
        }


        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.add-vessel', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.workflow_bidder_submission_bid_add_vessel', {
            url      : '/workflow-bidder/submission-bid/add-vessel',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow-bidder/submission-bid/add-vessel/add-vessel.html',
                    controller : 'AddVesselController as vm'
                }
            },
            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'add-vessel'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow-bidder/submission-bid/add-vessel');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-admin.prepare-itb.required-docs', {
            title : 'Required Documents',
            state : 'app.workflow_admin_prepare_itb_required_docs',
            icon  : 'icon-numeric-2-box',
            weight: 2
        });
*/        
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid.add-vessel')
        .controller('AddVesselController', AddVesselController);

    /** @ngInject */
    function AddVesselController(firebaseDataService,$mdSidenav,$scope,$timeout,$location,$firebaseArray,itbStatusService,workflowService,$sce,$mdDialog,utilsService,loginService,errorLogService,$filter)
    {
        // DECLARATIONS ***********************
        var vm = this;
        vm.vessels;
        vm.pending_technical_docs;
        vm.pending_commercial_docs;
        vm.vesselName = "";
        vm.selectedVessel;
        vm.itbBidderKeySelected;
        vm.addVesselComments = "";

        vm.gridOptions;
        vm.gridApi;

        vm.currentView = "list";

        // METHODS DECLARATION ****************
        vm.executeController = executeController;

        vm.initGrid = initGrid;

        vm.getVessels = getVessels;
        vm.loadGrid = loadGrid;
        vm.refreshGrid = refreshGrid;

        vm.newVessel = newVessel;
        vm.deleteVessel = deleteVessel;
        vm.deletePendingTechnicalDocsOfVessel = deletePendingTechnicalDocsOfVessel;
		vm.checkNotExistVesselAndSave = checkNotExistVesselAndSave;

        vm.save = save;
        vm.cancel = cancel;

        vm.addPendingTechnicalDocs = addPendingTechnicalDocs;

//***************************
//Function for testing proposal		
vm.insertDuplicatedRowsForTesting = insertDuplicatedRowsForTesting;
//***************************

        vm.redirectToReceiptItb = redirectToReceiptItb;
        vm.redirectToAddVessel = redirectToAddVessel;

        vm.redirectToRequiredTechnicalDocs = redirectToRequiredTechnicalDocs;
        vm.redirectToRequiredCommercialDocs = redirectToRequiredCommercialDocs;
        vm.redirectToRequiredGeneralDocs = redirectToRequiredGeneralDocs;
        
        vm.redirectToOtherDocs = redirectToOtherDocs;
        vm.redirectToCompletionBcf = redirectToCompletionBcf;
		vm.redirectToFinishUpload = redirectToFinishUpload;

        vm.showAlertDialog = showAlertDialog;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;

/*
        vm.toggleTechnicalView = toggleTechnicalView;
        vm.toggleCommercialView = toggleCommercialView;
*/
        vm.toggleSidenav = toggleSidenav;


        //START CONTROLLER *******************************
        vm.executeController();


        // METHODS ****************
        function executeController() {

            //We must retrieve itb_key of ITB selected in the workflow before execute the query.
//            vm.itbKeySelected = itbStatusService.getItbKey();
            vm.itbBidderKeySelected = itbStatusService.getItbBidderKey();

            vm.addVesselComments = $sce.trustAsHtml(itbStatusService.getAddVesselComments());

            //Initialization of the Grid (Technical docs GRID)
            vm.initGrid();

            //Vessels list obtained from FIREBASE
            vm.vessels = vm.getVessels(vm.itbBidderKeySelected);
            //console.log("[AddVesselController] (1) Get Vessels list of 'vessel_bidders' table START from ItbBidderKey '" + vm.itbBidderKeySelected + "'");
        }



        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                //enableFiltering: true,
                enableColumnMenus: false,


                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedVessel = row.entity;

                        //console.log("[AddVesselController] Selected VESSEL KEY = " + vm.selectedVessel.$id);
                        //console.log("[AddVesselController] Selected VESSEL NAME = " + vm.selectedVessel.vessel_name);
                        //console.log("************************************************************************");
                    });
                }
            };

            vm.gridOptions.columnDefs = [
                { name:'Vessel', field: 'vessel_name' }
            ];
        }


		//**********************************************************
        function refreshGrid() {
            vm.gridApi.core.refresh();
        }


		//**********************************************************
        function getVessels(pItbBidderKeySelected) {

            //Get Vessel list from "pending_technical_docs" table
//            var fbUrl = new Firebase(FIREBASE_URL + "/vessel_bidders/");
            var fbUrl = firebaseDataService.vessel_bidders;

            vm.vessels = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKeySelected));

            vm.vessels.$loaded()
                .then(function(data) {

                    vm.vessels = data;

                    //console.log("[AddVesselController] (2) Vessel list of 'vessel_bidders' table LOADED with " + data.length + " rows.");

                    //Load the grid with de itbs list
                    if (data.length > 0) {
                        vm.loadGrid(data);
                    }
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[AddVesselController] ERROR in getVessels() method for 'pending_technical_docs' table: " + error);

                    addError("AddVesselController / getVessels() function",error);
                });

        }



		//**********************************************************
        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;

//**********************************
//EXECUTE function for testing proposal						
//vm.insertDuplicatedRowsForTesting();
//**********************************
				
            });

            //console.log("[AddVesselController] (3) LOAD Grid DONE");
        }



		//**********************************************************
        function newVessel()  {

            vm.vesselName = "";
            vm.currentView = "detail";
        }


		//**********************************************************
        function deleteVessel() {

            var key;

            try {
                key = vm.selectedVessel.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a vessel.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a vessel.");
                return;
            }

            var vessel = vm.selectedVessel;
            var itbBidderKey = vm.selectedVessel.itb_bidder_key;
            var itbBidderVesselKey = vm.selectedVessel.itb_bidder_key + "&" + vm.selectedVessel.$id;

            if (vessel != null) {
                vm.vessels.$remove(vessel)
                    .then(function(ref) {
                        //console.log("[AddVesselController] Delete record from 'vessel_bidders' with KEY = " + ref.key);
 
                        //Refresh grid
                        vm.refreshGrid();

                        //We delete the records in 'pending_technical_docs' related to the Vessel deleted.
                        vm.deletePendingTechnicalDocsOfVessel(itbBidderVesselKey);
                    })

                    .catch(function(error) {
                        //vm.gridOptions.data = null;
                        //console.log("[AddVesselController] ERROR in deleteVessel() method: " + error);

                        addError("AddVesselController / deleteVessel() function",error);
                    });

            } else {
                //console.log("[AddVesselController] We can´t remove the row from 'vessel_bidders' because there isn´t a selected row.");
            }
        }


		//**********************************************************
        function deletePendingTechnicalDocsOfVessel(pItbBidderVesselKey) {

            //Get Vessel list from "pending_technical_docs" table
//            var fbUrl = new Firebase(FIREBASE_URL + "/pending_technical_docs/");
            var fbUrl = firebaseDataService.pending_technical_docs;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_vessel_key").equalTo(pItbBidderVesselKey));

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    for (var i=0;i<dataLength;i++) {

                        var recordToDelete = data[i];
                        result.$remove(recordToDelete);
                        //console.log("[AddVesselController] method deletePendingTechnicalDocsOfVessel() => Record with key=" + recordToDelete.$id + "DELETED");
                    }
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[AddVesselController] ERROR in deletePendingTechnicalDocsOfVessel() method for 'pending_technical_docs' table: " + error);

                    addError("AddVesselController / deletePendingTechnicalDocsOfVessel() function",error);
                });
        }


		
		//***********************************************************
		function checkNotExistVesselAndSave(pVesselName) {
			
			var fbUrl = firebaseDataService.vessel_bidders;

			//We get the vessels for this ITB and Bidder
            var vesselsForThisItbAndBidder = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(vm.itbBidderKeySelected));

            vesselsForThisItbAndBidder.$loaded()
                .then(function(data) {

                    vesselsForThisItbAndBidder = data;
					
					var result = $filter('filter')(vesselsForThisItbAndBidder, {vessel_name: pVesselName});
					
					var numberOfItemsFound = result.length;

                    if (numberOfItemsFound > 0) {
                        //console.log("[AddVesselController / checkNotExistVesselAndSave] (1) Vessel already exists.");
						
						vm.showAlertDialog("The vessel already exists. Please insert another name for the vessel.");
						
						return;
                    }
					
					//console.log("[AddVesselController / checkNotExistVesselAndSave] (2) Vessel doesn't exist => WE SAVE THE NEW VESSEL and create its Technical documents.");
					vm.save(pVesselName);
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[AddVesselController] ERROR in checkNotExistVesselAndSave() => " + error);

                    addError("AddVesselController / checkNotExistVesselAndSave() function",error);
                });			
			
		}
		

		//**********************************************************
        function save(pVessel) {

            if (pVessel != null) {

                var itbKey = itbStatusService.getItbKey();
                var bidderKey = itbStatusService.getBidderKey();
                var itbBidderKey = itbKey + "&" + bidderKey;
                var bidderCompany = itbStatusService.getBidderName();

                var stringJson = '{"itb_bidder_key": "' + itbBidderKey + '", "vessel_name": "' + pVessel + '", "active": true}';
                var jsonData = JSON.parse(stringJson);

                vm.vessels.$add(jsonData)
                    .then(function(ref) {
                        //console.log("Added new record to 'vessel_bidders' with ID = " + ref.key);

                        var vesselKey = ref.key;

                        //Add vessel to "pending_technical_docs" table
                        vm.addPendingTechnicalDocs(itbKey,bidderKey,bidderCompany,vesselKey,pVessel);

                        //Add vessel to "pending_commercial_docs" table
                        //vm.addPendingCommercialDocs(itbKey,bidderKey,bidderCompany,vesselKey,pVessel);

                        //Refresh grid
                        vm.loadGrid(vm.vessels);
                    })

                    .catch(function(error) {
                        //vm.gridOptions.data = null;
                        //console.log("[AddVesselController] ERROR in save() method: " + error);

                        addError("AddVesselController / save() function",error);
                    }
                );

                vm.currentView = 'list';
            }
        }




        function cancel() {
            vm.currentView = 'list';
        }



        function addPendingTechnicalDocs(pItbKey,pBidderKey,pBidderCompany,pVesselKey,pVessel) 
        {
            if ( ( (pItbKey != null) || (pItbKey != "") ) && ( (pBidderKey != null) || (pBidderKey != "") ) ) {
        
                //We obtain from Firebase the records of "technical_docs"
                var fbUrl = firebaseDataService.technical_docs;

                vm.technicalDocs = $firebaseArray(fbUrl.orderByChild("itb_key").equalTo(pItbKey));

                vm.technicalDocs.$loaded()
                    .then(function(data) {

                        vm.technicalDocs = data;

                        var technicalDocsLength = vm.technicalDocs.length;

                        //console.log("[AddVesselController] (2) technical docs list LOADED with " + technicalDocsLength + " rows.");

                        if (vm.technicalDocs.length > 0) 
                        {
                            //We add records to "pending_technical_docs" with all the records obtains of "technical_docs"
                            var itbBidderKey = pItbKey + "&" + pBidderKey;
                            var itbBidderVesselKey = itbBidderKey + "&" + pVesselKey;

                            var fbUrl2 = firebaseDataService.pending_technical_docs;

                            vm.pendingTechnicalDocs = $firebaseArray(fbUrl2.orderByChild("itb_bidder_key").equalTo(itbBidderKey).limitToLast(1));

                            vm.pendingTechnicalDocs.$loaded()
                                .then(function(data) {

                                    for (var i=0; i<technicalDocsLength; i++) {

                                        var stringJson = '{"itb_bidder_key": "' + itbBidderKey + '"'
                                                      +  ',"itb_key": "' + pItbKey + '"' 
                                                      +  ',"bidder_key": "' + pBidderKey + '"' 
                                                      +  ',"bidderCompany": "' + pBidderCompany + '"' 
                                                      +  ',"doc_key": "' + vm.technicalDocs[i].$id + '"' 
                                                      +  ',"name": "' + vm.technicalDocs[i].name + '"' 
                                                      +  ',"url": " "'
                                                      +  ',"pending": true' 
                                                      +  ',"active": true'
                                                      +  ',"vessel": "' + pVessel + '"'
                                                      +  ',"itb_bidder_vessel_key": "' + itbBidderVesselKey + '"' 
                                                      +  '}';

                                        var jsonData = JSON.parse(stringJson);

                                        vm.pendingTechnicalDocs.$add(jsonData)
                                            .then(function(ref) {

                                                //console.log("[AddVesselController] Added new record to 'pending_technical_docs' with KEY = " + ref.key);
                                            })

                                            .catch(function(error) {

                                                //console.log("[AddVesselController] ERROR adding 'pending technical doc' in 'addPendingTechnicalDocs()' function: " + error);

                                                addError("AddVesselController / addPendingTechnicalDocs() function / vm.pendingTechnicalDocs.$add() instruction",error);
                                            }
                                        );
                                    }

                                })

                                .catch(function(error) {

                                    //console.log("[AddVesselController] ERROR loading 'pending technical docs' in 'addPendingTechnicalDocs()' function: " + error);

                                    addError("AddVesselController / addPendingTechnicalDocs() function / vm.pendingTechnicalDocs.$loaded() instruction.",error);
                                }
                            );

                        }                

                    })

                    .catch(function(error) {

                        //console.log("[AddVesselController] ERROR loading 'technical docs' in 'addPendingTechnicalDocs()' function: " + error);

                        addError("AddVesselController / addPendingTechnicalDocs() function / vm.technicalDocs.$loaded() instruction.",error);
                    }
                );

            } else {

                vm.showAlertDialog("Not possible to add pending Technical docs to 'pending_technical_docs'");
            }

        }



        function showConfirmDeleteDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this vessel?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSH "YES" BUTTON
                    vm.deleteVessel();
                }, 
                function() {
                    //YOU HAVE PUSH "NO" BUTTON
                });
        }


        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }


		
// (24/03/2025) - INICIO			
/*
		//*****************************************
        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/
		//  (NUEVA VERSION)
		//************************************
		function addError(pLocation, pError) {

			// We need to convert pError parameter to string
			var stringError = pError.toString();

			// Remove ' characters from the pError string
			var pattern = /'/g;
			stringError = stringError.replace(pattern, '');

			// Remove " characters from the pError string
			var pattern = /"/g;
			stringError = stringError.replace(pattern, '');

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {
					////console.log(">>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'dateTime': data,
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'location': pLocation,
						'error': stringError
					};

					errorLogService.addError(recordToAdd);

					//console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
				})
				.catch(function () {
					//console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
				});
		}
// (24/03/2025) - FIN



/*
        function addPendingCommercialDocs(pItbKey,pBidderKey,pBidderCompany,pVesselKey,pVessel) 
        {
            if ( ( (pItbKey != null) || (pItbKey != "") ) && ( (pBidderKey != null) || (pBidderKey != "") ) ) {
        
                //We obtain from Firebase the records of "technical_docs"
                var fbUrl = new Firebase(FIREBASE_URL + "/commercial_docs/");
                vm.commercialDocs = $firebaseArray(fbUrl.orderByChild("itb_key").equalTo(pItbKey));

                vm.commercialDocs.$loaded()
                    .then(function(data) {

                        vm.commercialDocs = data;
                        //console.log("[AddVesselController] (2) commercial docs list LOADED with " + data.length + " rows.");

                        if (vm.commercialDocs.length > 0) 
                        {
                            //We add records to "pending_commercial_docs" with all the records obtains of "commercial_docs"
                            var itbBidderKey = pItbKey + "&" + pBidderKey;
                            var itbBidderVesselKey = itbBidderKey + "&" + pVesselKey;

                            var fbUrl2 = new Firebase(FIREBASE_URL + "/pending_commercial_docs/");
                            vm.pendingCommercialDocs = $firebaseArray(fbUrl2.orderByChild("itb_bidder_key").equalTo(itbBidderKey));

                            vm.pendingCommercialDocs.$loaded()
                                .then(function(data) {

                                    for (var i=0; i<vm.commercialDocs.length; i++) {

                                        var stringJson = '{"itb_bidder_key": "' + itbBidderKey + '"'
                                                      +  ',"itb_key": "' + pItbKey + '"' 
                                                      +  ',"bidder_key": "' + pBidderKey + '"' 
                                                      +  ',"bidderCompany": "' + pBidderCompany + '"' 
                                                      +  ',"doc_key": "' + vm.commercialDocs[i].$id + '"' 
                                                      +  ',"name": "' + vm.commercialDocs[i].name + '"' 
                                                      +  ',"url": " "'
                                                      +  ',"pending": true' 
                                                      +  ',"vessel": "' + pVessel + '"'
                                                      +  ',"itb_bidder_vessel_key": "' + itbBidderVesselKey + '"' 
                                                      +  '}';

                                        var jsonData = JSON.parse(stringJson);

                                        vm.pendingCommercialDocs.$add(jsonData)
                                            .then(function(ref) {
                                                //console.log("[AddVesselController] Added new record to 'pending_commercial_docs' with KEY = " + ref.key);
                                        });  
                                    }
                            });  
                        }                

                    })

                    .catch(function(error) {
                        //vm.gridOptions.data = null;
                        //console.log("[AddVesselController] ERROR retrieving technical docs in 'addPendingCommercialDocs' function: " + error);
                });

            } else {

                alert("Not possible to add pending Commercial docs to 'pending_commercial_docs'");
            }
        }
*/


        function redirectToReceiptItb() {

            $location.path("/workflow-bidder/receipt-itb");
        }


        function redirectToAddVessel() {
            $location.path("/workflow-bidder/submission-bid/add-vessel");
        }


        function redirectToRequiredTechnicalDocs() {
            $location.path("/workflow-bidder/submission-bid/required-technical-docs");
        }


        function redirectToRequiredCommercialDocs() {
            $location.path("/workflow-bidder/submission-bid/required-commercial-docs");
        }


        function redirectToRequiredGeneralDocs() {
            $location.path("/workflow-bidder/submission-bid/required-general-docs");
        }


        function redirectToOtherDocs() {
            $location.path("/workflow-bidder/submission-bid/other-docs");
        }


        function redirectToCompletionBcf() {
            $location.path("/workflow-bidder/completion-bcf");
        }

        function redirectToFinishUpload() {
            $location.path("/workflow-bidder/submission-bid/finish-upload");
        }

        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


		
//*********************************************************************		
// FOR TESTING PROPOSAL => DEACTIVATE THIS FUNCTION AFTER TESTING.		
//*********************************************************************		
        function insertDuplicatedRowsForTesting() 
        {
            var itbBidderKey = "-KntThBvOQ924IBlPEi5&-KAKqRnyUxSVtaJuk2IM";

			//We obtain from Firebase the records of "technical_docs"
			var fbUrl = firebaseDataService.pending_technical_docs;
			var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(itbBidderKey));

			result.$loaded()
				.then(function(data) {

					var pendingTechnicalDocs = data;

					var arrayLength = pendingTechnicalDocs.length;

					for (var i=0;i<arrayLength;i++) 
					{
						pendingTechnicalDocs.$add(data[i]);
					}                

				})

				.catch(function(error) {

					//console.log("insertDuplicatedRowsForTesting() ERROR loading 'technical docs' in 'addPendingTechnicalDocs()' function: " + error);

					addError("insertDuplicatedRowsForTesting() function / vm.technicalDocs.$loaded() instruction.",error);
				}
			);
        }			
		
		

/*
//FUNCIÓN DE TEST QUE INSERTA UN NUEVO REGISTRO EN "technical_docs"
        function TEST_insertCommercialDocIn_Docs(pItbKey,pName) {

            var fbUrl = new Firebase(FIREBASE_URL + "commercial_docs/");
            var docs = $firebaseArray(fbUrl);

            var stringJson = '{"itb_key": "' + pItbKey + '", "name": "' + pName + '"}';
            var jsonData = JSON.parse(stringJson);

            docs.$add(jsonData)
                .then(function(ref) {
                    //console.log("[commercialDocsController] Added new document to 'commercial_docs' record with ID = " + ref.key);

                    //Insert key in "itbs/mainDocs" record
                    //vm.TEST_insertNewDocIn_mainDocs(pItbKey,ref.key);
                }
            );
        }
*/


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.completion-bcf.pending-bcf', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.workflow_bidder_completion_bcf_pending_bcf', {
            url      : '/workflow-bidder/completion-bcf/pending-bcf',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow-bidder/completion-bcf/pending-bcf/pending-bcf.html',
                    controller : 'PendingBcfController as vm'
                }
            },


            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'pending-bcf'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow-bidder/completion-bcf/pending-bcf');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-bidder.completion-bcf', {
            title : 'Completion of BCF',
            state : 'app.workflow_bidder_completion_bcf',
            icon  : 'icon-numeric-2-box',
            weight: 2
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.completion-bcf.pending-bcf')
        .controller('PendingBcfController', PendingBcfController);

    /** @ngInject */
    function PendingBcfController($mdSidenav,$scope,$timeout,$location,FIREBASE_URL,$firebaseArray,itbStatusService,$filter,$mdDialog,$document)
    {
        var vm = this;

        // DECLARATIONS ***********************
        var vm = this;

        vm.itbBidderKey;
        vm.bcfsOfItb;
        vm.gridOptions;
        vm.gridApi;
        vm.selectedBcf;
        vm.currentView = 'list';
    
        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.getBcfsOfItb = getBcfsOfItb;

        vm.initGrid = initGrid;
        vm.loadGrid = loadGrid;

        vm.answerBcfDialog = answerBcfDialog;

        vm.redirectToBcfDocs = redirectToBcfDocs;
        vm.redirectToPendingBcf = redirectToPendingBcf;
        vm.redirectToOtherDocs = redirectToOtherDocs;
        vm.redirectToSelectItb = redirectToSelectItb;

        vm.toggleView = toggleView;
        vm.toggleSidenav = toggleSidenav;


        //START CONTROLLER *******************************
        vm.executeController();



        // METHODS ****************
        function executeController() 
        {
            //We must retrieve itb_key of ITB selected in the workflow before execute the query.
            vm.itbBidderKey = itbStatusService.getItbBidderKey();

            //Initialization of the Grid
            vm.initGrid();

            //bidders list obtained from FIREBASE
            vm.bcfsOfItb = vm.getBcfsOfItb(vm.itbBidderKey);
        }


        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableColumnMenus: false,


                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedBcf = row.entity;
                        //console.log("[CompletionBcfController] Selected Row KEY = " + vm.selectedBcf.$id);
                        //console.log("[CompletionBcfController] Selected Row SUBJECT = " + vm.selectedBcf.subject);

                        //console.log("[CompletionBcfController] Selected Row FROM NAME = " + vm.selectedBcf.fromName);
                        //console.log("[CompletionBcfController] Selected Row FROM EMAIL = " + vm.selectedBcf.fromEmail);
                        //console.log("[CompletionBcfController] Selected Row SENDER KEY = " + vm.selectedBcf.sender_key);
                        //console.log("[CompletionBcfController] Selected Row ITB SENDER KEY = " + vm.selectedBcf.itb_sender_key);

                        //console.log("[CompletionBcfController] Selected Row TO NAME = " + vm.selectedBcf.toName);
                        //console.log("[CompletionBcfController] Selected Row TO EMAIL = " + vm.selectedBcf.toEmail);
                        //console.log("[CompletionBcfController] Selected Row RECEIVER KEY = " + vm.selectedBcf.receiver_key);
                        //console.log("[CompletionBcfController] Selected Row ITB RECEIVER KEY = " + vm.selectedBcf.itb_receiver_key);

                        //console.log("[CompletionBcfController] Selected Row PENDING BCF = " + vm.selectedBcf.pendingBcf);
                    });
                }
                
            };

            vm.gridOptions.columnDefs = [
                { name:'Bidder (Company)', field: 'toName', width: '40%' },
                { name:'Required BCF', field: 'subject', width: '45%'  },
                { name: 'Pending', field: 'pendingBcf', type: 'boolean',width: '15%', enableCellEdit: false, cellTemplate: '<input type="checkbox" disabled="disabled" ng-model="row.entity.pendingBcf">'}
            ];
        }



        function getBcfsOfItb(pItbReceiverKey) {

            //console.log("(1)[PendingBcfController]  Get BCF's list for ITB_RECEIVER_KEY = '" + pItbReceiverKey + "'");

            //Get mail list from Firebase        
            var fbUrl = new Firebase(FIREBASE_URL + "/communications/");
            var result = $firebaseArray(fbUrl.orderByChild("itb_receiver_key").equalTo(pItbReceiverKey));

            result.$loaded()
                .then(function(data) {

                    //IMPORTANTE => FILTRAMOS EL RESULTADO DE LA CONSULTA A FIREBASE POR EL CAMPO "type"='bcf' PARA OBTENER SÓLO LAS COMUNICACIONES QUE SON BCFs
                    vm.bcfsOfItb = $filter('filter')(data, {type: 'bcf'});

                    //Load the grid with the data
                    vm.loadGrid(vm.bcfsOfItb);

                    //console.log("[PendingBcfController] getBcfsOfItb('" + pItbReceiverKey + "') LOADED with " + data.length + " elements.");
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[PendingBcfController] ERROR in function getBcfsOfItb(): " + error);
                });

        }



        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("[PendingBcfController] (3) LOAD Grid DONE");
        }



        function answerBcfDialog(ev)
        {
            //vm.getBiddersToSend();

            if (vm.selectedBcf == null) {

                alert("Please select a BCF record in the list");
                return;
            }


            $mdDialog.show({
                controller         : 'AnswerBcfDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: vm.selectedBcf,
                    type: 'bcf'
                },
                templateUrl        : 'app/main/apps/workflow-bidder/completion-bcf/pending-bcf/dialogs/compose/answer-bcf-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false
            });
        }


        function redirectToBcfDocs() {
            $location.path("/workflow-bidder/completion-bcf/bcf-docs");
        }

        function redirectToPendingBcf() {
            $location.path("/workflow-bidder/completion-bcf/pending-bcf");
        }

        function redirectToOtherDocs() {
            $location.path("/workflow-bidder/submission-bid/other-docs");
        }


        function redirectToSelectItb() {
            $location.path("/workflow-bidder/select-itb");
        }


        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';
        }



        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.completion-bcf.bcf-docs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.workflow_bidder_completion_bcf_bcf_docs', {
            url      : '/workflow-bidder/completion-bcf/bcf-docs',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow-bidder/completion-bcf/bcf-docs/bcf-docs.html',
                    controller : 'BcfDocsController as vm'
                }
            },
            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'bcf-docs'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow-bidder/completion-bcf/bcf-docs');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-bidder.submission-bid.required-docs', {
            title : 'Required Documents',
            state : 'app.workflow_bidder_submission_bid_required_docs',
            icon  : 'icon-numeric-1-box',
            weight: 1
        });
*/        
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.completion-bcf.bcf-docs')
        .controller('BcfDocsController', BcfDocsController);

    /** @ngInject */
    function BcfDocsController(firebaseDataService,$mdSidenav,$scope,$timeout,$location,$firebaseArray,itbStatusService,$http,workflowService,traceabilityService,errorLogService,utilsService,loginService,$sce,$mdDialog,$mdToast)
    {
        // DECLARATIONS ***********************
        var vm = this;
        var ACCESS_TOKEN = 'lhge3xkLsbAAAAAAAAAACDcG3R667qMJvWTgTyICBJrizvU1KEvC86tENaiaF84T';
        vm.docsPath;
        vm.otherDocs;
        vm.gridOptions;
        vm.gridApi;

        vm.currentView = 'list';
        vm.selectedDoc;
        vm.itbKeySelected;
        vm.bidderKeySelected;
        vm.itbBidderKeySelected;

        vm.fileUploaded;

        vm.bcfDocsComments = "";

        vm.disableDropboxButtons = false;          

        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.initGrid = initGrid;
        vm.getDocs = getDocs;
        vm.loadGrid = loadGrid;
        vm.refreshGrid = refreshGrid;

        vm.redirectToBcfDocs = redirectToBcfDocs;
        vm.redirectToPendingBcf = redirectToPendingBcf;
        vm.redirectToOtherDocs = redirectToOtherDocs;
        vm.redirectToSelectItb = redirectToSelectItb;

        vm.showAlertDialog = showAlertDialog;
        vm.showConfirmDeleteDialog = showConfirmDeleteDialog;

        vm.toggleView = toggleView;
        vm.toggleSidenav = toggleSidenav;

        vm.viewFile = viewFile;
        vm.selectFile = selectFile;
        vm.uploadFile = uploadFile;

        vm.uploadFileToDropbox = uploadFileToDropbox;
        vm.addDoc = addDoc;
        vm.deleteDoc = deleteDoc;
        vm.deleteFileFromDropbox = deleteFileFromDropbox;

        vm.updateFieldPendingDocsDownloaded = updateFieldPendingDocsDownloaded;

        //vm.getTraceabilityFromFirebaseByUser = getTraceabilityFromFirebaseByUser;
        vm.addTrace = addTrace;


        //START CONTROLLER *******************************
        vm.executeController();


        // METHODS ****************
        function executeController() {

            //We must retrieve itb_key of ITB selected in the workflow before execute the query.
            vm.itbKeySelected = itbStatusService.getItbKey();
            vm.bidderKeySelected = itbStatusService.getBidderKey();
            vm.itbBidderKeySelected = vm.itbKeySelected + "&" + vm.bidderKeySelected;

            vm.bcfDocsComments = $sce.trustAsHtml(itbStatusService.getBcfDocsComments());

            var itbName = itbStatusService.getItbName();
            var bidderName = itbStatusService.getBidderName()
            vm.docsPath = "cdn/itb/" + vm.itbKeySelected + "_" + itbName + "/" + vm.bidderKeySelected + "_" + bidderName + "/bcf_docs/";

            //Initialization of the Grids
            vm.initGrid();

            //Technical and Commercial docs list obtained from FIREBASE
            vm.otherDocs = vm.getDocs(vm.itbBidderKeySelected);

            //console.log("[BcfDocsController] (1) Get BCF Docs list process START from ItbBidderKey '" + vm.itbBidderKeySelected + "'");
        }



        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: false,
                enableColumnMenus: false,


                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedDoc = row.entity;

                        //console.log("[BcfDocsController] Selected BCF DOC KEY = " + vm.selectedDoc.$id);
                        //console.log("[BcfDocsController] Selected BCF DOC NAME = " + vm.selectedDoc.name);
                        //console.log("[BcfDocsController] Selected BCF DOC URL = " + vm.selectedDoc.url);
                        //console.log("************************************************************************");
                    });
                }
            };

            vm.gridOptions.columnDefs = [
                { name:'Document', field: 'name', width: '82%' },
                { name:'Date', field: 'dateTime', width: '18%' }
            ];
        }



        function getDocs(pItbBidderKeySelected) {

            //Get Main Docs list from Firebase
//            var fbUrl = new Firebase(FIREBASE_URL + "/bcf_docs/");
            var fbUrl = firebaseDataService.bcf_docs;

            var docs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKeySelected));

            docs.$loaded()
                .then(function(data) {

                    vm.otherDocs = data;
                    //console.log("[BcfDocsController] (2) Other Docs list LOADED with " + data.length + " rows.");

                    //Load the grid with de itbs list
                    if (data.length > 0) {
                        vm.loadGrid(data);
                    }
/*
//TEST addError(location,error) method
var prueba = null;
prueba.trim();
*/
                })

                .catch(function(error) {

                    //console.log("[BcfDocsController] ERROR: " + error + "(Log Error: Controller: BcfDocsController / Function: getDocs())");

                    addError("BcfDocsController / getDocs() function",error);
                });
        }



        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("[BcfDocsController] (3) LOAD Grid DONE");
        }



        function refreshGrid() {
            vm.gridApi.core.refresh();
        }




        function viewFile() {

            var key = "";
            var url = "";

            try {
                key = vm.selectedDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            try {
                url = "/" + vm.selectedDoc.url.trim();

                //VERY IMPORTANT => Due to an error when we insert document's URL through "Chartbid Bidder's App" => we must remove "//"" (doble slash) before the name of the file.
                //BEGIN OF THE CODE
                var correctURL = url.replace("//","/");
                url = correctURL;
                //END OF THE CODE

            } catch(e) {
                vm.showAlertDialog("There is not a document to show.");
                return;
            }

            if ( (url == null) || (url == "") || (url == undefined) ) {
                vm.showAlertDialog("There is not a document to show.");
                return;
            }

            ////console.log("url = " + url);
            var type = utilsService.getContentType(url);
            ////console.log("type = " + type);

            var urlPost = 'https://content.dropboxapi.com/2/files/download'; 

            var dataToSend = "";

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream;charset=utf-8',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + url + '"}'
                },
                responseType: 'blob'
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    ////console.log("DESCARGADO CORRECTAMENTE EL ARCHIVO.");

                    var blob = new Blob([responseData], {type: type});
                    blob.name = "downloadedFile";
                    var url = (window.URL || window.webkitURL).createObjectURL(blob); 

                    window.open(url,"_blank");    

                })
                .error(function (responseData, status, header, config) {

                    ////console.log("ERROR AL DESCARGAR Y VISUALIZAR EL ARCHIVO: " + responseData);

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("BcfDocsController / viewFile() function", error);
                }
            );

        }




        function selectFile() {
            //alert("EJECUTAMOS EL METODO 'selectFile()' ");
            angular.element(document.querySelector('#fileInput')).click();
        }



        function addDoc(pItbKey,pItbBidderKey,pName,pUrl,pDateTime) {

            var fbUrl = firebaseDataService.bcf_docs;

            var docs = $firebaseArray(fbUrl);

            var stringJson = '{"itb_key": "' + pItbKey + '", "itb_bidder_key": "' + pItbBidderKey + '", "name": "' + pName + '", "url": "' + pUrl  + '", "dateTime": "' + pDateTime + '", "downloaded": false}';
            var jsonData = JSON.parse(stringJson);

            docs.$add(jsonData)
                .then(function(ref) {
                    //console.log("[BcfDocsController] Added new document to 'bcf_docs' record with ID = " + ref.key);

                    //Refresh grid
                    vm.loadGrid(vm.otherDocs);

                    //Update the fiel "pendingDocsDownloaded" from "itb_bidders" table
                    vm.updateFieldPendingDocsDownloaded(pItbBidderKey,true);
                })

                .catch(function(error) {

                    //console.log("[BcfDocsController] ERROR: " + error + "(Log Error: Controller: BcfDocsController / Function: addDoc())");

                    addError("BcfDocsController / addDoc() function",error);
                }
            );
        }



        function updateFieldPendingDocsDownloaded(pItbBidderKey,pStatus) {

            var fbUrl = firebaseDataService.itb_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {

                    var itbBidderRecord = data[0];

                    itbBidderRecord.pendingDocsDownloaded = pStatus;

                    data.$save(itbBidderRecord);
                })

                .catch(function(error) {
                    //console.log("[BcfDocsController] ERROR in updateFieldPendingDocsDownloaded(): " + error);

                    addError("BcfDocsController / updateFieldPendingDocsDownloaded() function",error);

                    return true;
                });                
        }



        function deleteDoc() {

            var key;

            try {
                key = vm.selectedDoc.$id;

            } catch(e) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            if (key == null) {
                vm.showAlertDialog("Please select a document.");
                return;
            }

            vm.deleteFileFromDropbox(vm.selectedDoc.url);

            var doc = vm.selectedDoc;
            var fileName = vm.selectedDoc.name;
            
            if (doc != null) {
                vm.otherDocs.$remove(doc)
                    .then(function(ref) {
                        //console.log("[BcfDocsController] Deleted record from 'bcf_docs' with KEY = " + ref.key);

                        
                        vm.addTrace("BCF document '" + fileName + "' deleted.");

                        //Delete the file in Dropbox
                        //PENDIENTE DE REVISAR => vm.deleteFileFromDropbox(vm.selectedDoc.url);
                    }
                );
            } else {
                //console.log("[BcfDocsController] We can´t remove the row because there isn´t a selected row.");
            }
        }




        function deleteFileFromDropbox(pPath) {

            try {
                pPath = pPath.trim();

                //VERY IMPORTANT => Due to an error when we insert document's URL through "Chartbid Bidder's App" => we must remove "//"" (doble slash) before the name of the file.
                //BEGIN OF THE CODE
                var correctURL = pPath.replace("//","/");
                pPath = correctURL;
                //END OF THE CODE

            } catch(e) {
                vm.showAlertDialog("There is not a document to delete.");
                return;
            }


            if ( (pPath == null) || (pPath == "") || (pPath == undefined) ) {
                vm.showAlertDialog("There is not a document to delete.");
                return;
            }


            var filePath = "/" + pPath;
            
            vm.disableDropboxButtons = true;

            var urlPost = 'https://api.dropboxapi.com/2/files/delete_v2'; 

            var dataToSend = '{"path": "' + filePath + '"}';

            var config = {
                headers : {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log("File deleted successfully.");
                    vm.disableDropboxButtons = false;
                    showCustomToast("Document deleted successfully.");
                })
                .error(function (responseData, status, header, config) {

                    //console.log("dropbox DELETE ERROR => status: " + status);
                    //console.log('Error in deleting file from Dropbox process');
                    vm.showAlertDialog("There is a problem with the delete file process. Please, contact with the App administrator. (Log error: Controller: BcfDocsController / Function: deleteFileFromDropbox()");

                    vm.disableDropboxButtons = false;

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("BcfDocsController / deleteFileFromDropbox() function", error);
                }
            );
        }




        function uploadFile(pFile) {

            //Upload the file to dropbox
            utilsService.getCETdateTime()
                .success(function(data) {

//AKI
                    if (pFile == null) {
                        return;
                    }

                    // (20/07/2021) Check if file name doesn't contain invalid characters => `´'^\;':"\\|,<>\/?~
                    var format = /[`´'^\;':"\\|,<>\/?~]/;
                    var filename = "";

                    try {
                        filename = pFile.name;
                    } catch (error) {
                        //vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: RequiredTechnicalDocsController / Function: uploadFileToDropbox())");
                        return;
                    }

                    if( filename.match(format) ){
                        vm.showAlertDialog("An invalid character ([ ` ´ ' ^ \ ; ' : \" \\ \| , \< \> \/ \? \~ ]) was found in file name. Please, change the name and try again. Thank you.");
                        return;
                    }
//FIN AKI

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string for the uploading document = " + data);

                    //Upload the file to dropbox with the current CET DateTime
                    vm.uploadFileToDropbox(pFile,vm.docsPath,data);
                })
                .error(function () {
                    //console.log("ERROR => NOT POSSIBLE TO UPLOAD THE DOCUMENT BECAUSE IT HASN'T BEEN POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
            });            

        }




        function uploadFileToDropbox(pFile, pPath, pDateTime) {

            var fileName = "";

            try {
                fileName = pFile.name;
                
            } catch (error) {
                fileName = "";
                //vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: BcfDocsController / Function: uploadFileToDropbox())");
                return;
            }

            var fullPath = "/" + pPath + fileName;

            ////console.log("fullPath = " + fullPath);
            ////console.log("pFile = " + pFile);

            vm.disableDropboxButtons = true;

            var urlPost = 'https://content.dropboxapi.com/2/files/upload'; 

            var dataToSend = pFile;

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + fullPath + '", "mode": "add", "autorename": true, "mute": false}'
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log(responseData);
                    //console.log('file uploaded successfully');

                    vm.disableDropboxButtons = false;
                    showCustomToast("Document uploaded successfully.");                

                    //Save the record in "bcf_docs"
                    var name = fileName;
                    var url = pPath + fileName;
                    var dateTime = pDateTime;
                    ////console.log("url = " + url);
                    vm.addDoc(vm.itbKeySelected,vm.itbBidderKeySelected,name,url,dateTime);

                    //Insert a record in "traceability" table
                    vm.addTrace("BCF document '" + fileName + "' uploaded.");

                })
                .error(function (responseData, status, header, config) {
                    //console.log('Error : ' + status);
                    //console.log('Error in upload file to Dropbox process');
                    vm.showAlertDialog("There is a problem with the upload file process. Please, contact with the App administrator. (Log Error: Controller: BcfDocsController / Function: uploadFileToDropbox())");

                    vm.disableDropboxButtons = false;

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("BcfDocsController / uploadFileToDropbox() function", error);
                }
            );
        }





        function showConfirmDeleteDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to delete this document?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    //YOU HAVE PUSH "YES" BUTTON
                    vm.deleteDoc();
                }, 
                function() {
                    //YOU HAVE PUSH "NO" BUTTON
                });
        }


        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }

        function showCustomToast(pMessage) {

            $mdToast.show(
                $mdToast.simple()
                    .textContent(pMessage)
                    .position('top right')
                    .hideDelay(3000)
            );
        }

/*
        function getTraceabilityFromFirebaseByUser(pUserKey) {

            if (pUserKey != null) {

//                var fbUrl = new Firebase(FIREBASE_URL + "/traceability/");
                var fbUrl = firebaseDataService.traceability;    

                var result = $firebaseArray(fbUrl.orderByChild("user_key").equalTo(pUserKey));

                result.$loaded()
                    .then(function(data) {

                        traceabilityService.setTraceability(data);

                        //console.log("[traceabilityService] getTraceabilityByUser() method => Get all records of 'user_key' from 'traceability' table of Firebase.");

                        return data;
                    })
                    .catch(function(error) {
                        //console.log("[traceabilityService] getTraceabilityByUser() method => ERROR: " + error);
                    });

            } else {

                traceabilityService.setTraceability(null);
                return null;
            }
        }
*/



        function addTrace(pAction) {

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'date': data,
                        'time': '',
                        'dateTime': utilsService.getDateTime(),
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'action': pAction
                    };

                    traceabilityService.addTrace(recordToAdd);                    

                })
                .error(function () {
                    //console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }



        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }


/* PENDIENTE DE REVISAR 
        function deleteFileFromDropbox(pPath) {

            //alert("[FUNCIONA OK EL DELETE FILE DE DROPBOX] => EJECUTAMOS deleteFileFromDropbox()");

            $http({
                method: 'POST',
                url: 'https://api.dropboxapi.com/1/fileops/delete?access_token=' + ACCESS_TOKEN,
                root: 'auto',
                path: 'dropbox/' + pPath,
                locale: 'en'
            })
            .success(function(data, status, headers, config) {
                //console.log(data);
                //console.log('file deleted successfully');
            })
            .error(function(data, status, headers, config) {
                //console.log('Error : ' + data);
                //console.log('Error in deleting file from Dropbox process');
                alert("There is a problem with the delete file process. Please, contact with the App administrator. (Log error: Controller: UploadDocsController / Function: deleteFileFromDropbox()");
            });
        }
FIN PENDIENTE DE REVISAR */


        function redirectToBcfDocs() {
            $location.path("/workflow-bidder/completion-bcf/bcf-docs");
        }

        function redirectToPendingBcf() {
            $location.path("/workflow-bidder/completion-bcf/pending-bcf");
        }

        function redirectToOtherDocs() {
            $location.path("/workflow-bidder/submission-bid/other-docs");
        }

        function redirectToSelectItb() {
            $location.path("/workflow-bidder/select-itb");
        }

        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('CalendarViewController', CalendarViewController);

    /** @ngInject */
    function CalendarViewController($scope, $document, $mdDialog, $mdSidenav, BoardService, DialogService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.eventSources = [];

        vm.calendarUiConfig = {
            calendar: {
                editable        : true,
                eventLimit      : true,
                header          : '',
                dayNames        : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort   : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender      : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat    : {
                    month: 'ddd',
                    week : 'ddd M',
                    day  : 'ddd M'
                },
                eventClick      : function eventDetail(calendarEvent, ev)
                {
                    vm.openCardDialog(ev, calendarEvent.idCard);
                },
                eventAfterRender: function (event)
                {
                    vm.board.cards.getById(event.idCard).due = moment(event.start).toDate();
                },
                selectable      : true,
                selectHelper    : true,
                dayClick        : function (date, ev)
                {
                    eventDialog(date, ev);
                }
            }
        };

        // Methods
        vm.next = next;
        vm.prev = prev;
        vm.goToDate = goToDate;
        vm.openCardDialog = DialogService.openCardDialog;
        vm.toggleSidenav = toggleSidenav;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            vm.cards = getScheduledCards();
            vm.eventSources[0] = vm.cards;
        }

        /**
         * Get scheduled cards and prepare
         * them to show on the calendar
         *
         * @returns {Array}
         */
        function getScheduledCards()
        {
            var cards = [];
            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.due )
                {
                    cards.push({
                        idCard         : card.id,
                        title          : card.name,
                        start          : new Date(card.due),
                        allDay         : true,
                        backgroundColor: getEventBgColor(new Date(card.due))
                    });
                }
            });
            return cards;
        }

        /**
         * Get background color
         *
         * @param cardDue
         * @returns {*}
         */
        function getEventBgColor(cardDue)
        {
            if ( new Date() > cardDue )
            {
                return '#F44336';
            }
            return '#4CAF50';
        }

        /**
         * Watch board changes
         */
        $scope.$watch('vm.board', function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            init();

        }, true);

        /**
         * Go to Date
         *
         * @param date
         */
        function goToDate(date)
        {
            vm.calendarView.calendar.gotoDate(date);
            $mdSidenav('scheduled-tasks-sidenav').close();
        }

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Event Dialog
         */
        function eventDialog(date, ev)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/views/calendar/dialogs/event/event-dialog.html',
                controller         : "ScrumboardCalendarEventDialogController",
                controllerAs       : "vm",
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                locals             : {
                    dueDate: date
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardsViewController', BoardsViewController);

    /** @ngInject */
    function BoardsViewController(BoardList)
    {
        var vm = this;

        // Data
        vm.boardList = BoardList.data;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('BoardViewController', BoardViewController);

    /** @ngInject */
    function BoardViewController($document, $mdDialog, msUtils, BoardList, BoardService, CardFilters, DialogService)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.cardFilters = CardFilters;
        vm.card = {};
        vm.cardOptions = {};
        vm.newListName = '';
        vm.sortableListOptions = {
            axis       : 'x',
            delay      : 75,
            distance   : 7,
            items      : '> .list-wrapper',
            handle     : '.list-header',
            placeholder: 'list-wrapper list-sortable-placeholder',
            tolerance  : 'pointer',
            start      : function (event, ui)
            {
                var width = ui.item[0].children[0].clientWidth;
                var height = ui.item[0].children[0].clientHeight;
                ui.placeholder.css({
                    'min-width': width + 'px',
                    'width'    : width + 'px',
                    'height'   : height + 'px'
                });
            }
        };
        vm.sortableCardOptions = {
            appendTo            : 'body',
            connectWith         : '.list-cards',
            delay               : 75,
            distance            : 7,
            forceHelperSize     : true,
            forcePlaceholderSize: true,
            handle              : msUtils.isMobile() ? '.list-card-sort-handle' : false,
            helper              : function (event, el)
            {
                return el.clone().addClass('list-card-sort-helper');
            },
            placeholder         : 'list-card card-sortable-placeholder',
            tolerance           : 'pointer',
            scroll              : true,
            sort                : function (event, ui)
            {
                var listContentEl = ui.placeholder.closest('.list-content');
                var boardContentEl = ui.placeholder.closest('#board');

                if ( listContentEl )
                {
                    var listContentElHeight = listContentEl[0].clientHeight,
                        listContentElScrollHeight = listContentEl[0].scrollHeight;

                    if ( listContentElHeight !== listContentElScrollHeight )
                    {
                        var itemTop = ui.position.top,
                            itemBottom = itemTop + ui.item.height(),
                            listTop = listContentEl.offset().top,
                            listBottom = listTop + listContentElHeight;

                        if ( itemTop < listTop + 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() - 25);
                        }

                        if ( itemBottom > listBottom - 25 )
                        {
                            listContentEl.scrollTop(listContentEl.scrollTop() + 25);
                        }
                    }
                }

                if ( boardContentEl )
                {
                    var boardContentElWidth = boardContentEl[0].clientWidth;
                    var boardContentElScrollWidth = boardContentEl[0].scrollWidth;

                    if ( boardContentElWidth !== boardContentElScrollWidth )
                    {
                        var itemLeft = ui.position.left,
                            itemRight = itemLeft + ui.item.width(),
                            boardLeft = boardContentEl.offset().left,
                            boardRight = boardLeft + boardContentElWidth;

                        if ( itemLeft < boardLeft + 25 )
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
                        }

                        if ( itemRight > boardRight)
                        {
                            boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
                        }
                    }
                }
            }
        };

        // Methods
        vm.openCardDialog = DialogService.openCardDialog;
        vm.addNewList = addNewList;
        vm.removeList = removeList;
        vm.cardFilter = cardFilter;
        vm.isOverdue = isOverdue;

        //////////


        /**
         * Add new list
         */
        function addNewList()
        {
            if ( vm.newListName === '' )
            {
                return;
            }

            vm.board.lists.push({
                "id"     : msUtils.guidGenerator(),
                "name"   : vm.newListName,
                "idCards": []
            });

            vm.newListName = '';
        }

        /**
         * Remove list
         *
         * @param ev
         * @param list
         */
        function removeList(ev, list)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove List',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove list?',
                ariaLabel          : 'remove list',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });
            $mdDialog.show(confirm).then(function ()
            {
                vm.board.lists.splice(vm.board.lists.indexOf(list), 1);
            }, function ()
            {
                // Canceled
            });

        }

        /**
         * Card filter
         *
         * @param cardId
         * @returns {*}
         */
        function cardFilter(cardId)
        {
            var card = vm.board.cards.getById(cardId);

            try
            {
                if ( angular.lowercase(card.name).indexOf(angular.lowercase(vm.cardFilters.name)) < 0 )
                {
                    throw false;
                }

                angular.forEach(vm.cardFilters.labels, function (label)
                {
                    if ( !msUtils.exists(label, card.idLabels) )
                    {
                        throw false;
                    }
                });

                angular.forEach(vm.cardFilters.members, function (member)
                {
                    if ( !msUtils.exists(member, card.idMembers) )
                    {
                        throw false;
                    }
                });


            } catch ( err )
            {
                return err;
            }

            return true;
        }

        /**
         * Is the card overdue?
         *
         * @param cardDate
         * @returns {boolean}
         */
        function isOverdue(cardDate)
        {
            return new Date() > cardDate;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.todo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.to-do', {
            url      : '/to-do',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/todo/todo.html',
                    controller : 'TodoController as vm'
                }
            },
            resolve  : {
                Tasks: function (apiResolver)
                {
                    return apiResolver.resolve('todo.tasks@get');
                },
                Tags : function (apiResolver)
                {
                    return apiResolver.resolve('todo.tags@get');
                }
            },
            bodyClass: 'todo'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/todo');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.to-do', {
            title : 'To-Do',
            icon  : 'icon-checkbox-marked',
            state : 'app.to-do',
            badge : {
                content: 3,
                color  : '#4CAF50'
            },
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TaskDialogController', TaskDialogController);

    /** @ngInject */
    function TaskDialogController($mdDialog, Task, Tasks, event)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Task';
        vm.task = angular.copy(Task);
        vm.tasks = Tasks;
        vm.newTask = false;

        if ( !vm.task )
        {
            vm.task = {
                'id'                : '',
                'title'             : '',
                'notes'             : '',
                'startDate'         : new Date(),
                'startDateTimeStamp': new Date().getTime(),
                'dueDate'           : '',
                'dueDateTimeStamp'  : '',
                'completed'         : false,
                'starred'           : false,
                'important'         : false,
                'deleted'           : false,
                'tags'              : []
            };
            vm.title = 'New Task';
            vm.newTask = true;
            vm.task.tags = [];
        }

        // Methods
        vm.addNewTask = addNewTask;
        vm.saveTask = saveTask;
        vm.deleteTask = deleteTask;
        vm.newTag = newTag;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewTask()
        {
            vm.tasks.unshift(vm.task);

            closeDialog();
        }

        /**
         * Save task
         */
        function saveTask()
        {
            // Dummy save action
            for ( var i = 0; i < vm.tasks.length; i++ )
            {
                if ( vm.tasks[i].id === vm.task.id )
                {
                    vm.tasks[i] = angular.copy(vm.task);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete task
         */
        function deleteTask()
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Task will be deleted.')
                .ariaLabel('Delete Task')
                .ok('Delete')
                .cancel('Cancel')
                .targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                // Dummy delete action
                for ( var i = 0; i < vm.tasks.length; i++ )
                {
                    if ( vm.tasks[i].id === vm.task.id )
                    {
                        vm.tasks[i].deleted = true;
                        break;
                    }
                }
            }, function ()
            {
                // Cancel Action
            });
        }


        /**
         * New tag
         *
         * @param chip
         * @returns {{label: *, color: string}}
         */
        function newTag(chip)
        {
            var tagColors = ['#388E3C', '#F44336', '#FF9800', '#0091EA', '#9C27B0'];

            return {
                name : chip,
                label: chip,
                color: tagColors[Math.floor(Math.random() * (tagColors.length))]
            };
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('SettingsSidenavController', SettingsSidenavController);

    /** @ngInject */
    function SettingsSidenavController($mdColorPalette, BoardService)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.palettes = $mdColorPalette;
        vm.selectedMenu = 'Settings';

        // Methods

        ////////

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('FiltersSidenavController', FiltersSidenavController);

    /** @ngInject */
    function FiltersSidenavController(msUtils, BoardService, CardFilters)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.cardFilters = CardFilters;
        vm.labels = vm.board.labels;
        vm.members = vm.board.members;
        vm.selectedMenu = 'Settings';

        // Methods
        vm.exists = msUtils.exists;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('msSbAddCardController', msSbAddCardController)
        .directive('msSbAddCard', msSbAddCardDirective);

    /** @ngInject */
    function msSbAddCardController($scope, $timeout, BoardService, msUtils)
    {
        var vm = this;

        vm.newCardName = '';
        vm.listId = $scope.msListId;
        vm.board = BoardService.data;
        vm.cards = vm.board.cards;
        vm.list = vm.board.lists.getById(vm.listId);

        // Methods
        vm.addNewCard = addNewCard;

        /////

        /**
         * Add New Card
         */
        function addNewCard()
        {
            if ( vm.newCardName === '' )
            {
                return;
            }

            var newCardId = msUtils.guidGenerator();

            vm.cards.push({
                "id"               : newCardId,
                "name"             : vm.newCardName,
                "description"      : '',
                "idAttachmentCover": '',
                "idMembers"        : [],
                "idLabels"         : [],
                "attachments"      : [],
                "subscribed"       : false,
                "checklists"       : [],
                "checkItems"       : 0,
                "checkItemsChecked": 0,
                "comments"         : [],
                "activities"       : [],
                "due"              : null
            });

            vm.list.idCards.push(newCardId);

            $timeout(function ()
            {
                $scope.scrollListContentBottom();
            });

            vm.newCardName = '';
        }
    }

    /** @ngInject */
    function msSbAddCardDirective($document, $compile, $timeout)
    {
        return {
            restrict    : 'A',
            controller  : 'msSbAddCardController',
            controllerAs: 'vm',
            scope       : {
                msListId: '='
            },
            link        : function (scope, iElement)
            {
                scope.closeForm = closeForm;
                scope.scrollListContentBottom = scrollListContentBottom;

                var form = '<form ng-submit="vm.addNewCard()" class="ms-sb-add-card-form md-whiteframe-2dp" layout="column">\n\n    <md-input-container flex md-no-float>\n        <input placeholder="Card title" type="text" autocomplete="off"\n               ng-model="vm.newCardName" translate-attr-placeholder="SB.CARD_TITLE">\n    </md-input-container>\n\n    <div layout="row" layout-align="space-between center">\n        <md-button type="submit"\n                   class="add-button md-accent md-raised"\n                   aria-label="add" translate-attr-aria-label="SB.ADD">\n            <span translate="SB.ADD">Add</span>\n        </md-button>\n        <md-button ng-click="closeForm()" class="cancel-button md-icon-button"\n                   aria-label="cancel" translate-attr-aria-label="SB.CANCEL">\n            <md-icon md-font-icon="icon-close"></md-icon>\n        </md-button>\n    </div>\n\n</form>',
                    formEl = '',
                    listContent = iElement.prev();

                /**
                 * Click Event
                 */
                iElement.on('click', function (event)
                {
                    event.preventDefault();
                    openForm();
                });

                /**
                 * Open Form
                 */
                function openForm()
                {
                    iElement.hide();

                    formEl = $compile(form)(scope);

                    listContent.append(formEl);

                    scrollListContentBottom();

                    formEl.find('input').focus();

                    $timeout(function ()
                    {
                        $document.on('click', outSideClick);
                    });
                }

                /**
                 * Close Form
                 */
                function closeForm()
                {
                    formEl.remove();

                    iElement.next().remove();

                    iElement.show();

                    PerfectScrollbar.update(listContent[0]);

                    // Clean
                    $document.off('click', outSideClick);
                    scope.$on('$destroy', function ()
                    {
                        $document.off('click', outSideClick);
                    });
                }

                /**
                 * Scroll List to the Bottom
                 */
                function scrollListContentBottom()
                {
                    listContent[0].scrollTop = listContent[0].scrollHeight;
                }

                /**
                 * Click Outside Event Handler
                 * @param event
                 */
                var outSideClick = function (event)
                {
                    var isChild = formEl.has(event.target).length > 0;
                    var isSelf = formEl[0] == event.target;
                    var isInside = isChild || isSelf;

                    if ( !isInside )
                    {
                        closeForm();
                    }
                }

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardCardDialogController', ScrumboardCardDialogController);

    /** @ngInject */
    function ScrumboardCardDialogController($document, $mdDialog, fuseTheming, fuseGenerator, msUtils, BoardService, cardId)
    {
        var vm = this;

        // Data
        vm.board = BoardService.data;
        vm.card = vm.board.cards.getById(cardId);
        vm.newLabelColor = 'red';
        vm.members = vm.board.members;
        vm.labels = vm.board.labels;

        // Methods
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.rgba = fuseGenerator.rgba;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;
        vm.closeDialog = closeDialog;
        vm.getCardList = getCardList;
        vm.removeCard = removeCard;
        /* Attachment */
        vm.toggleCoverImage = toggleCoverImage;
        vm.removeAttachment = removeAttachment;
        /* Labels */
        vm.labelQuerySearch = labelQuerySearch;
        vm.filterLabel = filterLabel;
        vm.addNewLabel = addNewLabel;
        vm.removeLabel = removeLabel;
        /* Members */
        vm.memberQuerySearch = memberQuerySearch;
        vm.filterMember = filterMember;
        /* Checklist */
        vm.updateCheckedCount = updateCheckedCount;
        vm.addCheckItem = addCheckItem;
        vm.removeChecklist = removeChecklist;
        vm.createCheckList = createCheckList;
        /* Comment */
        vm.addNewComment = addNewComment;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Convert due date to the date object
            if ( vm.card.due )
            {
                vm.card.due = new Date(vm.card.due);
            }
        }

        /**
         * Close Dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Get Card List
         */
        function getCardList()
        {
            var response;
            for ( var i = 0, len = vm.board.lists.length; i < len; i++ )
            {
                if ( vm.board.lists[i].idCards.indexOf(vm.card.id) > -1 )
                {
                    response = vm.board.lists[i];
                    break;
                }
            }
            return response;
        }

        /**
         * Remove card
         *
         * @param ev
         */
        function removeCard(ev)
        {
            var confirm = $mdDialog.confirm({
                title              : 'Remove Card',
                parent             : $document.find('#scrumboard'),
                textContent        : 'Are you sure want to remove card?',
                ariaLabel          : 'remove card',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                ok                 : 'Remove',
                cancel             : 'Cancel'
            });

            $mdDialog.show(confirm).then(function ()
            {
                var cardList = getCardList();

                cardList.idCards.splice(cardList.idCards.indexOf(vm.card.id), 1);

                vm.board.cards.splice(vm.board.cards.indexOf(vm.card), 1);

            }, function ()
            {
                // Canceled
            });
        }

        /**
         * Toggle cover image
         *
         * @param attachmentId
         */
        function toggleCoverImage(attachmentId)
        {
            if ( attachmentId === vm.card.idAttachmentCover )
            {
                vm.card.idAttachmentCover = null;
            }
            else
            {
                vm.card.idAttachmentCover = attachmentId;
            }
        }

        /**
         * Remove attachment
         *
         * @param item
         */
        function removeAttachment(item)
        {
            if ( vm.card.idAttachmentCover === item.id )
            {
                vm.card.idAttachmentCover = '';
            }
            vm.card.attachments.splice(vm.card.attachments.indexOf(item), 1);
        }

        /**
         * Add label chips
         *
         * @param query
         * @returns {filterFn}
         */
        function labelQuerySearch(query)
        {
            return query ? vm.labels.filter(createFilterFor(query)) : [];
        }

        /**
         * Label filter
         *
         * @param label
         * @returns {boolean}
         */
        function filterLabel(label)
        {
            if ( !vm.labelSearchText || vm.labelSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(label.name).indexOf(angular.lowercase(vm.labelSearchText)) >= 0;
        }

        /**
         * Add new label
         */
        function addNewLabel()
        {
            vm.board.labels.push({
                "id"   : msUtils.guidGenerator(),
                "name" : vm.newLabelName,
                "color": vm.newLabelColor
            });

            vm.newLabelName = '';
        }

        /**
         * Remove label
         */
        function removeLabel()
        {
            var arr = vm.board.labels;
            arr.splice(arr.indexOf(arr.getById(vm.editLabelId)), 1);

            angular.forEach(vm.board.cards, function (card)
            {
                if ( card.idLabels && card.idLabels.indexOf(vm.editLabelId) > -1 )
                {
                    card.idLabels.splice(card.idLabels.indexOf(vm.editLabelId), 1);
                }
            });

            vm.newLabelName = '';
        }

        /**
         * Add member chips
         *
         * @param query
         * @returns {Array}
         */
        function memberQuerySearch(query)
        {
            return query ? vm.members.filter(createFilterFor(query)) : [];
        }

        /**
         * Member filter
         *
         * @param member
         * @returns {boolean}
         */
        function filterMember(member)
        {
            if ( !vm.memberSearchText || vm.memberSearchText === '' )
            {
                return true;
            }

            return angular.lowercase(member.name).indexOf(angular.lowercase(vm.memberSearchText)) >= 0;
        }

        /**
         * Update check list stats
         * @param list
         */
        function updateCheckedCount(list)
        {
            var checkItems = list.checkItems;
            var checkedItems = 0;
            var allCheckedItems = 0;
            var allCheckItems = 0;

            angular.forEach(checkItems, function (checkItem)
            {
                if ( checkItem.checked )
                {
                    checkedItems++;
                }
            });

            list.checkItemsChecked = checkedItems;

            angular.forEach(vm.card.checklists, function (item)
            {
                allCheckItems += item.checkItems.length;
                allCheckedItems += item.checkItemsChecked;
            });

            vm.card.checkItems = allCheckItems;
            vm.card.checkItemsChecked = allCheckedItems;
        }

        /**
         * Add checklist item
         *
         * @param text
         * @param checkList
         */
        function addCheckItem(text, checkList)
        {
            if ( !text || text === '' )
            {
                return;
            }

            var newCheckItem = {
                'name'   : text,
                'checked': false
            };

            checkList.checkItems.push(newCheckItem);

            updateCheckedCount(checkList);
        }

        /**
         * Remove checklist
         *
         * @param item
         */
        function removeChecklist(item)
        {
            vm.card.checklists.splice(vm.card.checklists.indexOf(item), 1);

            angular.forEach(vm.card.checklists, function (list)
            {
                updateCheckedCount(list);
            });
        }

        /**
         * Create checklist
         */
        function createCheckList()
        {
            vm.card.checklists.push({
                "id"               : msUtils.guidGenerator(),
                "name"             : vm.newCheckListTitle,
                "checkItemsChecked": 0,
                "checkItems"       : []
            });

            vm.newCheckListTitle = '';
        }

        /**
         * Add new comment
         *
         * @param newCommentText
         */
        function addNewComment(newCommentText)
        {
            var newComment = {
                "idMember": "36027j1930450d8bf7b10158",
                "message" : newCommentText,
                "time"    : "now"
            };

            vm.card.comments.unshift(newComment);
        }

        /**
         * Filter for chips
         *
         * @param query
         * @returns {filterFn}
         */
        function createFilterFor(query)
        {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item)
            {
                return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
            };
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.mail', {
            url      : '/mail',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/mail/mail.html',
                    controller : 'MailController as vm'
                }
            },
/*            
            resolve  : {
                Inbox: function (apiResolver)
                {
                    return apiResolver.resolve('mail.inbox@get');
                }
            },
*/
            bodyClass: 'mail',
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/mail');

        // Navigation
        msNavigationServiceProvider.saveItem('mail', {
            title : 'Communications',
            icon  : 'icon-email',
            state : 'app.mail',
/*            
            badge : {
                content: 25,
                color  : '#F44336'
            },
*/            
            weight: 1,
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('PrintMailDialogController', PrintMailDialogController);

    /** @ngInject */
    function PrintMailDialogController($mdDialog, $document, selectedMail)
    {

        // DECLARATIONS ***********************
        var vm = this;
        vm.selectedMail = selectedMail;


        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.printMail = printMail;
        vm.closeDialog = closeDialog;



        //START CONTROLLER *******************************
        vm.executeController();



        // METHODS ****************
        function executeController() 
        {
            vm.selectedMail = selectedMail;

//            vm.printMail('divMailToPrint');
        }



        function printMail(pDivToPrint) {

            var printContents = document.getElementById(pDivToPrint).innerHTML;
            var popupWin = window.open('', '_blank', 'width=600,height=450');
            popupWin.document.open();
            popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + printContents + '</body></html>');
            popupWin.document.close();
        }






        function closeDialog() 
        {
            $mdDialog.hide();
        }




    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('ComposeMailDialogController', ComposeMailDialogController);

    /** @ngInject */
    function ComposeMailDialogController($mdDialog, $document, selectedMail, type, isReply, mailerService, itbStatusService, loginService, FIREBASE_URL, $firebaseArray, $timeout, $scope)
    {

        // DECLARATIONS ***********************
        var vm = this;
        vm.login;
        vm.type = "";
        vm.isReply = false;
        vm.title = "";
        vm.form;
        vm.addressBookVisible = false;
        vm.itbKeySelected;
        vm.administrators;
        //vm.biddersOfItb;
        //vm.gridOptions;
        //vm.gridApi;
        //vm.selectedBidder;
        //vm.selectedBiddersArray;
        vm.addressBookButtonVisible = false;

        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.sendMail = sendMail;
        vm.closeDialog = closeDialog;
		vm.showAlertDialog = showAlertDialog;
//        vm.getAdministrators = getAdministrators;
//        vm.getAdministratorsList = getAdministratorsList;

        //vm.initGrid = initGrid;
        //vm.loadGrid = loadGrid;
        //vm.showAddressBook = showAddressBook;
        //vm.selectBidders = selectBidders;
        //vm.getBiddersOfItb = getBiddersOfItb;


        //START CONTROLLER *******************************
        vm.executeController();



        // METHODS ****************
        function executeController() 
        {

            vm.login = loginService.getLogin();
            vm.type = type;
            vm.isReply = isReply;

            if (vm.type == "bcf") {
                vm.title = "MAIL.SEND_CLARIFICATION";
            } else if (vm.type == "bulletin") {
                vm.title = "MAIL.SEND_BULLETIN";
            } else {
                vm.title = "MAIL.NEW_COMMUNICATION";
            }

/*
            if ( (vm.type != 'bulletin') && (!vm.isReply)) {
                vm.addressBookButtonVisible = true;
            }
*/
            vm.addressBookButtonVisible = false;

            var genericSubject = "[CHARTBID Communication] " + itbStatusService.getCharterer() + " Ref. " + itbStatusService.getItbReference() + " - ";


            //We assign default values
            vm.form = {
                from: vm.login.email,
                fromName: vm.login.name,
                toName: "Chart Shipping",
                subject: genericSubject
            };


            //Administrator obtained from FIREBASE
//            vm.administrators = vm.getAdministrators();

/*
            var CSSLfooter = '<p><br/><br/>Chart Shipping S.L.<br/>As brokers only<br/>-------------------------------------------<br/>Rambla Catalunya, 53-55, 6A<br/>08007  Barcelona - SPAIN<br/>+34 93 363 2854<br/><h5>This email and any files transmitted with it are confidential and intended solely for the use of the individual or entity to whom they are addressed. This message contains confidential information and is intended only for the individual named. If you are not the named addressee you should not disseminate, distribute or copy this e-mail. Please notify the sender immediately by e-mail if you have received this e-mail by mistake and delete this e-mail from your system. If you are not the intended recipient you are notified that disclosing, copying, distributing or taking any action in reliance on the contents of this information is strictly prohibited.</h5><br/></p>';
            vm.form.message = CSSLfooter;
*/
            vm.form.message = '';          


            // If replying
            if ( angular.isDefined(selectedMail) )
            {
                vm.form.to = selectedMail.fromEmail;
                vm.form.subject = 'RE: ' + selectedMail.subject;
                
                vm.form.message += '<br /><br /><blockquote>On [' + selectedMail.date + '  -  ' + selectedMail.time + ']  ' + selectedMail.fromName + " wrote this communication: <br /><br />" + selectedMail.message + '</blockquote>';

                vm.form.toKey = selectedMail.sender_key;
                vm.form.toName = selectedMail.fromName;
            }

        }


        function showAddressBook() 
        {
            vm.addressBookVisible = true;
        }


/*
        function getAdministrators() {

            //console.log("[ComposeMailDialogController]  Get administrators list ");

            //Get bidders list from Firebase        
            var fbUrl = new Firebase(FIREBASE_URL + "/administrators/");
            //vm.administrators = $firebaseArray(fbUrl.orderByChild("email"));
            vm.administrators = $firebaseArray(fbUrl);

            vm.administrators.$loaded()
                .then(function(data) {

                    //Assign bidders list to scope
                    vm.administrators = data;

                    //console.log("[ComposeMailDialogController] Administrators list LOADED with " + data.length + " elements.");

                    //Load the grid with de bidders list
                    //vm.loadGrid(vm.biddersOfItb)

                    vm.getAdministratorsList();
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[ComposeMailDialogController] ERROR in function getAdministrators(): " + error);
                });
        }



        function getAdministratorsList() 
        {

            vm.form.to = "";
            vm.form.toKey = "";
            vm.form.toName = "";

            var arrayLength = vm.administrators.length;

            if (arrayLength > 0) {
                vm.form.to = vm.administrators[0].email;
                vm.form.toKey = vm.administrators[0].$id;
                vm.form.toName = vm.administrators[0].name;
            
                for (var i=1;i<arrayLength;i++) {
                    vm.form.to += "," + vm.administrators[i].email;
                    vm.form.toKey += "#" + vm.administrators[i].$id;
                    vm.form.toName += "#" + vm.administrators[i].name;
                }
            }
        }
*/


        function closeDialog() 
        {
            $mdDialog.hide();
        }



        function sendMail(pType) 
        {
            //For all the messages from Bidder => type = communication
            pType = "communication";

            var itbKey = itbStatusService.getItbKey();
            var senderKey = vm.login.userKey;
            var itbSenderKey = itbKey + "&" + senderKey;
            
            //var pendingBcf = true;
            var pendingBcf = false;


//            var destinationEmails = vm.form.to;
            var destinationKeys = vm.form.toKey;
            var destinationNames = vm.form.toName;


            if ( (destinationNames == null) ||(destinationNames == "") ) {

                alert("There is not any address to send.");
				//vm.showAlertDialog("There is not any address to send.");
                return;
            }


            if (vm.form.message.trim().length == 0) {

				alert("There is not content for the message. Insert a content, please.");
				//vm.showAlertDialog("There is not content for the message. Insert a content, please.");
                return;
            }



/*
            //If communication type is 'bcf' and is a reply => must assign pendingBcf=false (because the BCF has been replied by the Bidder)
            if ( (pType == 'bcf') && (vm.isReply)) {
                pendingBcf = false;
            } else {
                pendingBcf = true;
            }
*/
            //MUY IMPORTANTE => Por ahora hemos deshabilitado el código anterior para considerar que todas las BCFs ya sean iniciales o respuestas a otras tendrán el campo pendingBcf=true SIEMPRE
            if (pType == 'bcf') {
                pendingBcf = true;
            }


            //'destinationEmails' must contain a "#" separated list of emails before sending emails (this format is necessary in the webAPI for sending emails)
            //destinationEmails = destinationEmails.replace(/,/g,"#");

            var receiverProfile = loginService.getUserProfile();
            var itbReceiverProfile = itbKey + "&" + receiverProfile;

            var dataToSend = {
                'user': 'developer@chartbid.com',
                'password': 'a-Syns6wSuqV4EajR6t7ig',
              
                //'arrayDestinationEmail': destinationEmails,
                'arrayDestinationEmail': '',

                //'arrayDestinationKey': destinationKeys,
                'arrayDestinationKey': '',

                'arrayDestinationName': destinationNames, 

                //'emailSender': vm.form.from,              //IMPORTANT => Accounts different from "chartship@chartbid.com" always will be rejected by SendGrid because aren't allowed sender accounts
                'emailSender': 'chartship@chartbid.com',    //IMPORTANT => The Sender always must be "chartship@chartbid.com" because other accounts will be rejected by SendGrid (other accounts aren't allowerd as Sender by SendGrid)

                'nameSender': vm.login.name,
                'subject': vm.form.subject,
                'body': vm.form.message,
                'itb_key': itbKey,
                'sender_key': senderKey,
                'itb_sender_key': itbSenderKey,
                'type': pType,
                'pendingBcf': pendingBcf,

                'senderProfile': '',
                'itb_senderProfile': '',
                'receiverProfile': receiverProfile,
                'itb_receiverProfile': itbReceiverProfile

//              'receiver_key': 'RECEIVER_KEY',
//              'itb_receiver_key': 'itbKey&RECEIVER_KEY'
            };

            //ENVIAMOS EL MAIL
            mailerService.processMail(dataToSend);

            //CERRAMOS LA VENTANA DE DIÁLOGO
            vm.closeDialog();
        }

		
		//**********************************************************
        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }



    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.calendar', [
            'ui.calendar'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/calendar');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.calendar', {
            title : 'Calendar',
            icon  : 'icon-calendar-today',
            state : 'app.calendar',
            weight: 2
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }

        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            vm.dialogTitle = (vm.dialogData.type === 'add' ? 'Add Event' : 'Edit Event');

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake the Full Calendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        function saveEvent()
        {
            var response = {
                type         : vm.dialogData.type,
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_blank', {
            url  : '/ui/page-layouts/blank',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/blank/blank.html',
                    controller : 'BlankController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank')
        .controller('BlankController', BlankController);

    /** @ngInject */
    function BlankController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-404', {
            title : '404',
            state : 'app.pages_errors_error-404',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/pages/auth/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/reset-password');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.reset-password', {
            title : 'Reset Password',
            state : 'app.pages_auth_reset-password',
            weight: 6
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register-v2', {
            url      : '/pages/auth/register-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register-v2': {
                    templateUrl: 'app/main/pages/auth/register-v2/register-v2.html',
                    controller : 'RegisterV2Controller as vm'
                }
            },
            bodyClass: 'register-v2'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register-v2');

/*
[@elusiona] INICIO
        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register-v2', {
            title : 'Register v2',
            state : 'app.pages_auth_register-v2',
            weight: 4
        });
[@elusiona] FIN
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register-v2')
        .controller('RegisterV2Controller', RegisterV2Controller);

    /** @ngInject */
    function RegisterV2Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginV2Controller', LoginV2Controller);

    /** @ngInject */
    function LoginV2Controller($scope)
    {
        var vm = this;

        // Data

        // Methods
        vm.submit = function() {

            alert("VALOR DE CAMPO EMAIL = " + vm.form.email);
            alert("VALOR DE CAMPO PASSWORD = " + vm.form.password);

            //Redireccionamos a la página de Dashboard
            $window.location = "/dashboard-project";

            alert("FIN FUNCTION submit()");
        }


        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/pages/auth/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register', {
            title : 'Register',
            state : 'app.pages_auth_register',
            weight: 3
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController($location)
    {
        // Data
        var vm = this;

        // Methods
        vm.registerUser = registerUser;

        function registerUser(company,email) {
            alert("It has been registered company '" + company + "' with e-mail '" + email + "'");
            $location.path("/workflow-admin/select-itb");
        }


        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(firebaseDataService,$location,$timeout,loginService,traceabilityService,utilsService,$firebaseArray,$mdDialog,$document)
    {
        // DATA DECLARATION
        var vm = this;
        vm.login = loginService.getLogin();
        vm.showAlert = false;
        vm.showSelectBidder = false;
        vm.bidders;
//        vm.biddersContactNames = new Array();
        vm.showLoginButton = false;


        //********************************************************
        // METHODS DECLARATION
		vm.firebaseAuthenticate = firebaseAuthenticate;
        vm.authenticate = authenticate;
        vm.checkLoginContact = checkLoginContact;
        vm.updateLoggedIn = updateLoggedIn;
        vm.getTraceabilityFromFirebaseByUser = getTraceabilityFromFirebaseByUser;
        vm.addTrace = addTrace;

        vm.loadBidderSelect = loadBidderSelect;
        vm.getBidderByEmail = getBidderByEmail;

        vm.selectBiddersDialog = selectBiddersDialog;

		
		//************************************************************
        function firebaseAuthenticate(ev) {

            vm.showAlert = false;


/* BEGIN - ELUSIONA 28/06/2021 */
//BEGIN - FIREBASE USER AUTHENTICATION
            firebase.auth().signInWithEmailAndPassword(vm.form.email,vm.form.password)

                .then(function(firebaseUser) {

                    //console.log("LOGIN BY FIREBASE RULES CORRECT");
					
					//console.log("VERSIÓN DE FIREBASE => " + firebase.SDK_VERSION);

                    $timeout(function() {
                        vm.authenticate(ev);
                    });
                    
                })

                .catch(function(error) {
                    // Handle Errors here.
                    var errorCode = error.code;
                    var errorMessage = error.message; 

                    //console.log("REJECTED LOGIN BY FIREBASE RULES => ErrorCode = " + errorCode + "  / errorMessage = " + errorMessage);


                    $timeout(function() {

                        vm.messageAlert = "Access denied for this user";
                        vm.showAlert = true;

                        $location.path("/pages/auth/login");
                    });

            });
//END - FIREBASE USER AUTHENTICATION
/* END - ELUSIONA 28/06/2021 */

        }
		
		

        //********************************************************
        // METHODS
        function authenticate(ev) {

            vm.bidders = null;

            var authenticationOK = false;
            vm.showAlert = false;

            var contactNumber = 0;
            vm.checkLoginContact(contactNumber,ev);
        }



        function loadBidderSelect(pEmail,ev) {

            vm.bidders = null;
            vm.getBidderByEmail(pEmail,0,ev)
        }



        function getBidderByEmail(pEmail,pContactNumber,ev) {

            //Get itbs list from Firebase        
//            var fbUrl = new Firebase(FIREBASE_URL + "/bidders/");
            var fbUrl = firebaseDataService.bidders;


            if (pContactNumber == 0) {
                var result = $firebaseArray(fbUrl.orderByChild("email").equalTo(pEmail));

            } else if (pContactNumber == 1) {
                var result = $firebaseArray(fbUrl.orderByChild("email1").equalTo(pEmail));

            } else if (pContactNumber == 2) {
                var result = $firebaseArray(fbUrl.orderByChild("email2").equalTo(pEmail));

            } else if (pContactNumber == 3) {
                var result = $firebaseArray(fbUrl.orderByChild("email3").equalTo(pEmail));

            } else if (pContactNumber == 4) {
                var result = $firebaseArray(fbUrl.orderByChild("email4").equalTo(pEmail));
            }            

            result.$loaded()
                .then(function(data) {

                    if (data.length > 0) {

                        for (var i=0;i<data.length;i++) {

                            try {
                                vm.bidders.push(data[i]);
                                //console.log("ADD Bidder with bidder_key = " + data[i].$id);
                            } catch(error) {
                                vm.bidders = data;
                            }
                        }
                    } 

                    pContactNumber++;
                    if (pContactNumber < 5) {
                        vm.getBidderByEmail(pEmail,pContactNumber)
                    } else {

                        if (vm.bidders.length == 1) {
                            //Redirect to "SELECT ITB" page
                            $location.path("/workflow-bidder/select-itb");
                        } else {
                            
                            //We show pop-up with the input select with the bidders related to email
                            vm.selectBiddersDialog(ev,pEmail);
                        }
                    }

                })
                .catch(function(error) {
                    //console.log("[LoginController] ERROR: " + error + " (Log Error: Controller: LoginController / Function: getBidderByEmail())");
                });
        }


        //Open compose dialog
        function selectBiddersDialog(ev,pEmail)
        {
            $mdDialog.show({
                controller         : 'SelectBiddersDialogController',
                controllerAs       : 'vm',
                locals             : {
                    bidders: vm.bidders,
                    email: pEmail
                },
                templateUrl        : 'app/main/pages/auth/login/dialogs/select-bidders/select-bidders-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev
                //clickOutsideToClose: true
            });
        }


        function checkLoginContact(pContactNumber,ev) {

            var authenticationOK = false;


            //We check if the user is a BIDDER
            var result = loginService.getBidderLogin(vm.form.email,vm.form.password,pContactNumber);

            result.$loaded()
                .then(function(data) {

                    var dataLength = data.length;

                    //console.log("EJECUCIÓN OK DE CONSULTA TABLA bidders con data.length = " + dataLength);

                    if (dataLength > 0) {

                        if (pContactNumber == 0) {

                            if (data[0].password == vm.form.password) {

                                vm.login.name = data[0].company;
                                vm.login.email = data[0].email;
                                vm.login.userKey = data[0].$id;
                                vm.login.userProfile = "bidder";
                                vm.login.ok = true;

                                authenticationOK = true;

                            } else {

                                authenticationOK = false;
                                pContactNumber++;

                                if (pContactNumber < 5) {
                                    vm.checkLoginContact(pContactNumber)
                                }
                            }
                        }

                        else if (pContactNumber == 1) {

                            if (data[0].password1 == vm.form.password) {

                                vm.login.name = data[0].company;
                                vm.login.email = data[0].email1;
                                vm.login.userKey = data[0].$id;
                                vm.login.userProfile = "bidder";
                                vm.login.ok = true;

                                authenticationOK = true;

                            } else {

                                authenticationOK = false;
                                pContactNumber++;

                                if (pContactNumber < 5) {
                                    vm.checkLoginContact(pContactNumber)
                                }
                            }
                        }

                        else if (pContactNumber == 2) {

                            if (data[0].password2 == vm.form.password) {

                                vm.login.name = data[0].company;
                                vm.login.email = data[0].email2;
                                vm.login.userKey = data[0].$id;
                                vm.login.userProfile = "bidder";
                                vm.login.ok = true;

                                authenticationOK = true;

                            } else {

                                authenticationOK = false;
                                pContactNumber++;

                                if (pContactNumber < 5) {
                                    vm.checkLoginContact(pContactNumber)
                                }
                            }
                        }

                        else if (pContactNumber == 3) {

                            if (data[0].password3 == vm.form.password) {

                                vm.login.name = data[0].company;
                                vm.login.email = data[0].email3;
                                vm.login.userKey = data[0].$id;
                                vm.login.userProfile = "bidder";
                                vm.login.ok = true;

                                authenticationOK = true;

                            } else {

                                authenticationOK = false;
                                pContactNumber++;

                                if (pContactNumber < 5) {
                                    vm.checkLoginContact(pContactNumber)
                                }
                            }
                        }

                        else if (pContactNumber == 4) {

                            if (data[0].password4 == vm.form.password) {

                                vm.login.name = data[0].company;
                                vm.login.email = data[0].email4;
                                vm.login.userKey = data[0].$id;
                                vm.login.userProfile = "bidder";
                                vm.login.ok = true;

                                authenticationOK = true;

                            } else {

                                authenticationOK = false;
                                pContactNumber++;

                                if (pContactNumber < 5) {
                                    vm.checkLoginContact(pContactNumber)
                                }
                            }
                        }


                    } else {

                        authenticationOK = false;
                        pContactNumber++;

                        if (pContactNumber < 5) {
                            vm.checkLoginContact(pContactNumber)
                        }
                    }


                    if (authenticationOK) {

                        //console.log("PASSWORD CORRECT");

                        //Assign the values obtained from Firebase to the loginService
                        loginService.setName(vm.login.name);
                        loginService.setEmail(vm.login.email);
                        loginService.setUserKey(vm.login.userKey);
                        loginService.setUserProfile(vm.login.userProfile);

                        //console.log("[loginService] => getBidderLogin() => OK");
                        //console.log("[loginService] => getBidderLogin() method => vm.login.name = " + vm.login.name);
                        //console.log("[loginService] => getBidderLogin() method => vm.login.email = " + vm.login.email);
                        //console.log("[loginService] => getBidderLogin() method => vm.login.userKey = " + vm.login.userKey);
                        //console.log("[loginService] => getBidderLogin() method => vm.login.userProfile = " + vm.login.userProfile);
                        //console.log("[loginService] => getBidderLogin() method => vm.login.ok = " + vm.login.ok);

                        vm.showAlert = false;

                        vm.updateLoggedIn(true,vm.login.userKey);

                        //Get all the records of user_key from "traceability" table in Firebase
                        //vm.traceability = vm.getTraceabilityFromFirebaseByUser(vm.login.userKey);

                        //Insert a record in "traceability" table
                        //vm.addTrace("Log In App Bidder");

                        //We check if the emails has others Bidders accounts
                        vm.loadBidderSelect(vm.login.email,ev);



                        //Redirect to "SELECT ITB" page
//                        $location.path("/workflow-bidder/select-itb");

                    } else {

                        vm.login.name = "";
                        vm.login.email = "";
                        vm.login.userKey = "";
                        vm.login.userProfile = "";
                        vm.login.ok = false;

                        vm.showAlert = true;

                        //console.log("[loginService] => getBidderLogin() => INCORRECT A");
                    }

                })

                .catch(function(error) {

                    vm.login.name = "";
                    vm.login.email = "";
                    vm.login.userKey = "";
                    vm.login.userProfile = "";
                    vm.login.ok = false;

                    vm.showAlert = true;

                    //console.log("[loginService] => getBidderLogin() => INCORRECT B");
                    //console.log("ERROR: " + error);
                }
            );
        }



        function updateLoggedIn(pValue,pBidderKey) {

//            var fbUrl = new Firebase(FIREBASE_URL + "/itb_bidders/");
            var fbUrl = firebaseDataService.itb_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("bidder_key").equalTo(pBidderKey));

            result.$loaded()
                .then(function(data) {
        
                    var numRecords = data.length;
                    //console.log("recordsLength = " + numRecords);

                    for (var i=0;i<numRecords;i++) {

                        var recordToUpdate = data[i];
                        recordToUpdate.loggedIn = pValue;

                        //console.log("recordToUpdate.loggedIn = " + recordToUpdate.loggedIn);

                        //Save the record
                        data.$save(recordToUpdate)
                            .then(function(ref) {
                                //console.log("[loginService] => updateLoggedIn() => record saved with Key = " + ref.key);
                            })
                        
                            .catch(function(error) {
                                //console.log("[loginService] => updateLoggedIn() ERROR in update process => " + error);
                            });
                    }
                    
                })

                .catch(function(error) {
                    //console.log("[loginService] => updateLoggedIn() ERROR in loaded process => " + error);
                });
        }



        function getTraceabilityFromFirebaseByUser(pUserKey) {

            if (pUserKey != null) {

//                var fbUrl = new Firebase(FIREBASE_URL + "/traceability/");
                var fbUrl = firebaseDataService.traceability;

                var result = $firebaseArray(fbUrl.orderByChild("user_key").equalTo(pUserKey));

                result.$loaded()
                    .then(function(data) {

                        traceabilityService.setTraceability(data);

                        //console.log("[traceabilityService] getTraceabilityByUser() method => Get all records of 'user_key' from 'traceability' table of Firebase.");

                        return data;
                    })
                    .catch(function(error) {
                        //console.log("[traceabilityService] getTraceabilityByUser() method => ERROR: " + error);
                    });

            } else {

                traceabilityService.setTraceability(null);
                return null;
            }
        }


        function addTrace(pAction) {

            var recordToAdd = {
                'user': loginService.getName(),
                'user_key': loginService.getUserKey(),
                'company': loginService.getName(), 
                'email': loginService.getEmail(),
                'userType': loginService.getUserProfile(),
                'date': utilsService.getDate(),
                'time': utilsService.getTime(),
                'dateTime': utilsService.getDateTime(),
                'itbName': '',
                'itb_key': '',
                'action': pAction
            };

            traceabilityService.addTrace(recordToAdd);
        }



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.bidder-profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_bidder_profile', {
            url      : '/pages/auth/bidder-profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/auth/bidder-profile/bidder-profile.html',
                    controller : 'BidderProfileController as vm'
                }
            },


            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'bidder-profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/bidder-profile');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('management.bidder', {
            title : 'BIDDER',
            state : 'app.management_bidder',
            icon  : 'icon-numeric-3-box',
            weight: 3
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.bidder-profile')
        .controller('BidderProfileController', BidderProfileController);

    /** @ngInject */
    function BidderProfileController(firebaseDataService,$scope,$timeout,$firebaseArray,$firebaseObject,traceabilityService,utilsService,$mdDialog,loginService,$location,mailerService)
    {
        // DECLARATIONS ***********************
        var vm = this;

        vm.bidderKey = "";
        vm.bidders;
        vm.gridOptions;
        vm.gridApi;
        vm.selectedBidder = null;
        vm.selectedRow = null;
        vm.selectedRowId = null;
        vm.selectedRowName = null;
        vm.currentView = 'list';
        vm.operation = "";
        vm.showPage = false;
        vm.passwordConfirm = "";
        vm.passwordConfirm1 = "";
        vm.passwordConfirm2 = "";
        vm.passwordConfirm3 = "";
        vm.passwordConfirm4 = "";

		var previousEmail = "";
        var previousEmail1 = "";
        var previousEmail2 = "";
        var previousEmail3 = "";
        var previousEmail4 = "";

        var previousPassword = "";
        var previousPassword1 = "";
        var previousPassword2 = "";
        var previousPassword3 = "";
        var previousPassword4 = "";		
    
        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.getBidder = getBidder;
//        vm.initGrid = initGrid;
//        vm.loadGrid = loadGrid;

        vm.addBidder = addBidder;
        vm.saveBidder = saveBidder;
        vm.deleteBidder = deleteBidder;
        vm.cancel = cancel;

        vm.updateBidderCompanyInAllTables = updateBidderCompanyInAllTables;
        vm.updateBidderCompanyInTable = updateBidderCompanyInTable;
        vm.getBidderEmail = getBidderEmail;

        vm.getTraceabilityFromFirebaseByUser = getTraceabilityFromFirebaseByUser;
        vm.addTrace = addTrace;

        vm.updatePasswordInFirebase = updatePasswordInFirebase;
        vm.addNewFirebaseUser = addNewFirebaseUser;
		
        vm.showAlertDialog = showAlertDialog;

        vm.toggleView = toggleView;

        //START CONTROLLER *******************************
        vm.executeController();

/*
        $scope.$watch('vm.bidders.length', function(current, original) {

            //console.log('(WATCH) vm.bidders.length was %s', original);

            //console.log('(WATCH) vm.bidders.length is now %s', current);

        });
*/


        // METHODS ****************
        function executeController() {

/*
            if (loginService.getUserProfile() == "bidder") {
                vm.showPage = false;
                vm.showAlertDialog();
                return;
            }
*/

            vm.bidderKey = loginService.getUserKey();
            ////console.log("BidderKey = " + vm.bidderKey)

//            vm.showPage = true;

            //Initialization of the Grid
//            vm.initGrid();

            //bidders list obtained from FIREBASE
            vm.getBidder(vm.bidderKey);


            //Get all the records of user_key from "traceability" table in Firebase
            vm.traceability = vm.getTraceabilityFromFirebaseByUser(loginService.getUserKey());
        }


/*
        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableColumnMenus: false,

                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedBidder = row.entity;
                        //console.log("Selected Row KEY = " + vm.selectedBidder.$id);
                        //console.log("Selected Row NAME = " + vm.selectedBidder.company);

                        //Insert a record in "traceability" table
                        vm.addTrace("Bidder '" + vm.selectedBidder.bidder + "' selected.");

                    });
                    
                }
            };

            vm.gridOptions.columnDefs = [
                { name:'Bidder', field: 'bidder', width: '200'},
                { name:'Contact 1', field: 'maincontact', width: '200'},
                { name:'E-mail 1', field: 'email', width: '200'},
                { name:'Contact 2', field: 'name1', width: '200'},
                { name:'E-mail 2', field: 'email1', width: '200'},
                { name:'Contact 3', field: 'name2', width: '200'},
                { name:'E-mail 3', field: 'email2', width: '200'},
                { name:'Contact 4', field: 'name3', width: '200'},
                { name:'E-mail 4', field: 'email3', width: '200'},
                { name:'Contact 5', field: 'name4', width: '200'},
                { name:'E-mail 5', field: 'email4', width: '200'}
            ];
        }
*/


/*
IMPLEMENTACIÓN DE LA FUNCIÓN $timeout() para obtener la FILA SELECCIONADA => PROBAR PARA VER SI FUNCIONA

      $timeout(function() {
        if($scope.gridApi.selection.selectRow){
          $scope.gridApi.selection.selectRow($scope.gridOptions.data[0]);
        }
      });
*/


        function getBidder(pBidderKey) {

            //console.log("(1) Get bidders list START");            

            //Get bidders list from Firebase        
//            var fbUrl = new Firebase(FIREBASE_URL + "/bidders/" + pBidderKey + "/");
            var fbUrl = firebaseDataService.bidders.child(pBidderKey);

            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    vm.bidders = data;
                    vm.selectedBidder = data;

                    //We assign the password to the 'passwordConfirm' value
                    if ( (vm.selectedBidder.password != null) && (vm.selectedBidder.password.trim().length > 0) ) {
                        vm.passwordConfirm = vm.selectedBidder.password;
                    }

                    //We assign the password1 to the 'passwordConfirm1' value
                    if ( (vm.selectedBidder.password1 != null) && (vm.selectedBidder.password1.trim().length > 0) ) {
                        vm.passwordConfirm1 = vm.selectedBidder.password1;
                    }

                    //We assign the password2 to the 'passwordConfirm2' value
                    if ( (vm.selectedBidder.password2 != null) && (vm.selectedBidder.password2.trim().length > 0) ) {
                        vm.passwordConfirm2 = vm.selectedBidder.password2;
                    }

                    //We assign the password3 to the 'passwordConfirm3' value
                    if ( (vm.selectedBidder.password3 != null) && (vm.selectedBidder.password3.trim().length > 0) ) {
                        vm.passwordConfirm3 = vm.selectedBidder.password3;
                    }

                    //We assign the password1 to the 'passwordConfirm4' value
                    if ( (vm.selectedBidder.password4 != null) && (vm.selectedBidder.password4.trim().length > 0) ) {
                        vm.passwordConfirm4 = vm.selectedBidder.password4;
                    }

// BEGIN - ELUSIONA 28/06/2021 

                    //Get emails from "bidders" table
                    previousEmail = vm.selectedBidder.email;

                    try {
                        previousEmail1 = vm.selectedBidder.email1;
                    } catch(e) {
                        previousEmail1 = "";
                    }                    

                    try {
                        previousEmail2 = vm.selectedBidder.email2;
                    } catch(e) {
                        previousEmail2 = "";
                    }                    

                    try {
                        previousEmail3 = vm.selectedBidder.email3;
                    } catch(e) {
                        previousEmail3 = "";
                    }                    

                    try {
                        previousEmail4 = vm.selectedBidder.email4;
                    } catch(e) {
                        previousEmail4 = "";
                    }                    


                    //Get passwords from "bidder" table
                    previousPassword = vm.selectedBidder.password;

                    try {
                        previousPassword1 = vm.selectedBidder.password1;
                    } catch(e) {
                        previousPassword1 = "";
                    }                    

                    try {
                        previousPassword2 = vm.selectedBidder.password2;
                    } catch(e) {
                        previousPassword2 = "";
                    }                    

                    try {
                        previousPassword3 = vm.selectedBidder.password3;
                    } catch(e) {
                        previousPassword3 = "";
                    }                    

                    try {
                        previousPassword4 = vm.selectedBidder.password4;
                    } catch(e) {
                        previousPassword4 = "";
                    }                    

// END - ELUSIONA 28/06/2021 
					
                    //console.log("(2) bidder LOADED with Key = " + data.$id);
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("ERROR: " + error);
                });
        }

/*
        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("(3) LOAD Grid DONE");
        }
*/


        function addBidder(bidder) 
        {
            if ( (bidder.password != null) && (bidder.password.trim().length > 0) && (bidder.password != vm.passwordConfirm)) {
                vm.showAlertDialog("Passwords for Contact 1 don't match");
                return;

            } else if ( (bidder.password1 != null) && (bidder.password1.trim().length > 0) && (bidder.password1 != vm.passwordConfirm1)) {
                vm.showAlertDialog("Passwords for Contact 2 don't match");
                return;

            } else if ( (bidder.password2 != null) && (bidder.password2.trim().length > 0) && (bidder.password2 != vm.passwordConfirm2)) {
                vm.showAlertDialog("Passwords for Contact 3 don't match");
                return;

            } else if ( (bidder.password3 != null) && (bidder.password3.trim().length > 0) && (bidder.password3 != vm.passwordConfirm3)) {
                vm.showAlertDialog("Passwords for Contact 4 don't match");
                return;

            } else if ( (bidder.password4 != null) && (bidder.password4.trim().length > 0) && (bidder.password4 != vm.passwordConfirm4)) {
                vm.showAlertDialog("Passwords for Contact 5 don't match");
                return;
            }

            if (bidder != null) {
                vm.bidders.$add(bidder)
                    .then(function(ref) {
                        //console.log("Added new record with ID = " + ref.key);

                        //Refresh grid
                        vm.loadGrid(vm.bidders);

                        //Insert a record in "traceability" table
                        vm.addTrace("Bidder '" + bidder.bidder + "' added");
                    }
                );
            }
        }


        function deleteBidder() 
        {
            var bidder = vm.selectedBidder;
            //console.log("Bidder KEY = " + vm.selectedBidder.$id);
            
            if (bidder != null) {
                vm.bidders.$remove(bidder)
                    .then(function(ref) {
                        //console.log("Delete record with ID = " + ref.key);

                        //Insert a record in "traceability" table
                        vm.addTrace("Bidder '" + bidder.bidder + "' deleted");
                    }
                );
            } else {
                //console.log("We can´t remove the row because there isn´t a selected row.");
            }
        }


        function saveBidder() 
        {
            var bidder = vm.selectedBidder;

            if ( (bidder.password != null) && (bidder.password.trim().length > 0) && (bidder.password != vm.passwordConfirm)) {
                vm.showAlertDialog("Passwords for Contact 1 don't match");
                return;

            } else if ( (bidder.password1 != null) && (bidder.password1.trim().length > 0) && (bidder.password1 != vm.passwordConfirm1)) {
                vm.showAlertDialog("Passwords for Contact 2 don't match");
                return;

            } else if ( (bidder.password2 != null) && (bidder.password2.trim().length > 0) && (bidder.password2 != vm.passwordConfirm2)) {
                vm.showAlertDialog("Passwords for Contact 3 don't match");
                return;

            } else if ( (bidder.password3 != null) && (bidder.password3.trim().length > 0) && (bidder.password3 != vm.passwordConfirm3)) {
                vm.showAlertDialog("Passwords for Contact 4 don't match");
                return;

            } else if ( (bidder.password4 != null) && (bidder.password4.trim().length > 0) && (bidder.password4 != vm.passwordConfirm4)) {
                vm.showAlertDialog("Passwords for Contact 5 don't match");
                return;
            }

            //console.log("START saveBidder() method");

            var bidderName = bidder.bidder;
            var bidderEmail = vm.getBidderEmail(bidder.email,bidder.email1,bidder.email2,bidder.email3,bidder.email4);

            if (bidder != null) {

                //console.log("bidder is not null => bidder.$id = " + bidder.$id);
                //console.log("vm.bidders.length = " + vm.bidders.length);

                vm.bidders.$save(bidder)
                    .then(function(ref) {

                        //console.log("Saved record with ID = " + ref.key);

                        //Refresh grid
                        //vm.loadGrid(vm.bidders);

                        //Insert a record in "traceability" table
                        vm.addTrace("Bidder '" + bidder.bidder + "' modified");

                        var notification = "<p><b>NOTIFICATION</b><br /><br />";
                        notification += "<p>Dear Administrator,<br /><br />";
                        notification += "The Bidder profile for '" + bidder.bidder + "' has been updated.";

                        mailerService.sendUpdateBidderNotification(notification);


                        
                        //Update the field "bidderCompany" in tables "itb_bidders", "pendind_technical_docs", "pending_commercial_docs"
                        var bidderKey = ref.key;
                        vm.updateBidderCompanyInAllTables(bidderKey,bidderName,bidderEmail);

/* BEGIN - ELUSIONA 28/06/2021 */

                    //BEGIN - UPDATE FIREBASE USER's PASSWORD FOR AUTHENTICATION
                        //For USER 0
                        if (bidder.email == previousEmail) {
                            vm.updatePasswordInFirebase(bidder.email,bidder.password,previousPassword);
                        } else {
                            vm.addNewFirebaseUser(bidder.email,bidder.password);    
                        }

                        //For USER 1
                        if ( (bidder.email1 != null) && (bidder.email1.trim() != "") ) {

                            if (previousEmail1 != null) {

                                if (bidder.email1 == previousEmail1) {
                                    vm.updatePasswordInFirebase(bidder.email1,bidder.password1,previousPassword1);
                                } else {
                                    vm.addNewFirebaseUser(bidder.email1,bidder.password1);
                                }

                            }
                            else {
                                vm.addNewFirebaseUser(bidder.email1,bidder.password1);
                            }
                        }

                        //For USER 2
                        if ( (bidder.email2 != null) && (bidder.email2.trim() != "") ) {

                            if (previousEmail2 != null) {

                                if (bidder.email2 == previousEmail2) {
                                    vm.updatePasswordInFirebase(bidder.email2,bidder.password2,previousPassword2);
                                } else {
                                    vm.addNewFirebaseUser(bidder.email2,bidder.password2);    
                                }

                            }
                            else {
                                vm.addNewFirebaseUser(bidder.email2,bidder.password2);
                            }
                        }

                        //For USER 3
                        if ( (bidder.email3 != null) && (bidder.email3.trim() != "") ) {

                            if (previousEmail3 != null) {

                                if (bidder.email3 == previousEmail3) {
                                    vm.updatePasswordInFirebase(bidder.email3,bidder.password3,previousPassword3);
                                } else {
                                    vm.addNewFirebaseUser(bidder.email3,bidder.password3);
                                }

                            }
                            else {
                                vm.addNewFirebaseUser(bidder.email3,bidder.password3);
                            }
                        }

                        //For USER 4
                        if ( (bidder.email4 != null) && (bidder.email4.trim() != "") ) {

                            if (previousEmail4 != null) {

                                if (bidder.email4 == previousEmail4) {
                                    vm.updatePasswordInFirebase(bidder.email4,bidder.password4,previousPassword4);
                                } else {
                                    vm.addNewFirebaseUser(bidder.email4,bidder.password4);
                                }

                            }
                            else {
                                vm.addNewFirebaseUser(bidder.email4,bidder.password4);
                            }
                        }
                    //END - UPDATE FIREBASE USER's PASSWORD FOR AUTHENTICATION

/* END - ELUSIONA 28/06/2021 */ 						
						
						
						
                        $location.path("/workflow-bidder/select-itb");
                    }
                );
            }
        }


        function cancel() {

            $location.path("/workflow-bidder/select-itb");
        }




        function getBidderEmail(pEmail,pEmail1,pEmail2,pEmail3,pEmail4) {

            var bidderEmail = "";

            try {
                pEmail = pEmail.trim();
                if (pEmail.length > 0) {
                    bidderEmail = pEmail;
                }
            } catch(error) {
                //Do nothing
            }

            try {
                pEmail1 = pEmail1.trim();
                if (pEmail1.length > 0) {
                    bidderEmail += "&" + pEmail1;
                }
            } catch(error) {
                //Do nothing
            }

            try {
                pEmail2 = pEmail2.trim();
                if (pEmail2.length > 0) {
                    bidderEmail += "&" + pEmail2;
                }
            } catch(error) {
                //Do nothing
            }

            try {
                pEmail3 = pEmail3.trim();
                if (pEmail3.length > 0) {
                    bidderEmail += "&" + pEmail3;
                }
            } catch(error) {
                //Do nothing
            }

            try {
                pEmail4 = pEmail4.trim();
                if (pEmail4.length > 0) {
                    bidderEmail += "&" + pEmail4;
                }
            } catch(error) {
                //Do nothing
            }

            return bidderEmail
        }



        //Update the field "bidderCompany" y "bidderEmail" in tables "itb_bidders", "pendind_technical_docs", "pending_commercial_docs" (NOTE: "bidderEmail" only in "itb_bidders" table)
        function updateBidderCompanyInAllTables(pBidderKey,pBidder,pBidderEmail)
        {
            vm.updateBidderCompanyInTable("itb_bidders",pBidderKey,pBidder,pBidderEmail);

            vm.updateBidderCompanyInTable("pending_technical_docs",pBidderKey,pBidder,"");

            vm.updateBidderCompanyInTable("pending_commercial_docs",pBidderKey,pBidder,"");

            vm.updateBidderCompanyInTable("pending_general_docs",pBidderKey,pBidder,"");            
        }


        function updateBidderCompanyInTable(pTableName,pBidderKey,pBidderCompany,pBidderEmail)
        {
            //For table "itb_bidders"
//            var fbUrl = new Firebase(FIREBASE_URL + "/" + pTableName + "/");
            var fbUrl = firebaseDataService.firebaseRootRef.child(pTableName);

            var records = $firebaseArray(fbUrl.orderByChild("bidder_key").equalTo(pBidderKey));

            records.$loaded()
                .then(function(data) {

                    for (var i=0; i<records.length;i++) {

                        records[i].bidderCompany = pBidderCompany;

                        if (pBidderEmail != "") {
                            records[i].bidderEmail = pBidderEmail;                            
                        }   

                        records.$save(records[i])
                            .then(function(ref) {

                                //console.log("[BidderController] Saved record in function 'updateBidderCompanyInAllTables' for '" + pTableName + "' table with ID = " + ref.key);
                            })
                            .catch(function(error) {
                                //vm.gridOptions.data = null;
                                //console.log("[BidderController] ERROR (save method) in function 'updateBidderCompanyInAllTables' for '" + pTableName + "' table: " + error);
                            });
                    }

                })
                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[BidderController] ERROR (loaded method) in function 'updateBidderCompanyInAllTables' for '" + pTableName + "' table: " + error);
                });
        }


        //****************************************************************************************************
        function addNewFirebaseUser(pEmail,pPassword) {

////console.log("addNewFirebaseUser => pEmail = " + pEmail);
////console.log("addNewFirebaseUser => pPassword = " + pPassword);

            //BEGIN - FIREBASE CREATE USER FOR AUTHENTICATION
            firebase.auth().createUserWithEmailAndPassword(pEmail,pPassword)
                .then(function() {
                    //console.log("FIREBASE USER CREATION SUCCESFUL for " + pEmail + " and " + pPassword);
                })
                .catch(function(error) {
                    // Handle Errors here.
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    //console.log("FIREBASE USER CREATION FAILED for " + pEmail + " and " + pPassword);
            });
            //END - FIREBASE CREATE USER FOR AUTHENTICATION
        }


// (27/03/2025) - INICIO
/*
        //****************************************************************************************************
        function updatePasswordInFirebase(pEmail,pPassword,pPreviousPassword) {

            if (pPassword == pPreviousPassword) {
                return;
            }

            //BEGIN - FIREBASE UPDATE USER's PASSWORD FOR AUTHENTICATION
            var firebaseUser = firebase.auth().currentUser;

            if (firebaseUser != null) {
                
                //If the email of the current Firebase user is the same as the email of the user to change => UPDATE THE PASSWORD FOR THE CURRENT FIREBASE USER
                if (firebaseUser.email == pEmail) {

                    firebaseUser.updatePassword(pPassword)
                        .then(function() {
                            //console.log("PASSWORD UPDATE SUCCESFUL for " + pEmail + " and " + pPassword);
                        }, 
                        function(error) {
                            //console.log("PASSWORD UPDATE FAILED for " + pEmail + " and " + pPassword);
                    });                    

                //If the email of the current Firebase user is different from the email of the user to change => LOGIN WITH THE OTHER USER AND UPDATE THE PASSWORD
                } else {

                    //BEGIN - FIREBASE USER AUTHENTICATION
                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> signInWithEmailAndPassword(" + pEmail + "," + pPreviousPassword + ")");

                    firebase.auth().signInWithEmailAndPassword(pEmail,pPreviousPassword)
                        .then(function(firebaseUser) {
                            //console.log("LOGIN WITH SECONDARY USER CORRECT for " + pEmail + " and " + pPreviousPassword);

                            var firebaseUser = firebase.auth().currentUser;

                            if (firebaseUser != null) {
                                
                                firebaseUser.updatePassword(pPassword)
                                    .then(function() {
                                        //console.log("PASSWORD UPDATE SUCCESFUL for " + pEmail + " and " + pPassword);

                                        //We update credentials password only if the email is the same as the login
                                        if (loginService.getEmail() == pEmail) {
                                            loginService.setPassword(pPassword);
                                        }

                                    }, 
                                    function(error) {
                                        //console.log("PASSWORD UPDATE FAILED for " + pEmail + " and " + pPassword);
                                });                    

                            } else {

                                //console.log("Firebase user signIn error: We can't get a firebase user for this email and password");
                            }                                         
                            
                        })

                        .catch(function(error) {
                            // Handle Errors here.
                            var errorCode = error.code;
                            var errorMessage = error.message; 

                            //console.log("Login with secondary user (" + pEmail + "," + pPreviousPassword + ") error => ErrorCode = " + errorCode + "  / errorMessage = " + errorMessage);

                    });
                    //END - FIREBASE USER AUTHENTICATION
                }

            }            

            //END - FIREBASE UPDATE USER's PASSWORD FOR AUTHENTICATION
        }		
	*/

		// (NUEVA VERSION)
		//********************************************************
		function updatePasswordInFirebase(pEmail, pPassword, pPreviousPassword) {
			if (pPassword == pPreviousPassword) {
				return;
			}

			var firebaseUser = firebase.auth().currentUser;
			
			var updateUserPassword = function(user) {
				var credential = firebase.auth.EmailAuthProvider.credential(user.email, pPreviousPassword);
				
				user.reauthenticate(credential)
					.then(function() {
						return user.updatePassword(pPassword);
					})
					.then(function() {
						//console.log("PASSWORD UPDATE SUCCESSFUL for " + pEmail);
						/*
						if (loginService.getEmail() == pEmail) {
							loginService.setPassword(pPassword);
						}
						*/
					})
					.catch(function(error) {
						console.error("PASSWORD UPDATE FAILED for " + pEmail + ": " + error.message);
					});
			};

			if (firebaseUser) {
				if (firebaseUser.email == pEmail) {
					updateUserPassword(firebaseUser);
				} else {
					firebase.auth().signInWithEmailAndPassword(pEmail, pPreviousPassword)
						.then(function(userCredential) {
							var newFirebaseUser = firebase.auth().currentUser;
							if (newFirebaseUser) {
								updateUserPassword(newFirebaseUser);
							} else {
								console.error("Unable to get Firebase user after sign-in");
							}
						})
						.catch(function(error) {
							console.error("Login failed for " + pEmail + ": " + error.code + " - " + error.message);
						});
				}
			}
		}		
// (27/03/2025) - FIN		
		
		


        function getTraceabilityFromFirebaseByUser(pUserKey) {

            if (pUserKey != null) {

//                var fbUrl = new Firebase(FIREBASE_URL + "/traceability/");
                var fbUrl = firebaseDataService.traceability;
                var result = $firebaseArray(fbUrl.orderByChild("user_key").equalTo(pUserKey));

                result.$loaded()
                    .then(function(data) {

                        traceabilityService.setTraceability(data);

                        //console.log("[traceabilityService] getTraceabilityByUser() method => Get all records of 'user_key' from 'traceability' table of Firebase.");

                        return data;
                    })
                    .catch(function(error) {
                        //console.log("[traceabilityService] getTraceabilityByUser() method => ERROR: " + error);
                    });

            } else {

                traceabilityService.setTraceability(null);
                return null;
            }
        }


		//************************************
        function addTrace(pAction) {

            utilsService.getCETdateTime()
                .then(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);

                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'date': data,
                        'time': '',
                        'dateTime': utilsService.getDateTime(),
                        'itbName': '',
                        'itb_key': '',
                        'action': pAction
                    };

                    traceabilityService.addTrace(recordToAdd);
                })
                .catch(function () {
                    //console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }


        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }


        function toggleView(method)
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';

            var bidder = vm.selectedBidder;

            if (vm.currentView == "detail") {

                if (method == "modify") {

                    vm.operation = "modify";

                } else {
                    vm.operation = "insert";
                    vm.selectedBidder = null;
                }
            }

            if (vm.currentView == "list") {

                if (method == "save") {

                    if (vm.operation == "modify") {
                        //console.log("We are going to execute saveBidder() method with key = " + bidder.$id);
                        vm.saveBidder();
                    } else {
                        //console.log("We are going to execute addBidder() method");
                        vm.addBidder(bidder);
                    }

                }
            }
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url      : '/pages/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.lock', {
            title : 'Lock Screen',
            state : 'app.pages_auth_lock',
            weight: 7
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController()
    {
        var vm = this;

        // Data
        vm.form = {
            username: 'Jane Doe'
        };

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/pages/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
            title : 'Forgot Password',
            state : 'app.pages_auth_forgot-password',
            weight: 5
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(firebaseDataService,$location,$firebaseArray,mailerService)
    {

        // DATA DECLARATION
        var vm = this;
        vm.bidders;


        //********************************************************
        // METHODS DECLARATION
        vm.getBidderByEmail = getBidderByEmail;
        vm.getRecoveryPassword = getRecoveryPassword;
        vm.sendLoginDataOfBidder = sendLoginDataOfBidder;

        //vm.sendResetLink = sendResetLink;




        //********************************************************
        // METHODS

        function getRecoveryPassword(pEmail) {

            var length = 0;

            vm.bidders = null;

            //This method assign bidders to the vm.bidders that have the email specified.
            vm.getBidderByEmail(pEmail,0);
        }




        function getBidderByEmail(pEmail,pContactNumber) {

//console.log("(1) CONTACTO" + pContactNumber + " =>  EXECUTION OF getBidderByEmail(" + pEmail + "," + pContactNumber + ")");

            //Get itbs list from Firebase        
//            var fbUrl = new Firebase(FIREBASE_URL + "/bidders/");
            var fbUrl = firebaseDataService.bidders;

            if (pContactNumber == 0) {
                var result = $firebaseArray(fbUrl.orderByChild("email").equalTo(pEmail));

            } else if (pContactNumber == 1) {
                var result = $firebaseArray(fbUrl.orderByChild("email1").equalTo(pEmail));

            } else if (pContactNumber == 2) {
                var result = $firebaseArray(fbUrl.orderByChild("email2").equalTo(pEmail));

            } else if (pContactNumber == 3) {
                var result = $firebaseArray(fbUrl.orderByChild("email3").equalTo(pEmail));

            } else if (pContactNumber == 4) {
                var result = $firebaseArray(fbUrl.orderByChild("email4").equalTo(pEmail));
            }            

            result.$loaded()
                .then(function(data) {

                    if (data.length > 0) {

                        for (var i=0;i<data.length;i++) {

                            try {
                                vm.bidders.push(data[i]);
                                //console.log("ADD Bidder with bidder_key = " + data[i].$id);
                            } catch(error) {
                                vm.bidders = data;
                            }
                        }
                    } 

                    pContactNumber++;
                    if (pContactNumber < 5) {

                        vm.getBidderByEmail(pEmail,pContactNumber)

                    } else {

                        var length = 0;

                        try {
                            length = vm.bidders.length;
                        } catch(error) {
                            length = 0;
                        }

                        if (length == 0) {

                            alert("The e-mail doesn´t exist in the system. Please insert another e-mail.");
                            return;
                        }

                        for (var i=0;i<length;i++) {

                            var bidder = vm.bidders[i];

                            vm.sendLoginDataOfBidder(bidder,pEmail);
                        }


                        alert("It has been sent a recovery email");
                        $location.path("/pages/auth/login");
                    }


                })
                .catch(function(error) {
                    //console.log("[LoginController] ERROR: " + error + " (Log Error: Controller: LoginController / Function: getBidderByEmail())");
                });
        }



        function sendLoginDataOfBidder(pBidder,pEmail) {

            var email = pBidder.email;
            var password = pBidder.password;

            var email1 = pBidder.email1;
            var password1 = pBidder.password1;

            var email2 = pBidder.email2;
            var password2 = pBidder.password2;

            var email3 = pBidder.email3;
            var password3 = pBidder.password3;
 
            var email4 = pBidder.email4;
            var password4 = pBidder.password4;


            try {
                if (email == pEmail) {
                    mailerService.sendLoginData(email,password);
                }
            } catch(error) {

            }

            try {
                if (email1 == pEmail) {
                    mailerService.sendLoginData(email1,password1);
                }
            } catch(error) {

            }

            try {
                if (email2 == pEmail) {
                    mailerService.sendLoginData(email2,password2);
                }
            } catch(error) {

            }

            try {
                if (email3 == pEmail) {
                    mailerService.sendLoginData(email3,password3);
                }
            } catch(error) {

            }

            try {
                if (email4 == pEmail) {
                    mailerService.sendLoginData(email4,password4);
                }
            } catch(error) {

            }

        }


        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_tables_simple-table', {
            url  : '/components/table/simple-table',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/tables/simple-table/simple-table.html',
                    controller : 'SimpleTableController as vm'
                }
            },
            resolve: {
                Employees: function (apiResolver)
                {
                    return apiResolver.resolve('tables.employees@get');
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table')
        .controller('SimpleTableController', SimpleTableController);

    /** @ngInject */
    function SimpleTableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_tables_datatable', {
            url    : '/components/table/datatable',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/tables/datatable/datatable.html',
                    controller : 'DatatableController as vm'
                }
            },
            resolve: {
                Employees: function (apiResolver)
                {
                    return apiResolver.resolve('tables.employees100@get');
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable')
        .controller('DatatableController', DatatableController);

    /** @ngInject */
    function DatatableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    /**
     * Replace those for demo assets
     * img/                     >>>            assets/angular-material-assets/img/
     * 'icons                   >>>            'assets/angular-material-assets/icons/
     */
    angular
        .module('app.components.material-docs', ['ngMaterial', 'ngMessages'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $stateProvider, ELEMENTS_NAVIGATION)
    {
        msNavigationServiceProvider.saveItem('components.elements', {
            title : 'Angular Material Elements',
            icon  : 'icon-layers',
            weight: 0
        });

        msNavigationServiceProvider.saveItem('components.elements.inputs', {
            title : 'Inputs',
            weight: 0
        });

        msNavigationServiceProvider.saveItem('components.elements.buttons', {
            title : 'Buttons',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.elements.content-elements', {
            title : 'Content Elements',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.elements.lists', {
            title : 'Lists',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.elements.menus', {
            title : 'Menus',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.elements.progress', {
            title : 'Progress',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.elements.others', {
            title : 'Others',
            weight: 6
        });


        angular.forEach(ELEMENTS_NAVIGATION, function (component)
        {

            $stateProvider.state('app.docs_' + component.stateName, {
                url  : '/components/angular-material-elements/' + component.url,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/material-docs/material-doc-template.html',
                        controller : 'DocTemplateController as vm'
                    }
                },
                data : component
            });

            // Navigation
            msNavigationServiceProvider.saveItem(component.navPath + '.' + component.url, {
                title : component.name,
                state : 'app.docs_' + component.stateName,
                weight: component.weight
            });
        });

    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .factory('$demoAngularScripts', DemoAngularScripts);

    function DemoAngularScripts()
    {
        var scripts = [
            'angular.js',
            'angular-animate.min.js',
            'angular-route.min.js',
            'angular-aria.min.js',
            'angular-messages.min.js'
        ];

        return {
            all: allAngularScripts
        };

        function allAngularScripts()
        {
            return scripts.map(fullPathToScript);
        }

        function fullPathToScript(script)
        {
            return "https://ajax.googleapis.com/ajax/libs/angularjs/1.4.8/" + script;
            //return "https://ajax.googleapis.com/ajax/libs/angularjs/" + BUILDCONFIG.ngVersion + "/" + script;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .directive('demoInclude', demoInclude)

    function demoInclude($q, $http, $compile, $templateCache, $timeout)
    {
        return {
            restrict: 'E',
            link    : postLink
        };

        function postLink(scope, element, attr)
        {
            var demoContainer;

            // Interpret the expression given as `demo-include files="something"`
            var files = scope.$eval(attr.files) || {};
            var ngModule = scope.$eval(attr.module) || '';

            $timeout(handleDemoIndexFile);

            /**
             * Fetch the index file, and if it contains its own ngModule
             * then bootstrap a new angular app with that ngModule. Otherwise, compile
             * the demo into the current ng-app.
             */
            function handleDemoIndexFile()
            {
                files.index.contentsPromise.then(function (contents)
                {
                    demoContainer = angular.element(
                        '<div class="demo-content ' + ngModule + '">'
                    );

                    var isStandalone = !!ngModule;
                    var demoScope;
                    var demoCompileService;
                    if ( isStandalone )
                    {
                        angular.bootstrap(demoContainer[0], [ngModule]);
                        demoScope = demoContainer.scope();
                        demoCompileService = demoContainer.injector().get('$compile');

                        scope.$on('$destroy', function ()
                        {
                            demoScope.$destroy();
                        });

                    }
                    else
                    {
                        demoScope = scope.$new();
                        demoCompileService = $compile;
                    }

                    // Once everything is loaded, put the demo into the DOM
                    $q.all([
                        handleDemoStyles(),
                        handleDemoTemplates()
                    ]).finally(function ()
                    {

                        demoScope.$evalAsync(function ()
                        {
                            element.append(demoContainer);
                            demoContainer.html(contents);
                            demoCompileService(demoContainer.contents())(demoScope);
                        });


                    });
                });

            }


            /**
             * Fetch the demo styles, and append them to the DOM.
             */
            function handleDemoStyles()
            {
                return $q.all(files.css.map(function (file)
                    {
                        return file.contentsPromise;
                    }))
                    .then(function (styles)
                    {
                        styles = styles.join('\n'); //join styles as one string

                        var styleElement = angular.element('<style>' + styles + '</style>');
                        document.body.appendChild(styleElement[0]);

                        scope.$on('$destroy', function ()
                        {
                            styleElement.remove();
                        });
                    });

            }

            /**
             * Fetch the templates for this demo, and put the templates into
             * the demo app's templateCache, with a url that allows the demo apps
             * to reference their templates local to the demo index file.
             *
             * For example, make it so the dialog demo can reference templateUrl
             * 'my-dialog.tmpl.html' instead of having to reference the url
             * 'generated/material.components.dialog/demo/demo1/my-dialog.tmpl.html'.
             */
            function handleDemoTemplates()
            {

                return $q.all(files.html.map(function (file)
                {

                    return file.contentsPromise.then(function (contents)
                    {
                        // Get the $templateCache instance that goes with the demo's specific ng-app.
                        var demoTemplateCache = demoContainer.injector().get('$templateCache');
                        demoTemplateCache.put(file.name, contents);

                        scope.$on('$destroy', function ()
                        {
                            demoTemplateCache.remove(file.name);
                        });

                    });

                }));

            }

        }

    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .directive('docsDemo', docsDemo)
        .directive('demoFile', demoFile)
        .filter('toHtml', toHtml)
        .directive('layoutAlign', function ()
        {
            return angular.noop;
        })
        .directive('layout', function ()
        {
            return angular.noop;
        });

    /** @ngInject */
    function docsDemo($mdUtil)
    {
        return {
            restrict        : 'E',
            scope           : true,
            templateUrl     : 'app/main/components/material-docs/demo/docs-demo.tmpl.html',
            transclude      : true,
            controller      :DocsDemoCtrl,
            controllerAs    : 'demoCtrl',
            bindToController: true
        };

        function DocsDemoCtrl($scope, $element, $attrs, $interpolate)
        {
            var self = this;

            self.interpolateCode = angular.isDefined($attrs.interpolateCode);
            self.demoId = $interpolate($attrs.demoId || '')($scope.$parent);
            self.demoTitle = $interpolate($attrs.demoTitle || '')($scope.$parent);
            self.demoModule = $interpolate($attrs.demoModule || '')($scope.$parent);
            self.files = {
                css : [],
                js  : [],
                html: []
            };

            self.addFile = function (name, contentsPromise)
            {
                var file = {
                    name           : convertName(name),
                    contentsPromise: contentsPromise,
                    fileType       : name.split('.').pop()
                };
                contentsPromise.then(function (contents)
                {
                    file.contents = contents;
                });

                if ( name === 'index.html' )
                {
                    self.files.index = file;
                }
                else if ( name === 'readme.html' )
                {
                    self.demoDescription = file;
                }
                else
                {
                    self.files[file.fileType] = self.files[file.fileType] || [];
                    self.files[file.fileType].push(file);
                }

                self.orderedFiles = []
                    .concat(self.files.index || [])
                    .concat(self.files.js || [])
                    .concat(self.files.css || [])
                    .concat(self.files.html || []);

            };

            self.editOnCodepen = function ()
            {
                codepen.editOnCodepen({
                    title : self.demoTitle,
                    files : self.files,
                    id    : self.demoId,
                    module: self.demoModule
                });
            };

            function convertName(name)
            {
                switch ( name )
                {
                    case "index.html" :
                        return "HTML";
                    case "script.js" :
                        return "JS";
                    case "style.css" :
                        return "CSS";
                    default :
                        return name;
                }
            }

        }
    }

    /** @ngInject */
    function demoFile($q, $interpolate)
    {
        return {
            restrict: 'E',
            require : '^docsDemo',
            compile : compile
        };

        function compile(element, attr)
        {
            var contentsAttr = attr.contents;
            var html = element.html();
            var name = attr.name;
            element.contents().remove();

            return function postLink(scope, element, attr, docsDemoCtrl)
            {
                docsDemoCtrl.addFile(
                    $interpolate(name)(scope),
                    $q.when(scope.$eval(contentsAttr) || html)
                );
                element.remove();
            };
        }
    }

    /** @ngInject */
    function toHtml($sce)
    {
        return function (str)
        {
            return $sce.trustAsHtml(str);
        };
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .factory('$demoAngularScripts', DemoAngularScripts);

    function DemoAngularScripts()
    {
        var scripts = [
            'angular.js',
            'angular-animate.min.js',
            'angular-route.min.js',
            'angular-aria.min.js',
            'angular-messages.min.js'
        ];

        return {
            all: allAngularScripts
        };

        function allAngularScripts()
        {
            return scripts.map(fullPathToScript);
        }

        function fullPathToScript(script)
        {
            return "https://ajax.googleapis.com/ajax/libs/angularjs/" + angular.version.full + "/" + script;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .constant('ELEMENTS_NAVIGATION', [
            /* INPUTS */
            {
                name      : 'Autocomplete',
                url       : 'autocomplete',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.autocomplete',
                stateName : 'material_components_autocomplete',
                weight    : 1
            },
            {
                name      : 'Checkbox',
                url       : 'checkbox',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.checkbox',
                stateName : 'material_components_checkbox',
                weight    : 2
            },
            {
                name      : 'Chips',
                url       : 'chips',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.chips',
                stateName : 'material_components_chips',
                weight    : 3
            },
            {
                name      : 'Date Picker',
                url       : 'date-picker',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.datepicker',
                stateName : 'material_components_datepicker',
                weight    : 4
            },
            {
                name      : 'Input',
                url       : 'input',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.input',
                stateName : 'material_components_input',
                weight    : 5
            },
            {
                name      : 'Radio Button',
                url       : 'radio-button',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.radioButton',
                stateName : 'material_components_radioButton',
                weight    : 6
            },
            {
                name      : 'Select',
                url       : 'select',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.select',
                stateName : 'material_components_select',
                weight    : 7
            },
            {
                name      : 'Slider',
                url       : 'slider',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.slider',
                stateName : 'material_components_slider',
                weight    : 8
            },
            {
                name      : 'Switch',
                url       : 'switch',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.switch',
                stateName : 'material_components_switch',
                weight    : 9
            },
            /* BUTTONS */
            {
                name      : 'Button',
                url       : 'button',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.button',
                stateName : 'material_components_button',
                weight    : 1
            },
            {
                name      : 'Fab Actions',
                url       : 'fab-actions',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabActions',
                stateName : 'material_components_fabActions',
                weight    : 2
            },
            {
                name      : 'Fab Speed Dial',
                url       : 'fab-speed-dial',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabSpeedDial',
                stateName : 'material_components_fabSpeedDial',
                weight    : 3
            },
            {
                name      : 'Fab Toolbar',
                url       : 'fab-toolbar',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabToolbar',
                stateName : 'material_components_fabToolbar',
                weight    : 4
            },
            /* CONTENT ELEMENTS */
            {
                name      : 'Bottom Sheet',
                url       : 'bottom-sheet',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.bottomSheet',
                stateName : 'material_components_bottomSheet',
                weight    : 1
            },
            {
                name      : 'Card',
                url       : 'card',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.card',
                stateName : 'material_components_card',
                weight    : 2
            },
            {
                name      : 'Content',
                url       : 'content',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.content',
                stateName : 'material_components_content',
                weight    : 3
            },
            {
                name      : 'Dialog',
                url       : 'dialog',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.dialog',
                stateName : 'material_components_dialog',
                weight    : 4
            },
            {
                name       : 'Icon',
                url        : 'icon',
                navPath    : 'components.elements.content-elements',
                moduleName : 'material.components.icon',
                stateName  : 'material_components_icon',
                excludeDemo: true,
                weight     : 5
            },
            {
                name      : 'Sidenav',
                url       : 'sidenav',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.sidenav',
                stateName : 'material_components_sidenav',
                weight    : 6
            },
            {
                name      : 'Subheader',
                url       : 'subheader',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.subheader',
                stateName : 'material_components_subheader',
                weight    : 7
            },
            {
                name      : 'Tabs',
                url       : 'tabs',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.tabs',
                stateName : 'material_components_tabs',
                weight    : 8
            },
            {
                name      : 'Toast',
                url       : 'toast',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.toast',
                stateName : 'material_components_toast',
                weight    : 9
            },
            {
                name      : 'Toolbar',
                url       : 'toolbar',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.toolbar',
                stateName : 'material_components_toolbar',
                weight    : 10
            },
            {
                name      : 'Tooltip',
                url       : 'tooltip',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.tooltip',
                stateName : 'material_components_tooltip',
                weight    : 11
            },
            {
                name      : "Whiteframe",
                url       : 'whiteframe',
                navPath   : 'components.elements.content-elements',
                moduleName: "material.components.whiteframe",
                stateName : 'material_components_whiteframe',
                weight    : 12
            },
            /* LISTS */
            {
                name      : 'Grid List',
                url       : 'grid-list',
                navPath   : 'components.elements.lists',
                moduleName: 'material.components.gridList',
                stateName : 'material_components_gridList',
                weight    : 1
            },
            {
                name      : 'List',
                url       : 'list',
                navPath   : 'components.elements.lists',
                moduleName: 'material.components.list',
                stateName : 'material_components_list',
                weight    : 2
            },
            /* MENUS */
            {
                name      : 'Menu',
                url       : 'menu',
                navPath   : 'components.elements.menus',
                moduleName: 'material.components.menu',
                stateName : 'material_components_menu',
                weight    : 1
            },
            {
                name      : 'Menu Bar',
                url       : 'menu-bar',
                navPath   : 'components.elements.menus',
                moduleName: 'material.components.menuBar',
                stateName : 'material_components_menu-bar',
                weight    : 2
            },
            /* PROGRESS */
            {
                name      : 'Progress Circular',
                url       : 'progress-circular',
                navPath   : 'components.elements.progress',
                moduleName: 'material.components.progressCircular',
                stateName : 'material_components_progressCircular',
                weight    : 1
            },
            {
                name      : 'Progress Linear',
                url       : 'progress-linear',
                navPath   : 'components.elements.progress',
                moduleName: 'material.components.progressLinear',
                stateName : 'material_components_progressLinear',
                weight    : 2
            },
            /* OTHERS */
            {
                name      : 'Divider',
                url       : 'divider',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.divider',
                stateName : 'material_components_divider',
                weight    : 1
            },
            {
                name      : 'Ripple',
                url       : 'ripple',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.ripple',
                stateName : 'material_core_ripple',
                weight    : 2
            },
            {
                name      : 'Sticky',
                url       : 'sticky',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.sticky',
                stateName : 'material_components_sticky',
                weight    : 3
            },
            {
                name      : 'Swipe',
                url       : 'swipe',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.swipe',
                stateName : 'material_components_swipe',
                weight    : 4
            },
            {
                name      : 'Util',
                url       : 'util',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.util',
                stateName : 'material_core_util',
                weight    : 5
            },
            {
                name      : 'Virtual Repeat',
                url       : 'virtual-repeat',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.virtualRepeat',
                stateName : 'material_components_virtualRepeat',
                weight    : 6
            }
        ]);
})();
angular.module('app.components.material-docs')
    .constant('DEMOS', [
        {
            "name"      : "autocomplete",
            "moduleName": "material.components.autocomplete",
            "label"     : "Autocomplete",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "autocompleteDemo",
                        "module"      : "autocompleteDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "autocompletedemoBasicUsage",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/autocomplete/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.autocomplete",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/autocomplete/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "autocompleteCustomTemplateDemo",
                        "module"      : "autocompleteCustomTemplateDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "autocompletedemoCustomTemplate",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/autocomplete/demoCustomTemplate/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/autocomplete/demoCustomTemplate/script.js"
                        }
                    ],
                    "moduleName": "material.components.autocomplete",
                    "name"      : "demoCustomTemplate",
                    "label"     : "Custom Template",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/autocomplete/demoCustomTemplate/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "autocompleteFloatingLabelDemo",
                        "module"      : "autocompleteFloatingLabelDemo",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "autocompletedemoFloatingLabel",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/autocomplete/demoFloatingLabel/script.js"
                        }
                    ],
                    "moduleName": "material.components.autocomplete",
                    "name"      : "demoFloatingLabel",
                    "label"     : "Floating Label",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/autocomplete/demoFloatingLabel/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "autocompleteDemoInsideDialog",
                        "module"      : "autocompleteDemoInsideDialog",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "autocompletedemoInsideDialog",
                    "css"       : [],
                    "html"      : [
                        {
                            "name"      : "dialog.tmpl.html",
                            "label"     : "dialog.tmpl.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/autocomplete/demoInsideDialog/dialog.tmpl.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/autocomplete/demoInsideDialog/script.js"
                        }
                    ],
                    "moduleName": "material.components.autocomplete",
                    "name"      : "demoInsideDialog",
                    "label"     : "Inside Dialog",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/autocomplete/demoInsideDialog/index.html"
                    }
                }
            ],
            "url"       : "demo/autocomplete"
        },
        {
            "name"      : "bottomSheet",
            "moduleName": "material.components.bottomSheet",
            "label"     : "Bottom Sheet",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "bottomSheetDemo1",
                        "module"      : "bottomSheetDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "bottomSheetdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/bottomSheet/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "bottom-sheet-grid-template.html",
                            "label"     : "bottom-sheet-grid-template.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/bottomSheet/demoBasicUsage/bottom-sheet-grid-template.html"
                        },
                        {
                            "name"      : "bottom-sheet-list-template.html",
                            "label"     : "bottom-sheet-list-template.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/bottomSheet/demoBasicUsage/bottom-sheet-list-template.html"
                        },
                        {
                            "name"      : "readme.html",
                            "label"     : "readme.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/bottomSheet/demoBasicUsage/readme.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/bottomSheet/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.bottomSheet",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/bottomSheet/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/bottomSheet"
        },
        {
            "name"      : "button",
            "moduleName": "material.components.button",
            "label"     : "Button",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "buttonsDemo1",
                        "module"      : "buttonsDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "buttondemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/button/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/button/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.button",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/button/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/button"
        },
        {
            "name"      : "card",
            "moduleName": "material.components.card",
            "label"     : "Card",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "cardDemo1",
                        "module"      : "cardDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "carddemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/card/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/card/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.card",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/card/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "cardDemo1",
                        "module"      : "cardDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "carddemoCardActionButtons",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/card/demoCardActionButtons/script.js"
                        }
                    ],
                    "moduleName": "material.components.card",
                    "name"      : "demoCardActionButtons",
                    "label"     : "Card Action Buttons",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/card/demoCardActionButtons/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "cardDemo1",
                        "module"      : "cardDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "carddemoInCardActions",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/card/demoInCardActions/script.js"
                        }
                    ],
                    "moduleName": "material.components.card",
                    "name"      : "demoInCardActions",
                    "label"     : "In Card Actions",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/card/demoInCardActions/index.html"
                    }
                }
            ],
            "url"       : "demo/card"
        },
        {
            "name"      : "checkbox",
            "moduleName": "material.components.checkbox",
            "label"     : "Checkbox",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "checkboxDemo1",
                        "module"      : "checkboxDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "checkboxdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/checkbox/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/checkbox/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.checkbox",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/checkbox/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "checkboxDemo1",
                        "module"      : "checkboxDemo2",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "checkboxdemoSyncing",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/checkbox/demoSyncing/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/checkbox/demoSyncing/script.js"
                        }
                    ],
                    "moduleName": "material.components.checkbox",
                    "name"      : "demoSyncing",
                    "label"     : "Syncing",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/checkbox/demoSyncing/index.html"
                    }
                }
            ],
            "url"       : "demo/checkbox"
        },
        {
            "name"      : "chips",
            "moduleName": "material.components.chips",
            "label"     : "Chips",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "chipsDemo",
                        "module"      : "chipsDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "chipsdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/chips/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/chips/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.chips",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/chips/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "contactChipsDemo",
                        "module"      : "contactChipsDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "chipsdemoContactChips",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/chips/demoContactChips/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/chips/demoContactChips/script.js"
                        }
                    ],
                    "moduleName": "material.components.chips",
                    "name"      : "demoContactChips",
                    "label"     : "Contact Chips",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/chips/demoContactChips/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "chipsCustomInputDemo",
                        "module"      : "chipsCustomInputDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "chipsdemoCustomInputs",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/chips/demoCustomInputs/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/chips/demoCustomInputs/script.js"
                        }
                    ],
                    "moduleName": "material.components.chips",
                    "name"      : "demoCustomInputs",
                    "label"     : "Custom Inputs",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/chips/demoCustomInputs/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "chipsCustomSeparatorDemo",
                        "module"      : "chipsCustomSeparatorDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "chipsdemoCustomSeparatorKeys",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/chips/demoCustomSeparatorKeys/script.js"
                        }
                    ],
                    "moduleName": "material.components.chips",
                    "name"      : "demoCustomSeparatorKeys",
                    "label"     : "Custom Separator Keys",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/chips/demoCustomSeparatorKeys/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "staticChipsDemo",
                        "module"      : "staticChipsDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "chipsdemoStaticChips",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/chips/demoStaticChips/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/chips/demoStaticChips/script.js"
                        }
                    ],
                    "moduleName": "material.components.chips",
                    "name"      : "demoStaticChips",
                    "label"     : "Static Chips",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/chips/demoStaticChips/index.html"
                    }
                }
            ],
            "url"       : "demo/chips"
        },
        {
            "name"      : "content",
            "moduleName": "material.components.content",
            "label"     : "Content",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "contentDemo1",
                        "module"      : "contentDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "contentdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/content/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/content/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.content",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/content/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/content"
        },
        {
            "name"      : "datepicker",
            "moduleName": "material.components.datepicker",
            "label"     : "Datepicker",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "datepickerBasicUsage",
                        "module"      : "datepickerBasicUsage",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "datepickerdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/datepicker/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/datepicker/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.datepicker",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/datepicker/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/datepicker"
        },
        {
            "name"      : "dialog",
            "moduleName": "material.components.dialog",
            "label"     : "Dialog",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "dialogDemo1",
                        "module"      : "dialogDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "dialogdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/dialog/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "dialog1.tmpl.html",
                            "label"     : "dialog1.tmpl.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/dialog/demoBasicUsage/dialog1.tmpl.html"
                        },
                        {
                            "name"      : "tabDialog.tmpl.html",
                            "label"     : "tabDialog.tmpl.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/dialog/demoBasicUsage/tabDialog.tmpl.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/dialog/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.dialog",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/dialog/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "dialogDemo2",
                        "module"      : "dialogDemo2",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "dialogdemoOpenFromCloseTo",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/dialog/demoOpenFromCloseTo/script.js"
                        }
                    ],
                    "moduleName": "material.components.dialog",
                    "name"      : "demoOpenFromCloseTo",
                    "label"     : "Open From Close To",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/dialog/demoOpenFromCloseTo/index.html"
                    }
                }
            ],
            "url"       : "demo/dialog"
        },
        {
            "name"      : "divider",
            "moduleName": "material.components.divider",
            "label"     : "Divider",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "dividerDemo1",
                        "module"      : "dividerDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "dividerdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/divider/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/divider/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.divider",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/divider/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/divider"
        },
        {
            "name"      : "fabSpeedDial",
            "moduleName": "material.components.fabSpeedDial",
            "label"     : "FAB Speed Dial",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "fabSpeedDialDemoBasicUsage",
                        "module"      : "fabSpeedDialDemoBasicUsage",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "fabSpeedDialdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/fabSpeedDial/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/fabSpeedDial/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.fabSpeedDial",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/fabSpeedDial/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "fabSpeedDialDemoMoreOptions",
                        "module"      : "fabSpeedDialDemoMoreOptions",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "fabSpeedDialdemoMoreOptions",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/fabSpeedDial/demoMoreOptions/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/fabSpeedDial/demoMoreOptions/script.js"
                        }
                    ],
                    "moduleName": "material.components.fabSpeedDial",
                    "name"      : "demoMoreOptions",
                    "label"     : "More Options",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/fabSpeedDial/demoMoreOptions/index.html"
                    }
                }
            ],
            "url"       : "demo/fabSpeedDial"
        },
        {
            "name"      : "fabToolbar",
            "moduleName": "material.components.fabToolbar",
            "label"     : "FAB Toolbar",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "fabToolbarBasicUsageDemo",
                        "module"      : "fabToolbarBasicUsageDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "fabToolbardemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/fabToolbar/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/fabToolbar/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.fabToolbar",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/fabToolbar/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/fabToolbar"
        },
        {
            "name"      : "gridList",
            "moduleName": "material.components.gridList",
            "label"     : "Grid List",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "gridListDemo1",
                        "module"      : "gridListDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "gridListdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "styles.css",
                            "label"     : "styles.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/gridList/demoBasicUsage/styles.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/gridList/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.gridList",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/gridList/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "gridListDemoApp",
                        "module"      : "gridListDemoApp",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "gridListdemoDynamicTiles",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/gridList/demoDynamicTiles/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/gridList/demoDynamicTiles/script.js"
                        }
                    ],
                    "moduleName": "material.components.gridList",
                    "name"      : "demoDynamicTiles",
                    "label"     : "Dynamic Tiles",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/gridList/demoDynamicTiles/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "gridListDemo1",
                        "module"      : "gridListDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "gridListdemoResponsiveUsage",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/gridList/demoResponsiveUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.gridList",
                    "name"      : "demoResponsiveUsage",
                    "label"     : "Responsive Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/gridList/demoResponsiveUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/gridList"
        },
        {
            "name"      : "icon",
            "moduleName": "material.components.icon",
            "label"     : "Icon",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "appDemoFontIconsWithClassnames",
                        "module"      : "appDemoFontIconsWithClassnames",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "icondemoFontIconsWithClassnames",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/icon/demoFontIconsWithClassnames/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/icon/demoFontIconsWithClassnames/script.js"
                        }
                    ],
                    "moduleName": "material.components.icon",
                    "name"      : "demoFontIconsWithClassnames",
                    "label"     : "Font Icons With Classnames",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/icon/demoFontIconsWithClassnames/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "appDemoFontIconsWithLigatures",
                        "module"      : "appDemoFontIconsWithLigatures",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "icondemoFontIconsWithLigatures",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/icon/demoFontIconsWithLigatures/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/icon/demoFontIconsWithLigatures/script.js"
                        }
                    ],
                    "moduleName": "material.components.icon",
                    "name"      : "demoFontIconsWithLigatures",
                    "label"     : "Font Icons With Ligatures",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/icon/demoFontIconsWithLigatures/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "appDemoSvgIcons",
                        "module"      : "appDemoSvgIcons",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "icondemoLoadSvgIconsFromUrl",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/icon/demoLoadSvgIconsFromUrl/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/icon/demoLoadSvgIconsFromUrl/script.js"
                        }
                    ],
                    "moduleName": "material.components.icon",
                    "name"      : "demoLoadSvgIconsFromUrl",
                    "label"     : "Load Svg Icons From Url",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/icon/demoLoadSvgIconsFromUrl/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "appSvgIconSets",
                        "module"      : "appSvgIconSets",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "icondemoSvgIconSets",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/icon/demoSvgIconSets/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/icon/demoSvgIconSets/script.js"
                        }
                    ],
                    "moduleName": "material.components.icon",
                    "name"      : "demoSvgIconSets",
                    "label"     : "Svg Icon Sets",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/icon/demoSvgIconSets/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "appUsingTemplateCache",
                        "module"      : "appUsingTemplateCache",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "icondemoUsingTemplateCache",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/icon/demoUsingTemplateCache/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/icon/demoUsingTemplateCache/script.js"
                        }
                    ],
                    "moduleName": "material.components.icon",
                    "name"      : "demoUsingTemplateCache",
                    "label"     : "Using Template Cache",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/icon/demoUsingTemplateCache/index.html"
                    }
                }
            ],
            "url"       : "demo/icon"
        },
        {
            "name"      : "input",
            "moduleName": "material.components.input",
            "label"     : "Input",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "inputBasicDemo",
                        "module"      : "inputBasicDemo",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "inputdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/input/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/input/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.input",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/input/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "inputErrorsApp",
                        "module"      : "inputErrorsApp",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "inputdemoErrors",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/input/demoErrors/style.css"
                        },
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/input/demoErrors/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/input/demoErrors/script.js"
                        },
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/input/demoErrors/script.js"
                        }
                    ],
                    "moduleName": "material.components.input",
                    "name"      : "demoErrors",
                    "label"     : "Errors",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/input/demoErrors/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "inputErrorsAdvancedApp",
                        "module"      : "inputErrorsAdvancedApp",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "inputdemoErrorsAdvanced",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/input/demoErrorsAdvanced/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/input/demoErrorsAdvanced/script.js"
                        }
                    ],
                    "moduleName": "material.components.input",
                    "name"      : "demoErrorsAdvanced",
                    "label"     : "Errors Advanced",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/input/demoErrorsAdvanced/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "inputIconDemo",
                        "module"      : "inputIconDemo",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "inputdemoIcons",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/input/demoIcons/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/input/demoIcons/script.js"
                        }
                    ],
                    "moduleName": "material.components.input",
                    "name"      : "demoIcons",
                    "label"     : "Icons",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/input/demoIcons/index.html"
                    }
                }
            ],
            "url"       : "demo/input"
        },
        {
            "name"      : "list",
            "moduleName": "material.components.list",
            "label"     : "List",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "listDemo1",
                        "module"      : "listDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "listdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/list/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/list/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.list",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/list/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "listDemo2",
                        "module"      : "listDemo2",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "listdemoListControls",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/list/demoListControls/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/list/demoListControls/script.js"
                        }
                    ],
                    "moduleName": "material.components.list",
                    "name"      : "demoListControls",
                    "label"     : "List Controls",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/list/demoListControls/index.html"
                    }
                }
            ],
            "url"       : "demo/list"
        },
        {
            "name"      : "menu",
            "moduleName": "material.components.menu",
            "label"     : "Menu",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "menuDemoBasic",
                        "module"      : "menuDemoBasic",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "menudemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/menu/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/menu/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.menu",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/menu/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "menuDemoPosition",
                        "module"      : "menuDemoPosition",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "menudemoMenuPositionModes",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/menu/demoMenuPositionModes/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/menu/demoMenuPositionModes/script.js"
                        }
                    ],
                    "moduleName": "material.components.menu",
                    "name"      : "demoMenuPositionModes",
                    "label"     : "Menu Position Modes",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/menu/demoMenuPositionModes/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "menuDemoWidth",
                        "module"      : "menuDemoWidth",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "menudemoMenuWidth",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/menu/demoMenuWidth/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/menu/demoMenuWidth/script.js"
                        }
                    ],
                    "moduleName": "material.components.menu",
                    "name"      : "demoMenuWidth",
                    "label"     : "Menu Width",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/menu/demoMenuWidth/index.html"
                    }
                }
            ],
            "url"       : "demo/menu"
        },
        {
            "name"      : "menuBar",
            "moduleName": "material.components.menuBar",
            "label"     : "Menu Bar",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "menuBarDemoBasic",
                        "module"      : "menuBarDemoBasic",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "menuBardemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/menuBar/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/menuBar/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.menuBar",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/menuBar/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/menuBar"
        },
        {
            "name"      : "progressCircular",
            "moduleName": "material.components.progressCircular",
            "label"     : "Progress Circular",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "progressCircularDemo1",
                        "module"      : "progressCircularDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "progressCirculardemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/progressCircular/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/progressCircular/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.progressCircular",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/progressCircular/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/progressCircular"
        },
        {
            "name"      : "progressLinear",
            "moduleName": "material.components.progressLinear",
            "label"     : "Progress Linear",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "progressLinearDemo1",
                        "module"      : "progressLinearDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "progressLineardemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/progressLinear/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/progressLinear/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.progressLinear",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/progressLinear/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/progressLinear"
        },
        {
            "name"      : "radioButton",
            "moduleName": "material.components.radioButton",
            "label"     : "Radio Button",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "radioDemo1",
                        "module"      : "radioDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "radioButtondemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/radioButton/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/radioButton/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.radioButton",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/radioButton/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "radioDemo2",
                        "module"      : "radioDemo2",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "radioButtondemoMultiColumn",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/radioButton/demoMultiColumn/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/radioButton/demoMultiColumn/script.js"
                        }
                    ],
                    "moduleName": "material.components.radioButton",
                    "name"      : "demoMultiColumn",
                    "label"     : "Multi Column",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/radioButton/demoMultiColumn/index.html"
                    }
                }
            ],
            "url"       : "demo/radioButton"
        },
        {
            "name"      : "select",
            "moduleName": "material.components.select",
            "label"     : "Select",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "selectDemoBasic",
                        "module"      : "selectDemoBasic",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "selectdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/select/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/select/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.select",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/select/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "selectDemoOptGroups",
                        "module"      : "selectDemoOptGroups",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "selectdemoOptionGroups",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/select/demoOptionGroups/script.js"
                        }
                    ],
                    "moduleName": "material.components.select",
                    "name"      : "demoOptionGroups",
                    "label"     : "Option Groups",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/select/demoOptionGroups/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "selectDemoOptionsAsync",
                        "module"      : "selectDemoOptionsAsync",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "selectdemoOptionsWithAsyncSearch",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/select/demoOptionsWithAsyncSearch/script.js"
                        }
                    ],
                    "moduleName": "material.components.select",
                    "name"      : "demoOptionsWithAsyncSearch",
                    "label"     : "Options With Async Search",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/select/demoOptionsWithAsyncSearch/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "selectDemoValidation",
                        "module"      : "selectDemoValidation",
                        "dependencies": [
                            "ngMaterial",
                            "ngMessages"
                        ]
                    },
                    "id"        : "selectdemoValidations",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/select/demoValidations/script.js"
                        }
                    ],
                    "moduleName": "material.components.select",
                    "name"      : "demoValidations",
                    "label"     : "Validations",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/select/demoValidations/index.html"
                    }
                }
            ],
            "url"       : "demo/select"
        },
        {
            "name"      : "sidenav",
            "moduleName": "material.components.sidenav",
            "label"     : "Sidenav",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "sidenavDemo1",
                        "module"      : "sidenavDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "sidenavdemoBasicUsage",
                    "css"       : [],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/sidenav/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.sidenav",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/sidenav/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/sidenav"
        },
        {
            "name"      : "slider",
            "moduleName": "material.components.slider",
            "label"     : "Slider",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "sliderDemo1",
                        "module"      : "sliderDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "sliderdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/slider/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/slider/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.slider",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/slider/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/slider"
        },
        {
            "name"      : "subheader",
            "moduleName": "material.components.subheader",
            "label"     : "Subheader",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "subheaderBasicDemo",
                        "module"      : "subheaderBasicDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "subheaderdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/subheader/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/subheader/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.subheader",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/subheader/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/subheader"
        },
        {
            "name"      : "swipe",
            "moduleName": "material.components.swipe",
            "label"     : "Swipe",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "demoSwipe",
                        "module"      : "demoSwipe",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "swipedemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/swipe/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "readme.html",
                            "label"     : "readme.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/swipe/demoBasicUsage/readme.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/swipe/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.swipe",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/swipe/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/swipe"
        },
        {
            "name"      : "switch",
            "moduleName": "material.components.switch",
            "label"     : "Switch",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "switchDemo1",
                        "module"      : "switchDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "switchdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/switch/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/switch/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.switch",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/switch/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/switch"
        },
        {
            "name"      : "tabs",
            "moduleName": "material.components.tabs",
            "label"     : "Tabs",
            "demos"     : [
                {
                    "ngModule"  : "",
                    "id"        : "tabsdemoDynamicHeight",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/tabs/demoDynamicHeight/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "readme.html",
                            "label"     : "readme.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/tabs/demoDynamicHeight/readme.html"
                        }
                    ],
                    "js"        : [],
                    "moduleName": "material.components.tabs",
                    "name"      : "demoDynamicHeight",
                    "label"     : "Dynamic Height",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/tabs/demoDynamicHeight/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "tabsDemoDynamicTabs",
                        "module"      : "tabsDemoDynamicTabs",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "tabsdemoDynamicTabs",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/tabs/demoDynamicTabs/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "readme.html",
                            "label"     : "readme.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/tabs/demoDynamicTabs/readme.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/tabs/demoDynamicTabs/script.js"
                        }
                    ],
                    "moduleName": "material.components.tabs",
                    "name"      : "demoDynamicTabs",
                    "label"     : "Dynamic Tabs",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/tabs/demoDynamicTabs/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "tabsDemoStaticTabs",
                        "module"      : "tabsDemoStaticTabs",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "tabsdemoStaticTabs",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/tabs/demoStaticTabs/style.css"
                        }
                    ],
                    "html"      : [
                        {
                            "name"      : "readme.html",
                            "label"     : "readme.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/tabs/demoStaticTabs/readme.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/tabs/demoStaticTabs/script.js"
                        }
                    ],
                    "moduleName": "material.components.tabs",
                    "name"      : "demoStaticTabs",
                    "label"     : "Static Tabs",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/tabs/demoStaticTabs/index.html"
                    }
                }
            ],
            "url"       : "demo/tabs"
        },
        {
            "name"      : "toast",
            "moduleName": "material.components.toast",
            "label"     : "Toast",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "toastDemo1",
                        "module"      : "toastDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "toastdemoBasicUsage",
                    "css"       : [],
                    "html"      : [
                        {
                            "name"      : "toast-template.html",
                            "label"     : "toast-template.html",
                            "fileType"  : "html",
                            "outputPath": "demo-partials/toast/demoBasicUsage/toast-template.html"
                        }
                    ],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/toast/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.toast",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/toast/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/toast"
        },
        {
            "name"      : "toolbar",
            "moduleName": "material.components.toolbar",
            "label"     : "Toolbar",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "toolbarDemo1",
                        "module"      : "toolbarDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "toolbardemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/toolbar/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/toolbar/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.toolbar",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/toolbar/demoBasicUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "toolbarDemo2",
                        "module"      : "toolbarDemo2",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "toolbardemoScrollShrink",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/toolbar/demoScrollShrink/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/toolbar/demoScrollShrink/script.js"
                        }
                    ],
                    "moduleName": "material.components.toolbar",
                    "name"      : "demoScrollShrink",
                    "label"     : "Scroll Shrink",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/toolbar/demoScrollShrink/index.html"
                    }
                }
            ],
            "url"       : "demo/toolbar"
        },
        {
            "name"      : "tooltip",
            "moduleName": "material.components.tooltip",
            "label"     : "Tooltip",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "tooltipDemo1",
                        "module"      : "tooltipDemo1",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "tooltipdemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/tooltip/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/tooltip/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.tooltip",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/tooltip/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/tooltip"
        },
        {
            "name"      : "virtualRepeat",
            "moduleName": "material.components.virtualRepeat",
            "label"     : "Virtual Repeat",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "virtualRepeatDeferredLoadingDemo",
                        "module"      : "virtualRepeatDeferredLoadingDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "virtualRepeatdemoDeferredLoading",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/virtualRepeat/demoDeferredLoading/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/virtualRepeat/demoDeferredLoading/script.js"
                        }
                    ],
                    "moduleName": "material.components.virtualRepeat",
                    "name"      : "demoDeferredLoading",
                    "label"     : "Deferred Loading",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/virtualRepeat/demoDeferredLoading/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "virtualRepeatHorizontalDemo",
                        "module"      : "virtualRepeatHorizontalDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "virtualRepeatdemoHorizontalUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/virtualRepeat/demoHorizontalUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/virtualRepeat/demoHorizontalUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.virtualRepeat",
                    "name"      : "demoHorizontalUsage",
                    "label"     : "Horizontal Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/virtualRepeat/demoHorizontalUsage/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "virtualRepeatInfiniteScrollDemo",
                        "module"      : "virtualRepeatInfiniteScrollDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "virtualRepeatdemoInfiniteScroll",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/virtualRepeat/demoInfiniteScroll/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/virtualRepeat/demoInfiniteScroll/script.js"
                        }
                    ],
                    "moduleName": "material.components.virtualRepeat",
                    "name"      : "demoInfiniteScroll",
                    "label"     : "Infinite Scroll",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/virtualRepeat/demoInfiniteScroll/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "virtualRepeatScrollToDemo",
                        "module"      : "virtualRepeatScrollToDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "virtualRepeatdemoScrollTo",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/virtualRepeat/demoScrollTo/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/virtualRepeat/demoScrollTo/script.js"
                        }
                    ],
                    "moduleName": "material.components.virtualRepeat",
                    "name"      : "demoScrollTo",
                    "label"     : "Scroll To",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/virtualRepeat/demoScrollTo/index.html"
                    }
                },
                {
                    "ngModule"  : {
                        "name"        : "virtualRepeatVerticalDemo",
                        "module"      : "virtualRepeatVerticalDemo",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "virtualRepeatdemoVerticalUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/virtualRepeat/demoVerticalUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/virtualRepeat/demoVerticalUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.virtualRepeat",
                    "name"      : "demoVerticalUsage",
                    "label"     : "Vertical Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/virtualRepeat/demoVerticalUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/virtualRepeat"
        },
        {
            "name"      : "whiteframe",
            "moduleName": "material.components.whiteframe",
            "label"     : "Whiteframe",
            "demos"     : [
                {
                    "ngModule"  : {
                        "name"        : "whiteframeBasicUsage",
                        "module"      : "whiteframeBasicUsage",
                        "dependencies": [
                            "ngMaterial"
                        ]
                    },
                    "id"        : "whiteframedemoBasicUsage",
                    "css"       : [
                        {
                            "name"      : "style.css",
                            "label"     : "style.css",
                            "fileType"  : "css",
                            "outputPath": "demo-partials/whiteframe/demoBasicUsage/style.css"
                        }
                    ],
                    "html"      : [],
                    "js"        : [
                        {
                            "name"      : "script.js",
                            "label"     : "script.js",
                            "fileType"  : "js",
                            "outputPath": "demo-partials/whiteframe/demoBasicUsage/script.js"
                        }
                    ],
                    "moduleName": "material.components.whiteframe",
                    "name"      : "demoBasicUsage",
                    "label"     : "Basic Usage",
                    "index"     : {
                        "name"      : "index.html",
                        "label"     : "index.html",
                        "fileType"  : "html",
                        "outputPath": "demo-partials/whiteframe/demoBasicUsage/index.html"
                    }
                }
            ],
            "url"       : "demo/whiteframe"
        }
    ]);
angular.module('app.components.material-docs')
    .constant('COMPONENTS', [
        {
            "name"      : "material.components.autocomplete",
            "type"      : "module",
            "outputPath": "partials/api/material.components.autocomplete/index.html",
            "url"       : "api/material.components.autocomplete",
            "label"     : "material.components.autocomplete",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/autocomplete/autocomplete.js",
            "docs"      : [
                {
                    "name"      : "mdAutocomplete",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.autocomplete/directive/mdAutocomplete.html",
                    "url"       : "api/directive/mdAutocomplete",
                    "label"     : "mdAutocomplete",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/autocomplete/js/autocompleteDirective.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdHighlightText",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.autocomplete/directive/mdHighlightText.html",
                    "url"       : "api/directive/mdHighlightText",
                    "label"     : "mdHighlightText",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/autocomplete/js/highlightDirective.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.bottomSheet",
            "type"      : "module",
            "outputPath": "partials/api/material.components.bottomSheet/index.html",
            "url"       : "api/material.components.bottomSheet",
            "label"     : "material.components.bottomSheet",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/bottomSheet/bottom-sheet.js",
            "docs"      : [
                {
                    "name"      : "$mdBottomSheet",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.bottomSheet/service/$mdBottomSheet.html",
                    "url"       : "api/service/$mdBottomSheet",
                    "label"     : "$mdBottomSheet",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/bottomSheet/bottom-sheet.js",
                    "hasDemo"   : false
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.button",
            "type"      : "module",
            "outputPath": "partials/api/material.components.button/index.html",
            "url"       : "api/material.components.button",
            "label"     : "material.components.button",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/button/button.js",
            "docs"      : [
                {
                    "name"      : "mdButton",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.button/directive/mdButton.html",
                    "url"       : "api/directive/mdButton",
                    "label"     : "mdButton",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/button/button.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.card",
            "type"      : "module",
            "outputPath": "partials/api/material.components.card/index.html",
            "url"       : "api/material.components.card",
            "label"     : "material.components.card",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/card/card.js",
            "docs"      : [
                {
                    "name"      : "mdCard",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.card/directive/mdCard.html",
                    "url"       : "api/directive/mdCard",
                    "label"     : "mdCard",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/card/card.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.checkbox",
            "type"      : "module",
            "outputPath": "partials/api/material.components.checkbox/index.html",
            "url"       : "api/material.components.checkbox",
            "label"     : "material.components.checkbox",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/checkbox/checkbox.js",
            "docs"      : [
                {
                    "name"      : "mdCheckbox",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.checkbox/directive/mdCheckbox.html",
                    "url"       : "api/directive/mdCheckbox",
                    "label"     : "mdCheckbox",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/checkbox/checkbox.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.chips",
            "type"      : "module",
            "outputPath": "partials/api/material.components.chips/index.html",
            "url"       : "api/material.components.chips",
            "label"     : "material.components.chips",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/chips/chips.js",
            "docs"      : [
                {
                    "name"      : "mdChip",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.chips/directive/mdChip.html",
                    "url"       : "api/directive/mdChip",
                    "label"     : "mdChip",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/chips/js/chipDirective.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdChipRemove",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.chips/directive/mdChipRemove.html",
                    "url"       : "api/directive/mdChipRemove",
                    "label"     : "mdChipRemove",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/chips/js/chipRemoveDirective.js"
                },
                {
                    "name"      : "mdChips",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.chips/directive/mdChips.html",
                    "url"       : "api/directive/mdChips",
                    "label"     : "mdChips",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/chips/js/chipsDirective.js"
                },
                {
                    "name"      : "mdContactChips",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.chips/directive/mdContactChips.html",
                    "url"       : "api/directive/mdContactChips",
                    "label"     : "mdContactChips",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/chips/js/contactChipsDirective.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.content",
            "type"      : "module",
            "outputPath": "partials/api/material.components.content/index.html",
            "url"       : "api/material.components.content",
            "label"     : "material.components.content",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/content/content.js",
            "docs"      : [
                {
                    "name"      : "mdContent",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.content/directive/mdContent.html",
                    "url"       : "api/directive/mdContent",
                    "label"     : "mdContent",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/content/content.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.datepicker",
            "type"      : "module",
            "outputPath": "partials/api/material.components.datepicker/index.html",
            "url"       : "api/material.components.datepicker",
            "label"     : "material.components.datepicker",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/datepicker/calendar.js",
            "docs"      : [
                {
                    "name"      : "$mdDateLocaleProvider",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.datepicker/service/$mdDateLocaleProvider.html",
                    "url"       : "api/service/$mdDateLocaleProvider",
                    "label"     : "$mdDateLocaleProvider",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/datepicker/dateLocaleProvider.js",
                    "hasDemo"   : false
                },
                {
                    "name"      : "mdDatepicker",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.datepicker/directive/mdDatepicker.html",
                    "url"       : "api/directive/mdDatepicker",
                    "label"     : "mdDatepicker",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/datepicker/datePicker.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.dialog",
            "type"      : "module",
            "outputPath": "partials/api/material.components.dialog/index.html",
            "url"       : "api/material.components.dialog",
            "label"     : "material.components.dialog",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/dialog/dialog.js",
            "docs"      : [
                {
                    "name"      : "mdDialog",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.dialog/directive/mdDialog.html",
                    "url"       : "api/directive/mdDialog",
                    "label"     : "mdDialog",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/dialog/dialog.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "$mdDialog",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.dialog/service/$mdDialog.html",
                    "url"       : "api/service/$mdDialog",
                    "label"     : "$mdDialog",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/dialog/dialog.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.divider",
            "type"      : "module",
            "outputPath": "partials/api/material.components.divider/index.html",
            "url"       : "api/material.components.divider",
            "label"     : "material.components.divider",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/divider/divider.js",
            "docs"      : [
                {
                    "name"      : "mdDivider",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.divider/directive/mdDivider.html",
                    "url"       : "api/directive/mdDivider",
                    "label"     : "mdDivider",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/divider/divider.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.fabActions",
            "type"      : "module",
            "outputPath": "partials/api/material.components.fabActions/index.html",
            "url"       : "api/material.components.fabActions",
            "label"     : "material.components.fabActions",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabActions/fabActions.js",
            "docs"      : [
                {
                    "name"      : "mdFabActions",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.fabActions/directive/mdFabActions.html",
                    "url"       : "api/directive/mdFabActions",
                    "label"     : "mdFabActions",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabActions/fabActions.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.fabSpeedDial",
            "type"      : "module",
            "outputPath": "partials/api/material.components.fabSpeedDial/index.html",
            "url"       : "api/material.components.fabSpeedDial",
            "label"     : "material.components.fabSpeedDial",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabSpeedDial/fabSpeedDial.js",
            "docs"      : [
                {
                    "name"      : "mdFabSpeedDial",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.fabSpeedDial/directive/mdFabSpeedDial.html",
                    "url"       : "api/directive/mdFabSpeedDial",
                    "label"     : "mdFabSpeedDial",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabSpeedDial/fabSpeedDial.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdFabTrigger",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.fabSpeedDial/directive/mdFabTrigger.html",
                    "url"       : "api/directive/mdFabTrigger",
                    "label"     : "mdFabTrigger",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabTrigger/fabTrigger.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.fabToolbar",
            "type"      : "module",
            "outputPath": "partials/api/material.components.fabToolbar/index.html",
            "url"       : "api/material.components.fabToolbar",
            "label"     : "material.components.fabToolbar",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabToolbar/fabToolbar.js",
            "docs"      : [
                {
                    "name"      : "mdFabToolbar",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.fabToolbar/directive/mdFabToolbar.html",
                    "url"       : "api/directive/mdFabToolbar",
                    "label"     : "mdFabToolbar",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/fabToolbar/fabToolbar.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.gridList",
            "type"      : "module",
            "outputPath": "partials/api/material.components.gridList/index.html",
            "url"       : "api/material.components.gridList",
            "label"     : "material.components.gridList",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js",
            "docs"      : [
                {
                    "name"      : "mdGridList",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.gridList/directive/mdGridList.html",
                    "url"       : "api/directive/mdGridList",
                    "label"     : "mdGridList",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdGridTile",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.gridList/directive/mdGridTile.html",
                    "url"       : "api/directive/mdGridTile",
                    "label"     : "mdGridTile",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.icon",
            "type"      : "module",
            "outputPath": "partials/api/material.components.icon/index.html",
            "url"       : "api/material.components.icon",
            "label"     : "material.components.icon",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/icon/icon.js",
            "docs"      : [
                {
                    "name"      : "mdIcon",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.icon/directive/mdIcon.html",
                    "url"       : "api/directive/mdIcon",
                    "label"     : "mdIcon",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/icon/js/iconDirective.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "$mdIconProvider",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.icon/service/$mdIconProvider.html",
                    "url"       : "api/service/$mdIconProvider",
                    "label"     : "$mdIconProvider",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/icon/js/iconService.js"
                },
                {
                    "name"      : "$mdIcon",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.icon/service/$mdIcon.html",
                    "url"       : "api/service/$mdIcon",
                    "label"     : "$mdIcon",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/icon/js/iconService.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.input",
            "type"      : "module",
            "outputPath": "partials/api/material.components.input/index.html",
            "url"       : "api/material.components.input",
            "label"     : "material.components.input",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/input/input.js",
            "docs"      : [
                {
                    "name"      : "mdInputContainer",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.input/directive/mdInputContainer.html",
                    "url"       : "api/directive/mdInputContainer",
                    "label"     : "mdInputContainer",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/input/input.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdInput",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.input/directive/mdInput.html",
                    "url"       : "api/directive/mdInput",
                    "label"     : "mdInput",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/input/input.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.list",
            "type"      : "module",
            "outputPath": "partials/api/material.components.list/index.html",
            "url"       : "api/material.components.list",
            "label"     : "material.components.list",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/list/list.js",
            "docs"      : [
                {
                    "name"      : "mdList",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.list/directive/mdList.html",
                    "url"       : "api/directive/mdList",
                    "label"     : "mdList",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/list/list.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdListItem",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.list/directive/mdListItem.html",
                    "url"       : "api/directive/mdListItem",
                    "label"     : "mdListItem",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/list/list.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.menu",
            "type"      : "module",
            "outputPath": "partials/api/material.components.menu/index.html",
            "url"       : "api/material.components.menu",
            "label"     : "material.components.menu",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/menu/menu.js",
            "docs"      : [
                {
                    "name"      : "mdMenu",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.menu/directive/mdMenu.html",
                    "url"       : "api/directive/mdMenu",
                    "label"     : "mdMenu",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/menu/js/menuDirective.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.menu-bar",
            "type"      : "module",
            "outputPath": "partials/api/material.components.menu-bar/index.html",
            "url"       : "api/material.components.menu-bar",
            "label"     : "material.components.menu-bar",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/menuBar/menu-bar.js",
            "docs"      : [
                {
                    "name"      : "mdMenuBar",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.menu-bar/directive/mdMenuBar.html",
                    "url"       : "api/directive/mdMenuBar",
                    "label"     : "mdMenuBar",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/menuBar/js/menuBarDirective.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.progressCircular",
            "type"      : "module",
            "outputPath": "partials/api/material.components.progressCircular/index.html",
            "url"       : "api/material.components.progressCircular",
            "label"     : "material.components.progressCircular",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/progressCircular/progress-circular.js",
            "docs"      : [
                {
                    "name"      : "mdProgressCircular",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.progressCircular/directive/mdProgressCircular.html",
                    "url"       : "api/directive/mdProgressCircular",
                    "label"     : "mdProgressCircular",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/progressCircular/progress-circular.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.progressLinear",
            "type"      : "module",
            "outputPath": "partials/api/material.components.progressLinear/index.html",
            "url"       : "api/material.components.progressLinear",
            "label"     : "material.components.progressLinear",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/progressLinear/progress-linear.js",
            "docs"      : [
                {
                    "name"      : "mdProgressLinear",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.progressLinear/directive/mdProgressLinear.html",
                    "url"       : "api/directive/mdProgressLinear",
                    "label"     : "mdProgressLinear",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/progressLinear/progress-linear.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.radioButton",
            "type"      : "module",
            "outputPath": "partials/api/material.components.radioButton/index.html",
            "url"       : "api/material.components.radioButton",
            "label"     : "material.components.radioButton",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js",
            "docs"      : [
                {
                    "name"      : "mdRadioGroup",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.radioButton/directive/mdRadioGroup.html",
                    "url"       : "api/directive/mdRadioGroup",
                    "label"     : "mdRadioGroup",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdRadioButton",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.radioButton/directive/mdRadioButton.html",
                    "url"       : "api/directive/mdRadioButton",
                    "label"     : "mdRadioButton",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.select",
            "type"      : "module",
            "outputPath": "partials/api/material.components.select/index.html",
            "url"       : "api/material.components.select",
            "label"     : "material.components.select",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/select/select.js",
            "docs"      : [
                {
                    "name"      : "mdSelect",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.select/directive/mdSelect.html",
                    "url"       : "api/directive/mdSelect",
                    "label"     : "mdSelect",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/select/select.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.sidenav",
            "type"      : "module",
            "outputPath": "partials/api/material.components.sidenav/index.html",
            "url"       : "api/material.components.sidenav",
            "label"     : "material.components.sidenav",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js",
            "docs"      : [
                {
                    "name"      : "$mdSidenav",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.sidenav/service/$mdSidenav.html",
                    "url"       : "api/service/$mdSidenav",
                    "label"     : "$mdSidenav",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js",
                    "hasDemo"   : false
                },
                {
                    "name"      : "mdSidenavFocus",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.sidenav/directive/mdSidenavFocus.html",
                    "url"       : "api/directive/mdSidenavFocus",
                    "label"     : "mdSidenavFocus",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js"
                },
                {
                    "name"      : "mdSidenav",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.sidenav/directive/mdSidenav.html",
                    "url"       : "api/directive/mdSidenav",
                    "label"     : "mdSidenav",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.slider",
            "type"      : "module",
            "outputPath": "partials/api/material.components.slider/index.html",
            "url"       : "api/material.components.slider",
            "label"     : "material.components.slider",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/slider/slider.js",
            "docs"      : [
                {
                    "name"      : "mdSlider",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.slider/directive/mdSlider.html",
                    "url"       : "api/directive/mdSlider",
                    "label"     : "mdSlider",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/slider/slider.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.sticky",
            "type"      : "module",
            "outputPath": "partials/api/material.components.sticky/index.html",
            "url"       : "api/material.components.sticky",
            "label"     : "material.components.sticky",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sticky/sticky.js",
            "docs"      : [
                {
                    "name"      : "$mdSticky",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.sticky/service/$mdSticky.html",
                    "url"       : "api/service/$mdSticky",
                    "label"     : "$mdSticky",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/sticky/sticky.js",
                    "hasDemo"   : false
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.subheader",
            "type"      : "module",
            "outputPath": "partials/api/material.components.subheader/index.html",
            "url"       : "api/material.components.subheader",
            "label"     : "material.components.subheader",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/subheader/subheader.js",
            "docs"      : [
                {
                    "name"      : "mdSubheader",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.subheader/directive/mdSubheader.html",
                    "url"       : "api/directive/mdSubheader",
                    "label"     : "mdSubheader",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/subheader/subheader.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.swipe",
            "type"      : "module",
            "outputPath": "partials/api/material.components.swipe/index.html",
            "url"       : "api/material.components.swipe",
            "label"     : "material.components.swipe",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/swipe/swipe.js",
            "docs"      : [
                {
                    "name"      : "mdSwipeLeft",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.swipe/directive/mdSwipeLeft.html",
                    "url"       : "api/directive/mdSwipeLeft",
                    "label"     : "mdSwipeLeft",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/swipe/swipe.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdSwipeRight",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.swipe/directive/mdSwipeRight.html",
                    "url"       : "api/directive/mdSwipeRight",
                    "label"     : "mdSwipeRight",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/swipe/swipe.js"
                },
                {
                    "name"      : "mdSwipeUp",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.swipe/directive/mdSwipeUp.html",
                    "url"       : "api/directive/mdSwipeUp",
                    "label"     : "mdSwipeUp",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/swipe/swipe.js"
                },
                {
                    "name"      : "mdSwipeDown",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.swipe/directive/mdSwipeDown.html",
                    "url"       : "api/directive/mdSwipeDown",
                    "label"     : "mdSwipeDown",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/swipe/swipe.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.switch",
            "type"      : "module",
            "outputPath": "partials/api/material.components.switch/index.html",
            "url"       : "api/material.components.switch",
            "label"     : "material.components.switch",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/switch/switch.js",
            "docs"      : [
                {
                    "name"      : "mdSwitch",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.switch/directive/mdSwitch.html",
                    "url"       : "api/directive/mdSwitch",
                    "label"     : "mdSwitch",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/switch/switch.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.tabs",
            "type"      : "module",
            "outputPath": "partials/api/material.components.tabs/index.html",
            "url"       : "api/material.components.tabs",
            "label"     : "material.components.tabs",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/tabs/tabs.js",
            "docs"      : [
                {
                    "name"      : "mdTab",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.tabs/directive/mdTab.html",
                    "url"       : "api/directive/mdTab",
                    "label"     : "mdTab",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/tabs/js/tabDirective.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdTabs",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.tabs/directive/mdTabs.html",
                    "url"       : "api/directive/mdTabs",
                    "label"     : "mdTabs",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/tabs/js/tabsDirective.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.toast",
            "type"      : "module",
            "outputPath": "partials/api/material.components.toast/index.html",
            "url"       : "api/material.components.toast",
            "label"     : "material.components.toast",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/toast/toast.js",
            "docs"      : [
                {
                    "name"      : "$mdToast",
                    "type"      : "service",
                    "outputPath": "partials/api/material.components.toast/service/$mdToast.html",
                    "url"       : "api/service/$mdToast",
                    "label"     : "$mdToast",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/toast/toast.js",
                    "hasDemo"   : false
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.toolbar",
            "type"      : "module",
            "outputPath": "partials/api/material.components.toolbar/index.html",
            "url"       : "api/material.components.toolbar",
            "label"     : "material.components.toolbar",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/toolbar/toolbar.js",
            "docs"      : [
                {
                    "name"      : "mdToolbar",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.toolbar/directive/mdToolbar.html",
                    "url"       : "api/directive/mdToolbar",
                    "label"     : "mdToolbar",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/toolbar/toolbar.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.tooltip",
            "type"      : "module",
            "outputPath": "partials/api/material.components.tooltip/index.html",
            "url"       : "api/material.components.tooltip",
            "label"     : "material.components.tooltip",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/tooltip/tooltip.js",
            "docs"      : [
                {
                    "name"      : "mdTooltip",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.tooltip/directive/mdTooltip.html",
                    "url"       : "api/directive/mdTooltip",
                    "label"     : "mdTooltip",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/tooltip/tooltip.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.components.virtualRepeat",
            "type"      : "module",
            "outputPath": "partials/api/material.components.virtualRepeat/index.html",
            "url"       : "api/material.components.virtualRepeat",
            "label"     : "material.components.virtualRepeat",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js",
            "docs"      : [
                {
                    "name"      : "mdVirtualRepeatContainer",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.virtualRepeat/directive/mdVirtualRepeatContainer.html",
                    "url"       : "api/directive/mdVirtualRepeatContainer",
                    "label"     : "mdVirtualRepeatContainer",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "mdVirtualRepeat",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.components.virtualRepeat/directive/mdVirtualRepeat.html",
                    "url"       : "api/directive/mdVirtualRepeat",
                    "label"     : "mdVirtualRepeat",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.core.ripple",
            "type"      : "module",
            "outputPath": "partials/api/material.core.ripple/index.html",
            "url"       : "api/material.core.ripple",
            "label"     : "material.core.ripple",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/l/src/core/services/ripple/ripple.js",
            "docs"      : [
                {
                    "name"      : "mdInkRipple",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.core.ripple/directive/mdInkRipple.html",
                    "url"       : "api/directive/mdInkRipple",
                    "label"     : "mdInkRipple",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/l/src/core/services/ripple/ripple.js",
                    "hasDemo"   : true
                },
                {
                    "name"      : "$mdInkRipple",
                    "type"      : "service",
                    "outputPath": "partials/api/material.core.ripple/service/$mdInkRipple.html",
                    "url"       : "api/service/$mdInkRipple",
                    "label"     : "$mdInkRipple",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/l/src/core/services/ripple/ripple.js"
                }
            ],
            "hasDemo"   : false
        },
        {
            "name"      : "material.core.util",
            "type"      : "module",
            "outputPath": "partials/api/material.core.util/index.html",
            "url"       : "api/material.core.util",
            "label"     : "material.core.util",
            "module"    : "material.components",
            "githubUrl" : "https://github.com/angular/material/blob/master/src/components/l/src/core/util/util.js",
            "docs"      : [
                {
                    "name"      : "mdAutofocus",
                    "type"      : "directive",
                    "outputPath": "partials/api/material.core.util/directive/mdAutofocus.html",
                    "url"       : "api/directive/mdAutofocus",
                    "label"     : "mdAutofocus",
                    "module"    : "material.components",
                    "githubUrl" : "https://github.com/angular/material/blob/master/src/components/l/src/core/util/util.js",
                    "hasDemo"   : true
                }
            ],
            "hasDemo"   : false
        }
    ]);

(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_nvd3', {
            url  : '/components/charts/nvd3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/nvd3/nvd3.html',
                    controller : 'Nvd3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3')
        .controller('Nvd3Controller', Nvd3Controller);

    function Nvd3Controller(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.lineChart = {
            options: {
                chart   : {
                    type                   : 'lineChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 40,
                        left  : 55
                    },
                    x                      : function (d)
                    {
                        return d.x;
                    },
                    y                      : function (d)
                    {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        axisLabel: 'Time (ms)'
                    },
                    yAxis                  : {
                        axisLabel        : 'Voltage (v)',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                },
                title   : {
                    enable: true,
                    text  : 'Title for Line Chart'
                },
                subtitle: {
                    enable: true,
                    text  : 'Subtitle for simple line chart. Lorem ipsum dolor sit amet, at eam blandit sadipscing, vim adhuc sanctus disputando ex, cu usu affert alienum urbanitas.',
                    css   : {
                        'text-align': 'center',
                        'margin'    : '10px 13px 0px 7px'
                    }
                },
                caption : {
                    enable: true,
                    html  : '<b>Figure 1.</b> Lorem ipsum dolor sit amet, at eam blandit sadipscing, <span style="text-decoration: underline;">vim adhuc sanctus disputando ex</span>, cu usu affert alienum urbanitas. <i>Cum in purto erat, mea ne nominavi persecuti reformidans.</i> Docendi blandit abhorreant ea has, minim tantas alterum pro eu. <span style="color: darkred;">Exerci graeci ad vix, elit tacimates ea duo</span>. Id mel eruditi fuisset. Stet vidit patrioque in pro, eum ex veri verterem abhorreant, id unum oportere intellegam nec<sup>[1, <a href="https://github.com/krispo/angular-nvd3" target="_blank">2</a>, 3]</sup>.',
                    css   : {
                        'text-align': 'justify',
                        'margin'    : '10px 13px 0px 7px'
                    }
                }
            },
            data   : sinAndCos()
        };

        vm.stackedAreaChart = {
            options: {
                chart: {
                    type                   : 'stackedAreaChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 40
                    },
                    x                      : function (d)
                    {
                        return d[0];
                    },
                    y                      : function (d)
                    {
                        return d[1];
                    },
                    useVoronoi             : false,
                    clipEdge               : true,
                    transitionDuration     : 500,
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        showMaxMin: false,
                        tickFormat: function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        }
                    },
                    yAxis                  : {
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'North America',
                    'values': [[1025409600000, 23.041422681023], [1028088000000, 19.854291255832], [1030766400000, 21.02286281168], [1033358400000, 22.093608385173], [1036040400000, 25.108079299458], [1038632400000, 26.982389242348], [1041310800000, 19.828984957662], [1043989200000, 19.914055036294], [1046408400000, 19.436150539916], [1049086800000, 21.558650338602], [1051675200000, 24.395594061773], [1054353600000, 24.747089309384], [1056945600000, 23.491755498807], [1059624000000, 23.376634878164], [1062302400000, 24.581223154533], [1064894400000, 24.922476843538], [1067576400000, 27.357712939042], [1070168400000, 26.503020572593], [1072846800000, 26.658901244878], [1075525200000, 27.065704156445], [1078030800000, 28.735320452588], [1080709200000, 31.572277846319], [1083297600000, 30.932161503638], [1085976000000, 31.627029785554], [1088568000000, 28.728743674232], [1091246400000, 26.858365172675], [1093924800000, 27.279922830032], [1096516800000, 34.408301211324], [1099195200000, 34.794362930439], [1101790800000, 35.609978198951], [1104469200000, 33.574394968037], [1107147600000, 31.979405070598], [1109566800000, 31.19009040297], [1112245200000, 31.083933968994], [1114833600000, 29.668971113185], [1117512000000, 31.490638014379], [1120104000000, 31.818617451128], [1122782400000, 32.960314008183], [1125460800000, 31.313383196209], [1128052800000, 33.125486081852], [1130734800000, 32.791805509149], [1133326800000, 33.506038030366], [1136005200000, 26.96501697216], [1138683600000, 27.38478809681], [1141102800000, 27.371377218209], [1143781200000, 26.309915460827], [1146369600000, 26.425199957518], [1149048000000, 26.823411519396], [1151640000000, 23.850443591587], [1154318400000, 23.158355444054], [1156996800000, 22.998689393695], [1159588800000, 27.9771285113], [1162270800000, 29.073672469719], [1164862800000, 28.587640408904], [1167541200000, 22.788453687637], [1170219600000, 22.429199073597], [1172638800000, 22.324103271052], [1175313600000, 17.558388444187], [1177905600000, 16.769518096208], [1180584000000, 16.214738201301], [1183176000000, 18.729632971229], [1185854400000, 18.814523318847], [1188532800000, 19.789986451358], [1191124800000, 17.070049054933], [1193803200000, 16.121349575716], [1196398800000, 15.141659430091], [1199077200000, 17.175388025297], [1201755600000, 17.286592443522], [1204261200000, 16.323141626568], [1206936000000, 19.231263773952], [1209528000000, 18.446256391095], [1212206400000, 17.822632399764], [1214798400000, 15.53936647598], [1217476800000, 15.255131790217], [1220155200000, 15.660963922592], [1222747200000, 13.254482273698], [1225425600000, 11.920796202299], [1228021200000, 12.122809090924], [1230699600000, 15.691026271393], [1233378000000, 14.720881635107], [1235797200000, 15.387939360044], [1238472000000, 13.765436672228], [1241064000000, 14.631445864799], [1243742400000, 14.292446536221], [1246334400000, 16.170071367017], [1249012800000, 15.948135554337], [1251691200000, 16.612872685134], [1254283200000, 18.778338719091], [1256961600000, 16.756026065421], [1259557200000, 19.385804443146], [1262235600000, 22.950590240168], [1264914000000, 23.61159018141], [1267333200000, 25.708586989581], [1270008000000, 26.883915999885], [1272600000000, 25.893486687065], [1275278400000, 24.678914263176], [1277870400000, 25.937275793024], [1280548800000, 29.461381693838], [1283227200000, 27.357322961861], [1285819200000, 29.057235285673], [1288497600000, 28.549434189386], [1291093200000, 28.506352379724], [1293771600000, 29.449241421598], [1296450000000, 25.796838168807], [1298869200000, 28.740145449188], [1301544000000, 22.091744141872], [1304136000000, 25.07966254541], [1306814400000, 23.674906973064], [1309406400000, 23.418002742929], [1312084800000, 23.24364413887], [1314763200000, 31.591854066817], [1317355200000, 31.497112374114], [1320033600000, 26.67238082043], [1322629200000, 27.297080015495], [1325307600000, 20.174315530051], [1327986000000, 19.631084213898], [1330491600000, 20.366462219461], [1333166400000, 19.284784434185], [1335758400000, 19.157810257624]]
                },

                {
                    'key'   : 'Africa',
                    'values': [[1025409600000, 7.9356392949025], [1028088000000, 7.4514668527298], [1030766400000, 7.9085410566608], [1033358400000, 5.8996782364764], [1036040400000, 6.0591869346923], [1038632400000, 5.9667815800451], [1041310800000, 8.65528925664], [1043989200000, 8.7690763386254], [1046408400000, 8.6386160387453], [1049086800000, 5.9895557449743], [1051675200000, 6.3840324338159], [1054353600000, 6.5196511461441], [1056945600000, 7.0738618553114], [1059624000000, 6.5745957367133], [1062302400000, 6.4658359184444], [1064894400000, 2.7622758754954], [1067576400000, 2.9794782986241], [1070168400000, 2.8735432712019], [1072846800000, 1.6344817513645], [1075525200000, 1.5869248754883], [1078030800000, 1.7172279157246], [1080709200000, 1.9649927409867], [1083297600000, 2.0261695079196], [1085976000000, 2.0541261923929], [1088568000000, 3.9466318927569], [1091246400000, 3.7826770946089], [1093924800000, 3.9543021004028], [1096516800000, 3.8309891064711], [1099195200000, 3.6340958946166], [1101790800000, 3.5289755762525], [1104469200000, 5.702378559857], [1107147600000, 5.6539569019223], [1109566800000, 5.5449506370392], [1112245200000, 4.7579993280677], [1114833600000, 4.4816139372906], [1117512000000, 4.5965558568606], [1120104000000, 4.3747066116976], [1122782400000, 4.4588822917087], [1125460800000, 4.4460351848286], [1128052800000, 3.7989113035136], [1130734800000, 3.7743883140088], [1133326800000, 3.7727852823828], [1136005200000, 7.2968111448895], [1138683600000, 7.2800122043237], [1141102800000, 7.1187787503354], [1143781200000, 8.351887016482], [1146369600000, 8.4156698763993], [1149048000000, 8.1673298604231], [1151640000000, 5.5132447126042], [1154318400000, 6.1152537710599], [1156996800000, 6.076765091942], [1159588800000, 4.6304473798646], [1162270800000, 4.6301068469402], [1164862800000, 4.3466656309389], [1167541200000, 6.830104897003], [1170219600000, 7.241633040029], [1172638800000, 7.1432372054153], [1175313600000, 10.608942063374], [1177905600000, 10.914964549494], [1180584000000, 10.933223880565], [1183176000000, 8.3457524851265], [1185854400000, 8.1078413081882], [1188532800000, 8.2697185922474], [1191124800000, 8.4742436475968], [1193803200000, 8.4994601179319], [1196398800000, 8.7387319683243], [1199077200000, 6.8829183612895], [1201755600000, 6.984133637885], [1204261200000, 7.0860136043287], [1206936000000, 4.3961787956053], [1209528000000, 3.8699674365231], [1212206400000, 3.6928925238305], [1214798400000, 6.7571718894253], [1217476800000, 6.4367313362344], [1220155200000, 6.4048441521454], [1222747200000, 5.4643833239669], [1225425600000, 5.3150786833374], [1228021200000, 5.3011272612576], [1230699600000, 4.1203601430809], [1233378000000, 4.0881783200525], [1235797200000, 4.1928665957189], [1238472000000, 7.0249415663205], [1241064000000, 7.006530880769], [1243742400000, 6.994835633224], [1246334400000, 6.1220222336254], [1249012800000, 6.1177436137653], [1251691200000, 6.1413396231981], [1254283200000, 4.8046006145874], [1256961600000, 4.6647600660544], [1259557200000, 4.544865006255], [1262235600000, 6.0488249316539], [1264914000000, 6.3188669540206], [1267333200000, 6.5873958262306], [1270008000000, 6.2281189839578], [1272600000000, 5.8948915746059], [1275278400000, 5.5967320482214], [1277870400000, 0.99784432084837], [1280548800000, 1.0950794175359], [1283227200000, 0.94479734407491], [1285819200000, 1.222093988688], [1288497600000, 1.335093106856], [1291093200000, 1.3302565104985], [1293771600000, 1.340824670897], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 4.4583692315], [1320033600000, 3.6493043348059], [1322629200000, 3.8610064091761], [1325307600000, 5.5144800685202], [1327986000000, 5.1750695220791], [1330491600000, 5.6710066952691], [1333166400000, 5.5611890039181], [1335758400000, 5.5979368839939]]
                },

                {
                    'key'   : 'South America',
                    'values': [[1025409600000, 7.9149900245423], [1028088000000, 7.0899888751059], [1030766400000, 7.5996132380614], [1033358400000, 8.2741174301034], [1036040400000, 9.3564460833513], [1038632400000, 9.7066786059904], [1041310800000, 10.213363052343], [1043989200000, 10.285809585273], [1046408400000, 10.222053149228], [1049086800000, 8.6188592137975], [1051675200000, 9.3335447543566], [1054353600000, 8.9312402186628], [1056945600000, 8.1895089343658], [1059624000000, 8.260622135079], [1062302400000, 7.7700786851364], [1064894400000, 7.9907428771318], [1067576400000, 8.7769091865606], [1070168400000, 8.4855077060661], [1072846800000, 9.6277203033655], [1075525200000, 9.9685913452624], [1078030800000, 10.615085181759], [1080709200000, 9.2902488079646], [1083297600000, 8.8610439830061], [1085976000000, 9.1075344931229], [1088568000000, 9.9156737639203], [1091246400000, 9.7826003238782], [1093924800000, 10.55403610555], [1096516800000, 10.926900264097], [1099195200000, 10.903144818736], [1101790800000, 10.862890389067], [1104469200000, 10.64604998964], [1107147600000, 10.042790814087], [1109566800000, 9.7173391591038], [1112245200000, 9.6122415755443], [1114833600000, 9.4337921146562], [1117512000000, 9.814827171183], [1120104000000, 12.059260396788], [1122782400000, 12.139649903873], [1125460800000, 12.281290663822], [1128052800000, 8.8037085409056], [1130734800000, 8.6300618239176], [1133326800000, 9.1225708491432], [1136005200000, 12.988124170836], [1138683600000, 13.356778764353], [1141102800000, 13.611196863271], [1143781200000, 6.8959030061189], [1146369600000, 6.9939633271353], [1149048000000, 6.7241510257676], [1151640000000, 5.5611293669517], [1154318400000, 5.6086488714041], [1156996800000, 5.4962849907033], [1159588800000, 6.9193153169278], [1162270800000, 7.0016334389778], [1164862800000, 6.7865422443273], [1167541200000, 9.0006454225383], [1170219600000, 9.2233916171431], [1172638800000, 8.8929316009479], [1175313600000, 10.345937520404], [1177905600000, 10.075914677026], [1180584000000, 10.089006188111], [1183176000000, 10.598330295008], [1185854400000, 9.9689546533009], [1188532800000, 9.7740580198146], [1191124800000, 10.558483060626], [1193803200000, 9.9314651823603], [1196398800000, 9.3997715873769], [1199077200000, 8.4086493387262], [1201755600000, 8.9698309085926], [1204261200000, 8.2778357995396], [1206936000000, 8.8585045600123], [1209528000000, 8.7013756413322], [1212206400000, 7.7933605469443], [1214798400000, 7.0236183483064], [1217476800000, 6.9873088186829], [1220155200000, 6.8031713070097], [1222747200000, 6.6869531315723], [1225425600000, 6.138256993963], [1228021200000, 5.6434994016354], [1230699600000, 5.495220262512], [1233378000000, 4.6885326869846], [1235797200000, 4.4524349883438], [1238472000000, 5.6766520778185], [1241064000000, 5.7675774480752], [1243742400000, 5.7882863168337], [1246334400000, 7.2666010034924], [1249012800000, 7.5191821322261], [1251691200000, 7.849651451445], [1254283200000, 10.383992037985], [1256961600000, 9.0653691861818], [1259557200000, 9.6705248324159], [1262235600000, 10.856380561349], [1264914000000, 11.27452370892], [1267333200000, 11.754156529088], [1270008000000, 8.2870811422455], [1272600000000, 8.0210264360699], [1275278400000, 7.5375074474865], [1277870400000, 8.3419527338039], [1280548800000, 9.4197471818443], [1283227200000, 8.7321733185797], [1285819200000, 9.6627062648126], [1288497600000, 10.187962234548], [1291093200000, 9.8144201733476], [1293771600000, 10.275723361712], [1296450000000, 16.796066079353], [1298869200000, 17.543254984075], [1301544000000, 16.673660675083], [1304136000000, 17.963944353609], [1306814400000, 16.63774086721], [1309406400000, 15.84857094609], [1312084800000, 14.767303362181], [1314763200000, 24.778452182433], [1317355200000, 18.370353229999], [1320033600000, 15.253137429099], [1322629200000, 14.989600840649], [1325307600000, 16.052539160125], [1327986000000, 16.424390322793], [1330491600000, 17.884020741104], [1333166400000, 18.372698836036], [1335758400000, 18.315881576096]]
                },

                {
                    'key'   : 'Asia',
                    'values': [[1025409600000, 13.153938631352], [1028088000000, 12.456410521864], [1030766400000, 12.537048663919], [1033358400000, 13.947386398309], [1036040400000, 14.421680682568], [1038632400000, 14.143238262286], [1041310800000, 12.229635347478], [1043989200000, 12.508479916948], [1046408400000, 12.155368409526], [1049086800000, 13.335455563994], [1051675200000, 12.888210138167], [1054353600000, 12.842092790511], [1056945600000, 12.513816474199], [1059624000000, 12.21453674494], [1062302400000, 11.750848343935], [1064894400000, 10.526579636787], [1067576400000, 10.873596086087], [1070168400000, 11.019967131519], [1072846800000, 11.235789380602], [1075525200000, 11.859910850657], [1078030800000, 12.531031616536], [1080709200000, 11.360451067019], [1083297600000, 11.456244780202], [1085976000000, 11.436991407309], [1088568000000, 11.638595744327], [1091246400000, 11.190418301469], [1093924800000, 11.835608007589], [1096516800000, 11.540980244475], [1099195200000, 10.958762325687], [1101790800000, 10.885791159509], [1104469200000, 13.605810720109], [1107147600000, 13.128978067437], [1109566800000, 13.119012086882], [1112245200000, 13.003706129783], [1114833600000, 13.326996807689], [1117512000000, 13.547947991743], [1120104000000, 12.807959646616], [1122782400000, 12.931763821068], [1125460800000, 12.795359993008], [1128052800000, 9.6998935538319], [1130734800000, 9.3473740089131], [1133326800000, 9.36902067716], [1136005200000, 14.258619539875], [1138683600000, 14.21241095603], [1141102800000, 13.973193618249], [1143781200000, 15.218233920664], [1146369600000, 14.382109727451], [1149048000000, 13.894310878491], [1151640000000, 15.593086090031], [1154318400000, 16.244839695189], [1156996800000, 16.017088850647], [1159588800000, 14.183951830057], [1162270800000, 14.148523245696], [1164862800000, 13.424326059971], [1167541200000, 12.974450435754], [1170219600000, 13.232470418021], [1172638800000, 13.318762655574], [1175313600000, 15.961407746104], [1177905600000, 16.287714639805], [1180584000000, 16.24659058389], [1183176000000, 17.564505594808], [1185854400000, 17.872725373164], [1188532800000, 18.018998508756], [1191124800000, 15.584518016602], [1193803200000, 15.480850647182], [1196398800000, 15.699120036985], [1199077200000, 19.184281817226], [1201755600000, 19.691226605205], [1204261200000, 18.982314051293], [1206936000000, 18.707820309008], [1209528000000, 17.459630929759], [1212206400000, 16.500616076782], [1214798400000, 18.086324003978], [1217476800000, 18.929464156259], [1220155200000, 18.233728682084], [1222747200000, 16.315776297325], [1225425600000, 14.632892190251], [1228021200000, 14.667835024479], [1230699600000, 13.946993947309], [1233378000000, 14.394304684398], [1235797200000, 13.724462792967], [1238472000000, 10.930879035807], [1241064000000, 9.8339915513708], [1243742400000, 10.053858541872], [1246334400000, 11.786998438286], [1249012800000, 11.780994901769], [1251691200000, 11.305889670277], [1254283200000, 10.918452290083], [1256961600000, 9.6811395055706], [1259557200000, 10.971529744038], [1262235600000, 13.330210480209], [1264914000000, 14.592637568961], [1267333200000, 14.605329141157], [1270008000000, 13.936853794037], [1272600000000, 12.189480759072], [1275278400000, 11.676151385046], [1277870400000, 13.058852800018], [1280548800000, 13.62891543203], [1283227200000, 13.811107569918], [1285819200000, 13.786494560786], [1288497600000, 14.045162857531], [1291093200000, 13.697412447286], [1293771600000, 13.677681376221], [1296450000000, 19.96151186453], [1298869200000, 21.049198298156], [1301544000000, 22.687631094009], [1304136000000, 25.469010617433], [1306814400000, 24.88379943712], [1309406400000, 24.203843814249], [1312084800000, 22.138760964036], [1314763200000, 16.034636966228], [1317355200000, 15.394958944555], [1320033600000, 12.62564246197], [1322629200000, 12.973735699739], [1325307600000, 15.78601833615], [1327986000000, 15.227368020134], [1330491600000, 15.899752650733], [1333166400000, 15.661317319168], [1335758400000, 15.359891177281]]
                },

                {
                    'key'   : 'Europe',
                    'values': [[1025409600000, 9.3433263069351], [1028088000000, 8.4583069475546], [1030766400000, 8.0342398154196], [1033358400000, 8.1538966876572], [1036040400000, 10.743604786849], [1038632400000, 12.349366155851], [1041310800000, 10.742682503899], [1043989200000, 11.360983869935], [1046408400000, 11.441336039535], [1049086800000, 10.897508791837], [1051675200000, 11.469101547709], [1054353600000, 12.086311476742], [1056945600000, 8.0697180773504], [1059624000000, 8.2004392233445], [1062302400000, 8.4566434900643], [1064894400000, 7.9565760979059], [1067576400000, 9.3764619255827], [1070168400000, 9.0747664160538], [1072846800000, 10.508939004673], [1075525200000, 10.69936754483], [1078030800000, 10.681562399145], [1080709200000, 13.184786109406], [1083297600000, 12.668213052351], [1085976000000, 13.430509403986], [1088568000000, 12.393086349213], [1091246400000, 11.942374044842], [1093924800000, 12.062227685742], [1096516800000, 11.969974363623], [1099195200000, 12.14374574055], [1101790800000, 12.69422821995], [1104469200000, 9.1235211044692], [1107147600000, 8.758211757584], [1109566800000, 8.8072309258443], [1112245200000, 11.687595946835], [1114833600000, 11.079723082664], [1117512000000, 12.049712896076], [1120104000000, 10.725319428684], [1122782400000, 10.844849996286], [1125460800000, 10.833535488461], [1128052800000, 17.180932407865], [1130734800000, 15.894764896516], [1133326800000, 16.412751299498], [1136005200000, 12.573569093402], [1138683600000, 13.242301508051], [1141102800000, 12.863536342041], [1143781200000, 21.034044171629], [1146369600000, 21.419084618802], [1149048000000, 21.142678863692], [1151640000000, 26.56848967753], [1154318400000, 24.839144939906], [1156996800000, 25.456187462166], [1159588800000, 26.350164502825], [1162270800000, 26.478333205189], [1164862800000, 26.425979547846], [1167541200000, 28.191461582256], [1170219600000, 28.930307448808], [1172638800000, 29.521413891117], [1175313600000, 28.188285966466], [1177905600000, 27.704619625831], [1180584000000, 27.49086242483], [1183176000000, 28.770679721286], [1185854400000, 29.06048067145], [1188532800000, 28.240998844973], [1191124800000, 33.004893194128], [1193803200000, 34.075180359928], [1196398800000, 32.548560664834], [1199077200000, 30.629727432729], [1201755600000, 28.642858788159], [1204261200000, 27.973575227843], [1206936000000, 27.393351882726], [1209528000000, 28.476095288522], [1212206400000, 29.29667866426], [1214798400000, 29.222333802896], [1217476800000, 28.092966093842], [1220155200000, 28.107159262922], [1222747200000, 25.482974832099], [1225425600000, 21.208115993834], [1228021200000, 20.295043095268], [1230699600000, 15.925754618402], [1233378000000, 17.162864628346], [1235797200000, 17.084345773174], [1238472000000, 22.24600710228], [1241064000000, 24.530543998508], [1243742400000, 25.084184918241], [1246334400000, 16.606166527359], [1249012800000, 17.239620011628], [1251691200000, 17.336739127379], [1254283200000, 25.478492475754], [1256961600000, 23.017152085244], [1259557200000, 25.617745423684], [1262235600000, 24.061133998641], [1264914000000, 23.223933318646], [1267333200000, 24.425887263936], [1270008000000, 35.501471156693], [1272600000000, 33.775013878675], [1275278400000, 30.417993630285], [1277870400000, 30.023598978467], [1280548800000, 33.327519522436], [1283227200000, 31.963388450372], [1285819200000, 30.49896723209], [1288497600000, 32.403696817913], [1291093200000, 31.47736071922], [1293771600000, 31.53259666241], [1296450000000, 41.760282761548], [1298869200000, 45.605771243237], [1301544000000, 39.986557966215], [1304136000000, 43.84633051005], [1306814400000, 39.857316881858], [1309406400000, 37.675127768207], [1312084800000, 35.775077970313], [1314763200000, 48.631009702578], [1317355200000, 42.830831754505], [1320033600000, 35.611502589362], [1322629200000, 35.320136981738], [1325307600000, 31.564136901516], [1327986000000, 32.074407502433], [1330491600000, 35.053013769977], [1333166400000, 33.873085184128], [1335758400000, 32.321039427046]]
                },

                {
                    'key'   : 'Australia',
                    'values': [[1025409600000, 5.1162447683392], [1028088000000, 4.2022848306513], [1030766400000, 4.3543715758736], [1033358400000, 5.4641223667245], [1036040400000, 6.0041275884577], [1038632400000, 6.6050520064486], [1041310800000, 5.0154059912793], [1043989200000, 5.1835708554647], [1046408400000, 5.1142682006164], [1049086800000, 5.0271381717695], [1051675200000, 5.3437782653456], [1054353600000, 5.2105844515767], [1056945600000, 6.552565997799], [1059624000000, 6.9873363581831], [1062302400000, 7.010986789097], [1064894400000, 4.4254242025515], [1067576400000, 4.9613848042174], [1070168400000, 4.8854920484764], [1072846800000, 4.0441111794228], [1075525200000, 4.0219596813179], [1078030800000, 4.3065749225355], [1080709200000, 3.9148434915404], [1083297600000, 3.8659430654512], [1085976000000, 3.9572824600686], [1088568000000, 4.7372190641522], [1091246400000, 4.6871476374455], [1093924800000, 5.0398702564196], [1096516800000, 5.5221787544964], [1099195200000, 5.424646299798], [1101790800000, 5.9240223067349], [1104469200000, 5.9936860983601], [1107147600000, 5.8499523215019], [1109566800000, 6.4149040329325], [1112245200000, 6.4547895561969], [1114833600000, 5.9385382611161], [1117512000000, 6.0486751030592], [1120104000000, 5.23108613838], [1122782400000, 5.5857797121029], [1125460800000, 5.3454665096987], [1128052800000, 5.0439154120119], [1130734800000, 5.054634702913], [1133326800000, 5.3819451380848], [1136005200000, 5.2638869269803], [1138683600000, 5.5806167415681], [1141102800000, 5.4539047069985], [1143781200000, 7.6728842432362], [1146369600000, 7.719946716654], [1149048000000, 8.0144619912942], [1151640000000, 7.942223133434], [1154318400000, 8.3998279827444], [1156996800000, 8.532324572605], [1159588800000, 4.7324285199763], [1162270800000, 4.7402397487697], [1164862800000, 4.9042069355168], [1167541200000, 5.9583963430882], [1170219600000, 6.3693899239171], [1172638800000, 6.261153903813], [1175313600000, 5.3443942184584], [1177905600000, 5.4932111235361], [1180584000000, 5.5747393101109], [1183176000000, 5.3833633060013], [1185854400000, 5.5125898831832], [1188532800000, 5.8116112661327], [1191124800000, 4.3962296939996], [1193803200000, 4.6967663605521], [1196398800000, 4.7963004350914], [1199077200000, 4.1817985183351], [1201755600000, 4.3797643870182], [1204261200000, 4.6966642197965], [1206936000000, 4.3609995132565], [1209528000000, 4.4736290996496], [1212206400000, 4.3749762738128], [1214798400000, 3.3274661194507], [1217476800000, 3.0316184691337], [1220155200000, 2.5718140204728], [1222747200000, 2.7034994044603], [1225425600000, 2.2033786591364], [1228021200000, 1.9850621240805], [1230699600000, 0], [1233378000000, 0], [1235797200000, 0], [1238472000000, 0], [1241064000000, 0], [1243742400000, 0], [1246334400000, 0], [1249012800000, 0], [1251691200000, 0], [1254283200000, 0.44495950017788], [1256961600000, 0.33945469262483], [1259557200000, 0.38348269455195], [1262235600000, 0], [1264914000000, 0], [1267333200000, 0], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0], [1288497600000, 0], [1291093200000, 0], [1293771600000, 0], [1296450000000, 0.52216435716176], [1298869200000, 0.59275786698454], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 0], [1320033600000, 0], [1322629200000, 0], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                },

                {
                    'key'   : 'Antarctica',
                    'values': [[1025409600000, 1.3503144674343], [1028088000000, 1.2232741112434], [1030766400000, 1.3930470790784], [1033358400000, 1.2631275030593], [1036040400000, 1.5842699103708], [1038632400000, 1.9546996043116], [1041310800000, 0.8504048300986], [1043989200000, 0.85340686311353], [1046408400000, 0.843061357391], [1049086800000, 2.119846992476], [1051675200000, 2.5285382124858], [1054353600000, 2.5056570712835], [1056945600000, 2.5212789901005], [1059624000000, 2.6192011642534], [1062302400000, 2.5382187823805], [1064894400000, 2.3393223047168], [1067576400000, 2.491219888698], [1070168400000, 2.497555874906], [1072846800000, 1.734018115546], [1075525200000, 1.9307268299646], [1078030800000, 2.2261679836799], [1080709200000, 1.7608893704206], [1083297600000, 1.6242690616808], [1085976000000, 1.7161663801295], [1088568000000, 1.7183554537038], [1091246400000, 1.7179780759145], [1093924800000, 1.7314274801784], [1096516800000, 1.2596883356752], [1099195200000, 1.381177053009], [1101790800000, 1.4408819615814], [1104469200000, 3.4743581836444], [1107147600000, 3.3603749903192], [1109566800000, 3.5350883257893], [1112245200000, 3.0949644237828], [1114833600000, 3.0796455899995], [1117512000000, 3.3441247640644], [1120104000000, 4.0947643978168], [1122782400000, 4.4072631274052], [1125460800000, 4.4870979780825], [1128052800000, 4.8404549457934], [1130734800000, 4.8293016233697], [1133326800000, 5.2238093263952], [1136005200000, 3.382306337815], [1138683600000, 3.7056975170243], [1141102800000, 3.7561118692318], [1143781200000, 2.861913700854], [1146369600000, 2.9933744103381], [1149048000000, 2.7127537218463], [1151640000000, 3.1195497076283], [1154318400000, 3.4066964004508], [1156996800000, 3.3754571113569], [1159588800000, 2.2965579982924], [1162270800000, 2.4486818633018], [1164862800000, 2.4002308848517], [1167541200000, 1.9649579750349], [1170219600000, 1.9385263638056], [1172638800000, 1.9128975336387], [1175313600000, 2.3412869836298], [1177905600000, 2.4337870351445], [1180584000000, 2.62179703171], [1183176000000, 3.2642864957929], [1185854400000, 3.3200396223709], [1188532800000, 3.3934212707572], [1191124800000, 4.2822327088179], [1193803200000, 4.1474964228541], [1196398800000, 4.1477082879801], [1199077200000, 5.2947122916128], [1201755600000, 5.2919843508028], [1204261200000, 5.198978305031], [1206936000000, 3.5603057673513], [1209528000000, 3.3009087690692], [1212206400000, 3.1784852603792], [1214798400000, 4.5889503538868], [1217476800000, 4.401779617494], [1220155200000, 4.2208301828278], [1222747200000, 3.89396671475], [1225425600000, 3.0423832241354], [1228021200000, 3.135520611578], [1230699600000, 1.9631418164089], [1233378000000, 1.8963543874958], [1235797200000, 1.8266636017025], [1238472000000, 0.93136635895188], [1241064000000, 0.92737801918888], [1243742400000, 0.97591889805002], [1246334400000, 2.6841193805515], [1249012800000, 2.5664341140531], [1251691200000, 2.3887523699873], [1254283200000, 1.1737801663681], [1256961600000, 1.0953582317281], [1259557200000, 1.2495674976653], [1262235600000, 0.36607452464754], [1264914000000, 0.3548719047291], [1267333200000, 0.36769242398939], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0.85450741275337], [1288497600000, 0.91360317921637], [1291093200000, 0.89647678692269], [1293771600000, 0.87800687192639], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0.43668720882994], [1304136000000, 0.4756523602692], [1306814400000, 0.46947368328469], [1309406400000, 0.45138896152316], [1312084800000, 0.43828726648117], [1314763200000, 2.0820861395316], [1317355200000, 0.9364411075395], [1320033600000, 0.60583907839773], [1322629200000, 0.61096950747437], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                }

            ]
        };

        vm.historicalBarChart = {
            options: {
                chart: {
                    type              : 'historicalBarChart',
                    height            : 450,
                    margin            : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 50
                    },
                    x                 : function (d)
                    {
                        return d[0];
                    },
                    y                 : function (d)
                    {
                        return d[1] / 100000;
                    },
                    showValues        : true,
                    valueFormat       : function (d)
                    {
                        return d3.format(',.1f')(d);
                    },
                    transitionDuration: 500,
                    xAxis             : {
                        axisLabel   : 'X Axis',
                        tickFormat  : function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        },
                        rotateLabels: 50,
                        showMaxMin  : false
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        axisLabelDistance: 35,
                        tickFormat       : function (d)
                        {
                            return d3.format(',.1f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'Quantity',
                    'bar'   : true,
                    'values': [[1159588800000, 3899486.0], [1162270800000, 3899486.0], [1164862800000, 3899486.0], [1167541200000, 3564700.0], [1170219600000, 3564700.0], [1172638800000, 3564700.0], [1175313600000, 2648493.0], [1177905600000, 2648493.0], [1180584000000, 2648493.0], [1183176000000, 2522993.0], [1185854400000, 2522993.0], [1188532800000, 2522993.0], [1191124800000, 2906501.0], [1193803200000, 2906501.0], [1196398800000, 2906501.0], [1199077200000, 2206761.0], [1201755600000, 2206761.0], [1204261200000, 2206761.0], [1206936000000, 2287726.0], [1209528000000, 2287726.0], [1212206400000, 2287726.0], [1214798400000, 2732646.0], [1217476800000, 2732646.0], [1220155200000, 2732646.0], [1222747200000, 2599196.0], [1225425600000, 2599196.0], [1228021200000, 2599196.0], [1230699600000, 1924387.0], [1233378000000, 1924387.0], [1235797200000, 1924387.0], [1238472000000, 1756311.0], [1241064000000, 1756311.0], [1243742400000, 1756311.0], [1246334400000, 1743470.0], [1249012800000, 1743470.0], [1251691200000, 1743470.0], [1254283200000, 1519010.0], [1256961600000, 1519010.0], [1259557200000, 1519010.0], [1262235600000, 1591444.0], [1264914000000, 1591444.0], [1267333200000, 1591444.0], [1270008000000, 1543784.0], [1272600000000, 1543784.0], [1275278400000, 1543784.0], [1277870400000, 1309915.0], [1280548800000, 1309915.0], [1283227200000, 1309915.0], [1285819200000, 1331875.0], [1288497600000, 1331875.0], [1291093200000, 1331875.0], [1293771600000, 1331875.0], [1296450000000, 1154695.0], [1298869200000, 1154695.0], [1301544000000, 1194025.0], [1304136000000, 1194025.0], [1306814400000, 1194025.0], [1309406400000, 1194025.0], [1312084800000, 1194025.0], [1314763200000, 1244525.0], [1317355200000, 475000.0], [1320033600000, 475000.0], [1322629200000, 475000.0], [1325307600000, 690033.0], [1327986000000, 690033.0], [1330491600000, 690033.0], [1333166400000, 514733.0], [1335758400000, 514733.0]]
                }]
        };

        vm.multiBarHorizontalChart = {
            options: {
                chart: {
                    type              : 'multiBarHorizontalChart',
                    height            : 450,
                    x                 : function (d)
                    {
                        return d.label;
                    },
                    y                 : function (d)
                    {
                        return d.value;
                    },
                    showControls      : true,
                    showValues        : true,
                    transitionDuration: 500,
                    xAxis             : {
                        showMaxMin: false
                    },
                    yAxis             : {
                        axisLabel : 'Values',
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },
            data   : [
                {
                    'key'   : 'Series1',
                    'color' : '#d62728',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': -1.8746444827653
                        },
                        {
                            'label': 'Group B',
                            'value': -8.0961543492239
                        },
                        {
                            'label': 'Group C',
                            'value': -0.57072943117674
                        },
                        {
                            'label': 'Group D',
                            'value': -2.4174010336624
                        },
                        {
                            'label': 'Group E',
                            'value': -0.72009071426284
                        },
                        {
                            'label': 'Group F',
                            'value': -0.77154485523777
                        },
                        {
                            'label': 'Group G',
                            'value': -0.90152097798131
                        },
                        {
                            'label': 'Group H',
                            'value': -0.91445417330854
                        },
                        {
                            'label': 'Group I',
                            'value': -0.055746319141851
                        }
                    ]
                },
                {
                    'key'   : 'Series2',
                    'color' : '#1f77b4',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': 25.307646510375
                        },
                        {
                            'label': 'Group B',
                            'value': 16.756779544553
                        },
                        {
                            'label': 'Group C',
                            'value': 18.451534877007
                        },
                        {
                            'label': 'Group D',
                            'value': 8.6142352811805
                        },
                        {
                            'label': 'Group E',
                            'value': 7.8082472075876
                        },
                        {
                            'label': 'Group F',
                            'value': 5.259101026956
                        },
                        {
                            'label': 'Group G',
                            'value': 0.30947953487127
                        },
                        {
                            'label': 'Group H',
                            'value': 0
                        },
                        {
                            'label': 'Group I',
                            'value': 0
                        }
                    ]
                }
            ]
        };

        vm.pieChart = {
            options: {
                chart: {
                    type              : 'pieChart',
                    height            : 500,
                    x                 : function (d)
                    {
                        return d.key;
                    },
                    y                 : function (d)
                    {
                        return d.y;
                    },
                    showLabels        : true,
                    transitionDuration: 500,
                    labelThreshold    : 0.01,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 35,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },
            data   : [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]
        };

        vm.donutChart = {
            options: {
                chart: {
                    type      : 'pieChart',
                    height    : 450,
                    donut     : true,
                    x         : function (d)
                    {
                        return d.key;
                    },
                    y         : function (d)
                    {
                        return d.y;
                    },
                    showLabels: true,

                    pie               : {
                        startAngle: function (d)
                        {
                            return d.startAngle / 2 - Math.PI / 2;
                        },
                        endAngle  : function (d)
                        {
                            return d.endAngle / 2 - Math.PI / 2;
                        }
                    },
                    transitionDuration: 500,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 70,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },

            data: [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]

        };

        vm.sparklineChart = {
            options: {
                chart: {
                    type              : 'sparklinePlus',
                    height            : 450,
                    x                 : function (d, i)
                    {
                        return i;
                    },
                    xTickFormat       : function (d)
                    {
                        return d3.time.format('%x')(new Date(vm.sparklineChart.data[d].x));
                    },
                    transitionDuration: 250
                }
            },

            //$scope.data = sine();
            data: volatileChart(130.0, 0.02)
        };

        vm.bulletChart = {
            options: {
                chart: {
                    type              : 'bulletChart',
                    transitionDuration: 500
                }
            },
            data   : {
                'title'   : 'Revenue',
                'subtitle': 'US$, in thousands',
                'ranges'  : [150, 225, 300],
                'measures': [220],
                'markers' : [250]
            }
        };

        vm.scatterChart = {
            options: {
                chart: {
                    type              : 'scatterChart',
                    height            : 450,
                    color             : d3.scale.category10().range(),
                    scatter           : {
                        onlyCircles: false
                    },
                    showDistX         : true,
                    showDistY         : true,
                    tooltipContent    : function (key)
                    {
                        return '<h3>' + key + '</h3>';
                    },
                    transitionDuration: 350,
                    xAxis             : {
                        axisLabel : 'X Axis',
                        tickFormat: function (d)
                        {
                            return d3.format('.02f')(d);
                        }
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                }
            },
            data   : generateData(4, 5)
        };

        // Methods


        //////////

        /*Random Data Generator */
        function sinAndCos()
        {
            var sin = [], sin2 = [],
                cos = [];

            //Data is represented as an array of {x,y} pairs.
            for ( var i = 0; i < 100; i++ )
            {
                sin.push({
                    x: i,
                    y: Math.sin(i / 10)
                });
                sin2.push({
                    x: i,
                    y: (i % 10 === 5 ? null : Math.sin(i / 10) * 0.25 + 0.5)
                });
                cos.push({
                    x: i,
                    y: 0.5 * Math.cos(i / 10 + 2) + Math.random() / 10
                });
            }

            //Line chart data should be sent as an array of series objects.
            return [
                {
                    values: sin,      //values - represents the array of {x,y} data points
                    key   : 'Sine Wave', //key  - the name of the series.
                    color : '#ff7f0e'  //color - optional: choose your own line color.
                },
                {
                    values: cos,
                    key   : 'Cosine Wave',
                    color : '#2ca02c'
                },
                {
                    values: sin2,
                    key   : 'Another sine wave',
                    color : '#7777ff',
                    area  : true      //area - set to true if you want this line to turn into a filled area chart.
                }
            ];
        }

        function volatileChart(startPrice, volatility, numPoints)
        {
            var rval = [];
            var now = +new Date();
            numPoints = numPoints || 100;
            for ( var i = 1; i < numPoints; i++ )
            {
                rval.push({
                    x: now + i * 1000 * 60 * 60 * 24,
                    y: startPrice
                });
                var rnd = Math.random();
                var changePct = 2 * volatility * rnd;
                if ( changePct > volatility )
                {
                    changePct -= (2 * volatility);
                }
                startPrice = startPrice + startPrice * changePct;
            }
            return rval;
        }

        /* Random Data Generator (took from nvd3.org) */
        function generateData(groups, points)
        {
            var data = [],
                shapes = ['circle', 'cross', 'triangle-up', 'triangle-down', 'diamond', 'square'],
                random = d3.random.normal();

            for ( var i = 0; i < groups; i++ )
            {
                data.push({
                    key   : 'Group ' + i,
                    values: []
                });

                for ( var j = 0; j < points; j++ )
                {
                    data[i].values.push(
                        {
                            x    : random(),
                            y    : random(),
                            size : Math.random(),
                            shape: shapes[j % 6]
                        });
                }
            }
            return data;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chartist', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_chartist', {
            url  : '/components/charts/chartist',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/chartist/chartist.html',
                    controller : 'ChartistController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chartist')
        .controller('ChartistController', ChartistController);

    function ChartistController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;


        // line chart
        vm.lineChart = {
            data   : {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                series: [
                    [12, 9, 7, 8, 5],
                    [2, 1, 3.5, 7, 3],
                    [1, 3, 4, 5, 6]
                ]
            },
            options: {
                fullWidth   : true,
                chartPadding: {
                    right: 40
                }
            }
        };

        // line Area chart
        vm.lineAreaChart = {
            data   : {
                labels: [1, 2, 3, 4, 5, 6, 7, 8],
                series: [
                    [5, 9, 7, 8, 5, 3, 5, 4]
                ]
            },
            options: {
                low     : 0,
                showArea: true
            }
        };

        vm.biPolarLineChart = {
            data   : {
                labels: [1, 2, 3, 4, 5, 6, 7, 8],
                series: [
                    [1, 2, 3, 1, -2, 0, 1, 0],
                    [-2, -1, -2, -1, -2.5, -1, -2, -1],
                    [0, 0, 0, 1, 2, 2.5, 2, 1],
                    [2.5, 2, 1, 0.5, 1, 0.5, -1, -2.5]
                ]
            },
            options: {
                high     : 3,
                low      : -3,
                showArea : true,
                showLine : false,
                showPoint: false,
                fullWidth: true,
                axisX    : {
                    showLabel: false,
                    showGrid : false
                }
            }
        };

        vm.stackedBarChart = {
            data   : {
                labels: ['Q1', 'Q2', 'Q3', 'Q4'],
                series: [
                    [800000, 1200000, 1400000, 1300000],
                    [200000, 400000, 500000, 300000],
                    [100000, 200000, 400000, 600000]
                ]
            },
            options: {
                stackBars: true,
                axisY    : {
                    labelInterpolationFnc: function (value)
                    {
                        return (value / 1000) + 'k';
                    }
                }
            },
            events : {
                draw: function (data)
                {
                    if ( data.type === 'bar' )
                    {
                        data.element.attr({
                            style: 'stroke-width: 30px'
                        });
                    }
                }
            }
        };

        // bar chart
        vm.barChart = {
            data             : {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                series: [
                    [5, 4, 3, 7, 5, 10, 3, 4, 8, 10, 6, 8],
                    [3, 2, 9, 5, 4, 6, 4, 6, 7, 8, 7, 4]
                ]
            },
            options          : {
                seriesBarDistance: 15
            },
            responsiveOptions: [
                ['screen and (min-width: 641px) and (max-width: 1024px)', {
                    seriesBarDistance: 10,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value;
                        }
                    }
                }],
                ['screen and (max-width: 640px)', {
                    seriesBarDistance: 5,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value[0];
                        }
                    }
                }]
            ]
        };

        // Horizontal bar chart
        vm.horizontalBarChart = {
            data   : {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                series: [
                    [5, 4, 3, 7, 5, 10, 3],
                    [3, 2, 9, 5, 4, 6, 4]
                ]
            },
            options: {
                seriesBarDistance: 10,
                reverseData      : true,
                horizontalBars   : true,
                axisY            : {
                    offset: 70
                }
            }
        };

        vm.biPolarBarChart = {
            data   : {
                labels: ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8', 'W9', 'W10'],
                series: [
                    [1, 2, 4, 8, 6, -2, -1, -4, -6, -2]
                ]
            },
            options: {
                high : 10,
                low  : -10,
                axisX: {
                    labelInterpolationFnc: function (value, index)
                    {
                        return index % 2 === 0 ? value : null;
                    }
                }
            }
        };

        // pie chart
        vm.pieChart = {
            data             : {
                labels: ['Bananas', 'Apples', 'Grapes'],
                series: [20, 15, 40]
            },
            options          : {
                labelInterpolationFnc: function (value)
                {
                    return value[0];
                }
            },
            responsiveOptions: [
                ['screen and (min-width: 640px)', {
                    chartPadding         : 40,
                    labelOffset          : 150,
                    labelDirection       : 'explode',
                    labelInterpolationFnc: function (value)
                    {
                        return value;
                    }
                }],
                ['screen and (min-width: 1024px)', {
                    labelOffset : 120,
                    chartPadding: 30
                }]
            ]

        };

        // donut chart
        vm.donutChart = {
            data   : {
                series: [20, 10, 30, 40]
            },
            options: {
                donut: true
            }
        };

        vm.gaugeChart = {
            data   : {
                series: [20, 10, 30, 40]
            },
            options: {
                donut     : true,
                donutWidth: 60,
                startAngle: 270,
                total     : 200,
                showLabel : true
            }
        };
        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chart-js', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_chart-js', {
            url  : '/components/charts/chart-js',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/chart-js/chart-js.html',
                    controller : 'ChartJsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chart-js')
        .controller('ChartJsController', ChartJsController);

    function ChartJsController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.lineChart = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            series: ['Series A', 'Series B'],
            data  : [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ]
        };

        vm.barChart = {
            labels: ['2006', '2007', '2008', '2009', '2010', '2011', '2012'],
            series: ['Series A', 'Series B'],
            data  : [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ]
        };

        vm.doughnutChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'],
            data  : [300, 500, 100]
        };

        vm.radarChart = {
            labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
            data  : [
                [65, 59, 90, 81, 56, 55, 40],
                [28, 48, 40, 19, 96, 27, 100]
            ]
        };

        vm.pieChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'],
            data  : [300, 500, 100]
        };

        vm.polarChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales', 'Tele Sales', 'Corporate Sales'],
            data  : [300, 500, 100, 40, 120]
        };

        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.c3', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_c3', {
            url  : '/components/charts/c3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/c3/c3.html',
                    controller : 'C3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.c3')
        .controller('C3Controller', C3Controller);

    function C3Controller(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.select-itb')
        .controller('SelectItbController', SelectItbController);


    /** @ngInject */
    function SelectItbController(firebaseDataService,$scope,$timeout,$location,$document,$mdDialog,$firebaseArray,$firebaseObject,loginService,itbStatusService,workflowService,utilsService,$filter,msNavigationService,uiGridConstants,errorLogService)
    {
        // DECLARATIONS ***********************
        var vm = this;

        vm.itbs;
        vm.charterers;
        vm.bidderKey;
        //vm.workflowStatus;

        vm.chartererSelected;

        vm.showAcceptRejectButtons = false;
        vm.showDownloadButton = false;

        vm.gridOptions;
        vm.gridApi;
        vm.selectedItb = null;
        vm.selectedRow = null;
        vm.selectedRowId = null;
        vm.selectedRowName = null;
        vm.currentView = 'list';
        vm.operation = "";

        vm.date_commencement;
        vm.date_closing;
        vm.time_commencement;
        vm.time_closing;

        vm.timeList;

        vm.pendingTechnicalDocs;
        vm.pendingCommercialDocs;
        vm.pendingGeneralDocs;
    
        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.refreshGrid = refreshGrid;
        vm.setAdministratorEmailList = setAdministratorEmailList;
        vm.getItbs = getItbs;
        vm.getCharterers = getCharterers;

        vm.getChartererObject = getChartererObject;

        vm.assignItbValues = assignItbValues;
//        vm.initValues = initValues;
        vm.initGrid = initGrid;
        vm.loadGrid = loadGrid;

        vm.showConfirmAcceptDialog = showConfirmAcceptDialog;
        vm.showConfirmRejectDialog = showConfirmRejectDialog;
        vm.downloadItbDocs = downloadItbDocs;
        vm.updateItbSelected = updateItbSelected;
        
        //vm.showRejectDialog = showRejectDialog;
        vm.selectDialog = selectDialog;


//        vm.addItb = addItb;
//        vm.deleteItb = deleteItb;
        vm.saveItb = saveItb;
        vm.selectItb = selectItb;

//        vm.addWorkflowRecord = addWorkflowRecord;
        
        vm.convertDateToString = convertDateToString;
//        vm.formatDate = formatDate;

        vm.assignChartererName = assignChartererName;

//        vm.toggleView = toggleView;
        
        vm.getExpiredItbStatusAndRedirect = getExpiredItbStatusAndRedirect;

        vm.showAlertDialog = showAlertDialog;

        vm.getUnreadMails = getUnreadMails;



        vm.reviewAllPendingDocs = reviewAllPendingDocs;
        vm.reviewPendingTechnicalDocs = reviewPendingTechnicalDocs;
        vm.reviewPendingCommercialDocs = reviewPendingCommercialDocs;
        vm.reviewPendingGeneralDocs = reviewPendingGeneralDocs;

        vm.checkTechnicalDocExistsInPendingTechnicalDocs = checkTechnicalDocExistsInPendingTechnicalDocs;
        vm.checkCommercialDocExistsInPendingCommercialDocs = checkCommercialDocExistsInPendingCommercialDocs;
        vm.checkGeneralDocExistsInPendingGeneralDocs = checkGeneralDocExistsInPendingGeneralDocs;

        //START CONTROLLER *******************************
        vm.executeController();


/*
//MUY IMPORTANTE => MONITORIZAMOS A TRAVÉS DE $watch LA VARIABLE indicada para actualizar el estado de ciertos elementos

        $scope.$watch('vm.selectedItb.bidderStatus',function(newValue,oldValue) {

            //console.log(">>>>>>>>>>>>>>>>>> MÉTODO $watch() >>>>>>>>>>>>>>>>>>> ");

            if ( (newValue == "") || (newValue == null) ) {
                return;
            }

            if (newValue === oldValue) {
                return;
            }

            if (vm.selectedItb.bidderStatus == "pending") {
                vm.showAcceptRejectButtons = true;
            } else {
                vm.showAcceptRejectButtons = false;
            }

            if (vm.selectedItb.bidderStatus == "accepted") {
                vm.showDownloadButton = true;
            } else {
                vm.showDownloadButton = false;
            }

        });
//FIN CODIGO MONITORIZACIÓN CON MÉTODO $watch()
*/


        // METHODS ****************
        function executeController() {

            vm.setAdministratorEmailList();
            
            //Initialization of the values
            //vm.initValues();

            //Initialization of the Grid
            vm.initGrid();

            //We refresh the mail counter badge in the main menu of the App
            msNavigationService.saveItem('mail', {badge : null });

            //itbs list obtained from FIREBASE
            vm.bidderKey = loginService.getUserKey();
            vm.itbs = vm.getItbs(vm.bidderKey);

            //charterers list obtained from FIREBASE
            vm.charterers = vm.getCharterers();
        }



        function refreshGrid() {
            vm.gridApi.core.refresh();
        }


        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableColumnMenus: false,

                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedItb = row.entity;

                        try {
                            vm.date_commencement = new Date(row.entity.commencementDate);
                        } catch(e) {
                            vm.date_commencement = new Date();
                        }

                        try {
                            //we obtain "extraClosingDate" instead of "closingDate" (only for App Bidders)
                            vm.date_closing = new Date(row.entity.extraClosingDate);
                        } catch(e) {
                            vm.date_closing = new Date();
                        }

                        if (row.entity.commencementTime == undefined) {
                            row.entity.commencementTime = "00:00";
                        }

                        if (row.entity.closingTime == undefined) {
                            row.entity.closingTime = "00:00";
                        }

                        vm.time_commencement = row.entity.commencementTime;
                        //we obtain "extraClosingTime" instead of "closingTime" (only for App Bidders)
                        vm.time_closing = row.entity.extraClosingTime;

                        if (vm.selectedItb.bidderStatus == "pending") {
                            vm.showAcceptRejectButtons = true;
                        } else {
                            vm.showAcceptRejectButtons = false;
                        }

/*
                        if (vm.selectedItb.bidderStatus == "accepted") {
                            vm.showDownloadButton = true;
                        } else {
                            vm.showDownloadButton = false;
                        }
*/

                        //console.log("[SelectItbController] Selected itb_key = " + vm.selectedItb.itb_key);
                        //console.log("[SelectItbController] Selected bidder_key = " + vm.selectedItb.bidder_key);
                        //console.log("[SelectItbController] Selected itb_bidder_key = " + vm.selectedItb.itb_bidder_key);
                        //console.log("[SelectItbController] Selected ITB TITLE = " + vm.selectedItb.itbName);

                        //console.log("************************************************************************");
                    });
                    
                }
            };

            vm.gridOptions.columnDefs = [
//                { name:'Reference', field: 'reference', width: '15%'  },
//                { name:'Charterers\' Ref', field: 'charterersReference', width: '15%'  },
//                { name:' ', field: 'charterer_key', width: '0%', visible: false },
                { name:'Charterer', field: 'charterer', width: '25%' },
                { name:'Title', field: 'itbName', width: '25%'  },
                { name:'Closing', field: 'extraClosingDate', width: '15%', sort: {direction: uiGridConstants.DESC,priority: 0}  },
                { name:'Time', field: 'extraClosingTime', width: '10%', sort: {direction: uiGridConstants.DESC,priority: 1}  },
                { name:'Status', field: 'itbStatus', width: '10%'  },
                { name:'Bidder Status', field: 'bidderStatus', width: '15%'  }

            ];
        }


        function setAdministratorEmailList() {

            var administratorEmailList = "";

            //Get bidders list from Firebase        
//            var fbUrl = new Firebase(FIREBASE_URL + "/administrators/");
            var fbUrl = firebaseDataService.administrators;

            var result = $firebaseArray(fbUrl);

            result.$loaded()
                .then(function(data) {

                    //console.log("[SelectItbController] Administrators email list LOADED with " + data.length + " elements.");

                    var arrayLength = data.length;

                    for (var i=0;i<arrayLength;i++) {
                        administratorEmailList += "&" + data[i].email;
                    }

                    if (administratorEmailList.length > 0) {
                        administratorEmailList = administratorEmailList.substring(1);

                        itbStatusService.setAdministratorEmails(administratorEmailList);
                    }
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[SelectItbController] ERROR in function setAdministratorEmailList(): " + error);

                    addError("SelectItbController / setAdministratorEmailList() function",error);
                });
        }



        function assignChartererName(pChartererKeySelected) {

            //We find the charterer object whose key was selected in the combobox at the detail view
            var charterer = vm.charterers.find(findChartererName);

            //We assign the charterer name (charterer company) to selectedItb.charterer property.
            vm.selectedItb.charterer = charterer.company;
        }


        function findChartererName(pCharterer) {
            return pCharterer.$id === vm.selectedItb.charterer_key;
        }



        function getChartererObject(pChartererName) {

            vm.charterers = $filter('filter')(vm.charterers, {company: pChartererName});

            //console.log("getChartererObject(" + pChartererName + ") => charterer.email = " + vm.charterers[0].email);

            return vm.charterers[0];
        }


        function getItbs(pBidderKey) {

            //Get itbs list from Firebase for Bidder logined
            vm.itbs = $firebaseArray(firebaseDataService.itb_bidders.orderByChild("bidder_key").equalTo(pBidderKey));

            vm.itbs.$loaded()
                .then(function(data) {

                    //Assign itbs list to scope
                    //vm.itbs = data;

                    //Assign only the itbs with bidders they´ve been invited.
                    vm.itbs = $filter('filter')(data, {emailSent: true});


                    //console.log("[SelectItbController] (2) itbs list LOADED with " + vm.itbs.length + " rows.");

                    //Load the grid with de itbs list
                    if (vm.itbs.length > 0) {
                        vm.loadGrid(vm.itbs);
                    }
/*
//TEST addError(location,error) method
var prueba = null;
prueba.trim();
*/

                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[SelectItbController] ERROR: " + error + " (Log Error: Controller: SelectItbController / Function: getItbs())");

                    addError("SelectItbController / getItbs() function",error);
                });
        }


        function getCharterers() {

            //Get itbs list from Firebase        
            vm.charterers = $firebaseArray(firebaseDataService.charterers.orderByChild("company"));

            vm.charterers.$loaded()
                .then(function(data) {

                    //Assign itbs list to scope
                    vm.charterers = data;

                    //console.log("[SelectItbController] (2) charterers list LOADED with " + data.length + " rows.");
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[SelectItbController] ERROR: " + error + " (Log Error: Controller: SelectItbController / Function: getCharterers())");

                    addError("SelectItbController / getCharterers() function",error);
                });
        }


        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("[SelectItbController] (3) LOAD Grid DONE");
        }



        function showConfirmAcceptDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to participate in this ITB?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    //vm.status = "You accepted to participate in the " + vm.selectedItb.itbName;
                    vm.selectedItb.bidderStatus = "accepted";
                    vm.saveItb();
                    vm.refreshGrid();
                }, 
                function() {
                    //vm.status = "You don´t confirm this action.";
                });
        }


        function showConfirmRejectDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to reject this ITB?')
                .textContent("")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    vm.selectDialog(ev);
                }, 
                function() {
                    //vm.status = "You don´t confirm this action.";
                });
        }




        function selectDialog(ev)
        {
            $mdDialog.show({
                controller         : 'SelectDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedItb: vm.selectedItb
                },
                templateUrl        : 'app/main/apps/workflow-bidder/select-itb/dialogs/select/select-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            })
            .then(function() {

                vm.saveItb();
                vm.refreshGrid();
            });
        }





        function downloadItbDocs() {

            vm.showAlertDialog("Download documents of the accepted ITB");
        }


        function saveItb() 
        {
            //console.log("[SelectItbController] START saveItb() method");

            var itb = vm.selectedItb;

            if (itb != null) {

                //console.log("[SelectItbController] ITB is not null => itb_key = " + itb.$id);
/*
                //Convertion process to string with 'yyyy/MM/dd' format for date and time in order to insert in Firebase (FIREBASE ONLY ACCEPTS object, array, string, number, boolean and null types)
                var fecha1 = new Date(vm.date_commencement);
                itb.commencementDate = vm.convertDateToString(fecha1);

                //Convertion process to string with 'yyyy/MM/dd' format for date and time in order to insert in Firebase (FIREBASE ONLY ACCEPTS object, array, string, number, boolean and null types)
                var fecha2 = new Date(vm.date_closing);
                itb.closingDate = vm.convertDateToString(fecha2);

                itb.commencementTime = vm.time_commencement;
                itb.closingTime = vm.time_closing;
*/
                vm.itbs.$save(itb)
                    .then(function(ref) {
                        //console.log("[SelectItbController] Saved record with itb_key = " + ref.key);
                    })
                    .catch(function(error) {
                        //console.log("[SelectItbController] ERROR: " + error + "(Log Error: Controller: SelectItbController / Function: saveItb())");
                        addError("SelectItbController / saveItb() function",error);
                    }
                );
            }
        }


        function assignItbValues(pItbKey) {

//            var fbUrl = new Firebase(FIREBASE_URL + "/itbs/" + pItbKey + "/");
            var fbUrl = firebaseDataService.itbs.child(pItbKey);

            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    //itbStatusService.setItbName(data.title);
                    itbStatusService.setItbReference(data.reference);
                    itbStatusService.setChartererReference(data.charterersReference);

                    itbStatusService.setAddVesselComments(data.addVesselComments);
                    itbStatusService.setTechnicalDocsComments(data.technicalDocsComments);
                    itbStatusService.setCommercialDocsComments(data.commercialDocsComments);
                    itbStatusService.setGeneralDocsComments(data.generalDocsComments);
                    itbStatusService.setOtherDocsComments(data.otherDocsComments);
                    itbStatusService.setBcfDocsComments(data.bcfDocsComments);

                })
                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[SelectItbController] ERROR in function assignItbValues(): " + error);

                    addError("SelectItbController / assignItbValues() function",error);
                });
        }



        function updateItbSelected(pValue,pItbBidderKey) {

//            var fbUrl = new Firebase(FIREBASE_URL + "/itb_bidders/");
            var fbUrl = firebaseDataService.itb_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {
        
                    var recordToUpdate = data[0];

                    recordToUpdate.itbSelected = true;
                    //console.log("recordToUpdate.itbSelected = " + recordToUpdate.itbSelected);

                    //Save the record
                    data.$save(recordToUpdate)
                        .then(function(ref) {
                            //console.log("[SelectItbController] => updateItbSelected() => Record updated with 'itb_bidders' key " + ref.key);
                        })
                    
                        .catch(function(error) {
                            //console.log("[SelectItbController] => updateItbSelected() ERROR in update process => " + error);
                        });
                    
                })

                .catch(function(error) {
                    //console.log("[SelectItbController] => updateItbSelected() ERROR in loaded process => " + error);

                    addError("SelectItbController / updateItbSelected() function",error);
                });
        }



        function selectItb()
        {
            itbStatusService.setCounterVisible(false);
            itbStatusService.setItbBidderKey("");

            vm.workflow = workflowService.resetWorkflowStatus();

            //console.log("[SelectItbController]  >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> itbStatusService.getItbBidderKey() = " + itbStatusService.getItbBidderKey());

            var itbKey;

            try {
                itbKey = vm.selectedItb.itb_key;

            } catch(e) {
                vm.showAlertDialog("Please select an ITB on the grid.");
                return;
            }

            if (itbKey == null) {
                vm.showAlertDialog("Please select an ITB on the grid.");
                return;
            }

            //Asignamos los valores de la "Itb_bidder" seleccionada al service "itbStatusService" para que esté disponible en cualquier parte de la App
            itbStatusService.setItbKey(itbKey);
            itbStatusService.setItbName(vm.selectedItb.itbName);
            itbStatusService.setBidderKey(vm.selectedItb.bidder_key);
            itbStatusService.setItbBidderKey(vm.selectedItb.itb_bidder_key);
            itbStatusService.setBidderName(vm.selectedItb.bidderCompany);
            itbStatusService.setCharterer(vm.selectedItb.charterer);
            itbStatusService.setChartererReference(vm.selectedItb.charterersReference);

            //console.log("vm.selectedItb.charterer = " + vm.selectedItb.charterer);

            //We find the charterer object whose ITB was selected in the gridView
            vm.chartererSelected = vm.getChartererObject(vm.selectedItb.charterer);

            itbStatusService.setChartererKey(vm.chartererSelected.$id);
            itbStatusService.setChartererEmails(vm.chartererSelected.email + "&" + vm.chartererSelected.email1 + "&" + vm.chartererSelected.email2 + "&" + vm.chartererSelected.email3 + "&" + vm.chartererSelected.email4);

            //console.log("itbStatusService.getChartererKey() = " + itbStatusService.getChartererKey());
            //console.log("itbStatusService.getChartererEmails() = " + itbStatusService.getChartererEmails());

            itbStatusService.setItbStatus("Active");
            itbStatusService.setBidderStatus(vm.selectedItb.bidderStatus);


            vm.assignItbValues(itbKey);

                //Convertion process to string with 'yyyy/MM/dd' format for date and time in order to insert in Firebase (FIREBASE ONLY ACCEPTS object, array, string, number, boolean and null types)
                var fecha1 = new Date(vm.date_commencement);
                var commencementDate = vm.convertDateToString(fecha1);
                var commencementTime = vm.time_commencement;

                //Convertion process to string with 'yyyy/MM/dd' format for date and time in order to insert in Firebase (FIREBASE ONLY ACCEPTS object, array, string, number, boolean and null types)
                var fecha2 = new Date(vm.date_closing);
                var closingDate = vm.convertDateToString(fecha2);
                var closingTime = vm.time_closing;

                itbStatusService.setItbClosingTime(closingTime);
                itbStatusService.setItbClosingDate(closingDate);

                itbStatusService.setItbCommencementDate(commencementDate);
                itbStatusService.setItbCommencementTime(commencementTime);

            //Mostramos el contador para la ITB
            itbStatusService.setCounterVisible(true);

            workflowService.setItbBidderKey(vm.selectedItb.itb_bidder_key);
            workflowService.setSelectItbStatus(true);

//            //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  [SelectItbController] workflowService.getSelectItbStatus() = " + workflowService.getSelectItbStatus());

            ////console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  [SelectItbController] workflowService.getReceiptItbStatus() = " + workflowService.getReceiptItbStatus());
            ////console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>  [SelectItbController] workflowService.getSubmissionBidStatus() = " + workflowService.getSubmissionBidStatus());


            //We update the "itbSelected" field of the "itb_bidders" table for Bidder selected
            vm.updateItbSelected(true,vm.selectedItb.itb_bidder_key);

            //console.log("[SelectItbController] ITB selected with itb_bidder_key = " + vm.selectedItb.itb_bidder_key);

            //We obtain the number of unread emails in order to refresh the badge counter in the main menu of the App ('mail' option)
            vm.getUnreadMails();

            //VERY IMPORTANT => We must review ALL the technical, commercial and general docs to insert the new docs in the pending_docs tables
            vm.reviewAllPendingDocs(itbKey,vm.selectedItb.bidder_key,vm.selectedItb.bidderCompany);

            //We get the EXPIRED ITB status and redirect to the correct page.
            vm.getExpiredItbStatusAndRedirect();

        }



        function reviewAllPendingDocs(pItbKey,pBidderKey,pBidderCompany) {


            //IMPORTANT => Add pending technical docs to Firebase table "pending_technical_docs"
            vm.reviewPendingTechnicalDocs(pItbKey,pBidderKey,pBidderCompany);  

            //IMPORTANT => Add pending commercial docs to Firebase table "pending_commercial_docs"
            vm.reviewPendingCommercialDocs(pItbKey,pBidderKey,pBidderCompany);

            //IMPORTANT => Add pending general info docs to Firebase table "pending_general_docs"
            vm.reviewPendingGeneralDocs(pItbKey,pBidderKey,pBidderCompany);

        }




        function reviewPendingCommercialDocs(pItbKey,pBidderKey,pBidderCompany) 
        {

            if ( (pItbKey == null) || (pItbKey == "") ) {
                vm.showAlertDialog("Not possible to review pending Commercial docs");
                return;
            }

            if ( (pBidderKey == null) || (pBidderKey == "") ) {
                vm.showAlertDialog("Not possible to review pending Commercial docs");
                return;
            }

            var itbBidderKey = pItbKey + "&" + pBidderKey;


//            var fbUrl = new Firebase(FIREBASE_URL + "/pending_commercial_docs/");
            var fbUrl = firebaseDataService.pending_commercial_docs;

            vm.pendingCommercialDocs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(itbBidderKey));

            vm.pendingCommercialDocs.$loaded()
                .then(function(data) {

                    vm.pendingCommercialDocs = data;


                    //We obtain from Firebase the records of "commercial_docs"
//                    var fbUrl2 = new Firebase(FIREBASE_URL + "/commercial_docs/");
                    var fbUrl2 = firebaseDataService.commercial_docs;

                    var commercialDocs = $firebaseArray(fbUrl2.orderByChild("itb_key").equalTo(pItbKey));

                    commercialDocs.$loaded()
                        .then(function(data) {

                            commercialDocs = data;
                            //console.log("[SelectItbController] commercial docs list LOADED with " + data.length + " rows.");

                            var commercialDocsArrayLength = 0;
                            try {
                                commercialDocsArrayLength = commercialDocs.length;
                            } catch (error) {
                                commercialDocsArrayLength = 0;
                            }


                            if (commercialDocsArrayLength > 0) 
                            {

                                for (var i=0; i<commercialDocsArrayLength; i++) {                        

                                    var docKey = commercialDocs[i].$id;
                                    var docName = commercialDocs[i].name;

                                    if (!vm.checkCommercialDocExistsInPendingCommercialDocs(vm.pendingCommercialDocs,docKey)) {

                                        var stringJson = '{"itb_bidder_key": "' + itbBidderKey + '"'
                                                      +  ',"itb_key": "' + pItbKey + '"' 
                                                      +  ',"bidder_key": "' + pBidderKey + '"' 
                                                      +  ',"bidderCompany": "' + pBidderCompany + '"' 
                                                      +  ',"doc_key": "' + docKey + '"' 
                                                      +  ',"name": "' + docName + '"' 
                                                      +  ',"url": " "'
                                                      +  ',"pending": true'
                                                      +  ',"active": true'
                                                      +  '}';

                                        var jsonData = JSON.parse(stringJson);

                                        vm.pendingCommercialDocs.$add(jsonData)
                                            .then(function(ref) {
                                                //console.log("[SelectItbController] Added new record to 'pending_commercial_docs with KEY = " + ref.key);
                                            })
                                        
                                            .catch(function(error) {
                                                //console.log("[SelectItbController] ERROR in 'reviewPendingCommercialDocs' function: " + error);
                                        });
                                    }
                                }

                            }

                        })

                        .catch(function(error) {
                            //console.log("[SelectItbController] ERROR in 'reviewPendingCommercialDocs' function: " + error);
                    });


                })
                .catch(function(error) {
                    //console.log("[SelectItbController] ERROR in 'reviewPendingCommercialDocs' function: " + error);

                    addError("SelectItbController / reviewPendingCommercialDocs() function",error);
            });

        }



        function checkCommercialDocExistsInPendingCommercialDocs(pPendingDocsArray,pDocKey) {

            var result = $filter('filter')(pPendingDocsArray, {doc_key: pDocKey});

            try {

                if (result.length > 0) {
                    return true;
                } else {
                    return false;
                }

            } catch(error) {
                return false;
            }
        }


        function reviewPendingGeneralDocs(pItbKey,pBidderKey,pBidderCompany) 
        {

            if ( (pItbKey == null) || (pItbKey == "") ) {
                vm.showAlertDialog("Not possible to review pending General docs");
                return;
            }

            if ( (pBidderKey == null) || (pBidderKey == "") ) {
                vm.showAlertDialog("Not possible to review pending General docs");
                return;
            }

            var itbBidderKey = pItbKey + "&" + pBidderKey;


//            var fbUrl = new Firebase(FIREBASE_URL + "/pending_general_docs/");
            var fbUrl = firebaseDataService.pending_general_docs;

            vm.pendingGeneralDocs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(itbBidderKey));

            vm.pendingGeneralDocs.$loaded()
                .then(function(data) {

                    vm.pendingGeneralDocs = data;


                    //We obtain from Firebase the records of "general_docs"
//                    var fbUrl2 = new Firebase(FIREBASE_URL + "/general_docs/");
                    var fbUrl2 = firebaseDataService.general_docs;

                    var generalDocs = $firebaseArray(fbUrl2.orderByChild("itb_key").equalTo(pItbKey));

                    generalDocs.$loaded()
                        .then(function(data) {

                            generalDocs = data;
                            //console.log("[SelectItbController] general docs list LOADED with " + data.length + " rows.");

                            var generalDocsArrayLength = 0;
                            try {
                                generalDocsArrayLength = generalDocs.length;
                            } catch (error) {
                                generalDocsArrayLength = 0;
                            }


                            if (generalDocsArrayLength > 0) 
                            {

                                for (var i=0; i<generalDocsArrayLength; i++) {                        

                                    var docKey = generalDocs[i].$id;
                                    var docName = generalDocs[i].name;

                                    if (!vm.checkGeneralDocExistsInPendingGeneralDocs(vm.pendingGeneralDocs,docKey)) {

                                        var stringJson = '{"itb_bidder_key": "' + itbBidderKey + '"'
                                                      +  ',"itb_key": "' + pItbKey + '"' 
                                                      +  ',"bidder_key": "' + pBidderKey + '"' 
                                                      +  ',"bidderCompany": "' + pBidderCompany + '"' 
                                                      +  ',"doc_key": "' + docKey + '"' 
                                                      +  ',"name": "' + docName + '"' 
                                                      +  ',"url": " "'
                                                      +  ',"pending": true'
                                                      +  ',"active": true'
                                                      +  '}';

                                        var jsonData = JSON.parse(stringJson);

                                        vm.pendingGeneralDocs.$add(jsonData)
                                            .then(function(ref) {
                                                //console.log("[SelectItbController] Added new record to 'reviewPendingGeneralDocs' with KEY = " + ref.key);
                                            })
                                        
                                            .catch(function(error) {
                                                //console.log("[SelectItbController] ERROR in 'reviewPendingGeneralDocs' function: " + error);
                                        });
                                    }
                                }

                            }

                        })

                        .catch(function(error) {
                            //console.log("[SelectItbController] ERROR in 'reviewPendingGeneralDocs' function: " + error);
                    });


                })
                .catch(function(error) {
                    //console.log("[SelectItbController] ERROR in 'reviewPendingGeneralDocs' function: " + error);

                    addError("SelectItbController / reviewPendingGeneralDocs() function",error);
            });

        }



        function checkGeneralDocExistsInPendingGeneralDocs(pPendingDocsArray,pDocKey) {

            var result = $filter('filter')(pPendingDocsArray, {doc_key: pDocKey});

            try {

                if (result.length > 0) {
                    return true;
                } else {
                    return false;
                }

            } catch(error) {
                return false;
            }
        }





        function reviewPendingTechnicalDocs(pItbKey,pBidderKey,pBidderCompany) 
        {

            if ( (pItbKey == null) || (pItbKey == "") ) {
                vm.showAlertDialog("Not possible to review pending Technical docs");
                return;
            }

            if ( (pBidderKey == null) || (pBidderKey == "") ) {
                vm.showAlertDialog("Not possible to review pending Technical docs");
                return;
            }

            var itbBidderKey = pItbKey + "&" + pBidderKey;


//            var fbUrl = new Firebase(FIREBASE_URL + "/pending_technical_docs/");
            var fbUrl = firebaseDataService.pending_technical_docs;

            vm.pendingTechnicalDocs = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(itbBidderKey));

            vm.pendingTechnicalDocs.$loaded()
                .then(function(data) {

                    vm.pendingTechnicalDocs = data;


                    //We obtain from Firebase the records of "technical_docs"
//                    var fbUrl2 = new Firebase(FIREBASE_URL + "/technical_docs/");
                    var fbUrl2 = firebaseDataService.technical_docs;

                    var technicalDocs = $firebaseArray(fbUrl2.orderByChild("itb_key").equalTo(pItbKey));

                    technicalDocs.$loaded()
                        .then(function(data) {

                            technicalDocs = data;
                            //console.log("[SelectItbController] technical docs list LOADED with " + data.length + " rows.");

                            var generalDocsArrayLength = 0;
                            try {
                                generalDocsArrayLength = technicalDocs.length;
                            } catch (error) {
                                generalDocsArrayLength = 0;
                            }


                            if (generalDocsArrayLength > 0) 
                            {

                                for (var i=0; i<generalDocsArrayLength; i++) {                        

                                    var docKey = technicalDocs[i].$id;
                                    var docName = technicalDocs[i].name;

                                    if (!vm.checkTechnicalDocExistsInPendingTechnicalDocs(vm.pendingTechnicalDocs,docKey)) {

                                        //We obtain the list of Vessels for this Bidder
//                                        var fbUrl3 = new Firebase(FIREBASE_URL + "/vessel_bidders/");
                                        var fbUrl3 = firebaseDataService.vessel_bidders;

                                        var vessels = $firebaseArray(fbUrl3.orderByChild("itb_bidder_key").equalTo(itbBidderKey));

                                        vessels.$loaded()
                                            .then(function(data) {

                                                vessels = data;

                                                var vesselsArrayLength = 0;
                                                try {
                                                    vesselsArrayLength = vessels.length;
                                                } catch (error) {
                                                    vesselsArrayLength = 0;
                                                }


                                                for (var j=0;j<vesselsArrayLength;j++) {

                                                    var vesselKey = vessels[j].$id;
                                                    var itbBidderVesselKey = itbBidderKey + "&" + vesselKey;
                                                    var vesselName = vessels[j].vessel_name;

                                                    var stringJson = '{"itb_bidder_key": "' + itbBidderKey + '"'
                                                                  +  ',"itb_key": "' + pItbKey + '"' 
                                                                  +  ',"itb_bidder_vessel_key": "' + itbBidderVesselKey + '"' 
                                                                  +  ',"bidder_key": "' + pBidderKey + '"' 
                                                                  +  ',"bidderCompany": "' + pBidderCompany + '"' 
                                                                  +  ',"doc_key": "' + docKey + '"' 
                                                                  +  ',"name": "' + docName + '"' 
                                                                  +  ',"url": " "'
                                                                  +  ',"pending": true'
                                                                  +  ',"active": true'
                                                                  +  ',"vessel": "' + vesselName + '"'
                                                                  +  '}';

                                                    var jsonData = JSON.parse(stringJson);

                                                    vm.pendingTechnicalDocs.$add(jsonData)
                                                        .then(function(ref) {
                                                            //console.log("[SelectItbController] Added new record to 'reviewPendingTechnicalDocs' with KEY = " + ref.key);
                                                        })
                                                    
                                                        .catch(function(error) {
                                                            //console.log("[SelectItbController] ERROR in 'reviewPendingTechnicalDocs' function: " + error);
                                                    });
                                                }

                                            })
                                            .catch(function(error) {
                                                //console.log("[SelectItbController] ERROR in 'reviewPendingTechnicalDocs' function: " + error);
                                        });

                                    }
                                }

                            }

                        })

                        .catch(function(error) {
                            //console.log("[SelectItbController] ERROR in 'reviewPendingTechnicalDocs' function: " + error);
                    });


                })
                .catch(function(error) {
                    //console.log("[SelectItbController] ERROR in 'reviewPendingTechnicalDocs' function: " + error);

                    addError("SelectItbController / reviewPendingTechnicalDocs() function",error);
            });

        }



        function checkTechnicalDocExistsInPendingTechnicalDocs(pPendingDocsArray,pDocKey) {

            var result = $filter('filter')(pPendingDocsArray, {doc_key: pDocKey});

            try {

                if (result.length > 0) {
                    return true;
                } else {
                    return false;
                }

            } catch(error) {
                return false;
            }
        }



// (24/03/2025) - INICIO		
/*		
		//**********************************************
        function getExpiredItbStatusAndRedirect() {

            var expiredItb = false;

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    //console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
                    //console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);

                    var fecha = new Date(vm.date_closing);
                    var closingDate = vm.convertDateToString(fecha);
                    var closingTime = vm.time_closing;

                    var closingDateTime = closingDate + " " + closingTime;
                    //console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> closingDateTime = " + closingDateTime);

                    //var interval = utilsService.getInterval("2016/06/27 17:00:00","2016/06/27 09:00:00");
                    var interval = utilsService.getInterval(closingDateTime,data);
//                    itbStatusService.setCounterTime(interval);
//                    vm.countdown = interval;


                    if (interval <= 0) {
                        workflowService.setExpiredItb(true);
                        expiredItb = true;
                    } else {
                        workflowService.setExpiredItb(false);
                        expiredItb = false;
                    }

                    //console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> INTERVAL IN MILISECONDS = " + interval);
                    //console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> EXPIRED ITB = " + expiredItb);
                    //console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

                    if (expiredItb) {

                        workflowService.setSelectItbStatus(true);
                        workflowService.setReceiptItbStatus(false);
                        workflowService.setSubmissionBidStatus(false);
                        workflowService.setCompletionBcfStatus(true);

                        //$location.path("/workflow-bidder/completion-bcf/bcf-docs");
                        $location.path("/mail");

                    } else {

                        workflowService.setSelectItbStatus(true);
                        workflowService.setReceiptItbStatus(true);
                        //workflowService.setSubmissionBidStatus(false);
                        workflowService.setCompletionBcfStatus(false);

                        $location.path("/workflow-bidder/receipt-itb");
                    }

                })
                .error(function () {

                    //console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
                    //console.log("[SelectItbController] ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                    //console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
                });


        }
*/

		//  (NUEVA VERSION)
		//******************************************
		function getExpiredItbStatusAndRedirect() {
			var expiredItb = false;

			// Obtener la fecha y hora CET del servidor
			utilsService.getCETdateTime().then(function(response) {
				var data = response;

				//console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
				//console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);

				var fecha = new Date(vm.date_closing);
				var closingDate = vm.convertDateToString(fecha);
				var closingTime = vm.time_closing;

				var closingDateTime = closingDate + " " + closingTime;
				//console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>> closingDateTime = " + closingDateTime);

				var interval = utilsService.getInterval(closingDateTime, data);

				if (interval <= 0) {
					workflowService.setExpiredItb(true);
					expiredItb = true;
				} else {
					workflowService.setExpiredItb(false);
					expiredItb = false;
				}

				//console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>> INTERVAL IN MILISECONDS = " + interval);
				//console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>> EXPIRED ITB = " + expiredItb);
				//console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
				
				if (expiredItb) {
					workflowService.setSelectItbStatus(true);
					workflowService.setReceiptItbStatus(false);
					workflowService.setSubmissionBidStatus(false);
					workflowService.setCompletionBcfStatus(true);

					$location.path("/mail");
				} else {
					workflowService.setSelectItbStatus(true);
					workflowService.setReceiptItbStatus(true);
					workflowService.setCompletionBcfStatus(false);

					$location.path("/workflow-bidder/receipt-itb");
				}
			}).catch(function() {
				//console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
				//console.log("[SelectItbController] ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
				//console.log("[SelectItbController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
			});
		}
		
// (24/03/2025) - FIN		



        function convertDateToString(pFecha) {

            //Convert Date to string with 'yyyy/MM/dd' format
            return pFecha.getFullYear() + "/" + (pFecha.getMonth()+1) + "/" + pFecha.getDate();
        }



        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");


            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    //$location.path("/workflow-admin/select-itb");
                }); 
        }



        function getUnreadMails() {

            var pItbReceiverKey = vm.selectedItb.itb_key + "&" + loginService.getUserKey(); 


            //console.log("[SelectItbController]  Execution of getUnreadMails('" + pItbReceiverKey + "')");

            //Get mail list from Firebase        
//            var fbUrl = new Firebase(FIREBASE_URL + "/communications/");
            var fbUrl = firebaseDataService.communications;

            vm.inbox = $firebaseArray(fbUrl.orderByChild("itb_receiver_key").equalTo(pItbReceiverKey));

            vm.inbox.$loaded()
                .then(function(data) {

                    //Assign bidders list to scope
                    vm.inbox = data;

                    if (data.length > 0) {

                        //We obtain the number of unread emails
                        vm.unreadMailsCount = 0;
                        var mailCount = data.length;
                        for (var i=0;i<mailCount;i++) {

                            if (!data[i].read) {
                                vm.unreadMailsCount++;
                            }

                            if (vm.unreadMailsCount > 0) {
                                //We refresh the mail counter badge in the main menu of the App
                                msNavigationService.saveItem('mail', {badge : {content: vm.unreadMailsCount, color  : '#F44336'} });
                            } else {
                                msNavigationService.saveItem('mail', {badge : null });
                            }
                        }                        

                    } else {

                        //We refresh the mail counter badge in the main menu of the App
                        msNavigationService.saveItem('mail', {badge : null });
                    }

                    //console.log("[SelectItbController] getUnreadMails('" + pItbReceiverKey + "') LOADED with " + data.length + " elements.");
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[SelectItbController] ERROR in function getUnreadMails(): " + error);

                    addError("SelectItbController / getUnreadMails() function",error);
                });
        }



        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }


/*
        function formatDate(pDate) {
            var result = moment(pDate).format('dd/MM/YYYY');
            //console.log("Resultado conversión fecha a formato 'DD/MM/YYYY' = " + result);
            return result;
        };
*/


/*
        function toggleView(method)
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';

            var itb = vm.selectedItb;

            if (vm.currentView == "detail") {

                if (method == "modify") {

                    vm.operation = "modify";

                } else {
                    vm.operation = "insert";

                    //We initilize values for the new ITB
                    vm.selectedItb = null;
                    vm.date_commencement = new Date();
                    vm.date_closing = new Date();
                    vm.time_commencement = "00:00";
                    vm.time_closing = "00:00";
                }
            }

            if (vm.currentView == "list") {

                if (method == "save") {

                    if (vm.operation == "modify") {
                        ////console.log("[SelectItbController] We are going to execute saveItb() method with key = " + itb.$id);
                        vm.saveItb();
                    } else {
                        //console.log("[SelectItbController] We are going to execute addItb() method");
                        vm.addItb(itb);
                    }
                }
            }
        }
*/

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.receipt-itb', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.workflow_bidder_receipt_itb', {
            url      : '/workflow-bidder/receipt-itb',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/workflow-bidder/receipt-itb/receipt-itb.html',
                    controller : 'ReceiptItbController as vm'
                }
            },
            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'receipt-itb'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/workflow-bidder/receipt-itb');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-admin.prepare-itb.upload-docs', {
            title : 'Upload Documents',
            state : 'app.workflow_admin_prepare_itb_upload_docs',
            icon  : 'icon-numeric-1-box',
            weight: 1
        });
*/        
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.receipt-itb')
        .controller('ReceiptItbController', ReceiptItbController);

    /** @ngInject */
    function ReceiptItbController(firebaseDataService,$mdSidenav,$scope,$timeout,$location,$firebaseArray,$firebaseObject,itbStatusService,workflowService,$http,$mdDialog,$document,traceabilityService,loginService,utilsService,errorLogService)
    {
        // DECLARATIONS ***********************
        var vm = this;
        
        var ACCESS_TOKEN = 'lhge3xkLsbAAAAAAAAAA7F4mpQiGgjg_fD658SG5evJitCht2fsvP7D-ZfaSwEl-';  //Dropbox API version 2

        vm.path;
        vm.mainDocs;
        vm.gridOptions;
        vm.gridApi;
        vm.currentView = 'list';
        vm.selectedDoc;
        vm.itbKeySelected;
        vm.itbNameSelected;
        vm.itbBidderKeySelected;
        vm.fileUploaded;

        vm.showAcceptRejectButtons = false;
        vm.showBackNextButtons = false;
        vm.disableAcceptDeclineButtons = true;

        vm.workflow;

        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.initGrid = initGrid;
        vm.getMainDocs = getMainDocs;
        vm.loadGrid = loadGrid;
        vm.refreshGrid = refreshGrid;
        vm.updateItbBidder = updateItbBidder;
        vm.updateItbAcceptedAndDeclined = updateItbAcceptedAndDeclined;
        vm.updateItbDocsDownloaded = updateItbDocsDownloaded;

        vm.redirectToSelectItb = redirectToSelectItb;
        vm.redirectToAddVessel = redirectToAddVessel;

        vm.toggleView = toggleView;
        vm.toggleSidenav = toggleSidenav;

        vm.selectFile = selectFile;
        vm.downloadFolderItbDocs = downloadFolderItbDocs;
        vm.getSharedLinkFolder = getSharedLinkFolder;

        vm.showConfirmAcceptDialog = showConfirmAcceptDialog;
        vm.showConfirmRejectDialog = showConfirmRejectDialog;
        vm.selectDialog = selectDialog;

        vm.addAcceptedDeclinedInfoToTraceability = addAcceptedDeclinedInfoToTraceability;

        vm.updateActiveFieldForAllPendingDocs = updateActiveFieldForAllPendingDocs;
        vm.updateActiveFieldForPendingCommercialDocs = updateActiveFieldForPendingCommercialDocs;
        vm.updateActiveFieldForPendingGeneralDocs = updateActiveFieldForPendingGeneralDocs;

        //vm.getTraceabilityFromFirebaseByUser = getTraceabilityFromFirebaseByUser;
        vm.addTrace = addTrace;


        //START CONTROLLER *******************************
        vm.executeController();


        // METHODS ****************
        function executeController() {

            //We must retrieve itb_key of ITB selected in the workflow before execute the query.
            vm.itbKeySelected = itbStatusService.getItbKey();
            vm.itbNameSelected = itbStatusService.getItbName();
            vm.path = "cdn/itb/" + vm.itbKeySelected + "_" + vm.itbNameSelected + "/main_docs";

//console.log("ReceiptItbController[]  vm.itbNameSelected = " + vm.itbNameSelected);
//console.log("[ReceiptItbController] vm.path = " + vm.path);

            vm.itbBidderKeySelected = itbStatusService.getItbBidderKey();


            //We check if bidderStatus is pending or not so we show ACCEPT and REJECT buttons
            if (itbStatusService.getBidderStatus() == "pending") {
                
                vm.showAcceptRejectButtons = false; //Because we show this buttons when the user pushes the "Download ITB documents" button
                vm.showBackNextButtons = false;

                vm.disableAcceptDeclineButtons = false;

            } else {

                //If the BidderStatus is "declined" => we don´t show the Back_Next buttons and we show Accept_Reject buttons disabled
                if (itbStatusService.getBidderStatus() == "declined") {

                    vm.showBackNextButtons = false;
                    vm.showAcceptRejectButtons = true;
                    vm.disableAcceptDeclineButtons = true;

                //If the BidderStatus is not "declined" then BidderStatus is "accepted" => we show the Back_Next buttons and we don't show Accept_Reject buttons
                } else {

                    vm.showBackNextButtons = true;
                    vm.showAcceptRejectButtons = false;
                    //vm.disableAcceptDeclineButtons = true;
                }
            }


            //Initialization of the Grid
            vm.initGrid();

            //Main docs list obtained from FIREBASE
            vm.mainDocs = vm.getMainDocs(vm.itbKeySelected);

            //console.log("[ReceiptItbController] (1) Get Main Docs list process START from ItbKey '" + vm.itbKeySelected + "'");
        }



        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                //enableFiltering: true,
                enableColumnMenus: false,


                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedDoc = row.entity;

                        //console.log("[ReceiptItbController] Selected MAIN DOC KEY = " + vm.selectedDoc.$id);
                        //console.log("[ReceiptItbController] Selected MAIN DOC NAME = " + vm.selectedDoc.name);
                        //console.log("[ReceiptItbController] Selected MAIN DOC URL = " + vm.selectedDoc.url);
                        //console.log("************************************************************************");
                    });
                }
            };

            vm.gridOptions.columnDefs = [
                { name:'File', field: 'name', width: '100%' },
                { name:' ', field: 'url', width: '0%', visible: false }
            ];
        }



        function getMainDocs(pItbKeySelected) {

            //Get Main Docs list from Firebase
//            var fbUrl = new Firebase(FIREBASE_URL + "/main_docs/");
            var fbUrl = firebaseDataService.main_docs;

            vm.mainDocs = $firebaseArray(fbUrl.orderByChild("itb_key").equalTo(pItbKeySelected));

            vm.mainDocs.$loaded()
                .then(function(data) {

                    vm.mainDocs = data;

                    //console.log("[ReceiptItbController] (2) Main Docs list LOADED with " + data.length + " rows.");

                    //Load the grid with de itbs list
                    if (data.length > 0) {
                        vm.loadGrid(data);
                    }

/*
//TEST addError(location,error) method
var prueba = null;
prueba.trim();
*/

                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[ReceiptItbController] ERROR: " + error + "(Log Error: Controller: ReceiptItbController / Function: getMainDocs())");

                    addError("ReceiptItbController / getMainDocs() function",error);
            });
        }



        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("[ReceiptItbController] (3) LOAD Grid DONE");
        }



        function refreshGrid() {
            vm.gridApi.core.refresh();
        }


        function showConfirmAcceptDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to participate in this ITB?')
                .textContent("We acknowledge receipt of your Invitation to Bid  and confirm that we will submit a bid. By clicking ‘ACCEPT’ we confirm that we understand that the documents contained therein are confidential and remain the property of Charterers.")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    //vm.status = "You accepted to participate in the " + vm.selectedItb.itbName;
                    itbStatusService.bidderStatus = "accepted";
                    itbStatusService.rejectReason = "";
                    vm.updateItbBidder(vm.itbBidderKeySelected);
                    vm.refreshGrid();

                    vm.showBackNextButtons = true;
                    vm.showAcceptRejectButtons = false;
                    vm.disableAcceptDeclineButtons = true;

                    //Update the "accepted=true" and "declined=false" fields of the Bidder for "itb_bidders" table.
                    vm.updateItbAcceptedAndDeclined(true,vm.itbBidderKeySelected);

                    //IMPORTANT => Update "active"=true for all the pending docs tables (pending_commercial_docs, pending_general_docs) NOT FOR pending_technical_docs and vessel_bidders because they haven´t been created yet)
                    vm.updateActiveFieldForAllPendingDocs(vm.itbBidderKeySelected,true);

                }, 
                function() {
                    //vm.status = "You don´t confirm this action.";
                    vm.showBackNextButtons = false;
                    vm.showAcceptRejectButtons = true;
                    vm.disableAcceptDeclineButtons = false;
                });
        }


        function showConfirmRejectDialog(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Are you sure you want to decline this ITB?')
                .textContent("We acknowledge receipt of your Invitation to Bid  but decline the invitation. By clicking ‘DECLINE’ we confirm that we understand that the documents contained therein are confidential and remain the property of Charterers.")
                //.ariaLabel(""'Lucky day')
                .ariaLabel("")
                .targetEvent(ev)
                .ok("Yes")
                .cancel("No");

            $mdDialog.show(confirm)
                .then(function() {
                    vm.selectDialog(ev);
                }, 
                function() {
                    //vm.status = "You don´t confirm this action.";
                });
        }




        function selectDialog(ev)
        {
            $mdDialog.show({
                controller         : 'SelectDialogController',
                controllerAs       : 'vm',
                locals             : {
                    //selectedItb: vm.selectedItb
                },
                templateUrl        : 'app/main/apps/workflow-bidder/receipt-itb/dialogs/select/select-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            })
            .then(function() {

                vm.updateItbBidder(vm.itbBidderKeySelected);
                vm.refreshGrid();

                vm.showBackNextButtons = false;
                vm.showAcceptRejectButtons = true;
                vm.disableAcceptDeclineButtons = true;

                //Update the "accepted=false" and "declined=true" fields of the Bidder for "itb_bidders" table.
                vm.updateItbAcceptedAndDeclined(false,vm.itbBidderKeySelected);

                //IMPORTANT => Update "active"=false for all the pending docs tables (pending_commercial_docs, pending_general_docs) NOT FOR pending_technical_docs and vessel_bidders because they haven´t been created yet)
                vm.updateActiveFieldForAllPendingDocs(vm.itbBidderKeySelected,false);

            },
            function() {

                vm.showBackNextButtons = false;
                vm.showAcceptRejectButtons = true;
                vm.disableAcceptDeclineButtons = false;
            });
        }


        function updateItbAcceptedAndDeclined(pIsAccepted,pItbBidderKey) {

//            var fbUrl = new Firebase(FIREBASE_URL + "/itb_bidders/");
            var fbUrl = firebaseDataService.itb_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {
        
                    var recordToUpdate = data[0];

                    if (pIsAccepted) {
                        recordToUpdate.accepted = true;
                        recordToUpdate.declined = false;
                        recordToUpdate.active = true;

                    } else {
                        recordToUpdate.declined = true;
                        recordToUpdate.accepted = false;
                        recordToUpdate.active = false;
                    }

                    //console.log("recordToUpdate.accepted = " + recordToUpdate.accepted);
                    //console.log("recordToUpdate.declined = " + recordToUpdate.declined);
                    //console.log("recordToUpdate.active = " + recordToUpdate.active);

                    //Save the record
                    data.$save(recordToUpdate)
                        .then(function(ref) {
                            //console.log("[ReceiptItbController] => updateItbAcceptedAndDeclined() => Record updated with 'itb_bidders' key " + pItbBidderKey);

                            var bidderKey = loginService.getUserKey();

                            vm.addAcceptedDeclinedInfoToTraceability(bidderKey,pIsAccepted);

                        })
                    
                        .catch(function(error) {
                            //console.log("[ReceiptItbController] => updateItbAcceptedAndDeclined() ERROR in update process => " + error);
                        });
                    
                })

                .catch(function(error) {
                    //console.log("[ReceiptItbController] => updateItbAcceptedAndDeclined() ERROR in loaded process => " + error);

                    addError("ReceiptItbController / updateItbAcceptedAndDeclined() function",error);
            });
        }


        function updateActiveFieldForAllPendingDocs(pItbBidderKey,pBooleanValue) {

            //We update 'active'=true for 'pending_commercial_docs' table after accepting to join to the ITB
            vm.updateActiveFieldForPendingCommercialDocs(pItbBidderKey,pBooleanValue);

            //We update 'active'=true for 'pending_general_docs' table after accepting to join to the ITB
            vm.updateActiveFieldForPendingGeneralDocs(pItbBidderKey,pBooleanValue);

            //IMPORTANT => We mustn't update the field 'active'=true for 'pending_technical_docs' table because this records is always inserted after doing login and accepting to join to the ITB 
            //              (and after inserting new vessels) and for that reason is impossible to insert pending technical docs before accepting the ITB
        }



        function updateActiveFieldForPendingCommercialDocs(pItbBidderKey,pBooleanValue) {

//            var fbUrl = new Firebase(FIREBASE_URL + "/pending_commercial_docs/");
            var fbUrl = firebaseDataService.pending_commercial_docs;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {
        
                    var arrayLength = 0;

                    try {
                        arrayLength = data.length;
                    } catch (error) {
                        arrayLength = 0;
                    }

                    for (var i=0;i<arrayLength;i++) {

                        var recordToUpdate = data[i];
                        recordToUpdate.active = pBooleanValue;
                        //console.log("'pending_commercial_docs' => recordToUpdate.active = " + recordToUpdate.active);

                        //Save the record
                        data.$save(recordToUpdate)
                            .then(function(ref) {
                                //console.log("[ReceiptItbController] => updateActiveFieldForPendingCommercialDocs() => Record updated with 'itb_bidders' key " + pItbBidderKey);
                            })
                    
                            .catch(function(error) {
                                //console.log("[ReceiptItbController] => updateActiveFieldForPendingCommercialDocs() ERROR in update process => " + error);
                            });
                    }
                })

                .catch(function(error) {
                    //console.log("[ReceiptItbController] => updateActiveFieldForPendingCommercialDocs() ERROR => " + error);

                    addError("ReceiptItbController / updateActiveFieldForPendingCommercialDocs() function",error);
            });
        }


        function updateActiveFieldForPendingGeneralDocs(pItbBidderKey,pBooleanValue) {

//            var fbUrl = new Firebase(FIREBASE_URL + "/pending_general_docs/");
            var fbUrl = firebaseDataService.pending_general_docs;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {
        
                    var arrayLength = 0;

                    try {
                        arrayLength = data.length;
                    } catch (error) {
                        arrayLength = 0;
                    }

                    for (var i=0;i<arrayLength;i++) {

                        var recordToUpdate = data[i];
                        recordToUpdate.active = pBooleanValue;
                        //console.log("'pending_general_docs' => recordToUpdate.active = " + recordToUpdate.active);

                        //Save the record
                        data.$save(recordToUpdate)
                            .then(function(ref) {
                                //console.log("[ReceiptItbController] => updateActiveFieldForPendingGeneralDocs() => Record updated with 'itb_bidders' key " + pItbBidderKey);
                            })
                    
                            .catch(function(error) {
                                //console.log("[ReceiptItbController] => updateActiveFieldForPendingGeneralDocs() ERROR in update process => " + error);
                            });
                    }
                })

                .catch(function(error) {
                    //console.log("[ReceiptItbController] => updateActiveFieldForPendingGeneralDocs() ERROR => " + error);

                    addError("ReceiptItbController / updateActiveFieldForPendingGeneralDocs() function",error);
            });
        }



        function addAcceptedDeclinedInfoToTraceability(pBidderKey,pIsAccepted) {

            var bidder;
            
//            var fbUrl = new Firebase(FIREBASE_URL + "/bidders/" + pBidderKey);
            var fbUrl = firebaseDataService.bidders.child(pBidderKey);

            var result = $firebaseObject(fbUrl);

            result.$loaded()
                .then(function(data) {

                    bidder = data;

                    var emailLogin = loginService.getEmail();
                    var contactName = "";

                    if (bidder.email == emailLogin) {
                        contactName = bidder.maincontact;

                    } else if (bidder.email1 == emailLogin) {
                        contactName = bidder.name1;

                    } else if (bidder.email2 == emailLogin) {
                        contactName = bidder.name2;

                    } else if (bidder.email3 == emailLogin) {
                        contactName = bidder.name3;

                    } else if (bidder.email4 == emailLogin) {
                        contactName = bidder.name4;

                    }

                    var bidderName = loginService.getName();

                    if (pIsAccepted) {
                        vm.addTrace("User '" + contactName + "' from Bidder '" + bidderName + "' has accepted the invitation.");
                    } else {
                        vm.addTrace("User '" + contactName + "' from Bidder '" + bidderName + "' has declined the invitation.");
                    }

                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[ReceiptItbController] ERROR: " + error + "(Log Error: Controller: ReceiptItbController / Function: addAcceptedDeclinedInfoToTraceability())");

                    addError("ReceiptItbController / addAcceptedDeclinedInfoToTraceability() function",error);
            });

        }



        
        function updateItbDocsDownloaded(pValue,pItbBidderKey) {

//            var fbUrl = new Firebase(FIREBASE_URL + "/itb_bidders/");
            var fbUrl = firebaseDataService.itb_bidders;

            var result = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            result.$loaded()
                .then(function(data) {
        
                    var recordToUpdate = data[0];

                    recordToUpdate.docsDownloaded = true;
                    //console.log("recordToUpdate.docsDownloaded = " + recordToUpdate.docsDownloaded);

                    //Save the record
                    data.$save(recordToUpdate)
                        .then(function(ref) {
                            //console.log("[ReceiptItbController] => updateItbDocsDownloaded() => Record updated with 'itb_bidders' key " + ref.key);
                        })
                    
                        .catch(function(error) {
                            //console.log("[ReceiptItbController] => updateItbDocsDownloaded() ERROR in update process => " + error);
                        });
                    
                })

                .catch(function(error) {
                    //console.log("[ReceiptItbController] => updateItbDocsDownloaded() ERROR in loaded process => " + error);

                    addError("ReceiptItbController / updateItbDocsDownloaded() function",error);
                });
        }





        function updateItbBidder(pItbBidderKey) {

            var recordToUpdate;

//            var fbUrl = new Firebase(FIREBASE_URL + "/itb_bidders/");
            var fbUrl = firebaseDataService.itb_bidders;

            var records = $firebaseArray(fbUrl.orderByChild("itb_bidder_key").equalTo(pItbBidderKey));

            records.$loaded()
                .then(function(data) {

                    recordToUpdate = data[0];

                    recordToUpdate.bidderStatus = itbStatusService.getBidderStatus();
                    recordToUpdate.rejectReason = itbStatusService.getRejectReason();

                    records.$save(recordToUpdate)
                        .then(function(ref) {
                            //console.log("[ReceiptItbController] 'updateItbBidder()' method => Record saved with ID = " + ref.key);
                        })
                        .catch(function(error) {
                            //console.log("[ReceiptItbController] ERROR: " + error + "(Log Error 2: Controller: ReceiptItbController / Function: updateItbBidder())");
                    });            
                })

                .catch(function(error) {
                    //console.log("[ReceiptItbController] ERROR: " + error + " (Log Error 1: Controller: ReceiptItbController / Function: updateItbBidder())");

                    addError("ReceiptItbController / updateItbBidder() function",error);
            });
        }




        function selectFile() {
            //alert("EJECUTAMOS EL METODO 'selectFile()' ");
            angular.element(document.querySelector('#fileInput')).click();
        }



// (24/03/2025) - INICIO
/*
		//*****************************************
        function downloadFolderItbDocs() {

            var itbKey = itbStatusService.getItbKey();
            var itbName = itbStatusService.getItbName();

            var path = "/cdn/itb/" + itbKey + "_" + itbName + "/main_docs";

            var urlPost = 'https://api.dropboxapi.com/2/sharing/create_shared_link_with_settings'; 

            var dataToSend = '{"path": "' + path + '"' + ', "settings": {"requested_visibility": "public"}}';
            ////console.log("dataToSend = " + dataToSend);
            var config = {
                headers : {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    //console.log("FOLDER DOWNLOADED SUCCESSFULLY.");

                    var url = responseData.url + "?dl=1";
                    window.open(url,"_blank");  

                    //We update the "docsDownloaded" field of the "itb_bidders" table for Bidder selected
                    vm.updateItbDocsDownloaded(true,vm.itbBidderKeySelected);

                    if (itbStatusService.getBidderStatus() != "accepted") {
                        vm.showAcceptRejectButtons = true;   
                    }

                })
                .error(function (responseData, status, header, config) {

                    //console.log("ERROR DOWNLOADING THE FOLDER with 'create_shared_link_with_settings' dropbox method. We are going to try with 'list_shared_links' dropbox method (we execute 'getSharedLinkFolder()' app method): " + responseData.error_summary);

                    //IMPORTANT => If the shared folder link was already created we have to get its link to download the folder so we run "getSharedLinkFolder" method
                    vm.getSharedLinkFolder(path);

                }
            );

        }
*/

		//  (NUEVA VERSION)

		//********************************************
		function downloadFolderItbDocs() {
			var itbKey = itbStatusService.getItbKey();
			var itbName = itbStatusService.getItbName();
			var path = "/cdn/itb/" + itbKey + "_" + itbName + "/main_docs";

			var urlPost = "https://api.dropboxapi.com/2/sharing/create_shared_link_with_settings";
			var dataToSend = JSON.stringify({
				path: path,
				settings: { requested_visibility: "public" }
			});

			var config = {
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer " + ACCESS_TOKEN
				}
			};

			$http.post(urlPost, dataToSend, config)
				.then(function (response) {
					//console.log("FOLDER DOWNLOADED SUCCESSFULLY.");

					var url = response.data.url + "?dl=1";
					window.open(url, "_blank");

					// Actualiza el estado de documentos descargados
					vm.updateItbDocsDownloaded(true, vm.itbBidderKeySelected);

					if (itbStatusService.getBidderStatus() !== "accepted") {
						vm.showAcceptRejectButtons = true;
					}
				})
				.catch(function (error) {
					//console.log("ERROR DOWNLOADING THE FOLDER with 'create_shared_link_with_settings' Dropbox method.");

					if (error.status === 409) {
						//console.log("Shared link already exists. Fetching existing link using 'list_shared_links'...");
						vm.getSharedLinkFolder(path);
					} else {
						//console.log("Unexpected error: " + (error.data && error.data.error_summary ? error.data.error_summary : "Unknown error"));
					}
				});
		}

// (24/03/2025) - FIN


/*
		//*************************************
        function getSharedLinkFolder(pPath) {

            var urlPost = 'https://api.dropboxapi.com/2/sharing/list_shared_links'; 

            var dataToSend = '{"path": "' + pPath + '"}';
            ////console.log("dataToSend = " + dataToSend);
            var config = {
                headers : {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN
                }
            }
                
            $http.post(urlPost, dataToSend, config)
                .then(function (responseData, status, headers, config) {

                    //console.log("FOLDER DOWNLOADED SUCCESSFULLY.");

                    var url = responseData.links[0].url + "?dl=1";
                    window.open(url,"_blank");    

                    //We update the "docsDownloaded" field of the "itb_bidders" table for Bidder selected
                    vm.updateItbDocsDownloaded(true,vm.itbBidderKeySelected);

                    if (itbStatusService.getBidderStatus() != "accepted") {
                        vm.showAcceptRejectButtons = true;   
                    }

                })
                .catch(function (responseData, status, header, config) {

                    //console.log("ERROR DOWNLOADING THE FOLDER with 'list_shared_links' dropbox method: " + responseData.error_summary);

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("ReceiptItbController / getSharedLinkFolder() function",error);
                }
            );

        }
*/

		//  (NUEVA VERSION)
		//*****************************************
		function getSharedLinkFolder(pPath) {
			var metadataUrl = "https://api.dropboxapi.com/2/files/get_metadata";
			var listLinksUrl = "https://api.dropboxapi.com/2/sharing/list_shared_links";
			var createLinkUrl = "https://api.dropboxapi.com/2/sharing/create_shared_link_with_settings";

			var config = {
				headers: {
					"Content-Type": "application/json",
					"Authorization": "Bearer " + ACCESS_TOKEN
				}
			};

			// Primero, verificamos si la carpeta existe
			$http.post(metadataUrl, JSON.stringify({ path: pPath }), config)
				.then(function () {
					// Si la carpeta existe, buscamos enlaces compartidos
					return $http.post(listLinksUrl, JSON.stringify({ path: pPath }), config);
				})
				.then(function (response) {
					var responseData = response.data;

					if (responseData.links && responseData.links.length > 0) {
						//console.log("FOLDER SHARED LINK FOUND. DOWNLOADING...");

						var url = responseData.links[0].url + "?dl=1";
						window.open(url, "_blank");

						vm.updateItbDocsDownloaded(true, vm.itbBidderKeySelected);

						if (itbStatusService.getBidderStatus() !== "accepted") {
							vm.showAcceptRejectButtons = true;
						}
					} else {
						//console.log("No shared link found. Creating a new one...");
						return $http.post(createLinkUrl, JSON.stringify({ path: pPath, settings: { requested_visibility: "public" } }), config);
					}
				})
				.then(function (createResponse) {
					if (createResponse && createResponse.data && createResponse.data.url) {
						//console.log("NEW SHARED LINK CREATED SUCCESSFULLY. DOWNLOADING...");

						var url = createResponse.data.url + "?dl=1";
						window.open(url, "_blank");

						vm.updateItbDocsDownloaded(true, vm.itbBidderKeySelected);

						if (itbStatusService.getBidderStatus() !== "accepted") {
							vm.showAcceptRejectButtons = true;
						}
					}
				})
				.catch(function (error) {
					var errorMsg = (error.data && error.data.error_summary) ? error.data.error_summary : "Unknown error";
					//console.log("ERROR: " + errorMsg);

					if (errorMsg.includes("path/not_found")) {
						//console.log("ERROR: The specified folder does not exist in Dropbox.");
					}

					var fullError = "DROPBOX error: " + errorMsg + " / status: " + (error.status || "Unknown");
					addError("ReceiptItbController / getSharedLinkFolder()", fullError);
				});
		}





// (24/03/2025) - INICIO
/*
        //****************************
        function addTrace(pAction) {

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'date': data,
                        'time': '',
                        'dateTime': utilsService.getDateTime(),
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'action': pAction
                    };

                    traceabilityService.addTrace(recordToAdd);

                })
                .error(function () {
                    //console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/

		//  (NUEVA VERSION)
		
		//*****************************
		function addTrace(pAction) {

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {
					//console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);

					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'date': data,
						'time': '',
						'dateTime': utilsService.getDateTime(),
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'action': pAction
					};

					traceabilityService.addTrace(recordToAdd);

				})
				.catch(function () {
					//console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
				});
		}
// (24/03/2025) - FIN


// (24/03/2025) - INICIO
/*
		//******************************************
        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
*/

		//  (NUEVA VERSION)
		//************************************
		function addError(pLocation, pError) {

			// We need to convert pError parameter to string
			var stringError = pError.toString();

			// Remove ' characters from the pError string
			var pattern = /'/g;
			stringError = stringError.replace(pattern, '');

			// Remove " characters from the pError string
			var pattern = /"/g;
			stringError = stringError.replace(pattern, '');

			// FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
			utilsService.getCETdateTime()
				.then(function (data) {
					////console.log(">>> CET DateTime string = " + data);
					
					var recordToAdd = {
						'user': loginService.getName(),
						'user_key': loginService.getUserKey(),
						'company': loginService.getName(),
						'email': loginService.getEmail(),
						'userType': loginService.getUserProfile(),
						'dateTime': data,
						'itb_key': itbStatusService.getItbKey(),
						'itbName': itbStatusService.getItbName(),
						'location': pLocation,
						'error': stringError
					};

					errorLogService.addError(recordToAdd);

					//console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
				})
				.catch(function () {
					//console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
				});
		}
// (24/03/2025) - FIN		
		

		

        function redirectToSelectItb() {

            vm.workflow = workflowService.resetWorkflowStatus();
            
            //Ponemos el contador de la ITB a 0, lo ocultamos y mostramos vacío el título de la ITB
            itbStatusService.setCounterVisible(false);
            itbStatusService.setItbBidderKey("");

            $location.path("/workflow-bidder/select-itb");
        }


        function redirectToAddVessel() {

            workflowService.setSubmissionBidStatus(true);

            $location.path("/workflow-bidder/submission-bid/add-vessel");
        }


/*
        function redirectToUploadDocs() {
            $location.path("/workflow-admin/prepare-itb/upload-docs");
        }


        function redirectToTechnicalDocs() {
            $location.path("/workflow-admin/prepare-itb/technical-docs");
        }


        function redirectToCommercialDocs() {
            $location.path("/workflow-admin/prepare-itb/commercial-docs");
        }

        function redirectToGeneralInfo() {
            $location.path("/workflow-admin/prepare-itb/general-info");
        }
*/


        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';
        }


        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('CardFilters', CardFiltersService);

    /** @ngInject */
    function CardFiltersService()
    {
        var service = {
            name   : '',
            labels : [],
            members: [],
            clear  : clear,
            isOn   : isOn
        };

        /**
         * Clear
         */
        function clear()
        {
            service.name = '';
            service.labels = [];
            service.members = [];
        }

        /**
         * Is on
         *
         * @returns {boolean}
         */
        function isOn()
        {
            return (service.name === '' && service.labels.length === 0 && service.members.length === 0 ) ? false : true;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('DialogService', DialogService);

    /** @ngInject */
    function DialogService($mdDialog, $document)
    {
        var service = {
            openCardDialog: openCardDialog
        };

        //////////

        /**
         * Open card dialog
         *
         * @param ev
         * @param cardId
         */
        function openCardDialog(ev, cardId)
        {
            $mdDialog.show({
                templateUrl        : 'app/main/apps/scrumboard/dialogs/card/card-dialog.html',
                controller         : "ScrumboardCardDialogController",
                controllerAs       : "vm",
                parent             : $document.find('#scrumboard'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                locals             : {
                    cardId: cardId
                }
            });
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .factory('BoardService', BoardService);

    /** @ngInject */
    function BoardService($q, api)
    {
        var service = {
            data        : {},
            addNewBoard : addNewBoard,
            getBoardData: getBoardData
        };

        /**
         * Get board data from the server
         *
         * @param boardId
         * @returns {*}
         */
        function getBoardData(boardId)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            api.scrumboard.board.get({id: boardId},

                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Create an empty board object and set it.
         *
         * For the demonstration purposes, we are creating the
         * empty object in the javascript which you wouldn't do
         * it in real life. Rather, you would make an API call
         * to your server to generate an empty object that fills
         * some of the areas for you like an ID, labels, members
         * or the default board settings.
         *
         * Then you would grab the response that comes from
         * the API call and attach it to the service.data object.
         */
        function addNewBoard()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Here you would make an API call to your server...
            _generateEmptyScrumboardObject().then(
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the response
                    deferred.resolve(response);
                },
                // ERROR
                function (response)
                {
                    // Reject the response
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Dummy function for generating an empty
         * scrumboard object for demonstration
         * purposes
         *
         * @private
         * returns {$promise}
         */
        function _generateEmptyScrumboardObject()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Fake id generator
            var id = parseInt(new Date().valueOf(), 16);

            // Prepare an empty scrumboard object
            var emptyObject = {
                data: {
                    name    : 'Untitled Board',
                    uri     : 'untitled-board',
                    id      : id,
                    settings: {
                        color          : '',
                        subscribed     : false,
                        cardCoverImages: true
                    },
                    lists   : [],
                    cards   : [],
                    members : [
                        {
                            id    : '56027c1930450d8bf7b10758',
                            name  : 'Alice Freeman',
                            avatar: 'assets/images/avatars/alice.jpg'
                        },
                        {
                            id    : '26027s1930450d8bf7b10828',
                            name  : 'Danielle Obrien',
                            avatar: 'assets/images/avatars/danielle.jpg'
                        },
                        {
                            id    : '76027g1930450d8bf7b10958',
                            name  : 'James Lewis',
                            avatar: 'assets/images/avatars/james.jpg'
                        },
                        {
                            id    : '36027j1930450d8bf7b10158',
                            name  : 'Vincent Munoz',
                            avatar: 'assets/images/avatars/vincent.jpg'
                        }
                    ],
                    labels  : [
                        {
                            id   : '26022e4129ad3a5sc28b36cd',
                            name : 'High Priority',
                            color: 'red'
                        },
                        {
                            id   : '56027e4119ad3a5dc28b36cd',
                            name : 'Design',
                            color: 'orange'
                        },
                        {
                            id   : '5640635e19ad3a5dc21416b2',
                            name : 'App',
                            color: 'blue'
                        },
                        {
                            id   : '6540635g19ad3s5dc31412b2',
                            name : 'Feature',
                            color: 'green'
                        }
                    ]
                }
            };

            // Resolve the promise
            deferred.resolve(emptyObject);

            return deferred.promise;
        }

        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.management.traceability', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.management_traceability', {
            url      : '/management/traceability',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/management/traceability/traceability.html',
                    controller : 'TraceabilityController as vm'
                }
            },


            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'traceability'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/management/traceability');

        // Navigation
        msNavigationServiceProvider.saveItem('management.traceability', {
            title : 'TRACEABILITY',
            state : 'app.management_traceability',
            icon  : 'icon-numeric-5-box',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.management.traceability')
        .controller('TraceabilityController', TraceabilityController);

    /** @ngInject */
    function TraceabilityController()
    {
        var vm = this;

        vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableColumnMenus: false,
        };

        vm.gridOptions.columnDefs = [
                { name:'User', field: 'user' },
                { name:'Action', field: 'action' },
                { name:'Date', field: 'date' },
        ];

        vm.gridOptions.data = [      
                {"user": "Michel Smits",
                 "action": "Create folder",
                 "date": "10/01/2016 12:30",
                },
                {"user": "Alain Lavigne",
                 "action": "Upload document",
                 "date": "10/01/2016 16:30",
                },
                {"user": "Bidder 1",
                 "action": "Download document",
                 "date": "11/01/2016 09:30",
                },
                {"user": "Tim Anderson",
                 "action": "Create question",
                 "date": "12/01/2016 10:00",
                }
        ];

        // Data
        vm.currentView = 'list';

        vm.toggleView = toggleView;
    
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';
        }
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.management.itb', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.management_itb', {
            url      : '/management/itb',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/management/itb/itb.html',
                    controller : 'ItbController as vm'
                }
            },


            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'itb'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/management/itb');

        // Navigation
        msNavigationServiceProvider.saveItem('management.itb', {
            title : 'ITB',
            state : 'app.management_itb',
            icon  : 'icon-numeric-4-box',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.management.itb')
        .controller('ItbController', ItbController);

    /** @ngInject */
    function ItbController($scope,$timeout,$firebaseArray,firebaseDataService,FIREBASE_URL)
    {
        // DECLARATIONS ***********************
        var vm = this;

        vm.itbs;
        vm.gridOptions;
        vm.gridApi;
        vm.selectedItb = null;
        vm.selectedRow = null;
        vm.selectedRowId = null;
        vm.selectedRowName = null;
        vm.currentView = 'list';
        vm.operation = "";

        vm.date_commencement;
        vm.date_closing;
        vm.time_commencement;
        vm.time_closing;

        vm.timeList;
    
        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.getItbs = getItbs;
        vm.getCharterers = getCharterers;
        vm.initValues = initValues;
        vm.initGrid = initGrid;
        vm.loadGrid = loadGrid;

        vm.addItb = addItb;
        vm.saveItb = saveItb;
        vm.deleteItb = deleteItb;
//        vm.modifyitb = modifyitb;

        vm.convertDateToString = convertDateToString;
//        vm.formatDate = formatDate;

        vm.assignChartererName = assignChartererName;

        vm.toggleView = toggleView;


        //START CONTROLLER *******************************
        vm.executeController();

/*
        $scope.$watch('vm.itbs.length', function(current, original) {

            //console.log('(WATCH) vm.itbs.length was %s', original);

            //console.log('(WATCH) vm.itbs.length is now %s', current);

        });
*/


        // METHODS ****************
        function executeController() {

            //Initialization of the values
            vm.initValues();

            //Initialization of the Grid
            vm.initGrid();

            //itbs list obtained from FIREBASE
            vm.itbs = vm.getItbs();

            //charterers list obtained from FIREBASE
            vm.charterers = vm.getCharterers();

            //console.log("(1) Get itbs list START");            
        }



        function initValues() {

            vm.timeList =  [
                { id: 1, name: '00:00' },
                { id: 2, name: '00:30' },
                { id: 3, name: '01:00' },
                { id: 4, name: '01:30' },
                { id: 5, name: '02:00' },
                { id: 6, name: '02:30' },
                { id: 7, name: '03:00' },
                { id: 8, name: '03:30' },
                { id: 9, name: '04:00' },
                { id: 10, name: '04:30' },
                { id: 11, name: '05:00' },
                { id: 12, name: '05:30' },
                { id: 13, name: '06:00' },
                { id: 14, name: '06:30' },
                { id: 15, name: '07:00' },
                { id: 16, name: '07:30' },
                { id: 17, name: '08:00' },
                { id: 18, name: '08:30' },
                { id: 19, name: '09:00' },
                { id: 20, name: '09:30' },
                { id: 21, name: '10:00' },
                { id: 22, name: '10:30' },
                { id: 23, name: '11:00' },
                { id: 24, name: '11:30' },
                { id: 25, name: '12:00' },
                { id: 26, name: '12:30' },
                { id: 27, name: '13:00' },
                { id: 28, name: '13:30' },
                { id: 29, name: '14:00' },
                { id: 30, name: '14:30' },
                { id: 31, name: '15:00' },
                { id: 32, name: '15:30' },
                { id: 33, name: '16:00' },
                { id: 34, name: '16:30' },
                { id: 35, name: '17:00' },
                { id: 36, name: '17:30' },
                { id: 37, name: '18:00' },
                { id: 38, name: '18:30' },
                { id: 39, name: '19:00' },
                { id: 40, name: '19:30' },
                { id: 41, name: '20:00' },
                { id: 42, name: '20:30' },
                { id: 43, name: '21:00' },
                { id: 44, name: '21:30' },
                { id: 45, name: '22:00' },
                { id: 46, name: '22:30' },
                { id: 47, name: '23:00' },
                { id: 48, name: '23:30' }
            ];

            vm.date_commencement = new Date();
            vm.date_closing = new Date();

            vm.time_commencement = "00:00";
            vm.time_closing = "00:00";
        }


        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableColumnMenus: false,

                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedItb = row.entity;

                        try {
                            vm.date_commencement = new Date(row.entity.commencementDate);
                        } catch(e) {
                            vm.date_commencement = new Date();
                        }

                        try {
                            vm.date_closing = new Date(row.entity.closingDate);
                        } catch(e) {
                            vm.date_closing = new Date();
                        }

                        if (row.entity.commencementTime == undefined) {
                            row.entity.commencementTime = "00:00";
                        }

                        if (row.entity.closingTime == undefined) {
                            row.entity.closingTime = "00:00";
                        }

                        vm.time_commencement = row.entity.commencementTime;
                        vm.time_closing = row.entity.closingTime;

                        //console.log("Selected Row KEY = " + vm.selectedItb.$id);
                        //console.log("Selected Row TITLE = " + vm.selectedItb.title);
                    });
                    
                }
            };

            vm.gridOptions.columnDefs = [
                { name:'Reference', field: 'reference', width: '15%'  },
                { name:'Charterers\' Ref', field: 'charterersReference', width: '15%'  },
                { name:' ', field: 'charterer_key', width: '0%', visible: false },
                { name:'Charterer', field: 'charterer', width: '20%' },
                { name:'Title', field: 'title', width: '25%'  },
                { name:'Commencement', field: 'commencementDate', width: '12%'  },
                { name:'Closing', field: 'closingDate', width: '13%'  }
            ];
        }


        function assignChartererName(pChartererKeySelected) {

            //We find the charterer object whose key was selected in the combobox at the detail view
            var charterer = vm.charterers.find(findChartererName);

            //We assign the charterer name (charterer company) to selectedItb.charterer property.
            vm.selectedItb.charterer = charterer.company;
        }


        function findChartererName(pCharterer) {
            return pCharterer.$id === vm.selectedItb.charterer_key;
        }


/*
IMPLEMENTACIÓN DE LA FUNCIÓN $timeout() para obtener la FILA SELECCIONADA => PROBAR PARA VER SI FUNCIONA

      $timeout(function() {
        if($scope.gridApi.selection.selectRow){
          $scope.gridApi.selection.selectRow($scope.gridOptions.data[0]);
        }
      });
*/


        function getItbs() {

            //Get itbs list from Firebase        
            vm.itbs = $firebaseArray(firebaseDataService.itbs.orderByChild("closingDate"));            

            vm.itbs.$loaded()
                .then(function(data) {

                    //Assign itbs list to scope
                    vm.itbs = data;

                    //console.log("(2) itbs list LOADED with " + data.length + " rows.");

                    //Load the grid with de itbs list
                    vm.loadGrid(data)
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("ERROR: " + error);
                });
        }


        function getCharterers() {

            //Get itbs list from Firebase        
            vm.charterers = $firebaseArray(firebaseDataService.charterers.orderByChild("company"));

            vm.charterers.$loaded()
                .then(function(data) {

                    //Assign itbs list to scope
                    vm.charterers = data;

                    //console.log("[SelectItbController] (2) charterers list LOADED with " + data.length + " rows.");
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[SelectItbController] ERROR: " + error + " (Log Error: Controller: SelectItbController / Function: getCharterers())");
                });
        }


        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("(3) LOAD Grid DONE");
        }


/* MUY IMPORTANTE => ESTE CODIGO INSERTA CORRECTAMENTE LOS bidder_key relacionados de una ITB determinada 
        function addItb(itb) {

            vm.addBidderToItb("-KAKp-dTovVdMcFGtfDe");
            vm.addBidderToItb("-KAKqRnyUxSVtaJuk2IM");
            vm.addBidderToItb("-KApd6k28n0otq3OU1hi");
            vm.addBidderToItb("-KApdbrJBEY5Dd2LIx1j");
        }

        function addBidderToItb(pBidderKey) 
        {
            var fbRef = new Firebase(FIREBASE_URL + "itbs/-KApZkzTPzSkgl2lBGQ1/bidders_status/");
            var bidders_status = $firebaseArray(fbRef);

            var stringBidderKey = '{"' + pBidderKey + '": true}';
            var jsonBidderKey = JSON.parse(stringBidderKey);
            
            bidders_status.$add(jsonBidderKey)
                .then(function(ref) {
                    //console.log("Operación PUSH i SET bidder_key ejecutada correctamente");
                }
            );
        }
 FIN CODIGO */

        function addItb(itb) 
        {
            if (itb != null) {

                //Assign default values to status.
                itb.status = "created";

                //Convertion process to string with 'yyyy/MM/dd' format for date and time in order to insert in Firebase (FIREBASE ONLY ACCEPTS object, array, string, number, boolean and null types)
                var fecha1 = new Date(vm.date_commencement);
                itb.commencementDate = vm.convertDateToString(fecha1);

                //Convertion process to string with 'yyyy/MM/dd' format for date and time in order to insert in Firebase (FIREBASE ONLY ACCEPTS object, array, string, number, boolean and null types)
                var fecha2 = new Date(vm.date_closing);
                itb.closingDate = vm.convertDateToString(fecha2);

                itb.commencementTime = vm.time_commencement;
                itb.closingTime = vm.time_closing;

                vm.itbs.$add(itb)
                    .then(function(ref) {
                        //console.log("[ItbController] Added new record with KEY = " + ref.key);
                    }
                );
            }
        }


        function deleteItb() 
        {
            var itb = vm.selectedItb;
            //console.log("[ItbController] Admnistrator KEY = " + vm.selectedItb.$id);
            
            if (itb != null) {
                vm.itbs.$remove(itb)
                    .then(function(ref) {
                        //console.log("[ItbController] Delete record with ID = " + ref.key);
                    }
                );
            } else {
                //console.log("[ItbController] We can´t remove the row because there isn´t a selected row.");
            }
        }



        function saveItb() 
        {
            //console.log("[ItbController] START saveItb() method");

            var itb = vm.selectedItb;

            if (itb != null) {

                //console.log("[ItbController] ITB is not null => itb_key = " + itb.$id);

                //Convertion process to string with 'yyyy/MM/dd' format for date and time in order to insert in Firebase (FIREBASE ONLY ACCEPTS object, array, string, number, boolean and null types)
                var fecha1 = new Date(vm.date_commencement);
                itb.commencementDate = vm.convertDateToString(fecha1);

                //Convertion process to string with 'yyyy/MM/dd' format for date and time in order to insert in Firebase (FIREBASE ONLY ACCEPTS object, array, string, number, boolean and null types)
                var fecha2 = new Date(vm.date_closing);
                itb.closingDate = vm.convertDateToString(fecha2);

                itb.commencementTime = vm.time_commencement;
                itb.closingTime = vm.time_closing;

                vm.itbs.$save(itb)
                    .then(function(ref) {
                        //console.log("[ItbController] Saved record with itb_key = " + ref.key);
                    }
                );
            }
        }


        function convertDateToString(pFecha) {

            //Convert Date to string with 'yyyy/MM/dd' format
            return pFecha.getFullYear() + "/" + (pFecha.getMonth()+1) + "/" + pFecha.getDate();
        }


        function toggleView(method)
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';

            var itb = vm.selectedItb;

            if (vm.currentView == "detail") {

                if (method == "modify") {

                    vm.operation = "modify";

                } else {
                    vm.operation = "insert";

                    //We initilize values for the new ITB
                    vm.selectedItb = null;
                    vm.date_commencement = new Date();
                    vm.date_closing = new Date();
                    vm.time_commencement = "00:00";
                    vm.time_closing = "00:00";
                }
            }

            if (vm.currentView == "list") {

                if (method == "save") {

                    if (vm.operation == "modify") {
                        //console.log("We are going to execute saveItb() method with key = " + itb.$id);
                        vm.saveItb();
                    } else {
                        //console.log("We are going to execute addItb() method");
                        vm.addItb(itb);
                    }

                }
            }
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.management.charterer', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.management_charterer', {
            url      : '/management/charterer',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/management/charterer/charterer.html',
                    controller : 'ChartererController as vm'
                }
            },


            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'charterer'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/management/charterer');

        // Navigation
        msNavigationServiceProvider.saveItem('management.charterer', {
            title : 'CHARTERER',
            state : 'app.management_charterer',
            icon  : 'icon-numeric-2-box',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.management.charterer')
        .controller('ChartererController', ChartererController);

    /** @ngInject */
    function ChartererController($scope,$timeout,$firebaseArray,firebaseDataService)
    {
        // DECLARATIONS ***********************
        var vm = this;

        vm.charterers;
        vm.gridOptions;
        vm.gridApi;
        vm.selectedCharterer = null;
        vm.selectedRow = null;
        vm.selectedRowId = null;
        vm.selectedRowName = null;
        vm.currentView = 'list';
        vm.operation = "";
    
        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.getCharterers = getCharterers;
        vm.initGrid = initGrid;
        vm.loadGrid = loadGrid;

        vm.addCharterer = addCharterer;
        vm.saveCharterer = saveCharterer;
        vm.deleteCharterer = deleteCharterer;
//        vm.modifyCharterer = modifyCharterer;

        vm.toggleView = toggleView;


        //START CONTROLLER *******************************
        vm.executeController();

/*
        $scope.$watch('vm.charterers.length', function(current, original) {

            //console.log('(WATCH) vm.charterers.length was %s', original);

            //console.log('(WATCH) vm.charterers.length is now %s', current);

        });
*/


        // METHODS ****************
        function executeController() {

            //Initialization of the Grid
            vm.initGrid();

            //Charterers list obtained from FIREBASE
            vm.charterers = vm.getCharterers();

            //console.log("(1) Get Charterers list START");            
        }


        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableColumnMenus: false,

                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedCharterer = row.entity;
                        //console.log("Selected Row KEY = " + vm.selectedCharterer.$id);
                        //console.log("Selected Row COMPANY = " + vm.selectedCharterer.company);
                    });
                    
                }
            };

            vm.gridOptions.columnDefs = [
                { name:'Company', field: 'company'},
                { name:'E-mail', field: 'email'},
                { name:'Contact', field: 'contact'},
                { name:'Phone', field: 'phone'},
                { name:'City', field: 'city'}
            ];
        }



/*
IMPLEMENTACIÓN DE LA FUNCIÓN $timeout() para obtener la FILA SELECCIONADA => PROBAR PARA VER SI FUNCIONA

      $timeout(function() {
        if($scope.gridApi.selection.selectRow){
          $scope.gridApi.selection.selectRow($scope.gridOptions.data[0]);
        }
      });
*/


        function getCharterers() {

            //Get Charterers list from Firebase        
            vm.charterers = $firebaseArray(firebaseDataService.charterers);

            vm.charterers.$loaded()
                .then(function(data) {

                    //Assign Charterers list to scope
                    vm.charterers = data;

                    //console.log("(2) Charterers list LOADED with " + data.length + " rows.");

                    //Load the grid with de Charterers list
                    vm.loadGrid(data)
                })

                .catch(function(error) {
                    //console.log("ERROR: " + error);
                });
        }


        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("(3) LOAD Grid DONE");
        }


        function addCharterer(charterer) 
        {
            if (charterer != null) {
                vm.charterers.$add(charterer)
                    .then(function(ref) {
                        //console.log("Added new record with ID = " + ref.key);
                    }
                );
            }
        }


        function deleteCharterer() 
        {
            var charterer = vm.selectedCharterer;
            //console.log("Admnistrator KEY = " + vm.selectedCharterer.$id);
            
            if (charterer != null) {
                vm.charterers.$remove(charterer)
                    .then(function(ref) {
                        //console.log("Delete record with ID = " + ref.key);
                    }
                );
            } else {
                //console.log("We can´t remove the row because there isn´t a selected row.");
            }
        }


        function saveCharterer() 
        {
            //console.log("START saveCharterer() method");

            var charterer = vm.selectedCharterer;

            if (charterer != null) {

                //console.log("Charterer is not null => Charterer.$id = " + charterer.$id);
                //console.log("vm.charterers.length = " + vm.charterers.length);

                vm.charterers.$save(charterer)
                    .then(function(ref) {
                        //console.log("Saved record with ID = " + ref.key);
                    }
                );
            }
        }



        function toggleView(method)
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';

            var charterer = vm.selectedCharterer;

            if (vm.currentView == "detail") {

                if (method == "modify") {

                    vm.operation = "modify";

                } else {
                    vm.operation = "insert";
                    vm.selectedCharterer = null;
                }
            }

            if (vm.currentView == "list") {

                if (method == "save") {

                    if (vm.operation == "modify") {
                        //console.log("We are going to execute saveCharterer() method with key = " + charterer.$id);
                        vm.saveCharterer();
                    } else {
                        //console.log("We are going to execute addCharterer() method");
                        vm.addCharterer(charterer);
                    }

                }
            }
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.management.bidder', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.management_bidder', {
            url      : '/management/bidder',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/management/bidder/bidder.html',
                    controller : 'BidderController as vm'
                }
            },


            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'bidder'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/management/bidder');

        // Navigation
        msNavigationServiceProvider.saveItem('management.bidder', {
            title : 'BIDDER',
            state : 'app.management_bidder',
            icon  : 'icon-numeric-3-box',
            weight: 3
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.management.bidder')
        .controller('BidderController', BidderController);

    /** @ngInject */
    function BidderController($scope,$timeout,$firebaseArray,firebaseDataService,FIREBASE_URL)
    {
        // DECLARATIONS ***********************
        var vm = this;

        vm.bidders;
        vm.gridOptions;
        vm.gridApi;
        vm.selectedBidder = null;
        vm.selectedRow = null;
        vm.selectedRowId = null;
        vm.selectedRowName = null;
        vm.currentView = 'list';
        vm.operation = "";
    
        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.getBidders = getBidders;
        vm.initGrid = initGrid;
        vm.loadGrid = loadGrid;

        vm.addBidder = addBidder;
        vm.saveBidder = saveBidder;
        vm.deleteBidder = deleteBidder;

        vm.updateBidderCompanyInAllTables = updateBidderCompanyInAllTables;
        vm.updateBidderCompanyInTable = updateBidderCompanyInTable;

        vm.toggleView = toggleView;

        //START CONTROLLER *******************************
        vm.executeController();

/*
        $scope.$watch('vm.bidders.length', function(current, original) {

            //console.log('(WATCH) vm.bidders.length was %s', original);

            //console.log('(WATCH) vm.bidders.length is now %s', current);

        });
*/


        // METHODS ****************
        function executeController() {

            //Initialization of the Grid
            vm.initGrid();

            //bidders list obtained from FIREBASE
            vm.bidders = vm.getBidders();
        }


        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableColumnMenus: false,

                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedBidder = row.entity;
                        //console.log("Selected Row KEY = " + vm.selectedBidder.$id);
                        //console.log("Selected Row NAME = " + vm.selectedBidder.company);
                    });
                    
                }
            };

            vm.gridOptions.columnDefs = [
                { name:'Company', field: 'company'},
                { name:'E-mail', field: 'email'},
                { name:'Phone', field: 'mainphone'},
                { name:'Main Contact', field: 'maincontact'},
                { name:'City', field: 'city'}
            ];
        }



/*
IMPLEMENTACIÓN DE LA FUNCIÓN $timeout() para obtener la FILA SELECCIONADA => PROBAR PARA VER SI FUNCIONA

      $timeout(function() {
        if($scope.gridApi.selection.selectRow){
          $scope.gridApi.selection.selectRow($scope.gridOptions.data[0]);
        }
      });
*/


        function getBidders() {

            //console.log("(1) Get bidders list START");            

            //Get bidders list from Firebase        
            vm.bidders = $firebaseArray(firebaseDataService.bidders);

            vm.bidders.$loaded()
                .then(function(data) {

                    //Assign bidders list to scope
                    vm.bidders = data;

                    //console.log("(2) bidders list LOADED with " + data.length + " rows.");

                    //Load the grid with de bidders list
                    vm.loadGrid(data)
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("ERROR: " + error);
                });
        }


        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("(3) LOAD Grid DONE");
        }


        function addBidder(bidder) 
        {
            if (bidder != null) {
                vm.bidders.$add(bidder)
                    .then(function(ref) {
                        //console.log("Added new record with ID = " + ref.key);
                    }
                );
            }
        }


        function deleteBidder() 
        {
            var bidder = vm.selectedBidder;
            //console.log("Bidder KEY = " + vm.selectedBidder.$id);
            
            if (bidder != null) {
                vm.bidders.$remove(bidder)
                    .then(function(ref) {
                        //console.log("Delete record with ID = " + ref.key);
                    }
                );
            } else {
                //console.log("We can´t remove the row because there isn´t a selected row.");
            }
        }


        function saveBidder() 
        {
            //console.log("START saveBidder() method");

            var bidder = vm.selectedBidder;

            if (bidder != null) {

                //console.log("bidder is not null => bidder.$id = " + bidder.$id);
                //console.log("vm.bidders.length = " + vm.bidders.length);

                vm.bidders.$save(bidder)
                    .then(function(ref) {

                        //console.log("Saved record with ID = " + ref.key);
                        
                        //Update the field "bidderCompany" in tables "itb_bidders", "pendind_technical_docs", "pending_commercial_docs"
                        var bidderKey = ref.key;
                        var bidderCompany = bidder.company;
                        vm.updateBidderCompanyInAllTables(bidderKey,bidderCompany);
                    }
                );
            }
        }


        //Update the field "bidderCompany" in tables "itb_bidders", "pendind_technical_docs", "pending_commercial_docs"
        function updateBidderCompanyInAllTables(pBidderKey,pBidderCompany)
        {
            vm.updateBidderCompanyInTable("itb_bidders",pBidderKey,pBidderCompany);

            vm.updateBidderCompanyInTable("pending_technical_docs",pBidderKey,pBidderCompany);

            vm.updateBidderCompanyInTable("pending_commercial_docs",pBidderKey,pBidderCompany);
        }


        function updateBidderCompanyInTable(pTableName,pBidderKey,pBidderCompany)
        {
            //For table "itb_bidders"
            var fbUrl = new Firebase(FIREBASE_URL + "/" + pTableName + "/");
            var records = $firebaseArray(fbUrl.orderByChild("bidder_key").equalTo(pBidderKey));

            records.$loaded()
                .then(function(data) {

                    for (var i=0; i<records.length;i++) {

                        records[i].bidderCompany = pBidderCompany;                       

                        records.$save(records[i])
                            .then(function(ref) {

                                //console.log("[BidderController] Saved record in function 'updateBidderCompanyInAllTables' for '" + pTableName + "' table with ID = " + ref.key);
                            })
                            .catch(function(error) {
                                //vm.gridOptions.data = null;
                                //console.log("[BidderController] ERROR (save method) in function 'updateBidderCompanyInAllTables' for '" + pTableName + "' table: " + error);
                            });
                    }

                })
                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[BidderController] ERROR (loaded method) in function 'updateBidderCompanyInAllTables' for '" + pTableName + "' table: " + error);
                });
        }



        function toggleView(method)
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';

            var bidder = vm.selectedBidder;

            if (vm.currentView == "detail") {

                if (method == "modify") {

                    vm.operation = "modify";

                } else {
                    vm.operation = "insert";
                    vm.selectedBidder = null;
                }
            }

            if (vm.currentView == "list") {

                if (method == "save") {

                    if (vm.operation == "modify") {
                        //console.log("We are going to execute saveBidder() method with key = " + bidder.$id);
                        vm.saveBidder();
                    } else {
                        //console.log("We are going to execute addBidder() method");
                        vm.addBidder(bidder);
                    }

                }
            }
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.management.administrator', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.management_administrator', {
            url      : '/management/administrator',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/management/administrator/administrator.html',
                    controller : 'AdministratorController as vm'
                }
            },


            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'administrator'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/management/administrator');

        // Navigation
        msNavigationServiceProvider.saveItem('management.administrator', {
            title : 'ADMINISTRATOR',
            state : 'app.management_administrator',
            icon  : 'icon-numeric-1-box',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.management.administrator')
        .controller('AdministratorController', AdministratorController);

    /** @ngInject */
    function AdministratorController($scope,$timeout,$firebaseArray,firebaseDataService)
    {
        // DECLARATIONS ***********************
        var vm = this;

        vm.administrators;
        vm.gridOptions;
        vm.gridApi;
        vm.selectedAdministrator = null;
        vm.selectedRow = null;
        vm.selectedRowId = null;
        vm.selectedRowName = null;
        vm.currentView = 'list';
        vm.operation = "";
    
        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.getAdministrators = getAdministrators;
        vm.initGrid = initGrid;
        vm.loadGrid = loadGrid;

        vm.addAdministrator = addAdministrator;
        vm.saveAdministrator = saveAdministrator;
        vm.deleteAdministrator = deleteAdministrator;
//        vm.modifyAdministrator = modifyAdministrator;

        vm.toggleView = toggleView;


        //START CONTROLLER *******************************
        vm.executeController();

/*
        $scope.$watch('vm.administrators.length', function(current, original) {

            //console.log('(WATCH) vm.administrators.length was %s', original);

            //console.log('(WATCH) vm.administrators.length is now %s', current);

        });
*/


        // METHODS ****************
        function executeController() {

            //Initialization of the Grid
            vm.initGrid();

            //Administrators list obtained from FIREBASE
            vm.administrators = vm.getAdministrators();

            //console.log("(1) Get Administrators list START");            
        }


        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: true,
                enableColumnMenus: false,

                onRegisterApi: function(gridApi) {
                    vm.gridApi = gridApi;
                  
                    vm.gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        
                        vm.selectedAdministrator = row.entity;
                        //console.log("Selected Row KEY = " + vm.selectedAdministrator.$id);
                        //console.log("Selected Row NAME = " + vm.selectedAdministrator.name);
                    });
                    
                }
            };

            vm.gridOptions.columnDefs = [
                    { name:'Name', field: 'name' },
                    { name:'E-mail', field: 'email' }
            ];
        }



/*
IMPLEMENTACIÓN DE LA FUNCIÓN $timeout() para obtener la FILA SELECCIONADA => PROBAR PARA VER SI FUNCIONA

      $timeout(function() {
        if($scope.gridApi.selection.selectRow){
          $scope.gridApi.selection.selectRow($scope.gridOptions.data[0]);
        }
      });
*/


        function getAdministrators() {

            //Get Administrators list from Firebase        
            vm.administrators = $firebaseArray(firebaseDataService.administrators);

            vm.administrators.$loaded()
                .then(function(data) {

                    //Assign administrators list to scope
                    vm.administrators = data;

                    //console.log("(2) Administrators list LOADED with " + data.length + " rows.");

                    //Load the grid with de administrators list
                    vm.loadGrid(data)
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("ERROR: " + error);
                });
        }


        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("(3) LOAD Grid DONE");
        }


        function addAdministrator(administrator) 
        {
            if (administrator != null) {
                vm.administrators.$add(administrator)
                    .then(function(ref) {
                        //console.log("Added new record with ID = " + ref.key);
                    }
                );
            }
        }


        function deleteAdministrator() 
        {
            var administrator = vm.selectedAdministrator;
            //console.log("Admnistrator KEY = " + vm.selectedAdministrator.$id);
            
            if (administrator != null) {
                vm.administrators.$remove(administrator)
                    .then(function(ref) {
                        //console.log("Delete record with ID = " + ref.key);
                    }
                );
            } else {
                //console.log("We can´t remove the row because there isn´t a selected row.");
            }
        }


        function saveAdministrator() 
        {
            //console.log("START saveAdministrator() method");

            var administrator = vm.selectedAdministrator;

            if (administrator != null) {

                //console.log("administrator is not null => administrator.$id = " + administrator.$id);
                //console.log("vm.administrators.length = " + vm.administrators.length);

                vm.administrators.$save(administrator)
                    .then(function(ref) {
                        //console.log("Saved record with ID = " + ref.key);
                    }
                );
            }
        }



        function toggleView(method)
        {
            vm.currentView = vm.currentView === 'list' ? 'detail' : 'list';

            var administrator = vm.selectedAdministrator;

            if (vm.currentView == "detail") {

                if (method == "modify") {

                    vm.operation = "modify";

                } else {
                    vm.operation = "insert";
                    vm.selectedAdministrator = null;
                }
            }

            if (vm.currentView == "list") {

                if (method == "save") {

                    if (vm.operation == "modify") {
                        //console.log("We are going to execute saveAdministrator() method with key = " + administrator.$id);
                        vm.saveAdministrator();
                    } else {
                        //console.log("We are going to execute addAdministrator() method");
                        vm.addAdministrator(administrator);
                    }

                }
            }
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboards_server', {
            url      : '/dashboard-server',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/server/dashboard-server.html',
                    controller : 'DashboardServerController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server')
        .controller('DashboardServerController', DashboardServerController);

    /** @ngInject */
    function DashboardServerController($scope, $interval, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;

        // Widget 1
        vm.widget1 = {
            title: vm.dashboardData.widget1.title,
            chart: {
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#4caf50', '#3f51b5', '#ff5722'],
                        height                 : 320,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 32,
                            left  : 48
                        },
                        useInteractiveGuideline: true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' min.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' MB';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.chart
            }
        };

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = {
            title   : vm.dashboardData.widget4.title,
            value   : vm.dashboardData.widget4.value,
            footnote: vm.dashboardData.widget4.footnote,
            detail  : vm.dashboardData.widget4.detail,
            chart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'lineChart',
                        color       : ['rgba(0, 0, 0, 0.27)'],
                        height      : 50,
                        margin      : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        duration    : 1,
                        clipEdge    : true,
                        interpolate : 'cardinal',
                        interactive : false,
                        isArea      : true,
                        showLegend  : false,
                        showControls: false,
                        showXAxis   : false,
                        showYAxis   : false,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yDomain     : [0, 4]
                    }
                },
                data   : vm.dashboardData.widget4.chart
            },
            init    : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget4.chart[0].values.length - 1,
                    x = vm.dashboardData.widget4.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function latencyTicker(min, max)
                {
                    // Increase the x value
                    x++;

                    var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

                    var newValue = {
                        x: x,
                        y: randomNumber
                    };

                    vm.widget4.chart.data[0].values.shift();
                    vm.widget4.chart.data[0].values.push(newValue);

                    // Randomize the value
                    vm.widget4.value = 20 + randomNumber + 'ms';
                }

                // Set interval
                var latencyTickerInterval = $interval(function ()
                {
                    latencyTicker(1, 4);
                }, 1000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(latencyTickerInterval);
                });
            }
        };

        // Widget 5
        vm.widget5 = vm.dashboardData.widget5;

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            chart: {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 140,
                        margin                 : {
                            top   : 8,
                            right : 32,
                            bottom: 16,
                            left  : 48
                        },
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        showLegend             : false,
                        showControls           : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 100],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' sec.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + '%';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data   : vm.dashboardData.widget6.chart
            },
            init : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget6.chart[0].values.length - 1,
                    x = vm.dashboardData.widget6.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function cpuTicker(min, max)
                {
                    // Increase the x value
                    x = x + 5;

                    var newValue = {
                        x: x,
                        y: Math.floor(Math.random() * (max - min + 1)) + min
                    };

                    vm.widget6.chart.data[0].values.shift();
                    vm.widget6.chart.data[0].values.push(newValue);
                }

                // Set interval
                var cpuTickerInterval = $interval(function ()
                {
                    cpuTicker(0, 100);
                }, 5000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(cpuTickerInterval);
                });
            }
        };

        // Widget 7
        vm.widget7 = {
            title    : vm.dashboardData.widget7.title,
            table    : vm.dashboardData.widget7.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                pageLength: 10,
                lengthMenu: [10, 20, 50, 100],
                autoWidth : false,
                responsive: true,
                columnDefs: [
                    {
                        width  : '20%',
                        targets: [0, 1, 2, 3, 4]
                    }
                ],
                columns   : [
                    {},
                    {},
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + ' KB/s';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + '%';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                var el = angular.element(data);
                                el.html(el.text() + ' MB');

                                return el[0].outerHTML;
                            }
                            else
                            {
                                return data;
                            }
                        }
                    }
                ]
            }
        };

        // Widget 8
        vm.widget8 = vm.dashboardData.widget8;

        // Methods

        //////////

        // Init Widget 4
        vm.widget4.init();

        // Init Widget 6
        vm.widget6.init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboards_project', {
            url      : '/dashboard-project',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller : 'DashboardProjectController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.project@get');
                }
            },
            bodyClass: 'dashboard-project'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($scope, $interval, $mdSidenav, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.projects = vm.dashboardData.projects;

        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title       : vm.dashboardData.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            supporting  : {
                widgets: {
                    created  : {
                        data : vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed   : {
                        data : vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened : {
                        data : vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix  : {
                        data : vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data : vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed    : {
                        data : vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart  : {
                    config : {
                        refreshDataOnly: true,
                        deepWatchData  : true
                    },
                    options: {
                        chart: {
                            type                   : 'lineChart',
                            color                  : ['#03A9F4'],
                            height                 : 50,
                            margin                 : {
                                top   : 8,
                                right : 0,
                                bottom: 0,
                                left  : 0
                            },
                            isArea                 : true,
                            interpolate            : 'cardinal',
                            clipEdge               : true,
                            duration               : 500,
                            showXAxis              : false,
                            showYAxis              : false,
                            showLegend             : false,
                            useInteractiveGuideline: true,
                            x                      : function (d)
                            {
                                return d.x;
                            },
                            y                      : function (d)
                            {
                                return d.y;
                            },
                            yDomain                : [0, 9],
                            xAxis                  : {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer       : {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data   : []
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key   : widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title       : vm.dashboardData.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboardData.widget6.footerLeft,
            footerRight : vm.dashboardData.widget6.footerRight,
            ranges      : vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title       : vm.dashboardData.widget7.title,
            ranges      : vm.dashboardData.widget7.ranges,
            schedule    : vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title    : vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type     : 'pieChart',
                        color    : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height   : 400,
                        margin   : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        labelType: 'percent',
                        x        : function (d)
                        {
                            return d.label;
                        },
                        y        : function (d)
                        {
                            return d.value;
                        },
                        tooltip  : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title       : vm.dashboardData.widget9.title,
            weeklySpent : {
                title    : vm.dashboardData.widget9.weeklySpent.title,
                count    : vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent  : {
                title    : vm.dashboardData.widget9.totalSpent.title,
                count    : vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining   : {
                title    : vm.dashboardData.widget9.remaining.title,
                count    : vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget : vm.dashboardData.widget9.totalBudget,
            chart       : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#00BCD4'],
                        height                 : 50,
                        margin                 : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 9],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key   : vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title    : vm.dashboardData.widget11.title,
            table    : vm.dashboardData.widget11.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true,
                order     : [1, 'asc'],
                columnDefs: [
                    {
                        width    : '40',
                        orderable: false,
                        targets  : [0]
                    },
                    {
                        width  : '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now   : {
                second: '',
                minute: '',
                hour  : '',
                day   : '',
                month : '',
                year  : ''
            },
            ticker: function ()
            {
                var now = moment();
                vm.nowWidget.now = {
                    second : now.format('ss'),
                    minute : now.format('mm'),
                    hour   : now.format('HH'),
                    day    : now.format('D'),
                    weekDay: now.format('dddd'),
                    month  : now.format('MMMM'),
                    year   : now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project)
        {
            vm.selectedProject = project;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.dashboards_analytics', {
            url      : '/dashboard-analytics',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/analytics/dashboard-analytics.html',
                    controller : 'DashboardAnalyticsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (apiResolver)
                {
                    return apiResolver.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics')
        .controller('DashboardAnalyticsController', DashboardAnalyticsController);

    /** @ngInject */
    function DashboardAnalyticsController(DashboardData, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.widget1 = {
            title             : vm.dashboardData.widget1.title,
            onlineUsers       : vm.dashboardData.widget1.onlineUsers,
            bigChart          : {
                options: {
                    chart: {
                        type                   : 'lineWithFocusChart',
                        color                  : ['#2196F3'],
                        height                 : 400,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 64,
                            left  : 48
                        },
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        showLegend             : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        yAxis                  : {
                            showMaxMin: false
                        },
                        x2Axis                 : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        y2Axis                 : {
                            showMaxMin: false
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.bigChart.chart
            },
            sessions          : {
                title   : vm.dashboardData.widget1.sessions.title,
                value   : vm.dashboardData.widget1.sessions.value,
                previous: vm.dashboardData.widget1.sessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.sessions.chart
            },
            pageviews         : {
                title   : vm.dashboardData.widget1.pageviews.title,
                value   : vm.dashboardData.widget1.pageviews.value,
                previous: vm.dashboardData.widget1.pageviews.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#3F51B5'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pageviews.chart
            },
            pagesSessions     : {
                title   : vm.dashboardData.widget1.pagesSessions.title,
                value   : vm.dashboardData.widget1.pagesSessions.value,
                previous: vm.dashboardData.widget1.pagesSessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#E91E63'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pagesSessions.chart
            },
            avgSessionDuration: {
                title   : vm.dashboardData.widget1.avgSessionDuration.title,
                value   : vm.dashboardData.widget1.avgSessionDuration.value,
                previous: vm.dashboardData.widget1.avgSessionDuration.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#009688'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                var formatTime = d3.time.format('%M:%S');
                                return formatTime(new Date('2012', '0', '1', '0', '0', d));
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.avgSessionDuration.chart
            }
        };

        // Widget 2
        vm.widget2 = {
            title: vm.dashboardData.widget2.title
        };

        // Widget 3
        vm.widget3 = {
            title       : vm.dashboardData.widget3.title,
            pages       : vm.dashboardData.widget3.pages,
            ranges      : vm.dashboardData.widget3.ranges,
            currentRange: vm.dashboardData.widget3.currentRange,
            changeRange : function (range)
            {
                vm.widget3.currentRange(range);
            }
        };

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;


        // Methods

        //////////

        // Widget 2
        uiGmapGoogleMapApi.then(function ()
        {
            vm.widget2.map = vm.dashboardData.widget2.map;
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/quick-panel');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(api, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        api.quickPanel.contacts.get({}, function (response)
        {
            vm.contacts = response.data;
        });

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_typography', {
            url      : '/ui/typography',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/typography/typography.html',
                    controller : 'TypographyController as vm'
                }
            },
            bodyClass: 'typography'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography')
        .controller('TypographyController', TypographyController);

    /** @ngInject */
    function TypographyController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('ThemeColorsController', ThemeColorsController);

    /** @ngInject */
    function ThemeColorsController(fuseTheming, $mdDialog, $document)
    {
        var vm = this;
        // Data
        vm.themes = fuseTheming.themes;

        // Methods
        vm.createTheme = createTheme;
        //////////

        function createTheme(ev)
        {
            $mdDialog.show({
                controller         : 'CustomThemeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_material-colors', {
            url  : '/ui/material-colors',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/material-colors/material-colors.html',
                    controller : 'MaterialColorsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors')
        .controller('MaterialColorsController', MaterialColorsController);

    /** @ngInject */
    function MaterialColorsController($mdColorPalette)
    {
        var vm = this;

        // Data
        vm.palettes = $mdColorPalette;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_icons', {
            url      : '/ui/icons',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/icons/icons.html',
                    controller : 'IconsController as vm'
                }
            },
            resolve  : {
                Icons: function (apiResolver)
                {
                    return apiResolver.resolve('icons@get');
                }
            },
            bodyClass: 'icons'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons')
        .controller('IconsController', IconsController);

    /** @ngInject */
    function IconsController(Icons)
    {
        var vm = this;

        // Data
        vm.icons = Icons.icons;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_forms', {
            url      : '/ui/forms',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/forms/forms.html',
                    controller : 'FormsController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms')
        .controller('FormsController', FormsController);

    /** @ngInject */
    function FormsController($mdDialog)
    {
        var vm = this;

        // Data
        vm.basicForm = {};
        vm.formWizard = {};

        vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
        'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
        'WY').split(' ').map(function (state)
        {
            return {abbrev: state};
        });

        // Methods
        vm.sendForm = sendForm;

        //////////

        /**
         * Send form
         */
        function sendForm(ev)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    }
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });

            // Clear the form data
            vm.formWizard = {};
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_timeline', {
                url      : '/pages/timeline',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (apiResolver)
                    {
                        return apiResolver.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline'
            })
            .state('app.pages_timeline_left', {
                url      : '/pages/timeline-left',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-left.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (apiResolver)
                    {
                        return apiResolver.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-left'
            })
            .state('app.pages_timeline_right', {
                url      : '/pages/timeline-right',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-right.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (apiResolver)
                    {
                        return apiResolver.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-right'
            });

        // Navigation
        msNavigationServiceProvider.saveItem('pages.timeline', {
            title : 'Timeline',
            icon  : 'icon-view-stream',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('pages.timeline.default', {
            title: 'Default',
            state: 'app.pages_timeline'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.left-aligned', {
            title: 'Left Aligned',
            state: 'app.pages_timeline_left'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.right-aligned', {
            title: 'Right Aligned',
            state: 'app.pages_timeline_right'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline')
        .controller('TimelineController', TimelineController);

    /** @ngInject */
    function TimelineController($q, api, Timeline)
    {
        var vm = this;

        // Data
        vm.timeline = Timeline.data;
        vm.currentPage = 1;
        vm.totalPages = 3;
        vm.pauseScroll = false;

        // Methods
        vm.loadNextPage = loadNextPage;

        //////////

        /**
         * Load next page
         * @returns promise
         */
        function loadNextPage()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Increase the current page number
            vm.currentPage = vm.currentPage + 1;

            // Check if we still have pages that we can load
            if ( vm.currentPage > vm.totalPages )
            {
                // Reject the promise
                deferred.reject('No more pages');
            }
            else
            {
                // Emulate the api call and load new timeline items in
                var pageName = 'page' + vm.currentPage;

                api.timeline[pageName].get({},

                    // SUCCESS
                    function (response)
                    {
                        for ( var i = 0; i < response.data.length; i++ )
                        {
                            vm.timeline.push(response.data[i]);
                        }

                        // Resolve the promise
                        deferred.resolve(response);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_search', {
            url      : '/pages/search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/search/search.html',
                    controller : 'SearchController as vm'
                }
            },
            resolve  : {
                Classic : function (apiResolver)
                {
                    return apiResolver.resolve('search.classic@get');
                },
                Mails   : function (apiResolver)
                {
                    return apiResolver.resolve('search.mails@get');
                },
                Users   : function (apiResolver)
                {
                    return apiResolver.resolve('search.users@get');
                },
                Contacts: function (apiResolver)
                {
                    return apiResolver.resolve('search.contacts@get');
                }
            },
            bodyClass: 'search'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/search');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.search', {
            title : 'Search',
            icon  : 'icon-magnify',
            state : 'app.pages_search',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(Classic, Mails, Users, Contacts)
    {
        var vm = this;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.classic = Classic.data;
        vm.mails = Mails.data;
        vm.users = Users.data;
        vm.contacts = Contacts.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.pages_profile', {
            url      : '/pages/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            resolve  : {
                Timeline    : function (apiResolver)
                {
                    return apiResolver.resolve('profile.timeline@get');
                },
                About       : function (apiResolver)
                {
                    return apiResolver.resolve('profile.about@get');
                },
                PhotosVideos: function (apiResolver)
                {
                    return apiResolver.resolve('profile.photosVideos@get');
                }
            },
            bodyClass: 'profile'
        });

        $translatePartialLoaderProvider.addPart('app/main/pages/profile');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.profile', {
            title : 'Profile',
            icon  : 'icon-account',
            state : 'app.pages_profile',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(Timeline, About, PhotosVideos)
    {
        var vm = this;

        // Data
        vm.posts = Timeline.posts;
        vm.activities = Timeline.activities;
        vm.about = About.data;
        vm.photosVideos = PhotosVideos.data;

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');

/*
        // Navigation
        msNavigationServiceProvider.saveItem('pages.maintenance', {
            title : 'Maintenance',
            icon  : 'icon-oil',
            state : 'app.pages_maintenance',
            weight: 5
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_invoice', {
            url      : '/pages/invoice',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/invoice/invoice.html',
                    controller : 'InvoiceController as vm'
                }
            },
            resolve  : {
                Invoice: function (apiResolver)
                {
                    return apiResolver.resolve('invoice@get');
                }
            },
            bodyClass: 'invoice'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.invoice', {
            title : 'Invoice',
            icon  : 'icon-receipt',
            state : 'app.pages_invoice',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice')
        .controller('InvoiceController', InvoiceController);

    /** @ngInject */
    function InvoiceController(Invoice)
    {
        var vm = this;

        // Data
        vm.invoice = Invoice.data;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_coming-soon', {
            url      : '/pages/coming-soon',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_coming-soon': {
                    templateUrl: 'app/main/pages/coming-soon/coming-soon.html',
                    controller : 'ComingSoonController as vm'
                }
            },
            bodyClass: 'coming-soon'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/coming-soon');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.coming-soon', {
            title : 'Coming Soon[@]',
            icon  : 'icon-alarm-check',
            state : 'app.pages_coming-soon',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon')
        .controller('ComingSoonController', ComingSoonController);

    /** @ngInject */
    function ComingSoonController()
    {
        var vm = this;

        // Data
        vm.endTime = 1472975790000;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.widgets', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_widgets', {
            url  : '/components/widgets',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/widgets/widgets.html',
                    controller : 'WidgetsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.widgets')
        .controller('WidgetsController', WidgetsController);

    /** @ngInject */
    function WidgetsController()
    {
        var vm = this;

        // Data
        vm.widget1 = {
            title        : 'WEEKLY TRANSACTIONS',
            value        : 30342,
            lastWeekValue: 30002,
            lastWeekDiff : '+ 1,12%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget2 = {
            title        : 'SALES QUOTA',
            value        : 40,
            lastWeekValue: 85,
            lastWeekDiff : '- 45%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget3 = {
            title : 'BOUNCE RATE',
            value : 80,
            detail: 'This is the back side. You can show detailed information here.'
        };

        vm.widget4 = {
            title        : 'STOCK COUNT',
            value        : 5583,
            lastWeekValue: 5583,
            lastWeekDiff : '- 0%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget5 = {
            title: 'USERS ONLINE',
            value: 658
        };

        vm.widget6 = {
            title: 'WASTELANDERS',
            value: 358
        };

        vm.widget7 = {
            title: 'VAULTS SEALED',
            value: 24
        };

        vm.widget8 = {
            title: 'VAULTS OPEN',
            value: 62
        };

        vm.widget9 = {
            title: 'SONGS',
            value: 210
        };

        vm.widget10 = {
            title: 'VIDEOS',
            value: 54
        };

        vm.widget11 = {
            title: 'DOCUMENTS',
            value: 1252
        };

        vm.widget12 = {
            date       : 'June 27, Saturday',
            temperature: 28,
            event      : 'Sunny',
            icon       : 'icon-weather-cloudy',
            location   : 'New York, NY',
            detail     : [
                {
                    day        : 'Sun',
                    icon       : 'icon-weather-rainy',
                    temperature: 24,
                    event      : 'Rainy'
                },
                {
                    day        : 'Mon',
                    icon       : 'icon-weather-pouring',
                    temperature: 23,
                    event      : 'Rainy'
                },
                {
                    day        : 'Tue',
                    icon       : 'icon-weather-cloudy',
                    temperature: 29,
                    event      : 'Overcast'
                },
                {
                    day        : 'Wed',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 28,
                    event      : 'Sunny'
                },
                {
                    day        : 'Thu',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 31,
                    event      : 'Sunny'
                }
            ]
        };

        vm.widget13 = {
            date       : 'June 28, Saturday',
            temperature: 16,
            event      : 'Rainy',
            icon       : 'icon-weather-rainy',
            location   : 'Moscow',
            detail     : [
                {
                    day        : 'Sun',
                    icon       : 'icon-weather-rainy',
                    temperature: 24,
                    event      : 'Rainy'
                },
                {
                    day        : 'Mon',
                    icon       : 'icon-weather-pouring',
                    temperature: 23,
                    event      : 'Rainy'
                },
                {
                    day        : 'Tue',
                    icon       : 'icon-weather-cloudy',
                    temperature: 29,
                    event      : 'Overcast'
                },
                {
                    day        : 'Wed',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 28,
                    event      : 'Sunny'
                },
                {
                    day        : 'Thu',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 31,
                    event      : 'Sunny'
                }
            ]
        };

        vm.widget14 = {
            title: 'Visitor Demographics',
            tabs : [
                {
                    label : '30 days',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 40
                                },
                                {
                                    title: 'Female',
                                    value: 41
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 32
                                },
                                {
                                    title: '35 - 44',
                                    value: 85
                                }
                            ]
                        }
                    ]
                },
                {
                    label : '10 days',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 32
                                },
                                {
                                    title: 'Female',
                                    value: 49
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 85
                                },
                                {
                                    title: '35 - 44',
                                    value: 60
                                }
                            ]
                        }
                    ]
                },
                {
                    label : '1 day',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 28
                                },
                                {
                                    title: 'Female',
                                    value: 60
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 17
                                },
                                {
                                    title: '35 - 44',
                                    value: 64
                                }
                            ]
                        }
                    ]
                }
            ]
        };

        vm.widget15 = {
            title: 'CPU USAGE',
            value: 200,
            chart: {
                columns: [
                    {
                        id    : 'CPU',
                        name  : 'CPU',
                        color : 'white',
                        values: '30,200,100,400,150,250',
                        type  : 'spline'
                    }
                ]
            }
        };

        vm.widget16 = {
            title        : 'STOCK COUNT',
            value        : 5583,
            lastWeekValue: 5583,
            lastWeekDiff : '- 0%',
            chart        : {
                columns: [
                    {
                        id    : 'STOCK',
                        name  : 'STOCK',
                        color : 'purple',
                        values: '30,200,100,400,150,250',
                        type  : 'area'
                    }
                ]
            }
        };

        vm.widget17 = {
            title   : 'IO RATE',
            subtitle: 'Showing last 5 hours',
            chart   : {
                columns: [
                    {
                        id    : 'Input',
                        name  : 'Input',
                        color : 'green',
                        values: '30,75,290,400,150,250',
                        type  : 'spline'
                    },
                    {
                        id    : 'Output',
                        name  : 'Output',
                        color : 'blue',
                        values: '500,300,120,600,50,80',
                        type  : 'spline'
                    }
                ]
            }
        };

        vm.widget18 = {
            title        : 'WEEKLY VISITORS',
            value        : 30342,
            lastWeekValue: 30002,
            lastWeekDiff : '1.12%',
            chart        : {
                columns: [
                    {
                        id    : 'Visitors',
                        name  : 'Visitors',
                        color : 'steelblue',
                        values: '30,75,290,400,150,250,75,210,125,92,30,75,290,400',
                        type  : 'bar'
                    }
                ]
            }
        };

        vm.widget19 = {
            title   : 'Google Inc.',
            subtitle: 'NASDAQ: GOOG',
            value   : '531.69',
            diff    : '2.29%',
            chart   : {
                columns: [
                    {
                        id    : 'GOOG',
                        name  : 'GOOG',
                        color : 'white',
                        values: '30,75,290,400,150,250,75,210,125,92,30,75,290,400',
                        type  : 'bar'
                    }
                ]
            }
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.price-tables', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_price-tables', {
            url  : '/components/price-tables',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/price-tables/price-tables.html'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.price-tables')
        .controller('PriceTablesController', PriceTablesController);

    /** @ngInject */
    function PriceTablesController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .controller('DocTemplateController', DocTemplateController);

    /** @ngInject */
    function DocTemplateController(DEMOS, COMPONENTS, $state, $http, $templateCache)
    {
        var vm = this;
        var component = $state.current.data;
        vm.materialVersion = '1.0.0-rc7';

        vm.componentName = component.name;

        vm.component = getComponent(component.moduleName);

        if ( !component.excludeDemo )
        {
            vm.demo = getDemo(component.moduleName);
        }

        if ( vm.component )
        {
            vm.docs = vm.component.docs;
        }

        if ( vm.demo )
        {
            vm.demos = [];

            angular.forEach(vm.demo.demos, function (demo)
            {
                // Get displayed contents (un-minified)
                var files = [demo.index]
                    .concat(demo.js || [])
                    .concat(demo.css || [])
                    .concat(demo.html || []);
                files.forEach(function (file)
                {
                    file.httpPromise = $http.get('app/main/components/material-docs/' + file.outputPath, {cache: $templateCache})
                        .then(function (response)
                        {
                            file.contents = response.data
                                .replace('<head/>', '');
                            return file.contents;
                        });
                });
                demo.$files = files;
                vm.demos.push(demo);
            });

            vm.demos = vm.demos.sort(function (a, b)
            {
                return a.name > b.name ? 1 : -1;
            });
        }

        // Data

        // Methods

        //////////

        function getDemo(value)
        {
            return DEMOS.filter(function (x)
            {
                return x.moduleName === value;
            })[0];
        }

        function getComponent(value)
        {
            return COMPONENTS.filter(function (x)
            {
                return x.name === value;
            })[0];
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.components_maps', {
                url  : '/components/maps',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/components/maps/maps.html',
                        controller : 'MapsController as vm'
                    },
                    'tabContent@app.components_maps': {
                        templateUrl: 'app/main/components/maps/tabs/simple.html'
                    }
                }
            })

            .state('app.components_maps.satellite', {
                url  : '/satellite',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/satellite.html'
                    }
                }
            })

            .state('app.components_maps.terrain', {
                url  : '/terrain',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/terrain.html'
                    }
                }
            })

            .state('app.components_maps.simple-marker', {
                url  : '/simple-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/simple-marker.html'
                    }
                }
            })

            .state('app.components_maps.custom-marker', {
                url  : '/custom-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/custom-marker.html'
                    }
                }
            })

            .state('app.components_maps.info-window', {
                url  : '/info-window',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/info-window.html'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps')
        .controller('MapsController', MapsController);

    /** @ngInject */
    function MapsController($state, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        var currentState = $state.current.name;

        switch ( currentState )
        {
            case 'app.components_maps':
                vm.selectedIndex = 0;
                break;

            case 'app.components_maps.satellite':
                vm.selectedIndex = 1;
                break;

            case 'app.components_maps.terrain':
                vm.selectedIndex = 2;
                break;

            case 'app.components_maps.simple-marker':
                vm.selectedIndex = 3;
                break;

            case 'app.components_maps.custom-marker':
                vm.selectedIndex = 4;
                break;

            case 'app.components_maps.info-window':
                vm.selectedIndex = 5;
                break;

            default:
                vm.selectedIndex = 0;
        }

        // Methods

        //////////

        uiGmapGoogleMapApi.then(function (maps)
        {
            vm.simpleMap = {
                center: {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom  : 8
            };

            vm.satelliteMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.SATELLITE
                }
            };

            vm.terrainMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.TERRAIN
                }
            };

            vm.simpleMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id    : 0,
                    coords: {
                        latitude : -25.363882,
                        longitude: 131.044922
                    }
                }
            };

            vm.customMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id     : 0,
                    coords : {
                        latitude : -25.363882,
                        longitude: 131.044922
                    },
                    options: {
                        icon: {
                            anchor: new maps.Point(36, 36),
                            origin: new maps.Point(0, 0),
                            url   : '//google-developers.appspot.com/maps/documentation/javascript/examples/full/images/beachflag.png'
                        }
                    }
                }
            };

        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.cards', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_cards', {
            url    : '/components/cards',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/cards/cards.html',
                    controller : 'CardsController as vm'
                }
            },
            resolve: {
                Cards: function (apiResolver)
                {
                    return apiResolver.resolve('cards@get');
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.cards')
        .controller('CardsController', CardsController);

    /** @ngInject */
    function CardsController(Cards)
    {
        var vm = this;

        // Data
        vm.cards = Cards.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.todo')
        .controller('TodoController', TodoController);

    /** @ngInject */
    function TodoController($document, $mdDialog, $mdSidenav, Tasks, Tags)
    {
        var vm = this;

        // Data
        vm.tasks = Tasks.data;
        vm.tags = Tags.data;
        vm.completed = [];
        vm.colors = ['blue', 'blue-grey', 'orange', 'pink', 'purple'];
        vm.projects = {
            'creapond'    : 'Project Creapond',
            'withinpixels': 'Project Withinpixels'
        };
        vm.selectedFilter = {
            filter : 'Start Date',
            dueDate: 'Next 3 days'
        };
        vm.selectedProject = 'creapond';

        // Tasks will be filtered against these models
        vm.taskFilters = {
            search   : '',
            tags     : [],
            completed: '',
            deleted  : false,
            important: '',
            starred  : '',
            startDate: '',
            dueDate  : ''
        };
        vm.taskFiltersDefaults = angular.copy(vm.taskFilters);
        vm.showAllTasks = true;

        vm.taskOrder = '';
        vm.taskOrderDescending = false;

        vm.sortableOptions = {
            handle        : '.handle',
            forceFallback : true,
            ghostClass    : 'todo-item-placeholder',
            fallbackClass : 'todo-item-ghost',
            fallbackOnBody: true,
            sort          : true
        };
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.preventDefault = preventDefault;
        vm.openTaskDialog = openTaskDialog;
        vm.toggleCompleted = toggleCompleted;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleFilter = toggleFilter;
        vm.toggleFilterWithEmpty = toggleFilterWithEmpty;
        vm.filterByStartDate = filterByStartDate;
        vm.filterByDueDate = filterByDueDate;
        vm.resetFilters = resetFilters;
        vm.toggleTagFilter = toggleTagFilter;
        vm.isTagFilterExists = isTagFilterExists;

        init();

        //////////

        /**
         * Initialize the controller
         */
        function init()
        {
            angular.forEach(vm.tasks, function (task)
            {
                if ( task.startDate )
                {
                    task.startDate = new Date(task.startDate);
                    task.startDateTimestamp = task.startDate.getTime();
                }

                if ( task.dueDate )
                {
                    task.dueDate = new Date(task.dueDate);
                    task.dueDateTimestamp = task.dueDate.getTime();
                }
            });
        }

        /**
         * Prevent default
         *
         * @param e
         */
        function preventDefault(e)
        {
            e.preventDefault();
            e.stopPropagation();
        }

        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openTaskDialog(ev, task)
        {
            $mdDialog.show({
                controller         : 'TaskDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/todo/dialogs/task/task-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Task : task,
                    Tasks: vm.tasks,
                    event: ev
                }
            });
        }

        /**
         * Toggle completed status of the task
         *
         * @param task
         * @param event
         */
        function toggleCompleted(task, event)
        {
            event.stopPropagation();
            task.completed = !task.completed;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggles filter with true or false
         *
         * @param filter
         */
        function toggleFilter(filter)
        {
            vm.taskFilters[filter] = !vm.taskFilters[filter];

            checkFilters();
        }

        /**
         * Toggles filter with true or empty string
         * @param filter
         */
        function toggleFilterWithEmpty(filter)
        {
            if ( vm.taskFilters[filter] === '' )
            {
                vm.taskFilters[filter] = true;
            }
            else
            {
                vm.taskFilters[filter] = '';
            }

            checkFilters();
        }

        /**
         * Reset filters
         */
        function resetFilters()
        {
            vm.showAllTasks = true;
            vm.taskFilters = angular.copy(vm.taskFiltersDefaults);
        }

        /**
         * Check filters and mark showAllTasks
         * as true if no filters selected
         */
        function checkFilters()
        {
            vm.showAllTasks = !!angular.equals(vm.taskFiltersDefaults, vm.taskFilters);
        }

        /**
         * Filter by startDate
         *
         * @param item
         * @returns {boolean}
         */
        function filterByStartDate(item)
        {
            if ( vm.taskFilters.startDate === true )
            {
                return item.startDate === new Date();
            }

            return true;
        }

        /**
         * Filter Due Date
         *
         * @param item
         * @returns {boolean}
         */
        function filterByDueDate(item)
        {
            if ( vm.taskFilters.dueDate === true )
            {
                return !(item.dueDate === null || item.dueDate.length === 0);
            }

            return true;
        }

        /**
         * Toggles tag filter
         *
         * @param tag
         */
        function toggleTagFilter(tag)
        {
            var i = vm.taskFilters.tags.indexOf(tag);

            if ( i > -1 )
            {
                vm.taskFilters.tags.splice(i, 1);
            }
            else
            {
                vm.taskFilters.tags.push(tag);
            }

            checkFilters();
        }

        /**
         * Returns if tag exists in the tagsFilter
         *
         * @param tag
         * @returns {boolean}
         */
        function isTagFilterExists(tag)
        {
            return vm.taskFilters.tags.indexOf(tag) > -1;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.scrumboard')
        .controller('ScrumboardController', ScrumboardController);

    /** @ngInject */
    function ScrumboardController($window, $mdSidenav, BoardService, BoardList, CardFilters)
    {
        var vm = this;

        // Data
        vm.currentView = 'board';
        vm.board = BoardService.data;
        vm.boardList = BoardList.data;
        vm.boardSelectorVisible = false;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.updateBoardUri = updateBoardUri;
        vm.clearFilters = CardFilters.clear;
        vm.filteringIsOn = CardFilters.isOn;

        ////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // IE list-content max-height hack
            if ( angular.element('html').hasClass('explorer') )
            {
                // Calculate the height for the first time
                calculateListContentHeight();

                // Attach calculateListContentHeight function to window resize
                $window.onresize = function ()
                {
                    calculateListContentHeight();
                }
            }
        }

        /**
         * IE ONLY
         * Calculate the list-content height
         * IE ONLY
         */
        function calculateListContentHeight()
        {
            // Get the required heights for calculations
            var listWrapperEl = angular.element('#board .list-wrapper').first(),
                listWrapperElHeight = listWrapperEl.height(),
                listHeaderElHeight = listWrapperEl.find('.list-header').height(),
                listFooterElHeight = listWrapperEl.find('.list-footer').height();

            // Calculate the max height
            var maxHeight = listWrapperElHeight - listHeaderElHeight - listFooterElHeight;

            // Add the max height
            angular.element('#board .list-content').css({'max-height': maxHeight});
        }

        /**
         * Update Board Uri
         *
         * Once you connect your app to your server,
         * you would do this on your API server.
         */
        function updateBoardUri()
        {
            if ( vm.boardList.getById(vm.board.id) )
            {
                vm.boardList.getById(vm.board.id).name = vm.board.name;
                vm.boardList.getById(vm.board.id).uri = vm.board.uri = encodeURIComponent(vm.board.name).replace(/%20/g, '-').toLowerCase();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('MailController', MailController);

    /** @ngInject */
    function MailController(firebaseDataService,$scope, $location, $document, $timeout, $mdDialog, $mdMedia, $mdSidenav, loginService, workflowService,$firebaseArray,itbStatusService,msNavigationService,errorLogService,utilsService)
    {

        // DECLARATIONS ***********************
        var vm = this;

        vm.showCommunications = false;
        vm.showListPanel = false;
        vm.showReadPanel = false;
        vm.login;
        vm.itbReceiverKey = "";
        vm.inbox;
        vm.sentbox;
        vm.trashbox;
        vm.genericAvatarSource;

        vm.accounts = {
            'Chart Shipping'    : 'chartship@chartbid.com'
        };

        vm.checked = [];
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'Chart Shipping';
        vm.selectedMail = {};

        vm.responsiveReadPane = undefined;
        vm.activeMailPaneIndex = 0;
        vm.dynamicHeight = false;

        vm.scrollPos = 0;
        vm.scrollEl = angular.element('#content');

        vm.selectedMailShowDetails = false;

        vm.showReadIcon = false;    //We use this variable in order to avoid to show the read icon in the sentbox and other boxes (like charterer boxes or administrator boxes)
        vm.unreadMailsCount = 0;

        vm.mainInboxShowed = true;


        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.showSelectItbAlertDialog = showSelectItbAlertDialog;

        vm.getInboxMails = getInboxMails;
        vm.getSentboxMails = getSentboxMails;

        vm.setAdministratorEmailList = setAdministratorEmailList;

        vm.toggleSidenav = toggleSidenav;
        vm.checkAll = checkAll;
        vm.closeReadPane = closeReadPane;
        vm.composeDialog = composeDialog;
        vm.isChecked = isChecked;
        vm.replyDialog = replyDialog;
        vm.selectMail = selectMail;
        vm.toggleStarred = toggleStarred;
        vm.toggleCheck = toggleCheck;

        vm.saveSelectedMail = saveSelectedMail;

        vm.printMailDialog = printMailDialog;


        //START CONTROLLER *******************************
        vm.executeController();


        //MUY IMPORTANTE => MONITORIZAMOS A TRAVÉS DE $watch LAS VARIABLES de interés
        // Watch screen size to activate responsive read pane
        $scope.$watch(
            function () {
                return $mdMedia('gt-md');
            }, 
            function (current) {
                vm.responsiveReadPane = !current;
            }
        );

        // Watch screen size to activate dynamic height on tabs
        $scope.$watch(
            function () {
                return $mdMedia('xs');
            }, 
            function (current) {
                vm.dynamicHeight = current;
            }
        );


/*
MUY IMPORTANTE => MONITORIZAMOS A TRAVÉS DE $watch EL OBJETO "vm.workflow" para ver si se ha modificado algún valor del workflow (estado o color)
                  ... en el caso de modificarse el valor de "itbKey" debemos ejecutar el método "workflowService.getWorkflowStatusByItbKey()" para obtener de Firebase el estado del workflow para esa ITB seleccionada.
MUY IMPORTANTE => DEBEMOS PONER EL TERCER PARÁMETRO DE LA FUNCIÓN $watch A TRUE
*/
        $scope.$watch('vm.inbox.length',function() {

            //We obtain the number of unread emails
            vm.unreadMailsCount = 0;

            var mailCount = 0;
            try {
                mailCount = vm.inbox.length;
            } catch(error) {
                mailCount = 0;
            }

            for (var i=0;i<mailCount;i++) {

                if (!vm.inbox[i].read) {
                    vm.unreadMailsCount++;
                }

                if (vm.unreadMailsCount > 0) {

                    //If we are showing the inbox (not the sentBox)
                    if (vm.mainInboxShowed) {
                       //We refresh the mail counter badge in the main menu of the App
                        msNavigationService.saveItem('mail', {badge : {content: vm.unreadMailsCount, color  : '#F44336'} });
                    } else {
                        msNavigationService.saveItem('mail', {badge : null });    
                    }

                } else {
                    msNavigationService.saveItem('mail', {badge : null });
                }
            }                        

            //console.log("[1]   >>>>>>>>>>>>>>>>>> MÉTODO $watch() >>>>>>>>>>>>>>>>>>>  vm.unreadMailsCount = " + vm.unreadMailsCount);

            if (vm.unreadMailsCount > 0) {

                //If we are showing the inbox (not the sentBox)
                if (vm.mainInboxShowed) {
                    msNavigationService.saveItem('mail', {badge : {content: vm.unreadMailsCount, color  : '#F44336'} });
                } else {
                    msNavigationService.saveItem('mail', {badge : null });    
                }
                
            } else {
                msNavigationService.saveItem('mail', {badge : null });
            }                                      

        },true);

//FIN CODIGO MONITORIZACIÓN CON MÉTODO $watch()


        // METHODS ****************
        function executeController() {

            //console.log("workflowService.getItbBidderKey() = " + workflowService.getItbBidderKey());
            //console.log("workflowService.getReceiptItbStatus() = " + workflowService.getReceiptItbStatus());
            //console.log("workflowService.getSubmissionBidStatus() = " + workflowService.getSubmissionBidStatus());
            //console.log("workflowService.getCompletionBcfStatus() = " + workflowService.getCompletionBcfStatus());

            if ( workflowService.getItbBidderKey() == "" ) {

                vm.showCommunications = false;
                vm.showSelectItbAlertDialog();
                return;

            } else {

                vm.showCommunications = true;   
            }

            vm.unreadMailsCount = 0;

            vm.login = loginService.getLogin();

            vm.genericAvatarSource = "assets/images/avatars/profile.jpg";

            vm.setAdministratorEmailList();

            //Load mails from Inbox
            //vm.itbReceiverKey = workflowService.getItbKey() + "&" + vm.login.userKey;   //PARA EL CASO DE OBTENER LOS MAILS RECIBIDOS
            vm.itbReceiverKey = workflowService.getItbBidderKey();   //PARA EL CASO DE OBTENER LOS MAILS RECIBIDOS
            vm.itbSenderKey = vm.itbReceiverKey;    //PARA EL CASO DE OBTENER LOS MAILS ENVIADOS
            vm.inbox = vm.getInboxMails(vm.itbReceiverKey);

        }


        function setAdministratorEmailList() {

            var administratorEmailList = "";

            //Get bidders list from Firebase        
//            var fbUrl = new Firebase(FIREBASE_URL + "/administrators/");
            var fbUrl = firebaseDataService.administrators;

            var result = $firebaseArray(fbUrl);

            result.$loaded()
                .then(function(data) {

                    //console.log("[MailController] Administrators email list LOADED with " + data.length + " elements.");

                    var arrayLength = data.length;

                    for (var i=0;i<arrayLength;i++) {
                        administratorEmailList += "&" + data[i].email;
                    }

                    if (administratorEmailList.length > 0) {
                        administratorEmailList = administratorEmailList.substring(1);

                        itbStatusService.setAdministratorEmails(administratorEmailList);
                    }
                })

                .catch(function(error) {
                    //vm.gridOptions.data = null;
                    //console.log("[MailController] ERROR in function setAdministratorEmailList(): " + error);

                    addError("MailController / setAdministratorEmailList() function",error);
                });
        }



        function showSelectItbAlertDialog() {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Alert")
                .textContent("Must select an ITB before sending mails. Please push 'SELECT ITB' button.")
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    $location.path("/workflow-bidder/select-itb");
                }); 
        }


        function getInboxMails(pItbReceiverKey) {

            vm.showReadIcon = true;

            vm.mainInboxShowed = true;

            //console.log("[MailController]  Execution of getInboxMails('" + pItbReceiverKey + "')");

            //Get mail list from Firebase        
//            var fbUrl = new Firebase(FIREBASE_URL + "/communications/");
            var fbUrl = firebaseDataService.communications;

            vm.inbox = $firebaseArray(fbUrl.orderByChild("itb_receiver_key").equalTo(pItbReceiverKey));

            vm.inbox.$loaded()
                .then(function(data) {

                    //Assign bidders list to scope
                    vm.inbox = data;

                    if (data.length > 0) {
                        vm.showListPanel = true;
                        vm.showReadPanel = true;

                        //Select de first mail of the Inbox
                        vm.selectedMail = vm.inbox[data.length-1];

                        //We obtain the number of unread emails
                        vm.unreadMailsCount = 0;
                        var mailCount = data.length;
                        for (var i=0;i<mailCount;i++) {

                            if (!data[i].read) {
                                vm.unreadMailsCount++;
                            }

                            //console.log("vm.unreadMailsCount = " + vm.unreadMailsCount);

                            if (vm.unreadMailsCount > 0) {

/*
                                if (vm.mainInboxShowed) {
                                    //We refresh the mail counter badge in the main menu of the App
                                    msNavigationService.saveItem('mail', {badge : {content: vm.unreadMailsCount, color  : '#F44336'} });
                                } else {
                                    msNavigationService.saveItem('mail', {badge : null });
                                }
*/                                

                                //We refresh the mail counter badge in the main menu of the App
                                msNavigationService.saveItem('mail', {badge : {content: vm.unreadMailsCount, color  : '#F44336'} });


                            } else {
                                msNavigationService.saveItem('mail', {badge : null });
                            }
                        }                        

                    } else {
                        vm.showListPanel = false;
                        vm.showReadPanel = false;
                    }


                    //console.log("[MailController] getInboxMails('" + pItbReceiverKey + "') LOADED with " + data.length + " elements.");


                })

                .catch(function(error) {
                    
                    //console.log("[MailController] ERROR in function getInboxMails(): " + error);

                    addError("MailController / getInboxMails() function",error);
                });
        }



        function getSentboxMails(pItbSenderKey) {

            vm.showReadIcon = false;

            //We avoid to show the Badge with the number of mails
            vm.mainInboxShowed = false;
            msNavigationService.saveItem('mail', {badge : null });


            //console.log("[MailController]  Execution of getSentBoxMails('" + pItbSenderKey + "')");

            //Get mail list from Firebase        
//            var fbUrl = new Firebase(FIREBASE_URL + "/communications/");
            var fbUrl = firebaseDataService.communications;

            vm.inbox = $firebaseArray(fbUrl.orderByChild("itb_sender_key").equalTo(pItbSenderKey));

            vm.inbox.$loaded()
                .then(function(data) {

                    //Assign bidders list to scope
                    vm.inbox = data;

//console.log("Number of mails in sentbox = " + data.length);

                    if (data.length > 0) {
                        vm.showListPanel = true;
                        vm.showReadPanel = true;

                        //Select de first mail of the Inbox
                        vm.selectedMail = vm.inbox[data.length-1];

                    } else {
                        vm.showListPanel = false;
                        vm.showReadPanel = false;
                    }

                    //console.log("[MailController] getSentboxMails('" + pItbSenderKey + "') LOADED with " + data.length + " elements.");
                })

                .catch(function(error) {
                    
                    //console.log("[MailController] ERROR in function getSentboxMails(): " + error);

                    addError("MailController / getSentboxMails() function",error);
                });
        }



        //Select mail        
        function selectMail(mail)
        {
            vm.selectedMail = mail;

            $timeout(function ()
            {
                // If responsive read pane is
                // active, navigate to it
                if ( angular.isDefined(vm.responsiveReadPane) && vm.responsiveReadPane )
                {
                    vm.activeMailPaneIndex = 1;
                }

                // Store the current scrollPos
                vm.scrollPos = vm.scrollEl.scrollTop();

                // Scroll to the top
                vm.scrollEl.scrollTop(0);
            });

            //IF the mail was read previously we exit from the method because we mustn´t do anything
            if (vm.selectedMail.read) {
                return;
            }

            //We update the "read" field from the "communications" table
            vm.selectedMail.read = true;
            vm.saveSelectedMail();

            //We refresh the mail counter badge in the main menu of the App
            vm.unreadMailsCount--;               
            if (vm.unreadMailsCount > 0) {

                if (vm.mainInboxShowed) {
                    msNavigationService.saveItem('mail', {badge : {content: vm.unreadMailsCount, color  : '#F44336'} });
                } else {
                    msNavigationService.saveItem('mail', {badge : null });    
                }

            } else {
                msNavigationService.saveItem('mail', {badge : null });
            }                                      
        }


        function saveSelectedMail() {

            if (!vm.showReadIcon) {

                return;
            }

            vm.inbox.$save(vm.selectedMail)
                .then(function(ref) {
                    //console.log("Saved mail record with ID = " + ref.key);
                })

                .catch(function(error) {

                    //console.log("[MailController] ERROR: " + error + "(Log Error: Controller: MailController / Function: saveSelectedMail())");

                    addError("MailController / saveSelectedMail() function",error);
                }
            );
        }


        //Open compose dialog
        function printMailDialog(ev)
        {
            $mdDialog.show({
                controller         : 'PrintMailDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: vm.selectedMail,
                },
                templateUrl        : 'app/main/apps/mail/dialogs/print/print-mail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev
                //clickOutsideToClose: true
            });
        }



        //Close read pane
        function closeReadPane()
        {
            if ( angular.isDefined(vm.responsiveReadPane) && vm.responsiveReadPane )
            {
                vm.activeMailPaneIndex = 0;

                $timeout(function ()
                {
                    vm.scrollEl.scrollTop(vm.scrollPos);
                }, 650);
            }
        }


        //Toggle starred
        function toggleStarred(mail, event)
        {
            event.stopPropagation();
            mail.starred = !mail.starred;
        }


         //Toggle checked status of the mail
        function toggleCheck(mail, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            var idx = vm.checked.indexOf(mail);

            if ( idx > -1 )
            {
                vm.checked.splice(idx, 1);
            }
            else
            {
                vm.checked.push(mail);
            }
        }


        //Return checked status of the mail
        function isChecked(mail)
        {
            return vm.checked.indexOf(mail) > -1;
        }


        //Check all
        function checkAll()
        {
            if ( vm.allChecked )
            {
                vm.checked = [];
                vm.allChecked = false;
            }
            else
            {
                angular.forEach(vm.inbox, function (mail)
                {
                    if ( !isChecked(mail) )
                    {
                        toggleCheck(mail);
                    }
                });

                vm.allChecked = true;
            }
        }


        //Open compose dialog
        function composeDialog(ev,pType)
        {
            $mdDialog.show({
                controller         : 'ComposeMailDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: undefined,
                    type: pType,     //POSSIBLE VALUES = ['communication']      Los tipos 'bcf' y 'bulletin' NO PUEDEN SER ENVIADOS POR UN BIDDER
                    isReply: false
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-mail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev
                //clickOutsideToClose: true
            });
        }


        //Open reply dialog 
        function replyDialog(ev,pType)
        {
            $mdDialog.show({
                controller         : 'ComposeMailDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: vm.selectedMail,
                    type: pType,     //VALUES POSSIBLE = ['communication','bcf']    El tipo 'bulletin' NO PUEDE SER ENVIADO POR UN BIDDER
                    isReply: true
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-mail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                //clickOutsideToClose: true
            });
        }


		//**************************************
        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }



        //Toggle sidenav
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.help', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.help', {
            url      : '/help',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/help/help.html',
                    controller : 'HelpController as vm'
                }
            },
            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'help'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/help');


        // Navigation
        msNavigationServiceProvider.saveItem('help', {
            title : 'Help',
            state : 'app.help',
            icon  : 'icon-help-circle',
            weight: 5
        });
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.help')
        .controller('HelpController', HelpController);

    /** @ngInject */
    function HelpController($scope,$http,utilsService,loginService,itbStatusService,errorLogService)
    {
        // VARIABLES DECLARATION ****************
        var vm = this;
        var ACCESS_TOKEN = 'lhge3xkLsbAAAAAAAAAA7F4mpQiGgjg_fD658SG5evJitCht2fsvP7D-ZfaSwEl-';  //Dropbox API version 2
        //vm.gridApi;
        //vm.questions;
        //vm.filaSeleccionada = "ID_ROW";


        // METHODS DECLARATION ****************
        //vm.executeController = executeController;
        //vm.initGrid = initGrid;
        //vm.loadGrid = loadGrid;
        //vm.refreshGrid = refreshGrid;
        //vm.playVideo = playVideo;
        
        vm.viewFile = viewFile;


        //START CONTROLLER *******************************
        //vm.executeController();


        // METHODS ****************


        function viewFile() {

            var url = "/help/ChartBid Bidders Instructions.pdf";

            ////console.log("url = " + url);
            var type = utilsService.getContentType(url);
            ////console.log("type = " + type);

            var urlPost = 'https://content.dropboxapi.com/2/files/download'; 

            var dataToSend = "";

            var config = {
                headers : {
                    'Content-Type': 'application/octet-stream;charset=utf-8',
                    'Authorization': 'Bearer ' + ACCESS_TOKEN,
                    'Dropbox-API-Arg':  '{"path": "' + url + '"}'
                },
                responseType: 'blob'
            }
                
            $http.post(urlPost, dataToSend, config)
                .success(function (responseData, status, headers, config) {

                    ////console.log("DESCARGADO CORRECTAMENTE EL ARCHIVO.");

                    var blob = new Blob([responseData], {type: type});
                    blob.name = "downloadedFile";
                    var url = (window.URL || window.webkitURL).createObjectURL(blob); 

                    window.open(url,"_blank");    

                })
                .error(function (responseData, status, header, config) {

                    ////console.log("ERROR AL DESCARGAR Y VISUALIZAR EL ARCHIVO: " + responseData);

                    var error = "DROPBOX error: " + responseData.error_summary + " / status: " + status;
                    addError("HelpController / viewFile() function", error);
                }
            );

        }



        function addError(pLocation, pError) {

            //We need to convert pError parameter to string
            var stringError = pError.toString();

            //Remove ' characters from the pError string
            var pattern = /'/g;
            stringError = stringError.replace(pattern,'');

            //Remove " characters from the pError string
            var pattern = /"/g;
            stringError = stringError.replace(pattern,'');

            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    ////console.log(">>> CET DateTime string = " + data);
                    
                    var recordToAdd = {
                        'user': loginService.getName(),
                        'user_key': loginService.getUserKey(),
                        'company': loginService.getName(), 
                        'email': loginService.getEmail(),
                        'userType': loginService.getUserProfile(),
                        'dateTime': data,
                        'itb_key': itbStatusService.getItbKey(),
                        'itbName': itbStatusService.getItbName(),
                        'location': pLocation,
                        'error': stringError
                    };

                    errorLogService.addError(recordToAdd);

                    //console.log("errorLogService.addError(" + pLocation + "," + stringError + ")");
                })
                .error(function () {
                    //console.log("ERROR in 'addError()' function => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                });
        }
        



/*        
        function executeController() {

            //Initialization of the Grids
            vm.initGrid();

            //DATA (questions) TO SHOW IN THE GRID
            vm.questions = [      
                {"question": "Question 1"},
                {"question": "Question 2"},
                {"question": "Question 3"},
                {"question": "Question 4"},
            ];

            //Load grid
            vm.loadGrid(vm.questions);
        }


        function initGrid() {

            vm.gridOptions = {
                enableSorting: true,
                multiSelect: false,
                enableRowSelection: true, 
                enableRowHeaderSelection: false,
                enableFiltering: false,
                enableColumnMenus: false,

                onRegisterApi = function(gridApi) {
                    vm.gridApi = gridApi;
                
                    gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                        if(row.isSelected){
                            vm.filaSeleccionada = row.entity.id;
                            alert("ID of selected Row = " + vm.filaSeleccionada);
                        }
                    });
                }



            };

            vm.gridOptions.columnDefs = [
                { name:'Question', field: 'question', width: '85%' }
                //MUY IMPORTANTE => CODIGO QUE PERMITE EJECUTAR UN METODO A PARTIR DE UNA COLUMNA DEL GRID                
                { name: ' ', , width: '15%' , cellTemplate:'<button type="button" class="btn primary" ng-click="grid.appScope.vm.playVideo(grid.appScope.vm.filaSeleccionada)">play video</button>' }
                    
            ];
        }


        function loadGrid(data)
        {
            //IMPORTANTE => Ejecutamos $timeout() para forzar la recarga de la vista con el grid actualizado.
            $timeout(function() {
                vm.gridOptions.data = data;
            });

            //console.log("[HelpController] (3) LOAD Grid DONE");
        }


        function refreshGrid() {
            vm.gridApi.core.refresh();
        }


        function playVideo(selectedRow){
            alert("Play the video " + selectedRow + " about the question selected");
        };

*/








        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.file-manager', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.file-manager', {
            url      : '/file-manager',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/file-manager/file-manager.html',
                    controller : 'FileManagerController as vm'
                }
            },
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
            bodyClass: 'file-manager'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/file-manager');

        // Navigation
        msNavigationServiceProvider.saveItem('file-manager', {
            title : 'File Manager',
            icon  : 'icon-folder',
            state : 'app.file-manager',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.file-manager')
        .controller('FileManagerController', FileManagerController);

    /** @ngInject */
    function FileManagerController($mdSidenav, Documents)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'michel'    : 'michel@chartship.net',
            'chartship': 'brokers@chartship.net'
        };
        vm.selectedAccount = 'michel';
        vm.currentView = 'list';
        vm.showDetails = true;

        vm.path = Documents.data.path;
        vm.folders = Documents.data.folders;
        vm.files = Documents.data.files;
        vm.selected = vm.files[0];

        // Methods
        vm.select = select;
        vm.toggleDetails = toggleDetails;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleView = toggleView;

        //////////

        /**
         * Select an item
         *
         * @param item
         */
        function select(item)
        {
            vm.selected = item;
        }

        /**
         * Toggle details
         *
         * @param item
         */
        function toggleDetails(item)
        {
            vm.selected = item;
            toggleSidenav('details-sidenav');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle view
         */
        function toggleView()
        {
            vm.currentView = vm.currentView === 'list' ? 'grid' : 'list';
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contact', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.contact', {
            url      : '/contact',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/contact/contact.html',
                    controller : 'ContactController as vm'
                }
            },


            
/*            
            resolve  : {
                Documents: function (apiResolver)
                {
                    return apiResolver.resolve('fileManager.documents@get');
                }
            },
*/            
            bodyClass: 'contact'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/contact');


        // Navigation
        msNavigationServiceProvider.saveItem('contact', {
            title : 'Contact',
            state : 'app.contact',
            icon  : 'icon-phone',
            weight: 4
        });
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contact')
        .controller('ContactController', ContactController);

    /** @ngInject */
    function ContactController(mailerService,$mdDialog,$location)
    {
        //VARIABLE DECLARATION
        var vm = this;
        vm.contactData;


        //METHODS DECLARATION
        vm.sendData = sendData;
        vm.showAlertDialog = showAlertDialog;


        //METHODS
        function sendData() {

            var message = "";

            message = "<h3><b>CONTACT FORM</b></h3>";
            message += "<br /><b>Name : </b>" + vm.contactData.name;
            message += "<br /><b>E-mail : </b>" + vm.contactData.email;
            message += "<br /><b>Message : </b>" + vm.contactData.message;
            message += "<br /><br />";


            //We send the data by mailService
            mailerService.sendContactData(message)
                .success(function (data, status, headers, config) {
                    var text = "Thank you for getting in contact with us. We will reply as soon as possible.";
                    vm.showAlertDialog(text);
                })
                .error(function (data, status, header, config) {
                    var text = "We have a technical problem with the sending. Please, try again later. Thanks.";
                    vm.showAlertDialog(text);
            });        


        }



        function showAlertDialog(pText) {
            // Appending dialog to document.body to cover sidenav in docs app
            var alert = $mdDialog.alert()
                .title("Information")
                .textContent(pText)
                //.ariaLabel("")
                //.targetEvent(ev)
                .ok("Close")
                //.cancel("No");

            $mdDialog.show(alert)
                .finally(function() {
                    ////console.log("WE REDIRECT TO 'SELECT-ITB' PAGE");
                    $location.path("/workflow-bidder/select-itb");
                }); 
        }







        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($mdDialog, $document)
    {
        var vm = this;

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        vm.events = [
            [
                {
                    id   : 1,
                    title: 'All Day Event',
                    start: new Date(y, m, 1),
                    end  : null
                },
                {
                    id   : 2,
                    title: 'Long Event',
                    start: new Date(y, m, d - 5),
                    end  : new Date(y, m, d - 2)
                },
                {
                    id   : 3,
                    title: 'Some Event',
                    start: new Date(y, m, d - 3, 16, 0),
                    end  : null
                },
                {
                    id   : 4,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 4, 16, 0),
                    end  : null
                },
                {
                    id   : 5,
                    title: 'Birthday Party',
                    start: new Date(y, m, d + 1, 19, 0),
                    end  : new Date(y, m, d + 1, 22, 30)
                },
                {
                    id   : 6,
                    title: 'All Day Event',
                    start: new Date(y, m, d + 8, 16, 0),
                    end  : null
                },
                {
                    id   : 7,
                    title: 'Long Event',
                    start: new Date(y, m, d + 12, 16, 0),
                    end  : null
                },
                {
                    id   : 8,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 9,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 10,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 11,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 12,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 13,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 14,
                    title: 'Conference',
                    start: new Date(y, m, d + 17, 4, 0),
                    end  : null
                },
                {
                    id   : 15,
                    title: 'Meeting',
                    start: new Date(y, m, d + 22, 4, 0),
                    end  : new Date(y, m, d + 24, 4, 0)
                }
            ]
        ];

        vm.calendarUiConfig = {
            calendar: {
                editable     : true,
                eventLimit   : true,
                header       : '',
                dayNames     : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender   : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat : {
                    month: 'ddd',
                    week : 'ddd M',
                    day  : 'ddd M'
                },
                eventClick   : eventDetail,
                selectable   : true,
                selectHelper : true,
                select       : select
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                if ( response.type === 'add' )
                {
                    // Add new
                    vm.events[0].push({
                        id   : vm.events[0].length + 20,
                        title: response.calendarEvent.title,
                        start: response.calendarEvent.start,
                        end  : response.calendarEvent.end
                    });
                }
                else
                {
                    for ( var i = 0; i < vm.events[0].length; i++ )
                    {
                        // Update
                        if ( vm.events[0][i].id === response.calendarEvent.id )
                        {
                            vm.events[0][i] = {
                                title: response.calendarEvent.title,
                                start: response.calendarEvent.start,
                                end  : response.calendarEvent.end
                            };

                            break;
                        }
                    }
                }
            });
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'angular-chartist',
                'chart.js',
                'datatables',
                'gridshore.c3js.chart',
                'nvd3',
                'pascalprecht.translate',
                'timer',
                'ui.router',
                'uiGmapgoogle-maps',
                'textAngular',
                'ui.sortable',
                'ng-sortable',
                'xeditable',
                'ui.grid',
                'ui.grid.selection',
                'ui.grid.resizeColumns',
//                'ui.grid.autoResize',
                'ui.grid.edit', 
                'ui.grid.rowEdit', 
                'ui.grid.cellNav',
                'firebase',
                'ngFileUpload'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement.children().eq(1)).then(function ()
                    {
                        // Remove the element if still exists
                        if ( iElement )
                        {
                            iElement.remove();
                        }

                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toString(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                sort               : sortByWeight,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @returns {Array}
             */
            function getNavigationObject()
            {
                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController(msNavigationService)
    {
        var vm = this;

        // Data
        vm.navigation = msNavigationService.getNavigationObject();

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '='
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time
                        msNavigationService.setFolded(scope.folded);

                        if ( scope.folded )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeSuccess
                     */
                    scope.$on('$stateChangeSuccess', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : true,
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            vm.selectedIndex++;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === vm.forms.length - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean|*}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '='
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Edge",
                    versionSearch: "Edge",
                    identity     : "Edge"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Chrome",
                    identity : "Chrome"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "OmniWeb",
                    versionSearch: "OmniWeb/",
                    identity     : "OmniWeb"
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : "Apple",
                    versionSearch: "Version",
                    identity     : "Safari"
                },
                {
                    prop    : $window.opera,
                    identity: "Opera"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "iCab",
                    identity : "iCab"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "KDE",
                    identity : "Konqueror"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Firefox",
                    identity : "Firefox"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "Camino",
                    identity : "Camino"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Netscape",
                    identity : "Netscape"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "MSIE",
                    identity     : "Explorer",
                    versionSearch: "MSIE"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Trident/7",
                    identity     : "Explorer",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Gecko",
                    identity     : "Mozilla",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Mozilla",
                    identity     : "Netscape",
                    versionSearch: "Mozilla"
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: "Win",
                    identity : "Windows"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Mac",
                    identity : "Mac"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Linux",
                    identity : "Linux"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPhone",
                    identity : "iPhone"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPod",
                    identity : "iPod"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPad",
                    identity : "iPad"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Android",
                    identity : "Android"
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) != -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index == -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || "unknown-browser";
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || "unknown-version";
            var os = searchString(osData) || "unknown-os";

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) == -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/workflow');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.workflow')
        .controller('WorkflowController', WorkflowController);

    /** @ngInject */
    function WorkflowController($scope,$timeout,$location,itbStatusService,workflowService)
    {

        // DECLARATIONS ***********************
        var vm = this;
        vm.workflow;

        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.redirectToSelectItb = redirectToSelectItb;
        vm.redirectToReceiptItb = redirectToReceiptItb;
        vm.redirectToSubmissionBid = redirectToSubmissionBid;
        vm.redirectToBcfDocuments = redirectToBcfDocuments;

        //START CONTROLLER *******************************
        vm.executeController();



/*
MUY IMPORTANTE => MONITORIZAMOS A TRAVÉS DE $watch EL OBJETO "vm.workflow" para ver si se ha modificado algún valor del workflow (estado o color)
                  ... en el caso de modificarse el valor de "itbKey" debemos ejecutar el método "workflowService.getWorkflowStatusByItbKey()" para obtener de Firebase el estado del workflow para esa ITB seleccionada.
MUY IMPORTANTE => DEBEMOS PONER EL TERCER PARÁMETRO DE LA FUNCIÓN $watch A TRUE
*/
        $scope.$watch('vm.workflow',function() {

            //console.log("[1]   >>>>>>>>>>>>>>>>>> MÉTODO $watch() >>>>>>>>>>>>>>>>>>>  vm.workflow.itbBidderKey = " + vm.workflow.itbBidderKey);

            if ( (vm.workflow.itbBidderKey == "") || (vm.workflow.itbBidderKey == null) ) {
                vm.workflow = workflowService.getWorkflowStatus();
                //vm.workflow = workflowService.resetWorkflowStatus();

                return;
            }


            //console.log("[2]   >>>>>>>>>>>>>>>>>> MÉTODO $watch() >>>>>>>>>>>>>>>>>>>  vm.workflow.itbBidderKey = " + vm.workflow.itbBidderKey);

            var result = workflowService.getWorkflowStatusByItbBidderKey(vm.workflow.itbBidderKey);

            result.$loaded()
                .then(function(data) {

                    vm.workflow = data[0];
                    //console.log("[3]   >>>>>>>>>>>>>>>>>> MÉTODO $watch() >>>>>>>>>>>>>>>>>>>  vm.workflow.itbBidderKey = " + vm.workflow.itbBidderKey);
                    workflowService.setItbBidderKey(vm.workflow.itbBidderKey);


                    if (vm.workflow.expiredItb) {

                        vm.workflow.selectItbStatus = true;
                        vm.workflow.selectItbStatusColor = "enabled-button";
                        workflowService.setSelectItbStatusColor(vm.workflow.selectItbStatusColor);

                        vm.workflow.receiptItbStatus = false;
                        vm.workflow.receiptItbStatusColor = "disabled-button";
                        workflowService.setReceiptItbStatusColor(vm.workflow.receiptItbStatusColor);

                        vm.workflow.submissionBidStatus = false;
                        vm.workflow.submissionBidStatusColor = "disabled-button";
                        workflowService.setSubmissionBidStatusColor(vm.workflow.submissionBidStatusColor);

                        vm.workflow.completionBcfStatus = true;
                        vm.workflow.completionBcfStatusColor = "enabled-button";
                        workflowService.setCompletionBcfStatusColor(vm.workflow.completionBcfStatusColor);

                        return;
                    }


                    if (vm.workflow.selectItbStatus) {
                        vm.workflow.selectItbStatusColor = "enabled-button";
                    } else {
                        vm.workflow.selectItbStatusColor = "disabled-button";
                    }
                    workflowService.setSelectItbStatusColor(vm.workflow.selectItbStatusColor);


                    if (vm.workflow.receiptItbStatus) {
                        vm.workflow.receiptItbStatusColor = "enabled-button";
                    } else {
                        vm.workflow.receiptItbStatusColor = "disabled-button";
                    }
                    workflowService.setReceiptItbStatusColor(vm.workflow.receiptItbStatusColor);


                    if (vm.workflow.submissionBidStatus) {
                        vm.workflow.submissionBidStatusColor = "enabled-button";
                    } else {
                        vm.workflow.submissionBidStatusColor = "disabled-button";
                    }
                    workflowService.setSubmissionBidStatusColor(vm.workflow.submissionBidStatusColor);


                    if (vm.workflow.completionBcfStatus) {
                        vm.workflow.completionBcfStatusColor = "enabled-button";
                    } else {
                        vm.workflow.completionBcfStatusColor = "disabled-button";
                    }
                    workflowService.setCompletionBcfStatusColor(vm.workflow.completionBcfStatusColor);

                })
                .catch(function(error) {
                    //console.log("[WorkflowController] '$watch()' method => ERROR: " + error);
                }
            );

        },true);

//FIN CODIGO MONITORIZACIÓN CON MÉTODO $watch()




        // METHODS ****************

        function executeController() {

            vm.workflow = workflowService.getWorkflowStatus();
            ////console.log("[WorkflowController] => workflowService.getWorkflowStatus() method");
        }


        function redirectToSelectItb() {

            //Ponemos el contador de la ITB a 0, lo ocultamos y mostramos vacío el título de la ITB
            itbStatusService.setCounterVisible(false);
            itbStatusService.setItbBidderKey("");

            vm.workflow = workflowService.resetWorkflowStatus();

            $location.path("/workflow-bidder/select-itb");
        }


        function redirectToReceiptItb() {
            $location.path("/workflow-bidder/receipt-itb");
        }


        function redirectToSubmissionBid() {
            $location.path("/workflow-bidder/submission-bid/add-vessel");
        }


        function redirectToBcfDocuments() {
            $location.path("/workflow-bidder/completion-bcf/bcf-docs");
        }

               
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $mdSidenav, $translate, $mdToast, $mdDialog, $location, $interval, $scope, itbStatusService, workflowService, loginService, utilsService)
    {
        // DECLARATIONS ***********************
        var vm = this;
        vm.workflow;
        vm.status;
        vm.login;
        vm.countdown = 0;


/*
            vm.endCounter = 1472975790000; //2592000;    //30 días en segundos
            vm.counterStart = workflowService.getReleaseItbStatus();
            
            vm.status = itbStatusService.getStatus();

            //Obtenemos el nombre de la ITB
            vm.status.itbName = itbStatusService.getItbName();

            //Obtenemos el estado de visiblidad del contador de tiempo de la ITB
            vm.status.counterVisible = itbStatusService.getCounterVisible();

            //Obtenemos el número de segundos del contador de tiempo de la ITB
            vm.status.counterTime = itbStatusService.getCounterTime();
*/


        // METHODS DECLARATION ****************
        vm.executeController = executeController;
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.myProfile = myProfile;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.refreshCounter = refreshCounter;

        vm.counterfinished = counterfinished;
        vm.showAlert = showAlert;

        //START CONTROLLER *******************************
        vm.executeController();



//MUY IMPORTANTE => MONITORIZAMOS A TRAVÉS DE $watch LA VARIABLE "vm.workflow.itbKey" para ver si se ha seleccionado otro ITB diferente al actual....
        //                  ... en ese caso debemos ejecutar el método "workflowService.getWorkflowStatusByItbKey()" para obtener el estado del workflow para esa ITB seleccionada.
        $scope.$watch('vm.status',function() {

            //console.log("[ToolbarController] >>>>>>>>>>>>>>>>>> MÉTODO $watch() para itbBidderKey = " + vm.status.itbBidderKey);

            if ( (vm.status.itbBidderKey == "") || (vm.status.itbBidderKey == null) ) {
                vm.workflow = workflowService.getWorkflowStatus();

                //Reset the counter
                vm.refreshCounter()

                return;
            }

            var result = workflowService.getWorkflowStatusByItbBidderKey(vm.status.itbBidderKey);

            result.$loaded()
                .then(function(data) {

                    vm.workflow = data[0];

                    //Reset the counter
                    vm.refreshCounter()

                })
                .catch(function(error) {
                    //console.log("[ToolbarController] >>>>>>>>>>>>  MÉTODO $watch() => ERROR: " + error);
                }
            );
        },true);
//FIN CODIGO MONITORIZACIÓN CON MÉTODO $watch()





        // METHODS ****************
        function executeController() {

            vm.loginName = loginService.getName();


            vm.status = itbStatusService.getStatus();
            vm.workflow = workflowService.getWorkflowStatus();

//            //console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>  vm.status.chartererReference = " + vm.status.chartererReference);
//            //console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>  vm.status.itbReference = " + vm.status.itbReference);


/*
            //Obtenemos el nombre de la ITB
            vm.status.itbName = itbStatusService.getItbName();

            //Obtenemos el estado de visiblidad del contador de tiempo de la ITB
            vm.status.counterVisible = itbStatusService.getCounterVisible();

            //Obtenemos el número de segundos del contador de tiempo de la ITB
            vm.status.counterTime = itbStatusService.getCounterTime();
*/
            vm.bodyEl = angular.element('body');
            $rootScope.global = {
                search: ''
            };

            vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
            ];
        
            vm.languages = [
            {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'gb'
            },
            {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
            ];

            vm.userStatus = vm.userStatusOptions[0];
            vm.selectedLanguage = vm.languages[0];

//            $interval(vm.refreshCounter, 5000);
//            $rootScope.$broadcast('timer-set-countdown',vm.status.counterTime);
        }

		
// (24/03/2025) - INICIO

/*
		//**************************
        function refreshCounter() {

            if (vm.status.itbBidderKey == "") {

                //Reset the counter
                vm.countdown = 0;
                return;
            }


            //FUNCTION FOR GETTING THE 'CET' DATETIME FROM THE SERVER
            utilsService.getCETdateTime()
                .success(function(data) {

                    //console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
                    //console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);

                    var closingDateTime = itbStatusService.getItbClosingDate() + " " + itbStatusService.getItbClosingTime()
                    //console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> closingDateTime = " + closingDateTime);

                    //var interval = utilsService.getInterval("2016/06/27 17:00:00","2016/06/27 09:00:00");
                    var interval = utilsService.getInterval(closingDateTime,data);
                    itbStatusService.setCounterTime(interval);
                    vm.countdown = interval;


                    if (interval <= 0) {
                        vm.workflow.setExpiredItb = true;
                        workflowService.setExpiredItb(true);
                    }

                    //console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> INTERVAL IN MILISECONDS = " + interval);
                    //console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

                })
                .error(function () {

                    //console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
                    //console.log("[ToolbarController] ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
                    //console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
                });
        }
*/

		// (NUEVA VERSION)
		//***************************
		function refreshCounter() {
			if (vm.status.itbBidderKey === "") {
				// Reset the counter
				vm.countdown = 0;
				return;
			}

			// Obtener la fecha y hora CET del servidor
			utilsService.getCETdateTime().then(function(response) {
				var data = response;
				//console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
				//console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);

				var closingDateTime = itbStatusService.getItbClosingDate() + " " + itbStatusService.getItbClosingTime();
				//console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>> closingDateTime = " + closingDateTime);

				var interval = utilsService.getInterval(closingDateTime, data);
				itbStatusService.setCounterTime(interval);
				vm.countdown = interval;

				if (interval <= 0) {
					vm.workflow.setExpiredItb = true;
					workflowService.setExpiredItb(true);
				}

				//console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>> INTERVAL IN MILISECONDS = " + interval);
				//console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
			}).catch(function() {
				//console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
				//console.log("[ToolbarController] ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
				//console.log("[ToolbarController] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
			});
		}
// (24/03/2025) - FIN



        function counterfinished() {

            alert("THE TIME FOR THIS ITB HAS FINISHED");
//            showAlert($event);

            vm.workflow.setExpiredItb = true;
            workflowService.setExpiredItb(true);

            $location.path("/workflow-bidder/select-itb");
        }


        function showAlert(ev) {
            // Appending dialog to document.body to cover sidenav in docs app
            // Modal dialogs should fully cover application
            // to prevent interaction outside of dialog
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title('COUNTER ALERT')
                    .textContent('The time for this ITB has expired.')
                    .ariaLabel('The time for this ITB has expired.')
                    .ok('Close')
                    .targetEvent(ev)
            );
        }



        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            //RESET the data from the SERVICES of the App
            itbStatusService.resetStatus();
            workflowService.resetWorkflowStatus();
            loginService.resetLogin();

            $location.path("/pages/auth/login");
        }


        function myProfile()
        {
            $location.path("/pages/auth/bidder-profile");
        }


        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            // Show temporary message if user selects a language other than English
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            //Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

})();
(function() {
  'use strict';

  angular.module('app.services', []);
})();
(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('workflowService', workflowService);

  //workflowService.$inject = ['$firebaseArray', 'firebaseDataService'];

  function workflowService(firebaseDataService,$firebaseArray) {

    var workflow = new workflow();

    var service = {
      workflow: workflow,
      resetWorkflowStatus: resetWorkflowStatus,
      getWorkflowStatus: getWorkflowStatus,
      getWorkflowStatusByItbBidderKey:getWorkflowStatusByItbBidderKey,

      getItbBidderKey: getItbBidderKey,
      getSelectItbStatus: getSelectItbStatus,
      getSelectItbStatusColor: getSelectItbStatusColor,

      getReceiptItbStatus: getReceiptItbStatus,
      getReceiptItbStatusColor: getReceiptItbStatusColor,

      getSubmissionBidStatus: getSubmissionBidStatus,
      getSubmissionBidStatusColor: getSubmissionBidStatusColor,

      getCompletionBcfStatus: getCompletionBcfStatus,
      getCompletionBcfStatusColor: getCompletionBcfStatusColor,

      getExpiredItb: getExpiredItb,

      setItbBidderKey: setItbBidderKey,

      setSelectItbStatus: setSelectItbStatus,
      setSelectItbStatusColor: setSelectItbStatusColor,

      setReceiptItbStatus: setReceiptItbStatus,      
      setReceiptItbStatusColor: setReceiptItbStatusColor,      

      setSubmissionBidStatus: setSubmissionBidStatus,
      setSubmissionBidStatusColor: setSubmissionBidStatusColor,

      setCompletionBcfStatus: setCompletionBcfStatus,
      setCompletionBcfStatusColor: setCompletionBcfStatusColor,

      setExpiredItb: setExpiredItb
   };

    return service;


    ////////////
    function workflow() {

      this.itbBidderKey = "";

      this.selectItbStatus = true;
      this.selectItbStatusColor = "enabled-button";

      this.receiptItbStatus = false;
      this.receiptItbStatusColor = "disabled-button";

      this.submissionBidStatus = false;
      this.submissionBidStatusColor = "disabled-button";

      this.completionBcfStatus = false;
      this.completionBcfStatusColor = "disabled-button";

      this.expiredItb = false;
    }


    function getWorkflowStatus() {

      return this.workflow;
    }


    function resetWorkflowStatus() {

      ////console.log(">>>>>>>>>>>>>>>>>> resetWorkflowStatus()");
      this.workflow.itbBidderKey = "";

      this.workflow.selectItbStatus = true;
      this.workflow.selectItbStatusColor = "enabled-button";

      this.workflow.receiptItbStatus = false;
      this.workflow.receiptItbStatusColor = "disabled-button";

      this.workflow.submissionBidStatus = false;
      this.workflow.submissionBidStatusColor = "disabled-button";

      this.workflow.completionBcfStatus = false;
      this.workflow.completionBcfStatusColor = "disabled-button";

      this.workflow.expiredItb = false;

      return this.workflow;
    }


    function getWorkflowStatusByItbBidderKey(pItbBidderKey) {

      ////console.log(">>>>>>>>>>>>>>>>>> getWorkflowStatusByItbBidderKey(" + pItbBidderKey + ")");

      if (pItbBidderKey != null) {
//        var fbUrl = new Firebase(FIREBASE_URL + "/workflow_bidder/");
        var fbUrl = firebaseDataService.workflow_bidder;

        var result = $firebaseArray(fbUrl.orderByChild("itbBidderKey").equalTo(pItbBidderKey));

/*
            result.$loaded()
                .then(function(data) {

                    //console.log(">>>>>>>>>>>>>>>>>> MÉTODO $watch() >>>>>>>>>>>>>>>>>>> (4)");
                    this.workflow = data[0];

                    //console.log("[WorkflowController] => MÉTODO $watch() ejecución de getWorkflowStatusByItbKey() method");
                    //console.log(">>>>>>>>>>>>>>>>>> MÉTODO $watch() ejecución de getWorkflowStatusByItbKey => vm.workflow.itbKey = " + this.workflow.itbKey);
                    //console.log(">>>>>>>>>>>>>>>>>> MÉTODO $watch() ejecución de getWorkflowStatusByItbKey => vm.workflow.selectItbStatus = " + this.workflow.selectItbStatus);
                    //console.log(">>>>>>>>>>>>>>>>>> MÉTODO $watch() ejecución de getWorkflowStatusByItbKey => vm.workflow.prepareItbStatus = " + this.workflow.prepareItbStatus);
                    //console.log(">>>>>>>>>>>>>>>>>> MÉTODO $watch() ejecución de getWorkflowStatusByItbKey => vm.workflow.createBidderStatus = " + this.workflow.createBidderStatus);
                    //console.log(">>>>>>>>>>>>>>>>>> MÉTODO $watch() ejecución de getWorkflowStatusByItbKey => vm.workflow.releaseItbStatus = " + this.workflow.releaseItbStatus);
                    //console.log(">>>>>>>>>>>>>>>>>> MÉTODO $watch() ejecución de getWorkflowStatusByItbKey => vm.workflow.receivedBidsStatus = " + this.workflow.receivedBidsStatus);
                    //console.log(">>>>>>>>>>>>>>>>>> MÉTODO $watch() ejecución de getWorkflowStatusByItbKey => vm.workflow.completedItbStatus = " + this.workflow.completedItbStatus);

                })
                .catch(function(error) {
                    //console.log("ERROR: " + error);
                }
            );
*/

        //ATENCION => EN VEZ DE DEVOLVER UN OBJETO workflow DEVOLVEMOS LA VARIABLE 'result' (OBJETO PROMISE) CON EL RESULTADO DE LA CONSULTA.
        return result;
      } 

      return null;
    }


/*
    function saveStatus(pItbKey, pWorkflow) {

      if ( (pItbKey == null) || (pItbKey == "") ) {
        //console.log("[workflowService] setSelectItbStatus() method => itbKey is NULL or empty, is not possible to save the status in Firebase.");
        return;
      }

      pWorkflow.itbKey = pItbKey;

      //ACTUALIZAMOS EL VALOR EN LA TABLA "workflow" DE FIREBASE      
      var fbUrl = new Firebase(FIREBASE_URL + "/workflow/");
      var result = $firebaseArray(fbUrl.orderByChild("itbKey").equalTo(pItbKey));

      result.$loaded()
          .then(function(data) {

            result.$save(pWorkflow)
              .then(function(ref) {
                //console.log("Record saved in FIREBASE 'workflow' table");
              })

              .catch(function(error) {
                //console.log("ERROR saving record in FIREBASE 'workflow' table. [ERROR: " + error + "]");
              });
          })

          .catch(function(error) {
              //console.log("ERROR saving record in FIREBASE 'workflow' table. [ERROR: " + error + "]");
          }
      );
    }
*/


    //GETTERs
    function getItbBidderKey() {
      return this.workflow.itbBidderKey;
    }


    function getSelectItbStatus() {
      return this.workflow.selectItbStatus;
    }


    function getSelectItbStatusColor() {
      return this.workflow.selectItbStatusColor;
    }


    function getReceiptItbStatus() {
      return this.workflow.receiptItbStatus;
    }


    function getReceiptItbStatusColor() {
      return this.workflow.receiptItbStatusColor;
    }


    function getSubmissionBidStatus() {
      return this.workflow.submissionBidStatus;
    }

    function getSubmissionBidStatusColor() {
      return this.workflow.submissionBidStatusColor;
    }


    function getCompletionBcfStatus() {
      return this.workflow.completionBcfStatus;
    }

    function getCompletionBcfStatusColor() {
      return this.workflow.completionBcfStatusColor;
    }


    function getExpiredItb() {
      return this.workflow.expiredItb;
    }



    //SETTERs
    function setItbBidderKey(pValue) {
      this.workflow.itbBidderKey = pValue;
    }



    function setSelectItbStatus(pStatus) {

      this.workflow.selectItbStatus = pStatus;

      var itbBidderKey = this.workflow.itbBidderKey;
      var recordToUpdate;

      if ( (itbBidderKey == null) || (itbBidderKey == "") ) {
        //console.log("[workflowService] setSelectItbStatus() method => itbBidderKey is NULL or empty, is not possible to save the status in Firebase.");
        return;
      }

      //ACTUALIZAMOS EL VALOR EN LA TABLA "workflow" DE FIREBASE      
//      var fbUrl = new Firebase(FIREBASE_URL + "/workflow_bidder/");
      var fbUrl = firebaseDataService.workflow_bidder;

      var result = $firebaseArray(fbUrl.orderByChild("itbBidderKey").equalTo(itbBidderKey));

      result.$loaded()
          .then(function(data) {

            //Assign administrators list to scope
            recordToUpdate = data[0];

            recordToUpdate.selectItbStatus = pStatus;
            result.$save(recordToUpdate)
              .then(function(ref) {
                //console.log("[workflowService] setSelectItbStatus() method => Saved record with workflow 'selectItbStatus' = " + pStatus);
              }
            );
          })

          .catch(function(error) {
              //console.log("ERROR: " + error);
          }
      );
      
      if (pStatus) {
        this.workflow.selectItbStatusColor = "enabled-button";
      } else {
        this.workflow.selectItbStatusColor = "disabled-button";
      }
    }


    function setSelectItbStatusColor(pValue) {
        this.workflow.selectItbStatusColor = pValue;
    }


    function setReceiptItbStatus(pStatus) {

      this.workflow.receiptItbStatus = pStatus;

      var itbBidderKey = this.workflow.itbBidderKey;
      var recordToUpdate;

      if ( (itbBidderKey == null) || (itbBidderKey == "") ) {
        //console.log("[workflowService] setReceiptItbStatus() method => itbBidderKey is NULL or empty, is not possible to save the status in Firebase.");
        return;
      }

      //ACTUALIZAMOS EL VALOR EN LA TABLA "workflow" DE FIREBASE      
//      var fbUrl = new Firebase(FIREBASE_URL + "/workflow_bidder/");
      var fbUrl = firebaseDataService.workflow_bidder;

      var result = $firebaseArray(fbUrl.orderByChild("itbBidderKey").equalTo(itbBidderKey));

      result.$loaded()
          .then(function(data) {

            //Assign administrators list to scope
            recordToUpdate = data[0];

            recordToUpdate.receiptItbStatus = pStatus;
            result.$save(recordToUpdate)
              .then(function(ref) {
                //console.log("[workflowService] setReceiptItbStatus() method => Saved record with workflow 'receiptItbStatus' = " + pStatus);
              }
            );
          })

          .catch(function(error) {
              //console.log("ERROR: " + error);
          }
      );
      
      if (pStatus) {
        this.workflow.receiptItbStatusColor = "enabled-button";
      } else {
        this.workflow.receiptItbStatusColor = "disabled-button";
      }
    }


    function setReceiptItbStatusColor(pValue) {
        this.workflow.receiptItbStatusColor = pValue;
    }

      
    function setSubmissionBidStatus(pStatus) {

      this.workflow.submissionBidStatus = status;

      var itbBidderKey = this.workflow.itbBidderKey;
      var recordToUpdate;

      if ( (itbBidderKey == null) || (itbBidderKey == "") ) {
        //console.log("[workflowService] setSubmissionBidStatus() method => itbBidderKey is NULL or empty, is not possible to save the status in Firebase.");
        return;
      }

      //ACTUALIZAMOS EL VALOR EN LA TABLA "workflow" DE FIREBASE      
//      var fbUrl = new Firebase(FIREBASE_URL + "/workflow_bidder/");
      var fbUrl = firebaseDataService.workflow_bidder;

      var result = $firebaseArray(fbUrl.orderByChild("itbBidderKey").equalTo(itbBidderKey));

      result.$loaded()
          .then(function(data) {

            //Assign administrators list to scope
            recordToUpdate = data[0];
            recordToUpdate.submissionBidStatus = pStatus;
            result.$save(recordToUpdate)
              .then(function(ref) {
                //console.log("[workflowService] setSubmissionBidStatus() method => Saved record with workflow 'submissionBidStatus' = " + pStatus);
              }
            );
          })

          .catch(function(error) {
              //console.log("ERROR: " + error);
          }
      );

      if (pStatus) {
        this.workflow.submissionBidStatusColor = "enabled-button";
      } else {
        this.workflow.submissionBidStatusColor = "disabled-button";
      }
    }


    function setSubmissionBidStatusColor(pValue) {
        this.workflow.submissionBidStatusColor = pValue;
    }


    function setCompletionBcfStatus(pStatus) {

      this.workflow.completionBcfStatus = status;

      var itbBidderKey = this.workflow.itbBidderKey;
      var recordToUpdate;

      if ( (itbBidderKey == null) || (itbBidderKey == "") ) {
        //console.log("[workflowService] setCompletionBcfStatus() method => itbBidderKey is NULL or empty, is not possible to save the status in Firebase.");
        return;
      }

      //ACTUALIZAMOS EL VALOR EN LA TABLA "workflow" DE FIREBASE      
//      var fbUrl = new Firebase(FIREBASE_URL + "/workflow_bidder/");
      var fbUrl = firebaseDataService.workflow_bidder;

      var result = $firebaseArray(fbUrl.orderByChild("itbBidderKey").equalTo(itbBidderKey));

      result.$loaded()
          .then(function(data) {

            //Assign administrators list to scope
            recordToUpdate = data[0];
            recordToUpdate.completionBcfStatus = pStatus;
            result.$save(recordToUpdate)
              .then(function(ref) {
                //console.log("[workflowService] setCompletionBcfStatus() method => Saved record with workflow 'completionBcfStatus' = " + pStatus);
              }
            );
          })

          .catch(function(error) {
              //console.log("ERROR: " + error);
          }
      );

      if (pStatus) {
        this.workflow.completionBcfStatusColor = "enabled-button";
      } else {
        this.workflow.completionBcfStatusColor = "disabled-button";
      }          
    }



    function setCompletionBcfStatusColor(pValue) {
        this.workflow.completionBcfStatusColor = pValue;
    }



    function setExpiredItb(pValue) {

      this.workflow.expiredItb = pValue;

      //console.log("[workflowService] >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> this.workflow.expiredItb = " + this.workflow.expiredItb);

      var itbBidderKey = this.workflow.itbBidderKey;
      var recordToUpdate;

      if ( (itbBidderKey == null) || (itbBidderKey == "") ) {
        //console.log("[workflowService] setExpiredItb() method => itbBidderKey is NULL or empty, is not possible to save the status in Firebase.");
        return;
      }

      //ACTUALIZAMOS EL VALOR EN LA TABLA "workflow" DE FIREBASE      
//      var fbUrl = new Firebase(FIREBASE_URL + "/workflow_bidder/");
      var fbUrl = firebaseDataService.workflow_bidder;

      var result = $firebaseArray(fbUrl.orderByChild("itbBidderKey").equalTo(itbBidderKey));

      result.$loaded()
          .then(function(data) {

            //Assign administrators list to scope
            recordToUpdate = data[0];
            recordToUpdate.expiredItb = pValue;
            result.$save(recordToUpdate)
              .then(function(ref) {
                //console.log("[workflowService] setExpiredItb() method => Saved record with workflow 'expiredItb' = " + pValue);
              }
            );
          })

          .catch(function(error) {
              //console.log("ERROR: " + error);
          }
      );

    }




  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('utilsService', utilsService);

  //workflowService.$inject = ['$firebaseArray', 'firebaseDataService'];

  function utilsService($http) {


    var service = {

      getCETdateTime: getCETdateTime,
      getInterval: getInterval,
      getDate: getDate,
      getTime: getTime,
      getDateTime: getDateTime,
      getContentType: getContentType,
      getLastCharacter: getLastCharacter,
      removeLastCharacter: removeLastCharacter,
      writeConsole: writeConsole      
    };


    return service;


    ////////////
    
    function Utils() {

    }


// (24/03/2025) - INICIO
/*
    //***************************************************************
    function getCETdateTime() {

      var user = "developer@chartbid.com";
      var password = "a-Syns6wSuqV4EajR6t7ig";

      var config = {
          headers : {
              'Content-Type': 'application/json'
          }
      }

      //IMPORTANT => The function return a PROMISE object.
      return $http.get('https://webapi2256.azurewebsites.net/api/DateTime?user=' + user + '&password=' + password,config);
    }
*/
	
    //NUEVA VERSION
    //***************************************************************
    function getCETdateTime() {
        var config = {
            headers: { 'Content-Type': 'application/json' }
        };

			return $http.get('https://timeapi.io/api/Time/current/zone?timeZone=UTC', config)
            .then(function(response) {
                // Obtenemos la fecha del objeto JSON
                var json_dateTimeUTC = response.data.dateTime + 'Z';

                //console.log("****************** json_dateTimeUTC = " + json_dateTimeUTC + " ****************************");

                // Convertimos el formato
                var formattedDateTime = new Date(json_dateTimeUTC)
                    .toISOString()
                    .replace('T', ' ')
                    .slice(0, 19)
                    .replace(/-/g, '/');

                //console.log("****************** formattedDateTime = " + formattedDateTime + " ****************************");

                return formattedDateTime;
            })
            .catch(function(error) {
                console.error("Error obteniendo la fecha y hora:", error);
                return null;
            });
    }
// (24/03/2025) - FIN
	
	


    //***************************************************************
    function getInterval(pEndDateString, pStartDateString) {

      var endDate = new Date(pEndDateString);
      var startDate = new Date(pStartDateString);

      var endDateMiliseconds = endDate.getTime();
      var startDateMiliseconds = startDate.getTime();

      var intervalInSeconds = (endDateMiliseconds - startDateMiliseconds) / 1000;

      return intervalInSeconds;
    }




    //***************************************************************
    function getDate() {

      var now = new Date();
      var date = now.getFullYear() + "/" + String("00" + (now.getMonth()+1)).slice(-2) + "/" + String("00" + now.getDate()).slice(-2);

      return date;
    }



    //***************************************************************
    function getTime() {

      var now = new Date();
      var time = String("00" + now.getHours()).slice(-2) + ":" + String("00" + now.getMinutes()).slice(-2);

      return time;
    }



    //***************************************************************
    function getDateTime() {

      var now = new Date();
      var date = now.getFullYear() + "/" + String("00" + (now.getMonth()+1)).slice(-2) + "/" + String("00" + now.getDate()).slice(-2);
      var time = String("00" + now.getHours()).slice(-2) + ":" + String("00" + now.getMinutes()).slice(-2);
      var dateTime = date + " " + time;

      return dateTime;
    }



    function getNameFromUrl(pUrl) {

      var name = pUrl.replace(/^.*[\\\/]/, '')

      return name;
    }



    //***************************************************************
    function getContentType(pUrl) {

      var fileExtension = pUrl.split(".").pop();

      var type = "application/pdf";     //We assign the default extension

      if (fileExtension == "png") {
          type = "image/png";

      } else if ( (fileExtension == "jpg") || (fileExtension == "jpeg") ) {
          type = "image/jpg";

      } else if (fileExtension == "gif") {
          type = "image/gif";

      } else if (fileExtension == "pdf") {
          type = "application/pdf";

      } else if (fileExtension == "txt") {
          type = "text/plain";

      } else if ( (fileExtension == "doc") || (fileExtension == "docx") ) {
          type = "application/msword";

      } else if ( (fileExtension == "xls") || (fileExtension == "xlsx") ) {
          type = "application/vnd.ms-excel";

      } else if ( (fileExtension == "ppt") || (fileExtension == "pptx") ) {
          type = "application/vnd.ms-powerpoint";

      } else if (fileExtension == "pub") {
          type = "application/x-mspublisher";
      }

      return type;
    }



    //***************************************************************
    function getLastCharacter(pString) {

        var lastChar = pString.substr(pString.length - 1);

        return lastChar;
    }


    //***************************************************************
    function removeLastCharacter(pString) {

        var newString = pString.slice(0, -1);

        return newString;
    }


    //***************************************************************
    function writeConsole(pText,pActive) {

      if (pActive) {
        //console.log(pText);
      }
    }





  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('traceabilityService', traceabilityService);

  //workflowService.$inject = ['$firebaseArray', 'firebaseDataService'];

  function traceabilityService(firebaseDataService,$firebaseArray,utilsService) {

    var traceability = new Traceability();

    var service = {
/*      
      traceability: traceability,
      getTraceabilityFromFirebaseByItb: getTraceabilityFromFirebaseByItb,
      getTraceabilityFromFirebaseByUser: getTraceabilityFromFirebaseByUser,
      getTraceabilityByItb: getTraceabilityByItb,
      getTraceabilityByUser: getTraceabilityByUser,
*/
      getTraceability: getTraceability,
      setTraceability: setTraceability,
      addTrace: addTrace
   };

    return service;


    ////////////
    
    function Traceability() {

      return this;
    }


/*
    function getTraceabilityFromFirebaseByItb(pItbKey) {

      if (pItbKey != null) {

        var fbUrl = new Firebase(FIREBASE_URL + "/traceability/");
        var result = $firebaseArray(fbUrl.orderByChild("itb_key").equalTo(pItbKey));


        //ATENCION => EN VEZ DE DEVOLVER UN OBJETO traceability DEVOLVEMOS LA VARIABLE 'result' (OBJETO PROMISE) CON EL RESULTADO DE LA CONSULTA.
        //return result;

        result.$loaded()
            .then(function(data) {

                //Assign data to traceability
                traceability = data;

                //console.log("[traceabilityService] getTraceability() method => Get all records of 'itb_key' from 'traceability' table of Firebase.");

            })
            .catch(function(error) {
                //console.log("[traceabilityService] getTraceability() method => ERROR: " + error);
        });

      } else {

        traceability = null;
      }
    }


    function getTraceabilityFromFirebaseByUser(pUserKey) {

      if (pUserKey != null) {

        var fbUrl = new Firebase(FIREBASE_URL + "/traceability/");
        var result = $firebaseArray(fbUrl.orderByChild("user_key").equalTo(pUserKey));

        result.$loaded()
            .then(function(data) {

                //Assign data to traceability
                traceability = data;

                //console.log("[traceabilityService] getTraceabilityByUser() method => Get all records of 'user_key' from 'traceability' table of Firebase.");

            })
            .catch(function(error) {
                //console.log("[traceabilityService] getTraceabilityByUser() method => ERROR: " + error);
        });

      } else {

        traceability = null;
      }
    }



    function getTraceabilityByItb() {

        return traceability;
    }
      



    function getTraceabilityByUser() {

      return traceability;
    }
*/


    function getTraceability() {

      return traceability;
    }


    function setTraceability(pArray) {

      traceability = pArray;
    }



    function addTrace(pRecordToAdd) {

//return;      

      if (pRecordToAdd != null) {

        var itbKey = pRecordToAdd.user_key;

        var fbUrl = firebaseDataService.traceability;

        var records = $firebaseArray(fbUrl.orderByChild("itb_key").equalTo(itbKey).limitToLast(1));

        records.$add(pRecordToAdd)
            .then(function(ref) {
                //console.log("[traceabilityService] addTrace() method");
            });
      }

    }




  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('mailerService', mailerService);

//  itbStatusService.$inject = ['$firebaseObject', 'firebaseDataService'];

  function mailerService(firebaseDataService,$http,$firebaseArray,utilsService,itbStatusService) {

    var mailer = new Mailer();

    var service = {
      //mailer: Mailer,
      processMail: processMail,
      sendMail: sendMail,
      sendLoginData: sendLoginData,
      sendUpdateBidderNotification: sendUpdateBidderNotification,
      testMailer: testMailer,
      sendContactData : sendContactData
    };

    return service;


    ////////////
    function Mailer() {


    }


/*
        //VARIABLES DE WEB API EN AZURE

        public string user { get; set; }
        public string password { get; set; }
        public string arrayDestinationEmail { get; set; }   //Es un string con las cuentas de e-mail separadas por #
        public string emailSender { get; set; }
        public string nameSender { get; set; }
        public string subject { get; set; }
        public string body { get; set; }
*/



// (24/03/2025) - INICIO
/*
	//******************************************
    function processMail(pEmailData) {

        if (pEmailData.subject.trim().length == 0) {

            pEmailData.subject = " ";
        }

        if (pEmailData.body.trim().length == 0) {

            pEmailData.body = "[NO CONTENT] ";
        }


        //If the receiver is the administrator => load email list with all the e-mails of the ADMINISTRATOR
        if (pEmailData.arrayDestinationName == "Chart Shipping") {

            //We get the list of e-mail of all the administrators
            var emailList = itbStatusService.getAdministratorEmails();

        //If the receiver is the charterer => load email list with all the e-mails of the CHARTERER
        } else {

            //We get the list of e-mail of all the administrators
            var emailList = itbStatusService.getChartererEmails();
            pEmailData.arrayDestinationName = itbStatusService.getCharterer();
            pEmailData.arrayDestinationKey = itbStatusService.getChartererKey();

        }


        //Change the caracter "&" for "#" in case there is a Bidder with more than one email joined by "&"
        emailList = emailList.replace(/&/g,"#");


        //IMPORTANT => We must remove the last "#" characters if exists. If we don't remove then sendMail() doesn't send any email.
        for (var i=0;i<(emailList.length-1);i++) {
            var lastCharacter = utilsService.getLastCharacter(emailList);
            if (lastCharacter == "#") {
                emailList = utilsService.removeLastCharacter(emailList);
            } else {
                break;
            }
        }


        pEmailData.arrayDestinationEmail = emailList;
        //console.log("************** emailList BEFORE SENDING EMAIL = " + emailList);


        //Send email to ALL DESTINATIONS  at the same time.
        sendMail(pEmailData);

		//console.log("(1) >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> pEmailData.arrayDestinationEmail = " + pEmailData.arrayDestinationEmail);
		//console.log("(1) >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> pEmailData.arrayDestinationKey = " + pEmailData.arrayDestinationKey);
		//console.log("(1) >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> pEmailData.arrayDestinationName = " + pEmailData.arrayDestinationName);


        if (pEmailData.arrayDestinationEmail.indexOf('#') > -1) {
            var arrayEmails = pEmailData.arrayDestinationEmail.split('#');
        } else {
            var arrayEmails = new Array(1);
            arrayEmails[0] = pEmailData.arrayDestinationEmail;
        }


        if (pEmailData.arrayDestinationKey.indexOf('#') > -1) {
            var arrayKeys = pEmailData.arrayDestinationKey.split('#');
        } else {
            var arrayKeys = new Array(1);
            arrayKeys[0] = pEmailData.arrayDestinationKey;
        }


        if (pEmailData.arrayDestinationName.indexOf('#') > -1) {
            var arrayNames = pEmailData.arrayDestinationName.split('#');
        } else {
            var arrayNames = new Array(1);
            arrayNames[0] = pEmailData.arrayDestinationName;
        }


        utilsService.getCETdateTime()
            .success(function(data) {

                //console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> CET DateTime string = " + data);

                //Add one record for each destination to Firebase (table 'communications')
                //var receiverKey = arrayKeys[i];
                //var itbReceiverKey = pEmailData.itb_key + "&" + receiverKey;
                //var receiverName = arrayNames[i];

                if (pEmailData.arrayDestinationName == "Chart Shipping") {

                    var receiverKey = 'undefinedKey';
                    var itbReceiverKey = 'undefinedKey';
                    var receiverName = 'Chart Shipping';
                    var receiverEmail = 'chartship@chartbid.com';

                    var receiverProfile = "administrator";
                    var itb_receiverProfile = pEmailData.itb_key + "&" + receiverProfile;

                } else {

                    var receiverKey = itbStatusService.getChartererKey();
                    var itbReceiverKey = itbStatusService.getItbKey() + "&" + receiverKey;
                    var receiverName = itbStatusService.getCharterer();
                    var receiverEmail = '';

                    var receiverProfile = "charterer";
                    var itb_receiverProfile = pEmailData.itb_key + "&" + receiverProfile;
                }


                var recordToAdd = {
                    'itb_key': pEmailData.itb_key,
                    'sender_key': pEmailData.sender_key,
                    'itb_sender_key': pEmailData.itb_sender_key,
                    'receiver_key': receiverKey,
                    'itb_receiver_key': itbReceiverKey,
                    'fromEmail': pEmailData.emailSender,
                    'fromName': pEmailData.nameSender,
                    'toEmail': receiverEmail,
                    'toName': receiverName,
                    'subject': pEmailData.subject,
                    'date': data,
                    'time': '',
                    'message': pEmailData.body,
                    'deleted': false,
                    'type': pEmailData.type,
                    'pendingBcf': pEmailData.pendingBcf,

                    'senderProfile': '',
                    'itb_senderProfile': '',
                    'receiverProfile': receiverProfile,
                    'itb_receiverProfile': itb_receiverProfile,
                    'read': false
                };

                saveMail(recordToAdd);

            })
                .error(function () {
                    //console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
        });

    }
*/

        //(NUEVA VERSION)
        //**********************************************
		function processMail(pEmailData) {

        //ESTRUCTURA DEL PARÁMETRO "pEmailData"
/*
            var pEmailData = {
                'user': 'developer@chartbid.com',
                'password': 'a-Syns6wSuqV4EajR6t7ig',
                'arrayDestinationEmail': destinationEmails,
                'arrayDestinationKey': destinationKeys,
                'arrayDestinationName': destinationNames,
                'emailSender': vm.form.from,
                'nameSender': vm.login.name,
                'subject': vm.form.subject,
                'body': vm.form.message,

                'itb_key': itbKey,
                'sender_key': SenderKey,
                'itb_sender_key': itbSenderKey,
                'type': type,
                'pendingBcf': true,

                'senderProfile': '',
                'itb_senderProfile': '',
                'receiverProfile': receiverProfile,
                'itb_receiverProfile': itbReceiverProfile

//              'receiver_key': 'RECEIVER_KEY',
//              'itb_receiver_key': 'itbKey&RECEIVER_KEY'
            };
*/

		
			if (pEmailData.subject.trim().length === 0) {
				pEmailData.subject = " ";
			}

			if (pEmailData.body.trim().length === 0) {
				pEmailData.body = "[NO CONTENT] ";
			}

			var emailList = "";
			
			if (pEmailData.arrayDestinationName === "Chart Shipping") {
				emailList = itbStatusService.getAdministratorEmails();
			} else {
				emailList = itbStatusService.getChartererEmails();
				pEmailData.arrayDestinationName = itbStatusService.getCharterer();
				pEmailData.arrayDestinationKey = itbStatusService.getChartererKey();
			}

			emailList = emailList.replace(/&/g, "#");
			
			while (emailList.endsWith("#")) {
				emailList = emailList.slice(0, -1);
			}

			pEmailData.arrayDestinationEmail = emailList;
			//console.log("************** emailList BEFORE SENDING EMAIL = " + emailList);
			sendMail(pEmailData);

			//console.log("(1) >>> pEmailData.arrayDestinationEmail = " + pEmailData.arrayDestinationEmail);
			//console.log("(1) >>> pEmailData.arrayDestinationKey = " + pEmailData.arrayDestinationKey);
			//console.log("(1) >>> pEmailData.arrayDestinationName = " + pEmailData.arrayDestinationName);

			var arrayEmails = pEmailData.arrayDestinationEmail.indexOf('#') > -1 ? pEmailData.arrayDestinationEmail.split('#') : [pEmailData.arrayDestinationEmail];
			var arrayKeys = pEmailData.arrayDestinationKey.indexOf('#') > -1 ? pEmailData.arrayDestinationKey.split('#') : [pEmailData.arrayDestinationKey];
			var arrayNames = pEmailData.arrayDestinationName.indexOf('#') > -1 ? pEmailData.arrayDestinationName.split('#') : [pEmailData.arrayDestinationName];

			utilsService.getCETdateTime().then(function(data) {
				//console.log(">>>>>>>>> CET DateTime string = " + data);
				
				var receiverKey, itbReceiverKey, receiverName, receiverEmail, receiverProfile, itb_receiverProfile;
				
				if (pEmailData.arrayDestinationName === "Chart Shipping") {
					receiverKey = 'undefinedKey';
					itbReceiverKey = 'undefinedKey';
					receiverName = 'Chart Shipping';
					receiverEmail = 'chartship@chartbid.com';
					receiverProfile = "administrator";
					itb_receiverProfile = pEmailData.itb_key + "&" + receiverProfile;
				} else {
					receiverKey = itbStatusService.getChartererKey();
					itbReceiverKey = itbStatusService.getItbKey() + "&" + receiverKey;
					receiverName = itbStatusService.getCharterer();
					receiverEmail = '';
					receiverProfile = "charterer";
					itb_receiverProfile = pEmailData.itb_key + "&" + receiverProfile;
				}

				var recordToAdd = {
					'itb_key': pEmailData.itb_key,
					'sender_key': pEmailData.sender_key,
					'itb_sender_key': pEmailData.itb_sender_key,
					'receiver_key': receiverKey,
					'itb_receiver_key': itbReceiverKey,
					'fromEmail': pEmailData.emailSender,
					'fromName': pEmailData.nameSender,
					'toEmail': receiverEmail,
					'toName': receiverName,
					'subject': pEmailData.subject,
					'date': data,
					'time': '',
					'message': pEmailData.body,
					'deleted': false,
					'type': pEmailData.type,
					'pendingBcf': pEmailData.pendingBcf,
					'senderProfile': '',
					'itb_senderProfile': '',
					'receiverProfile': receiverProfile,
					'itb_receiverProfile': itb_receiverProfile,
					'read': false
				};

				saveMail(recordToAdd);
			}).catch(function() {
				//console.log("ERROR => NOT POSSIBLE TO GET THE CET DATETIME FROM THE AZURE SERVER.");
			});
		}

// (24/03/2025) - FIN

	

	//*******************************
    function sendMail(pEmailData) {

/*      //ESTRUCTURA DEL PARÁMETRO "pEmailData"
         var pEmailData = {
            'user': 'developer@chartbid.com',
            'password': 'a-Syns6wSuqV4EajR6t7ig',
            'arrayDestinationEmail': 'jlmartos@elusiona.com#elusiona@elusiona.com#fusiona@fusiona.net',
            'emailSender': 'developer@chartbid.com',
            'nameSender': 'Chartbid App',
            'subject': 'TEST MAILER',
            'body': 'Test mailer [content]'
        };
*/
	
		//console.log("(2)  pEmailData.arrayDestinationEmail = " + pEmailData.arrayDestinationEmail);
		//console.log("(2)  pEmailData.emailSender = " + pEmailData.emailSender);
		//console.log("(2)  pEmailData.nameSender = " + pEmailData.nameSender);
		//console.log("(2)  pEmailData.subject = " + pEmailData.subject);
		//console.log("(2)  pEmailData.body = " + pEmailData.body);

        var config = {
            headers : {
                'Content-Type': 'application/json;charset=utf-8',
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Methods': '*',
                'Access-Control-Allow-Origin': 'https://burning-inferno-2655.firebaseapp.com,https://bidder-app.firebaseapp.com,https://developer-admin-app.firebaseapp.com,https://developer-bidder-app.firebaseapp.com,http://localhost:3000,https://localhost:3000'
            }
        }

// (24/03/2025) - INICIO
        //we send the mail by means of the webAPI
        //$http.post('https://webapi2256.azurewebsites.net/api/Mailer', pEmailData, config)

        //we send the mail using Webhook from MAKE connected to AuthSMTP API.
        $http.post('https://hook.eu2.make.com/38dkvazlmbgon2dfb88mv4mxi5vjxr4b', pEmailData, config)
// (24/03/2025) - FIN		
		
            .success(function (pEmailData, status, headers, config) {
                //$scope.PostDataResponse = pEmailData;
                //console.log("ENVIADOS CORRECTAMENTE LOS DATOS PARA EL ENVÍO DEL MAIL A TRAVES DE LA API de MAKE y el servicio AuthSMTP.");

                return true;
            })
            .error(function (pEmailData, status, header, config) {

                //console.log("ERROR AL ENVIAR EMAIL a través de sendMail() y la API de MAKE");

                return false;
            });

    }

	

    function sendLoginData(pEmail,pPassword) {

        var userAPI = 'developer@chartbid.com';
        var passwordAPI = 'a-Syns6wSuqV4EajR6t7ig';

        var data = "";
        var subject = '[CHARTBID] Log in data ';

        var linkToChartbid = '<p><br/><a href="https://app.chartbid.com/">You can access to Chartbid here</a></p>';
        var CSSLfooter = '<p><br/>Chart Shipping S.L.<br/>As brokers only<br/>-------------------------------------------<br/>Rambla Catalunya, 53-55, 6A<br/>08007  Barcelona - SPAIN<br/>+34 93 363 2854<br/><h5>This email and any files transmitted with it are confidential and intended solely for the use of the individual or entity to whom they are addressed. This message contains confidential information and is intended only for the individual named. If you are not the named addressee you should not disseminate, distribute or copy this e-mail. Please notify the sender immediately by e-mail if you have received this e-mail by mistake and delete this e-mail from your system. If you are not the intended recipient you are notified that disclosing, copying, distributing or taking any action in reliance on the contents of this information is strictly prohibited.</h5><br/></p>';

        var body = "<p>Dear Bidder,<br /><br />";

        body += "You have been registered on the ChartBid© On-line Procurement site, hosted at <a href='https://app.chartbid.com/'>https://app.chartbid.com/</a><br />";
        body += "To use the site, click on the link or copy and paste it in your browser.<br /><br />";

        body += "On the ChartBid© Login page, you should enter your email address as your User Name and also as your temporary Password.<br />";
        body += "<b>If you are already registered with Chartbid, please enter with your existing password</b>.<br /><br />";

        body += "<b>Your login data:<br />";
        body += "e-mail: " + pEmail + "<br />";
        body += "password: " + pPassword + "<br /></b><br /><br />";

        body += "The first time you log in, it is recommended that you change your password.<br />";
        body += "After logging in, click on your Username and go to “My Profile”.<br />";
        body += "You will see the information of all the users within your company here.<br />";
        body += "There may be up to 5 users to access the system.<br />";
        body += "You may modify the data on “My Profile” at any time; including usernames, contact details and passwords.<br /><br />";

        body += "You are responsible for all actions taken with this ID. New passwords should meet the following guidelines:<br />";
        body += "- ARE CASE SENSITIVE<br />";
        body += "- Must be at least 6 characters long<br />";
        body += "- We advise you to change your password regularly.<br /><br /><br />";

        body += "PLEASE DO NOT REPLY TO THIS AUTOMATED EMAIL AS THESE REPLIES ARE NOT MONITORED.<br /><br />";

        body += "If you experience a:<br />";
        body += "- Password problem, please click on the FORGOT PASSWORD link for a password reset.<br />";
        body += "- If you experience a technical or usability issue please contact Chart Shipping at:<br />";
        body += "brokers@chartship.net or tel: +34 933 632 854<br /><br />";

        body += "Best Regards,</p>";

        body += linkToChartbid;
        body += CSSLfooter;

        var dataToSend = {
            'user': userAPI,
            'password': passwordAPI,
            'arrayDestinationEmail': pEmail,
            'emailSender': 'chartship@chartbid.com',
            'nameSender': 'Chart Shipping',
            'subject': subject,
            'body': body
        };

        var config = {
            headers : {
                'Content-Type': 'application/json;charset=utf-8',
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Methods': '*',
                'Access-Control-Allow-Origin': 'https://burning-inferno-2655.firebaseapp.com,https://bidder-app.firebaseapp.com,https://developer-admin-app.firebaseapp.com,https://developer-bidder-app.firebaseapp.com,http://localhost:3000,https://localhost:3000'
            }
        }

// (24/03/2025) - INICIO
        //we send the mail by means of the webAPI
        //$http.post('https://webapi2256.azurewebsites.net/api/Mailer', dataToSend, config)

        //we send the mail using Webhook from MAKE connected to AuthSMTP API.
        $http.post('https://hook.eu2.make.com/38dkvazlmbgon2dfb88mv4mxi5vjxr4b', dataToSend, config)
		
// (24/03/2025) - FIN		

            .success(function (data, status, headers, config) {
                //$scope.PostDataResponse = pEmailData;
                //console.log("ENVIADOS CORRECTAMENTE LOS DATOS DE LOGIN A TRAVES DE sendGrid a la cuenta " + pEmail);

                return true;
            })
            .error(function (data, status, header, config) {

                //console.log("ERROR AL ENVIAR DATOS DE LOGIN A TRAVES DE sendGrid");

                return false;
            });

    }



    function sendUpdateBidderNotification(pMessage) {

        var userAPI = 'developer@chartbid.com';
        var passwordAPI = 'a-Syns6wSuqV4EajR6t7ig';

        var data = "";
        var subject = '[CHARTBID] Notification - Bidder updated';

        var linkToChartbid = '<p><br/><a href="http://admin.chartbid.com/">You can access to Chartbid here</a></p>';
        var CSSLfooter = '<p><br/>Chart Shipping S.L.<br/>As brokers only<br/>-------------------------------------------<br/>Rambla Catalunya, 53-55, 6A<br/>08007  Barcelona - SPAIN<br/>+34 93 363 2854<br/><h5>This email and any files transmitted with it are confidential and intended solely for the use of the individual or entity to whom they are addressed. This message contains confidential information and is intended only for the individual named. If you are not the named addressee you should not disseminate, distribute or copy this e-mail. Please notify the sender immediately by e-mail if you have received this e-mail by mistake and delete this e-mail from your system. If you are not the intended recipient you are notified that disclosing, copying, distributing or taking any action in reliance on the contents of this information is strictly prohibited.</h5><br/></p>';

        var body = pMessage;

        body += linkToChartbid;
        body += CSSLfooter;

        var dataToSend = {
            'user': userAPI,
            'password': passwordAPI,
            'arrayDestinationEmail': 'brokers@chartship.net',
            'emailSender': 'chartship@chartbid.com',
            'nameSender': 'Chart Shipping',
            'subject': subject,
            'body': body
        };

        var config = {
            headers : {
                'Content-Type': 'application/json;charset=utf-8',
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Methods': '*',
                'Access-Control-Allow-Origin': 'https://burning-inferno-2655.firebaseapp.com,https://bidder-app.firebaseapp.com,https://developer-admin-app.firebaseapp.com,https://developer-bidder-app.firebaseapp.com,http://localhost:3000,https://localhost:3000'
            }
        }

// (24/03/2025) - INICIO
        //we send the mail by means of the webAPI
        //$http.post('https://webapi2256.azurewebsites.net/api/Mailer', dataToSend, config)

        //we send the mail using Webhook from MAKE connected to AuthSMTP API.
        $http.post('https://hook.eu2.make.com/38dkvazlmbgon2dfb88mv4mxi5vjxr4b', dataToSend, config)
// (24/03/2025) - FIN		

            .success(function (data, status, headers, config) {
                //$scope.PostDataResponse = pEmailData;
                //console.log("ENVIADOS CORRECTAMENTE LOS DATOS DE LOGIN A TRAVES DE sendGrid a la cuenta de brokers@chartship.net.");

                return true;
            })
            .error(function (data, status, header, config) {

                //console.log("ERROR AL ENVIAR DATOS DE LOGIN A TRAVES DE sendGrid");

                return false;
            });

    }




    function saveMail(pRecordToAdd) {

/*
        //ESTRUCTURA DEL PARÁMETRO "pRecordToAdd"
        var recordToAdd = {
            'itb_key': 'itb_key',
            'sender_key': 'sender_key',
            'itb_sender_key': 'itb_sender_key',
            'receiver_key': 'receiver_key',
            'itb_receiver_key': 'itb_receiver_key',
            'fromEmail': pData.emailSender,
            'fromName': pData.nameSender,
            'toEmail':pData.emailDestination,
            'toName':'toName',
            'subject': pData.subject,
            'date': fechaActualFormatoFirebase,
            'time': horaActual,
            'message': pData.body,
            'deleted': false,
            'type': pType,

            'pendingBcf': pendingBcf,
            'senderProfile': '',
            'itb_senderProfile': '',
            'receiverProfile': receiverProfile,
            'itb_receiverProfile': itb_receiverProfile
        };
*/

        var itbSenderKey = pRecordToAdd.itb_sender_key;

        //ACTUALIZAMOS EL VALOR EN LA TABLA "workflow" DE FIREBASE
//        var fbUrl = new Firebase(FIREBASE_URL + "/communications/");
        var fbUrl = firebaseDataService.communications;

        var result = $firebaseArray(fbUrl.orderByChild("itb_sender_key").equalTo(itbSenderKey));

        result.$loaded()
            .then(function(data) {

                result.$add(pRecordToAdd)
                    .then(function(ref) {
                        //console.log("[MailerService] saveMail() method => Saved record in 'communications' table of Firebase.");
                    });
            })

            .catch(function(error) {
                //console.log("ERROR: " + error);
            });
    }



    function testMailer() {

        var data = "";

        var config = {
            headers : {
                'Content-Type': 'application/json;charset=utf-8',
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Methods': '*',
                'Access-Control-Allow-Origin': 'https://burning-inferno-2655.firebaseapp.com,https://bidder-app.firebaseapp.com,https://developer-admin-app.firebaseapp.com,https://developer-bidder-app.firebaseapp.com,http://localhost:3000,https://localhost:3000'
            }
        }

// (24/03/2025) - INICIO
        //$http.get('http://webapi2256.azurewebsites.net/api/TestMailer?user=developer@chartbid.com&password=a-Syns6wSuqV4EajR6t7ig', data, config)

        //we send the mail using Webhook from MAKE connected to AuthSMTP API.
        $http.post('https://hook.eu2.make.com/38dkvazlmbgon2dfb88mv4mxi5vjxr4b', data, config)
// (24/03/2025) - FIN		

            .success(function (data, status, headers, config) {
                //console.log("ENVIADOS DATOS PARA EL ENVÍO DEL MAIL => " + data);
                return true;
            })
            .error(function (data, status, header, config) {
                /*
                $scope.ResponseDetails = "Data: " + data +
                    "<hr />status: " + status +
                    "<hr />headers: " + header +
                    "<hr />config: " + config;
                //console.log("ERROR AL ENVIAR DATOS PARA EL ENVÍO DEL MAIL => " + $scope.ResponseDetails);
                */
                //console.log("ERROR AL ENVIAR DATOS PARA EL ENVÍO DEL MAIL");
                return false;
            });
    }



    function sendContactData(pMessage) {

        var userAPI = 'developer@chartbid.com';
        var passwordAPI = 'a-Syns6wSuqV4EajR6t7ig';

        var data = "";
        var subject = '[CHARTBID] Contact Form - Request from user';

        //var linkToChartbid = '<p><br/><a href="http://admin.chartbid.com/">You can access to Chartbid here</a></p>';
        var CSSLfooter = '<p><br/>Chart Shipping S.L.<br/>As brokers only<br/>-------------------------------------------<br/>Rambla Catalunya, 53-55, 6A<br/>08007  Barcelona - SPAIN<br/>+34 93 363 2854<br/><h5>This email and any files transmitted with it are confidential and intended solely for the use of the individual or entity to whom they are addressed. This message contains confidential information and is intended only for the individual named. If you are not the named addressee you should not disseminate, distribute or copy this e-mail. Please notify the sender immediately by e-mail if you have received this e-mail by mistake and delete this e-mail from your system. If you are not the intended recipient you are notified that disclosing, copying, distributing or taking any action in reliance on the contents of this information is strictly prohibited.</h5><br/></p>';

        var body = pMessage;

        //body += linkToChartbid;
        body += CSSLfooter;

        var dataToSend = {
            'user': userAPI,
            'password': passwordAPI,
            'arrayDestinationEmail': 'brokers@chartship.net',
            'emailSender': 'chartship@chartbid.com',
            'nameSender': 'Chart Shipping',
            'subject': subject,
            'body': body
        };

        var config = {
            headers : {
                'Content-Type': 'application/json;charset=utf-8',
                'Access-Control-Allow-Headers': '*',
                'Access-Control-Allow-Methods': '*',
                'Access-Control-Allow-Origin': 'https://burning-inferno-2655.firebaseapp.com,https://bidder-app.firebaseapp.com,https://developer-admin-app.firebaseapp.com,https://developer-bidder-app.firebaseapp.com,http://localhost:3000,https://localhost:3000'
            }
        }

// (24/03/2025) - INICIO		
        //we send the mail by means of the webAPI
        //var result = $http.post('https://webapi2256.azurewebsites.net/api/Mailer', dataToSend, config);
		
        //we send the mail using Webhook from MAKE connected to AuthSMTP API.
        $http.post('https://hook.eu2.make.com/38dkvazlmbgon2dfb88mv4mxi5vjxr4b', dataToSend, config)
// (24/03/2025) - FIN		

        return result;
    }


	

    //************ GETTERs *******************



    //************ SETTERs *******************



  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('loginService', loginService);

//  itbStatusService.$inject = ['$firebaseObject', 'firebaseDataService'];

  function loginService(firebaseDataService,$http,$firebaseArray) {

    var login = new login();

    var service = {
        login: login,
        getLogin: getLogin,
        resetLogin: resetLogin,

        getBidderLogin: getBidderLogin,
        //getAdministratorLogin: getAdministratorLogin,
        //getChartererLogin: getChartererLogin,
        getName: getName,
        getEmail: getEmail,
        getUserKey: getUserKey,
        getUserProfile: getUserProfile,
        setName: setName,
        setEmail: setEmail,
        setUserKey: setUserKey,
        setUserProfile: setUserProfile,
        save: save
    };

    return service;



    ////////////
    function login() {

      this.name = "";
      this.email = "";
      this.userKey = "";
      this.userProfile = "";        //POSSIBLE VALUES = ["administrator","charterer"]
      this.ok = false;

      //console.log("INICIO EJECUCION constructor login()");
      //console.log("this.name = " + this.name);
      //console.log("this.email = " + this.email);
      //console.log("this.userKey = " + this.userKey);
      //console.log("this.userProfile = " + this.userProfile);
      //console.log("this.ok = " + this.ok);
      //console.log("FIN EJECUCION constructor login()");
    }



    function getLogin() {

        //console.log("EJECUCION getLogin()");
        //console.log("this.name = " + this.name);
        //console.log("this.email = " + this.email);
        //console.log("this.userKey = " + this.userKey);
        //console.log("this.userProfile = " + this.userProfile);
        //console.log("this.ok = " + this.ok);
        //console.log("FIN EJECUCION constructor login()");

        return this;
    }


    function resetLogin() {

      this.name = "";
      this.email = "";
      this.userKey = "";
      this.userProfile = "";        //POSSIBLE VALUES = ["administrator","charterer"]
      this.ok = false;
    }


    function getBidderLogin(pEmail,pPassword,pContactNumber) {

        if ( (pEmail != null) && (pEmail.trim().length > 0) && (pPassword != null) && (pPassword.trim().length > 0) ) {

//            var fbUrl = new Firebase(FIREBASE_URL + "/bidders/");
            var fbUrl = firebaseDataService.bidders;
            
            var result;

            if (pContactNumber == 0){
                result = $firebaseArray(fbUrl.orderByChild("email").equalTo(pEmail));
            } 
            else if (pContactNumber == 1) {
                result = $firebaseArray(fbUrl.orderByChild("email1").equalTo(pEmail));
            }
            else if (pContactNumber == 2) {
                result = $firebaseArray(fbUrl.orderByChild("email2").equalTo(pEmail));
            }
            else if (pContactNumber == 3) {
                result = $firebaseArray(fbUrl.orderByChild("email3").equalTo(pEmail));
            }
            else if (pContactNumber == 4) {
                result = $firebaseArray(fbUrl.orderByChild("email4").equalTo(pEmail));
            }

            return result;

        } else {

            return null;
        } 
    }


/*
    function getAdministratorLogin(pEmail,pPassword) {

        if ( (pEmail != null) && (pEmail.trim().length > 0) && (pPassword != null) && (pPassword.trim().length > 0) ) {

            var fbUrl = new Firebase(FIREBASE_URL + "/administrators/");
            var result = $firebaseArray(fbUrl.orderByChild("email").equalTo(pEmail));

            return result;

        } else {

            return null;
        } 
    }


  function getChartererLogin(pEmail,pPassword) {

        if ( (pEmail != null) && (pEmail.trim().length > 0) && (pPassword != null) && (pPassword.trim().length > 0) ) {

            var fbUrl = new Firebase(FIREBASE_URL + "/charterers/");
            var result = $firebaseArray(fbUrl.orderByChild("email").equalTo(pEmail));

            return result;

        } else {

            return null;
        } 
    }
*/


    function save(pRecordToAdd) {

/*
        var recordToAdd = {
            'name': 'value',
        };
*/

/*
        var itbSenderKey = pRecordToAdd.itb_sender_key;

        //ACTUALIZAMOS EL VALOR EN LA TABLA "workflow" DE FIREBASE      
        var fbUrl = new Firebase(FIREBASE_URL + "/communications/");
        var result = $firebaseArray(fbUrl.orderByChild("itb_sender_key").equalTo(itbSenderKey));

        result.$loaded()
            .then(function(data) {

                result.$add(pRecordToAdd)
                    .then(function(ref) {
                        //console.log("[MailerService] saveMail() method => Saved record in 'communications' table of Firebase.");
                    });
            })

            .catch(function(error) {
                //console.log("ERROR: " + error);
            });
*/            
    }







    //************ GETTERs *******************
    function getName() {
        return this.name;
    }


    function getEmail() {
        return this.email;
    }

    function getUserKey() {
        return this.userKey;
    }

    function getUserProfile() {
        return this.userProfile;
    }


    //************ SETTERs *******************
    function setName(pValue) {
        this.name = pValue;
    }

    function setEmail(pValue) {
        this.email = pValue;
    }

    function setUserKey(pValue) {
        this.userKey = pValue;
    }

    function setUserProfile(pValue) {
        this.userProfile = pValue;
    }



  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('itbStatusService', itbStatusService);

//  itbStatusService.$inject = ['$firebaseObject', 'firebaseDataService'];

  function itbStatusService() {

    var status = new Status();
    var dataLoaded = false;
    

    var service = {
      status: Status,
      resetStatus: resetStatus,
      getStatus: getStatus,      
      setItbKey: setItbKey,
      setBidderKey: setBidderKey,      
      setItbBidderKey: setItbBidderKey,
      setItbName: setItbName,
      setBidderName: setBidderName,
      setItbStatus: setItbStatus,
      setBidderStatus: setBidderStatus,
      setRejectReason: setRejectReason,
      setCharterer: setCharterer,
      setChartererKey: setChartererKey,
      setChartererReference: setChartererReference,
      setChartererEmails: setChartererEmails,
      setAdministratorEmails: setAdministratorEmails,

      setItbReference: setItbReference,
      
      setItbCommencementDate: setItbCommencementDate,
      setItbClosingDate: setItbClosingDate,
      setItbCommencementTime: setItbCommencementTime,
      setItbClosingTime: setItbClosingTime,
      
      setCounterVisible: setCounterVisible,
      setCounterTime: setCounterTime,
      setCounterStart: setCounterStart,

      setAddVesselComments:setAddVesselComments,
      setTechnicalDocsComments: setTechnicalDocsComments,
      setCommercialDocsComments: setCommercialDocsComments,
      setGeneralDocsComments: setGeneralDocsComments,
      setOtherDocsComments: setOtherDocsComments,
      setBcfDocsComments: setBcfDocsComments,

      getItbKey: getItbKey,
      getBidderKey: getBidderKey,
      getItbBidderKey: getItbBidderKey,
      getItbName: getItbName,
      getBidderName: getBidderName,
      getItbStatus: getItbStatus,
      getBidderStatus: getBidderStatus,
      getRejectReason: getRejectReason,
      getCharterer: getCharterer,
      getChartererKey: getChartererKey,
      getChartererReference: getChartererReference,
      getChartererEmails: getChartererEmails,
      getAdministratorEmails: getAdministratorEmails,

      getItbReference: getItbReference,

      getItbCommencementDate: getItbCommencementDate,
      getItbClosingDate: getItbClosingDate,
      
      getItbCommencementTime: getItbCommencementTime,
      getItbClosingTime: getItbClosingTime,
      
      getCounterVisible: getCounterVisible,
      getCounterTime: getCounterTime,
      getCounterStart: getCounterStart,

      getAddVesselComments:getAddVesselComments,
      getTechnicalDocsComments: getTechnicalDocsComments,
      getCommercialDocsComments: getCommercialDocsComments,
      getGeneralDocsComments: getGeneralDocsComments,
      getOtherDocsComments: getOtherDocsComments,
      getBcfDocsComments: getBcfDocsComments

/*      
      setBidSelectItbStatus: setBidSelectItbStatus,
      setBidReceiptItbStatus: setBidReceiptItbStatus,
      setBidSubmissionBidStatus: setBidSubmissionBidStatus,
      setBidCompletionBcfStatus: setBidCompletionBcfStatus
*/      
/*      
      setSelectItbStatus: setSelectItbStatus,
      setPrepareItbStatus: setPrepareItbStatus,
      setCreateBidderStatus: setCreateBidderStatus,
      setReleaseItbStatus: setReleaseItbStatus,
      setReceivedBidsStatus: setReceivedBidsStatus,
      setCompletedItbStatus: setCompletedItbStatus
*/      
    };

    return service;


    ////////////
    function Status() {

      this.itbKey = "";
      this.bidderKey = "";
      this.itbBidderKey = this.itbKey + "&" + this.bidderKey;
      this.itbName = "";
      this.bidderName = "";
      this.itbStatus = "";
      this.bidderStatus = "";
      this.rejectReason = "";
      this.charterer = "";
      this.chartererKey = "";
      this.chartererReference = "",
      this.chartererEmails = "";
      this.administratorEmails = "";

      this.itbReference = "",

      this.counterVisible = false;
      this.counterTime = 0;
      this.counterStart = false;


      this.itbCommencementDate = "";
      this.itbClosingDate = "";
      this.itbCommencementTime = "";
      this.itbClosingTime = "";

      this.addVesselComments = "";
      this.technicalDocsComments = "";
      this.commercialDocsComments = "";
      this.generalDocsComments = "";
      this.otherDocsComments = "";
      this.bcfDocsComments = "";

/*
      this.bidSelectItbStatus = true;
      this.bidReceiptItbStatus = false;
      this.bidSubmissionBidStatus = false;
      this.bidCompletionBcfStatus = false;
*/
/*
      this.selectItbStatus = true;
      this.prepareItbStatus = false;
      this.createBidderStatus = false;
      this.releaseItbStatus = false;
      this.receivedBidsStatus = false;
      this.completedItbStatus = false;
*/      
    }


    //************ GETTERs *******************
    function getStatus() {

      //console.log("************************************************************************");      
      //console.log("[itbStatusService] this.itbKey = " + this.itbKey);
      //console.log("[itbStatusService] this.bidderKey = " + this.bidderKey);
      //console.log("[itbStatusService] this.itbBidderKey = " + this.itbBidderKey);
      //console.log("[itbStatusService] this.itbName = " + this.itbName);
      //console.log("[itbStatusService] this.bidderName = " + this.bidderName);
      //console.log("[itbStatusService] this.itbStatus = " + this.itbStatus);
      //console.log("[itbStatusService] this.bidderStatus = " + this.bidderStatus);
      //console.log("[itbStatusService] this.rejectReason = " + this.rejectReason);
      //console.log("[itbStatusService] this.charterer = " + this.charterer);
      //console.log("[itbStatusService] this.chartererKey = " + this.chartererKey);
      //console.log("[itbStatusService] this.chartererReference = " + this.chartererReference);
      //console.log("[itbStatusService] this.chartererEmails = " + this.chartererEmails);
      //console.log("[itbStatusService] this.administratorEmails = " + this.administratorEmails);

      //console.log("[itbStatusService] this.itbReference = " + this.itbReference);

      //console.log("[itbStatusService] this.counterVisible = " + this.counterVisible);
      //console.log("[itbStatusService] this.counterTime = " + this.counterTime);
      //console.log("[itbStatusService] this.setCounterStart = " + this.setCounterStart);
      
      //console.log("[itbStatusService] this.itbCommencementDate = " + this.itbCommencementDate);
      //console.log("[itbStatusService] this.itbClosingDate = " + this.itbClosingDate);
      //console.log("[itbStatusService] this.itbCommencementTime = " + this.itbCommencementTime);
      //console.log("[itbStatusService] this.itbClosingTime = " + this.itbClosingTime);

      //console.log("[itbStatusService] this.addVesselComments = " + this.addVesselComments);
      //console.log("[itbStatusService] this.technicalDocsComments = " + this.technicalDocsComments);
      //console.log("[itbStatusService] this.commercialDocsComments = " + this.commercialDocsComments);
      //console.log("[itbStatusService] this.generalDocsComments = " + this.generalDocsComments);
      //console.log("[itbStatusService] this.otherDocsComments = " + this.otherDocsComments);
      //console.log("[itbStatusService] this.bcfDocsComments = " + this.bcfDocsComments);

/*
      //console.log("[itbStatusService] this.selectItbStatus = " + this.selectItbStatus);
      //console.log("[itbStatusService] this.prepareItbStatus = " + this.prepareItbStatus);
      //console.log("[itbStatusService] this.createBidderStatus = " + this.createBidderStatus);
      //console.log("[itbStatusService] this.releaseItbStatus = " + this.releaseItbStatus);
      //console.log("[itbStatusService] this.receivedBidsStatus = " + this.receivedBidsStatus);
      //console.log("[itbStatusService] this.completedItbStatus = " + this.completedItbStatus);
      //console.log("************************************************************************");

      //console.log("[itbStatusService] this.bidSelectItbStatus = " + this.bidSelectItbStatus);
      //console.log("[itbStatusService] this.bidReceiptItbStatus = " + this.bidReceiptItbStatus);
      //console.log("[itbStatusService] this.bidSubmissionBidStatus = " + this.bidSubmissionBidStatus);
      //console.log("[itbStatusService] this.bidCompletionBcfStatus = " + this.bidCompletionBcfStatus);
      //console.log("************************************************************************");      
*/
      return this;
    }


    function resetStatus() {

      this.itbKey = "";
      this.bidderKey = "";
      this.itbBidderKey = "";
      this.itbName = "";
      this.bidderName = "";
      this.itbStatus = "";
      this.bidderStatus = "";
      this.rejectReason = "";
      this.charterer = "";
      this.chartererKey = "";
      this.chartererReference = "",
      this.chartererEmails = "";
      this.administratorEmails = "";

      this.itbReference = "",

      this.counterVisible = false;
      this.counterTime = 0;
      this.counterStart = false;


      this.itbCommencementDate = "";
      this.itbClosingDate = "";
      this.itbCommencementTime = "";
      this.itbClosingTime = "";

      this.addVesselComments = "";
      this.technicalDocsComments = "";
      this.commercialDocsComments = "";
      this.generalDocsComments = "";
      this.otherDocsComments = "";
      this.bcfDocsComments = "";
    }


/*
    function setSelectItbStatus(status) {
      
      var workflowStatus = $firebaseArray(firebaseDataService.workflow);

      if (this.workflow.selectItb != null) {

        this.workflow.selectItb = status;

        workflowStatus.$save(this.workflow)
            .then(function(ref) {
                //console.log("Saved record with workflow STATUS");
            }
        );
      }
    }
*/

    function getItbKey() {
        return this.itbKey;
    }

    function getBidderKey() {
        return this.bidderKey;
    }

    function getItbBidderKey() {
        return this.itbBidderKey;
    }

    function getItbName() {
      return this.itbName;
    }

    function getBidderName() {
      return this.bidderName;
    }

    function getItbStatus() {
      return this.itbStatus;
    }
    
    function getBidderStatus() {
      return this.bidderStatus;
    }

    function getRejectReason() {
      return this.rejectReason;
    }

    function getCharterer() {
      return this.charterer;
    }

    function getChartererKey() {
      return this.chartererKey;
    }

    function getChartererReference() {
      return this.chartererReference;
    }

    function getChartererEmails() {
      return this.chartererEmails;
    }

    function getAdministratorEmails() {
      return this.administratorEmails;
    }

      
    function getItbReference() {
      return this.itbReference;
    }

    function getCounterVisible() {
      return this.counterVisible;
    }

    function getCounterTime() {
      return this.counterTime;
    }

    function getCounterStart() {
      return this.counterStart;
    }


    function getItbCommencementDate() {
      return this.itbCommencementDate;
    }

    function getItbClosingDate() {
      return this.itbClosingDate;
    }

    function getItbCommencementTime() {
      return this.itbCommencementTime;
    }

    function getItbClosingTime() {
      return this.itbClosingTime;
    }


    function getAddVesselComments() {
      return this.addVesselComments;
    }

    function getTechnicalDocsComments() {
      return this.technicalDocsComments;
    }

    function getCommercialDocsComments() {
      return this.commercialDocsComments;
    }

    function getGeneralDocsComments() {
      return this.generalDocsComments;
    }

    function getOtherDocsComments() {
      return this.otherDocsComments;
    }

    function getBcfDocsComments() {
      return this.bcfDocsComments;
    }


    //************ SETTERs *******************
    function setItbKey(pKey) {
        this.itbKey = pKey;
    }

    function setBidderKey(pKey) {
        this.bidderKey = pKey;
    }

    function setItbBidderKey(pKey) {
        this.itbBidderKey = pKey;
    }

    function setItbName(pName) {
        this.itbName = pName;
    }

    function setBidderName(pName) {
        this.bidderName = pName;
    }

    function setItbStatus(pStatus) {
        this.itbStatus = pStatus;
    }

    function setBidderStatus(pStatus) {
        this.bidderStatus = pStatus;
    }

    function setRejectReason(pReason) {
      this.rejectReason = pReason;
    }

    function setCharterer(pValue) {
        this.charterer = pValue;
    }

    function setChartererKey(pValue) {
        this.chartererKey = pValue;
    }

    function setChartererReference(pValue) {
        this.chartererReference = pValue;
    }

    function setChartererEmails(pValue) {
        this.chartererEmails = pValue;
    }

    function setAdministratorEmails(pValue) {
        this.administratorEmails = pValue;
    }

    function setItbReference(pValue) {
        this.itbReference = pValue;
    }


    function setCounterVisible(pValue) {
      this.counterVisible = pValue;
    }

    function setCounterTime(pValue) {
      this.counterTime = pValue;

      //console.log("[itbStatusService] this.counterTime = " + this.counterTime);
    }


    function setCounterStart(pValue) {
      this.counterStart = pValue;

      //console.log("[itbStatusService] this.counterStart = " + this.counterStart);
    }

    function setItbCommencementDate(pValue) {
      this.itbCommencementDate = pValue;
    }

    function setItbClosingDate(pValue) {
      this.itbClosingDate = pValue;
    }

    function setItbCommencementTime(pValue) {
      this.itbCommencementTime = pValue;
    }

    function setItbClosingTime(pValue) {
      this.itbClosingTime = pValue;
    }


    function setAddVesselComments(pValue) {
      this.addVesselComments = pValue;
    }

    function setTechnicalDocsComments(pValue) {
      this.technicalDocsComments = pValue;
    }

    function setCommercialDocsComments(pValue) {
      this.commercialDocsComments = pValue;
    }

    function setGeneralDocsComments(pValue) {
      this.generalDocsComments = pValue;
    }

    function setOtherDocsComments(pValue) {
      this.otherDocsComments = pValue;
    }

    function setBcfDocsComments(pValue) {
      this.bcfDocsComments = pValue;
    }


/*
    function setBidSelectItbStatus(pStatus) {
        this.bidSelectItbStatus = pStatus;
    }


    function setBidReceiptItbStatus(pStatus) {
        this.bidReceiptItbStatus = pStatus;
    }


    function setBidSubmissionBidStatus(pStatus) {
        this.bidSubmissionBidStatus = pStatus;
    }


    function setBidCompletionBcfStatus(pStatus) {
        this.bidCompletionBcfStatus = pStatus;
    }
*/
/*
    function setSelectItbStatus(pStatus) {
        this.selectItbStatus = pStatus;
    }
      

    function setPrepareItbStatus(pStatus) {
        this.prepareItbStatus = pStatus;
    }


    function setCreateBidderStatus(pStatus) {
        this.createBidderStatus = pStatus;
    }


    function setReleaseItbStatus(pStatus) {
        this.releaseItbStatus = pStatus;
    }


    function setReceivedBidsStatus(pStatus) {
        this.receivedBidsStatus = pStatus;
    }


    function setCompletedItbStatus(pStatus) {
        this.completedItbStatus = pStatus;
    }
*/

  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('firebaseDataService', firebaseDataService);


  function firebaseDataService() {

/*
    //TEST SERVER - DEVELOPER
    var config = {
        apiKey: "AIzaSyCpPyaSPSOdu0dT7C-W4yCfjorESDzJb80",
        authDomain: "projectId.firebaseapp.com",
        databaseURL: "https://developer-bidder-app.firebaseio.com/",
        storageBucket: "gs://developer-bidder-app.appspot.com/",
    };
*/


    //PRODUCTION SERVER
    var config = {
        apiKey: "AIzaSyD8iaDxnCuy1iTXaJEUrn97lYBdWahfJkw",
        authDomain: "firebase-bidder-app.firebaseapp.com",
        databaseURL: "https://bidder-app.firebaseio.com/",
        storageBucket: "gs://firebase-bidder-app.appspot.com/",
    };



    firebase.initializeApp(config);

    var firebaseRootRef = firebase.database().ref();
    var firebaseStorageRootRef = firebase.storage().ref();




    var service = {

      firebaseRootRef: firebaseRootRef,
      firebaseStorageRootRef: firebaseStorageRootRef,

      administrators: firebaseRootRef.child('administrators'),
      charterers: firebaseRootRef.child('charterers'),
      bidders: firebaseRootRef.child('bidders'),
      itbs: firebaseRootRef.child('itbs'),
      itb_bidders: firebaseRootRef.child('itb_bidders'),
      docs: firebaseRootRef.child('docs'),
      workflow: firebaseRootRef.child('workflow'),
      workflow_bidder: firebaseRootRef.child('workflow_bidder'),
      traceability: firebaseRootRef.child('traceability'),
      communications: firebaseRootRef.child('communications'),
      vessel_bidders: firebaseRootRef.child('vessel_bidders'),
      pending_commercial_docs: firebaseRootRef.child('pending_commercial_docs'),
      commercial_docs: firebaseRootRef.child('commercial_docs'),
      pending_general_docs: firebaseRootRef.child('pending_general_docs'),
      general_docs: firebaseRootRef.child('general_docs'),
      pending_technical_docs: firebaseRootRef.child('pending_technical_docs'),
      technical_docs: firebaseRootRef.child('technical_docs'),
      bcf_docs: firebaseRootRef.child('bcf_docs'),
      main_docs: firebaseRootRef.child('main_docs'),
      other_docs: firebaseRootRef.child('other_docs'),
      errors: firebaseRootRef.child('errors')
    };

    return service;
  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('errorLogService', errorLog);

  function errorLog(firebaseDataService,$firebaseArray,utilsService) {

    var errorLog = new ErrorLog();

    var service = {
/*      
      traceability: traceability,
      getTraceabilityFromFirebaseByItb: getTraceabilityFromFirebaseByItb,
      getTraceabilityFromFirebaseByUser: getTraceabilityFromFirebaseByUser,
      getTraceabilityByItb: getTraceabilityByItb,
      getTraceabilityByUser: getTraceabilityByUser,
*/
      getErrorLog: getErrorLog,
      setErrorLog: setErrorLog,
      addError: addError
   };

    return service;


    ////////////
    
    function ErrorLog() {

      return this;
    }


/*
    function getTraceabilityFromFirebaseByItb(pItbKey) {

      if (pItbKey != null) {

        var fbUrl = new Firebase(FIREBASE_URL + "/traceability/");
        var result = $firebaseArray(fbUrl.orderByChild("itb_key").equalTo(pItbKey));


        //ATENCION => EN VEZ DE DEVOLVER UN OBJETO traceability DEVOLVEMOS LA VARIABLE 'result' (OBJETO PROMISE) CON EL RESULTADO DE LA CONSULTA.
        //return result;

        result.$loaded()
            .then(function(data) {

                //Assign data to traceability
                traceability = data;

                //console.log("[traceabilityService] getTraceability() method => Get all records of 'itb_key' from 'traceability' table of Firebase.");

            })
            .catch(function(error) {
                //console.log("[traceabilityService] getTraceability() method => ERROR: " + error);
        });

      } else {

        traceability = null;
      }
    }


    function getTraceabilityFromFirebaseByUser(pUserKey) {

      if (pUserKey != null) {

        var fbUrl = new Firebase(FIREBASE_URL + "/traceability/");
        var result = $firebaseArray(fbUrl.orderByChild("user_key").equalTo(pUserKey));

        result.$loaded()
            .then(function(data) {

                //Assign data to traceability
                traceability = data;

                //console.log("[traceabilityService] getTraceabilityByUser() method => Get all records of 'user_key' from 'traceability' table of Firebase.");

            })
            .catch(function(error) {
                //console.log("[traceabilityService] getTraceabilityByUser() method => ERROR: " + error);
        });

      } else {

        traceability = null;
      }
    }



    function getTraceabilityByItb() {

        return traceability;
    }
      



    function getTraceabilityByUser() {

      return traceability;
    }
*/


    function getErrorLog() {

      return errorLog;
    }


    function setErrorLog(pArray) {

      errorLog = pArray;
    }



    function addError(pRecordToAdd) {

      if (pRecordToAdd != null) {

        var itbKey = pRecordToAdd.user_key;

        var fbUrl = firebaseDataService.errors;

        var records = $firebaseArray(fbUrl.orderByChild("itb_key").equalTo(itbKey).limitToLast(1));

        records.$add(pRecordToAdd)
            .then(function(ref) {
                //console.log("[errorLogService] addError() method executed successfully");
            })

            .catch(function(error) {
                //console.log("[errorLogService] ERROR in addError() method with error: " + error);
            }
        );
      }
      
    }




  }

})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('administratorService', administratorService);

  administratorService.$inject = ['$firebaseArray', 'firebaseDataService'];

  function administratorService($firebaseArray, firebaseDataService) {

    var administrators = null;
    var dataLoaded = false;
    
    var service = {
      administrator: Administrator,
      getAdministrators: getAdministrators,
      isDataLoaded: isDataLoaded,
      //getAdministratorById: getAdministratorById,
      addAdministrator: addAdministrator,
      deleteAdministrator: deleteAdministrator,
      deleteAll: deleteAll
    };

    return service;


    ////////////
    function Administrator() {
      this.name = '';
      this.email = '';
      //this.password = '';
    }


/*
    function getAdministrators() {
      if (!administrators) {
        administrators = $firebaseArray(firebaseDataService.administrators);
      }
      return administrators;
    }
*/


    function getAdministrators() {
      if (!administrators) {
        administrators = $firebaseArray(firebaseDataService.administrators);
        administrators.$loaded()
          .then(function(data) {
            data === administrators;
            dataLoaded = true;
            //console.log("(1) Administrators list LOADED with " + data.length + " rows.");
          })
          .catch(function(error) {
            //console.log("ERROR: " + error);
            dataLoaded = true;
            administrators = null;            
          });
      }
      return administrators;      
    }


    function isDataLoaded() {

      return dataLoaded;
    }



    function addAdministrator(administrator) {

/*
      //INICIO FUNCIONA OK
      firebaseDataService.administrators.push(administrator);
      administrators.$save(administrator);
      //FIN FUNCIONA OK
*/
      administrators.$add(administrator)
        .then(function(ref) {
          var id = ref.key;
          //console.log("Added record with ID = " + id);
        }
      );
      
    }

    function deleteAdministrator(administrator) {

      //console.log("SERVICE - Delete administrator");
      administrators.$remove(administrator)
        .then(function(ref) {
          //console.log("Delete record with ID = " + ref.key);
        }
      );
    }




    function deleteAll() {
      if (administrators) {
        administrators.$destroy();
        administrators = null;
      }
    }


/*
    function getPartiesByUser(uid) {
      if (!parties) {
        parties = $firebaseArray(firebaseDataService.users.child(uid).child('parties'));
      }
      return parties;
    }
*/




  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(api)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        api.quickPanel.activities.get({}, function (response)
        {
            vm.activities = response.data;
        });

        api.quickPanel.events.get({}, function (response)
        {
            vm.events = response.data;
        });

        api.quickPanel.notes.get({}, function (response)
        {
            vm.notes = response.data;
        });

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/navigation');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active')
        })
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

//[@elusiona] INICIO CODIGO INSERTADO
            // Workflow
            'app.workflow',
//[@elusiona] FIN CODIGO INSERTADO

            // Quick panel
            'app.quick-panel',

            // Apps
//[@elusiona] CODIGO DESHABILITADO            'app.dashboards',
//[@elusiona] CODIGO DESHABILITADO      'app.calendar',

            'app.mail',
//            'app.file-manager',
//            'app.management',
            'app.workflow-bidder',
            'app.services',

//[@elusiona] CODIGO DESHABILITADO      'app.scrumboard',
//[@elusiona] CODIGO DESHABILITADO      'app.todo',

//[@elusiona] INICIO CODIGO INSERTADO
            'app.contact',
            'app.help',
//[@elusiona] FIN CODIGO INSERTADO            

            // Pages
            'app.pages'

            // User Interface
//[@elusiona] CODIGO DESHABILITADO      'app.ui',

            // Components
//[@elusiona] CODIGO DESHABILITADO      'app.components'
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, uiGmapGoogleMapApiProvider, $translateProvider, $provide, fuseConfigProvider)
    {
        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Enable debug logging
        $logProvider.debugEnabled(true);

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // uiGmapgoogle-maps configuration
        uiGmapGoogleMapApiProvider.configure({
            //    key: 'your api key',
            v        : '3.exp',
            libraries: 'weather,geometry,visualization'
        });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.quote.iconclass = 'icon-format-quote';

                return taTools;
            }
        ]);

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : true,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

//[@elusiona] INICIO CODIGO MODIFICADO      
//        $urlRouterProvider.otherwise('/mail');

        $urlRouterProvider.otherwise('/pages/auth/login');        
//[@elusiona] FIN CODIGO MODIFICADO                          


        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
/*   
//[@elusiona] INICIO CODIGO DESHABILITADO      
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
//[@elusiona] FIN CODIGO DESHABILITADO                  
*/
        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: 'app/core/layouts/vertical-navigation.html',
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarController as vm'
                    },
//[@elusiona] INICIO CODIGO INSERTADO
                    'workflow@app'   : {
                        templateUrl: 'app/workflow/layouts/vertical-navigation/workflow.html',
                        controller : 'WorkflowController as vm'
                    },
//[@elusiona] FIN CODIGO INSERTADO
                    'navigation@app': {
                        templateUrl: 'app/navigation/layouts/vertical-navigation/navigation.html',
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });


    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')

        //BASE DATOS DE PRODUCCION
        .constant('FIREBASE_URL', 'https://bidder-app.firebaseIO.com/');
        
        //BASE DE DATOS DE TEST (DESARROLLO)
//        .constant('FIREBASE_URL', 'https://developer-bidder-app.firebaseIO.com/');


    })();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($mdDateLocaleProvider)
    {
	    $mdDateLocaleProvider.formatDate = function(date) {
    	   return moment(date).format('YYYY-MM-DD');
    	}

		$mdDateLocaleProvider.parseDate = function(dateString) {
    		var m = moment(dateString, 'YYYY/MM/DD', true);
    		return m.isValid() ? m.toDate() : new Date(NaN);
		};    	

    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allows you to
         * add hardcoded parameters to your API calls that you want them to be sent every
         * time you make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *          list     : $resource('http://api.example.com/blog);
         *          getById  : $resource('http://api.example.com/blog/:id', {id: '@id'});
         *          getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'},
         *              'get': {method: 'GET', params: {getByDate: true}}
         *          );
         *      }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  //console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  //console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  //console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource servive, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        api.dashboard = {
            project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
            server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
            analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
        };

        api.cards = $resource(api.baseUrl + 'cards/cards.json');

        api.fileManager = {
            documents: $resource(api.baseUrl + 'file-manager/documents.json')
        };

        api.icons = $resource('assets/icons/selection.json');

        api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

        api.mail = {
            inbox: $resource(api.baseUrl + 'mail/inbox.json')
        };

        api.profile = {
            timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
            about       : $resource(api.baseUrl + 'profile/about.json'),
            photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
        };

        api.quickPanel = {
            activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
            contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
            events    : $resource(api.baseUrl + 'quick-panel/events.json'),
            notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
        };

        api.search = {
            classic : $resource(api.baseUrl + 'search/classic.json'),
            mails   : $resource(api.baseUrl + 'search/mails.json'),
            users   : $resource(api.baseUrl + 'search/users.json'),
            contacts: $resource(api.baseUrl + 'search/contacts.json')
        };

        api.scrumboard = {
            boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
            board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
        };

        api.tables = {
            employees   : $resource(api.baseUrl + 'tables/employees.json'),
            employees100: $resource(api.baseUrl + 'tables/employees100.json')
        };

        api.timeline = {
            page1: $resource(api.baseUrl + 'timeline/page-1.json'),
            page2: $resource(api.baseUrl + 'timeline/page-2.json'),
            page3: $resource(api.baseUrl + 'timeline/page-3.json')
        };

        api.todo = {
            tasks: $resource(api.baseUrl + 'todo/tasks.json'),
            tags : $resource(api.baseUrl + 'todo/tags.json')
        };

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login-v2', {
            url      : '/pages/auth/login-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login-v2': {
                    templateUrl: 'app/main/pages/auth/login-v2/login-v2.html',
                    controller : 'LoginV2Controller as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login-v2');

/*
[@elusiona] INICIO        
        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.login-v2', {
            title : 'Login v2',
            state : 'app.pages_auth_login-v2',
            weight: 2
        });
[@elusiona] FIN
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder.submission-bid', [
            'app.workflow-bidder.submission-bid.add-vessel',
            'app.workflow-bidder.submission-bid.required-technical-docs',
            'app.workflow-bidder.submission-bid.required-commercial-docs',
            'app.workflow-bidder.submission-bid.required-general-docs',
            'app.workflow-bidder.submission-bid.other-docs',
			'app.workflow-bidder.submission-bid.finish-upload'
        ])
        .config(config);


    /** @ngInject */
    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
/*        
        // Navigation
        msNavigationServiceProvider.saveItem('workflow-bidder.prepare-itb', {
            title : 'Prepare ITB',
            icon :  'icon-numeric-2-box',
            weight: 2
        });
*/        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.workflow-bidder', [
            'app.workflow-bidder.select-itb',
            'app.workflow-bidder.receipt-itb',
            'app.workflow-bidder.submission-bid',
            'app.workflow-bidder.completion-bcf'
        ])
        .config(config);


    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
/*        
        msNavigationServiceProvider.saveItem('workflow-bidder', {
            title : 'Workflow (BIDDER)',
            icon :  'icon-transfer',
            weight: 6
        });
*/        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.management', [
            'app.management.administrator',
            'app.management.charterer',
            'app.management.bidder',
            'app.management.itb',
            'app.management.traceability'
        ])
        .config(config);


    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        
        msNavigationServiceProvider.saveItem('management', {
            title : 'Management',
            icon : 'icon-oil',
            weight: 3
        });
        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards', [
            'app.dashboards.project',
            'app.dashboards.server',
            'app.dashboards.analytics'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
/*        
        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : 'APPS',
            group : true,
            weight: 1
        });
*/        
/*
        msNavigationServiceProvider.saveItem('apps.dashboards', {
            title : 'Dashboards',
            icon  : 'icon-tile-four',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.project', {
            title: 'Project',
            state: 'app.dashboards_project'
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.server', {
            title: 'Server',
            state: 'app.dashboards_server'
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.analytics', {
            title: 'Analytics',
            state: 'app.dashboards_analytics'
        });
*/        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui', [
            'app.ui.forms',
            'app.ui.icons',
            'app.ui.material-colors',
            'app.ui.page-layouts.blank',
            'app.ui.page-layouts.carded.fullwidth',
            'app.ui.page-layouts.carded.fullwidth-ii',
            'app.ui.page-layouts.carded.left-sidenav',
            'app.ui.page-layouts.carded.left-sidenav-ii',
            'app.ui.page-layouts.carded.right-sidenav',
            'app.ui.page-layouts.carded.right-sidenav-ii',
            'app.ui.page-layouts.simple.fullwidth',
            'app.ui.page-layouts.simple.left-sidenav',
            'app.ui.page-layouts.simple.left-sidenav-ii',
            'app.ui.page-layouts.simple.right-sidenav',
            'app.ui.page-layouts.simple.right-sidenav-ii',
            'app.ui.page-layouts.simple.tabbed',
            'app.ui.theme-colors',
            'app.ui.typography'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('ui', {
            title : 'USER INTERFACE',
            group : true,
            weight: 3
        });

        msNavigationServiceProvider.saveItem('ui.forms', {
            title: 'Forms',
            icon : 'icon-window-restore',
            state: 'app.ui_forms'
        });

        msNavigationServiceProvider.saveItem('ui.icons', {
            title: 'Icons',
            icon : 'icon-file-image-box',
            state: 'app.ui_icons'
        });

        msNavigationServiceProvider.saveItem('ui.typography', {
            title: 'Typography',
            icon : 'icon-format-size',
            state: 'app.ui_typography'
        });

        msNavigationServiceProvider.saveItem('ui.theme-colors', {
            title: 'Theme Colors',
            icon : 'icon-palette-advanced',
            state: 'app.ui_theme-colors'
        });

        msNavigationServiceProvider.saveItem('ui.material-colors', {
            title: 'Material Colors',
            icon : 'icon-palette',
            state: 'app.ui_material-colors'
        });


        msNavigationServiceProvider.saveItem('ui.page-layouts', {
            title: 'Page Layouts',
            icon : 'icon-view-quilt'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded', {
            title: 'Carded'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_carded_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth-ii', {
            title: 'Full Width (II)',
            state: 'app.ui_page-layouts_carded_fullwidth-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_carded_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_carded_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_carded_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_carded_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple', {
            title: 'Simple'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_simple_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_simple_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_simple_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_simple_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_simple_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.tabbed', {
            title: 'Tabbed',
            state: 'app.ui_page-layouts_simple_tabbed'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.blank', {
            title: 'Blank',
            state: 'app.ui_page-layouts_blank'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
//[@elusiona] DESHABILITADO            'app.pages.auth.login-v2',
            'app.pages.auth.bidder-profile',
//[@elusiona] DESHABILITADO            'app.pages.auth.register-v2',
            'app.pages.auth.forgot-password',
            'app.pages.auth.reset-password',
            'app.pages.auth.lock',
//[@elusiona] DESHABILITADO            'app.pages.coming-soon',
//[@elusiona] DESHABILITADO            'app.pages.error-404',
//[@elusiona] DESHABILITADO            'app.pages.error-500',
//[@elusiona] DESHABILITADO            'app.pages.invoice',

            'app.pages.maintenance',

//[@elusiona] DESHABILITADO                        'app.pages.profile',

//[@elusiona] DESHABILITADO            'app.pages.search',
//[@elusiona] DESHABILITADO            'app.pages.timeline'
        ])
        .config(config);





    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        
/*
        msNavigationServiceProvider.saveItem('pages', {
            title : 'PAGES',
            group : true,
            weight: 7
        });
*/        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components', [
            'app.components.cards',
            'app.components.charts.c3',
            'app.components.charts.chartist',
            'app.components.charts.chart-js',
            'app.components.charts.nvd3',
            'app.components.maps',
            'app.components.price-tables',
            'app.components.tables.simple-table',
            'app.components.tables.datatable',
            'app.components.widgets',
            'app.components.material-docs'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('components', {
            title : 'COMPONENTS',
            group : true,
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.cards', {
            title : 'Cards',
            icon  : 'icon-content-copy',
            state : 'app.components_cards'
        });

        msNavigationServiceProvider.saveItem('components.charts', {
            title: 'Charts',
            icon : 'icon-poll'
        });

        msNavigationServiceProvider.saveItem('components.charts.c3', {
            title: 'C3',
            state: 'app.components_charts_c3'
        });

        msNavigationServiceProvider.saveItem('components.charts.chart-js', {
            title: 'Chart.js',
            state: 'app.components_charts_chart-js'
        });

        msNavigationServiceProvider.saveItem('components.charts.chartist', {
            title: 'Chartist',
            state: 'app.components_charts_chartist'
        });

        msNavigationServiceProvider.saveItem('components.charts.nvd3', {
            title: 'nvD3',
            state: 'app.components_charts_nvd3'
        });

        msNavigationServiceProvider.saveItem('components.maps', {
            title: 'Maps',
            icon : 'icon-map-marker',
            state: 'app.components_maps'
        });

        msNavigationServiceProvider.saveItem('components.price-tables', {
            title: 'Price Tables',
            icon : 'icon-view-carousel',
            state: 'app.components_price-tables'
        });

        msNavigationServiceProvider.saveItem('components.tables', {
            title: 'Tables',
            icon : 'icon-table-large'
        });

        msNavigationServiceProvider.saveItem('components.tables.simple-table', {
            title: 'Simple Table',
            state: 'app.components_tables_simple-table'
        });

        msNavigationServiceProvider.saveItem('components.tables.datatable', {
            title: 'Datatable',
            state: 'app.components_tables_datatable'
        });

        msNavigationServiceProvider.saveItem('components.widgets', {
            title: 'Widgets',
            icon : 'icon-apps',
            state: 'app.components_widgets'
        });
    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination=\"\" md-swipe-content=\"\" md-stretch-tabs=\"always\"><md-tab><md-tab-label>TRACEABILITY</md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" ms-scroll=\"\" ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex=\"\"></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex=\"\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" ui-view=\"navigation\"></div><div id=\"content-container\" flex=\"\" layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex=\"\"><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll=\"\" ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex=\"\" layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-toolbar id=\"workflow\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"workflow\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-background md-hue-1\" ms-scroll=\"\" ui-view=\"content\" flex=\"\"></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll=\"\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex=\"\" layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon id=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon id=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label> <input id=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate=\"\" translate-attr-placeholder=\"TOOLBAR.SEARCH\" flex=\"\"></div>");
$templateCache.put("app/main/apps/calendar_DESHABILITADO/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" ng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span> <span class=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate=\"\" translate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span translate=\"CALENDAR.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate=\"\" translate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDAR.TODAY\">Today</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate=\"\" translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate=\"\" translate-attr-aria-label=\"CALENDAR.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate=\"\" translate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" aria-label=\"Previous\" translate=\"\" translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate=\"\" translate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate=\"\" translate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/apps/contact/contact.html","<div id=\"contact\" layout=\"column\" class=\"page-layout simple right-sidenav\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/apps/contact/views/detail/detail-view-contact.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/file-manager_DESHABILITADO/file-manager.html","<div id=\"file-manager\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/file-manager/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header md-accent-bg\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between\"><md-button class=\"md-icon-button main-sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle Main Sidenav\" translate=\"\" translate-attr-aria-label=\"FILE.TOOGLE_MAIN_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"right-side\" layout=\"row\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate=\"\" translate-attr-aria-label=\"FM.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span translate=\"FM.SEARCH\">Search</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'list\'\" class=\"md-icon-button\" ng-click=\"vm.toggleView()\" aria-label=\"view type\" translate=\"\" translate-attr-aria-label=\"FM.GRID_VIEW\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"FM.GRID_VIEW\">Grid View</span></md-tooltip></md-button><md-button ng-if=\"vm.currentView === \'grid\'\" class=\"md-icon-button\" aria-label=\"view type\" ng-click=\"vm.toggleView()\" translate=\"\" translate-attr-aria-label=\"FM.LIST_VIEW\"><md-icon md-font-icon=\"icon-view-headline\"></md-icon><md-tooltip><span translate=\"FM.LIST_VIEW\">List View</span></md-tooltip></md-button></div></div><div class=\"breadcrumb text-truncate\" layout=\"row\" layout-align=\"start center\"><span data-ng-repeat=\"path in vm.path\">{{path}}<md-icon md-font-icon=\"icon-chevron-right\" class=\"icon separator\"></md-icon></span></div></div><md-button class=\"add-file-button md-fab md-warn\" ng-click=\"vm.addFile($event)\" aria-label=\"Add file\" translate=\"\" translate-attr-aria-label=\"FM.ADD_FILE\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-if=\"vm.currentView === \'grid\'\" ng-include=\"\'app/main/apps/file-manager/views/grid/grid-view.html\'\"></div><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/file-manager/views/list/list-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/help/help.html","<div id=\"help\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-include=\"\'app/main/apps/help/views/list/list-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/mail/mail.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\" ng-show=\"vm.showCommunications\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/mail/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle Sidenav\" translate=\"\" translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" md-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for an e-mail or contact\" translate=\"\" translate-attr-placeholder=\"MAIL.SEARCH_PLACEHOLDER\"></div></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"content-wrapper\" layout=\"row\" flex=\"\"><md-tabs md-selected=\"vm.activeMailPaneIndex\" class=\"mail-tabs\" md-dynamic-height=\"{{vm.dynamicHeight}}\" flex=\"\"><md-tab><md-tab-label>Mails</md-tab-label><md-tab-body><div class=\"content mail-list-pane\" ng-include=\"\'app/main/apps/mail/views/list/list-view.html\'\" ms-scroll=\"\" ng-show=\"vm.showListPanel\"></div></md-tab-body></md-tab><md-tab><md-tab-label>Read Pane</md-tab-label><md-tab-body><div class=\"content mail-read-pane\" ng-include=\"\'app/main/apps/mail/views/read/read-view.html\'\" ms-scroll=\"\" ng-show=\"vm.showReadPanel\"></div></md-tab-body></md-tab></md-tabs></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/scrumboard.html","<div id=\"scrumboard\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"column\"><div class=\"header-content\" layout=\"row\" layout-align=\"space-between\" layout-wrap=\"\" flex=\"\"><div layout=\"row\" layout-align=\"center center\" flex-order=\"1\" flex-order-xs=\"2\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" ng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" ng-click=\"vm.boardSelectorVisible = !vm.boardSelectorVisible\" aria-label=\"boards button\" translate=\"\" translate-attr-aria-label=\"SB.BOARDS_BUTTON\"><md-icon md-font-icon=\"icon-trello\" class=\"icon\"></md-icon><span translate=\"SB.BOARDS\">BOARDS</span></md-button></div><div class=\"header-board-name\" layout=\"row\" layout-align=\"center center\" flex-order=\"2\" flex-order-xs=\"1\" flex-xs=\"100\"><i ng-if=\"vm.board.settings.subscribed\" class=\"board-subscribe s16 icon-eye\"></i> <span editable-text=\"vm.board.name\" onaftersave=\"vm.updateBoardUri()\">{{vm.board.name}}</span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" flex-order=\"3\"><md-button ui-sref-active-eq=\"ng-hide\" class=\"md-icon-button\" ui-sref=\"app.scrumboard.boards.board.calendar\" aria-label=\"Calendar\" translate=\"\" translate-attr-aria-label=\"SB.CALENDAR\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-tooltip><span translate=\"SB.CALENDAR\">Calendar</span></md-tooltip></md-button><md-button ui-sref-active-eq=\"ng-hide\" class=\"md-icon-button\" ui-sref=\"app.scrumboard.boards.board\" aria-label=\"Board\" translate=\"\" translate-attr-aria-label=\"SB.BOARD\"><md-icon md-font-icon=\"icon-trello\"></md-icon><md-tooltip><span translate=\"SB.BOARD\">Board</span></md-tooltip></md-button><md-button ng-if=\"vm.filteringIsOn()\" class=\"md-icon-button\" ng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate=\"\" translate-attr-aria-label=\"SB.CLEAR_FILTERS\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip sb.clear_filters=\"\">Clear Filters</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate=\"\" translate-attr-aria-label=\"SB.FILTER_CARDS\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span translate=\"SB.FILTER_CARDS\">Filter Cards</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" aria-label=\"Settings\" translate=\"\" translate-attr-aria-label=\"SB.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip><span translate=\"SB.SETTINGS\">Settings</span></md-tooltip></md-button></div></div></div><div ng-show=\"vm.boardSelectorVisible\" id=\"board-selector\" class=\"md-accent-bg animate-slide-down board-list md-whiteframe-3dp\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"row\" layout-align=\"start center\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" ui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex=\"\" class=\"board-name\">{{board.name}}</div><div class=\"board-options\"><i class=\"icon-dots-horizontal\"></i></div><div ng-if=\"board.id === vm.board.id\" class=\"selected-icon green-bg\"><i class=\"icon-check s24\"></i></div></div><div class=\"board-list-item add-new-board\" ui-sref=\"app.scrumboard.boards.addBoard\" ui-sref-active=\"hidden\" layout=\"column\" layout-align=\"space-between center\"><div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex=\"\" class=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add New Board</div></div></div><md-backdrop class=\"board-selector-backdrop md-dialog-backdrop md-opaque\" ng-show=\"vm.boardSelectorVisible\" ng-click=\"vm.boardSelectorVisible = false\" aria-hidden=\"true\"></md-backdrop><md-content class=\"content\" flex=\"\" layout=\"column\" ui-view=\"scrumboardContent\"></md-content><md-sidenav class=\"settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/settings-sidenav.html\'\" ng-controller=\"SettingsSidenavController as vm\" ms-sidenav-helper=\"\"></md-sidenav><md-sidenav class=\"filters-sidenav md-sidenav-right\" md-component-id=\"filters-sidenav\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/filters/filters-sidenav.html\'\" ng-controller=\"FiltersSidenavController as vm\" ms-sidenav-helper=\"\"></md-sidenav></div>");
$templateCache.put("app/main/apps/todo_DESHABILITADO/todo.html","<div id=\"todo\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/todo/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div class=\"search-wrapper md-whiteframe-4dp\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\" translate=\"\" translate-attr-aria-label=\"TODO.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex=\"\" ng-model=\"vm.taskFilters.search\" type=\"text\" placeholder=\"Search for a task or tag\" translate=\"\" translate-attr-placeholder=\"TODO.SEARCH\"></div></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified\" ng-model=\"vm.selectedFilter.dueDate\" placeholder=\"Due Date\"><md-option value=\"Next 3 days\" translate=\"TODO.NEXT_3_DAYS\">Next 3 days</md-option><md-option value=\"Next 7 days\" translate=\"TODO.NEXT_7_DAYS\">Next 7 days</md-option><md-option value=\"Next 2 weeks\" translate=\"TODO.NEXT_2_WEEKS\">Next 2 weeks</md-option><md-option value=\"Next month\" translate=\"TODO.NEXT_MONTH\">Next month</md-option></md-select><div layout=\"row\" layout-align=\"start center\"><md-select class=\"simplified\" ng-model=\"vm.taskOrder\" placeholder=\"Order\" ng-change=\"vm.taskOrderDescending = vm.taskOrder === \'\' ? false : vm.taskOrderDescending\"><md-option value=\"startDateTimestamp\" translate=\"TODO.START_DATE\">Start Date</md-option><md-option value=\"dueDateTimestamp\" translate=\"TODO.DUE_DATE\">Due Date</md-option><md-option value=\"\" translate=\"TODO.MANUAL\">Manual</md-option><md-option value=\"title\" translate=\"TODO.TITLE\">Title</md-option></md-select><md-button class=\"md-icon-button\" ng-disabled=\"vm.taskOrder === \'\'\" ng-click=\"vm.taskOrderDescending = !vm.taskOrderDescending\" aria-label=\"Sort Direction\" translate=\"\" translate-attr-aria-label=\"TODO.SORT_DIRECTION\"><md-icon md-font-icon=\"icon-sort-ascending\" ng-if=\"vm.taskOrderDescending === false\"></md-icon><md-icon md-font-icon=\"icon-sort-descending\" ng-if=\"vm.taskOrderDescending === true\"></md-icon></md-button></div></div><div class=\"content\" layout=\"row\" flex=\"\"><md-content class=\"todo-list-pane\" flex=\"\" ng-include=\"\'app/main/apps/todo/views/list/list-view.html\'\" ms-scroll=\"vm.msScrollOptions\"></md-content></div></div></div></div>");
$templateCache.put("app/main/components/cards/cards.html","<div id=\"cards\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div class=\"title\">Cards</div></div></div><div class=\"content\" md-background-bg=\"\"><p>Cards are useful for showing excerpts, quick information or notifications. Using <code>ms-card</code> directive you can easily create different cards compatible with Google\'s Material Design specifications.</p><p><code>ms-card</code> directive templates have pre-defined content areas. The reason for that is to force you to create cards that follows both Google\'s Material Design specifications and Fuse Theme\'s general design rules. But of course you can create your own designs and templates and use them with <code>ms-card</code> directive.</p><div><div class=\"md-title mt-32\">Template 1</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-1/template-1.html\'\" ng-model=\"vm.cards[0]\"></ms-card><div class=\"md-title mt-48\">Template 2</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-2/template-2.html\'\" ng-model=\"vm.cards[1]\"></ms-card><div class=\"md-title mt-48\">Template 3</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-3/template-3.html\'\" ng-model=\"vm.cards[2]\"></ms-card><div class=\"md-title mt-48\">Template 4</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-4/template-4.html\'\" ng-model=\"vm.cards[3]\"></ms-card><div class=\"md-title mt-48\">Template 5</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-5/template-5.html\'\" ng-model=\"vm.cards[4]\"></ms-card><div class=\"md-title mt-48\">Template 6</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-6/template-6.html\'\" ng-model=\"vm.cards[5]\"></ms-card><div class=\"md-title mt-48\">Template 7</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-7/template-7.html\'\" ng-model=\"vm.cards[6]\"></ms-card><div class=\"md-title mt-48\">Template 8</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-8/template-8.html\'\" ng-model=\"vm.cards[7]\"></ms-card><div class=\"md-title mt-48\">Template 9</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-9/template-9.html\'\" ng-model=\"vm.cards[8]\"></ms-card><div class=\"md-title mt-48\">Template 10</div><ms-card template=\"\'app/core/directives/ms-card/templates/template-10/template-10.html\'\" ng-model=\"vm.cards[9]\"></ms-card></div></div></div>");
$templateCache.put("app/main/components/maps/maps.html","<div id=\"maps\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div class=\"title\">Maps</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"http://angular-ui.github.io/angular-google-maps/\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><md-tabs md-stretch-tabs=\"\" md-selected=\"vm.selectedIndex\"><md-tab ui-sref=\"app.components_maps\">Simple Map</md-tab><md-tab ui-sref=\"app.components_maps.satellite\">Satellite Map</md-tab><md-tab ui-sref=\"app.components_maps.terrain\">Terrain Map</md-tab><md-tab ui-sref=\"app.components_maps.simple-marker\">Simple Marker</md-tab><md-tab ui-sref=\"app.components_maps.custom-marker\">Custom Marker</md-tab><md-tab ui-sref=\"app.components_maps.info-window\">Info Window</md-tab></md-tabs><md-content ui-view=\"tabContent\" flex=\"\" class=\"card md-whiteframe-4dp\"></md-content></div></div>");
$templateCache.put("app/main/components/material-docs/material-doc-template.html","<div class=\"doc-page material-docs doc-template page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">ANGULAR MATERIAL ELEMENTS</span></div><div class=\"title\">{{vm.componentName}}</div></div></div><div flex=\"\" class=\"content\"><md-tabs md-selected=\"selectedIndex\" md-dynamic-height=\"\"><md-tab ng-if=\"vm.demo\"><md-tab-label>{{vm.demo.label}} (Demo)</md-tab-label><md-tab-body><a class=\"reference-link md-yellow-200-bg\" href=\"https://material.angularjs.org/{{vm.materialVersion}}/demo/{{vm.demo.name}}\" target=\"_blank\">Go to official Angular Material <b>{{vm.demo.name}}</b> demo page</a><docs-demo ng-repeat=\"demo in vm.demos\" demo-id=\"{{demo.id}}\" demo-title=\"{{demo.label}}\" demo-module=\"{{demo.ngModule.module}}\"><demo-file ng-repeat=\"file in demo.$files\" name=\"{{file.name}}\" contents=\"file.httpPromise\"></demo-file></docs-demo></md-tab-body></md-tab><md-tab ng-repeat=\"doc in vm.docs\"><md-tab-label>{{doc.name}} ({{doc.type}})</md-tab-label><md-tab-body><a class=\"reference-link md-yellow-200-bg\" href=\"https://material.angularjs.org/{{vm.materialVersion}}/api/{{doc.type}}/{{doc.name}}\" target=\"_blank\">Go to official Angular Material <b>{{doc.name}} {{doc.type}}</b> documentation page</a><div class=\"\" ng-include=\"\'app/main/components/material-docs/\'+doc.outputPath\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/components/price-tables/price-tables.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">PAGES</span></div><div class=\"title\">Price Tables</div></div></div><div class=\"content\"><div class=\"md-title\">Style 1</div><div class=\"price-tables\" flex=\"\" layout=\"row\" layout-wrap=\"\"><div class=\"price-table style-1 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-primary-bg\"><span>BASIC</span></div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\">4</div><div class=\"period\">/ month</div></div></div><md-divider></md-divider><div class=\"terms\" layout=\"column\"><div class=\"term\"><span class=\"text-bold\">10</span> Projects</div><div class=\"term\"><span class=\"text-bold\">10</span> Pages</div><div class=\"term\"><span class=\"text-bold\">100</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">BUY NOW</md-button></div><div class=\"price-table style-1 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type md-primary-bg\" layout=\"row\" layout-align=\"space-between center\"><span>STANDARD</span> <span class=\"sale md-accent-color md-hue-1\">Save 15%</span></div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\">8</div><div class=\"period\">/ month</div></div></div><md-divider></md-divider><div class=\"terms\" layout=\"column\"><div class=\"term\"><span class=\"text-bold\">20</span> Projects</div><div class=\"term\"><span class=\"text-bold\">20</span> Pages</div><div class=\"term\"><span class=\"text-bold\">200</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">BUY NOW</md-button></div><div class=\"price-table style-1 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-primary-bg\" layout=\"row\"><span>ADVANCED</span></div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\">12</div><div class=\"period\">/ month</div></div></div><md-divider></md-divider><div class=\"terms\" layout=\"column\"><div class=\"term\"><span class=\"text-bold\">40</span> Projects</div><div class=\"term\"><span class=\"text-bold\">40</span> Pages</div><div class=\"term\"><span class=\"text-bold\">500</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">BUY NOW</md-button></div></div><div class=\"md-title\">Style 2</div><div class=\"price-tables\" flex=\"\" layout=\"row\" layout-wrap=\"\"><div class=\"price-table style-2 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-accent-fg\">SILVER PACKAGE</div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">99</div></div><div class=\"period\">PER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\"><span class=\"text-bold\">10</span> Projects</div><div class=\"term\"><span class=\"text-bold\">10</span> Pages</div><div class=\"term\"><span class=\"text-bold\">100</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED</md-button></div><div class=\"price-table style-2 md-whiteframe-8dp\" layout=\"column\"><div class=\"badge md-warn-bg\">BEST VALUE</div><div class=\"package-type md-accent-fg\">GOLD PACKAGE</div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">299</div></div><div class=\"period\">PER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\"><span class=\"text-bold\">20</span> Projects</div><div class=\"term\"><span class=\"text-bold\">20</span> Pages</div><div class=\"term\"><span class=\"text-bold\">200</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED</md-button></div><div class=\"price-table style-2 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-accent-fg\">PLATINUM PACKAGE</div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">499</div></div><div class=\"period\">PER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\"><span class=\"text-bold\">40</span> Projects</div><div class=\"term\"><span class=\"text-bold\">40</span> Pages</div><div class=\"term\"><span class=\"text-bold\">500</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED</md-button></div></div><div class=\"md-title\">Style 3</div><div class=\"price-tables\" flex=\"\" layout=\"row\" layout-align=\"start start\" layout-wrap=\"\"><div class=\"price-table style-3 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">Starter</div><div class=\"subtitle\">For small teams</div></div><div class=\"price md-primary-bg md-hue-3\" layout=\"row\" layout-align=\"center start\"><div class=\"currency md-accent-fg\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value md-accent-fg\">29</div><div class=\"period\">monthly per user</div></div></div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div class=\"term\">Unlimited pages</div><div class=\"term\">Unlimited disk space</div><div class=\"term\">24 / 7 Free support</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED FREE</md-button><div class=\"note\">7 day free trial to start</div></div><div class=\"price-table style-3 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">Pro</div><div class=\"subtitle\">For larger teams</div></div><div class=\"price md-primary-bg\" layout=\"row\" layout-align=\"center start\"><div class=\"currency md-accent-fg\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value md-accent-fg\">59</div><div class=\"period\">monthly per user</div></div></div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div class=\"term\">Unlimited pages</div><div class=\"term\">Unlimited disk space</div><div class=\"term\">24 / 7 Free support</div><div class=\"term md-warn-fg\">Advanced reporting</div><div class=\"term md-warn-fg\">Customizable interface</div><div class=\"term md-warn-fg\">CRM Integration</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED FREE</md-button><div class=\"note\">30 day free trial to start</div></div><div class=\"price-table style-3 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">Enterprise</div><div class=\"subtitle\">For big teams</div></div><div class=\"price md-primary-bg md-hue-3\" layout=\"row\" layout-align=\"center start\"><div class=\"currency md-accent-fg\">$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value md-accent-fg\">99</div><div class=\"period\">monthly per user</div></div></div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div class=\"term\">Unlimited pages</div><div class=\"term\">Unlimited disk space</div><div class=\"term\">For full feature list, call us</div></div><md-button class=\"cta-button md-raised md-accent\">CALL US</md-button><div class=\"note\">90 day free trial to start</div></div></div></div></div>");
$templateCache.put("app/main/components/widgets/widgets.html","<div id=\"widgets\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div class=\"title\">Widgets</div></div></div><div class=\"content\"><p class=\"h3 m-16\">Here you can see some of the other widget styles. These are just tiny example of what you can do with using <code class=\"no-highlight\">ms-widget</code> directive and helper classes. You are not limited to these styles or widgets, you can easily create wide variety of widgets.</p><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget1.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"md-display-1\" layout=\"row\" layout-align=\"start center\"><span>{{vm.widget1.value | number}}</span><md-icon md-font-icon=\"icon-trending-up\" class=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span>Last week: {{vm.widget1.lastWeekValue | number}}</span> <span class=\"text-boxed-light\">{{vm.widget1.lastWeekDiff}}</span></div></div></ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 green-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget2.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div><div class=\"md-display-1 pb-16\">{{vm.widget2.value}}%</div><div class=\"pb-16\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget2.value}}\"></md-progress-linear></div></div><div layout=\"row\" layout-align=\"start center\"><span>Last week: {{vm.widget2.lastWeekValue}}%</span> <span class=\"text-boxed-light\">{{vm.widget2.lastWeekDiff}}</span></div></div></ms-widget-front><ms-widget-back class=\"p-16 green-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 blue-grey-bg white-fg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget3.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex=\"\"><div><div class=\"md-display-1 pb-16\">{{vm.widget3.value}}%</div><div class=\"pb-8\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget3.value}}\"></md-progress-linear></div></div><div>See more details...</div></div></ms-widget-front><ms-widget-back class=\"p-16 blue-grey-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 deep-purple-bg white-fg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget4.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"md-display-1 pb-8\" layout=\"row\" layout-align=\"start center\"><span>{{vm.widget4.value | number}}</span><md-icon md-font-icon=\"icon-trending-down\" class=\"s36 ml-16\"></md-icon></div><div>See more details...</div></div></ms-widget-front><ms-widget-back class=\"p-16 deep-purple-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-1 pb-8\">{{vm.widget5.value}}</div><div class=\"font-weight-500 secondary-text\">{{vm.widget5.title}}</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"font-weight-500 secondary-text pb-8\">{{vm.widget6.title}}</div><div class=\"md-display-1\">{{vm.widget6.value}}</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex=\"\"><div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8\">{{vm.widget7.value}}</span> <span class=\"font-weight-500 secondary-text\">{{vm.widget7.title}}</span></div><div><md-icon md-font-icon=\"icon-thumb-up\" class=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex=\"\"><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex=\"\"><div><md-icon md-font-icon=\"icon-lock-unlocked\" class=\"s48 hint-text\"></md-icon></div><div class=\"pr-8\" layout=\"column\" layout-align=\"center end\"><div class=\"md-display-1 pb-8\">{{vm.widget8.value}}</div><div class=\"font-weight-500 secondary-text\">{{vm.widget8.title}}</div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 deep-orange-bg white-fg\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-3 pb-8\">{{vm.widget9.value}}</div><div class=\"h3 font-weight-500\">{{vm.widget9.title}}</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-music-note\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 cyan-bg white-fg\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-3 pb-8\">{{vm.widget10.value}}</div><div class=\"h3 font-weight-500\">{{vm.widget10.title}}</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-filmstrip\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 teal-bg white-fg\" layout=\"row\" flex=\"\"><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"md-display-3 pb-8\">{{vm.widget11.value}}</div><div class=\"h3 font-weight-500\">{{vm.widget11.title}}</div></div><div class=\"background-image-center\"><md-icon md-font-icon=\"icon-file-document\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 light-blue-bg\" layout=\"column\" flex=\"\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 secondary-text\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"s16 mr-8\"></md-icon><span class=\"font-weight-500\">{{vm.widget12.date}}</span><md-icon md-font-icon=\"icon-arrow-right\" class=\"s16 ml-8\"></md-icon></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"white-fg\" layout=\"column\" layout-align=\"center center\" flex=\"\"><div><md-icon md-font-icon=\"{{vm.widget12.icon}}\" class=\"s96\"></md-icon></div><div class=\"pt-16\" layout=\"row\" layout-align=\"center center\"><div class=\"md-display-2\">{{vm.widget12.temperature}}&deg;</div><div class=\"pl-16\" layout=\"column\"><div class=\"h1 text-semibold\">{{vm.widget12.event}}</div><div class=\"h4 secondary-text\">{{vm.widget12.location}}</div></div></div><div class=\"pt-32\" layout=\"row\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"s16\"></md-icon><span class=\"pl-8\">22 km/h</span></div><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-compass\" class=\"s16\"></md-icon><span class=\"pl-8\">NW</span></div></div></div></ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg\" layout=\"column\" flex=\"\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"pt-16 pb-16 white-fg\"><span class=\"h1\">Next 5 days</span></div><div class=\"pl-8 pr-8\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start center\" ng-repeat=\"detail in vm.widget12.detail\"><div class=\"h4 pb-8 black-fg secondary-text\">{{detail.day}}</div><md-icon md-font-icon=\"{{detail.icon}}\" class=\"s36 white-fg\"></md-icon><div class=\"h3 pt-8 white-fg\">{{detail.temperature}}&deg;</div></div></div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" flex=\"\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4 secondary-text\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"s16 mr-8\"></md-icon><span class=\"font-weight-500\">{{vm.widget13.date}}</span><md-icon md-font-icon=\"icon-arrow-right\" class=\"s16 ml-8\"></md-icon></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div><md-icon md-font-icon=\"{{vm.widget13.icon}}\" class=\"s96\"></md-icon></div><div class=\"pt-16\" layout=\"row\" layout-align=\"center center\"><div class=\"md-display-2\">{{vm.widget13.temperature}}&deg;</div><div class=\"pl-16\" layout=\"column\"><div class=\"h1 text-semibold\">{{vm.widget13.event}}</div><div class=\"h4 secondary-text\">{{vm.widget13.location}}</div></div></div><div class=\"pt-32\" layout=\"row\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"s16\"></md-icon><span class=\"pl-8\">22 km/h</span></div><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-compass\" class=\"s16\"></md-icon><span class=\"pl-8\">NW</span></div></div></div></ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg\" layout=\"column\" flex=\"\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div class=\"pt-16 pb-16 white-fg\"><span class=\"h1\">Next 5 days</span></div><div class=\"pl-8 pr-8\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start center\" ng-repeat=\"detail in vm.widget13.detail\"><div class=\"h4 pb-8 black-fg secondary-text\">{{detail.day}}</div><md-icon md-font-icon=\"{{detail.icon}}\" class=\"s36 white-fg\"></md-icon><div class=\"h3 pt-8 white-fg\">{{detail.temperature}}&deg;</div></div></div></ms-widget-back></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget14.title}}</div></div><md-tabs class=\"md-accent no-radius\" md-dynamic-height=\"\"><md-tab label=\"{{tab.label}}\" ng-repeat=\"tab in vm.widget14.tabs\"><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div flex=\"100\" flex-gt-md=\"50\" ng-repeat=\"group in tab.groups\"><div class=\"h2 m-16 pb-16 border-bottom\">{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span class=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear class=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div></md-tab></md-tabs></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 red-bg white-fg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget15.title}}</div><div layout=\"row\" layout-align=\"start center\"><div class=\"pr-8\"><md-icon md-font-icon=\"icon-alert\" class=\"s24 hint-text\"></md-icon></div><div class=\"h1 secondary-text\">{{vm.widget15.value}}%</div></div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"cpu-usage\"><chart-column ng-repeat=\"column in vm.widget15.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis><chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-legend show-legend=\"false\"><chart-size chart-height=\"120\"></chart-size></chart-legend></chart-column></c3chart></div></ms-widget-front></ms-widget><ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget16.title}}</div><div layout=\"row\" layout-align=\"start center\"><div class=\"h1 secondary-text\">{{vm.widget16.value}}</div><md-icon md-font-icon=\"icon-trending-up\" class=\"mh-8\"></md-icon></div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"stock\"><chart-column ng-repeat=\"column in vm.widget16.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis><chart-axis-x show=\"false\"></chart-axis-x><chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-legend show-legend=\"false\"><chart-size chart-height=\"120\"></chart-size></chart-legend></chart-column></c3chart></div></ms-widget-front></ms-widget><ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget17.title}}</div><div class=\"secondary-text\">{{vm.widget17.subtitle}}</div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"io-rate\"><chart-column ng-repeat=\"column in vm.widget17.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis><chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-size chart-height=\"120\"></chart-size></chart-column></c3chart></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 white-bg\"><div layout=\"row\" layout-align=\"space-between\"><div class=\"mr-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget18.title}}</div><div class=\"h1 secondary-text\">{{vm.widget18.value | number}}</div><div class=\"pt-8\" layout=\"row\" layout-align=\"start center\"><div>LW: {{vm.widget18.lastWeekValue | number}}</div><div class=\"text-boxed\">{{vm.widget18.lastWeekDiff}}</div></div></div><c3chart flex=\"\" bindto-id=\"weekly-visitors\"><chart-column ng-repeat=\"column in vm.widget18.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-legend show-legend=\"false\"><chart-bar width=\"10\"><chart-size chart-height=\"240\"></chart-size></chart-bar></chart-legend></chart-column></c3chart></div></ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 light-blue-bg white-fg\"><div layout=\"row\" layout-align=\"space-between\"><div class=\"mr-16\"><div class=\"h1 weight-500 pb-8\">{{vm.widget19.title}}</div><div class=\"h4 secondary-text weight-500 pb-8\">{{vm.widget19.subtitle}}</div><div layout=\"row\" layout-align=\"start center\"><div class=\"md-display-1 pr-8\">{{vm.widget19.value}}</div><md-icon md-font-icon=\"icon-trending-up\" class=\"s24\"></md-icon></div></div><c3chart flex=\"\" bindto-id=\"goog-nasdaq\"><chart-column ng-repeat=\"column in vm.widget19.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-legend show-legend=\"false\"><chart-bar width=\"10\"><chart-size chart-height=\"240\"></chart-size></chart-bar></chart-legend></chart-column></c3chart></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/pages/coming-soon/coming-soon.html","<div id=\"coming-soon\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"coming-soon-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"coming-soon-form\" class=\"md-whiteframe-8dp\"><div class=\"top\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"COMINGSOON.TITLE\">Hey! Thank you for checking out our app.</div><div class=\"subtitle\" translate=\"COMINGSOON.SUBTITLE\">It’s not quite ready yet, but we are working hard and it will be ready in approximately:</div><timer end-time=\"vm.endTime\" layout=\"row\" layout-wrap=\"\"><div flex-xs=\"50\"><div class=\"value\">{{days}}</div><div class=\"type\" translate=\"COMINGSOON.DAYS\">days</div></div><div flex-xs=\"50\"><div class=\"value\">{{hours}}</div><div class=\"type\" translate=\"COMINGSOON.HOURS\">hours</div></div><div flex-xs=\"50\"><div class=\"value\">{{minutes}}</div><div class=\"type\" translate=\"COMINGSOON.MINUTES\">minutes</div></div><div flex-xs=\"50\"><div class=\"value\">{{seconds}}</div><div class=\"type\" translate=\"COMINGSOON.SECONDS\">seconds</div></div></timer></div><form><div class=\"message\" translate=\"COMINGSOON.MESSAGE\">If you would like to be notified when the app is ready, you can subscribe to our e-mail list.</div><md-input-container flex=\"\" md-no-float=\"\"><input type=\"email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"COMINGSOON.EMAIL_ADRESS\"></md-input-container><md-button class=\"md-raised md-accent\" aria-label=\"SUBSCRIBE\" translate=\"COMINGSOON.SUBSCRIBE\" translate-attr-aria-label=\"COMINGSOON.SUBSCRIBE\">SUBSCRIBE</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/invoice/invoice.html","<div id=\"invoice\" class=\"page-layout blank\" layout=\"row\" ms-scroll=\"\"><div class=\"invoice-container\"><div class=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\"><span translate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.from.website}}</div></div></div><div layout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" layout-align=\"end center\"><div translate=\"INVOICE.CLIENT\">CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span translate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.client.website}}</div></div></div></div><table class=\"summary\"><tr class=\"code\"><td class=\"label\" translate=\"INVOICE.INVOICE\">INVOICE</td><td class=\"value\">{{vm.invoice.number}}</td></tr><tr><td class=\"label\" translate=\"INVOICE.INVOICE_DATE\">INVOICE DATE</td><td class=\"value\">{{vm.invoice.date}}</td></tr><tr><td class=\"label\" translate=\"INVOICE.DUE_DATE\">DUE DATE</td><td class=\"value\">{{vm.invoice.dueDate}}</td></tr><tr><td class=\"label\" translate=\"INVOICE.TOTAL_DUE\">TOTAL DUE</td><td class=\"value\">{{vm.invoice.total | currency}}</td></tr></table></div><div class=\"content\"><table class=\"simple invoice-table\"><thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" translate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th class=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">{{service.title}}</div><div class=\"detail\">{{service.detail}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">SUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" translate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">In condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros. Nulla laoreet ipsum quam, quis auctor velit sodales sit amet. Phasellus at felis iaculis, sodales lectus vitae, egestas mauris. Duis cursus, metus non dignissim consectetur, augue erat convallis massa, sit amet mollis lacus lorem eu purus. Praesent posuere ante quam. Curabitur ultricies magna diam, non consequat purus suscipit quis. Proin egestas nibh id massa dapibus, sed auctor velit ullamcorper. Integer id dolor nunc.</div></div></div></div></div></div>");
$templateCache.put("app/main/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"maintenance-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"MAINTENANCE.TITLE\">Closed for scheduled maintenance!</div><div class=\"subtitle\" translate=\"MAINTENANCE.SUBTITLE\">We\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img class=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"><div class=\"name\">Katherine Wilson</div></div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" aria-label=\"Follow\" translate=\"PROFILE.FOLLOW\" translate-attr-aria-label=\"PROFILE.FOLLOW\">Follow</md-button><md-button class=\"md-raised md-primary\" translate=\"PROFILE.SEND_MESSAGE\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">Send Message</md-button></div></div><div class=\"content\" flex=\"\"><md-tabs md-dynamic-height=\"\"><md-tab><md-tab-label><span translate=\"PROFILE.TIMELINE\">Timeline</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab\" ng-include=\"\'app/main/pages/profile/tabs/timeline/timeline.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" ng-include=\"\'app/main/pages/profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"PROFILE.PHOTOS_VIDEOS\">Photos & Videos</span></md-tab-label><md-tab-body><md-content class=\"photos-videos-tab\" ng-include=\"\'app/main/pages/profile/tabs/photos-videos/photos-videos.html\'\"></md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/search/search.html","<div id=\"search\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"search\" flex=\"\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.search\" type=\"text\" placeholder=\"Search..\" translate=\"\" translate-attr-placeholder=\"SEARCH.SEARCH\" flex=\"\"></div><md-menu class=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate=\"\" translate-attr-aria-label=\"SEARCH.SEARCH_SETTINGS\"><md-icon md-menu-origin=\"\" md-menu-align-target=\"\" md-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.dummyFunction()\"><p translate=\"SEARCH.SETTINGS_1\">Settings 1</p></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.dummyFunction()\"><p translate=\"SEARCH.SETTINGS_2\">Settings 2</p></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"content\" flex=\"\"><md-tabs md-dynamic-height=\"\"><md-tab label=\"Classic\"><md-content class=\"classic-tab\" ng-include=\"\'app/main/pages/search/tabs/classic/classic.html\'\"></md-content></md-tab><md-tab label=\"Emails\"><md-content class=\"emails-tab\" ng-include=\"\'app/main/pages/search/tabs/emails/emails.html\'\"></md-content></md-tab><md-tab label=\"Users\"><md-content class=\"users-tab\" ng-include=\"\'app/main/pages/search/tabs/users/users.html\'\"></md-content></md-tab><md-tab label=\"Contacts\"><md-content class=\"contacts-tab\" ng-include=\"\'app/main/pages/search/tabs/contacts/contacts.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-left.html","<div id=\"timeline\" class=\"timeline-left\" ms-timeline=\"\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item=\"\" layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-right.html","<div id=\"timeline\" class=\"timeline-right\" ms-timeline=\"\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item=\"\" layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline.html","<div id=\"timeline\" layout-column=\"\" flex=\"\" ms-timeline=\"\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item=\"\" layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div></div></div>");
$templateCache.put("app/main/ui/forms/forms.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Forms</div></div></div><div class=\"content\" layout=\"column\"><div class=\"md-title\">Form Wizard</div><div class=\"pb-16\">Form wizard is a combination of md-tabs and forms that we have created for you. You can have as many steps as you want.</div><div layout=\"row\"><ms-form-wizard flex=\"\"><md-tabs md-dynamic-height=\"\" md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Personal Information</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" placeholder=\"Firstname\" required=\"\"><div ng-messages=\"wizardStep1.firstname.$error\" ng-show=\"wizardStep1.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Lastname\" required=\"\"><div ng-messages=\"wizardStep1.lastname.$error\" ng-show=\"wizardStep1.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><input type=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"wizardStep1.email.$error\" ng-show=\"wizardStep1.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Email field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div></div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" flex=\"\"><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"password\" ng-model=\"vm.formWizard.password\" placeholder=\"Password\" required=\"\"><div ng-messages=\"wizardStep1.password.$error\" ng-show=\"wizardStep1.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.formWizard.passwordConfirm\" placeholder=\"Password (Confirm)\" required=\"\"><div ng-messages=\"wizardStep1.passwordConfirm.$error\" ng-show=\"wizardStep1.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Password (Confirm) field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Address</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form=\"\" novalidate=\"\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label>City</label> <input type=\"text\" name=\"city\" ng-model=\"vm.formWizard.city\"></md-input-container><md-input-container flex=\"\"><label>State</label><md-select ng-model=\"vm.formWizard.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Postal Code</label> <input name=\"postalcode\" ng-model=\"vm.formWizard.postalCode\" placeholder=\"12345\" required=\"\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"wizardStep2.postalcode.$error\" ng-show=\"wizardStep2.postalcode.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>You must supply a postal code.</span></div><div ng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><label>Address</label> <textarea ng-model=\"vm.formWizard.address\" columns=\"1\" md-maxlength=\"150\" rows=\"5\" required=\"\"></textarea><div ng-messages=\"wizardStep2.address.$error\" ng-show=\"wizardStep2.address.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>Address field is required.</span></div><div ng-message=\"md-maxlength\"><span>Address can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i></span> <span class=\"ms-form-wizard-step-text\">Payment Method</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form=\"\" novalidate=\"\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" ng-model=\"vm.formWizard.cardholder\" placeholder=\"Card Holder\" required=\"\"><div ng-messages=\"wizardStep3.cardholder.$error\" ng-show=\"wizardStep3.cardholder.$dirty\" role=\"alert\"><div ng-message=\"required\"><span>Card holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" ng-model=\"vm.formWizard.cardnumber\" placeholder=\"Card Number\" required=\"\"><div ng-messages=\"wizardStep3.cardnumber.$error\" ng-show=\"wizardStep3.cardnumber.$dirty\" role=\"alert\"><div ng-message=\"required\"><span>Card number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"CC2\" ng-model=\"vm.formWizard.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required=\"\"><div ng-messages=\"wizardStep3.cc2.$error\" ng-show=\"wizardStep3.cc2.$dirty\" role=\"alert\" multipl=\"\"><div ng-message=\"required\"><span>CC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"expirationDate\" ng-model=\"vm.formWizard.expirationDate\" placeholder=\"Expiration Date\" required=\"\"><div ng-messages=\"wizardStep3.expirationDate.$error\" ng-show=\"wizardStep3.expirationDate.$dirty\" role=\"alert\"><div ng-message=\"required\"><span>Expiration date field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex=\"\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Send</md-button></div></ms-form-wizard></div><div class=\"md-title mt-32\">Basic form with validation</div><div class=\"pb-16\">With this form example, Submit button will only be activated if all the required fields are filled and if there is no error on the form.</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate=\"\"><div class=\"form-title\">Optional form title</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.basicForm.firstname\" placeholder=\"Firstname\" required=\"\"><div ng-messages=\"basicForm.firstname.$error\" ng-show=\"basicForm.firstname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex=\"\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.basicForm.lastname\" placeholder=\"Lastname\" required=\"\"><div ng-messages=\"basicForm.lastname.$error\" ng-show=\"basicForm.lastname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"\"><label>City</label> <input type=\"text\" name=\"city\" ng-model=\"vm.basicForm.city\"></md-input-container><md-input-container flex=\"\"><label>State</label><md-select ng-model=\"vm.basicForm.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex=\"\"><label>Postal Code</label> <input name=\"postalcode\" ng-model=\"vm.basicForm.postalCode\" placeholder=\"12345\" required=\"\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"basicForm.postalcode.$error\" ng-show=\"basicForm.postalcode.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span>You must supply a postal code.</span></div><div ng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><label>Biography</label> <textarea ng-model=\"vm.basicForm.biography\" columns=\"1\" md-maxlength=\"150\" rows=\"5\"></textarea></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></form></div><div class=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" flex=\"40\"><div class=\"form-title\">Form ng-model data</div><div class=\"json-data-wrapper\"><pre>{{vm.basicForm | json}}</pre></div></div></div></div></div>");
$templateCache.put("app/main/ui/icons/icons.html","<div id=\"icons\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Icons</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"https://materialdesignicons.com/\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\" layout=\"column\"><div id=\"icons-list\" class=\"card md-whiteframe-1dp\" layout=\"row\" layout-wrap=\"\"><div class=\"item\" ng-repeat=\"icon in ::vm.icons track by icon.properties.id\" layout-align=\"start center\"><i class=\"icon icon-{{::icon.properties.name}} s40\"></i><div class=\"name secondary-text text-center\">icon-{{::icon.properties.name}}</div></div></div></div></div>");
$templateCache.put("app/main/ui/material-colors/material-colors.html","<div id=\"material-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Material Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><md-tabs class=\"color-tabs\" md-dynamic-height=\"\" md-swipe-content=\"\"><md-tab ng-repeat=\"(paletteName, palette) in vm.palettes\" md-on-select=\"vm.selected = paletteName; vm.selectedPalette = palette\"><md-tab-label><span class=\"text-capitalize\">{{paletteName}}</span></md-tab-label></md-tab></md-tabs><md-content class=\"color-tab\"><div class=\"h3 pb-16\">Fuse has classes for every single color from <a href=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" target=\"_blank\">Material Design Color Palette</a> for your convenient. You can use them with pretty much every element except Angular Material directives.</div><div class=\"color-header colored-bg\" ng-class=\"\'md-\'+vm.selected+\'-bg\'\" layout=\"row\" layout-align=\"start start\" layout-wrap=\"\" layout-padding=\"\"><div flex=\"100\"><h3 class=\"text-capitalize\">{{vm.selected}}</h3></div><div layout=\"row\" layout-align=\"space-between center\" flex=\"100\"><div>500</div><div>rgb({{vm.selectedPalette[\'500\'].value[0]}},{{vm.selectedPalette[\'500\'].value[1]}},{{vm.selectedPalette[\'500\'].value[2]}})</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"colored-bg\" ng-repeat=\"(hue, hueValue) in vm.selectedPalette\" flex=\"100\" layout=\"row\" layout-sm=\"column\" layout-padding=\"\" ng-class=\"vm.selected+\'-\'+hue+\'-bg\'\"><div flex=\"\">{{hue}}</div><div class=\"colored-bg\" ng-class=\"\'md-\'+vm.selected+\'-\'+hue+\'-bg\'\" flex=\"\">.{{\'md-\'+vm.selected+\'-\'+hue+\'-bg\'}}</div><div flex=\"\">.{{vm.selected+\'-\'+hue+\'-bg\'}}</div><div class=\"fg-box white-bg md-whiteframe-2dp\" ng-class=\"vm.selected+\'-\'+hue+\'-fg\'\">.{{vm.selected+\'-\'+hue+\'-fg\'}}</div></div></div></md-content></div></div>");
$templateCache.put("app/main/ui/theme-colors/theme-colors.html","<div id=\"theme-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Theme Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-warn reference-button\" ng-click=\"vm.createTheme($event);\"><md-icon md-font-icon=\"icon-palette\"></md-icon><span>Create Your Own Theme!</span></md-button></div></div><div class=\"content\"><md-tabs class=\"color-tabs\" md-dynamic-height=\"\" md-swipe-content=\"\" md-stretch-tabs=\"always\"><md-tab label=\"Primary Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/primary/primary.html\'\"></md-content></md-tab><md-tab label=\"Accent Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/accent/accent.html\'\"></md-content></md-tab><md-tab label=\"Warn Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/warn/warn.html\'\"></md-content></md-tab><md-tab label=\"Background Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/background/background.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/typography/typography.html","<div id=\"typography\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Typography</div></div><div class=\"content\"><div class=\"md-title\">Material design headings</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">112px</div><span class=\"md-display-4\">Display 4</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-display-4\">Display 4</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">56px</div><span class=\"md-display-3\">Display 3</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-display-3\">Display 3</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">45px</div><span class=\"md-display-2\">Display 2</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-display-2\">Display 2</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">34px</div><span class=\"md-display-1\">Display 1</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-display-1\">Display 1</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">24px</div><span class=\"md-headline\">Headline</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-headline\">Headline</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">20px</div><span class=\"md-title\">Title</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-title\">Title</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">16px</div><span class=\"md-subhead\">Subhead</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"md-subhead\">Subhead</span></hljs></div></div><div class=\"md-title\">Headings</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">24px</div><h1>Heading 1</h1></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h1>Heading 1</h1><div class=\"h1\">Heading 1</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">20px</div><h2>Heading 2</h2></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h2>Heading 2</h2><div class=\"h2\">Heading 2</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">16px</div><h3>Heading 3</h3></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h3>Heading 3</h3><div class=\"h3\">Heading 3</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">14px</div><h4>Heading 4</h4></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h4>Heading 4</h4><div class=\"h4\">Heading 4</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">13px</div><h5>Heading 5</h5></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h5>Heading 5</h5><div class=\"h5\">Heading 5</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption secondary-text\">12px</div><h6>Heading 6</h6></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\"><h6>Heading 6</h6><div class=\"h6\">Heading 6</div></hljs></div></div><div class=\"md-title\">Inline text elements</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is a<mark>marked</mark>text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is a<mark>marked</mark>text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><del>This is a deleted text.</del></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><del>This is a deleted text.</del></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><s>This is a strike-through text.</s></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><s>This is a strike-through text.</s></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><u>This is an underlined text.</u></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><u>This is an underlined text.</u></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><small>This is a small text.</small></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><small>This is a small text.</small></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><strong>This is a strong text.</strong></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scrollx=\"\"><strong>This is a strong text.</strong></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><em>This is an italic text.</em></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><em>This is an italic text.</em></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is a <span class=\"text-super\">super</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is a <span class=\"text-super\">super</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is a <span class=\"text-sub\">sub</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is a <span class=\"text-sub\">sub</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is a <span class=\"text-capitalize\">capitalized</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is a <span class=\"text-capitalized\">capitalized</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is an <span class=\"text-uppercase\">uppercase</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is an <span class=\"text-uppercase\">uppercase</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span>This is a <span class=\"text-lowercase\">LOWERCASE</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\">This is a <span class=\"text-lowercase\">LOWERCASE</span> text.</hljs></div></div><div class=\"md-title\">Abbrevations</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><abbr title=\"Angular JS\">Angular JS</abbr></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><abbr title=\"Angular JS\">Angular JS</abbr></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span><abbr title=\"Cascaded Style Sheet\">CSS</abbr></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><abbr title=\"Cascaded Style Sheet\">CSS</abbr></hljs></div></div><div class=\"md-title\">Blockquotes</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer></blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer></blockquote></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><blockquote class=\"reverse\"><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer></blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><blockquote class=\"reverse\"><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer></blockquote></hljs></div></div><div class=\"md-title\">Lists</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><ul><li>Unordered list item</li><li>Unordered list item</li><li>Unordered list item</li><li>Unordered list item</li></ul></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><ul><li>Unordered list item</li><li>Unordered list item</li><li>Unordered list item</li><li>Unordered list item</li></ul></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><ol><li>Ordered list item</li><li>Ordered list item</li><li>Ordered list item</li><li>Ordered list item</li></ol></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><ol><li>Ordered list item</li><li>Ordered list item</li><li>Ordered list item</li><li>Ordered list item</li></ol></hljs></div></div><div class=\"md-title\">Definition lists</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><dl><dt>Definition term</dt><dd>This is the definition description</dd><dt>Another definition term</dt><dd>This is also another definition description</dd></dl></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><dl><dt>Definition term</dt><dd>This is the definition description</dd><dt>Another definition term</dt><dd>This is also another definition description</dd></dl></hljs></div></div><div class=\"md-title\">Other helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"text-left\">Left aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"text-left\">Left aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"text-center\">Center aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"text-center\">Center aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"text-right\">Right aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"text-right\">Right aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><p><span class=\"text-boxed\">Boxed text</span></p></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><p><span class=\"text-boxed\">Boxed text</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><p><span class=\"text-strike\">Strike-through text</span></p></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><p><span class=\"text-strike\">Strike-through text</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"text-italic\">Italic text</div><div class=\"text-semibold\">Semi-bold text</div><div class=\"text-bold\">Bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"text-italic\">Italic text</div><div class=\"text-semibold\">Semi-bold text</div><div class=\"text-bold\">Bold text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><span class=\"text-truncate\">This is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa fermentum dictum. Aenean mollis molestie felis, ut interdum ex vehicula a.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><span class=\"text-truncate\">This is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa fermentum dictum. Aenean mollis molestie felis, ut interdum ex vehicula a.</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"\"><div class=\"md-caption mb-16\">Font weight helpers from 100 to 900</div><span class=\"font-weight-100\">font-weight: 100</span> <span>...</span> <span class=\"font-weight-900\">font-weight: 900</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"\" ms-scroll=\"\"><span class=\"font-weight-100\">font-weight: 100</span> ... <span class=\"font-weight-900\">font-weight: 900</span></hljs></div></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">CB</span> <span class=\"logo-text\">ChartBid</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide=\"\" show-gt-sm=\"\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"></md-subheader><md-list-item class=\"friend md-3-line\"><img ng-src=\"assets/images/avatars/profile.jpg\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div class=\"md-list-item-text\"><h3 class=\"message\">Michel Smits</h3><h3 class=\"message\">Create Folder</h3><p class=\"time\">10/01/2016 12:30</p></div></md-list-item><md-list-item class=\"friend md-3-line\"><img ng-src=\"assets/images/avatars/profile.jpg\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"md-list-item-text\"><h3 class=\"message\">Alain Lavigne</h3><h3 class=\"message\">Upload document</h3><p class=\"time\">10/01/2016 16:30</p></div></md-list-item><md-list-item class=\"friend md-3-line\"><img ng-src=\"assets/images/avatars/profile.jpg\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"md-list-item-text\"><h3 class=\"message\">Bidder 1</h3><h3 class=\"message\">Download document</h3><p class=\"time\">11/01/2016 09:30</p></div></md-list-item><md-list-item class=\"friend md-3-line\"><img ng-src=\"assets/images/avatars/profile.jpg\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"md-list-item-text\"><h3 class=\"message\">Tim Anderson</h3><h3 class=\"message\">Create question</h3><p class=\"time\">12/01/2016 10:00</p></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader><md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item class=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" ng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\"><h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div class=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4><span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"Call\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon md-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></div></md-toolbar><md-content flex=\"\" layout-paddings=\"\" ms-scroll=\"\" id=\"chat-dialog\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img ng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex=\"\"><div class=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content><form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea ng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex=\"\" ng-model=\"vm.replyMessage\" placeholder=\"Type and hit enter to send message\" translate=\"\" translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\"></textarea><md-button class=\"md-fab md-icon-button\" type=\"submit\" aria-label=\"Send message\" translate=\"\" translate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"lang in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar></ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin=\"\" md-menu-align-target=\"\"><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"lang in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate=\"\" translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div id=\"zona-izquierda\" layout=\"row\" layout-align=\"start center\" flex=\"\"><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm=\"\" aria-label=\"Toggle navigation\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular></div><div id=\"zona-derecha\" layout=\"row\" layout-align=\"start left\"><div id=\"itb-counter-container\"><div ng-show=\"vm.status.counterVisible\" layout=\"row\" layout-align=\"start left\"><div id=\"itb-area\">{{ vm.status.charterer }} - Ref {{ vm.status.chartererReference }}<md-tooltip md-direction=\"bottom\">{{vm.status.itbName}} - {{vm.status.itbReference}}</md-tooltip></div><timer ng-if=\"vm.countdown>0\" countdown=\"vm.countdown\" interval=\"1000\" finish-callback=\"vm.counterfinished()\" layout=\"row\" layout-wrap=\"\"><div flex-xs=\"50\"><div class=\"value\">{{days}}</div><div class=\"type\" translate=\"TOOLBAR.COUNTER.DAYS\">Days</div></div><div flex-xs=\"50\"><div class=\"value\">{{hours}}</div><div class=\"type\" translate=\"TOOLBAR.COUNTER.HOURS\">Hours</div></div><div flex-xs=\"50\"><div class=\"value\">{{minutes}}</div><div class=\"type\" translate=\"TOOLBAR.COUNTER.MINUTES\">Minutes</div></div><div flex-xs=\"50\"><div class=\"value\">{{seconds}}</div><div class=\"type\" translate=\"TOOLBAR.COUNTER.SECONDS\">Seconds</div></div></timer><timer ng-if=\"vm.countdown<=0\" countdown=\"vm.countdown\" interval=\"1000\" layout=\"row\" layout-wrap=\"\"><div flex-xs=\"50\"><div class=\"value\">0</div><div class=\"type\" translate=\"TOOLBAR.COUNTER.DAYS\">Days</div></div><div flex-xs=\"50\"><div class=\"value\">0</div><div class=\"type\" translate=\"TOOLBAR.COUNTER.HOURS\">Hours</div></div><div flex-xs=\"50\"><div class=\"value\">0</div><div class=\"type\" translate=\"TOOLBAR.COUNTER.MINUTES\">Minutes</div></div><div flex-xs=\"50\"><div class=\"value\">0</div><div class=\"type\" translate=\"TOOLBAR.COUNTER.SECONDS\">Seconds</div></div></timer><closingdate><div flex-xs=\"50\"><div class=\"value\">{{vm.status.itbClosingDate}} {{vm.status.itbClosingTime}}</div><div class=\"type\" translate=\"\">closing date (GMT)</div></div></closingdate></div></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate=\"\" translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target=\"\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon=\"\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs=\"\">{{vm.loginName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs=\"\"></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button ng-click=\"vm.myProfile()\">My Profile</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/workflow/layouts/vertical-navigation/workflow.html","<div layout=\"column\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"!vm.workflow.selectItbStatus\" class=\"{{vm.workflow.selectItbStatusColor}}\" aria-label=\"Select ITB\" ng-click=\"vm.redirectToSelectItb()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"\">Select ITB</div><md-icon ng-show=\"vm.workflow.selectItbStatus\" md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button><md-button ng-disabled=\"!vm.workflow.receiptItbStatus\" class=\"{{vm.workflow.receiptItbStatusColor}}\" aria-label=\"Receipt of ITB\" ng-click=\"vm.redirectToReceiptItb()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"\">Receipt of ITB</div><md-icon ng-show=\"vm.workflow.receiptItbStatus\" md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button><md-button ng-disabled=\"!vm.workflow.submissionBidStatus\" class=\"{{vm.workflow.submissionBidStatusColor}}\" aria-label=\"Submission of Bid\" ng-click=\"vm.redirectToSubmissionBid()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"\">Submission of Bid</div><md-icon ng-show=\"vm.workflow.submissionBidStatus\" md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button><md-button ng-disabled=\"!vm.workflow.completionBcfStatus\" class=\"{{vm.workflow.completionBcfStatusColor}}\" aria-label=\"Attachments\" ng-click=\"vm.redirectToBcfDocuments()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"\">Attachments</div><md-icon ng-show=\"vm.workflow.completionBcfStatus\" md-font-icon=\"icon-paperclip\" class=\"s20 icon-white\"></md-icon></div></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm=\"\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul class=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-horizontal-nested.html\"><div ms-navigation-horizontal-item layout=\"row\"> <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\" ng-class=\"{\'active md-accent-bg\': vm.isActive}\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </div> <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-class=\"{\'active md-accent-bg\': vm.isActive}\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren\"> <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\" ng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\"><div ms-navigation-item layout=\"row\"> <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </div> <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && node.title\"> <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i> <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span> <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span> <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i> </a> </div> <ul ng-if=\"vm.hasChildren\"> <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li> </ul></script>");
$templateCache.put("app/main/apps/dashboards_DESHABILITADO/analytics/dashboard-analytics.html","<div id=\"dashboard-analytics\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><div class=\"text-boxed green-600-bg white-fg\">{{vm.widget1.onlineUsers}} online users</div></div><div class=\"pb-32 border-bottom\"><nvd3 class=\"h-400 remove-x-lines remove-opacity\" options=\"vm.widget1.bigChart.options\" data=\"vm.widget1.bigChart.data\"></nvd3></div><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div class=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div layout=\"column\" flex=\"\"><div class=\"h3 secondary-text pb-8\">{{vm.widget1.sessions.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.sessions.value}}</div><div><nvd3 class=\"h-40\" options=\"vm.widget1.sessions.options\" data=\"vm.widget1.sessions.data\"></nvd3></div></div></div><div class=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div layout=\"column\" flex=\"\"><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pageviews.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pageviews.value}}</div><div><nvd3 class=\"h-40\" options=\"vm.widget1.pageviews.options\" data=\"vm.widget1.pageviews.data\"></nvd3></div></div></div><div class=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div layout=\"column\" flex=\"\"><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pagesSessions.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pagesSessions.value}}</div><div><nvd3 class=\"h-40\" options=\"vm.widget1.pagesSessions.options\" data=\"vm.widget1.pagesSessions.data\"></nvd3></div></div></div><div class=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div layout=\"column\" flex=\"\"><div class=\"h3 secondary-text pb-8\">{{vm.widget1.avgSessionDuration.title}}</div><div class=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.avgSessionDuration.value}}</div><div><nvd3 class=\"h-40\" options=\"vm.widget1.avgSessionDuration.options\" data=\"vm.widget1.avgSessionDuration.data\"></nvd3></div></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"65\"><ms-widget-front class=\"white-bg\"><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><ui-gmap-google-map center=\"vm.widget2.map.center\" zoom=\"vm.widget2.map.zoom\" options=\"vm.widget2.map.options\"><ui-gmap-markers models=\"vm.widget2.map.markers\" coords=\"\'coords\'\"><ui-gmap-windows show=\"show\"><div ng-non-bindable=\"\">{{sessions}}</div></ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"35\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget3.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget3.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div class=\"ph-16 pv-20 border-bottom\" ng-repeat=\"page in vm.widget3.pages[vm.widget3.currentRange]\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" flex=\"\"><span class=\"h4 pb-10\">{{page.path}}</span><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{page.value}}\"></md-progress-linear></div><div class=\"pl-32 h3 font-weight-500 secondary-text\">{{page.value}}%</div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget4.title}}</div></div><md-tabs class=\"md-accent no-radius\" md-dynamic-height=\"\"><md-tab label=\"{{tab.label}}\" ng-repeat=\"tab in vm.widget4.tabs\"><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" ng-repeat=\"group in tab.groups\"><div class=\"h2 m-16 pb-16 border-bottom\">{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span class=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear class=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div></md-tab></md-tabs></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/apps/dashboards_DESHABILITADO/project/dashboard-project.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" layout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Welcome back, John!</span></div><div class=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div><div layout=\"row\"><div class=\"selected-project\">{{vm.selectedProject.name}}</div><md-menu id=\"projects-menu\" md-offset=\"0 48\"><md-button class=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" aria-label=\"Select project\" md-menu-origin=\"\" md-menu-align-target=\"\"><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"project in vm.projects\"><md-button ng-click=\"vm.selectProject(project)\" aria-label=\"{{project.name}}\"><span ng-class=\"{\'secondary-text\': vm.selectedProject == project}\">{{project.name}}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content\"><md-tabs md-dynamic-height=\"\"><md-tab label=\"Home\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.widget1.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">{{vm.widget2.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{vm.widget4.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:</span> <span class=\"h4 ml-8\">{{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\" layout-wrap=\"\"><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div class=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" ng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" ng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\"><nvd3 class=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" data=\"vm.widget5.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap=\"\"><div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\" ng-repeat=\"(name, widget) in vm.widget5.supporting.widgets\"><div class=\"h4 secondary-text\">{{widget.data.label}}</div><div class=\"md-display-1\">{{widget.data.count[vm.widget5.currentRange]}}</div><nvd3 class=\"h-50\" config=\"vm.widget5.supporting.chart.config\" options=\"vm.widget5.supporting.chart.options\" data=\"widget.chart.data\"></nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget6.currentRange\" ng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div class=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" data=\"vm.widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" layout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerRight.title}}</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"event in vm.widget7.schedule[vm.widget7.currentRange]\"><div><div class=\"h3\">{{event.title}}</div><div><span class=\"secondary-text\">{{event.time}}</span> <span ng-if=\"event.location\">, {{event.location}}</span></div></div><md-button class=\"md-icon-button\" aria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Budget Summary\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget9.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget9.currentRange\" ng-change=\"vm.widget9.changeRange(vm.widget9.currentRange)\" aria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.weeklySpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.weeklySpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex=\"\"><nvd3 class=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.weeklySpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.totalSpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.totalSpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex=\"\"><nvd3 class=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.totalSpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.remaining.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.remaining.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex=\"\"><nvd3 class=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.remaining.chartData\"></nvd3></div></div><div class=\"pv-24 mh-24 border-top\"><div class=\"h4 secondary-text\">{{vm.widget9.totalBudget.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>{{vm.widget9.totalBudget.count}}</span></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"simple-table-container\" ms-responsive-table=\"\"><div class=\"table-title\">{{vm.widget10.title}}</div><table class=\"simple\"><thead><tr><th ng-repeat=\"column in vm.widget10.table.columns\">{{column.title}}</th></tr></thead><tbody><tr ng-repeat=\"row in vm.widget10.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">{{cell.value}}</span> <i ng-if=\"cell.icon\" class=\"icon {{cell.icon}}\"></i></td></tr></tbody></table></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Team Members\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 mb-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">{{vm.widget11.title}}</div><div class=\"text-boxed red-bg white-fg m-0\">{{vm.widget11.table.rows.length}} members</div></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget11.dtOptions\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in ::vm.widget11.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ::vm.widget11.table.rows\"><td ng-repeat=\"cell in row\"><img class=\"avatar\" ng-if=\"$index === 0\" ng-src=\"assets/images/avatars/{{cell}}\"> <span ng-if=\"$index != 0\">{{cell}}</span></td></tr></tbody></table></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div class=\"widget-group\"><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin=\"\" md-menu-align-target=\"\" aria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\"><div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.month}}</span></div><div class=\"font-size-72 line-height-88 secondary-text font-weight-400\">{{vm.nowWidget.now.day}}</div><div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front></ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h4\"><md-icon md-font-icon=\"icon-map-marker\" class=\"icon mr-8\"></md-icon>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin=\"\" md-menu-align-target=\"\" aria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\"><md-icon md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\"></md-icon><span class=\"md-display-2 font-weight-300 secondary-text\">{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}}</span> <span class=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span class=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div class=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}}</span> <span class=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\"><div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\"></md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span class=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div></md-sidenav></div>");
$templateCache.put("app/main/apps/dashboards_DESHABILITADO/server/dashboard-server.html","<div id=\"dashboard-server\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class=\"h-320\" options=\"vm.widget1.chart.options\" data=\"vm.widget1.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-harddisk\"></md-icon><div class=\"h3\">{{vm.widget2.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-24\" layout=\"row\" layout-align=\"start center\"><div class=\"h2\">{{vm.widget2.value.used}}</div><div class=\"h2 secondary-text pl-8\">/ {{vm.widget2.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget2.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back class=\"p-16 pr-32 pink-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 blue-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-server-network\"></md-icon><div class=\"h3\">{{vm.widget3.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-24\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">{{vm.widget3.value.used}}</div><div class=\"h2 pl-8 secondary-text\">/ {{vm.widget3.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget3.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back class=\"p-16 pr-32 blue-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-clock-fast\"></md-icon><div class=\"h3\">{{vm.widget4.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-8 h1\">{{vm.widget4.value}}</div><div class=\"chart-fill-16\"><nvd3 class=\"h-50 remove-opacity remove-line-stroke\" config=\"vm.widget4.chart.config\" options=\"vm.widget4.chart.options\" data=\"vm.widget4.chart.data\"></nvd3></div></ms-widget-front><ms-widget-back class=\"p-16 pr-32 teal-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-scale\"></md-icon><div class=\"h3\">{{vm.widget5.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex=\"\"><div class=\"h1 pb-8\" layout=\"row\" layout-align=\"start center\"><span>{{vm.widget5.value}}</span><md-icon md-font-icon=\"icon-trending-down\" class=\"ml-16\"></md-icon></div><div class=\"secondary-text\">{{vm.widget5.footnote}}</div></div></ms-widget-front><ms-widget-back class=\"p-16 pr-32 indigo-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget5.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class=\"h-140 remove-x-lines remove-opacity\" config=\"vm.widget6.chart.config\" options=\"vm.widget6.chart.options\" data=\"vm.widget6.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap=\"\"><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"60\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget7.title}}</span> <span class=\"ml-16 text-boxed pink-bg white-fg\">{{vm.widget7.table.rows.length}} processes</span></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget7.dtOptions\"><thead><tr><th class=\"secondary-text\" ng-repeat=\"column in ::vm.widget7.table.columns\"><div class=\"table-header\"><span class=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr ng-repeat=\"row in ::vm.widget7.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">{{cell.value}}</span></td></tr></tbody></table></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" flex-gt-md=\"40\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget8.title}}</span> <span class=\"ml-16 text-boxed blue-bg white-fg\">Showing last {{vm.widget8.activities.length}} activity</span></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"ph-16 pv-15 border-bottom\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"activity in vm.widget8.activities\"><div><i class=\"icon pr-16 mr-16 border-right\" ng-class=\"{\'icon-arrow-down red-fg\':activity.type === \'Input\', \'icon-arrow-up green-fg\':activity.type === \'Output\'}\"></i></div><div class=\"h4 text-bold\" flex=\"\">{{activity.process}}</div><div class=\"h4 font-weight-500 secondary-text\">{{activity.value}}</div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/administrator/administrator.html","<div id=\"administrator\" layout=\"column\" class=\"page-layout simple right-sidenav\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/management/administrator/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/management/administrator/views/detail/detail-view-administrator.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/bidder/bidder.html","<div id=\"bidder\" layout=\"column\" class=\"page-layout simple right-sidenav\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/management/bidder/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/management/bidder/views/detail/detail-view-bidder.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/charterer/charterer.html","<div id=\"charterer\" layout=\"column\" class=\"page-layout simple right-sidenav\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/management/charterer/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/management/charterer/views/detail/detail-view-charterer.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/itb/itb.html","<div id=\"itb\" layout=\"column\" class=\"page-layout simple right-sidenav\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/management/itb/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/management/itb/views/detail/detail-view-itb.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/traceability/traceability.html","<div id=\"traceability\" layout=\"column\" class=\"page-layout simple right-sidenav\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/management/traceability/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/management/traceability/views/detail/detail-view-traceability.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/select-itb/select-itb.html","<div id=\"select-itb\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/workflow-bidder/select-itb/views/list/list-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/receipt-itb/receipt-itb.html","<div id=\"receipt-itb\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/workflow-bidder/receipt-itb/views/list/list-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/components/charts/c3/c3.html","<div id=\"c3\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div class=\"title\">C3.js</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"http://jettro.github.io/c3-angular-directive/\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div class=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"line-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"line\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"line\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Line Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"line-area-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"area\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"area\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Spline Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"spline-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"spline\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"spline\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Spline Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"spline-area-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"area-spline\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"area-spline\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Step Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"step-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"step\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"step\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Step Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"step-area-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"area-step\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"area-step\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></chart-column></chart-column></c3chart></div><div class=\"md-title\">Stacked Bar Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"stacked-bar-plot1-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"bar\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"bar\"><chart-group group-values=\"data 1,data 2\"></chart-group></chart-column></chart-column></c3chart></div><div class=\"md-title\">Scatter Plot Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"scatter-plot2-chart\"><chart-column column-id=\"Data 1 x\" column-values=\"3.2, 3.2, 3.1, 2.3, 2.8, 2.8, 3.3, 2.4, 2.9, 2.7, 2.0, 3.0, 2.2, 2.9, 2.9, 3.1, 3.0, 2.7, 2.2, 2.5, 3.2, 2.8, 2.5, 2.8, 2.9, 3.0, 2.8, 3.0, 2.9, 2.6, 2.4, 2.4, 2.7, 2.7, 3.0, 3.4, 3.1, 2.3, 3.0, 2.5, 2.6, 3.0, 2.6, 2.3, 2.7, 3.0, 2.9, 2.9, 2.5, 2.8\"><chart-column column-id=\"Data 2 x\" column-values=\"3.3, 2.7, 3.0, 2.9, 3.0, 3.0, 2.5, 2.9, 2.5, 3.6, 3.2, 2.7, 3.0, 2.5, 2.8, 3.2, 3.0, 3.8, 2.6, 2.2, 3.2, 2.8, 2.8, 2.7, 3.3, 3.2, 2.8, 3.0, 2.8, 3.0, 2.8, 3.8, 2.8, 2.8, 2.6, 3.0, 3.4, 3.1, 3.0, 3.1, 3.1, 3.1, 2.7, 3.2, 3.3, 3.0, 2.5, 3.0, 3.4, 3.0\"><chart-column column-id=\"Data 1\" column-values=\"1.4, 1.5, 1.5, 1.3, 1.5, 1.3, 1.6, 1.0, 1.3, 1.4, 1.0, 1.5, 1.0, 1.4, 1.3, 1.4, 1.5, 1.0, 1.5, 1.1, 1.8, 1.3, 1.5, 1.2, 1.3, 1.4, 1.4, 1.7, 1.5, 1.0, 1.1, 1.0, 1.2, 1.6, 1.5, 1.6, 1.5, 1.3, 1.3, 1.3, 1.2, 1.4, 1.2, 1.0, 1.3, 1.2, 1.3, 1.3, 1.1, 1.3\" column-type=\"scatter\"><chart-column column-id=\"Data 2\" column-values=\"2.5, 1.9, 2.1, 1.8, 2.2, 2.1, 1.7, 1.8, 1.8, 2.5, 2.0, 1.9, 2.1, 2.0, 2.4, 2.3, 1.8, 2.2, 2.3, 1.5, 2.3, 2.0, 2.0, 1.8, 2.1, 1.8, 1.8, 1.8, 2.1, 1.6, 1.9, 2.0, 2.2, 1.5, 1.4, 2.3, 2.4, 1.8, 1.8, 2.1, 2.4, 2.3, 1.9, 2.3, 2.5, 2.3, 1.9, 2.0, 2.3, 1.8\" column-type=\"scatter\"><chart-axes values-xs=\"Data 1:Data 1 x,Data 2:Data 2 x\"></chart-axes></chart-column></chart-column></chart-column></chart-column></c3chart></div><div class=\"md-title\">Pie Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"pie-plot1-chart\"><chart-column column-id=\"Data 1\" column-values=\"70\" column-type=\"pie\"><chart-column column-id=\"Data 2\" column-values=\"35\" column-type=\"pie\"><chart-column column-id=\"Data 3\" column-values=\"60\" column-type=\"pie\"><chart-pie expand=\"true\"></chart-pie></chart-column></chart-column></chart-column></c3chart></div><div class=\"md-title\">Donut Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"donut-plot1-chart\"><chart-column column-id=\"Data 1\" column-values=\"70\" column-type=\"donut\"><chart-column column-id=\"Data 2\" column-values=\"35\" column-type=\"donut\"><chart-column column-id=\"Data 3\" column-values=\"60\" column-type=\"donut\"><chart-donut title=\"Donut\" width=\"60\"></chart-donut></chart-column></chart-column></chart-column></c3chart></div><div class=\"md-title\">Gauge Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"gauge-plot1-chart\"><chart-column column-id=\"Data 1\" column-values=\"70\" column-type=\"gauge\"><chart-gauge min=\"50\" max=\"75\" units=\"hours\" width=\"39\"></chart-gauge></chart-column></c3chart></div></div></div>");
$templateCache.put("app/main/components/charts/chart-js/chart-js.html","<div id=\"chartJs\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div class=\"title\">Chart.js</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"https://github.com/jtblin/angular-chart.js\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div class=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"vm.lineChart.data\" chart-labels=\"vm.lineChart.labels\" chart-legend=\"true\" chart-series=\"vm.lineChart.series\"></canvas></div><div class=\"md-title\">Bar Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"vm.barChart.data\" chart-labels=\"vm.barChart.labels\"></canvas></div><div class=\"md-title\">Doughnut Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"vm.doughnutChart.data\" chart-labels=\"vm.doughnutChart.labels\"></canvas></div><div class=\"md-title\">Radar Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"radar\" class=\"chart chart-radar\" chart-data=\"vm.radarChart.data\" chart-labels=\"vm.radarChart.labels\"></canvas></div><div class=\"md-title\">Pie Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"vm.pieChart.data\" chart-labels=\"vm.pieChart.labels\"></canvas></div><div class=\"md-title\">Polar Area Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"polar-area\" class=\"chart chart-polar-area\" chart-data=\"vm.polarChart.data\" chart-labels=\"vm.polarChart.labels\"></canvas></div></div></div>");
$templateCache.put("app/main/components/charts/chartist/chartist.html","<div id=\"chartist\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div class=\"title\">Chartist</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"https://github.com/paradox41/angular-chartist.js\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div class=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.lineChart.data\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.lineChart.options\"></chartist></div><div class=\"md-title\">Line Area Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.lineAreaChart.data\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.lineAreaChart.options\"></chartist></div><div class=\"md-title\">Bi-polar Line Chart With Area Only</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.biPolarLineChart.data\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.biPolarLineChart.options\"></chartist></div><div class=\"md-title\">Bar Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.barChart.data\" chartist-chart-type=\"Bar\" chartist-chart-options=\"vm.barChart.options\" chartist-responsive-options=\"vm.barChart.responsiveOptions\"></chartist></div><div class=\"md-title\">Horizontal Bar Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.horizontalBarChart.data\" chartist-chart-type=\"Bar\" chartist-chart-options=\"vm.horizontalBarChart.options\"></chartist></div><div class=\"md-title\">Bi-polar Bar Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.biPolarBarChart.data\" chartist-chart-type=\"Bar\" chartist-chart-options=\"vm.biPolarBarChart.options\"></chartist></div><div class=\"md-title\">Stacked Bar Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.stackedBarChart.data\" chartist-chart-type=\"Bar\" chartist-chart-options=\"vm.stackedBarChart.options\" chartist-events=\"vm.stackedBarChart.events\"></chartist></div><div class=\"md-title\">Doughnut Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.donutChart.data\" chartist-chart-type=\"Pie\" chartist-chart-options=\"vm.donutChart.options\"></chartist></div><div class=\"md-title\">Pie Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.pieChart.data\" chartist-chart-type=\"Pie\" chartist-chart-options=\"vm.pieChart.options\" chartist-responsive-options=\"vm.pieChart.responsiveOptions\"></chartist></div><div class=\"md-title\">Gauge Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.gaugeChart.data\" chartist-chart-type=\"Pie\" chartist-chart-options=\"vm.gaugeChart.options\"></chartist></div></div></div>");
$templateCache.put("app/main/components/charts/nvd3/nvd3.html","<div id=\"nvd3\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div class=\"title\">nvD3</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"http://krispo.github.io/angular-nvd3/#/\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div class=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.lineChart.options\" data=\"vm.lineChart.data\" class=\"with-3d-shadow with-transitions\"></nvd3></div><div class=\"md-title\">Stacked Area Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.stackedAreaChart.options\" data=\"vm.stackedAreaChart.data\"></nvd3></div><div class=\"md-title\">Sparkline Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.sparklineChart.options\" data=\"vm.sparklineChart.data\"></nvd3></div><div class=\"md-title\">Historical Bar Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.historicalBarChart.options\" data=\"vm.historicalBarChart.data\"></nvd3></div><div class=\"md-title\">Multi Bar Horizontal Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.multiBarHorizontalChart.options\" data=\"vm.multiBarHorizontalChart.data\"></nvd3></div><div class=\"md-title\">Pie Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.pieChart.options\" data=\"vm.pieChart.data\"></nvd3></div><div class=\"md-title\">Donut Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.donutChart.options\" data=\"vm.donutChart.data\"></nvd3></div><div class=\"md-title\">Bullet Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.bulletChart.options\" data=\"vm.bulletChart.data\"></nvd3></div><div class=\"md-title\">Scatter Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.scatterChart.options\" data=\"vm.scatterChart.data\"></nvd3></div></div></div>");
$templateCache.put("app/main/components/maps/tabs/custom-marker.html","<ui-gmap-google-map center=\"vm.customMarkerMap.center\" zoom=\"vm.customMarkerMap.zoom\"><ui-gmap-marker coords=\"vm.customMarkerMap.marker.coords\" idkey=\"vm.customMarkerMap.marker.id\" options=\"vm.customMarkerMap.marker.options\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/info-window.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker coords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"><ui-gmap-window show=\"\'true\'\"><div ng-non-bindable=\"\"><div id=\"siteNotice\"></div><h1 id=\"firstHeading\" class=\"firstHeading\">Uluru</h1><div id=\"bodyContent\"><p><b>Uluru</b>, also referred to as <b>Ayers Rock</b>, is a large sandstone rock formation in the southern part of the Northern Territory, central Australia.</p><p>Attribution: Uluru, <a href=\"//en.wikipedia.org/w/index.php?title=Uluru&amp;oldid=297882194\">http://en.wikipedia.org/w/index.php?title=Uluru</a> (last visited June 22, 2009).</p></div></div></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/satellite.html","<ui-gmap-google-map center=\"vm.satelliteMap.center\" zoom=\"vm.satelliteMap.zoom\" options=\"vm.satelliteMap.options\"></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/simple-marker.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker coords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/simple.html","<ui-gmap-google-map center=\"vm.simpleMap.center\" zoom=\"vm.simpleMap.zoom\"></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/terrain.html","<ui-gmap-google-map center=\"vm.terrainMap.center\" zoom=\"vm.terrainMap.zoom\" options=\"vm.terrainMap.options\"></ui-gmap-google-map>");
$templateCache.put("app/main/components/material-docs/demo/docs-demo.tmpl.html","<div class=\"doc-demo-content doc-content\"><div flex=\"\" layout=\"column\" style=\"z-index:1\"><div class=\"doc-description\" ng-bind-html=\"demoCtrl.demoDescription.contents | toHtml\"></div><div ng-transclude=\"\"></div><section class=\"demo-container md-whiteframe-z1\" ng-class=\"{\'show-source\': demoCtrl.$showSource}\"><md-toolbar class=\"demo-toolbar md-primary\"><div class=\"md-toolbar-tools\"><h3>{{demoCtrl.demoTitle}}</h3><span flex=\"\"></span><md-button class=\"md-icon-button\" aria-label=\"View Source\" ng-class=\"{ active: demoCtrl.$showSource }\" ng-click=\"demoCtrl.$showSource = !demoCtrl.$showSource\"><md-tooltip md-autohide=\"\">View Source</md-tooltip><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_code_24px.svg\"></md-icon></md-button></div></md-toolbar><md-tabs class=\"demo-source-tabs md-primary\" md-dynamic-height=\"\" ng-show=\"demoCtrl.$showSource\"><md-tab ng-repeat=\"file in demoCtrl.orderedFiles\" label=\"{{file.name}}\"><md-content md-scroll-y=\"\" class=\"demo-source-container\"><hljs class=\"no-header\" code=\"file.contentsPromise\" lang=\"{{file.fileType}}\" should-interpolate=\"demoCtrl.interpolateCode\"></hljs></md-content></md-tab></md-tabs><demo-include files=\"demoCtrl.files\" module=\"demoCtrl.demoModule\" class=\"{{demoCtrl.demoId}}\"></demo-include></section></div></div>");
$templateCache.put("app/main/components/tables/datatable/datatable.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div class=\"title\">Datatable</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised reference-button\" href=\"https://l-lin.github.io/angular-datatables\" target=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div class=\"md-title\">Zero Configuration</div><div class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Position</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Office</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Age</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Salary</span></div></th></tr></thead><tbody><tr ng-repeat=\"employee in ::vm.employees\"><td>{{ employee.name }}</td><td>{{ employee.position }}</td><td>{{ employee.office }}</td><td>{{ employee.age }}</td><td>{{ employee.startDate }}</td><td>{{ employee.salary }}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/components/tables/simple-table/simple-table.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div class=\"title\">Simple Table</div></div></div><div class=\"content\">Tables are used to present raw data sets, and usually appear in desktop enterprise products.<p>Data sets may include:</p><ul><li>Three or more columns of data</li><li>A corresponding visualization</li><li>The ability for users to query and manipulate data at scale</li></ul><div class=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\">Employees</div><table class=\"simple\" ms-responsive-table=\"\"><thead><tr><th>Name</th><th>Position</th><th>Office</th><th class=\"text-right\">Age</th><th class=\"text-right\">Start Date</th><th class=\"text-right\">Salary</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-repeat=\"person in vm.employees\"><td class=\"name\">{{person.name}}</td><td class=\"position\">{{person.position}}</td><td class=\"office\">{{person.office}}</td><td class=\"age text-right\">{{person.age}}</td><td class=\"start-date text-right\">{{person.startDate}}</td><td class=\"salary text-right\">{{person.salary | currency}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/pages/auth/bidder-profile/bidder-profile.html","<div id=\"bidder-profile\" layout=\"column\" class=\"page-layout simple right-sidenav\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/pages/auth/bidder-profile/views/detail/detail-view-bidder.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>CB</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password</div><form ng-submit=\"vm.getRecoveryPassword(vm.form.email)\" name=\"forgotPasswordForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"forgotPasswordForm.email.$error\" ng-show=\"forgotPasswordForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RECOVERY_PASSWORD\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RECOVERY_PASSWORD\">SEND RECOVERY PASSWORD</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"lock-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" layout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img class=\"avatar big\" src=\"assets/images/avatars/katherine.jpg\"><md-icon md-font-icon=\"icon-lock\" class=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex=\"\" layout=\"column\" layout-align=\"start\" layout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">Your session is locked</div><div class=\"subtitle\" translate=\"LOCK.SUBTITLE\">Due to inactivity, your session is locked. Enter your password to continue.</div></div></div><form name=\"lockForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input ng-model=\"vm.form.username\" placeholder=\"Username\" translate=\"\" translate-attr-placeholder=\"LOCK.USERNAME\" disabled=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOCK.PASSWORD\" required=\"\"><div ng-messages=\"lockForm.password.$error\" ng-show=\"lockForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOCK.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"UNLOCK\" ng-disabled=\"lockForm.$invalid || lockForm.$pristine\" translate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\">UNLOCK</md-button></form><div class=\"message\"><a ui-sref=\"app.pages_auth_login\" class=\"md-accent-color\"><span translate=\"LOCK.ARE_YOU_NOT\">Are you not</span><span>Jane Doe?</span></a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img src=\"/assets/images/logos/logo-web.png\"></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><div ng-if=\"vm.showAlert\" class=\"title red-text\" translate=\"LOGIN.FAILED\">Log in process failed. Try again</div><form ng-submit=\"vm.firebaseAuthenticate($event)\" name=\"loginForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"loginForm.email.$error\" ng-show=\"loginForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div><br></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOGIN.PASSWORD\" required=\"\"><div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex=\"\" hide=\"\" show-gt-sm=\"\"><div class=\"logo md-accent-bg\"><span>CB</span></div><div class=\"title\" translate=\"LOGIN_V2.INTRO_TITLE\">Welcome to the FUSE!</div><div class=\"description\" translate=\"LOGIN_V2.INTRO_DESCRIPTION\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.</div></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll=\"\"><div id=\"login-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm=\"\"><span>F</span></div><div class=\"title\" translate=\"LOGIN_V2.TITLE\">Log in to your account</div><div class=\"description\" translate=\"LOGIN_V2.DESCRIPTION\">Sed mollis velit facilisis facilisis viverra</div><form name=\"loginForm\" novalidate=\"\" ng-submit=\"vm.submit()\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"LOGIN_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"loginForm.email.$error\" ng-show=\"loginForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"LOGIN_V2.PASSWORD\" required=\"\"><div ng-messages=\"loginForm.password.$error\" ng-show=\"loginForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN_V2.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN_V2.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN_V2.LOG_IN\" translate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button></form><div class=\"register\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN_V2.DONT_HAVE_ACCOUNT\">Don\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register-v2\" translate=\"LOGIN_V2.CREATE_ACCOUNT\">Create an account</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"register-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>CB</span></div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div><form ng-submit=\"vm.registerUser(vm.form.company,vm.form.email)\" name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"company\" ng-model=\"vm.form.company\" placeholder=\"Company\" translate=\"\" translate-attr-placeholder=\"REGISTER.COMPANY\" required=\"\"><div ng-messages=\"registerForm.company.$error\" ng-show=\"registerForm.company.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.COMPANY_REQUIRED\">Company Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Main Email\" translate=\"\" translate-attr-placeholder=\"REGISTER.MAIN_EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.email.$error\" ng-show=\"registerForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"REGISTER.PASSWORD\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"mainphone\" ng-model=\"vm.form.mainphone\" placeholder=\"Main Phone\" translate=\"\" translate-attr-placeholder=\"REGISTER.MAIN_PHONE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"address\" ng-model=\"vm.form.address\" placeholder=\"Address\" translate=\"\" translate-attr-placeholder=\"REGISTER.ADDRESS\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"city\" ng-model=\"vm.form.city\" placeholder=\"City\" translate=\"\" translate-attr-placeholder=\"REGISTER.CITY\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"postcode\" ng-model=\"vm.form.postcode\" placeholder=\"PostCode\" translate=\"\" translate-attr-placeholder=\"REGISTER.POSTCODE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"country\" ng-model=\"vm.form.country\" placeholder=\"Country\" translate=\"\" translate-attr-placeholder=\"REGISTER.COUNTRY\"></md-input-container><hr><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"name1\" ng-model=\"vm.form.name1\" placeholder=\"Name 1\" translate=\"\" translate-attr-placeholder=\"REGISTER.NAME_1\"><div ng-messages=\"registerForm.name1.$error\" ng-show=\"registerForm.name1.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email1\" ng-model=\"vm.form.email1\" placeholder=\"E-mail 1\" translate=\"\" translate-attr-placeholder=\"REGISTER.EMAIL_1\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email1.$error\" ng-show=\"registerForm.email1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">E-mail 1 field is required</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">E-mail 1 must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"phone1\" ng-model=\"vm.form.phone1\" placeholder=\"Phone 1\" translate=\"\" translate-attr-placeholder=\"REGISTER.PHONE_1\"></md-input-container><hr><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"name2\" ng-model=\"vm.form.name2\" placeholder=\"Name 2\" translate=\"\" translate-attr-placeholder=\"REGISTER.NAME_2\"><div ng-messages=\"registerForm.name2.$error\" ng-show=\"registerForm.name2.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email2\" ng-model=\"vm.form.email2\" placeholder=\"E-mail 2\" translate=\"\" translate-attr-placeholder=\"REGISTER.EMAIL_2\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email2.$error\" ng-show=\"registerForm.email2.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">E-mail 2 field is required</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">E-mail 2 must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"phone2\" ng-model=\"vm.form.phone2\" placeholder=\"Phone 2\" translate=\"\" translate-attr-placeholder=\"REGISTER.PHONE_2\"></md-input-container><hr><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"name3\" ng-model=\"vm.form.name3\" placeholder=\"Name 3\" translate=\"\" translate-attr-placeholder=\"REGISTER.NAME_3\"><div ng-messages=\"registerForm.name3.$error\" ng-show=\"registerForm.name3.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email3\" ng-model=\"vm.form.email3\" placeholder=\"E-mail 3\" translate=\"\" translate-attr-placeholder=\"REGISTER.EMAIL_3\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email3.$error\" ng-show=\"registerForm.email3.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">E-mail 3 field is required</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">E-mail 3 must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"phone3\" ng-model=\"vm.form.phone3\" placeholder=\"Phone 3\" translate=\"\" translate-attr-placeholder=\"REGISTER.PHONE_3\"></md-input-container><hr><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"name4\" ng-model=\"vm.form.name4\" placeholder=\"Name 4\" translate=\"\" translate-attr-placeholder=\"REGISTER.NAME_4\"><div ng-messages=\"registerForm.name4.$error\" ng-show=\"registerForm.name4.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email4\" ng-model=\"vm.form.email4\" placeholder=\"E-mail 4\" translate=\"\" translate-attr-placeholder=\"REGISTER.EMAIL_4\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email4.$error\" ng-show=\"registerForm.email4.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">E-mail 4 field is required</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">E-mail 4 must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"phone4\" ng-model=\"vm.form.phone4\" placeholder=\"Phone 4\" translate=\"\" translate-attr-placeholder=\"REGISTER.PHONE_4\"></md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required=\"\"></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">I read and accept</span> <a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions</a></div></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"CREATE MY ACCOUNT\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"REGISTER.LOGIN\">Log in</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/register-v2/register-v2.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex=\"\" hide=\"\" show-gt-sm=\"\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"REGISTER_V2.INTRO_TITLE\">Welcome to the FUSE!</div><div class=\"description\" translate=\"REGISTER_V2.INTRO_DESCRIPTION\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex=\"\" ms-scroll=\"\"><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm=\"\"><span>F</span></div><div class=\"title\" translate=\"REGISTER_V2.TITLE\">Create an account</div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\">Sed mollis velit facilisis facilisis viverra</div><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.NAME\" required=\"\"><div ng-messages=\"registerForm.username.$error\" ng-show=\"registerForm.username.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.email.$error\" ng-show=\"registerForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.PASSWORD\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required=\"\"></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER_V2.READ_ACCEPT\">I read and accept</span> <a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\">terms and conditions</a></div></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"CREATE MY ACCOUNT\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"REGISTER_V2.LOGIN\">Log in</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll=\"\"><div id=\"reset-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password</div><form name=\"resetPasswordForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate=\"\" translate-attr-placeholder=\"RESETPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"resetPasswordForm.email.$error\" ng-show=\"resetPasswordForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"RESETPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"RESETPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"resetPasswordForm.passwordConfirm.$error\" ng-show=\"resetPasswordForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" translate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" translate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div class=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate=\"\" translate-attr-placeholder=\"ERROR404.SEARCH\" flex=\"\"></div><a class=\"back-link md-accent-color\" href=\"/\" translate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" translate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" translate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/ui/page-layouts/blank/blank.html","<div class=\"page-layout blank\" layout=\"row\"><h2>Blank page</h2></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-content.html","<div class=\"demo-content\"><img src=\"assets/images/etc/early-sunrise.jpg\" class=\"md-card-image\" alt=\"sunrise\"><h1>Early Sunrise</h1><h4 class=\"secondary-text\">Demo Content</h4><p>One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections.</p><blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What\'s happened to me? \" he thought. It wasn\'t a dream.</p><footer>John Doe</footer></blockquote><p>His room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.</p><p>It showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops of rain could be heard hitting the pane, which made him feel quite sad.</p><p>\"How about if I sleep a little bit longer and forget all this nonsense\", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn\'t get into that position. However hard he threw himself onto his right, he always rolled back to where he was.</p><p>He must have tried it a hundred times, shut his eyes so that he wouldn\'t have to look at the floundering legs, and only stopped when he began to feel a mild, dull pain there that he had never felt before. \"Oh, God\", he thought, \"what a strenuous career it is that I\'ve chosen!</p><p>Travelling day in and day out. Doing business like this takes much more effort than doing your own business at home, and on top of that there\'s the curse of travelling, worries about making train connections, bad and irregular food, contact with different people all the time so that you can never get to know anyone or become friendly with them.</p><p>\"He felt a slight itch up on his belly; pushed himself slowly up on his back towards the headboard so that he could lift his head better; found where the itch was, and saw that it was covered with lots of little white spots which he didn\'t know what to make of; and when he tried to feel the place with one of his legs he drew it quickly back because as soon as he touched it he was overcome by a cold shudder. He slid back into his former position.</p><p>\"Getting up early all the time\", he thought, \"it makes you stupid. You\'ve got to get enough sleep. Other travelling salesmen live a life of luxury. For instance, whenever I go back to the guest house during the morning to copy out the contract, these gentlemen are always still sitting there eating their breakfasts. I ought to just try that with my boss; I\'d get kicked out on the spot. But who knows, maybe that would be the best thing for me...</p></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-sidenav.html","<div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Sidenav Demo</md-subheader><md-list-item><p>Sidenav Item 1</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 2</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 3</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 4</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 5</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 6</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 7</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 8</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 9</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 10</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 11</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 12</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 13</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 14</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 15</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 16</p></md-list-item></md-list></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div class=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button class=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" layout-align=\"space-between\" layout-fill=\"\" flex=\"\"><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" ng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div class=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" aria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/apps/calendar_DESHABILITADO/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex=\"\"></span><md-button class=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate=\"\" translate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex=\"\"><span class=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span> {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex=\"\"><span class=\"h4\" translate=\"CALENDAR.30_MIN_BEFORE\">30 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.15_MIN_BEFORE\">15 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.30_MIN_LATER\">30 minutes later</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex=\"\"><span class=\"h4\">Istanbul, Turkey</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon><div layout=\"row\" flex=\"\"><img src=\"assets/images/avatars/alice.jpg\" class=\"avatar\" alt=\"alice\"> <img src=\"assets/images/avatars/joyce.jpg\" class=\"avatar\" alt=\"joyce\"> <img src=\"assets/images/avatars/vincent.jpg\" class=\"avatar\" alt=\"vincent\"></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/calendar_DESHABILITADO/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label> <input name=\"title\" ng-model=\"vm.calendarEvent.title\" required=\"\"><div ng-messages=\"eventForm.title.$error\" ng-show=\"eventForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-list class=\"all-day\"><md-list-item><p translate=\"CALENDAR.ALL_DAY\">All Day</p><md-switch class=\"md-secondary\" ng-model=\"vm.calendarEvent.allday\" aria-label=\"All day\" translate=\"\" translate-attr-aria-label=\"CALENDAR.ALL_DAY\"></md-switch></md-list-item></md-list><div layout=\"row\" class=\"date-row\"><md-datepicker ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\"></md-datepicker><md-input-container flex=\"\" md-no-float=\"\"><input ng-model=\"vm.calendarEvent.startTime\" placeholder=\"Start Time\" translate=\"\" translate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout=\"row\" class=\"date-row\"><md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\"></md-datepicker><md-input-container flex=\"\" md-no-float=\"\"><input ng-model=\"vm.calendarEvent.endTime\" placeholder=\"End Time\" translate=\"\" translate-attr-placeholder=\"CALENDAR.END_TIME\"></md-input-container></div><md-input-container class=\"md-block\" flex=\"\"><label translate=\"CALENDAR.REPEAT\">Repeat</label> <input ng-model=\"vm.calendarEvent.repeat\"></md-input-container><md-input-container class=\"md-block\" flex=\"\"><label translate=\"CALENDAR.LOCATION\">Location</label> <input ng-model=\"vm.calendarEvent.location\"></md-input-container><div class=\"notifications\" layout=\"column\"><div class=\"title\" translate=\"CALENDAR.NOTIFICATIONS\">Notifications</div><md-select ng-model=\"notification\" placeholder=\"Notification\" ng-repeat=\"notification in vm.calendarEvent.notifications\"><md-option ng-repeat=\"opt in vm.notifications\" value=\"{{opt}}\">{{opt}}</md-option></md-select><md-button aria-label=\"+ Add Another Notification\" translate=\"CALENDAR.ADD_NOTIFICATION\" translate-attr-aria-label=\"CALENDAR.ADD_NOTIFICATION\">+ Add Another Notification</md-button></div><md-input-container flex=\"\" class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes</label> <textarea ng-model=\"vm.task.notes\" md-maxlength=\"250\"></textarea></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" ng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" translate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/contact/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/contact/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/contact/views/detail/detail-view-contact.html","<div id=\"detail-view-contact\"><div class=\"message\">Contact</div><div class=\"separador\"></div><div layout=\"column\" layout-xs=\"column\" layout-align=\"center center\"><div id=\"contact-layer\" layout=\"column\" layout-xs=\"column\" layout-align=\"center center\"><div><md-icon md-font-icon=\"icon-map-marker-radius\" class=\"s20\"></md-icon><label translate=\"CONTACT.OFFICE\">Office</label><div id=\"contact-content\">Park House, Suite G1/G5<br>North Street<br>Horsham, RH12 9SB<br>United Kingdom</div></div><div><md-icon md-font-icon=\"icon-phone\" class=\"s20\"></md-icon><label translate=\"CONTACT.CALL\">Call</label><div id=\"contact-content\">Tel: +44 (0) 203 146 8777</div></div><div><md-icon md-font-icon=\"icon-email\" class=\"s20\"></md-icon><label translate=\"CONTACT.CONTACT\">Contact</label><div id=\"contact-content\">chartship@chartbid.com</div></div></div><div id=\"content2\">(For Chartbid questions only. For all tender related questions please send a message via the communications section of this portal)</div></div></div>");
$templateCache.put("app/main/apps/contact/views/list/list-view.html","<div class=\"message\">ITB List</div><table class=\"simple\" ms-responsive-table=\"\"><div id=\"grid1\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\"></div></table><div>ROW SELECTED = {{vm.selectedItem}}</div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"DELETE\" ng-disabled=\"false\" translate=\"ITB.DELETE\" translate-attr-aria-label=\"ITB.DELETE\" ng-click=\"\">DELETE</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"MODIFY\" ng-disabled=\"false\" translate=\"ITB.MODIFY\" translate-attr-aria-label=\"ITB.MODIFY\" ng-click=\"vm.toggleView()\">MODIFY</md-button><md-button class=\"md-raised md-accent\" aria-label=\"INSERT\" ng-disabled=\"false\" translate=\"ITB.INSERT\" translate-attr-aria-label=\"ITB.INSERT\" ng-click=\"vm.toggleView()\">INSERT</md-button></div>");
$templateCache.put("app/main/apps/file-manager_DESHABILITADO/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">Michel Smits</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/file-manager_DESHABILITADO/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/file-manager_DESHABILITADO/views/grid/grid-view.html","<div class=\"grid-view\" layout=\"column\"><div class=\"folders\" layout=\"row\" layout-wrap=\"\"><div class=\"md-background-bg md-hue-1 md-whiteframe-1dp item folder\" ng-click=\"vm.select(folder)\" ng-repeat=\"folder in vm.folders | filter:global.search\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\"><span class=\"file-icon\"><md-icon md-font-icon=\"icon-{{folder.type}}\"></md-icon></span> <span class=\"name\">{{folder.name}}</span></div><div class=\"show-details\" hide-gt-md=\"\"><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate=\"\" translate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(folder)\"></md-icon></md-button></div></div></div><div class=\"files\" layout=\"row\" layout-wrap=\"\"><div ng-click=\"vm.select(file)\" class=\"md-whiteframe-1dp item file\" ng-repeat=\"file in vm.files | filter:global.search\" layout=\"column\"><div class=\"preview\"><img ng-src=\"{{file.preview}}\"></div><div class=\"bottom md-background-bg md-hue-1\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"title\" layout-align=\"start center\" flex=\"\"><span class=\"file-icon\"><md-icon md-font-icon=\"icon-{{file.type}}\"></md-icon></span> <span class=\"name\">{{file.name}}</span></div><div class=\"show-details\" hide-gt-md=\"\"><md-button class=\"md-icon-button sidenav-toggle\" aria-label=\"Details\" translate=\"\" translate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\" ng-click=\"vm.toggleDetails(file)\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/apps/file-manager_DESHABILITADO/views/list/list-view.html","<table class=\"simple list-view\"><thead><tr><th></th><th translate=\"FM.NAME\">Name</th><th hide=\"\" show-gt-sm=\"\" translate=\"FM.TYPE\">Type</th><th hide-xs=\"\" translate=\"FM.OWNER\">Owner</th><th hide-xs=\"\" translate=\"FM.SIZE\">Size</th><th hide=\"\" show-gt-md=\"\" translate=\"FM.LAST_MODIFIED\">Last Modified</th><th hide-gt-md=\"\"></th></tr></thead><tbody><tr ng-repeat=\"folder in vm.folders | filter:global.search\" ng-click=\"vm.select(folder)\" ng-class=\"{\'selected\' : vm.selected === folder}\"><td class=\"file-icon\"><md-icon md-font-icon=\"icon-{{folder.type}}\"></md-icon></td><td class=\"name\">{{folder.name}}</td><td class=\"type\" hide=\"\" show-gt-sm=\"\">{{folder.type}}</td><td class=\"owner\" hide-xs=\"\">{{folder.owner}}</td><td class=\"size\" hide-xs=\"\">{{folder.size === \'\' ? \'-\': folder.size}}</td><td class=\"last-modified\" hide=\"\" show-gt-md=\"\">{{folder.modified}}</td><td class=\"show-details\" hide-gt-md=\"\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(folder)\" aria-label=\"Toggle details sidenav\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr><tr ng-repeat=\"file in vm.files | filter:global.search\" ng-click=\"vm.select(file)\" ng-class=\"{\'selected\' : vm.selected === file}\"><td class=\"file-icon\"><md-icon md-font-icon=\"icon-{{file.type}}\"></md-icon></td><td class=\"name\">{{file.name}}</td><td class=\"type\" hide=\"\" show-gt-sm=\"\">{{file.type}}</td><td class=\"owner\" hide-xs=\"\">{{file.owner}}</td><td class=\"size\" hide-xs=\"\">{{file.size === \'\' ? \'-\': file.size}}</td><td class=\"last-modified\" hide=\"\" show-gt-md=\"\">{{file.modified}}</td><td class=\"show-details\" hide-gt-md=\"\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleDetails(file)\" aria-label=\"Details\" translate=\"\" translate-attr-aria-label=\"FM.DETAILS\"><md-icon md-font-icon=\"icon-information-outline\"></md-icon></md-button></td></tr></tbody></table>");
$templateCache.put("app/main/apps/help/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/help/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/help/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">ITB Detail</div><table class=\"simple\" ms-responsive-table=\"\"><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"reference\" ng-model=\"vm.form.reference\" placeholder=\"Reference\" translate=\"\" translate-attr-placeholder=\"ITB.REFERENCE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterers_reference\" ng-model=\"vm.form.charterers_reference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"ITB.CHARTERERS_REFERENCE\" required=\"\"><div ng-messages=\"registerForm.charterers_reference.$error\" ng-show=\"registerForm.charterers_reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterer\" ng-model=\"vm.form.charterer\" placeholder=\"Charterer\" translate=\"\" translate-attr-placeholder=\"ITB.CHARTERER\" required=\"\"><div ng-messages=\"registerForm.charterer.$error\" ng-show=\"registerForm.charterer.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"title\" ng-model=\"vm.form.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"ITB.TITLE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"vessel_type\" ng-model=\"vm.form.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"ITB.VESSEL_TYPE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"location\" ng-model=\"vm.form.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"ITB.LOCATION\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"commencement\" ng-model=\"vm.form.commencement\" placeholder=\"Commencement\" translate=\"\" translate-attr-placeholder=\"ITB.COMMENCEMENT\"><div ng-messages=\"registerForm.commencement.$error\" ng-show=\"registerForm.commencement.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.COMMENCEMENT_REQUIRED\">Commencement field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"closing_date\" ng-model=\"vm.form.closing_date\" placeholder=\"Closing Date\" translate=\"\" translate-attr-placeholder=\"ITB.CLOSING_DATE\"><div ng-messages=\"registerForm.closing_date.$error\" ng-show=\"registerForm.closing_date.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.CLOSING_DATE_REQUIRED\">Closing Date field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ITB.CANCEL\" translate-attr-aria-label=\"ITB.CANCEL\" ng-click=\"vm.toggleView()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ITB.SAVE\" translate-attr-aria-label=\"ITB.SAVE\" ng-click=\"vm.toggleView()\">SAVE</md-button></div></form></table></div>");
$templateCache.put("app/main/apps/help/views/list/list-view.html","<div class=\"separador-title\"></div><div class=\"message\">HELP</div><div class=\"separador-help\"></div><table class=\"simple\" ms-responsive-table=\"\"><div>For user instructions please download “ChartBid Electronic Bidding Portal - Quick Reference Guide”.</div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button class=\"grey-button\" ng-click=\"vm.viewFile()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"HELP.DOWNLOAD_DOC\" translate-attr-aria-label=\"HELP.DOWNLOAD_DOC\">DOWNLOAD DOCUMENT</div><md-icon md-font-icon=\"icon-magnify\" class=\"s20 icon-white\"></md-icon></div></md-button></div>");
$templateCache.put("app/main/apps/mail/dialogs/compose/compose-mail-dialog.html","<md-dialog class=\"compose-mail-dialog\" aria-label=\"New communication\"><form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"{{vm.title}}\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate=\"\" translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div ng-show=\"!vm.addressBookVisible\"><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label translate=\"MAIL.FROM\">From</label> <input ng-model=\"vm.form.fromName\" type=\"text\" disabled=\"\"></md-input-container><md-input-container class=\"md-block to\" ng-class=\"{\'hidden-cc\': vm.hiddenCC, \'hidden-bcc\': vm.hiddenBCC}\"><label>To:</label> <input ng-model=\"vm.form.toName\" type=\"text\" disabled=\"\"><div class=\"cc-bcc\" layout=\"row\" layout-align=\"start center\"><div ng-show=\"{{ vm.addressBookButtonVisible }}\" class=\"show-cc\" ng-click=\"vm.showAddressBook()\" tranlate=\"\" translate-aria-label=\"MAIL.ADDRESS_BOOK\">Address book</div></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"MAIL.SUBJECT\">Subject</label> <input ng-model=\"vm.form.subject\" type=\"text\"></md-input-container><text-angular ng-model=\"vm.form.message\" ta-toolbar=\"[[\'bold\',\'underline\',\'quote\',\'ul\',\'ol\']]\"></text-angular></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.sendMail(vm.type)\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MAIL.SEND\" translate-attr-aria-label=\"MAIL.SEND\">SEND</md-button></div></md-dialog-actions></div></form></md-dialog>");
$templateCache.put("app/main/apps/mail/dialogs/print/print-mail-dialog.html","<md-dialog class=\"print-mail-dialog\" aria-label=\"Mail\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"Print Dialog\">Print Dialog</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate=\"\" translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div id=\"divMailToPrint\"><div class=\"mail-header\"><div class=\"subject\" flex=\"\"><h3>{{vm.selectedMail.subject}}</h3></div></div><div class=\"mail-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\" translate=\"MAIL.DETAILS.FROM\">From: &nbsp;</span> <span class=\"title\" translate=\"MAIL.DETAILS.TO\">To: &nbsp;</span> <span class=\"title\" translate=\"MAIL.DETAILS.DATE\">Date: &nbsp;</span></div><div layout=\"column\"><span class=\"detail\">{{vm.selectedMail.fromName}}</span> <span class=\"detail\">{{vm.selectedMail.finalToName}}</span> <span class=\"detail\">{{vm.selectedMail.date}}</span></div></div></div></div><div ng-bind-html=\"vm.selectedMail.message\"></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.printMail(\'divMailToPrint\')\" class=\"send-button md-accent md-raised\" aria-label=\"Print\" translate=\"MAIL.PRINT\" translate-attr-aria-label=\"MAIL.PRINT\">PRINT</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/mail/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon></span> <span class=\"logo-text\" translate=\"MAIL.MAILBOX\">Mailbox</span></div><div class=\"separador\"></div><div class=\"account\"><div class=\"title2\">{{ vm.login.name}}</div><div class=\"title2\">{{ vm.login.email}}</div></div></div><div class=\"separador\"></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"compose-button\"><md-button class=\"md-accent md-raised\" aria-label=\"new communication\" ng-click=\"vm.composeDialog($event,\'communication\')\" translate=\"MAIL.NEW_COMMUNICATION\">NEW COMMUNICATION</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" ng-click=\"vm.getInboxMails(vm.itbReceiverKey)\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-inbox\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.INBOX\">Inbox</span></div></md-button><md-button class=\"item\" aria-label=\"sent\" ng-click=\"vm.getSentboxMails(vm.itbSenderKey)\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon><span class=\"title\" translate=\"MAIL.SENT\">Sent</span></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/mail/views/list/list-view.html","<div class=\"mail-list-item {{mail.status}}\" ng-repeat=\"mail in vm.inbox | orderBy : \'-date\' | filter: vm.search | filter: global.search\" md-ink-ripple=\"\" ng-click=\"vm.selectMail(mail)\" ng-class=\"{\'starred\': mail.starred, \'selected\': vm.selectedMail === mail, \'checked\': vm.isChecked(mail)}\"><div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isChecked(mail)\" ng-click=\"vm.toggleCheck(mail, $event)\" aria-label=\"{{vm.isChecked(mail)? \'Uncheck\':\'check\'}}\"></md-checkbox><div class=\"info\" flex=\"\" layout=\"column\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" alt=\"{{mail.from.name}}\" ng-src=\"{{vm.genericAvatarSource}}\"><span class=\"text-truncate\">{{mail.fromName}}</span></div><div class=\"subject text-truncate\"><md-icon ng-if=\"vm.showReadIcon\" ng-show=\"!mail.read\" md-font-icon=\"icon-alert-circle\" class=\"s20 icon-red\"></md-icon>{{mail.subject}}</div><div class=\"message\">{{mail.message | htmlToPlaintext | limitTo:90}}{{mail.message.length > 90 ? \'...\' : \'\'}}</div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"time\">{{mail.date}}</div></div></div></div>");
$templateCache.put("app/main/apps/mail/views/read/read-view.html","<div class=\"mail-header\"><div class=\"subject\" flex=\"\">{{vm.selectedMail.subject}}</div></div><div class=\"mail-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\"><div><img alt=\"{{vm.selectedMail.fromName}}\" ng-src=\"{{vm.genericAvatarSource}}\" class=\"avatar\"></div><div layout=\"column\" layout-align=\"start start\"><div class=\"name\">{{vm.selectedMail.fromName}}</div><div class=\"to\" layout=\"row\" layout-align=\"start center\"><div class=\"to-text\" translate=\"MAIL.INFO.TO\">to</div><div>{{vm.selectedMail.toName}}</div></div></div></div><a class=\"toggle-details md-accent-color\" ng-hide=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" translate=\"MAIL.SHOW_DETAILS\">Show Details</a> <a class=\"toggle-details md-accent-color\" ng-show=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" translate=\"MAIL.HIDE_DETAILS\">Hide Details</a><div ng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\" translate=\"MAIL.DETAILS.FROM\">From:</span> <span class=\"title\" translate=\"MAIL.DETAILS.TO\">To:</span> <span class=\"title\" translate=\"MAIL.DETAILS.DATE\">Date:</span></div><div layout=\"column\"><span class=\"detail\">{{vm.selectedMail.fromName}}</span> <span class=\"detail\">{{vm.selectedMail.toName}}</span> <span class=\"detail\">{{vm.selectedMail.date}}</span></div></div></div><md-button aria-label=\"Print\" translate-aria-label=\"MAIL.PRINT\" ng-click=\"vm.printMailDialog($event)\"><md-icon md-font-icon=\"icon-printer\"></md-icon><span translate=\"MAIL.PRINT\">Print</span></md-button><md-button aria-label=\"Reply\" translate-aria-label=\"MAIL.REPLY\" ng-click=\"vm.replyDialog($event,vm.selectedMail.type)\"><md-icon md-font-icon=\"icon-reply\"></md-icon><span translate=\"MAIL.REPLY\">Reply</span></md-button></div><div ng-bind-html=\"vm.selectedMail.message\"></div></div><div ng-if=\"vm.selectedMail.attachments\" class=\"attachments\"><div class=\"title\"><span translte=\"MAIL.ATTACHMENTS\">Attachments</span> ({{vm.selectedMail.attachments.length}})</div><div class=\"attachment-list\" layout-wrap=\"\" layout=\"row\"><div class=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.selectedMail.attachments\"><img class=\"preview\" ng-src=\"{{attachment.preview}}\"><div layout=\"column\"><a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.VIEW\">View</a> <a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.DOWNLOAD\">Download</a><div class=\"size\">({{attachment.size}})</div></div></div></div></div>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/dialogs/card/card-dialog.html","<md-dialog class=\"card-dialog\" aria-label=\"Card Dialog\" ng-cloak=\"\"><md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-datepicker class=\"due-date-picker\" ng-model=\"vm.card.due\" ng-change=\"vm.calculateOverdue()\" md-placeholder=\"Due date\"></md-datepicker><md-menu md-offset=\"0 48\" class=\"labels\"><md-button class=\"md-icon-button\" aria-label=\"Label\" translate=\"\" translate-attr-aria-label=\"SB.LABEL\" ng-click=\"vm.labelTabIndex = 0;$mdOpenMenu($event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-label-outline\"></md-icon></md-button><md-menu-content class=\"labels-menu-content\" width=\"4\" ms-scroll=\"\"><md-tabs md-selected=\"vm.labelTabIndex\" md-dynamic-height=\"\"><md-tab><md-tab-body><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Search labels...\" type=\"text\" ng-model=\"vm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_LABELS\"></md-input-container></md-menu-item><md-menu-item class=\"label\" ng-repeat=\"label in vm.labels | filter: vm.filterLabel\"><md-button class=\"label-toggle-button\" md-prevent-menu-close=\"\" ng-class=\"\'md-\'+label.color+\'-bg\'\" ng-click=\"vm.toggleInArray(label.id, vm.card.idLabels)\" aria-label=\"Toggle Label\" translate=\"\" translate-attr-aria-label=\"SB.TOGGLE_LABEL\"><div layout=\"row\" layout-align=\"space-between center\"><span>{{label.name}}</span> <i ng-if=\"vm.exists(label.id, vm.card.idLabels)\" class=\"icon-check s16\"></i></div></md-button><md-button class=\"md-icon-button label-edit-button\" md-prevent-menu-close=\"\" ng-click=\"vm.editLabelId = label.id; vm.labelTabIndex = 2\" aria-label=\"Edit Label\" translate=\"\" translate-attr-aria-label=\"SB.EDIT_LABEL\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button class=\"add-label-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 1\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span translate=\"SB.ADD_NEW_LABEL\">Add new label</span></md-button></md-menu-item></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"add-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 0\" aria-label=\"Back\" translate=\"\" translate-attr-aria-label=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex=\"\" translate=\"SB.CREATE_LABEL\">Create Label</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\"><form ng-submit=\"vm.addNewLabel(); vm.labelTabIndex = 0\" layout=\"column\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.newLabelName\" translate=\"\" translate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i class=\"icon-check s18\" ng-if=\"vm.newLabelColor === palette\"></i></label></div><md-button type=\"submit\" md-prevent-menu-close=\"\" class=\"create-button md-accent md-raised\" aria-label=\"Create\" translate=\"\" translate-attr-aria-label=\"SB.CREATE\"><span translate=\"SB.CREATE\">Create</span></md-button></form></div></div></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"edit-label-tab-content\"><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button class=\"md-icon-button\" md-prevent-menu-close=\"\" ng-click=\"vm.labelTabIndex = 0\" aria-label=\"back\" translate=\"\" translate-attr-aria-label=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex=\"\" translate=\"SB.EDIT_LABEL\">Edit Label</span></div><div class=\"content\" layout=\"column\" layout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Label Name\" type=\"text\" ng-model=\"vm.board.labels.getById(vm.editLabelId).name\" translate=\"\" translate-attr-placeholder=\"SB.LABEL_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.board.labels.getById(vm.editLabelId).color\" ng-value=\"palette\" aria-label=\"{{palette}}\"> <i ng-if=\"vm.board.labels.getById(vm.editLabelId).color === palette\" class=\"icon-check s18\"></i></label></div><div layout=\"row\" layout-align=\"end center\" flex=\"\"><md-button class=\"remove-button md-icon-button\" type=\"submit\" md-prevent-menu-close=\"\" ng-click=\"vm.removeLabel(); vm.labelTabIndex=0\" aria-label=\"remove\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div></md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><md-menu md-offset=\"0 48\" class=\"members\"><md-button class=\"md-icon-button\" aria-label=\"Members\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-account-multiple\"></md-icon></md-button><md-menu-content class=\"members-menu-content\" width=\"4\" ms-scroll=\"\"><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Search members...\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.memberSearchText\" translate=\"\" translate-attr-placeholder=\"SB.SEARCH_MEMBERS\"></md-input-container></md-menu-item><md-menu-item class=\"member\" ng-repeat=\"member in vm.members | filter: vm.filterMember\"><md-button ng-click=\"vm.toggleInArray(member.id, vm.card.idMembers)\" md-prevent-menu-close=\"\" aria-label=\"toggle member\" translate=\"\" translate-attr-aria-label=\"SB.TOGGLE_MEMBER\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"avatar\"><p class=\"member-name\">{{ member.name }}</p></div><i class=\"icon-check s16\" ng-if=\"vm.exists(member.id, vm.card.idMembers)\"></i></div></md-button></md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"\" aria-label=\"Attachment\" translate=\"\" translate-attr-aria-label=\"SB.ATTACHMENT\"><md-icon md-font-icon=\"icon-attachment\"></md-icon></md-button><md-menu md-offset=\"0 48px\" class=\"checklist\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"checklist\" translate=\"\" translate-attr-aria-label=\"SB.CHECKLIST\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-checkbox-marked\"></md-icon></md-button><md-menu-content class=\"checklist-menu-content\" width=\"4\"><form ng-submit=\"vm.createCheckList()\" layout=\"column\" layout-align=\"start end\"><md-input-container class=\"no-errors-spacer\" md-no-float=\"\"><input placeholder=\"Checklist Title\" autocomplete=\"off\" type=\"text\" ng-model=\"vm.newCheckListTitle\" translate=\"\" translate-attr-placeholder=\"SB.CHECKLIST_TITLE\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add Checklist\" translate=\"\" translate-attr-aria-label=\"SB.ADD_CHECKLIST\"><span translate=\"SB.ADD_CHECKLIST\">Add Checklist</span></md-button></form></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"subscribe\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Subscribe\" translate=\"\" translate-attr-aria-label=\"SB.SUBSCRIBE\"><md-icon md-menu-origin=\"\" ng-if=\"vm.card.subscribed\" md-font-icon=\"icon-eye\"></md-icon><md-icon md-menu-origin=\"\" ng-if=\"!vm.card.subscribed\" md-font-icon=\"icon-eye-off\"></md-icon></md-button><md-menu-content class=\"subscribe-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.card.subscribed = !vm.card.subscribed\" aria-label=\"Subscribed\" translate=\"\" translate-attr-aria-label=\"SB.SUBSCRIBED\"><span ng-if=\"!vm.card.subscribed\" translate=\"SB.SUBSCRIBE\">Subscribe</span> <span ng-if=\"vm.card.subscribed\" translate=\"SB.UNSUBSCRIBE\">Unsubscribe</span></md-button></md-menu-item></md-menu-content></md-menu><md-menu md-offset=\"0 48px\" class=\"options\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-horizontal\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeCard()\" aria-label=\"Remove Card\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_CARD\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target=\"\"></md-icon><span translate=\"SB.REMOVE_CARD\">Remove Card</span></md-button></md-menu-item></md-menu-content></md-menu><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate=\"\" translate-attr-aria-label=\"SB.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><div layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div class=\"card-breadcrumb\" layout=\"row\" layout-align=\"start center\"><span>{{vm.board.name}}</span> <i class=\"icon-menu-right\"></i> <span>{{vm.getCardList().name}}</span></div><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.card.subscribed\" class=\"card-subscribe s18\" md-font-icon=\"icon-eye\"></md-icon><div class=\"card-name\"><span editable-text=\"vm.card.name\">{{vm.card.name}}</span></div></div></div><md-datepicker ng-if=\"vm.card.due\" class=\"due-date-picker\" ng-model=\"vm.card.due\" ng-change=\"vm.calculateOverdue()\" md-placeholder=\"Due date\"></md-datepicker></div><div class=\"description\"><md-input-container class=\"md-block\"><label translate=\"SB.DESCRIPTION\">Description</label> <textarea ng-model=\"vm.card.description\" columns=\"1\" md-maxlength=\"150\" rows=\"5\"></textarea></md-input-container></div><div class=\"sections\"><div ng-if=\"vm.card.idLabels[0] || vm.card.idMembers[0]\" class=\"section\" layout=\"row\"><div ng-if=\"vm.card.idLabels[0]\" flex=\"\" class=\"labels\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-label-outline s18\"></i> <span class=\"section-title\" translate=\"SB.LABELS\">Labels</span></div><div class=\"section-content\"><md-chips class=\"label-chips\" ng-model=\"vm.card.idLabels\" md-autocomplete-snap=\"\" md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedLabel\" md-search-text=\"vm.searchLabelText\" md-items=\"label in vm.labelQuerySearch(vm.searchLabelText)\" md-item-text=\"label.name\" placeholder=\"Search for a label\"><span md-highlight-text=\"vm.searchLabelText\">{{label.name}}</span></md-autocomplete><md-chip-template class=\"label-chip\" ng-class=\"\'md-\'+vm.board.labels.getById($chip).color+\'-bg\'\"><span>{{vm.board.labels.getById($chip).name}}</span></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><div ng-if=\"vm.card.idMembers[0]\" flex=\"\" class=\"members\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span class=\"section-title\" translate=\"SB.MEMBERS\">Members</span></div><div class=\"section-content\"><md-chips class=\"member-chips\" ng-model=\"vm.card.idMembers\" md-autocomplete-snap=\"\" md-require-match=\"true\" md-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedMember\" md-search-text=\"vm.searchText\" md-items=\"member in vm.memberQuerySearch(vm.searchText)\" md-item-text=\"member.name\" placeholder=\"Search for a member\"><span md-highlight-text=\"vm.searchText\">{{member.name}}</span></md-autocomplete><md-chip-template class=\"member-chip\"><img class=\"member-chip-avatar\" ng-src=\"{{vm.board.members.getById($chip).avatar}}\"><md-tooltip>{{vm.board.members.getById($chip).name}}</md-tooltip></md-chip-template><button md-chip-remove=\"\" class=\"md-primary\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div></div><div ng-if=\"vm.card.attachments[0]\" class=\"section\"><div class=\"attachments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"section-title\" translate=\"SB.ATTACHMENTS\">Attachments</span></div><div class=\"section-content\"><div class=\"attachment\" ng-repeat=\"item in vm.card.attachments\" ng-switch=\"item.type\"><div ng-switch-when=\"image\" layout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" ng-style=\"{\'background-image\': \'url({{item.src}})\'}\"></div><div class=\"attachment-content\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span class=\"attachment-name\">{{item.name}}</span> <i ng-if=\"vm.card.idAttachmentCover === item.id\" class=\"icon-star yellow-700-fg attachment-is-cover s18\"></i></div><span class=\"attachment-time\">{{item.time}}</span><md-menu><md-button class=\"md-raised attachment-actions-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"attachment actions\"><span layout=\"row\" layout-align=\"center center\"><span translate=\"SB.ACTIONS\">Actions</span> <i class=\"icon-chevron-down s20\"></i></span></md-button><md-menu-content><md-menu-item><md-button ng-click=\"vm.toggleCoverImage(item.id)\" aria-label=\"Toggle Cover Image\" translate=\"\" translate-attr-aria-label=\"SB.TOGGLE_COVER_IMAGE\"><span ng-if=\"vm.card.idAttachmentCover !== item.id\" translate=\"\">Make Cover</span> <span ng-if=\"vm.card.idAttachmentCover === item.id\" translate=\"\">Remove Cover</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.removeAttachment(item)\" aria-label=\"Remove Attachment\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_ATTACHMENT\"><span translate=\"SB.REMOVE_ATTACHMENT\">Remove Attachment</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div ng-switch-when=\"link\" layout=\"row\"><div class=\"attachment-preview md-whiteframe-2dp\" layout=\"column\" layout-align=\"center center\"><span translate=\"SB.LINK\">LINK</span></div><div class=\"attachment-content\" layout=\"column\"><span class=\"attachment-url\">{{item.url}}</span> <span class=\"attachment-time\">{{item.time}}</span></div></div></div><md-button class=\"add-attachment-button\" aria-label=\"add attachment\"><div layout=\"row\" layout-align=\"start center\"><i class=\"icon-plus s20\"></i> <span translate=\"SB.ADD_AN_ATTACHMENT\">Add an attachment</span></div></md-button></div></div></div><div ng-if=\"vm.card.checklists\" class=\"section\" ng-repeat=\"checklist in vm.card.checklists\"><div class=\"checklist\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked s18\"></i> <span flex=\"\" class=\"section-title\" editable-text=\"checklist.name\">{{checklist.name}}</span><md-menu md-offset=\"0 48px\" class=\"options\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeChecklist(checklist)\" aria-label=\"Remove Checklist\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_CHECKLIST\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target=\"\"></md-icon><span translate=\"SB.REMOVE_CHECKLIST\">Remove Checklist</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"section-content\"><div class=\"checklist-progress\" layout=\"row\" layout-align=\"start center\"><span class=\"checklist-progress-value\">{{checklist.checkItemsChecked}} / {{checklist.checkItems.length}}</span><md-progress-linear class=\"md-accent checklist-progressbar\" md-mode=\"determinate\" value=\"{{100 * checklist.checkItemsChecked / checklist.checkItems.length}}\"></md-progress-linear></div><div class=\"check-items\"><div class=\"check-item\" ng-repeat=\"checkItem in checklist.checkItems\"><md-checkbox ng-model=\"checkItem.checked\" ng-change=\"vm.updateCheckedCount(checklist)\" aria-label=\"{{checkItem.name}}\">{{checkItem.name}}</md-checkbox></div></div><form name=\"newCheckItemForm\" class=\"new-check-item-form\" ng-submit=\"vm.addCheckItem(vm[checklist.id].newCheckItem, checklist);vm[checklist.id].newCheckItem = \'\'\" layout=\"row\" layout-align=\"space-between center\"><md-input-container flex=\"\"><label layout=\"row\" layout-align=\"center\"><i class=\"icon-plus s18\"></i> <span translate=\"SB.ADD_AN_ITEM\">Add an item</span></label> <input type=\"text\" autocomplete=\"off\" ng-model=\"vm[checklist.id].newCheckItem\" md-maxlength=\"150\"></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Add\" translate=\"\" translate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.ADD\">Add</span></md-button></form></div></div></div><div class=\"section\"><div class=\"comments\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"section-title\" translate=\"SB.COMMENTS\">Comments</span></div><div class=\"section-content\"><form name=\"cardCommentForm\" ng-submit=\"vm.addNewComment(vm.newCommentText); vm.newCommentText =\'\'\" class=\"comment new-comment\" layout=\"column\" layout-align=\"start end\" no-validate=\"\"><div layout-fill=\"\" layout=\"row\"><img class=\"comment-member-avatar\" src=\"assets/images/avatars/profile.jpg\"><md-input-container flex=\"\" md-no-float=\"\"><textarea ms-scroll=\"\" placeholder=\"Write a comment..\" ng-model=\"vm.newCommentText\" required=\"\" translate=\"\" translate-attr-placeholder=\"SB.WRITE_A_COMMENT\"></textarea></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" ng-disabled=\"cardCommentForm.$invalid || cardCommentForm.$pristine\" aria-label=\"Add\"><span translate=\"SB.ADD\">Add</span></md-button></form><div class=\"comment\" layout=\"row\" ng-repeat=\"comment in vm.card.comments\"><img class=\"comment-member-avatar\" ng-src=\"{{vm.board.members.getById(comment.idMember).avatar}}\"><div layout=\"column\"><div class=\"comment-member-name\">{{vm.board.members.getById(comment.idMember).name}}</div><div class=\"comment-bubble\">{{comment.message}}</div><div class=\"comment-time secondary-text\">{{comment.time}}</div></div></div></div></div></div><div ng-if=\"vm.card.activities[0]\" class=\"section\"><div class=\"activities\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-format-list-bulleted s18\"></i> <span class=\"section-title\" translate=\"SB.ACTIVITY\">Activity</span></div><div class=\"section-content\"><div class=\"activity\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"activity in vm.card.activities\"><img class=\"activity-member-avatar\" ng-src=\"{{vm.board.members.getById(activity.idMember).avatar}}\"><div class=\"activity-member-name\">{{vm.board.members.getById(activity.idMember).name}}</div><div class=\"activity-message\">{{activity.message}}</div><div class=\"activity-time secondary-text\">{{activity.time}}</div></div></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><span flex=\"\" class=\"menu-title\" translate=\"SB.FILTER_CARDS\">Filter Cards</span><md-button ng-if=\"vm.filteringIsOn()\" ng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"SB.CLEAR_FILTER\">Clear Filters</span></md-tooltip></md-button></div></md-toolbar><md-content class=\"\" ms-scroll=\"\"><md-list><md-subheader class=\"md-no-sticky\" translate=\"SB.FILTER_BY_CARD_NAME\">Filter by Card Name</md-subheader><md-list-item><input flex=\"\" placeholder=\"Type Card Name\" type=\"text\" ng-model=\"vm.cardFilters.name\" translate=\"\" translate-attr-placeholder=\"SB.TYPE_CARD_NAME\"></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\" translate=\"SB.FILTER_BY_LABELS\">Filter by Labels</md-subheader><md-list-item class=\"label\" ng-repeat=\"label in vm.labels\" ng-click=\"vm.toggleInArray(label.id, vm.cardFilters.labels)\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon><p>{{label.name}}</p><i class=\"icon-check s16\" ng-if=\"vm.exists(label.id, vm.cardFilters.labels)\"></i></md-list-item><md-divider></md-divider><md-subheader class=\"md-no-sticky\" translate=\"SB.FILTER_BY_MEMBERS\">Filter by Members</md-subheader><md-list-item class=\"member\" ng-repeat=\"member in vm.members\" ng-click=\"vm.toggleInArray(member.id, vm.cardFilters.members)\" aria-label=\"Toggle Member\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p class=\"member-name\">{{ member.name }}</p><i class=\"icon-check s16\" ng-if=\"vm.exists(member.id, vm.cardFilters.members)\"></i></md-list-item></md-list></md-content>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button ng-hide=\"vm.selectedMenu === \'Settings\'\" class=\"md-icon-button\" ng-click=\"vm.selectedMenu = \'Settings\'\" aria-label=\"back\" translate=\"\" translate-attr-aria-label=\"SB.BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><span flex=\"\" class=\"menu-title\">{{vm.selectedMenu}}</span></div></md-toolbar><md-content ng-show=\"vm.selectedMenu === \'Settings\'\" class=\"animate-slide-right settings\" ms-scroll=\"\" ms-sidenav-helper=\"\"><md-list><md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Board Color\'\"><md-icon md-font-icon=\"icon-format-color-fill\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.BOARD_COLOR\">Board Color</p></md-list-item><md-list-item class=\"item\" ng-click=\"vm.board.settings.cardCoverImages = !vm.board.settings.cardCoverImages\"><md-icon md-font-icon=\"icon-image-area\" class=\"s18\"></md-icon><p flex=\"\" class=\"title\" translate=\"SB.CARD_COVER_IMAGES\">Card Cover Images</p><md-icon ng-show=\"vm.board.settings.cardCoverImages\" md-font-icon=\"icon-check\" class=\"s18\"></md-icon></md-list-item><md-list-item class=\"item\" ng-click=\"vm.board.settings.subscribed = !vm.board.settings.subscribed\"><md-icon md-font-icon=\"icon-eye\" class=\"s18\"></md-icon><p flex=\"\" class=\"title\" translate=\"SB.SUBSCRIBE\">Subscribe</p><md-icon ng-show=\"vm.board.settings.subscribed\" md-font-icon=\"icon-check\" class=\"s18\"></md-icon></md-list-item><md-list-item class=\"item\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.COPY_BOARD\">Copy Board</p></md-list-item><md-list-item class=\"item\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.DELETE_BOARD\">Delete Board</p></md-list-item><md-divider></md-divider><md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Labels\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-label\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.LABELS\">Labels</p></md-list-item><md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Members\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.MEMBERS\">Members</p></md-list-item></md-list></md-content><md-content ng-show=\"vm.selectedMenu === \'Board Color\'\" class=\"animate-slide-left board-color-selection\"><div layout=\"column\" layout-fill=\"\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/color/color-menu.html\'\" ng-controller=\"ColorMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Labels\'\" class=\"animate-slide-left labels\"><div layout=\"column\" layout-fill=\"\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/labels/labels-menu.html\'\" ng-controller=\"LabelsMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Members\'\" class=\"animate-slide-left members\"><div layout=\"column\" layout-fill=\"\" ng-include=\"\'app/main/apps/scrumboard/sidenavs/settings/menus/members/members-menu.html\'\" ng-controller=\"MembersMenuController as vm\"></div></md-content>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/views/board/board-view.html","<div id=\"board\" ng-class=\"vm.board.settings.color+\'-100-bg\'\" ui-sortable=\"vm.sortableListOptions\" ng-model=\"vm.board.lists\" layout=\"row\"><div class=\"list-wrapper\" ng-repeat=\"list in vm.board.lists track by list.id\"><div class=\"list md-whiteframe-1dp\" layout=\"column\"><div class=\"list-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span editable-text=\"list.name\">{{list.name}}</span></div><md-menu md-offset=\"0 48px\" class=\"options list-header-option-button\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Options\" translate=\"\" translate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin=\"\" md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" width=\"4\"><md-menu-item><md-button ng-click=\"vm.removeList($event,list)\" aria-label=\"Remove List\" translate=\"\" translate-attr-aria-label=\"SB.REMOVE_LIST\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target=\"\"></md-icon><span translate=\"SB.REMOVE_LIST\">Remove List</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"list-content\" ms-scroll=\"\"><div class=\"list-cards\" ui-sortable=\"vm.sortableCardOptions\" ng-model=\"list.idCards\"><div ng-if=\"cardId\" class=\"list-card md-whiteframe-3dp\" ng-repeat=\"cardId in list.idCards | filter: vm.cardFilter track by $index\" ng-click=\"vm.openCardDialog($event, cardId)\"><div ng-if=\"vm.board.settings.cardCoverImages && vm.board.cards.getById(cardId).idAttachmentCover\" class=\"list-card-cover\"><img ng-src=\"{{vm.board.cards.getById(cardId).attachments.getById(vm.board.cards.getById(cardId).idAttachmentCover).src}}\"></div><div class=\"list-card-details\"><div class=\"list-card-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" class=\"icon s16\"></md-icon></div><div ng-if=\"vm.board.cards.getById(cardId).idLabels.length > 0\" class=\"list-card-labels\" layout=\"row\" layout-wrap=\"\"><span class=\"list-card-label\" ng-class=\"\'md-\'+vm.board.labels.getById(labelId).color+\'-bg\'\" ng-repeat=\"labelId in vm.board.cards.getById(cardId).idLabels\"><md-tooltip>{{vm.board.labels.getById(labelId).name}}</md-tooltip></span></div><div class=\"list-card-name\">{{vm.board.cards.getById(cardId).name}}</div><div ng-if=\"vm.board.cards.getById(cardId).due || vm.board.cards.getById(cardId).checkItems\" class=\"list-card-badges\" layout=\"row\" layout-align=\"start center\"><span class=\"badge due-date\" ng-class=\"{\'overdue\': vm.isOverdue(vm.board.cards.getById(cardId).due)}\" ng-if=\"vm.board.cards.getById(cardId).due\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-clock s16\"></i> <span>{{vm.board.cards.getById(cardId).due | date}}</span></span><span ng-if=\"vm.board.cards.getById(cardId).checkItems\" class=\"badge check-items\" ng-class=\"{\'completed\': vm.board.cards.getById(cardId).checkItemsChecked === vm.board.cards.getById(cardId).checkItems}\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked-circle s16\"></i> <span>{{vm.board.cards.getById(cardId).checkItemsChecked}}</span> <span>/</span> <span>{{vm.board.cards.getById(cardId).checkItems}}</span></span></div><div ng-if=\"vm.board.cards.getById(cardId).idMembers.length > 0\" class=\"list-card-members\" layout=\"row\"><div class=\"list-card-member\" ng-repeat=\"memberId in vm.board.cards.getById(cardId).idMembers\"><img class=\"list-card-member-avatar\" ng-src=\"{{vm.board.members.getById(memberId).avatar}}\"><md-tooltip><div class=\"name\">{{ vm.board.members.getById(memberId).name}}</div></md-tooltip></div></div></div><div class=\"list-card-footer\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span ng-if=\"vm.board.cards.getById(cardId).subscribed\" class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-eye s18\"></i></span><span ng-if=\"vm.board.cards.getById(cardId).description !== \'\'\" class=\"list-card-footer-item\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-document s18\"></i></span></div><div layout=\"row\" layout-align=\"end center\"><span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).attachments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">{{vm.board.cards.getById(cardId).attachments.length}}</span></span><span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).comments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\"></i> <span class=\"value\">{{vm.board.cards.getById(cardId).comments.length}}</span></span></div></div></div></div></div><div class=\"list-footer list-add-card\" ms-sb-add-card=\"\" ms-list-id=\"list.id\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\"><div><i class=\"icon-plus s20\"></i></div><span transalte=\"SB.ADD_A_CART\">Add a card</span></div></div></div><div class=\"new-list-wrapper\"><div class=\"list new-list md-whiteframe-1dp\"><span editable-text=\"vm.newListName\" e-form=\"newListForm\" onaftersave=\"vm.addNewList()\"></span><md-button class=\"new-list-form-button\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><div layout=\"row\" layout-align=\"start center\"><i class=\"icon-plus md-red-bg\"></i> <span translate=\"SB.ADD_A_LIST\">Add a list</span></div></md-button></div></div></div>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/views/calendar/calendar-view.html","<div id=\"board-calendar\" class=\"page-layout simple right-sidenav\" flex=\"\" layout=\"row\" ng-class=\"vm.board.settings.color+\'-100-bg\'\"><md-sidenav class=\"sidenav scheduled-tasks-sidenav md-sidenav-left\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"scheduled-tasks-sidenav\" ng-include=\"\'app/main/apps/scrumboard/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div id=\"calendar\" class=\"md-whiteframe-2dp\" flex=\"\" layout=\"column\" ng-class=\"vm.currentMonthShort\"><div class=\"calendar-header\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><md-button hide-gt-md=\"\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'scheduled-tasks-sidenav\')\" aria-label=\"Scheduled Cards Sidenav\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><md-tooltip><span translate=\"SB.SCHEDULED_CARDS\">Scheduled Cards</span></md-tooltip></md-button><div class=\"\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" aria-label=\"Previous\" translate=\"\" translate-attr-aria-label=\"SB.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate=\"\" translate-attr-aria-label=\"SB.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate=\"\" translate-attr-aria-label=\"SB.TODAY\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"SB.TODAY\">Today</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate=\"\" translate-attr-aria-label=\"SB.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"SB.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate=\"\" translate-attr-aria-label=\"SB.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"SB.WEEK\">Week</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate=\"\" translate-attr-aria-label=\"SB.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"SB.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"calendar-main\" ms-scroll=\"\" flex=\"\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.eventSources\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/views/boards/boards-view.html","<div id=\"boards\" class=\"md-accent-bg\" layout=\"column\" flex=\"\"><div id=\"board-selector\" layout=\"column\" layout-align=\"start center\" flex=\"\"><h1 translate=\"SB.SCRUMBOARD_APP\">Scrumboard App</h1><div class=\"board-list\" layout=\"row\" layout-align=\"center center\" layout-wrap=\"\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" ui-sref=\"app.scrumboard.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"center center\"><md-icon md-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div class=\"board-name\">{{board.name}}</div></div><div class=\"board-list-item add-new-board\" layout=\"column\" layout-align=\"center center\" ui-sref=\"app.scrumboard.boards.addBoard\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"icon s64\"></md-icon><div class=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">Add new board</div></div></div></div></div>");
$templateCache.put("app/main/apps/todo_DESHABILITADO/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate=\"\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label translate=\"TODO.TITLE\">Title</label> <input name=\"title\" ng-model=\"vm.task.title\" required=\"\"><div ng-messages=\"taskForm.title.$error\" ng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><div class=\"tags\"><label translate=\"TODO.TAGS\">Tags</label><md-chips ng-model=\"vm.task.tags\" md-transform-chip=\"vm.newTag($chip)\"><md-chip-template><span ng-if=\"$chip.color\" class=\"color\" ng-style=\"{\'background-color\':$chip.color}\"></span> <span>{{$chip.label}}</span></md-chip-template></md-chips></div><div layout-sm=\"column\" layout=\"row\"><div flex=\"\" class=\"date-container\"><label translate=\"TODO.START_DATE\">Start Date</label><md-datepicker flex=\"\" ng-model=\"vm.task.startDate\" md-placeholder=\"Start Date\"></md-datepicker></div><div flex=\"\" class=\"date-container\"><label translate=\"TODO.DUE_DATE\">Due Date</label><md-datepicker flex=\"\" ng-model=\"vm.task.dueDate\" md-placeholder=\"Due Date\"></md-datepicker></div></div><div class=\"notes\"><label translate=\"TODO.NOTES\">Notes</label><text-angular ng-model=\"vm.task.notes\"></text-angular></div><div class=\"attachment-list\"><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-2.doc</span> <span class=\"size\">(12 Kb)</span></div><md-button class=\"md-icon-button\"><md-icon md-font-icon=\"icon-close\" aria-label=\"delete attachment\" class=\"s16\"></md-icon></md-button></div><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-1.jpg</span> <span class=\"size\">(350 Kb)</span></div><md-button class=\"md-icon-button\" aria-label=\"Delete attachment\" translate=\"\" translate-attr-aria-label=\"TODO.DELETE_ATTACHMENT\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newTask\" ng-click=\"vm.saveTask()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"SAVE\" translate=\"TODO.SAVE\" translate-attr-aria-label=\"TODO.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newTask\" ng-click=\"vm.addNewTask()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"TODO.ADD_TASK\" translate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button><md-button class=\"md-icon-button\" aria-label=\"Attach file\" translate=\"\" translate-attr-aria-label=\"TODO.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Insert picture\" translate=\"\" translate-attr-aria-label=\"TODO.INSERT_PICTURE\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon></md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteTask($event)\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/todo_DESHABILITADO/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"s24\"></md-icon></span> <span class=\"logo-text\" translate=\"TODO.TO_DO\">To-Do</span></div><md-select class=\"project-selection simplified\" ng-model=\"vm.selectedProject\" placeholder=\"Select Project\"><md-option ng-repeat=\"(project, title) in vm.projects\" value=\"{{project}}\">{{title}}</md-option></md-select></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"add-task-button\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.openTaskDialog($event)\" aria-label=\"ADD TASK\" translate=\"TODO.ADD_TASK\" translate-attr-aria-label=\"TODO.ADD_TASK\">ADD TASK</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"All Tasks\" translate=\"\" translate-attr-aria-label=\"TODO.ALL_TASKS\" ng-class=\"{\'selected\':vm.showAllTasks}\" ng-click=\"vm.resetFilters()\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-view-headline\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.ALL_TASKS\">All Tasks</span></div></md-button><div class=\"item subheader\" translate=\"TODO.FILTERS\">Filters</div><md-button class=\"item\" aria-label=\"Starred\" translate=\"\" translate-attr-aria-label=\"TODO.STARRED\" ng-click=\"vm.toggleFilterWithEmpty(\'starred\')\" ng-class=\"{\'selected\':vm.taskFilters.starred}\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.STARRED\">Starred</span></md-button><md-button class=\"item\" aria-label=\"Priority\" translate=\"\" translate-attr-aria-label=\"TODO.PRIORITY\" ng-click=\"vm.toggleFilterWithEmpty(\'important\')\" ng-class=\"{\'selected\':vm.taskFilters.important}\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.PRIORITY\">Priority</span></md-button><md-button class=\"item\" aria-label=\"Scheduled\" translate=\"\" translate-attr-aria-label=\"TODO.SCHEDULED\" ng-click=\"vm.toggleFilterWithEmpty(\'dueDate\')\" ng-class=\"{\'selected\':vm.taskFilters.dueDate}\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.SCHEDULED\">Scheduled</span></md-button><md-button class=\"item\" aria-label=\"Today\" translate=\"\" translate-attr-aria-label=\"TODO.TODAY\" ng-click=\"vm.toggleFilterWithEmpty(\'startDate\')\" ng-class=\"{\'selected\':vm.taskFilters.startDate}\"><md-icon md-font-icon=\"icon-calendar-today\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.TODAY\">Today</span></md-button><md-button class=\"item\" aria-label=\"Done\" translate=\"\" translate-attr-aria-label=\"TODO.DONE\" ng-click=\"vm.toggleFilterWithEmpty(\'completed\')\" ng-class=\"{\'selected\':vm.taskFilters.completed}\"><md-icon md-font-icon=\"icon-check\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DONE\">Done</span></md-button><md-button class=\"item\" aria-label=\"Deleted\" translate=\"\" translate-attr-aria-label=\"TODO.DELETED\" ng-click=\"vm.toggleFilter(\'deleted\')\" ng-class=\"{\'selected\':vm.taskFilters.deleted}\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon><span class=\"title\" translate=\"TODO.DELETED\">Deleted</span></md-button><div class=\"item subheader\" translate=\"TODO.TAGS\">Tags</div><md-button class=\"tag item\" aria-label=\"tag {{tag.label}}\" ng-repeat=\"tag in vm.tags\" ng-click=\"vm.toggleTagFilter(tag)\" ng-class=\"{\'selected\':vm.isTagFilterExists(tag)}\"><md-icon md-font-icon=\"icon-label\" class=\"s16\" ng-style=\"{\'color\' : tag.color}\"></md-icon><span class=\"title\">{{tag.label}}</span></md-button></div></md-content>");
$templateCache.put("app/main/apps/todo_DESHABILITADO/views/list/list-view.html","<div class=\"todo-items\" ng-sortable=\"vm.sortableOptions\" ng-model=\"vm.tasks\" ng-class=\"{\'sortable\': vm.taskOrder === \'\'}\"><div class=\"todo-item\" md-ink-ripple=\"\" layout=\"row\" layout-align=\"start center\" ng-click=\"vm.openTaskDialog($event, task)\" ng-repeat=\"task in vm.tasks | orderBy:vm.taskOrder:vm.taskOrderDescending | filter:global.search | filter:vm.taskFilters.search | filterByTags:vm.taskFilters.tags | filter:{\'completed\': vm.taskFilters.completed} | filter:{\'deleted\': vm.taskFilters.deleted} | filter:{\'important\': vm.taskFilters.important} | filter:{\'starred\':vm.taskFilters.starred} | filter:vm.filterByStartDate | filter:vm.filterByDueDate track by $index\" ng-class=\"{\'starred\': task.starred, \'selected\': task.selected, \'completed\': task.completed}\"><div class=\"handle\" ng-click=\"vm.preventDefault($event)\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><md-checkbox class=\"no-label\" ng-checked=\"task.completed\" ng-click=\"vm.toggleCompleted(task, $event)\" aria-label=\"{{task.completed ? \'Not completed\' : \'Completed\'}}\"></md-checkbox><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div class=\"info\" flex=\"\"><div class=\"title\">{{task.title}}</div><div class=\"notes\">{{task.notes}}</div><div class=\"tags\" layout=\"row\" layout-align=\"start center\"><div class=\"tag\" layout=\"row\" layout-align=\"start center\" data-ng-repeat=\"tag in task.tags\"><div class=\"tag-color\" ng-style=\"{\'background-color\': tag.color}\"></div><div class=\"tag-label\">{{tag.label}}</div></div></div></div><div class=\"buttons\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"is-important red-600-fg\" ng-if=\"task.important\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"is-starred amber-600-fg\" ng-if=\"task.starred\"></md-icon><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"TODO.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"task.completed = !task.completed\" aria-label=\"Toggle done\" translate-attr-aria-label=\"TODO.TOGGLE_DONE\"><md-icon ng-class=\"task.completed === false ? \'grey-fg\' : \'blue-fg\'\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"s18\"></md-icon><span ng-show=\"!task.completed\" translate=\"TODO.MARK_AS_DONE\">Mark as done</span> <span ng-show=\"task.completed\" translate=\"TODO.MARK_AS_UNDONE\">Mark as undone</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"task.important = !task.important\" aria-label=\"Toggle important\" translate-attr-aria-label=\"TODO.TOGGLE_IMPORTANT\"><md-icon ng-class=\"task.important === false ? \'grey-fg\' : \'red-600-fg\'\" md-font-icon=\"icon-alert-circle\" class=\"s18\"></md-icon><span ng-show=\"!task.important\" translate=\"TODO.MARK_AS_IMPORTANT\">Mark as important</span> <span ng-show=\"task.important\" translate=\"TODO.REMOVE_IMPORTANT\">Remove important</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"task.starred = !task.starred\" aria-label=\"Toggle star\" translate-attr-aria-label=\"TODO.TOGGLE_STAR\"><md-icon ng-class=\"task.starred === false ? \'grey-fg\' : \'amber-600-fg\'\" md-font-icon=\"icon-star\" class=\"s18\"></md-icon><span ng-show=\"!task.starred\" translate=\"TODO.ADD_STAR\">Add star</span> <span ng-show=\"task.starred\" translate=\"TODO.REMOVE_STAR\">Remove star</span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/bcf-docs/bcf-docs.html","<div id=\"bcf-docs\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/workflow-bidder/completion-bcf/bcf-docs/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/workflow-bidder/completion-bcf/bcf-docs/views/detail/detail-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/pending-bcf/pending-bcf.html","<div id=\"pending-bcf\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/workflow-bidder/completion-bcf/pending-bcf/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/workflow-bidder/completion-bcf/pending-bcf/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/workflow-bidder/completion-bcf/pending-bcf/views/detail/detail-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/add-vessel/add-vessel.html","<div id=\"add-vessel\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/add-vessel/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/add-vessel/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/add-vessel/views/detail/detail-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/finish-upload/finish-upload.html","<div id=\"finish-upload\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/finish-upload/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/finish-upload/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/finish-upload/views/detail/detail-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/other-docs/other-docs.html","<div id=\"other-docs\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/other-docs/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/other-docs/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/other-docs/views/detail/detail-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-commercial-docs/required-commercial-docs.html","<div id=\"required-commercial-docs\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/required-commercial-docs/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/required-commercial-docs/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/required-commercial-docs/views/detail/detail-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-general-docs/required-general-docs.html","<div id=\"required-general-docs\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/required-general-docs/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/required-general-docs/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/required-general-docs/views/detail/detail-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-technical-docs/required-technical-docs.html","<div id=\"required-technical-docs\" class=\"page-layout simple right-sidenav\" layout=\"row\"><md-sidenav class=\"main-sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/required-technical-docs/sidenavs/main/main-sidenav.html\'\" ms-scroll=\"\" ms-sidenav-helper=\"\"></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><md-content class=\"content\" layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.currentView === \'list\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/required-technical-docs/views/list/list-view.html\'\"></div><div ng-if=\"vm.currentView === \'detail\'\" ng-include=\"\'app/main/apps/workflow-bidder/submission-bid/required-technical-docs/views/detail/detail-view.html\'\"></div></md-content></div></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/button.html","<div class=\"doc-content theming\"><h1 id=\"-lt-md-button-gt-\">&lt;md-button&gt;</h1><p>Below is a snapshot of the Angular Material <strong>button</strong> component demos with the default themes and standard options:</p><p><img src=\"https://cloud.githubusercontent.com/assets/210413/7947020/fafde934-093f-11e5-9584-27eb2deedd0f.png\" alt=\"buttonsdemo\"></p><p><br></p><h3 id=\"css-styles\">CSS Styles</h3><p>The base CSS class for all <code>&lt;md-button&gt;</code> components is <code>.md-button</code>:</p><hljs lang=\"css\">.md-button { padding: 0 6px 0 6px; margin: 6px 8px 6px 8px; min-width: 88px; border-radius: 3px; font-size: 14px; text-align: center; text-transform: uppercase; text-decoration:none; border: none; outline: none; }</hljs><p>When defining custom CSS overrides, developers should create their own CSS class. For example, to define a <code>.btn1</code> override to <strong>md-button</strong> use:</p><hljs lang=\"css\">.btn1 { // your custom overrides here }</hljs><hljs lang=\"html\"><md-button class=\"btn1\" ng-click=\"acceptOffer();\">Accept</md-button></hljs><p><br></p><h3 id=\"theme-requirements\">Theme Requirements</h3><p>All Angular Material components have specific CSS rules constructed using the theme name and theme-class overrides. For the <strong>Default</strong> theme, however, these rules are added to the components styles using the <code>.md-default-theme</code> class. If, however, you have configured a custom theme called <code>companyX</code> that is <strong>NOT</strong> the default theme, then any CSS overrides <strong>must</strong> use fully-specified classname. For <code>&lt;md-button&gt;</code> the <strong>fully-specified classname</strong> will be <code>.md-button.md-companyX-theme.btn1</code>.</p><hljs lang=\"css\">.md-button.md-companyX-theme.btn1 { } .md-button.md-companyX-theme.md-primary.btn1 { } .md-button.md-companyX-theme.md-accent.btn1 { } .md-button.md-companyX-theme.md-warn.btn1 { }</hljs><p><br></p><h2 id=\"flat-buttons\">Flat Buttons</h2><p><img src=\"https://cloud.githubusercontent.com/assets/210413/7945984/bda14884-0939-11e5-9196-131ded20ca77.png\" alt=\"mdbuttonflatdefault3\"></p><hljs lang=\"html\"><md-button>Button</md-button></hljs><hljs lang=\"css\">.md-button { color : currentColor; } .md-button:not([disabled]):hover { background-color: rgba(158, 158, 158, 0.2); } .md-button[disabled] { color : rgba(0, 0, 0, 0.26); background-color: transparent; }</hljs><p><br></p><h4 id=\"custom-css-overrides\">Custom CSS Overrides</h4><p><img src=\"https://cloud.githubusercontent.com/assets/210413/7945987/c1b1c700-0939-11e5-879c-ba804ca03267.png\" alt=\"mdbuttonflatdefault_overrides2\"></p><hljs lang=\"html\"><md-button class=\"btn1\">Button</md-button></hljs><hljs lang=\"css\">.btn1 { color : rgb(49, 46, 46); background-color: rgba(255, 222, 121, 0.96); border-radius: 10px 0 0 10px; font-size: 16px; } .btn1:not([disabled]):hover { background-color: rgba(107, 103, 91, 0.96); color: white; } .btn1[disabled] { color : rgb(187, 187, 187); background-color: rgba(230, 230, 229, 0.96); }</hljs><p><br></p><h2 id=\"raised-buttons\">Raised Buttons</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7254163/fe898728-e849-11e4-943b-a9cd88ec9573.PNG\" alt=\"raisedbutton\"></p><p>Add the <code>.md-raised</code> class to create a raised button:</p><hljs lang=\"html\"><md-button class=\"md-raised\">Button</md-button></hljs><hljs lang=\"css\">.md-button.md-raised:not([disabled]) { box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26); }</hljs><p><br></p><h2 id=\"cornered-buttons\">Cornered buttons</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7254379/682592ac-e84b-11e4-8d33-78314cea8bda.PNG\" alt=\"corneredbutton\"></p><p>Add the <code>.md-cornered</code> class to create a button with corners:</p><hljs lang=\"html\"><md-button class=\"md-raised md-cornered\">Button</md-button></hljs><hljs lang=\"css\">.md-button.md-cornered { border-radius: 0; }</hljs><p><br></p><h2 id=\"default-fab-button\">Default FAB Button</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7254736/8fec7ee8-e84d-11e4-9cf9-58ea9221c3c2.PNG\" alt=\"floatingbutton\"></p><p>Add the <code>.md-fab</code> class in order to create a floating action button (aka FAB):</p><hljs lang=\"html\"><md-button class=\"md-fab\" aria-label=\"Eat cake\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/cake.svg\"></md-icon></md-button></hljs><hljs lang=\"css\">.md-button.md-fab { line-height: 5.6rem; min-width: 0; width: 5.6rem; height: 5.6rem; border-radius: 50%; }</hljs><p><br></p><h2 id=\"mini-fab-button\">Mini FAB Button</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7273617/1fcca280-e8fe-11e4-9588-231a9e860be1.PNG\" alt=\"minibutton\"></p><p>Add the <code>.md-mini</code> class in order to create small, mini-FAB buttons:</p><hljs lang=\"html\"><md-button class=\"md-fab md-mini\" aria-label=\"Eat cake\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/cake.svg\"></md-icon></md-button></hljs><hljs lang=\"css\">.md-button.md-fab.md-mini { line-height: 4rem; width: 4rem; height: 4rem; }</hljs><p><br></p><h2 id=\"icon-button-using-svgs\">Icon button using SVGs</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7273908/d701bd8a-e900-11e4-84c7-44c580c7372d.PNG\" alt=\"iconbutton\"></p><p>Create icon buttons by adding the <code>.md-icon-button</code> class and the <code>&lt;md-icon ...&gt;</code> component:</p><hljs lang=\"html\"><md-button class=\"md-icon-button md-primary\" aria-label=\"Settings\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/menu.svg\"></md-icon></md-button></hljs><hljs lang=\"css\">.md-button.md-icon-button { margin: 0 0.6rem; height: 4.8rem; min-width: 0; line-height: 4.8rem; padding-left: 0; padding-right: 0; width: 4.8rem; }</hljs><p><br></p><h2 id=\"icon-button-using-font-icons\">Icon button using Font-icons</h2><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/7670414/f57721ba-fcab-11e4-9a22-67970063797c.PNG\" alt=\"fonticonbutton\"></p><p>Here is another example of a button with font icons:</p><hljs lang=\"html\"><md-button><md-icon md-font-icon=\"icon-home\" ng-style=\"{color: \'green\', \'font-size\':\'36px\', height:\'36px\'}\"></md-icon></md-button></hljs><p><br></p><h2 id=\"grouping-with-css-overrides\">Grouping with CSS Overrides</h2><p><img src=\"https://cloud.githubusercontent.com/assets/210413/7961138/1b48bb16-09cb-11e5-9283-bdda28b8bb66.png\" alt=\"mdbuttongroup\"></p><p>Using the customization approaches documented above, we can easily create a mdButtonGroup:</p><hljs lang=\"html\"><section layout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><md-button class=\"groupX left\">Apple</md-button><md-button class=\"groupX middle\">Samsung</md-button><md-button class=\"groupX middle\">Sony</md-button><md-button class=\"groupX right\">B&amp;O</md-button></section></hljs><hljs lang=\"css\">.groupX { font-size: 16px; margin: 20px 0; padding: 3px 15px 3px 15px; color: rgb(49, 46, 46); background-color: rgba(224, 224, 224, 0.96); text-transform: none; font-weight: 400; min-width:100px; } .md-button.left { border-radius: 10px 0 0 10px; } .md-button.middle { border-radius: 0; border-left: 1px solid rgba(230, 230, 230, 0.96); border-right: 1px solid rgba(230, 230, 230, 0.96); } .md-button.right { border-radius: 0 10px 10px 0; } .md-button:not([disabled]):hover { background-color: rgba(193, 193, 193, 0.96); color: rgba(44, 65, 164, 0.96); transition: 0.3s; }</hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/checkbox.html","<div class=\"doc-content theming\"><h2>CSS Styles</h2><p>The css decalaration of the <code>&lt;md-checkbox&gt;</code> component is:</p><hljs lang=\"css\">md-checkbox { margin: 8px; cursor: pointer; padding-left: 18px; padding-right: 0; line-height: 26px; min-width: 18px; min-height: 18px; }</hljs><p><br></p><h3>Ink color</h3><p>In order to change the color when the checkbox is checked:</p><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/8035909/b2130da0-0dfc-11e5-932f-4424d3b46d5b.PNG\" alt=\"greencheckbox\"></p><hljs lang=\"html\"><md-checkbox class=\"green\">Green Checkbox</md-checkbox></hljs><hljs lang=\"css\">md-checkbox.md-checked.green .md-icon { background-color: rgba(0, 255, 0, 0.87); }</hljs><p><br></p><h3>Disabled</h3><p>In order to change the color when a disabled checkbox is checked:</p><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/8036177/dc941a86-0dfe-11e5-8892-ac19ec6926fe.PNG\" alt=\"checkboxdisabledred\"><br></p><hljs lang=\"html\"><md-checkbox ng-disabled=\"true\" class=\"red\" ng-model=\"data.cb4\" ng-init=\"data.cb4=true\">Checkbox: Disabled, Checked</md-checkbox></hljs><hljs lang=\"css\">md-checkbox.md-checked[disabled].red .md-icon { background-color: rgba(255, 0, 0, 0.26); }</hljs><p><br></p><h3>Borders</h3><p>In order to add a custom border do the following:</p><img src=\"https://cloud.githubusercontent.com/assets/1292882/8037214/388dd40c-0e05-11e5-82a7-4bfa2541e968.PNG\" alt=\"checkboxcustomborder\"><br><br><hljs lang=\"html\"><div><md-checkbox ng-model=\"data.cb2\" aria-label=\"Checkbox 2\" ng-true-value=\"\'yup\'\" ng-false-value=\"\'nope\'\">Default Border</md-checkbox></div><div><md-checkbox ng-model=\"data.cb2\" aria-label=\"Checkbox 2\" ng-true-value=\"\'yup\'\" class=\"dotted\" ng-false-value=\"\'nope\'\">Custom Border</md-checkbox></div></hljs><hljs lang=\"css\">md-checkbox.dotted .md-icon { border-width: 1px; border-style: dashed; }</hljs><br><h3>Bi-Di</h3><p>The mdCheckbox directive supports bi-directional specifiers in the <code>&lt;html dir=&quot;rtl&quot;&gt;</code> tag:</p><p><img src=\"https://cloud.githubusercontent.com/assets/1292882/8036091/fb40bcf6-0dfd-11e5-8319-25e68939d1a3.PNG\" alt=\"checkboxrtl\"></p></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/typography.html","<div class=\"doc-content theming\"><p>Angular Material provides typography CSS classes you can use to create visual consistency across your application.</p><p><a href=\"http://www.google.com/design/spec/style/typography.html\">Reference the Material Design specification for Typography.</a></p><section class=\"demo-container\"><md-toolbar class=\"demo-toolbar\"><div class=\"md-toolbar-tools\"><h3>Heading Styles</h3></div></md-toolbar><div class=\"md-whiteframe-z1 docs-list\"><p style=\"margin-top: 0;\">To preserve <a href=\"http://webaim.org/techniques/semanticstructure/\">semantic structures</a>, you should style the <code>&lt;h1&gt;</code> - <code>&lt;h6&gt;</code> heading tags with the styling classes shown below:</p><div layout=\"row\" class=\"docs-descriptions\"><h4 class=\"md-body-1\" flex=\"25\" id=\"headings-selectors\">Selectors</h4><h4 class=\"md-body-1\" id=\"headings-output\">Output</h4></div><md-divider></md-divider><ul><li layout=\"column\" layout-gt-md=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-display-4</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-4 docs-output\">Light 112px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-display-3</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-3 docs-output\">Regular 56px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-display-2</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-2 docs-output\">Regular 45px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-display-1</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-1 docs-output\">Regular 34px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-headline</code></span><h5 aria-describedby=\"headings-output\" class=\"md-headline docs-output\">Regular 24px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-title</code></span><h5 aria-describedby=\"headings-output\" class=\"md-title docs-output\">Medium 20px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-subhead</code></span><h5 aria-describedby=\"headings-output\" class=\"md-subhead docs-output\">Regular 16px</h5></li></ul><h4 class=\"md-title\">Example</h4><hljs lang=\"html\"><h1 class=\"md-display-3\">Headline</h1><h2 class=\"md-display-1\">Headline</h2><h3 class=\"md-headline\">Headline</h3></hljs><br><span class=\"md-body-1\">Note: Base font size is <code>10px</code> for easy rem units (1.2rem = 12px). Body font size is <code>14px</code>. sp = scalable pixels.</span></div></section><section class=\"demo-container\"><md-toolbar class=\"demo-toolbar\"><div class=\"md-toolbar-tools\"><h3>Body Copy</h3></div></md-toolbar><div class=\"md-whiteframe-z1 docs-list\"><div layout=\"row\" class=\"docs-descriptions\"><h4 class=\"md-body-1\" flex=\"25\" id=\"body-selectors\">Selectors</h4><h4 class=\"md-body-1\" id=\"body-output\">Output</h4></div><md-divider></md-divider><ul><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-body-1</code><br></span><p class=\"docs-output md-body-1\" aria-describedby=\"body-output\">Regular 14px</p></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>\n          .md-body-2</code></span><p class=\"md-body-2 docs-output\" aria-describedby=\"body-output\">Medium 14px</p></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-button</code></span><div class=\"docs-output\" aria-describedby=\"body-output\"><md-button class=\"md-raised\" style=\"margin-left:0; margin-right:0;\">Medium 14px</md-button></div></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-caption</code><br></span><div class=\"docs-output\" aria-describedby=\"body-output\"><small class=\"md-caption\">Regular 12px</small></div></li></ul><h4 class=\"md-title\">Examples</h4><hljs lang=\"html\"><p class=\"md-body-2\">Body copy with medium weight.</p><md-button>Button</md-button><p class=\"md-body-1\">Regular body copy <small class=\"md-caption\">with small text</small>.</p><span class=\"md-caption\">Caption</span></hljs></div></section></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/01_introduction.html","<div class=\"doc-content theming\"><p>Material Design is a visual language with specifications for innovative user experiences (UX) and user interface (UI) elements. Themes convey meaning through color, tones, and contrasts, similar to how Layouts convey meaning through keylines and alignments.</p><p>Theme <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-palette\"><strong>color palettes</strong></a>, alphas, and shadows deliver a consistent tone to your application and a unified feel for all Angular Material UI components.</p><p>Theming allows changing the color of your Angular Material application. If you need more custom styling (such as layout changes including padding, margins, etc) you will need to either write CSS rules with custom selectors, or build a custom version of the <code>angular-material.css</code> file using SASS and custom variables.</p><p><img src=\"https://cloud.githubusercontent.com/assets/210413/4816236/bf7783dc-5edd-11e4-88ef-1f8b6e87e1d7.png\" alt=\"color palette\" style=\"max-width: 100%;\"></p><h2 id=\"theming-approach\">Theming Approach</h2><p>Angular Material makes it easy to design an app which follows the Material style guide&#39;s suggested design patterns:</p><blockquote><p>Limit your selection of colors by choosing three color hues from the primary palette and one accent color from the secondary palette. The accent color may or may not need fallback options.</p></blockquote><p>This concept is central to how Angular Material approaches theming.</p><h2 id=\"important-terms\">Important Terms</h2><h3 id=\"hues-shades\">Hues / Shades</h3><p>A hue/shade is a single color within a palette.</p><h3 id=\"palettes\">Palettes</h3><p>A palette is a collection of hues. By default, Angular Material ships with all palettes from the material design spec built in. Valid palettes include:</p><ul><li>red</li><li>pink</li><li>purple</li><li>deep-purple</li><li>indigo</li><li>blue</li><li>light-blue</li><li>cyan</li><li>teal</li><li>green</li><li>light-green</li><li>lime</li><li>yellow</li><li>amber</li><li>orange</li><li>deep-orange</li><li>brown</li><li>grey</li><li>blue-grey</li></ul><h3 id=\"color-intentions\">Color Intentions</h3><p>A color intention is a mapping of a palette for a given intention within your application.</p><p>Valid color intentions in Angular Material include:</p><ul><li><em>primary</em> - used to represent primary interface elements for a user</li><li><em>accent</em> - used to represent secondary interface elements for a user</li><li><em>warn</em> - used to represent interface elements that the user should be careful of</li></ul><h3 id=\"themes\">Themes</h3><p>A theme is a configuration of palettes used for specific color intentions. A theme also specifies a background color palette to be used for the application.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/02_declarative_syntax.html","<div class=\"doc-content theming\"><p>Theming in angular material uses classes to apply an intention group to a given component. Most components in Angular Material support intention classes as expected, including:</p><ul><li>md-button</li><li>md-checkbox</li><li>md-progress-circular</li><li>md-progress-linear</li><li>md-radio-button</li><li>md-slider</li><li>md-switch</li><li>md-tabs</li><li>md-text-float</li><li>md-toolbar</li></ul><h3 id=\"specifying-intention-group\">Specifying intention group</h3><p>The classes to apply the color intention for a given component are as follows: <code>md-primary</code>, <code>md-accent</code>, <code>md-warn</code>.</p><hljs lang=\"html\"><md-button class=\"md-primary\">Click me</md-button><md-button class=\"md-accent\">or maybe me</md-button><md-button class=\"md-warn\">Careful</md-button></hljs><h3 id=\"differentiating-within-an-intention-group-\">Differentiating within an intention group.</h3><p>If you need to slightly differentiate an element, you can specify an additional class of <code>md-hue-1</code>, <code>md-hue-2</code>, or <code>md-hue-3</code>. Use these classes sparingly in your application to avoid overwhelming users.</p><hljs lang=\"html\"><md-button class=\"md-primary\">Click me</md-button><md-button class=\"md-primary md-hue-1\">Click me</md-button><md-button class=\"md-primary md-hue-2\">Click me</md-button></hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/03_configuring_a_theme.html","<div class=\"doc-content theming\"><h2 id=\"configuring-a-theme\">Configuring a theme</h2><p>By default your Angular Material application will use the default theme, a theme that is pre-configured with the following palettes for intention groups:</p><ul><li><em>primary</em> - indigo</li><li><em>accent</em> - pink</li><li><em>warn</em> - red</li><li><em>background</em> - grey (note that white is in this palette)</li></ul><p>Configuring of the default theme is done by using the <code>$mdThemingProvider</code> during application configuration.</p><h3 id=\"configuring-color-intentions\">Configuring Color Intentions</h3><p>You can specify a color palette for a given color intention by calling the appropriate configuration method (<code>theme.primaryPalette</code>, <code>theme.accentPalette</code>, <code>theme.warnPalette</code>, <code>theme.backgroundPalette</code>).</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;pink&#39;) .accentPalette(&#39;orange&#39;); });</hljs><h3 id=\"specifying-dark-themes\">Specifying Dark Themes</h3><p>You can mark a theme as dark by calling <code>theme.dark()</code>.</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .dark(); });</hljs><h3 id=\"specifying-custom-hues-for-color-intentions\">Specifying Custom Hues For Color Intentions</h3><p>You can specify the hues from a palette that will be used by an intention group by default and for the <code>md-hue-1</code>, <code>md-hue-2</code>, <code>md-hue-3</code> classes.</p><p>By default, shades <code>500</code>, <code>300</code> <code>800</code> and <code>A100</code> are used for <code>primary</code> and <code>warn</code> intentions, while <code>A200</code>, <code>A100</code>, <code>A400</code> and <code>A700</code> are used for <code>accent</code>.</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;pink&#39;, { &#39;default&#39;: &#39;400&#39;, // by default use shade 400 from the pink palette for primary intentions &#39;hue-1&#39;: &#39;100&#39;, // use shade 100 for the <code>md-hue-1</code> class &#39;hue-2&#39;: &#39;600&#39;, // use shade 600 for the <code>md-hue-2</code> class &#39;hue-3&#39;: &#39;A100&#39; // use shade A100 for the <code>md-hue-3</code> class }) // If you specify less than all of the keys, it will inherit from the // default shades .accentPalette(&#39;purple&#39;, { &#39;default&#39;: &#39;200&#39; // use shade 200 for default, and keep all other shades the same }); });</hljs><h3 id=\"defining-custom-palettes\">Defining Custom Palettes</h3><p>As mentioned before, Angular Material ships with the Material Design Spec&#39;s color palettes built in. In the event that you need to define a custom color palette, you can use <code>$mdThemingProvider</code> to define it, thereby making it available to your theme for use in its intention groups. Note that you must specify all hues in the definition map.</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.definePalette(&#39;amazingPaletteName&#39;, { &#39;50&#39;: &#39;ffebee&#39;, &#39;100&#39;: &#39;ffcdd2&#39;, &#39;200&#39;: &#39;ef9a9a&#39;, &#39;300&#39;: &#39;e57373&#39;, &#39;400&#39;: &#39;ef5350&#39;, &#39;500&#39;: &#39;f44336&#39;, &#39;600&#39;: &#39;e53935&#39;, &#39;700&#39;: &#39;d32f2f&#39;, &#39;800&#39;: &#39;c62828&#39;, &#39;900&#39;: &#39;b71c1c&#39;, &#39;A100&#39;: &#39;ff8a80&#39;, &#39;A200&#39;: &#39;ff5252&#39;, &#39;A400&#39;: &#39;ff1744&#39;, &#39;A700&#39;: &#39;d50000&#39;, &#39;contrastDefaultColor&#39;: &#39;light&#39;, // whether, by default, text (contrast) // on this palette should be dark or light &#39;contrastDarkColors&#39;: [&#39;50&#39;, &#39;100&#39;, //hues which contrast should be &#39;dark&#39; by default &#39;200&#39;, &#39;300&#39;, &#39;400&#39;, &#39;A100&#39;], &#39;contrastLightColors&#39;: undefined // could also specify this if default was &#39;dark&#39; }); $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;amazingPaletteName&#39;) });</hljs><p>Sometimes it is easier to extend an existing color palette to overwrite a few colors than define a whole new one. You can use <code>$mdThemingProvider.extendPalette</code> to quickly extend an existing color palette.</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { // Extend the red theme with a few different colors var neonRedMap = $mdThemingProvider.extendPalette(&#39;red&#39;, { &#39;500&#39;: &#39;ff0000&#39; }); // Register the new color palette map with the name <code>neonRed</code> $mdThemingProvider.definePalette(&#39;neonRed&#39;, neonRedMap); // Use that theme for the primary intentions $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;neonRed&#39;) });</hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/04_multiple_themes.html","<div class=\"doc-content theming\"><p>In most applications, declaring multiple themes is <strong>not</strong> necessary. Instead, you should configure the <code>default</code> theme for your needs. If you need multiple themes in a single application, Angular Material does provide tools to make this possible.</p><h3 id=\"registering-another-theme\">Registering another theme</h3><p>Use the <code>$mdThemingProvider</code> to register a second theme within your application. By default all themes will inherit from the <code>default</code> theme. Once you have registered the second theme, you can configure it with the same chainable interface used on the default theme.</p><hljs lang=\"js\">angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;altTheme&#39;) .primaryPalette(&#39;purple&#39;) // specify primary color, all // other color intentions will be inherited // from default });</hljs><h3 id=\"using-another-theme\">Using another theme</h3><h4 id=\"via-the-provider\">Via the Provider</h4><p>You can change the default theme to be used across your entire application using the provider:</p><hljs lang=\"js\">$mdThemingProvider.setDefaultTheme(&#39;altTheme&#39;);</hljs><h4 id=\"via-a-directive\">Via a Directive</h4><p>Angular Material also exposes the <code>md-theme</code> directive which will set the theme on an element and all child elements.</p><p>In the following example, the application will use the <code>default</code> theme, while the second child <code>div</code> will use the <code>altTheme</code>. This allows you to theme different parts of your application differently.</p><hljs lang=\"html\"><div><md-button class=\"md-primary\">I will be blue (by default)</md-button><div md-theme=\"altTheme\"><md-button class=\"md-primary\">I will be purple (altTheme)</md-button></div></div></hljs><h4 id=\"dynamic-themes\">Dynamic Themes</h4><p>By default, to save on performance, theming directives will <strong>not</strong> watch <code>md-theme</code> for changes. If you need themes to be dynamically modified, you will need to use the <code>md-theme-watch</code> directive.</p><hljs lang=\"html\"><div><md-button ng-click=\"dynamicTheme = \'default\'\">Default</md-button><md-button ng-click=\"dynamicTheme = \'altTheme\'\">altTheme</md-button><div md-theme=\"{{ dynamicTheme }}\" md-theme-watch=\"\"><md-button class=\"md-primary\">I&#39;m dynamic</md-button></div></div></hljs><p>If you need this behavior in your entire application (ie. on all <code>md-theme</code> directives) you can use the <code>$mdThemingProvider</code> to enable it.</p><hljs lang=\"js\">$mdThemingProvider.alwaysWatchTheme(true);</hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/05_under_the_hood.html","<div class=\"doc-content theming\"><h3 id=\"under-the-hood\">Under the Hood</h3><p>Angular Material dynamically generates CSS for registered themes by injecting several <code>&lt;script&gt;</code> tags into the <code>&lt;head&gt;</code> section of the application at runtime. Here is how that process currently works:</p><ol><li><p>During the Angular Material build process, a function in <code>gulp/util.js</code> called <a href=\"https://github.com/angular/material/blob/master/gulp/util.js#L187\">themeBuildStream()</a> compiles all <code>*-theme.scss</code> files from components into a single CSS string that is injected into the <code>material.core</code> module as a constant called <code>$MD_THEME_CSS</code>.</p></li><li><p>At runtime, a function in <code>src/core/services/theming/theming.js</code> called <a href=\"https://github.com/angular/material/blob/master/src/core/services/theming/theming.js#L450\">generateThemes()</a> parses <code>$MD_THEME_CSS</code> to generate the <code>&lt;style&gt;</code> tags that are added to the <code>&lt;head&gt;</code> section of the application. A closure variable called <code>GENERATED</code> is used to keep track of the themes that have had their CSS generated.</p></li><li><p>For each of the four (4) palettes (e.g. <code>primary</code>, <code>accent</code>, <code>warn</code> and <code>background</code>) <em>in each registered theme</em> (including the default theme), there are four (4) <code>&lt;style&gt;</code> tags added to the <code>&lt;head&gt;</code> section (e.g. <code>.md-primary</code>, <code>.md-primary.md-hue-1</code>, <code>.md-primary.md-hue-2</code>, <code>.md-primary.md-hue-3</code>). Each registered theme results in 16 <code>&lt;style&gt;</code> tags being generated.</p></li></ol></div>");
$templateCache.put("app/main/pages/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap=\"\"><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.GENDER\">Gender</div><div class=\"info\">{{vm.about.general.gender}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.BIRTHDAY\">Birthday</div><div class=\"info\">{{vm.about.general.birthday}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LOCATIONS\">Locations</div><div class=\"info location\" ng-repeat=\"location in vm.about.general.locations\"><span>{{location}}</span><md-icon md-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon></div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.ABOUT_ME\">About Me</div><div class=\"info\">{{vm.about.general.about}}</div></div></div></div><div class=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.WORK\">Work</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.OCCUPATION\">Occupation</div><div class=\"info\">{{vm.about.work.occupation}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKILLS\">Skills</div><div class=\"info\">{{vm.about.work.skills}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.JOBS\">Jobs</div><table class=\"info jobs\"><tr class=\"job\" ng-repeat=\"job in vm.about.work.jobs\"><td class=\"company\">{{job.company}}</td><td class=\"date\">{{job.date}}</td></tr></table></div></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.CONTACT\">Contact</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">{{vm.about.contact.address}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TEL\">Tel.</div><div class=\"info\" ng-repeat=\"tel in vm.about.contact.tel\"><span>{{tel}}</span></div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.WEBSITE\">Website</div><div class=\"info\" ng-repeat=\"website in vm.about.contact.websites\"><span>{{website}}</span></div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div class=\"info\" ng-repeat=\"email in vm.about.contact.emails\"><span>{{email}}</span></div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.FRIENDS\">Friends</div><div class=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>454</span> <span translate=\"PROFILE.MORE\">More</span></div></header><div class=\"content\" layout=\"row\" layout-wrap=\"\"><div class=\"friend\" flex=\"20\" ng-repeat=\"friend in vm.about.friends\"><img ng-src=\"{{friend.avatar}}\"></div></div></div><div class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.JOINED_GROUPS\">Joined Groups</div><div class=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>6</span> <span translate=\"PROFILE.MORE\">More</span></div></header><div class=\"content\"><div class=\"group\" ng-repeat=\"group in vm.about.groups\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{group.logo}}\" class=\"logo\" alt=\"{{group.name}}\"><div><div class=\"name\">{{group.name}}</div><div class=\"category\">{{group.category}}</div><div class=\"members\">{{group.members}} people</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate=\"\" translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\"><span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" layout=\"row\" layout-wrap=\"\"><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" ng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div class=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap=\"\"><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" flex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex=\"\"><textarea placeholder=\"Write something..\" translate=\"\" translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea><footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"insert photo\" translate=\"\" translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon md-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate=\"\" translate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span translate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add location\" translate=\"\" translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon md-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span></md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" translate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider></md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" layout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-src=\"{{post.user.avatar}}\"><div layout=\"column\"><div class=\"title\"><span class=\"username md-accent-color\">{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" translate=\"PROFILE.TYPE_POST\">posted on your timeline</span> <span ng-if=\"post.type == \'something\'\" translate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> <span ng-if=\"post.type == \'video\'\" translate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span ng-if=\"post.type == \'article\'\" translate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div class=\"time\">{{post.time}}</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate=\"\" translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div class=\"content\"><div ng-if=\"post.message\" class=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\"><img ng-if=\"post.media.type === \'image\'\" ng-src=\"{{post.media.preview}}\"><div ng-if=\"post.media.type === \'video\'\" ng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div class=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div class=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span translate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>({{post.like}})</span></div></md-button><md-button class=\"share-button\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>({{post.share}})</span></div></md-button></div></div><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div ng-if=\"post.comments\" class=\"comment-count\">{{post.comments.length}} comments<md-icon md-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill=\"\" ng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\"><div flex=\"\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user.name}}</span> <span class=\"time\">{{comment.time}}</span></div><div class=\"message\">{{comment.message}}</div><div class=\"actions\" layout=\"row\" layout-align=\"space-between center\"><a href=\"#\" class=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply</a><md-icon flex=\"\" md-font-icon=\"icon-flag\" class=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" layout=\"row\" layout-fill=\"\"><img src=\"assets/images/avatars/profile.jpg\" class=\"avatar\"><form flex=\"\"><textarea placeholder=\"Add a comment...\" translate=\"\" translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button ng-click=\"\" class=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" translate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div class=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" flex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">See All</div></header><div class=\"content\" layout=\"row\" layout-wrap=\"\"><div class=\"activities\"><div class=\"activity\" layout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" class=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span class=\"username md-accent-color\">{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div><span class=\"time secondary-text\">{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/search/tabs/classic/classic.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><span class=\"result-count h3 secondary-text\"><span>54</span> <span translate=\"SEARCH.RESULTS\">Results</span></span><div class=\"pager\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span></span> <span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"results\"><div class=\"result-item\" ng-repeat=\"item in vm.classic\"><div class=\"title\">{{item.title}}</div><div class=\"url\">{{item.url}}</div><div class=\"excerpt\">{{item.excerpt}}</div></div></div><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs=\"\"><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs=\"\"><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs=\"\"><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs=\"\"><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs=\"\"><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs=\"\"><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs=\"\"><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs=\"\"><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs=\"\"><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/contacts/contacts.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.CONTACTS\">Contacts</span> <span class=\"secondary-text\"><span>13</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span></span> <span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><table class=\"results simple clickable\" ms-responsive-table=\"\"><thead><tr><th></th><th translate=\"SEARCH.NAME\">Name</th><th translate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.PHONE\">Phone</th><th translate=\"SEARCH.EMAIL\">Email</th></tr></thead><tbody><tr class=\"result-item\" ng-repeat=\"contact in vm.contacts\"><td class=\"text-left avatar-cell\" ng-if=\"contact.avatar\"><img class=\"avatar\" alt=\"{{contact.name}}\" ng-src=\"{{contact.avatar}}\"></td><td class=\"text-left avatar-cell\" ng-if=\"!contact.avatar\"><div class=\"avatar\" ms-random-class=\"vm.colors\">{{contact.name[0]}}</div></td><td class=\"name\">{{contact.name}}</td><td class=\"position\">{{contact.position}}</td><td class=\"phone\">{{contact.phone}}</td><td class=\"email\">{{contact.email}}</td></tr></tbody></table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs=\"\"><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs=\"\"><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs=\"\"><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs=\"\"><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs=\"\"><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs=\"\"><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs=\"\"><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs=\"\"><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs=\"\"><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/emails/emails.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.EMAILS\">E-Mails</span> <span class=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span></span> <span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"results\"><div class=\"result-item {{mail.status}}\" ng-repeat=\"mail in vm.mails | filter: vm.search\" md-ink-ripple=\"\"><div layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"mail.from.avatar\" alt=\"{{mail.from.name}}\" ng-src=\"{{mail.from.avatar}}\"><div class=\"avatar\" ng-if=\"!mail.from.avatar\" ms-random-class=\"vm.colors\">{{mail.from.name[0]}}</div><div class=\"info\" flex=\"\" layout=\"column\"><div class=\"name text-truncate\">{{mail.from.name}}</div><div class=\"subject secondary-text text-truncate\">{{mail.subject}}</div><div class=\"message secondary-text text-truncate\">{{mail.message | htmlToPlaintext}}</div></div><div layout=\"column\" layout-align=\"center end\"><div class=\"time secondary-text\">{{mail.time}}</div></div></div></div></div><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs=\"\"><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs=\"\"><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs=\"\"><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs=\"\"><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs=\"\"><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs=\"\"><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs=\"\"><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs=\"\"><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs=\"\"><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/users/users.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.USERS\">Users</span> <span class=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span></span> <span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><table class=\"results simple clickable\" ms-responsive-table=\"\"><thead><tr><th translate=\"SEARCH.NAME\">Name</th><th translate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.OFFICE\">Office</th><th class=\"text-right\" translate=\"SEARCH.AGE\">Age</th><th class=\"text-right\" translate=\"SEARCH.START_DATE\">Start Date</th><th class=\"text-right\" translate=\"SEARCH.SALARY\">Salary</th><th class=\"text-left\" translate=\"SEARCH.EMAIL\">Email</th></tr></thead><tbody><tr class=\"result-item user\" ng-repeat=\"user in vm.users\"><td class=\"name\">{{user.name}}</td><td class=\"position\">{{user.position}}</td><td class=\"office\">{{user.office}}</td><td class=\"age text-right\">{{user.age}}</td><td class=\"start-date text-right\">{{user.startDate}}</td><td class=\"salary text-right\">{{user.salary | currency}}</td><td class=\"email text-left\">{{user.email}}</td></tr></tbody></table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to previous page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink=\"\" ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs=\"\"><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs=\"\"><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs=\"\"><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs=\"\"><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs=\"\"><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs=\"\"><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs=\"\"><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs=\"\"><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs=\"\"><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate=\"\" translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth/fullwidth.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with independent scroll</span></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>Content toolbar</span></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" flex=\"\"><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with page scroll</span></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>Content toolbar</span></div><md-content class=\"content\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Left sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>Content toolbar</p></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html","<div class=\"page-layout carded right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex=\"\"><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Right sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex=\"\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>Content toolbar</p><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle right pane\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll=\"\" flex=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout carded left-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" flex=\"\"><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Left sidenav with page scroll</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>Content toolbar</p></div><md-content class=\"content\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout carded right-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" flex=\"\"><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Right sidenav with page scroll</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>Content toolbar</p><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle right pane\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html","<div class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with independent scroll</span></div></div><div class=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/fullwidth/fullwidth.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\"><span class=\"h2\">Fullwidth</span></div><div class=\"content\" md-background-bg=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">Right sidenav with independent scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout simple left-sidenav single-scroll\" layout=\"row\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with page scroll</span></div></div><div class=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout simple right-sidenav single-scroll\" layout=\"row\"><div class=\"center\" flex=\"\" ms-scroll=\"\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">Right sidenav with page scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md=\"\" aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll=\"\" ms-sidenav-helper=\"\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/tabbed/tabbed.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\"><span class=\"h2\">Tabbed</span></div><div class=\"content\"><md-tabs md-dynamic-height=\"\"><md-tab label=\"Tab 1\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 2\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 3\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html","<md-dialog class=\"custom-theme-dialog\" aria-label=\"Custom Theme\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Custom Theme Generator</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" ng-repeat=\"type in [\'primary\', \'accent\', \'warn\', \'background\']\"><h3 class=\"type\">{{type}}</h3><md-input-container><label>Palette</label><md-select ng-model=\"vm.theme[type].name\" ng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].contrast, 1)}\"><md-option ng-value=\"palette\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\">{{palette}}</md-option></md-select></md-input-container><div layout=\"row\" ng-repeat=\"hueType in [\'default\', \'hue-1\', \'hue-2\', \'hue-3\']\"><md-input-container><label>{{hueType}}</label><md-select ng-model=\"vm.theme[type].hues[hueType]\" ng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].contrast, 1)}\"><md-option ng-value=\"hue\" ng-repeat=\"(hue, opt) in vm.palettes[vm.theme[type].name]\" ng-style=\"{\'background-color\': vm.rgba(opt.value), \'color\': vm.rgba(opt.contrast, 1)}\">{{hue}}</md-option></md-select></md-input-container></div></div><md-divider></md-divider><div layout=\"row\"><p>To make this theme permanent, copy the below code and add it into the \"fuseThemes\" object in \"core/theming/fuse-themes.constant.js\" file. You can also replace the \"CUSTOM_THEME_NAME\" with your theme name.</p></div><div layout=\"row\"><textarea readonly=\"\" class=\"theme-object\">\"CUSTOM_THEME_NAME\" : {{vm.theme}}</textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-accent\" ng-click=\"vm.setTheme()\">Set Theme</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ui/theme-colors/tabs/accent/accent.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.accent.color}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .secondary-text</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .hint-text</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .divider</div></div><div flex=\"100\" class=\"md-accent-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.color}}</div><div flex=\"\">.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.accent.hue1.color}}</div><div flex=\"\">.md-accent-bg .md-hue-1</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .md-hue-1 .secondary-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .md-hue-1 .hint-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-1\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.hue1.color}}</div><div flex=\"\">.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.accent.hue2.color}}</div><div flex=\"\">.md-accent-bg .md-hue-2</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .md-hue-2 .secondary-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .md-hue-2 .hint-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-2\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.hue2.color}}</div><div flex=\"\">.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.accent.hue3.color}}</div><div flex=\"\">.md-accent-bg .md-hue-3</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast1}}</div><div flex=\"\">.md-accent-bg</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-accent-bg .md-hue-3 .secondary-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-accent-bg .md-hue-3 .hint-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.accent.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-accent-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-3\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.accent.hue3.color}}</div><div flex=\"\">.md-accent-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/background/background.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.background.color}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .secondary-text</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .hint-text</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .divider</div></div><div flex=\"100\" class=\"md-primary-bg md-background-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.background.color}}</div><div flex=\"\">.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.background.hue1.color}}</div><div flex=\"\">.md-background-bg .md-hue-1</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.hue1.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .md-hue-1 .secondary-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .md-hue-1 .hint-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding=\"\"><div flex=\"\" class=\"md-background-fg md-hue-1\">As foreground color</div><div flex=\"\" class=\"md-background-fg md-hue-1\">{{vm.themes.active.theme.background.hue1.color}}</div><div flex=\"\" class=\"md-background-fg md-hue-1\">.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.background.hue2.color}}</div><div flex=\"\">.md-background-bg .md-hue-2</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.hue2.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .md-hue-2 .secondary-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .md-hue-2 .hint-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding=\"\"><div flex=\"\" class=\"md-background-fg md-hue-2\">As foreground color</div><div flex=\"\" class=\"md-background-fg md-hue-2\">{{vm.themes.active.theme.background.hue2.color}}</div><div flex=\"\" class=\"md-background-fg md-hue-2\">.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.background.hue3.color}}</div><div flex=\"\">.md-background-bg .md-hue-3</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.background.hue3.contrast1}}</div><div flex=\"\">.md-background-bg</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.background.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-background-bg .md-hue-3 .secondary-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.background.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-background-bg .md-hue-3 .hint-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.background.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-background-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding=\"\"><div flex=\"\" class=\"md-background-fg md-hue-3\">As foreground color</div><div flex=\"\" class=\"md-background-fg md-hue-3\">{{vm.themes.active.theme.background.hue3.color}}</div><div flex=\"\" class=\"md-background-fg md-hue-3\">.md-background-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/primary/primary.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.primary.color}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .secondary-text</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .hint-text</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .divider</div></div><div flex=\"100\" class=\"md-primary-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.color}}</div><div flex=\"\">.md-primary-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.primary.hue1.color}}</div><div flex=\"\">.md-primary-bg .md-hue-1</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .md-hue-1 .secondary-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .md-hue-1 .hint-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-1\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.hue1.color}}</div><div flex=\"\">.md-primary-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.primary.hue2.color}}</div><div flex=\"\">.md-primary-bg .md-hue-2</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .md-hue-2 .secondary-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .md-hue-2 .hint-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-2\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.hue2.color}}</div><div flex=\"\">.md-primary-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.primary.hue3.color}}</div><div flex=\"\">.md-primary-bg .md-hue-3</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast1}}</div><div flex=\"\">.md-primary-bg</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-primary-bg .md-hue-3 .secondary-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-primary-bg .md-hue-3 .hint-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.primary.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-primary-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-3\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.primary.hue3.color}}</div><div flex=\"\">.md-primary-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/warn/warn.html","<div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Default</div><div flex=\"\">{{vm.themes.active.theme.warn.color}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .secondary-text</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .hint-text</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .divider</div></div><div flex=\"100\" class=\"md-warn-fg\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.color}}</div><div flex=\"\">.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 1</div><div flex=\"\">{{vm.themes.active.theme.warn.hue1.color}}</div><div flex=\"\">.md-warn-bg .md-hue-1</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .md-hue-1 .secondary-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .md-hue-1 .hint-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.hue1.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-1\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.hue1.color}}</div><div flex=\"\">.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 2</div><div flex=\"\">{{vm.themes.active.theme.warn.hue2.color}}</div><div flex=\"\">.md-warn-bg .md-hue-2</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .md-hue-2 .secondary-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .md-hue-2 .hint-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.hue2.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-2\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.hue2.color}}</div><div flex=\"\">.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap=\"\" layout-align=\"center center\"><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Hue 3</div><div flex=\"\">{{vm.themes.active.theme.warn.hue3.color}}</div><div flex=\"\">.md-warn-bg .md-hue-3</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div flex=\"\">Primary Text</div><div flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast1}}</div><div flex=\"\">.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"secondary-text\" flex=\"\">Secondary Text / Icon</div><div class=\"secondary-text\" flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast2}}</div><div class=\"secondary-text\" flex=\"\">.md-warn-bg .md-hue-3 .secondary-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"hint-text\" flex=\"\">Hint Text / Disabled Text</div><div class=\"hint-text\" flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast3}}</div><div class=\"hint-text\" flex=\"\">.md-warn-bg .md-hue-3 .hint-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding=\"\"><div class=\"fade-text\" flex=\"\">Fade Text / Divider</div><div class=\"fade-text\" flex=\"\">{{vm.themes.active.theme.warn.hue3.contrast4}}</div><div class=\"fade-text\" flex=\"\">.md-warn-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-3\" layout=\"row\" layout-padding=\"\"><div flex=\"\">As foreground color</div><div flex=\"\">{{vm.themes.active.theme.warn.hue3.color}}</div><div flex=\"\">.md-warn-fg</div></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/administrator/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/management_DESHABILITADO/administrator/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/administrator/views/detail/detail-view-administrator.html","<div id=\"detail-view-administrator\"><div class=\"message\">Administrator Detail</div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><form name=\"registerForm\" id=\"register-form\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ADMINISTRATOR.NAME\">Name</label> <input name=\"name\" ng-model=\"vm.selectedAdministrator.name\" placeholder=\"Name\" translate=\"\" translate-attr-placeholder=\"ADMINISTRATOR.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.name.$error\" ng-show=\"registerForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ADMINISTRATOR.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ADMINISTRATOR.EMAIL\">E-mail</label> <input type=\"email\" name=\"email\" ng-model=\"vm.selectedAdministrator.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"ADMINISTRATOR.INSERT_VALUE\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.email.$error\" ng-show=\"registerForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"ADMINISTRATOR.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"ADMINISTRATOR.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ADMINISTRATOR.PASSWORD\">Password</label> <input type=\"password\" name=\"password\" ng-model=\"vm.selectedAdministrator.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"ADMINISTRATOR.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ADMINISTRATOR.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ADMINISTRATOR.PASSWORD_CONFIRM\">Password (confirm)</label> <input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.selectedAdministrator.passwordConfirm\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"ADMINISTRATOR.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ADMINISTRATOR.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ADMINISTRATOR.CANCEL\" translate-attr-aria-label=\"ADMINISTRATOR.CANCEL\" ng-click=\"vm.toggleView(\'cancel\')\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ADMINISTRATOR.SAVE\" translate-attr-aria-label=\"ADMINISTRATOR.SAVE\" ng-click=\"vm.toggleView(\'save\')\">SAVE</md-button></div></form></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/administrator/views/list/list-view.html","<div class=\"message\" layout=\"row\" layout-align=\"center center\">Administrator List</div><div layout=\"row\" layout-align=\"center center\"><table class=\"simple\" ms-responsive-table=\"\"><div id=\"grid1\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table></div><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"DELETE\" ng-disabled=\"false\" translate=\"ADMINISTRATOR.DELETE\" translate-attr-aria-label=\"ADMINISTRATOR.DELETE\" ng-click=\"vm.deleteAdministrator()\">DELETE</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"MODIFY\" ng-disabled=\"false\" translate=\"ADMINISTRATOR.MODIFY\" translate-attr-aria-label=\"ADMINISTRATOR.MODIFY\" ng-click=\"vm.toggleView(\'modify\')\">MODIFY</md-button><md-button class=\"md-raised md-accent\" aria-label=\"INSERT\" ng-disabled=\"false\" translate=\"ADMINISTRATOR.INSERT\" translate-attr-aria-label=\"ADMINISTRATOR.INSERT\" ng-click=\"vm.toggleView(\'insert\')\">INSERT</md-button></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/bidder/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/management_DESHABILITADO/bidder/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/bidder/views/detail/detail-view-bidder.html","<div id=\"detail-view-bidder\"><div class=\"message\">Bidder Detail</div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><form name=\"registerForm\" id=\"register-form\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.COMPANY\">Company</label> <input name=\"company\" ng-model=\"vm.selectedBidder.company\" placeholder=\"Company\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.company.$error\" ng-show=\"registerForm.company.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.COMPANY_REQUIRED\">Company Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.MAIN_EMAIL\">Main E-mail</label> <input type=\"email\" name=\"email\" ng-model=\"vm.selectedBidder.email\" placeholder=\"Main E-mail\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.email.$error\" ng-show=\"registerForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.EMAIL_REQUIRED\">E-mail field is required</span></div><div ng-message=\"pattern\"><span translate=\"BIDDER.ERRORS.EMAIL_MUST_VALID\">E-mail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PASSWORD\">Password</label> <input type=\"password\" name=\"password\" ng-model=\"vm.selectedBidder.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PASSWORD_CONFIRM\">Password (confirm)</label> <input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.selectedBidder.passwordConfirm\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.MAIN_CONTACT\">Main Contact</label> <input name=\"maincontact\" ng-model=\"vm.selectedBidder.maincontact\" placeholder=\"Main Contact\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"><div ng-messages=\"registerForm.maincontact.$error\" ng-show=\"registerForm.maincontact.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.MAIN_CONTACT_REQUIRED\">Main Contact field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.MAIN_PHONE\">Main Phone</label> <input name=\"mainphone\" ng-model=\"vm.selectedBidder.mainphone\" placeholder=\"Main Phone\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.ADDRESS\">Address</label> <input name=\"address\" ng-model=\"vm.selectedBidder.address\" placeholder=\"Address\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.CITY\">City</label> <input name=\"city\" ng-model=\"vm.selectedBidder.city\" placeholder=\"City\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.POSTCODE\">PostCode</label> <input name=\"postcode\" ng-model=\"vm.selectedBidder.postcode\" placeholder=\"PostCode\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.COUNTRY\">Country</label> <input name=\"country\" ng-model=\"vm.selectedBidder.country\" placeholder=\"Country\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.NAME_1\">Name 1</label> <input name=\"name1\" ng-model=\"vm.selectedBidder.name1\" placeholder=\"Name 1\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"><div ng-messages=\"registerForm.name1.$error\" ng-show=\"registerForm.name1.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.EMAIL_1\">E-mail 1</label> <input type=\"email\" name=\"email1\" ng-model=\"vm.selectedBidder.email1\" placeholder=\"E-mail 1\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email1.$error\" ng-show=\"registerForm.email1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.EMAIL_REQUIRED\">E-mail 1 field is required</span></div><div ng-message=\"pattern\"><span translate=\"BIDDER.ERRORS.EMAIL_MUST_VALID\">E-mail 1 must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PASSWORD_1\">Password 1</label> <input type=\"password\" name=\"password1\" ng-model=\"vm.selectedBidder.password1\" placeholder=\"Password 1\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PASSWORD_CONFIRM_1\">Password 1 (confirm)</label> <input type=\"password\" name=\"passwordConfirm1\" ng-model=\"vm.selectedBidder.passwordConfirm1\" placeholder=\"Password 1 (Confirm)\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PHONE_1\">Phone 1</label> <input name=\"phone1\" ng-model=\"vm.selectedBidder.phone1\" placeholder=\"Phone 1\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.NAME_2\">Name 2</label> <input name=\"name2\" ng-model=\"vm.selectedBidder.name2\" placeholder=\"Name 2\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"><div ng-messages=\"registerForm.name2.$error\" ng-show=\"registerForm.name2.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.EMAIL_2\">E-mail 2</label> <input type=\"email\" name=\"email2\" ng-model=\"vm.selectedBidder.email2\" placeholder=\"E-mail 2\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email2.$error\" ng-show=\"registerForm.email2.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.EMAIL_REQUIRED\">E-mail 2 field is required</span></div><div ng-message=\"pattern\"><span translate=\"BIDDER.ERRORS.EMAIL_MUST_VALID\">E-mail 2 must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PASSWORD_2\">Password 1</label> <input type=\"password\" name=\"password2\" ng-model=\"vm.selectedBidder.password2\" placeholder=\"Password 2\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PASSWORD_CONFIRM_2\">Password 2 (confirm)</label> <input type=\"password\" name=\"passwordConfirm2\" ng-model=\"vm.selectedBidder.passwordConfirm2\" placeholder=\"Password 2 (Confirm)\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PHONE_2\">Phone 2</label> <input name=\"phone2\" ng-model=\"vm.selectedBidder.phone2\" placeholder=\"Phone 2\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.NAME_3\">Name 3</label> <input name=\"name3\" ng-model=\"vm.selectedBidder.name3\" placeholder=\"Name 3\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"><div ng-messages=\"registerForm.name3.$error\" ng-show=\"registerForm.name3.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.EMAIL_3\">E-mail 3</label> <input type=\"email\" name=\"email3\" ng-model=\"vm.selectedBidder.email3\" placeholder=\"E-mail 3\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email3.$error\" ng-show=\"registerForm.email3.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.EMAIL_REQUIRED\">E-mail 3 field is required</span></div><div ng-message=\"pattern\"><span translate=\"BIDDER.ERRORS.EMAIL_MUST_VALID\">E-mail 3 must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PASSWORD_3\">Password 3</label> <input type=\"password\" name=\"password3\" ng-model=\"vm.selectedBidder.password3\" placeholder=\"Password 3\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PASSWORD_CONFIRM_3\">Password 3 (confirm)</label> <input type=\"password\" name=\"passwordConfirm3\" ng-model=\"vm.selectedBidder.passwordConfirm3\" placeholder=\"Password 3 (Confirm)\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PHONE_3\">Phone 3</label> <input name=\"phone3\" ng-model=\"vm.selectedBidder.phone3\" placeholder=\"Phone 3\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.NAME_4\">Name 4</label> <input name=\"name4\" ng-model=\"vm.selectedBidder.name4\" placeholder=\"Name 4\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"><div ng-messages=\"registerForm.name4.$error\" ng-show=\"registerForm.name4.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.EMAIL_4\">E-mail 4</label> <input type=\"email\" name=\"email4\" ng-model=\"vm.selectedBidder.email4\" placeholder=\"E-mail 4\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email4.$error\" ng-show=\"registerForm.email4.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.EMAIL_REQUIRED\">E-mail 4 field is required</span></div><div ng-message=\"pattern\"><span translate=\"BIDDER.ERRORS.EMAIL_MUST_VALID\">E-mail 4 must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PASSWORD_4\">Password 4</label> <input type=\"password\" name=\"password4\" ng-model=\"vm.selectedBidder.password4\" placeholder=\"Password 4\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PASSWORD_CONFIRM_4\">Password 4 (confirm)</label> <input type=\"password\" name=\"passwordConfirm4\" ng-model=\"vm.selectedBidder.passwordConfirm4\" placeholder=\"Password 4 (Confirm)\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER.PHONE_4\">Phone 4</label> <input name=\"phone4\" ng-model=\"vm.selectedBidder.phone4\" placeholder=\"Phone 4\" translate=\"\" translate-attr-placeholder=\"BIDDER.INSERT_VALUE\"></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ITB.CANCEL\" translate-attr-aria-label=\"ITB.CANCEL\" ng-click=\"vm.toggleView(\'cancel\')\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ITB.SAVE\" translate-attr-aria-label=\"ITB.SAVE\" ng-click=\"vm.toggleView(\'save\')\">SAVE</md-button></div></form></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/bidder/views/list/list-view.html","<div class=\"message\" layout=\"row\" layout-align=\"center center\">Bidder List</div><div layout=\"row\" layout-align=\"center center\"><table class=\"simple\" ms-responsive-table=\"\"><div id=\"grid1\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table></div><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"DELETE\" ng-disabled=\"false\" translate=\"BIDDER.DELETE\" translate-attr-aria-label=\"BIDDER.DELETE\" ng-click=\"vm.deleteBidder()\">DELETE</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"MODIFY\" ng-disabled=\"false\" translate=\"BIDDER.MODIFY\" translate-attr-aria-label=\"BIDDER.MODIFY\" ng-click=\"vm.toggleView(\'modify\')\">MODIFY</md-button><md-button class=\"md-raised md-accent\" aria-label=\"INSERT\" ng-disabled=\"false\" translate=\"BIDDER.INSERT\" translate-attr-aria-label=\"BIDDER.INSERT\" ng-click=\"vm.toggleView(\'insert\')\">INSERT</md-button></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/charterer/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/management_DESHABILITADO/charterer/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/charterer/views/list/list-view.html","<div class=\"message\" layout=\"row\" layout-align=\"center center\">Charterer List</div><div layout=\"row\" layout-align=\"center center\"><table class=\"simple\" ms-responsive-table=\"\"><div id=\"grid1\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table></div><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"DELETE\" ng-disabled=\"false\" translate=\"CHARTERER.DELETE\" translate-attr-aria-label=\"CHARTERER.DELETE\" ng-click=\"vm.deleteCharterer()\">DELETE</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"MODIFY\" ng-disabled=\"false\" translate=\"CHARTERER.MODIFY\" translate-attr-aria-label=\"CHARTERER.MODIFY\" ng-click=\"vm.toggleView(\'modify\')\">MODIFY</md-button><md-button class=\"md-raised md-accent\" aria-label=\"INSERT\" ng-disabled=\"false\" translate=\"CHARTERER.INSERT\" translate-attr-aria-label=\"CHARTERER.INSERT\" ng-click=\"vm.toggleView(\'insert\')\">INSERT</md-button></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/charterer/views/detail/detail-view-charterer.html","<div id=\"detail-view-charterer\"><div class=\"message\">Charterer Detail</div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><form name=\"registerForm\" id=\"register-form\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"CHARTERER.COMPANY\">Company</label> <input name=\"company\" ng-model=\"vm.selectedCharterer.company\" placeholder=\"Company\" translate=\"\" translate-attr-placeholder=\"CHARTERER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.company.$error\" ng-show=\"registerForm.company.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"CHARTERER.ERRORS.COMPANY_REQUIRED\">Company Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"CHARTERER.MAIN_EMAIL\">Main E-mail</label> <input type=\"email\" name=\"email\" ng-model=\"vm.selectedCharterer.email\" placeholder=\"Main Email\" translate=\"\" translate-attr-placeholder=\"CHARTERER.INSERT_VALUE\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.email.$error\" ng-show=\"registerForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"CHARTERER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"CHARTERER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"CHARTERER.PASSWORD\">Password</label> <input type=\"password\" name=\"password\" ng-model=\"vm.selectedCharterer.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"CHARTERER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"CHARTERER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"CHARTERER.PASSWORD_CONFIRM\">Password (confirm)</label> <input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.selectedCharterer.passwordConfirm\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"CHARTERER.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"CHARTERER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"CHARTERER.CONTACT\">Contact</label> <input name=\"contact\" ng-model=\"vm.selectedCharterer.contact\" placeholder=\"Contact\" translate=\"\" translate-attr-placeholder=\"CHARTERER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"CHARTERER.PHONE\">Phone</label> <input name=\"phone\" ng-model=\"vm.selectedCharterer.phone\" placeholder=\"Phone\" translate=\"\" translate-attr-placeholder=\"CHARTERER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"CHARTERER.ADDRESS\">Address</label> <input name=\"address\" ng-model=\"vm.selectedCharterer.address\" placeholder=\"Address\" translate=\"\" translate-attr-placeholder=\"CHARTERER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"CHARTERER.CITY\">City</label> <input name=\"city\" ng-model=\"vm.selectedCharterer.city\" placeholder=\"City\" translate=\"\" translate-attr-placeholder=\"CHARTERER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"CHARTERER.POSTCODE\">PostCode</label> <input name=\"postcode\" ng-model=\"vm.selectedCharterer.postcode\" placeholder=\"PostCode\" translate=\"\" translate-attr-placeholder=\"CHARTERER.INSERT_VALUE\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"CHARTERER.COUNTRY\">Country</label> <input name=\"country\" ng-model=\"vm.selectedCharterer.country\" placeholder=\"Country\" translate=\"\" translate-attr-placeholder=\"CHARTERER.INSERT_VALUE\"></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ITB.CANCEL\" translate-attr-aria-label=\"ITB.CANCEL\" ng-click=\"vm.toggleView(\'cancel\')\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ITB.SAVE\" translate-attr-aria-label=\"ITB.SAVE\" ng-click=\"vm.toggleView(\'save\')\">SAVE</md-button></div></form></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/itb/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/itb/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/management_DESHABILITADO/itb/views/detail/detail-view-itb.html","<div id=\"detail-view-itb\"><div class=\"message\">ITB Detail</div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><form name=\"registerForm\" id=\"register-form\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ITB.REFERENCE\">Reference</label> <input name=\"reference\" ng-model=\"vm.selectedItb.reference\" placeholder=\"[insert Reference]\" translate=\"\" translate-attr-placeholder=\"ITB.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ITB.CHARTERERS_REFERENCE\">Charterers Reference</label> <input name=\"charterersReference\" ng-model=\"vm.selectedItb.charterersReference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"ITB.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.charterersReference.$error\" ng-show=\"registerForm.charterersReference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ITB.CHARTERER\">Charterer (KEY)</label><md-select name=\"charterer_key\" placeholder=\"Charterer\" ng-model=\"vm.selectedItb.charterer_key\" md-on-close=\"vm.assignChartererName(vm.selectedItb.charterer_key)\"><md-option ng-value=\"charterer.$id\" ng-repeat=\"charterer in vm.charterers\">{{charterer.company}}</md-option></md-select><div ng-messages=\"registerForm.charterer_key.$error\" ng-show=\"registerForm.charterer_key.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><div class=\"separador\"></div><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ITB.TITLE\">Title</label> <input name=\"title\" ng-model=\"vm.selectedItb.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"ITB.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ITB.VESSEL_TYPE\">Vessel Type</label> <input name=\"vessel_type\" ng-model=\"vm.selectedItb.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"ITB.INSERT_VALUE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ITB.LOCATION\">Location</label> <input name=\"location\" ng-model=\"vm.selectedItb.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"ITB.INSERT_VALUE\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"ITB.STATUS\">Status</label> <input name=\"reference\" ng-model=\"vm.selectedItb.status\" placeholder=\"[insert Reference]\" translate=\"\" translate-attr-placeholder=\"ITB.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.status.$error\" ng-show=\"registerForm.status.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ITB.ERRORS.STATUS_REQUIRED\">Status field is required</span></div></div></md-input-container><div layout-sm=\"column\" layout=\"row\"><label translate=\"SELECT_ITB.COMMENCEMENT\">Commencement Date</label><div flex=\"\" class=\"date-container\"><md-datepicker flex=\"\" ng-model=\"vm.date_commencement\" style=\"width: 20px;\"></md-datepicker></div><div flex=\"\" class=\"date-container\"><md-select placeholder=\"Time\" ng-model=\"vm.time_commencement\" style=\"width: 20px;\"><md-option ng-value=\"time.name\" ng-repeat=\"time in vm.timeList\">{{time.name}}</md-option></md-select></div></div><div layout-sm=\"column\" layout=\"row\"><label translate=\"SELECT_ITB.CLOSING_DATE\">Closing Date</label><div flex=\"\" class=\"date-container\"><md-datepicker flex=\"\" ng-model=\"vm.date_closing\" style=\"width: 20px;\"></md-datepicker></div><div flex=\"\" class=\"date-container\"><md-select placeholder=\"Time\" ng-model=\"vm.time_closing\" style=\"width: 20px;\"><md-option ng-value=\"time.name\" ng-repeat=\"time in vm.timeList\">{{time.name}}</md-option></md-select></div></div><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ITB.BACK\" translate-attr-aria-label=\"ITB.BACK\" ng-click=\"vm.toggleView(\'save\')\">SAVE</md-button></div></form></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/itb/views/list/list-view.html","<div class=\"message\" layout=\"row\" layout-align=\"center center\">ITB List</div><div layout=\"row\" layout-align=\"center center\"><table class=\"simple\" ms-responsive-table=\"\"><div id=\"grid1\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table></div><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"DELETE\" ng-disabled=\"false\" translate=\"ITB.DELETE\" translate-attr-aria-label=\"ITB.DELETE\" ng-click=\"vm.deleteItb()\">DELETE</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"MODIFY\" ng-disabled=\"false\" translate=\"ITB.MODIFY\" translate-attr-aria-label=\"ITB.MODIFY\" ng-click=\"vm.toggleView(\'modify\')\">MODIFY</md-button><md-button class=\"md-raised md-accent\" aria-label=\"INSERT\" ng-disabled=\"false\" translate=\"ITB.INSERT\" translate-attr-aria-label=\"ITB.INSERT\" ng-click=\"vm.toggleView(\'insert\')\">INSERT</md-button></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/traceability/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/traceability/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/management_DESHABILITADO/traceability/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"separador1\"></div><div class=\"message\">Traceability Detail</div><table class=\"simple\" ms-responsive-table=\"\"><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"name\" ng-model=\"vm.form.name\" placeholder=\"Name\" translate=\"\" translate-attr-placeholder=\"TRACEABILITY.NAME\" required=\"\"><div ng-messages=\"registerForm.name.$error\" ng-show=\"registerForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TRACEABILITY.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate=\"\" translate-attr-placeholder=\"TRACEABILITY.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.email.$error\" ng-show=\"registerForm.email.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"TRACEABILITY.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span translate=\"TRACEABILITY.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate=\"\" translate-attr-placeholder=\"TRACEABILITY.PASSWORD\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TRACEABILITY.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate=\"\" translate-attr-placeholder=\"TRACEABILITY.PASSWORD_CONFIRM\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TRACEABILITY.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"TRACEABILITY.CANCEL\" translate-attr-aria-label=\"TRACEABILITY.CANCEL\" ng-click=\"vm.toggleView()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"TRACEABILITY.SAVE\" translate-attr-aria-label=\"TRACEABILITY.SAVE\" ng-click=\"vm.toggleView()\">SAVE</md-button></div></form></table></div>");
$templateCache.put("app/main/apps/management_DESHABILITADO/traceability/views/list/list-view.html","<div class=\"message\" layout=\"row\" layout-align=\"center center\">Traceability (Events List)</div><div layout=\"row\" layout-align=\"center center\"><table class=\"simple\" ms-responsive-table=\"\"><div id=\"grid1\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table></div><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"></div>");
$templateCache.put("app/main/apps/workflow-bidder/select-itb/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/select-itb/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/select-itb/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">Select ITB - ITB Detail</div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><form name=\"registerForm\" id=\"register-form\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"SELECT_ITB.REFERENCE\">Reference</label> <input name=\"reference\" ng-model=\"vm.selectedItb.reference\" placeholder=\"[insert Reference]\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"SELECT_ITB.CHARTERERS_REFERENCE\">Charterers Reference</label> <input name=\"charterersReference\" ng-model=\"vm.selectedItb.charterersReference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.charterersReference.$error\" ng-show=\"registerForm.charterersReference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"SELECT_ITB.CHARTERER\">Charterer (KEY)</label><md-select name=\"charterer_key\" placeholder=\"Charterer\" ng-model=\"vm.selectedItb.charterer_key\" md-on-close=\"vm.assignChartererName(vm.selectedItb.charterer_key)\"><md-option ng-value=\"charterer.$id\" ng-repeat=\"charterer in vm.charterers\">{{charterer.company}}</md-option></md-select><div ng-messages=\"registerForm.charterer_key.$error\" ng-show=\"registerForm.charterer_key.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><div class=\"separador\"></div><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"SELECT_ITB.TITLE\">Title</label> <input name=\"title\" ng-model=\"vm.selectedItb.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.INSERT_VALUE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"SELECT_ITB.VESSEL_TYPE\">Vessel Type</label> <input name=\"vessel_type\" ng-model=\"vm.selectedItb.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.INSERT_VALUE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"SELECT_ITB.LOCATION\">Location</label> <input name=\"location\" ng-model=\"vm.selectedItb.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.INSERT_VALUE\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><div layout-sm=\"column\" layout=\"row\"><label translate=\"SELECT_ITB.COMMENCEMENT\">Commencement Date</label><div flex=\"\" class=\"date-container\"><md-datepicker flex=\"\" ng-model=\"vm.date_commencement\" style=\"width: 20px;\"></md-datepicker></div><div flex=\"\" class=\"date-container\"><md-select placeholder=\"Time\" ng-model=\"vm.time_commencement\" style=\"width: 20px;\"><md-option ng-value=\"time.name\" ng-repeat=\"time in vm.timeList\">{{time.name}}</md-option></md-select></div></div><div layout-sm=\"column\" layout=\"row\"><label translate=\"SELECT_ITB.CLOSING_DATE\">Closing Date</label><div flex=\"\" class=\"date-container\"><md-datepicker flex=\"\" ng-model=\"vm.date_closing\" style=\"width: 20px;\"></md-datepicker></div><div flex=\"\" class=\"date-container\"><md-select placeholder=\"Time\" ng-model=\"vm.time_closing\" style=\"width: 20px;\"><md-option ng-value=\"time.name\" ng-repeat=\"time in vm.timeList\">{{time.name}}</md-option></md-select></div></div><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"BACK\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.BACK\" translate-attr-aria-label=\"SELECT_ITB.BACK\" ng-click=\"vm.toggleView(\'save\')\">SAVE</md-button></div></form><div class=\"separador\"></div></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/select-itb/views/list/list-view.html","<div class=\"message\">Select ITB (List of ITBs)</div><table class=\"simple\" ms-responsive-table=\"\"><div class=\"comment\">IMPORTANT: All dates in format \'yyyy/mm/dd\'</div><div class=\"separador\"></div><div id=\"grid1\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><div class=\"separador-horizontal\"><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-click=\"vm.selectItb()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"SELECT_ITB.SELECT_ITB\" translate-attr-aria-label=\"SELECT_ITB.SELECT_ITB\">Select ITB</div><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button></div></div><div class=\"separador\"></div>");
$templateCache.put("app/main/apps/workflow-bidder/receipt-itb/dialogs/select/select-dialog.html","<md-dialog class=\"select-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"RECEIPT_ITB.FORM_TITLE\">Confirm process</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate=\"\" translate-aria-label=\"RECEIPT_ITB.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><br><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"RECEIPT_ITB.REASON_REQUIRED\">The reason is required</label><br><textarea md-maxlength=\"250\" rows=\"20\" md-select-on-focus=\"\" name=\"rejectReason\" ng-model=\"vm.rejectReason\" placeholder=\"Reason\" translate=\"\" translate-attr-placeholder=\"RECEIPT_ITB.INSERT_TEXT\" required=\"\">\n                </textarea><div ng-messages=\"registerForm.rejectReason.$error\" ng-show=\"registerForm.rejectReason.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"RECEIPT_ITB.ERRORS.REJECT_REASON_REQUIRED\">Reason is required</span></div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"right center\"><md-button ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"RECEIPT_ITB.SEND\" translate-attr-aria-label=\"SELECT_ITB.SEND\">SEND</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/workflow-bidder/receipt-itb/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/receipt-itb/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"TECHNICAL_DOCS.TASKS_MENU\">Tasks Menu</span></div></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" ng-click=\"vm.redirectToUploadDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-1-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"TECHNICAL_DOCS.UPLOAD_DOCS\">Upload Docs</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToTechnicalDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-2-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"TECHNICAL_DOCS.TECHNICAL_DOCS\">Technical Documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToCommercialDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-3-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"TECHNICAL_DOCS.COMMERCIAL_DOCS\">Commercial Documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToGeneralInfo()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-4-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"COMMERCIAL_DOCS.GENERAL_INFO\">General Information</div></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/receipt-itb/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">ITB Detail</div><table class=\"simple\" ms-responsive-table=\"\"><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"reference\" ng-model=\"vm.form.reference\" placeholder=\"Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.REFERENCE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterers_reference\" ng-model=\"vm.form.charterers_reference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERERS_REFERENCE\" required=\"\"><div ng-messages=\"registerForm.charterers_reference.$error\" ng-show=\"registerForm.charterers_reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterer\" ng-model=\"vm.form.charterer\" placeholder=\"Charterer\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERER\" required=\"\"><div ng-messages=\"registerForm.charterer.$error\" ng-show=\"registerForm.charterer.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"title\" ng-model=\"vm.form.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.TITLE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"vessel_type\" ng-model=\"vm.form.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.VESSEL_TYPE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"location\" ng-model=\"vm.form.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.LOCATION\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"commencement\" ng-model=\"vm.form.commencement\" placeholder=\"Commencement\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.COMMENCEMENT\"><div ng-messages=\"registerForm.commencement.$error\" ng-show=\"registerForm.commencement.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.COMMENCEMENT_REQUIRED\">Commencement field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"closing_date\" ng-model=\"vm.form.closing_date\" placeholder=\"Closing Date\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CLOSING_DATE\"><div ng-messages=\"registerForm.closing_date.$error\" ng-show=\"registerForm.closing_date.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CLOSING_DATE_REQUIRED\">Closing Date field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.CANCEL\" translate-attr-aria-label=\"SELECT_ITB.CANCEL\" ng-click=\"vm.toggleView()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.SAVE\" translate-attr-aria-label=\"SELECT_ITB.SAVE\" ng-click=\"vm.toggleView()\">SAVE</md-button></div></form></table></div>");
$templateCache.put("app/main/apps/workflow-bidder/receipt-itb/views/list/list-view.html","<div class=\"message\">Receipt of ITB</div><table class=\"simple\" ms-responsive-table=\"\"><div id=\"grid1\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button class=\"grey-button\" aria-label=\"RECEIPT_ITB.DOWNLOAD_DOCS\" ng-click=\"vm.downloadFolderItbDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"RECEIPT_ITB.DOWNLOAD_DOCS\" translate-attr-aria-label=\"RECEIPT_ITB.DOWNLOAD_DOCS\">Download documents of the ITB</div><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button><div class=\"separador-horizontal\"></div><md-button type=\"submit\" class=\"red-button\" aria-label=\"DECLINE\" ng-disabled=\"vm.disableAcceptDeclineButtons\" ng-show=\"vm.showAcceptRejectButtons\" translate=\"RECEIPT_ITB.DECLINE\" translate-attr-aria-label=\"RECEIPT_ITB.DECLINE\" ng-click=\"vm.showConfirmRejectDialog($event)\">DECLINE</md-button><md-button class=\"green-button\" aria-label=\"ACCEPT\" ng-disabled=\"vm.disableAcceptDeclineButtons\" ng-show=\"vm.showAcceptRejectButtons\" translate=\"RECEIPT_ITB.ACCEPT\" translate-attr-aria-label=\"RECEIPT_ITB.ACCEPT\" ng-click=\"vm.showConfirmAcceptDialog($event)\">ACCEPT</md-button><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-show=\"vm.showBackNextButtons\" ng-click=\"vm.redirectToSelectItb()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s20 icon-white\"></md-icon><div class=\"title\" translate=\"RECEIPT_ITB.BACK\" translate-attr-aria-label=\"RECEIPT_ITB.BACK\">Back</div></div></md-button><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-show=\"vm.showBackNextButtons\" ng-click=\"vm.redirectToAddVessel()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"RECEIPT_ITB.NEXT\" translate-attr-aria-label=\"RECEIPT_ITB.NEXT\">Next</div><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button><div class=\"separador\"></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/index.html","<div class=\"doc-content\"><h1><code>material.components.autocomplete</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.bottomSheet/index.html","<div class=\"doc-content\"><h1><code>material.components.bottomSheet</code></h1><p>BottomSheet</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.button/index.html","<div class=\"doc-content\"><h1><code>material.components.button</code></h1><p>Button</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/index.html","<div class=\"doc-content\"><h1><code>material.components.chips</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.card/index.html","<div class=\"doc-content\"><h1><code>material.components.card</code></h1><p>Card components.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.checkbox/index.html","<div class=\"doc-content\"><h1><code>material.components.checkbox</code></h1><p>Checkbox module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.content/index.html","<div class=\"doc-content\"><h1><code>material.components.content</code></h1><p>Scrollable content</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/index.html","<div class=\"doc-content\"><h1><code>material.components.datepicker</code></h1><p>Datepicker</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/index.html","<div class=\"doc-content\"><h1><code>material.components.dialog</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabActions/index.html","<div class=\"doc-content\"><h1><code>material.components.fabActions</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.divider/index.html","<div class=\"doc-content\"><h1><code>material.components.divider</code></h1><p>Divider module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabSpeedDial/index.html","<div class=\"doc-content\"><h1><code>material.components.fabSpeedDial</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabToolbar/index.html","<div class=\"doc-content\"><h1><code>material.components.fabToolbar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabTrigger/index.html","<div class=\"doc-content\"><h1><code>material.components.fabTrigger</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/index.html","<div class=\"doc-content\"><h1><code>material.components.gridList</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/index.html","<div class=\"doc-content\"><h1><code>material.components.icon</code></h1><p>Icon</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/index.html","<div class=\"doc-content\"><h1><code>material.components.input</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu/index.html","<div class=\"doc-content\"><h1><code>material.components.menu</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/index.html","<div class=\"doc-content\"><h1><code>material.components.list</code></h1><p>List module</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu-bar/index.html","<div class=\"doc-content\"><h1><code>material.components.menu-bar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressCircular/index.html","<div class=\"doc-content\"><h1><code>material.components.progressCircular</code></h1><p>Circular Progress module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressLinear/index.html","<div class=\"doc-content\"><h1><code>material.components.progressLinear</code></h1><p>Linear Progress module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/index.html","<div class=\"doc-content\"><h1><code>material.components.radioButton</code></h1><p>radioButton module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.showHide/index.html","<div class=\"doc-content\"><h1><code>material.components.showHide</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.select/index.html","<div class=\"doc-content\"><h1><code>material.components.select</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/index.html","<div class=\"doc-content\"><h1><code>material.components.sidenav</code></h1><p>A Sidenav QP component.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.slider/index.html","<div class=\"doc-content\"><h1><code>material.components.slider</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sticky/index.html","<div class=\"doc-content\"><h1><code>material.components.sticky</code></h1><p>Sticky effects for md</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.subheader/index.html","<div class=\"doc-content\"><h1><code>material.components.subheader</code></h1><p>SubHeader module</p><p>Subheaders are special list tiles that delineate distinct sections of a list or grid list and are typically related to the current filtering or sorting criteria. Subheader tiles are either displayed inline with tiles or can be associated with content, for example, in an adjacent column.</p><p>Upon scrolling, subheaders remain pinned to the top of the screen and remain pinned until pushed on or off screen by the next subheader. @see <a href=\"https://www.google.com/design/spec/components/subheaders.html\">Material Design Specifications</a></p><blockquote><p>To improve the visual grouping of content, use the system color for your subheaders.</p></blockquote></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/index.html","<div class=\"doc-content\"><h1><code>material.components.swipe</code></h1><p>Swipe module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.switch/index.html","<div class=\"doc-content\"><h1><code>material.components.switch</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toast/index.html","<div class=\"doc-content\"><h1><code>material.components.toast</code></h1><p>Toast</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/index.html","<div class=\"doc-content\"><h1><code>material.components.tabs</code></h1><p>Tabs, created with the <code>&lt;md-tabs&gt;</code> directive provide <em>tabbed</em> navigation with different styles. The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.</p><p>Features include support for:</p><ul><li>static or dynamic tabs,</li><li>responsive designs,</li><li>accessibility support (ARIA),</li><li>tab pagination,</li><li>external or internal tab content,</li><li>focus indicators and arrow-key navigations,</li><li>programmatic lookup and access to tab controllers, and</li><li>dynamic transitions through different tab contents.</li></ul></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toolbar/index.html","<div class=\"doc-content\"><h1><code>material.components.toolbar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tooltip/index.html","<div class=\"doc-content\"><h1><code>material.components.tooltip</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/index.html","<div class=\"doc-content\"><h1><code>material.components.virtualRepeat</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.whiteframe/index.html","<div class=\"doc-content\"><h1><code>material.components.whiteframe</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.componentRegistry/index.html","<div class=\"doc-content\"><h1><code>material.core.componentRegistry</code></h1><p>A component instance registration service. Note: currently this as a private service in the SideNav component.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/index.html","<div class=\"doc-content\"><h1><code>material.core.ripple</code></h1><p>Ripple</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.util/index.html","<div class=\"doc-content\"><h1><code>material.core.util</code></h1><p>Util</p></div>");
$templateCache.put("app/main/pages/auth/bidder-profile/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/pages/auth/bidder-profile/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FM.FILE_MANAGER\">File Manager</span></div><div class=\"account\"><div class=\"title\">John Doe</div><md-select class=\"account-selection simplified\" ng-model=\"vm.selectedAccount\" placeholder=\"Select Account\"><md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select></div></div><div class=\"content\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.MY_FILES\">My Files</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.STARRED\">Starred</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.SHARRED_WITH_ME\">Sharred with me</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.RECENT\">Recent</div></div></md-button><md-button class=\"item\" aria-label=\"starred\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FM.OFFLINE\">Offline</div></div></md-button></div></div>");
$templateCache.put("app/main/pages/auth/bidder-profile/views/list/list-view.html","<div class=\"message\" layout=\"row\" layout-align=\"center center\">BIDDER List</div><div layout=\"row\" layout-align=\"center center\"><table class=\"simple\" ms-responsive-table=\"\"><div id=\"grid1\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table></div><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"DELETE\" ng-disabled=\"false\" translate=\"BIDDER_PROFILE.DELETE\" translate-attr-aria-label=\"BIDDER_PROFILE.DELETE\" ng-click=\"vm.deleteBidder()\">DELETE</md-button><md-button type=\"submit\" class=\"grey-button\" aria-label=\"MODIFY\" ng-disabled=\"false\" translate=\"BIDDER_PROFILE.MODIFY\" translate-attr-aria-label=\"BIDDER_PROFILE.MODIFY\" ng-click=\"vm.toggleView(\'modify\')\">MODIFY</md-button><md-button class=\"grey-button\" aria-label=\"INSERT\" ng-disabled=\"false\" translate=\"BIDDER_PROFILE.INSERT\" translate-attr-aria-label=\"BIDDER_PROFILE.INSERT\" ng-click=\"vm.toggleView(\'insert\')\">INSERT</md-button></div>");
$templateCache.put("app/main/pages/auth/bidder-profile/views/detail/detail-view-bidder.html","<div id=\"detail-view-BIDDER_PROFILE\"><div class=\"message\">BIDDER Detail</div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><form name=\"registerForm\" id=\"register-form\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.COMPANY\">Company</label> <input name=\"company\" ng-model=\"vm.selectedBidder.company\" placeholder=\"Company\" translate=\"\" translate-attr-placeholder=\"\" required=\"\"><div ng-messages=\"registerForm.company.$error\" ng-show=\"registerForm.company.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.COMPANY_REQUIRED\">Company Name field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.ADDRESS\">Address</label> <input name=\"address\" ng-model=\"vm.selectedBidder.address\" placeholder=\"Address\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.CITY\">City</label> <input name=\"city\" ng-model=\"vm.selectedBidder.city\" placeholder=\"City\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.POSTCODE\">PostCode</label> <input name=\"postcode\" ng-model=\"vm.selectedBidder.postcode\" placeholder=\"PostCode\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.COUNTRY\">Country</label> <input name=\"country\" ng-model=\"vm.selectedBidder.country\" placeholder=\"Country\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container><div id=\"contact-layer\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.MAIN_CONTACT\">Main Contact</label> <input name=\"maincontact\" ng-model=\"vm.selectedBidder.maincontact\" placeholder=\"Main Contact\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.MAIN_EMAIL\">Main E-mail</label> <input type=\"email\" name=\"email\" ng-model=\"vm.selectedBidder.email\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\" ng-pattern=\"/^.+@.+\\..+$/\" required=\"\"><div ng-messages=\"registerForm.email.$error\" ng-show=\"registerForm.email.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.EMAIL_REQUIRED\">E-mail field is required</span></div><div ng-message=\"pattern\"><span translate=\"BIDDER_PROFILE.ERRORS.EMAIL_MUST_VALID\">E-mail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PASSWORD\">Password</label> <input type=\"password\" name=\"password\" ng-model=\"vm.selectedBidder.password\" placeholder=\"\" ng-minlength=\"6\" translate=\"\" translate-attr-placeholder=\"\" required=\"\"><div ng-messages=\"registerForm.password.$error\" ng-show=\"registerForm.password.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"minlength\"><span translate=\"BIDDER_PROFILE.ERRORS.MIN_LENGTH\">At least 6 characters are required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PASSWORD_CONFIRM\">Password (confirm)</label> <input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.passwordConfirm\" ng-minlength=\"6\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\" required=\"\"><div ng-messages=\"registerForm.passwordConfirm.$error\" ng-show=\"registerForm.passwordConfirm.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (confirm) field is required</span></div><div ng-message=\"minlength\"><span translate=\"BIDDER_PROFILE.ERRORS.MIN_LENGTH\">At least 6 characters are required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.MAIN_PHONE\">Main Phone</label> <input name=\"mainphone\" ng-model=\"vm.selectedBidder.mainphone\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container></div><div id=\"contact-layer\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.NAME_1\">Name 2</label> <input name=\"name1\" ng-model=\"vm.selectedBidder.name1\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.EMAIL_1\">E-mail 2</label> <input type=\"email\" name=\"email1\" ng-model=\"vm.selectedBidder.email1\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email1.$error\" ng-show=\"registerForm.email1.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.EMAIL_REQUIRED\">E-mail field is required</span></div><div ng-message=\"pattern\"><span translate=\"BIDDER_PROFILE.ERRORS.EMAIL_MUST_VALID\">E-mail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PASSWORD_1\">Password 2</label> <input type=\"password\" name=\"password1\" ng-model=\"vm.selectedBidder.password1\" placeholder=\"\" ng-minlength=\"6\" translate=\"\" translate-attr-placeholder=\"\"><div ng-messages=\"registerForm.password1.$error\" ng-show=\"registerForm.password1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"minlength\"><span translate=\"BIDDER_PROFILE.ERRORS.MIN_LENGTH\">At least 6 characters are required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PASSWORD_CONFIRM_1\">Password 2 (confirm)</label> <input type=\"password\" name=\"passwordConfirm1\" ng-model=\"vm.passwordConfirm1\" ng-minlength=\"6\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"><div ng-messages=\"registerForm.passwordConfirm1.$error\" ng-show=\"registerForm.passwordConfirm1.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div ng-message=\"minlength\"><span translate=\"BIDDER_PROFILE.ERRORS.MIN_LENGTH\">At least 6 characters are required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PHONE_1\">Phone 2</label> <input name=\"phone1\" ng-model=\"vm.selectedBidder.phone1\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container></div><div id=\"contact-layer\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.NAME_2\">Name 3</label> <input name=\"name2\" ng-model=\"vm.selectedBidder.name2\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.EMAIL_2\">E-mail 3</label> <input type=\"email\" name=\"email2\" ng-model=\"vm.selectedBidder.email2\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email2.$error\" ng-show=\"registerForm.email2.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.EMAIL_REQUIRED\">E-mail field is required</span></div><div ng-message=\"pattern\"><span translate=\"BIDDER_PROFILE.ERRORS.EMAIL_MUST_VALID\">E-mail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PASSWORD_2\">Password 3</label> <input type=\"password\" name=\"password2\" ng-model=\"vm.selectedBidder.password2\" placeholder=\"\" ng-minlength=\"6\" translate=\"\" translate-attr-placeholder=\"\"><div ng-messages=\"registerForm.password2.$error\" ng-show=\"registerForm.password2.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"minlength\"><span translate=\"BIDDER_PROFILE.ERRORS.MIN_LENGTH\">At least 6 characters are required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PASSWORD_CONFIRM_2\">Password 3 (confirm)</label> <input type=\"password\" name=\"passwordConfirm2\" ng-model=\"vm.passwordConfirm2\" ng-minlength=\"6\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"><div ng-messages=\"registerForm.passwordConfirm2.$error\" ng-show=\"registerForm.passwordConfirm2.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div ng-message=\"minlength\"><span translate=\"BIDDER_PROFILE.ERRORS.MIN_LENGTH\">At least 6 characters are required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PHONE_2\">Phone 3</label> <input name=\"phone2\" ng-model=\"vm.selectedBidder.phone2\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container></div><div id=\"contact-layer\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.NAME_3\">Name 4</label> <input name=\"name3\" ng-model=\"vm.selectedBidder.name3\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.EMAIL_3\">E-mail 4</label> <input type=\"email\" name=\"email3\" ng-model=\"vm.selectedBidder.email3\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email3.$error\" ng-show=\"registerForm.email3.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.EMAIL_REQUIRED\">E-mail 3 field is required</span></div><div ng-message=\"pattern\"><span translate=\"BIDDER_PROFILE.ERRORS.EMAIL_MUST_VALID\">E-mail 3 must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PASSWORD_3\">Password 4</label> <input type=\"password\" name=\"password3\" ng-model=\"vm.selectedBidder.password3\" placeholder=\"\" ng-minlength=\"6\" translate=\"\" translate-attr-placeholder=\"\"><div ng-messages=\"registerForm.password3.$error\" ng-show=\"registerForm.password3.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"minlength\"><span translate=\"BIDDER_PROFILE.ERRORS.MIN_LENGTH\">At least 6 characters are required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PASSWORD_CONFIRM_3\">Password 4 (confirm)</label> <input type=\"password\" name=\"passwordConfirm3\" ng-model=\"vm.passwordConfirm3\" ng-minlength=\"6\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"><div ng-messages=\"registerForm.passwordConfirm3.$error\" ng-show=\"registerForm.passwordConfirm3.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div ng-message=\"minlength\"><span translate=\"BIDDER_PROFILE.ERRORS.MIN_LENGTH\">At least 6 characters are required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PHONE_3\">Phone 4</label> <input name=\"phone3\" ng-model=\"vm.selectedBidder.phone3\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container></div><div id=\"contact-layer\"><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.NAME_4\">Name 5</label> <input name=\"name4\" ng-model=\"vm.selectedBidder.name4\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.EMAIL_4\">E-mail 5</label> <input type=\"email\" name=\"email4\" ng-model=\"vm.selectedBidder.email4\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\" ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"registerForm.email4.$error\" ng-show=\"registerForm.email4.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.EMAIL_REQUIRED\">E-mail 4 field is required</span></div><div ng-message=\"pattern\"><span translate=\"BIDDER_PROFILE.ERRORS.EMAIL_MUST_VALID\">E-mail 4 must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PASSWORD_4\">Password 5</label> <input type=\"password\" name=\"password4\" ng-model=\"vm.selectedBidder.password4\" placeholder=\"\" ng-minlength=\"6\" translate=\"\" translate-attr-placeholder=\"\"><div ng-messages=\"registerForm.password4.$error\" ng-show=\"registerForm.password4.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"minlength\"><span translate=\"BIDDER_PROFILE.ERRORS.MIN_LENGTH\">At least 6 characters are required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PASSWORD_CONFIRM_4\">Password 5 (confirm)</label> <input type=\"password\" name=\"passwordConfirm4\" ng-model=\"vm.passwordConfirm4\" ng-minlength=\"6\" placeholder=\"\" translate=\"\" translate-attr-placeholder=\"\"><div ng-messages=\"registerForm.passwordConfirm4.$error\" ng-show=\"registerForm.passwordConfirm4.$touched\" role=\"alert\" multiple=\"\"><div ng-message=\"required\"><span translate=\"BIDDER_PROFILE.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div><div ng-message=\"minlength\"><span translate=\"BIDDER_PROFILE.ERRORS.MIN_LENGTH\">At least 6 characters are required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><label translate=\"BIDDER_PROFILE.PHONE_4\">Phone 5</label> <input name=\"phone4\" ng-model=\"vm.selectedBidder.phone4\" placeholder=\"Phone 4\" translate=\"\" translate-attr-placeholder=\"\"></md-input-container></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" translate=\"BIDDER_PROFILE.CANCEL\" translate-attr-aria-label=\"BIDDER_PROFILE.CANCEL\" ng-click=\"vm.cancel()\">CANCEL</md-button><md-button type=\"submit\" class=\"grey-button\" aria-label=\"SAVE\" ng-disabled=\"registerForm.$invalid\" translate=\"BIDDER_PROFILE.SAVE\" translate-attr-aria-label=\"BIDDER_PROFILE.SAVE\" ng-click=\"vm.saveBidder()\">SAVE</md-button></div></form></div></div>");
$templateCache.put("app/main/pages/auth/login/dialogs/select-bidders/select-bidders-dialog.html","<md-dialog class=\"select-bidders-dialog\" aria-label=\"New communication\"><form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"\">BIDDER SELECTION</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate=\"\" translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div ng-show=\"!vm.addressBookVisible\"><md-dialog-content ms-scroll=\"\"><br><md-input-container class=\"md-block\" md-no-float=\"\"><md-select name=\"bidder\" placeholder=\"Select a Bidder\" ng-model=\"vm.selectedBidder\" md-on-close=\"vm.assignBidderName(selectedBidderKey)\"><md-option ng-value=\"bidder\" ng-repeat=\"bidder in vm.bidders\">{{bidder.company}}</md-option></md-select><div ng-messages=\"registerForm.bidder_key.$error\" ng-show=\"registerForm.bidder_key.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.BIDDER_REQUIRED\">Bidder field is required</span></div></div></md-input-container><br><br><br><br></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.selectBidder(vm.selectedBidder)\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"\" translate-attr-aria-label=\"\">SELECT BIDDER</md-button></div></md-dialog-actions></div></form></md-dialog>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/sidenavs/settings/menus/color/color-menu.html","<div class=\"header md-whiteframe-2dp\"><md-list><md-list-item class=\"selected-color\"><p class=\"title\" flex=\"\">Selected Color:</p><div ng-if=\"!vm.board.settings.color\" class=\"preview md-background-bg md-hue-1\"></div><div ng-if=\"vm.board.settings.color\" class=\"preview\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\">{{vm.board.settings.color}}</div><md-button class=\"md-icon-button\" ng-click=\"vm.board.settings.color = \'\'\" aria-label=\"Default Color\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button></md-list-item></md-list></div><div flex=\"\" class=\"content\" ms-scroll=\"\" ms-sidenav-helper=\"\"><md-list><md-list-item class=\"color\" ng-repeat=\"(paletteName, palette) in vm.palettes\" ng-click=\"vm.board.settings.color = paletteName\" ng-class=\"\'md-\'+paletteName+\'-bg\'\" aria-label=\"color select\"><p flex=\"\">{{paletteName}}</p><i class=\"icon-check s16\" ng-if=\"paletteName === vm.board.settings.color\"></i></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/sidenavs/settings/menus/labels/labels-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Label</md-subheader><md-list-item class=\"label\"><div layout=\"row\" layout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"vm.newLabelColor+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" aria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i></label></div></md-menu-content></md-menu><span editable-text=\"vm.newLabelName\" e-form=\"newLabelForm\" onaftersave=\"vm.addNewLabel()\"></span><p flex=\"\" class=\"title new-label-form-button\" ng-click=\"newLabelForm.$show()\" ng-hide=\"newLabelForm.$visible\">Enter New Label Name</p></div></md-list-item><md-divider></md-divider><md-list-item class=\"label\" ng-repeat=\"label in vm.board.labels\"><div layout=\"row\" layout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap=\"\"><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" ng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" layout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"label.color\" ng-value=\"palette\" aria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i></label></div></md-menu-content></md-menu><p flex=\"\" class=\"title\" editable-text=\"label.name\">{{label.name}}</p><md-button ng-click=\"vm.removeLabel($event, label.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/sidenavs/settings/menus/members/members-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Member</md-subheader><md-list-item class=\"add-new-member\"><form ng-submit=\"vm.newMember()\" layout=\"row\" layout-align=\"start center\"><input flex=\"\" placeholder=\"Type Member Name\" type=\"text\" ng-model=\"vm.newMemberSearchInput\"><md-button type=\"submit\" class=\"md-accent md-raised\" aria-label=\"Add New Member\">Add</md-button></form></md-list-item><md-divider></md-divider><md-list-item class=\"member\" ng-repeat=\"member in vm.board.members\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p class=\"member-name\">{{ member.name }}</p><md-button ng-click=\"vm.removeMember($event, member.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></md-list-item></md-list>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/views/calendar/dialogs/event/event-dialog.html","<md-dialog class=\"event-calendar-dialog\" aria-label=\"Event Dialog\" ng-cloak=\"\"><md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">{{vm.eventDate | date}}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\" layout=\"column\"><md-tabs md-dynamic-height=\"\"><md-tab><md-tab-label>Add New Card</md-tab-label><md-tab-body><div class=\"new-card-tab-content\"><md-subheader class=\"md-no-sticky\">Card Name</md-subheader><md-input-container layout=\"row\" class=\"new-card-name\" md-no-float=\"\"><input ng-model=\"vm.newCardName\" placeholder=\"Type card name..\" type=\"text\"></md-input-container><md-list class=\"lists\"><md-subheader class=\"md-no-sticky\">Select List</md-subheader><md-content class=\"lists-content\" flex=\"\" ms-scroll=\"\"><md-list-item ng-repeat=\"list in vm.board.lists\" ng-click=\"vm.newCardListId = list.id\"><p class=\"list-name\">{{list.name}}</p><md-checkbox ng-checked=\"vm.newCardListId === list.id\" class=\"md-secondary\" ng-click=\"vm.newCardListId = list.id\" aria-label=\"list\"></md-checkbox></md-list-item></md-content></md-list><div class=\"\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.addNewCard()\" ng-disabled=\"vm.newCardName === \'\' || vm.newCardListId === \'\'\" aria-label=\"add\">Add</md-button></div></div></md-tab-body></md-tab><md-tab><md-tab-label>Assign The Date to Cards</md-tab-label><md-tab-body><div class=\"assign-due-date-tab-content\"><md-list class=\"cards\"><md-subheader class=\"md-no-sticky\">Select Cards</md-subheader><md-content class=\"cards-content\" flex=\"\" ms-scroll=\"\"><md-list-item class=\"card\" ng-repeat=\"card in vm.board.cards\" ng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" aria-label=\"card\"><p layout=\"column\" layout-align=\"start start\"><span class=\"card-name\">{{card.name}}</span> <span class=\"card-date\">{{card.due | date}}</span></p><md-checkbox ng-checked=\"vm.exists(card.id, vm.selectedCards)\" ng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" class=\"md-secondary\" aria-label=\"card\"></md-checkbox></md-list-item></md-content></md-list><div layout=\"row\" layout-align=\"end center\"><md-button ng-disabled=\"!vm.selectedCards[0]\" ng-click=\"vm.assignDueDate()\" class=\"md-accent md-raised\" aria-label=\"assign\">Assign</md-button></div></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/scrumboard_DESHABILITADO/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html","<div class=\"md-title sidenav-title\">Scheduled Cards</div><div class=\"cards\"><div ng-if=\"vm.cards.length <= 0\"><span translate=\"SB.NO_SCHEDULED_CARD\">There is no scheduled card.</span></div><div class=\"card\" layout=\"row\" ng-repeat=\"card in vm.cards\"><md-button class=\"md-raised card-date\" ng-click=\"vm.goToDate(card.start)\"><div class=\"day-in-week\">{{card.start | date:\'EEEE\'}}</div><div class=\"day\">{{card.start | date:\'d\' }}</div><div class=\"month-year\">{{card.start | date:\'MMM yyyy\'}}</div></md-button><div class=\"card-title\" flex=\"\" layout=\"column\" layout-align=\"center start\" ng-click=\"vm.openCardDialog($event, card.idCard)\"><span>{{card.title}}</span></div></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/pending-bcf/dialogs/compose/answer-bcf-dialog.html","<md-dialog class=\"answer-bcf-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" translate=\"PENDING_BCF.DIALOG_TITLE\">BCF reply</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate=\"\" translate-aria-label=\"PENDING_BCF.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll=\"\"><md-input-container class=\"md-block\"><label translate=\"PENDING_BCF.SUBJECT\">Subject</label> <input ng-readonly=\"true\" ng-model=\"vm.form.subject\" type=\"text\"></md-input-container><text-angular ng-model=\"vm.form.message\"></text-angular></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.sendMail(\'communication\')\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"PENDING_BCF.SEND\" translate-attr-aria-label=\"PENDING_BCF.SEND\">SEND</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/bcf-docs/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/bcf-docs/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"BCF_DOCS.TASKS_MENU\">Tasks Menu</span></div></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToPendingBcf()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-1-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"BCF_DOCS.PENDING_BCF\">Pending BCF</div></div></md-button><md-button class=\"item\" aria-label=\"inbox\" ng-click=\"vm.redirectToBcfDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-2-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"BCF_DOCS.BCF_DOCS\">BCF documents</div></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/bcf-docs/views/list/list-view.html","<div class=\"message\">Attachments</div><table class=\"simple\" ms-responsive-table=\"\"><div class=\"comment\" data-ng-bind-html=\"vm.bcfDocsComments\"></div><div class=\"separador\"></div><div id=\"grid\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"red-button\" aria-label=\"DELETE_FILE\" ng-disabled=\"vm.disableDropboxButtons\" translate=\"BCF_DOCS.DELETE_FILE\" translate-attr-aria-label=\"BCF.DELETE_FILE\" ng-click=\"vm.showConfirmDeleteDialog($event)\">DELETE FILE</md-button><md-button class=\"grey-button\" ng-click=\"vm.viewFile()\" ng-disabled=\"vm.disableDropboxButtons\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"BCF_DOCS.VIEW_DOC\" translate-attr-aria-label=\"BCF_DOCS.VIEW_DOC\">VIEW DOCUMENT</div><md-icon md-font-icon=\"icon-magnify\" class=\"s20 icon-white\"></md-icon></div></md-button><input type=\"file\" id=\"fileInput\" ng-change=\"vm.uploadFile(vm.fileUploaded)\" class=\"ng-hide\" ngf-select=\"\" ng-model=\"vm.fileUploaded\" ngf-accept=\"\'*/*\'\" required=\"\"><md-button class=\"grey-button\" ng-click=\"vm.selectFile()\" ng-disabled=\"vm.disableDropboxButtons\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"BCF_DOCS.UPLOAD_FILE\" translate-attr-aria-label=\"BCF_DOCS.UPLOAD_FILE\">UPLOAD FILE</div><md-icon md-font-icon=\"icon-paperclip\" class=\"s20 icon-white\"></md-icon></div></md-button><div class=\"separador-horizontal\"></div><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToSelectItb()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s20 icon-white\"></md-icon><div class=\"title\" translate=\"BCF_DOCS.BACK\" translate-attr-aria-label=\"BCF_DOCS.BACK\">Back</div></div></md-button></div><div class=\"separador\"></div>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/bcf-docs/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">ITB Detail</div><table class=\"simple\" ms-responsive-table=\"\"><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"reference\" ng-model=\"vm.form.reference\" placeholder=\"Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.REFERENCE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterers_reference\" ng-model=\"vm.form.charterers_reference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERERS_REFERENCE\" required=\"\"><div ng-messages=\"registerForm.charterers_reference.$error\" ng-show=\"registerForm.charterers_reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterer\" ng-model=\"vm.form.charterer\" placeholder=\"Charterer\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERER\" required=\"\"><div ng-messages=\"registerForm.charterer.$error\" ng-show=\"registerForm.charterer.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"title\" ng-model=\"vm.form.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.TITLE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"vessel_type\" ng-model=\"vm.form.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.VESSEL_TYPE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"location\" ng-model=\"vm.form.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.LOCATION\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"commencement\" ng-model=\"vm.form.commencement\" placeholder=\"Commencement\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.COMMENCEMENT\"><div ng-messages=\"registerForm.commencement.$error\" ng-show=\"registerForm.commencement.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.COMMENCEMENT_REQUIRED\">Commencement field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"closing_date\" ng-model=\"vm.form.closing_date\" placeholder=\"Closing Date\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CLOSING_DATE\"><div ng-messages=\"registerForm.closing_date.$error\" ng-show=\"registerForm.closing_date.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CLOSING_DATE_REQUIRED\">Closing Date field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.CANCEL\" translate-attr-aria-label=\"SELECT_ITB.CANCEL\" ng-click=\"vm.toggleView()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.SAVE\" translate-attr-aria-label=\"SELECT_ITB.SAVE\" ng-click=\"vm.toggleView()\">SAVE</md-button></div></form></table></div>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/pending-bcf/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/pending-bcf/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"PENDING_BCF.TASKS_MENU\">Tasks Menu</span></div></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToPendingBcf()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-1-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"PENDING_BCF.PENDING_BCF\">Pending BCF</div></div></md-button><md-button class=\"item\" aria-label=\"inbox\" ng-click=\"vm.redirectToBcfDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-2-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"PENDING_BCF.BCF_DOCS\">BCF documents</div></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/pending-bcf/views/list/list-view.html","<div class=\"message\">Completion of any BCF - Pending BCF</div><table class=\"simple\" ms-responsive-table=\"\"><div id=\"grid1\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"grey-button\" aria-label=\"PRINT_REPORT\" ng-disabled=\"false\" translate=\"PENDING_BCF.PRINT_REPORT\" translate-attr-aria-label=\"PENDING_BCF.PRINT_REPORT\" ng-click=\"\">PRINT REPORT</md-button><md-button type=\"submit\" class=\"grey-button\" aria-label=\"PENDING_BCF.ANSWER_BID_CLARIFICATION\" ng-disabled=\"false\" translate=\"PENDING_BCF.ANSWER_BID_CLARIFICATION\" translate-attr-aria-label=\"PENDING_BCF.ANSWER_BID_CLARIFICATION\" ng-click=\"vm.answerBcfDialog($event)\">ANSWER BID CLARIFICATION</md-button><div class=\"separador-horizontal\"></div><md-button class=\"green-button\" aria-label=\"\" ng-disabled=\"false\" ng-click=\"vm.redirectToSelectItb()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s20 icon-white\"></md-icon><div class=\"title\" translate=\"PENDING_BCF.BACK\" translate-attr-aria-label=\"PENDING_BCF.BACK\">Back</div></div></md-button><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToBcfDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"PENDING_BCF.NEXT\" translate-attr-aria-label=\"PENDING_BCF.NEXT\">Next</div><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button></div><div class=\"separador\"></div>");
$templateCache.put("app/main/apps/workflow-bidder/completion-bcf/pending-bcf/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">ITB Detail</div><table class=\"simple\" ms-responsive-table=\"\"><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"reference\" ng-model=\"vm.form.reference\" placeholder=\"Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.REFERENCE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterers_reference\" ng-model=\"vm.form.charterers_reference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERERS_REFERENCE\" required=\"\"><div ng-messages=\"registerForm.charterers_reference.$error\" ng-show=\"registerForm.charterers_reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterer\" ng-model=\"vm.form.charterer\" placeholder=\"Charterer\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERER\" required=\"\"><div ng-messages=\"registerForm.charterer.$error\" ng-show=\"registerForm.charterer.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"title\" ng-model=\"vm.form.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.TITLE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"vessel_type\" ng-model=\"vm.form.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.VESSEL_TYPE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"location\" ng-model=\"vm.form.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.LOCATION\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"commencement\" ng-model=\"vm.form.commencement\" placeholder=\"Commencement\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.COMMENCEMENT\"><div ng-messages=\"registerForm.commencement.$error\" ng-show=\"registerForm.commencement.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.COMMENCEMENT_REQUIRED\">Commencement field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"closing_date\" ng-model=\"vm.form.closing_date\" placeholder=\"Closing Date\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CLOSING_DATE\"><div ng-messages=\"registerForm.closing_date.$error\" ng-show=\"registerForm.closing_date.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CLOSING_DATE_REQUIRED\">Closing Date field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.CANCEL\" translate-attr-aria-label=\"SELECT_ITB.CANCEL\" ng-click=\"vm.toggleView()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.SAVE\" translate-attr-aria-label=\"SELECT_ITB.SAVE\" ng-click=\"vm.toggleView()\">SAVE</md-button></div></form></table></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/add-vessel/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/add-vessel/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"ADD_VESSEL.TASKS_MENU\">Tasks Menu</span></div></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" ng-click=\"vm.redirectToAddVessel()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-1-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"ADD_VESSEL.ADD_VESSEL\">Add Vessel</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredTechnicalDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-2-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_TECHNICAL_DOCS\">Required technical documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredCommercialDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-3-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_COMMERCIAL_DOCS\">Required commercial documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredGeneralDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-4-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_GENERAL_DOCS\">Required general documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToOtherDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-5-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"ADD_VESSEL.OTHER_DOCS\">Other Documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToFinishUpload()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-6-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FINISH_UPLOAD.FINISH_UPLOAD\">Finish Upload</div></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/add-vessel/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">Submission of Bid - Vessel Detail</div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><form name=\"registerForm\" id=\"register-form\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"vesselName\" ng-model=\"vm.vesselName\" placeholder=\"Vessel name\" translate=\"\" translate-attr-placeholder=\"ADD_VESSEL.VESSEL_NAME\" required=\"\"><div ng-messages=\"registerForm.vesselName.$error\" ng-show=\"registerForm.vesselName.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"ADD_VESSEL.ERRORS.VESSEL_NAME_REQUIRED\">Vessel name field is required</span></div></div></md-input-container><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ADD_VESSEL.CANCEL\" translate-attr-aria-label=\"ADD_VESSEL.CANCEL\" ng-click=\"vm.cancel()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"ADD_VESSEL.SAVE\" translate-attr-aria-label=\"ADD_VESSEL.SAVE\" ng-click=\"vm.checkNotExistVesselAndSave(vm.vesselName)\">SAVE</md-button></div></form></div></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/add-vessel/views/list/list-view.html","<div class=\"message\">Submission of Bid - Add Vessel</div><table class=\"simple\" ms-responsive-table=\"\"><div class=\"comment\" data-ng-bind-html=\"vm.addVesselComments\"></div><div class=\"separador\"></div><div id=\"grid\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"red-button\" aria-label=\"DELETE_VESSEL\" ng-disabled=\"false\" translate=\"ADD_VESSEL.DELETE_VESSEL\" translate-attr-aria-label=\"ADD_VESSEL.DELETE_VESSEL\" ng-click=\"vm.showConfirmDeleteDialog($event)\">DELETE VESSEL</md-button><md-button type=\"submit\" class=\"grey-button\" aria-label=\"NEW_VESSEL\" ng-disabled=\"false\" translate=\"ADD_VESSEL.NEW_VESSEL\" translate-attr-aria-label=\"ADD_VESSEL.NEW_VESSEL\" ng-click=\"vm.newVessel()\">NEW VESSEL</md-button><div class=\"separador-horizontal\"></div><md-button class=\"green-button\" aria-label=\"\" ng-disabled=\"false\" ng-click=\"vm.redirectToReceiptItb()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s20 icon-white\"></md-icon><div class=\"title\" translate=\"ADD_VESSEL.BACK\" translate-attr-aria-label=\"ADD_VESSEL.BACK\">Back</div></div></md-button><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToRequiredTechnicalDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"ADD_VESSEL.NEXT\" translate-attr-aria-label=\"ADD_VESSEL.NEXT\">Next</div><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button></div><div class=\"separador\"></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/finish-upload/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/finish-upload/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"FINISH_UPLOAD.TASKS_MENU\">Tasks Menu</span></div></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" ng-click=\"vm.redirectToAddVessel()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-1-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"ADD_VESSEL.ADD_VESSEL\">Add Vessel</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredTechnicalDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-2-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_TECHNICAL_DOCS\">Required technical documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredCommercialDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-3-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_COMMERCIAL_DOCS\">Required commercial documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredGeneralDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-4-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_GENERAL_DOCS\">Required general documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToOtherDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-5-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"OTHER_DOCS.OTHER_DOCS\">Other Documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToFinishUpload()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-6-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FINISH_UPLOAD.FINISH_UPLOAD\">Finish Upload</div></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/finish-upload/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">ITB Detail</div><table class=\"simple\" ms-responsive-table=\"\"><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"reference\" ng-model=\"vm.form.reference\" placeholder=\"Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.REFERENCE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterers_reference\" ng-model=\"vm.form.charterers_reference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERERS_REFERENCE\" required=\"\"><div ng-messages=\"registerForm.charterers_reference.$error\" ng-show=\"registerForm.charterers_reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterer\" ng-model=\"vm.form.charterer\" placeholder=\"Charterer\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERER\" required=\"\"><div ng-messages=\"registerForm.charterer.$error\" ng-show=\"registerForm.charterer.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"title\" ng-model=\"vm.form.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.TITLE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"vessel_type\" ng-model=\"vm.form.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.VESSEL_TYPE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"location\" ng-model=\"vm.form.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.LOCATION\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"commencement\" ng-model=\"vm.form.commencement\" placeholder=\"Commencement\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.COMMENCEMENT\"><div ng-messages=\"registerForm.commencement.$error\" ng-show=\"registerForm.commencement.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.COMMENCEMENT_REQUIRED\">Commencement field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"closing_date\" ng-model=\"vm.form.closing_date\" placeholder=\"Closing Date\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CLOSING_DATE\"><div ng-messages=\"registerForm.closing_date.$error\" ng-show=\"registerForm.closing_date.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CLOSING_DATE_REQUIRED\">Closing Date field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.CANCEL\" translate-attr-aria-label=\"SELECT_ITB.CANCEL\" ng-click=\"vm.toggleView()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.SAVE\" translate-attr-aria-label=\"SELECT_ITB.SAVE\" ng-click=\"vm.toggleView()\">SAVE</md-button></div></form></table></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/finish-upload/views/list/list-view.html","<div class=\"message\">Submission of Bid - Finish Upload</div><table class=\"simple\" ms-responsive-table=\"\"><div class=\"comment\" data-ng-bind-html=\"vm.finishUploadComments\"></div><div class=\"separador\"></div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"red-button\" aria-label=\"COMPLETE_UPLOAD_OF_DOCUMENTS\" ng-disabled=\"vm.disableCompleteUploadDocumentsButton\" translate=\"FINISH_UPLOAD.COMPLETE_UPLOAD_OF_DOCUMENTS\" translate-attr-aria-label=\"FINISH_UPLOAD.COMPLETE_UPLOAD_OF_DOCUMENTS\" ng-click=\"vm.showConfirmFinishUploadDialog($event)\">COMPLETE UPLOAD OF DOCUMENTS</md-button><div class=\"separador-horizontal\"></div><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToOtherDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s20 icon-white\"></md-icon><div class=\"title\" translate=\"FINISH_UPLOAD.BACK\" translate-attr-aria-label=\"FINISH_UPLOAD.BACK\">Back</div></div></md-button></div><div class=\"separador\"></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/other-docs/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/other-docs/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"OTHER_DOCS.TASKS_MENU\">Tasks Menu</span></div></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" ng-click=\"vm.redirectToAddVessel()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-1-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"OTHER_DOCS.ADD_VESSEL\">Add Vessel</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredTechnicalDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-2-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_TECHNICAL_DOCS\">Required technical documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredCommercialDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-3-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_COMMERCIAL_DOCS\">Required commercial documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredGeneralDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-4-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_GENERAL_DOCS\">Required general documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToOtherDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-5-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"OTHER_DOCS.OTHER_DOCS\">Other Documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToFinishUpload()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-6-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FINISH_UPLOAD.FINISH_UPLOAD\">Finish Upload</div></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/other-docs/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">ITB Detail</div><table class=\"simple\" ms-responsive-table=\"\"><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"reference\" ng-model=\"vm.form.reference\" placeholder=\"Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.REFERENCE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterers_reference\" ng-model=\"vm.form.charterers_reference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERERS_REFERENCE\" required=\"\"><div ng-messages=\"registerForm.charterers_reference.$error\" ng-show=\"registerForm.charterers_reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterer\" ng-model=\"vm.form.charterer\" placeholder=\"Charterer\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERER\" required=\"\"><div ng-messages=\"registerForm.charterer.$error\" ng-show=\"registerForm.charterer.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"title\" ng-model=\"vm.form.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.TITLE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"vessel_type\" ng-model=\"vm.form.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.VESSEL_TYPE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"location\" ng-model=\"vm.form.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.LOCATION\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"commencement\" ng-model=\"vm.form.commencement\" placeholder=\"Commencement\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.COMMENCEMENT\"><div ng-messages=\"registerForm.commencement.$error\" ng-show=\"registerForm.commencement.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.COMMENCEMENT_REQUIRED\">Commencement field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"closing_date\" ng-model=\"vm.form.closing_date\" placeholder=\"Closing Date\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CLOSING_DATE\"><div ng-messages=\"registerForm.closing_date.$error\" ng-show=\"registerForm.closing_date.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CLOSING_DATE_REQUIRED\">Closing Date field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.CANCEL\" translate-attr-aria-label=\"SELECT_ITB.CANCEL\" ng-click=\"vm.toggleView()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.SAVE\" translate-attr-aria-label=\"SELECT_ITB.SAVE\" ng-click=\"vm.toggleView()\">SAVE</md-button></div></form></table></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/other-docs/views/list/list-view.html","<div class=\"message\">Submission of Bid - Other documents</div><table class=\"simple\" ms-responsive-table=\"\"><div class=\"comment\" data-ng-bind-html=\"vm.otherDocsComments\"></div><div class=\"separador\"></div><div id=\"grid\" class=\"gridStyle\" ui-grid=\"vm.gridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"red-button\" aria-label=\"DELETE_FILE\" ng-disabled=\"vm.disableDropboxButtons\" translate=\"OTHER_DOCS.DELETE_FILE\" translate-attr-aria-label=\"OTHER_DOCS.DELETE_FILE\" ng-click=\"vm.showConfirmDeleteDialog($event)\">DELETE FILE</md-button><md-button class=\"grey-button\" ng-click=\"vm.viewFile()\" ng-disabled=\"vm.disableDropboxButtons\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"OTHER_DOCS.VIEW_DOC\" translate-attr-aria-label=\"OTHER_DOCS.VIEW_DOC\">VIEW DOCUMENT</div><md-icon md-font-icon=\"icon-magnify\" class=\"s20 icon-white\"></md-icon></div></md-button><input type=\"file\" id=\"fileInput\" ng-change=\"vm.uploadFile(vm.fileUploaded)\" class=\"ng-hide\" ngf-select=\"\" ng-model=\"vm.fileUploaded\" ngf-accept=\"\'*/*\'\" required=\"\"><md-button class=\"grey-button\" ng-click=\"vm.selectFile()\" ng-disabled=\"vm.disableDropboxButtons\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"OTHER_DOCS.UPLOAD_FILE\" translate-attr-aria-label=\"OTHER_DOCS.UPLOAD_FILE\">UPLOAD FILE</div><md-icon md-font-icon=\"icon-paperclip\" class=\"s20 icon-white\"></md-icon></div></md-button><div class=\"separador-horizontal\"></div><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToRequiredGeneralDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s20 icon-white\"></md-icon><div class=\"title\" translate=\"OTHER_DOCS.BACK\" translate-attr-aria-label=\"OTHER_DOCS.BACK\">Back</div></div></md-button><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToFinishUpload()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"OTHER_DOCS.NEXT\" translate-attr-aria-label=\"OTHER_DOCS.NEXT\">Next</div><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button></div><div class=\"separador\"></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-commercial-docs/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-commercial-docs/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"REQUIRED_COMMERCIAL_DOCS.TASKS_MENU\">Tasks Menu</span></div></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" ng-click=\"vm.redirectToAddVessel()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-1-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_COMMERCIAL_DOCS.ADD_VESSEL\">Add Vessel</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredTechnicalDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-2-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_COMMERCIAL_DOCS.REQUIRED_TECHNICAL_DOCS\">Required technical documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredCommercialDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-3-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_COMMERCIAL_DOCS.REQUIRED_COMMERCIAL_DOCS\">Required commercial documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredGeneralDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-4-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_COMMERCIAL_DOCS.REQUIRED_GENERAL_DOCS\">Required general documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToOtherDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-5-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_COMMERCIAL_DOCS.OTHER_DOCS\">Other Documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToFinishUpload()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-6-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FINISH_UPLOAD.FINISH_UPLOAD\">Finish Upload</div></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-commercial-docs/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">ITB Detail</div><table class=\"simple\" ms-responsive-table=\"\"><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"reference\" ng-model=\"vm.form.reference\" placeholder=\"Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.REFERENCE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterers_reference\" ng-model=\"vm.form.charterers_reference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERERS_REFERENCE\" required=\"\"><div ng-messages=\"registerForm.charterers_reference.$error\" ng-show=\"registerForm.charterers_reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterer\" ng-model=\"vm.form.charterer\" placeholder=\"Charterer\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERER\" required=\"\"><div ng-messages=\"registerForm.charterer.$error\" ng-show=\"registerForm.charterer.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"title\" ng-model=\"vm.form.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.TITLE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"vessel_type\" ng-model=\"vm.form.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.VESSEL_TYPE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"location\" ng-model=\"vm.form.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.LOCATION\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"commencement\" ng-model=\"vm.form.commencement\" placeholder=\"Commencement\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.COMMENCEMENT\"><div ng-messages=\"registerForm.commencement.$error\" ng-show=\"registerForm.commencement.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.COMMENCEMENT_REQUIRED\">Commencement field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"closing_date\" ng-model=\"vm.form.closing_date\" placeholder=\"Closing Date\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CLOSING_DATE\"><div ng-messages=\"registerForm.closing_date.$error\" ng-show=\"registerForm.closing_date.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CLOSING_DATE_REQUIRED\">Closing Date field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.CANCEL\" translate-attr-aria-label=\"SELECT_ITB.CANCEL\" ng-click=\"vm.toggleView()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.SAVE\" translate-attr-aria-label=\"SELECT_ITB.SAVE\" ng-click=\"vm.toggleView()\">SAVE</md-button></div></form></table></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-commercial-docs/views/list/list-view.html","<div class=\"message\">Submission of Bid - Required Commercial documents</div><table class=\"simple\" ms-responsive-table=\"\"><div class=\"comment\" data-ng-bind-html=\"vm.commercialDocsComments\"></div><div class=\"separador\"></div><div id=\"commercialGrid\" class=\"gridStyle\" ui-grid=\"vm.commercialGridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"red-button\" aria-label=\"DELETE_FILE\" ng-disabled=\"vm.disableDropboxButtons\" translate=\"REQUIRED_COMMERCIAL_DOCS.DELETE_FILE\" translate-attr-aria-label=\"REQUIRED_COMMERCIAL_DOCS.DELETE_FILE\" ng-click=\"vm.showConfirmDeleteDialog($event)\">DELETE FILE</md-button><md-button class=\"grey-button\" ng-click=\"vm.viewCommercialFile()\" ng-disabled=\"vm.disableDropboxButtons\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"REQUIRED_COMMERCIAL_DOCS.VIEW_DOC\" translate-attr-aria-label=\"REQUIRED_COMMERCIAL_DOCS.VIEW_DOC\">VIEW DOCUMENT</div><md-icon md-font-icon=\"icon-magnify\" class=\"s20 icon-white\"></md-icon></div></md-button><input type=\"file\" id=\"commercialFileInput\" ng-change=\"vm.uploadCommercialFile(vm.commercialFileUploaded)\" class=\"ng-hide\" ngf-select=\"\" ng-model=\"vm.commercialFileUploaded\" ngf-accept=\"\'*/*\'\" required=\"\"><md-button class=\"grey-button\" ng-click=\"vm.selectCommercialFile()\" ng-disabled=\"vm.disableDropboxButtons\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"REQUIRED_COMMERCIAL_DOCS.UPLOAD_FILE\" translate-attr-aria-label=\"REQUIRED_COMMERCIAL_DOCS.UPLOAD_FILE\">UPLOAD FILE</div><md-icon md-font-icon=\"icon-paperclip\" class=\"s20 icon-white\"></md-icon></div></md-button><div class=\"separador-horizontal\"></div><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToRequiredTechnicalDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s20 icon-white\"></md-icon><div class=\"title\" translate=\"REQUIRED_COMMERCIAL_DOCS.BACK\" translate-attr-aria-label=\"REQUIRED_COMMERCIAL_DOCS.BACK\">Back</div></div></md-button><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToRequiredGeneralDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"REQUIRED_COMMERCIAL_DOCS.NEXT\" translate-attr-aria-label=\"REQUIRED_COMMERCIAL_DOCS.NEXT\">Next</div><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button></div><div class=\"separador\"></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-general-docs/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"REQUIRED_GENERAL_DOCS.TASKS_MENU\">Tasks Menu</span></div></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" ng-click=\"vm.redirectToAddVessel()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-1-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.ADD_VESSEL\">Add Vessel</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredTechnicalDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-2-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_TECHNICAL_DOCS\">Required technical documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredCommercialDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-3-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_COMMERCIAL_DOCS\">Required commercial documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredGeneralDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-4-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.REQUIRED_GENERAL_DOCS\">Required general documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToOtherDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-5-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.OTHER_DOCS\">Other Documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToFinishUpload()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-6-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FINISH_UPLOAD.FINISH_UPLOAD\">Finish Upload</div></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-general-docs/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-general-docs/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">ITB Detail</div><table class=\"simple\" ms-responsive-table=\"\"><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"reference\" ng-model=\"vm.form.reference\" placeholder=\"Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.REFERENCE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterers_reference\" ng-model=\"vm.form.charterers_reference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERERS_REFERENCE\" required=\"\"><div ng-messages=\"registerForm.charterers_reference.$error\" ng-show=\"registerForm.charterers_reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterer\" ng-model=\"vm.form.charterer\" placeholder=\"Charterer\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERER\" required=\"\"><div ng-messages=\"registerForm.charterer.$error\" ng-show=\"registerForm.charterer.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"title\" ng-model=\"vm.form.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.TITLE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"vessel_type\" ng-model=\"vm.form.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.VESSEL_TYPE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"location\" ng-model=\"vm.form.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.LOCATION\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"commencement\" ng-model=\"vm.form.commencement\" placeholder=\"Commencement\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.COMMENCEMENT\"><div ng-messages=\"registerForm.commencement.$error\" ng-show=\"registerForm.commencement.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.COMMENCEMENT_REQUIRED\">Commencement field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"closing_date\" ng-model=\"vm.form.closing_date\" placeholder=\"Closing Date\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CLOSING_DATE\"><div ng-messages=\"registerForm.closing_date.$error\" ng-show=\"registerForm.closing_date.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CLOSING_DATE_REQUIRED\">Closing Date field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.CANCEL\" translate-attr-aria-label=\"SELECT_ITB.CANCEL\" ng-click=\"vm.toggleView()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.SAVE\" translate-attr-aria-label=\"SELECT_ITB.SAVE\" ng-click=\"vm.toggleView()\">SAVE</md-button></div></form></table></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-general-docs/views/list/list-view.html","<div class=\"message\">Submission of Bid - Required General Information documents</div><table class=\"simple\" ms-responsive-table=\"\"><div class=\"comment\" data-ng-bind-html=\"vm.generalDocsComments\"></div><div class=\"separador\"></div><div id=\"generalGrid\" class=\"gridStyle\" ui-grid=\"vm.generalGridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"red-button\" aria-label=\"DELETE_FILE\" ng-disabled=\"vm.disableDropboxButtons\" translate=\"REQUIRED_GENERAL_DOCS.DELETE_FILE\" translate-attr-aria-label=\"REQUIRED_GENERAL_DOCS.DELETE_FILE\" ng-click=\"vm.showConfirmDeleteDialog($event)\">DELETE FILE</md-button><md-button class=\"grey-button\" ng-click=\"vm.viewGeneralFile()\" ng-disabled=\"vm.disableDropboxButtons\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.VIEW_DOC\" translate-attr-aria-label=\"REQUIRED_GENERAL_DOCS.VIEW_DOC\">VIEW DOCUMENT</div><md-icon md-font-icon=\"icon-magnify\" class=\"s20 icon-white\"></md-icon></div></md-button><input type=\"file\" id=\"generalFileInput\" ng-change=\"vm.uploadGeneralFile(vm.generalFileUploaded)\" class=\"ng-hide\" ngf-select=\"\" ng-model=\"vm.generalFileUploaded\" ngf-accept=\"\'*/*\'\" required=\"\"><md-button class=\"grey-button\" ng-click=\"vm.selectGeneralFile()\" ng-disabled=\"vm.disableDropboxButtons\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.UPLOAD_FILE\" translate-attr-aria-label=\"REQUIRED_GENERAL_DOCS.UPLOAD_FILE\">UPLOAD FILE</div><md-icon md-font-icon=\"icon-paperclip\" class=\"s20 icon-white\"></md-icon></div></md-button><div class=\"separador-horizontal\"></div><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToRequiredCommercialDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s20 icon-white\"></md-icon><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.BACK\" translate-attr-aria-label=\"REQUIRED_GENERAL_DOCS.BACK\">Back</div></div></md-button><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToOtherDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"REQUIRED_GENERAL_DOCS.NEXT\" translate-attr-aria-label=\"REQUIRED_GENERAL_DOCS.NEXT\">Next</div><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button></div><div class=\"separador\"></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-technical-docs/sidenavs/details/details-sidenav.html","<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div class=\"toolbar\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.delete()\" aria-label=\"Delete\" translate=\"\" translate-attr-aria-label=\"FM.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"FM.DELETE\">Delete</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"Download\" translate=\"\" translate-attr-aria-label=\"FM.DOWNLOAD\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip><span translate=\"FM.DOWNLOAD\">Download</span></md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"FM.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon><md-tooltip><span translate=\"FM.MORE\">More</span></md-tooltip></md-button></div><div><div class=\"title\">{{vm.selected.name}}</div><div class=\"subtitle secondary-text\"><span translate=\"FM.EDITED\">Edited</span>: {{vm.selected.modified}}</div></div></div><md-content class=\"content\" flex=\"\" ms-scroll=\"\"><div class=\"file-details\"><div class=\"preview file-icon\" layout=\"row\" layout-align=\"center center\"><i class=\"icon-{{vm.selected.type}} s48\"></i></div><md-list class=\"offline-switch\"><md-list-item><p translate=\"FM.AVAILABLE_OFFLINE\">Available Offline</p><md-switch class=\"md-secondary\" ng-model=\"vm.selected.offline\" aria-label=\"Toggle offline\" translate=\"\" translate-attr-aria-label=\"FM.TOOGLE_OFFLINE\"></md-switch></md-list-item></md-list><div class=\"title\" translate=\"FM.INFO\">Info</div><table><tr class=\"type\"><th translate=\"FM.TYPE\">Type</th><td>{{vm.selected.type}}</td></tr><tr class=\"size\"><th translate=\"FM.SIZE\">Size</th><td>{{vm.selected.size === \'\' ? \'-\': vm.selected.size}}</td></tr><tr class=\"location\"><th translate=\"FM.LOCATION\">Location</th><td>{{vm.selected.location}}</td></tr><tr class=\"owner\"><th translate=\"FM.OWNER\">Owner</th><td>{{vm.selected.owner}}</td></tr><tr class=\"modified\"><th translate=\"FM.MODIFIED\">Modified</th><td>{{vm.selected.modified}}</td></tr><tr class=\"opened\"><th translate=\"FM.OPENED\">Opened</th><td>{{vm.selected.opened}}</td></tr><tr class=\"created\"><th translate=\"FM.CREATED\">Created</th><td>{{vm.selected.created}}</td></tr></table></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-technical-docs/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-folder\" class=\"icon s24\"></md-icon></span> <span class=\"logo-text\" translate=\"REQUIRED_TECHNICAL_DOCS.TASKS_MENU\">Tasks Menu</span></div></div><md-content ms-scroll=\"\" class=\"content\" flex=\"\"><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" ng-click=\"vm.redirectToAddVessel()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-1-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_TECHNICAL_DOCS.ADD_VESSEL\">Add Vessel</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredTechnicalDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-2-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_TECHNICAL_DOCS.REQUIRED_TECHNICAL_DOCS\">Required technical documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredCommercialDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-3-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_TECHNICAL_DOCS.REQUIRED_COMMERCIAL_DOCS\">Required commercial documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToRequiredGeneralDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-4-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_TECHNICAL_DOCS.REQUIRED_GENERAL_DOCS\">Required general documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToOtherDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-5-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"REQUIRED_TECHNICAL_DOCS.OTHER_DOCS\">Other Documents</div></div></md-button><md-button class=\"item\" aria-label=\"starred\" ng-click=\"vm.redirectToFinishUpload()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-numeric-6-box\" class=\"s16\"></md-icon><div class=\"title\" translate=\"FINISH_UPLOAD.FINISH_UPLOAD\">Finish Upload</div></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-technical-docs/views/detail/detail-view.html","<div id=\"detail-view\"><div class=\"message\">ITB Detail</div><table class=\"simple\" ms-responsive-table=\"\"><form name=\"registerForm\" novalidate=\"\"><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"reference\" ng-model=\"vm.form.reference\" placeholder=\"Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.REFERENCE\" required=\"\"><div ng-messages=\"registerForm.reference.$error\" ng-show=\"registerForm.reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.REFERENCE_REQUIRED\">Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterers_reference\" ng-model=\"vm.form.charterers_reference\" placeholder=\"Charterers\' Reference\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERERS_REFERENCE\" required=\"\"><div ng-messages=\"registerForm.charterers_reference.$error\" ng-show=\"registerForm.charterers_reference.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERERS_REFERENCE_REQUIRED\">Charterers´ Reference field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"charterer\" ng-model=\"vm.form.charterer\" placeholder=\"Charterer\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CHARTERER\" required=\"\"><div ng-messages=\"registerForm.charterer.$error\" ng-show=\"registerForm.charterer.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CHARTERER_REQUIRED\">Charterer field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"title\" ng-model=\"vm.form.title\" placeholder=\"Title\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.TITLE\" required=\"\"><div ng-messages=\"registerForm.title.$error\" ng-show=\"registerForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"vessel_type\" ng-model=\"vm.form.vessel_type\" placeholder=\"Vessel Type\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.VESSEL_TYPE\"><div ng-messages=\"registerForm.vessel_type.$error\" ng-show=\"registerForm.vessel_type.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.VESSEL_TYPE_REQUIRED\">Vessel type field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"location\" ng-model=\"vm.form.location\" placeholder=\"Location\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.LOCATION\"><div ng-messages=\"registerForm.location.$error\" ng-show=\"registerForm.location.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.LOCATION_REQUIRED\">Location field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"commencement\" ng-model=\"vm.form.commencement\" placeholder=\"Commencement\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.COMMENCEMENT\"><div ng-messages=\"registerForm.commencement.$error\" ng-show=\"registerForm.commencement.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.COMMENCEMENT_REQUIRED\">Commencement field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float=\"\"><input name=\"closing_date\" ng-model=\"vm.form.closing_date\" placeholder=\"Closing Date\" translate=\"\" translate-attr-placeholder=\"SELECT_ITB.CLOSING_DATE\"><div ng-messages=\"registerForm.closing_date.$error\" ng-show=\"registerForm.closing_date.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"SELECT_ITB.ERRORS.CLOSING_DATE_REQUIRED\">Closing Date field is required</span></div></div></md-input-container><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-accent md-warn\" aria-label=\"CANCEL\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.CANCEL\" translate-attr-aria-label=\"SELECT_ITB.CANCEL\" ng-click=\"vm.toggleView()\">CANCEL</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"SAVE\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"SELECT_ITB.SAVE\" translate-attr-aria-label=\"SELECT_ITB.SAVE\" ng-click=\"vm.toggleView()\">SAVE</md-button></div></form></table></div>");
$templateCache.put("app/main/apps/workflow-bidder/submission-bid/required-technical-docs/views/list/list-view.html","<div class=\"message\">Submission of Bid - Required Technical documents</div><table class=\"simple\" ms-responsive-table=\"\"><div class=\"comment\" data-ng-bind-html=\"vm.technicalDocsComments\"></div><div class=\"separador\"></div><div id=\"technicalGrid\" class=\"gridStyle\" ui-grid=\"vm.technicalGridOptions\" ui-grid-selection=\"\" ui-grid-resize-columns=\"\"></div></table><div class=\"separador\"></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button type=\"submit\" class=\"red-button\" aria-label=\"DELETE_FILE\" ng-disabled=\"vm.disableDropboxButtons\" translate=\"REQUIRED_TECHNICAL_DOCS.DELETE_FILE\" translate-attr-aria-label=\"REQUIRED_TECHNICAL_DOCS.DELETE_FILE\" ng-click=\"vm.showConfirmDeleteDialog($event)\">DELETE FILE</md-button><md-button class=\"grey-button\" ng-click=\"vm.viewTechnicalFile()\" ng-disabled=\"vm.disableDropboxButtons\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"REQUIRED_TECHNICAL_DOCS.VIEW_DOC\" translate-attr-aria-label=\"REQUIRED_TECHNICAL_DOCS.VIEW_DOC\">VIEW DOCUMENT</div><md-icon md-font-icon=\"icon-magnify\" class=\"s20 icon-white\"></md-icon></div></md-button><input type=\"file\" id=\"technicalFileInput\" ng-change=\"vm.uploadTechnicalFile(vm.technicalFileUploaded)\" class=\"ng-hide\" ngf-select=\"\" ng-model=\"vm.technicalFileUploaded\" ngf-accept=\"\'*/*\'\" required=\"\"><md-button class=\"grey-button\" ng-click=\"vm.selectTechnicalFile()\" ng-disabled=\"vm.disableDropboxButtons\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"REQUIRED_TECHNICAL_DOCS.UPLOAD_FILE\" translate-attr-aria-label=\"REQUIRED_TECHNICAL_DOCS.UPLOAD_FILE\">UPLOAD FILE</div><md-icon md-font-icon=\"icon-paperclip\" class=\"s20 icon-white\"></md-icon></div></md-button><div class=\"separador-horizontal\"></div><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToAddVessel()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left-bold-circle-outline\" class=\"s20 icon-white\"></md-icon><div class=\"title\" translate=\"REQUIRED_TECHNICAL_DOCS.BACK\" translate-attr-aria-label=\"REQUIRED_TECHNICAL_DOCS.BACK\">Back</div></div></md-button><md-button class=\"green-button\" aria-label=\"SELECT ITB\" ng-disabled=\"false\" ng-click=\"vm.redirectToRequiredCommercialDocs()\"><div class=\"context\" layout=\"row\" layout-align=\"start center\"><div class=\"title\" translate=\"REQUIRED_TECHNICAL_DOCS.NEXT\" translate-attr-aria-label=\"REQUIRED_TECHNICAL_DOCS.NEXT\">Next</div><md-icon md-font-icon=\"icon-arrow-right-bold-circle-outline\" class=\"s20 icon-white\"></md-icon></div></md-button></div><div class=\"separador\"></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/directive/mdAutocomplete.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-autocomplete&gt;</code> is a special input component with a drop-down of all possible matches to a custom query. This component allows you to provide real-time suggestions as the user types in the input area.</p><p>To start, you will need to specify the required parameters and provide a template for your results. The content inside <code>md-autocomplete</code> will be treated as a template.</p><p>In more complex cases, you may want to include other content such as a message to display when no matches were found. You can do this by wrapping your template in <code>md-item-template</code> and adding a tag for <code>md-not-found</code>. An example of this is shown below.</p><h3 id=\"validation\">Validation</h3><p>You can use <code>ng-messages</code> to include validation the same way that you would normally validate; however, if you want to replicate a standard input with a floating label, you will have to do the following:</p><ul><li>Make sure that your template is wrapped in <code>md-item-template</code></li><li>Add your <code>ng-messages</code> code inside of <code>md-autocomplete</code></li><li>Add your validation properties to <code>md-autocomplete</code> (ie. <code>required</code>)</li><li>Add a <code>name</code> to <code>md-autocomplete</code> (to be used on the generated <code>input</code>)</li></ul><p>There is an example below of how this should look.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"basic-example\">Basic Example</h3><hljs lang=\"html\"><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" md-item-text=\"item.display\"><span md-highlight-text=\"searchText\">{{item.display}}</span></md-autocomplete></hljs><h3 id=\"example-with-not-found-message\">Example with &quot;not found&quot; message</h3><hljs lang=\"html\"><md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" md-item-text=\"item.display\"><md-item-template><span md-highlight-text=\"searchText\">{{item.display}}</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></hljs><p>In this example, our code utilizes <code>md-item-template</code> and <code>md-not-found</code> to specify the different parts that make up our component.</p><h3 id=\"example-with-validation\">Example with validation</h3><hljs lang=\"html\"><form name=\"autocompleteForm\"><md-autocomplete required=\"\" md-input-name=\"autocomplete\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" md-item-text=\"item.display\"><md-item-template><span md-highlight-text=\"searchText\">{{item.display}}</span></md-item-template><div ng-messages=\"autocompleteForm.autocomplete.$error\"><div ng-message=\"required\">This field is required</div></div></md-autocomplete></form></hljs><p>In this example, our code utilizes <code>md-item-template</code> and <code>md-not-found</code> to specify the different parts that make up our component.</p></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-items</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression in the format of <code>item in items</code> to iterate over matches for your search.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-selected-item-change <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression to be run each time a new item is selected</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-search-text-change <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression to be run each time the search text updates</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-search-text <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>A model to bind the search query text to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-selected-item <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>A model to bind the selected item to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-item-text <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression that will convert your object to a single string.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-cache <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Disables the internal caching that happens in autocomplete</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-disabled <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Determines whether or not to disable the input field</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-min-length <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Specifies the minimum length of text before autocomplete will make suggestions</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-delay <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Specifies the amount of time (in milliseconds) to wait before looking for results</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-autofocus <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If true, will immediately focus the input element</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-autoselect <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If true, the first item will be selected by default</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-menu-class <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>This will be applied to the dropdown menu for styling</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-floating-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>This will add a floating label to autocomplete and wrap it in <code>md-input-container</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-input-name <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The name attribute given to the input element to be used with FormController</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-input-id <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>An ID to be added to the input element</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-input-minlength <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The minimum length for the input&#39;s value for validation</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-input-maxlength <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The maximum length for the input&#39;s value for validation</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-select-on-match <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When set, autocomplete will automatically select exact the item if the search text is an exact match</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/directive/mdHighlightText.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>md-highlight-text</code> directive allows you to specify text that should be highlighted within an element. Highlighted text will be wrapped in <code>&lt;span class=&quot;highlight&quot;&gt;&lt;/span&gt;</code> which can be styled through CSS. Please note that child elements may not be used with this directive.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><input placeholder=\"Enter a search term...\" ng-model=\"searchTerm\" type=\"text\"><ul><li ng-repeat=\"result in results\" md-highlight-text=\"searchTerm\">{{result.text}}</li></ul></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-highlight-text</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>A model to be searched for</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-highlight-flags <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>A list of flags (loosely based on JavaScript RexExp flags).</p><h4 id=\"-supported-flags-\"><strong>Supported flags</strong>:</h4><ul><li><code>g</code>: Find all matches within the provided text</li><li><code>i</code>: Ignore case when searching for matches</li><li><code>$</code>: Only match if the text ends with the search term</li><li><code>^</code>: Only match if the text begins with the search term</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.backdrop/directive/mdBackdrop.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-backdrop&gt;</code> is a backdrop element used by other components, such as dialog and bottom sheet. Apply class <code>opaque</code> to make the backdrop use the theme backdrop color.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><ul><li>as element:<pre><code>&lt;md-backdrop&gt;&#13;&#10;...&#13;&#10;&lt;/md-backdrop&gt;&#13;</code></pre></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.bottomSheet/service/$mdBottomSheet.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdBottomSheet</code> opens a bottom sheet over the app and provides a simple promise API.</p><h2 id=\"restrictions\">Restrictions</h2><ul><li>The bottom sheet&#39;s template must have an outer <code>&lt;md-bottom-sheet&gt;</code> element.</li><li>Add the <code>md-grid</code> class to the bottom sheet for a grid layout.</li><li>Add the <code>md-list</code> class to the bottom sheet for a list layout.</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div ng-controller=\"MyController\"><md-button ng-click=\"openBottomSheet()\">Open a Bottom Sheet!</md-button></div></hljs><hljs lang=\"js\">var app = angular.module(&#39;app&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdBottomSheet) { $scope.openBottomSheet = function() { $mdBottomSheet.show({ template: &#39;<md-bottom-sheet>Hello!</md-bottom-sheet>&#39; }); }; });</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdBottomSheet.show(options);\n</code></h3><div class=\"service-desc\"><p>Show a bottom sheet with the specified options.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* options</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>An options object, with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>: The url of an html template file that will be used as the content of the bottom sheet. Restrictions: the template must have an outer <code>md-bottom-sheet</code> element.</li><li><code>template</code> - <code>{string=}</code>: Same as templateUrl, except this is an actual template string.</li><li><code>scope</code> - <code>{object=}</code>: the scope to link the template / controller to. If none is specified, it will create a new child scope. This scope will be destroyed when the bottom sheet is removed unless <code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>: whether to preserve the scope when the element is removed. Default is false</li><li><code>controller</code> - <code>{string=}</code>: The controller to associate with this bottom sheet.</li><li><code>locals</code> - <code>{string=}</code>: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, <code>locals: {three: 3}</code> would inject <code>three</code> into the controller with the value of 3.</li><li><code>clickOutsideToClose</code> - <code>{boolean=}</code>: Whether the user can click outside the bottom sheet to close it. Default true.</li><li><code>escapeToClose</code> - <code>{boolean=}</code>: Whether the user can press escape to close the bottom sheet. Default true.</li><li><code>resolve</code> - <code>{object=}</code>: Similar to locals, except it takes promises as values and the bottom sheet will not open until the promises resolve.</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li><li><code>parent</code> - <code>{element=}</code>: The element to append the bottom sheet to. The <code>parent</code> may be a <code>function</code>, <code>string</code>, <code>object</code>, or null. Defaults to appending to the body of the root element (or the root element) of the application. e.g. angular.element(document.getElementById(&#39;content&#39;)) or &quot;#content&quot;</li><li><code>disableParentScroll</code> - <code>{boolean=}</code>: Whether to disable scrolling while the bottom sheet is open. Default true.</li></ul></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that can be resolved with <code>$mdBottomSheet.hide()</code> or rejected with <code>$mdBottomSheet.cancel()</code>.</p></td></tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdBottomSheet.hide([response]);\n</code></h3><div class=\"service-desc\"><p>Hide the existing bottom sheet and resolve the promise returned from <code>$mdBottomSheet.show()</code>. This call will close the most recently opened/current bottomsheet (if any).</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the resolved promise.</p></td></tr></tbody></table></div></li><li id=\"cancel\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdBottomSheet.cancel([response]);\n</code></h3><div class=\"service-desc\"><p>Hide the existing bottom sheet and reject the promise returned from <code>$mdBottomSheet.show()</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the rejected promise.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.button/directive/mdButton.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-button&gt;</code> is a button directive with optional ink ripples (default enabled).</p><p>If you supply a <code>href</code> or <code>ng-href</code> attribute, it will become an <code>&lt;a&gt;</code> element. Otherwise, it will become a <code>&lt;button&gt;</code> element. As per the <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">Material Design specifications</a> the FAB button background is filled with the accent color [by default]. The primary color palette may be used with the <code>md-primary</code> class.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>Regular buttons:</p><hljs lang=\"html\"><md-button>Flat Button</md-button><md-button href=\"http://google.com\">Flat link</md-button><md-button class=\"md-raised\">Raised Button</md-button><md-button ng-disabled=\"true\">Disabled Button</md-button><md-button><md-icon md-svg-src=\"your/icon.svg\"></md-icon>Register Now</md-button></hljs><p>FAB buttons:</p><hljs lang=\"html\"><md-button class=\"md-fab\" aria-label=\"FAB\"><md-icon md-svg-src=\"your/icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Mini FAB\"><md-icon md-svg-src=\"your/icon.svg\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Custom Icon Button\"><md-icon md-svg-icon=\"path/to/your.svg\"></md-icon></md-button></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If present, disable ripple ink effects.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-disabled <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>En/Disable based on the expression</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-ripple-size <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Overrides the default ripple size logic. Options: <code>full</code>, <code>partial</code>, <code>auto</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Adds alternative text to button for accessibility, useful for icon buttons. If no default text is found, a warning will be logged.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.card/directive/mdCard.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-card&gt;</code> directive is a container element used within <code>&lt;md-content&gt;</code> containers.</p><p>An image included as a direct descendant will fill the card&#39;s width, while the <code>&lt;md-card-content&gt;</code> container will wrap text content and provide padding. An <code>&lt;md-card-footer&gt;</code> element can be optionally included to put content flush against the bottom edge of the card.</p><p>Action buttons can be included in an <code>&lt;md-card-actions&gt;</code> element, similar to <code>&lt;md-dialog-actions&gt;</code>. You can then position buttons using layout attributes.</p><p>Card is built with:</p><ul><li><code>&lt;md-card-header&gt;</code> - Header for the card, holds avatar, text and squared image<ul><li><code>&lt;md-card-avatar&gt;</code> - Card avatar<ul><li><code>md-user-avatar</code> - Class for user image</li><li><code>&lt;md-icon&gt;</code></li></ul></li><li><code>&lt;md-card-header-text&gt;</code> - Contains elements for the card description<ul><li><code>md-title</code> - Class for the card title</li><li><code>md-subhead</code> - Class for the card sub header</li></ul></li></ul></li><li><code>&lt;img&gt;</code> - Image for the card</li><li><code>&lt;md-card-title&gt;</code> - Card content title<ul><li><code>&lt;md-card-title-text&gt;</code><ul><li><code>md-headline</code> - Class for the card content title</li><li><code>md-subhead</code> - Class for the card content sub header</li></ul></li><li><code>&lt;md-card-title-media&gt;</code> - Squared image within the title<ul><li><code>md-media-sm</code> - Class for small image</li><li><code>md-media-md</code> - Class for medium image</li><li><code>md-media-lg</code> - Class for large image</li></ul></li></ul></li><li><code>&lt;md-card-content&gt;</code> - Card content<ul><li><code>md-media-xl</code> - Class for extra large image</li></ul></li><li><code>&lt;md-card-actions&gt;</code> - Card actions<ul><li><code>&lt;md-card-icon-actions&gt;</code> - Icon actions</li></ul></li></ul><p>Cards have constant width and variable heights; where the maximum height is limited to what can fit within a single view on a platform, but it can temporarily expand as needed.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"card-with-optional-footer\">Card with optional footer</h3><hljs lang=\"html\"><md-card><img src=\"card-image.png\" class=\"md-card-image\" alt=\"image caption\"><md-card-content><h2>Card headline</h2><p>Card content</p></md-card-content><md-card-footer>Card footer</md-card-footer></md-card></hljs><h3 id=\"card-with-actions\">Card with actions</h3><hljs lang=\"html\"><md-card><img src=\"card-image.png\" class=\"md-card-image\" alt=\"image caption\"><md-card-content><h2>Card headline</h2><p>Card content</p></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button>Action 1</md-button><md-button>Action 2</md-button></md-card-actions></md-card></hljs><h3 id=\"card-with-header-image-title-actions-and-content\">Card with header, image, title actions and content</h3><hljs lang=\"html\"><md-card><md-card-header><md-card-avatar><img class=\"md-user-avatar\" src=\"avatar.png\"></md-card-avatar><md-card-header-text><span class=\"md-title\">Title</span> <span class=\"md-subhead\">Sub header</span></md-card-header-text></md-card-header><img ng-src=\"card-image.png\" class=\"md-card-image\" alt=\"image caption\"><md-card-title><md-card-title-text><span class=\"md-headline\">Card headline</span> <span class=\"md-subhead\">Card subheader</span></md-card-title-text></md-card-title><md-card-actions layout=\"row\" layout-align=\"start center\"><md-button>Action 1</md-button><md-button>Action 2</md-button><md-card-icon-actions><md-button class=\"md-icon-button\" aria-label=\"icon\"><md-icon md-svg-icon=\"icon\"></md-icon></md-button></md-card-icon-actions></md-card-actions><md-card-content><p>Card content</p></md-card-content></md-card></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChip.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-chip&gt;</code> is a component used within <code>&lt;md-chips&gt;</code> and is responsible for rendering individual chips.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-chip>{{$chip}}</md-chip></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChipRemove.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-chip-remove&gt;</code> Designates an element to be used as the delete button for a chip. This element is passed as a child of the <code>md-chips</code> element.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-chips><button md-chip-remove=\"\">DEL</button></md-chips></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChips.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-chips&gt;</code> is an input component for building lists of strings or objects. The list items are displayed as &#39;chips&#39;. This component can make use of an <code>&lt;input&gt;</code> element or an <code>&lt;md-autocomplete&gt;</code> element.</p><h3 id=\"custom-templates\">Custom templates</h3><p>A custom template may be provided to render the content of each chip. This is achieved by specifying an <code>&lt;md-chip-template&gt;</code> element containing the custom content as a child of <code>&lt;md-chips&gt;</code>.</p><p>Note: Any attributes on <code>&lt;md-chip-template&gt;</code> will be dropped as only the innerHTML is used for the chip template. The variables <code>$chip</code> and <code>$index</code> are available in the scope of <code>&lt;md-chip-template&gt;</code>, representing the chip object and its index in the list of chips, respectively. To override the chip delete control, include an element (ideally a button) with the attribute <code>md-chip-remove</code>. A click listener to remove the chip will be added automatically. The element is also placed as a sibling to the chip content (on which there are also click listeners) to avoid a nested ng-click situation.</p><p></p><h3>Pending Features</h3><p></p><ul style=\"padding-left:20px;\"><ul>Style<li>Colours for hover, press states (ripple?).</li></ul><ul>Validation<li>allow a validation callback</li><li>hilighting style for invalid chips</li></ul><ul>Item mutation<li>Support <code>&lt;md-chip-edit&gt;</code> template, show/hide the edit element on tap/click? double tap/double click?</li></ul><ul>Truncation and Disambiguation (?)<li>Truncate chip text where possible, but do not truncate entries such that two are indistinguishable.</li></ul><ul>Drag and Drop<li>Drag and drop chips between related <code>&lt;md-chips&gt;</code> elements.</li></ul></ul><p><span style=\"font-size:.8em;text-align:center\">Warning: This component is a WORK IN PROGRESS. If you use it now, it will probably break on you in the future.</span></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-chips ng-model=\"myItems\" placeholder=\"Add an item\" readonly=\"isReadOnly\"></md-chips></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>A model to bind the list of items to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-transform-chip</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression of form <code>myFunction($chip)</code> that when called expects one of the following return values:</p><ul><li>an object representing the <code>$chip</code> input string</li><li><code>undefined</code> to simply add the <code>$chip</code> input string, or</li><li><code>null</code> to prevent the chip from being appended</li></ul></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-require-match</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If true, and the chips template contains an autocomplete, only allow selection of pre-defined chips (i.e. you cannot add new ones).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">secondary-placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input, displayed when there is at least on item in the list</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">readonly <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Disables list manipulation (deleting or adding list items), hiding the input and delete buttons</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-add <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression which will be called when a chip has been added.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-remove <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression which will be called when a chip has been removed.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-select <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression which will be called when a chip is selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">delete-hint <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>A string read by screen readers instructing users that pressing the delete key will remove the chip.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">delete-button-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>A label for the delete button. Also hidden and read by screen readers.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-separator-keys <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An array of key codes used to separate chips.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdContactChips.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-contact-chips&gt;</code> is an input component based on <code>md-chips</code> and makes use of an <code>md-autocomplete</code> element. The component allows the caller to supply a query expression which returns a list of possible contacts. The user can select one of these and add it to the list of chips.</p><p>You may also use the <code>md-highlight-text</code> directive along with it&#39;s parameters to control the appearance of the matched text inside of the contacts&#39; autocomplete popup.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-contact-chips ng-model=\"ctrl.contacts\" md-contacts=\"ctrl.querySearch($query)\" md-contact-name=\"name\" md-contact-image=\"image\" md-contact-email=\"email\" placeholder=\"To\"></md-contact-chips></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>A model to bind the list of items to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-contacts</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>An expression expected to return contacts matching the search test, <code>$query</code>.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-contact-name</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The field name of the contact object representing the contact&#39;s name.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-contact-email</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The field name of the contact object representing the contact&#39;s email address.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-contact-image</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The field name of the contact object representing the contact&#39;s image.</p><p>// The following attribute has been removed but may come back.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">secondary-placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input, displayed when there is at least on item in the list</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">filter-selected <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Whether to filter selected contacts from the list of suggestions shown in the autocomplete.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.checkbox/directive/mdCheckbox.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The checkbox directive is used like the normal <a href=\"https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D\">angular checkbox</a>.</p><p>As per the <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">material design spec</a> the checkbox is in the accent color by default. The primary color palette may be used with the <code>md-primary</code> class.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-checkbox ng-model=\"isChecked\" aria-label=\"Finished?\">Finished ?</md-checkbox><md-checkbox md-no-ink=\"\" ng-model=\"hasInk\" aria-label=\"No Ink Effects\">No Ink Effects</md-checkbox><md-checkbox ng-disabled=\"true\" ng-model=\"isDisabled\" aria-label=\"Disabled\">Disabled</md-checkbox></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Assignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">name <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-true-value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>The value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-false-value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>The value to which the expression should be set when not selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-change <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Angular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Use of attribute indicates use of ripple ink effects</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Adds label to checkbox for accessibility. Defaults to checkbox&#39;s text. If no default text is found, a warning will be logged.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.content/directive/mdContent.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-content&gt;</code> directive is a container element useful for scrollable content</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><ul><li>Add the <code>[layout-padding]</code> attribute to make the content padded.</li></ul><hljs lang=\"html\"><md-content layout-padding=\"\">Lorem ipsum dolor sit amet, ne quod novum mei.</md-content></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/directive/mdDatepicker.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-datepicker&gt;</code> is a component used to select a single date. For information on how to configure internationalization for the date picker, see <code>$mdDateLocaleProvider</code>.</p><p>This component supports <a href=\"https://docs.angularjs.org/api/ngMessages/directive/ngMessages\">ngMessages</a>. Supported attributes are:</p><ul><li><code>required</code>: whether a required date is not set.</li><li><code>mindate</code>: whether the selected date is before the minimum allowed date.</li><li><code>maxdate</code>: whether the selected date is after the maximum allowed date.</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-datepicker ng-model=\"birthday\"></md-datepicker></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>The component&#39;s model. Expects a JavaScript Date object.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-change <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Expression evaluated when the model value changes.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-min-date <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>Expression representing a min date (inclusive).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-max-date <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>Expression representing a max date (inclusive).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-date-filter <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-function\">function(Date): boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-function\">function(Date): boolean</code></td><td class=\"description\"><p>Function expecting a date and returning a boolean whether it can be selected or not.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">String</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">String</code></td><td class=\"description\"><p>The date input placeholder value.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-disabled <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether the datepicker is disabled.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-required <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether a value is required for the datepicker.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/service/$mdDateLocaleProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>$mdDateLocaleProvider</code> is the provider that creates the <code>$mdDateLocale</code> service. This provider that allows the user to specify messages, formatters, and parsers for date internationalization. The <code>$mdDateLocale</code> service itself is consumed by Angular Material components that that deal with dates.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">myAppModule.config(function($mdDateLocaleProvider) { // Example of a French localization. $mdDateLocaleProvider.months = [&#39;janvier&#39;, &#39;février&#39;, &#39;mars&#39;, ...]; $mdDateLocaleProvider.shortMonths = [&#39;janv&#39;, &#39;févr&#39;, &#39;mars&#39;, ...]; $mdDateLocaleProvider.days = [&#39;dimanche&#39;, &#39;lundi&#39;, &#39;mardi&#39;, ...]; $mdDateLocaleProvider.shortDays = [&#39;Di&#39;, &#39;Lu&#39;, &#39;Ma&#39;, ...]; // Can change week display to start on Monday. $mdDateLocaleProvider.firstDayOfWeek = 1; // Optional. $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...]; // Example uses moment.js to parse and format dates. $mdDateLocaleProvider.parseDate = function(dateString) { var m = moment(dateString, &#39;L&#39;, true); return m.isValid() ? m.toDate() : new Date(NaN); }; $mdDateLocaleProvider.formatDate = function(date) { return moment(date).format(&#39;L&#39;); }; $mdDateLocaleProvider.monthHeaderFormatter = function(date) { return myShortMonths[date.getMonth()] + &#39; &#39; + date.getFullYear(); }; // In addition to date display, date components also need localized messages // for aria-labels for screen-reader users. $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) { return &#39;Semaine &#39; + weekNumber; }; $mdDateLocaleProvider.msgCalendar = &#39;Calendrier&#39;; $mdDateLocaleProvider.msgOpenCalendar = &#39;Ouvrir le calendrier&#39;; });</hljs></section><section class=\"api-section\"><h2>Properties</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Property</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">months <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>Array of month names (in order).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">shortMonths <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>Array of abbreviated month names.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">days <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>Array of the days of the week (in order).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">shortDays <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>Array of abbreviated dayes of the week.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">dates <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>Array of dates of the month. Only necessary for locales using a numeral system other than [1, 2, 3...].</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">firstDayOfWeek <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>The first day of the week. Sunday = 0, Monday = 1, etc.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">parseDate <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-function\">function(string): Date</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-function\">function(string): Date</code></td><td class=\"description\"><p>Function to parse a date object from a string.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">formatDate <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code></td><td class=\"description\"><p>Function to format a date object to a string.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">monthHeaderFormatter <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code></td><td class=\"description\"><p>Function that returns the label for a month given a date.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">weekNumberFormatter <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-function\">function(number): string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-function\">function(number): string</code></td><td class=\"description\"><p>Function that returns a label for a week given the week number.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">msgCalendar <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Translation of the label &quot;Calendar&quot; for the current locale.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">msgOpenCalendar <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Translation of the button label &quot;Open calendar&quot; for the current locale.</p></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/directive/mdDialog.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-dialog&gt;</code> - The dialog&#39;s template must be inside this element.</p><p>Inside, use an <code>&lt;md-dialog-content&gt;</code> element for the dialog&#39;s content, and use an <code>&lt;md-dialog-actions&gt;</code> element for the dialog&#39;s actions.</p><ul><li><h2 id=\"css\">CSS</h2></li><li><code>.md-dialog-content</code> - class that sets the padding on the content as the spec file</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"dialog-template\">Dialog template</h3><hljs lang=\"html\"><md-dialog aria-label=\"List dialog\"><md-dialog-content><md-list><md-list-item ng-repeat=\"item in items\"><p>Number {{item}}</p></md-list-item></md-list></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Close Dialog</md-button></md-dialog-actions></md-dialog></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/service/$mdDialog.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdDialog</code> opens a dialog over the app to inform users about critical information or require them to make decisions. There are two approaches for setup: a simple promise API and regular object syntax.</p><h2 id=\"restrictions\">Restrictions</h2><ul><li>The dialog is always given an isolate scope.</li><li>The dialog&#39;s template must have an outer <code>&lt;md-dialog&gt;</code> element. Inside, use an <code>&lt;md-dialog-content&gt;</code> element for the dialog&#39;s content, and use an <code>&lt;md-dialog-actions&gt;</code> element for the dialog&#39;s actions.</li><li>Dialogs must cover the entire application to keep interactions inside of them. Use the <code>parent</code> option to change where dialogs are appended.</li></ul><h2 id=\"sizing\">Sizing</h2><ul><li>Complex dialogs can be sized with <code>flex=&quot;percentage&quot;</code>, i.e. <code>flex=&quot;66&quot;</code>.</li><li>Default max-width is 80% of the <code>rootElement</code> or <code>parent</code>.</li></ul><h2 id=\"css\">CSS</h2><ul><li><code>.md-dialog-content</code> - class that sets the padding on the content as the spec file</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div ng-app=\"demoApp\" ng-controller=\"EmployeeController\"><div><md-button ng-click=\"showAlert()\" class=\"md-raised md-warn\">Employee Alert!</md-button></div><div><md-button ng-click=\"showDialog($event)\" class=\"md-raised\">Custom Dialog</md-button></div><div><md-button ng-click=\"closeAlert()\" ng-disabled=\"!hasAlert()\" class=\"md-raised\">Close Alert</md-button></div><div><md-button ng-click=\"showGreeting($event)\" class=\"md-raised md-primary\">Greet Employee</md-button></div></div></hljs><h3 id=\"javascript-object-syntax\">JavaScript: object syntax</h3><hljs lang=\"js\">(function(angular, undefined){ &quot;use strict&quot;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;AppCtrl&#39;, AppController); function AppController($scope, $mdDialog) { var alert; $scope.showAlert = showAlert; $scope.showDialog = showDialog; $scope.items = [1, 2, 3]; // Internal method function showAlert() { alert = $mdDialog.alert({ title: &#39;Attention&#39;, textContent: &#39;This is an example of how easy dialogs can be!&#39;, ok: &#39;Close&#39; }); $mdDialog .show( alert ) .finally(function() { alert = undefined; }); } function showDialog($event) { var parentEl = angular.element(document.body); $mdDialog.show({ parent: parentEl, targetEvent: $event, template: &#39;<md-dialog aria-label=\"List dialog\">&#39; + &#39;<md-dialog-content>&#39;+ &#39;<md-list>&#39;+ &#39;<md-list-item ng-repeat=\"item in items\">&#39;+ &#39;<p>Number {{item}}</p>&#39; + &#39; &#39;+ &#39;</md-list-item></md-list>&#39;+ &#39;</md-dialog-content>&#39; + &#39;<md-dialog-actions>&#39; + &#39;<md-button ng-click=\"closeDialog()\" class=\"md-primary\">&#39; + &#39; Close Dialog&#39; + &#39;</md-button>&#39; + &#39;</md-dialog-actions>&#39; + &#39;</md-dialog>&#39;, locals: { items: $scope.items }, controller: DialogController }); function DialogController($scope, $mdDialog, items) { $scope.items = items; $scope.closeDialog = function() { $mdDialog.hide(); } } } } })(angular);</hljs><h3 id=\"javascript-promise-api-syntax-custom-dialog-template\">JavaScript: promise API syntax, custom dialog template</h3><hljs lang=\"js\">(function(angular, undefined){ &quot;use strict&quot;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;EmployeeController&#39;, EmployeeEditor) .controller(&#39;GreetingController&#39;, GreetingController); // Fictitious Employee Editor to show how to use simple and complex dialogs. function EmployeeEditor($scope, $mdDialog) { var alert; $scope.showAlert = showAlert; $scope.closeAlert = closeAlert; $scope.showGreeting = showCustomGreeting; $scope.hasAlert = function() { return !!alert }; $scope.userName = $scope.userName || &#39;Bobby&#39;; // Dialog #1 - Show simple alert dialog and cache // reference to dialog instance function showAlert() { alert = $mdDialog.alert() .title(&#39;Attention, &#39; + $scope.userName) .textContent(&#39;This is an example of how easy dialogs can be!&#39;) .ok(&#39;Close&#39;); $mdDialog .show( alert ) .finally(function() { alert = undefined; }); } // Close the specified dialog instance and resolve with &#39;finished&#39; flag // Normally this is not needed, just use &#39;$mdDialog.hide()&#39; to close // the most recent dialog popup. function closeAlert() { $mdDialog.hide( alert, &quot;finished&quot; ); alert = undefined; } // Dialog #2 - Demonstrate more complex dialogs construction and popup. function showCustomGreeting($event) { $mdDialog.show({ targetEvent: $event, template: &#39;<md-dialog>&#39; + &#39;<md-dialog-content>Hello {{ employee }}!</md-dialog-content>&#39; + &#39;<md-dialog-actions>&#39; + &#39;<md-button ng-click=\"closeDialog()\" class=\"md-primary\">&#39; + &#39; Close Greeting&#39; + &#39;</md-button>&#39; + &#39;</md-dialog-actions>&#39; + &#39;</md-dialog>&#39;, controller: &#39;GreetingController&#39;, onComplete: afterShowAnimation, locals: { employee: $scope.userName } }); // When the &#39;enter&#39; animation finishes... function afterShowAnimation(scope, element, options) { // post-show code here: DOM element focus, etc. } } // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog // Here we used ng-controller=&quot;GreetingController as vm&quot; and // $scope.vm ===<controller instance=\"\">function showCustomGreeting() { $mdDialog.show({ clickOutsideToClose: true, scope: $scope, // use parent scope in template preserveScope: true, // do not forget this if use parent scope // Since GreetingController is instantiated with ControllerAs syntax // AND we are passing the parent &#39;$scope&#39; to the dialog, we MUST // use &#39;vm.<xxx>&#39; in the template markup template: &#39;<md-dialog>&#39; + &#39;<md-dialog-content>&#39; + &#39; Hi There {{vm.employee}}&#39; + &#39;</md-dialog-content>&#39; + &#39;</md-dialog>&#39;, controller: function DialogController($scope, $mdDialog) { $scope.closeDialog = function() { $mdDialog.hide(); } } }); } } // Greeting controller used with the more complex &#39;showCustomGreeting()&#39; custom dialog function GreetingController($scope, $mdDialog, employee) { // Assigned from construction <code>locals</code> options... $scope.employee = employee; $scope.closeDialog = function() { // Easily hides most recent dialog shown... // no specific instance reference is needed. $mdDialog.hide(); }; } })(angular);</xxx></controller></hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"alert\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.alert();\n</code></h3><div class=\"service-desc\"><p>Builds a preconfigured dialog with the specified message.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdDialogPreset</code> with the chainable configuration methods:</p><ul><li>$mdDialogPreset#title(string) - Sets the alert title.</li><li>$mdDialogPreset#textContent(string) - Sets the alert message.</li><li>$mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.</li><li>$mdDialogPreset#ok(string) - Sets the alert &quot;Okay&quot; button text.</li><li>$mdDialogPreset#theme(string) - Sets the theme of the alert dialog.</li><li>$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.</li></ul></td></tr></tbody></table></div></li><li id=\"confirm\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.confirm();\n</code></h3><div class=\"service-desc\"><p>Builds a preconfigured dialog with the specified message. You can call show and the promise returned will be resolved only if the user clicks the confirm action on the dialog.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdDialogPreset</code> with the chainable configuration methods:</p><p>Additionally, it supports the following methods:</p><ul><li>$mdDialogPreset#title(string) - Sets the confirm title.</li><li>$mdDialogPreset#textContent(string) - Sets the confirm message.</li><li>$mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.</li><li>$mdDialogPreset#ok(string) - Sets the confirm &quot;Okay&quot; button text.</li><li>$mdDialogPreset#cancel(string) - Sets the confirm &quot;Cancel&quot; button text.</li><li>$mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.</li><li>$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.</li></ul></td></tr></tbody></table></div></li><li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.show(optionsOrPreset);\n</code></h3><div class=\"service-desc\"><p>Show a dialog with the specified options.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* optionsOrPreset</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Either provide an <code>$mdDialogPreset</code> returned from <code>alert()</code>, and <code>confirm()</code>, or an options object with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>: The url of a template that will be used as the content of the dialog.</li><li><code>template</code> - <code>{string=}</code>: HTML template to show in the dialog. This <strong>must</strong> be trusted HTML with respect to Angular&#39;s <a href=\"https://docs.angularjs.org/api/ng/service/$sce\">$sce service</a>. This template should <strong>never</strong> be constructed with any kind of user input or user data.</li><li><code>autoWrap</code> - <code>{boolean=}</code>: Whether or not to automatically wrap the template with a <code>&lt;md-dialog&gt;</code> tag if one is not provided. Defaults to true. Can be disabled if you provide a custom dialog directive.</li><li><code>targetEvent</code> - <code>{DOMClickEvent=}</code>: A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.</li><li><code>openFrom</code> - <code>{string|Element|object}</code>: The query selector, DOM element or the Rect object that is used to determine the bounds (top, left, height, width) from which the Dialog will originate.</li><li><code>closeTo</code> - <code>{string|Element|object}</code>: The query selector, DOM element or the Rect object that is used to determine the bounds (top, left, height, width) to which the Dialog will target.</li><li><code>scope</code> - <code>{object=}</code>: the scope to link the template / controller to. If none is specified, it will create a new isolate scope. This scope will be destroyed when the dialog is removed unless <code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>: whether to preserve the scope when the element is removed. Default is false</li><li><code>disableParentScroll</code> - <code>{boolean=}</code>: Whether to disable scrolling while the dialog is open. Default true.</li><li><code>hasBackdrop</code> - <code>{boolean=}</code>: Whether there should be an opaque backdrop behind the dialog. Default true.</li><li><code>clickOutsideToClose</code> - <code>{boolean=}</code>: Whether the user can click outside the dialog to close it. Default false.</li><li><code>escapeToClose</code> - <code>{boolean=}</code>: Whether the user can press escape to close the dialog. Default true.</li><li><code>focusOnOpen</code> - <code>{boolean=}</code>: An option to override focus behavior on open. Only disable if focusing some other way, as focus management is required for dialogs to be accessible. Defaults to true.</li><li><code>controller</code> - <code>{function|string=}</code>: The controller to associate with the dialog. The controller will be injected with the local <code>$mdDialog</code>, which passes along a scope for the dialog.</li><li><code>locals</code> - <code>{object=}</code>: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, <code>locals: {three: 3}</code> would inject <code>three</code> into the controller, with the value 3. If <code>bindToController</code> is true, they will be copied to the controller instead.</li><li><code>bindToController</code> - <code>bool</code>: bind the locals to the controller, instead of passing them in. These values will not be available until after initialization.</li><li><code>resolve</code> - <code>{object=}</code>: Similar to locals, except it takes promises as values, and the dialog will not open until all of the promises resolve.</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li><li><code>parent</code> - <code>{element=}</code>: The element to append the dialog to. Defaults to appending to the root element of the application.</li><li><code>onShowing</code> `{function=} Callback function used to announce the show() action is starting.</li><li><code>onComplete</code> <code>{function=}</code>: Callback function used to announce when the show() action is finished.</li><li><code>onRemoving</code> <code>{function=}</code>: Callback function used to announce the close/hide() action is starting. This allows developers to run custom animations in parallel the close animations.</li><li><code>fullscreen</code> <code>{boolean=}</code>: An option to apply <code>.md-dialog-fullscreen</code> class on open.</li></ul></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that can be resolved with <code>$mdDialog.hide()</code> or rejected with <code>$mdDialog.cancel()</code>.</p></td></tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.hide([response]);\n</code></h3><div class=\"service-desc\"><p>Hide an existing dialog and resolve the promise returned from <code>$mdDialog.show()</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the resolved promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that is resolved when the dialog has been closed.</p></td></tr></tbody></table></div></li><li id=\"cancel\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.cancel([response]);\n</code></h3><div class=\"service-desc\"><p>Hide an existing dialog and reject the promise returned from <code>$mdDialog.show()</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the rejected promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that is resolved when the dialog has been closed.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabActions/directive/mdFabActions.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-fab-actions&gt;</code> directive is used inside of a <code>&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code> directive to mark an element (or elements) as the actions and setup the proper event listeners.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>See the <code>&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code> directives for example usage.</p></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.divider/directive/mdDivider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-divider></md-divider><md-divider md-inset=\"\"></md-divider></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-inset <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Add this attribute to activate the inset divider style.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabSpeedDial/directive/mdFabSpeedDial.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-fab-speed-dial&gt;</code> directive is used to present a series of popup elements (usually <code>&lt;md-button&gt;</code>s) for quick access to common actions.</p><p>There are currently two animations available by applying one of the following classes to the component:</p><ul><li><code>md-fling</code> - The speed dial items appear from underneath the trigger and move into their appropriate positions.</li><li><code>md-scale</code> - The speed dial items appear in their proper places by scaling from 0% to 100%.</li></ul><p>You may also easily position the trigger by applying one one of the following classes to the <code>&lt;md-fab-speed-dial&gt;</code> element:</p><ul><li><code>md-fab-top-left</code></li><li><code>md-fab-top-right</code></li><li><code>md-fab-bottom-left</code></li><li><code>md-fab-bottom-right</code></li></ul><p>These CSS classes use <code>position: absolute</code>, so you need to ensure that the container element also uses <code>position: absolute</code> or <code>position: relative</code> in order for them to work.</p><p>Additionally, you may use the standard <code>ng-mouseenter</code> and <code>ng-mouseleave</code> directives to open or close the speed dial. However, if you wish to allow users to hover over the empty space where the actions will appear, you must also add the <code>md-hover-full</code> class to the speed dial element. Without this, the hover effect will only occur on top of the trigger.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-fab-speed-dial md-direction=\"up\" class=\"md-fling\"><md-fab-trigger><md-button aria-label=\"Add...\"><md-icon icon=\"/assets/angular-material-assets/img/icons/plus.svg\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Add User\"><md-icon icon=\"/assets/angular-material-assets/img/icons/user.svg\"></md-icon></md-button><md-button aria-label=\"Add Group\"><md-icon icon=\"/assets/angular-material-assets/img/icons/group.svg\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-direction</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>From which direction you would like the speed dial to appear relative to the trigger element.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-open <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Programmatically control whether or not the speed-dial is visible.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabSpeedDial/directive/mdFabTrigger.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-fab-trigger&gt;</code> directive is used inside of a <code>&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code> directive to mark an element (or elements) as the trigger and setup the proper event listeners.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>See the <code>&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code> directives for example usage.</p></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabToolbar/directive/mdFabToolbar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-fab-toolbar&gt;</code> directive is used present a toolbar of elements (usually <code>&lt;md-button&gt;</code>s) for quick access to common actions when a floating action button is activated (via click or keyboard navigation).</p><p>You may also easily position the trigger by applying one one of the following classes to the <code>&lt;md-fab-toolbar&gt;</code> element:</p><ul><li><code>md-fab-top-left</code></li><li><code>md-fab-top-right</code></li><li><code>md-fab-bottom-left</code></li><li><code>md-fab-bottom-right</code></li></ul><p>These CSS classes use <code>position: absolute</code>, so you need to ensure that the container element also uses <code>position: absolute</code> or <code>position: relative</code> in order for them to work.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-fab-toolbar md-direction=\"left\"><md-fab-trigger><md-button aria-label=\"Add...\"><md-icon icon=\"/assets/angular-material-assets/img/icons/plus.svg\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Add User\"><md-icon icon=\"/assets/angular-material-assets/img/icons/user.svg\"></md-icon></md-button><md-button aria-label=\"Add Group\"><md-icon icon=\"/assets/angular-material-assets/img/icons/group.svg\"></md-icon></md-button></md-fab-actions></md-fab-toolbar></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-direction</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>From which direction you would like the toolbar items to appear relative to the trigger element. Supports <code>left</code> and <code>right</code> directions.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-open <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Programmatically control whether or not the toolbar is visible.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/directive/mdGridList.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Grid lists are an alternative to standard list views. Grid lists are distinct from grids used for layouts and other visual presentations.</p><p>A grid list is best suited to presenting a homogenous data type, typically images, and is optimized for visual comprehension and differentiating between like data types.</p><p>A grid list is a continuous element consisting of tessellated, regular subdivisions called cells that contain tiles (<code>md-grid-tile</code>).</p><p><img src=\"//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png\" style=\"width: 300px; height: auto; margin-right: 16px;\" alt=\"Concept of grid explained visually\"> <img src=\"//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png\" style=\"width: 300px; height: auto;\" alt=\"Grid concepts legend\"></p><p>Cells are arrayed vertically and horizontally within the grid.</p><p>Tiles hold content and can span one or more cells vertically or horizontally.</p><h3 id=\"responsive-attributes\">Responsive Attributes</h3><p>The <code>md-grid-list</code> directive supports &quot;responsive&quot; attributes, which allow different <code>md-cols</code>, <code>md-gutter</code> and <code>md-row-height</code> values depending on the currently matching media query (as defined in <code>$mdConstant.MEDIA</code>).</p><p>In order to set a responsive attribute, first define the fallback value with the standard attribute name, then add additional attributes with the following convention: <code>{base-attribute-name}-{media-query-name}=&quot;{value}&quot;</code> (ie. <code>md-cols-lg=&quot;8&quot;</code>)</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>Basic:</p><hljs lang=\"html\"><md-grid-list md-cols=\"5\" md-gutter=\"1em\" md-row-height=\"4:3\"><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>Fixed-height rows:</p><hljs lang=\"html\"><md-grid-list md-cols=\"4\" md-row-height=\"200px\" ...=\"\"><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>Fit rows:</p><hljs lang=\"html\"><md-grid-list md-cols=\"4\" md-row-height=\"fit\" style=\"height: 400px;\" ...=\"\"><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>Using responsive attributes:</p><hljs lang=\"html\"><md-grid-list md-cols-sm=\"2\" md-cols-md=\"4\" md-cols-lg=\"8\" md-cols-gt-lg=\"12\" ...=\"\"><md-grid-tile></md-grid-tile></md-grid-list></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-cols</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Number of columns in the grid.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-row-height</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>One of</p><ul><li>CSS length - Fixed height rows (eg. <code>8px</code> or <code>1rem</code>)</li><li><code>{width}:{height}</code> - Ratio of width to height (eg. <code>md-row-height=&quot;16:9&quot;</code>)</li><li><code>&quot;fit&quot;</code> - Height will be determined by subdividing the available height by the number of rows</li></ul></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-gutter <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The amount of space between tiles in CSS units (default 1px)</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-layout <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Expression to evaluate after layout. Event object is available as <code>$event</code>, and contains performance information.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/directive/mdGridTile.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Tiles contain the content of an <code>md-grid-list</code>. They span one or more grid cells vertically or horizontally, and use <code>md-grid-tile-{footer,header}</code> to display secondary content.</p><h3 id=\"responsive-attributes\">Responsive Attributes</h3><p>The <code>md-grid-tile</code> directive supports &quot;responsive&quot; attributes, which allow different <code>md-rowspan</code> and <code>md-colspan</code> values depending on the currently matching media query (as defined in <code>$mdConstant.MEDIA</code>).</p><p>In order to set a responsive attribute, first define the fallback value with the standard attribute name, then add additional attributes with the following convention: <code>{base-attribute-name}-{media-query-name}=&quot;{value}&quot;</code> (ie. <code>md-colspan-sm=&quot;4&quot;</code>)</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>With header:</p><hljs lang=\"html\"><md-grid-tile><md-grid-tile-header><h3>This is a header</h3></md-grid-tile-header></md-grid-tile></hljs><p>With footer:</p><hljs lang=\"html\"><md-grid-tile><md-grid-tile-footer><h3>This is a footer</h3></md-grid-tile-footer></md-grid-tile></hljs><p>Spanning multiple rows/columns:</p><hljs lang=\"html\"><md-grid-tile md-colspan=\"2\" md-rowspan=\"3\"></md-grid-tile></hljs><p>Responsive attributes:</p><hljs lang=\"html\"><md-grid-tile md-colspan=\"1\" md-colspan-sm=\"3\" md-colspan-md=\"5\"></md-grid-tile></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-colspan <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The number of columns to span (default 1). Cannot exceed the number of columns in the grid. Supports interpolation.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-rowspan <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The number of rows to span (default 1). Supports interpolation.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/directive/mdIcon.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>md-icon</code> directive makes it easier to use vector-based icons in your app (as opposed to raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.</p><p>Icons should be consider view-only elements that should not be used directly as buttons; instead nest a <code>&lt;md-icon&gt;</code> inside a <code>md-button</code> to add hover and click features.</p><h3 id=\"icon-fonts\">Icon fonts</h3><p>Icon fonts are a technique in which you use a font where the glyphs in the font are your icons instead of text. Benefits include a straightforward way to bundle everything into a single HTTP request, simple scaling, easy color changing, and more.</p><p><code>md-icon</code> lets you consume an icon font by letting you reference specific icons in that font by name rather than character code.</p><h3 id=\"svg\">SVG</h3><p>For SVGs, the problem with using <code>&lt;img&gt;</code> or a CSS <code>background-image</code> is that you can&#39;t take advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG animation.</p><p><code>md-icon</code> makes it easier to use SVG icons by <em>inlining</em> the SVG into an <code>&lt;svg&gt;</code> element in the document. The most straightforward way of referencing an SVG icon is via URL, just like a traditional <code>&lt;img&gt;</code>. <code>$mdIconProvider</code>, as a convenience, lets you <em>name</em> an icon so you can reference it by name instead of URL throughout your templates.</p><p>Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can also be given a name, which acts as a namespace for individual icons, so you can reference them like <code>&quot;social:cake&quot;</code>.</p><p>When using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be easily loaded and used.When use font-icons, developers must following three (3) simple steps:</p><ol><li>Load the font library. e.g.<br>&lt;link href=&quot;<a href=\"https://fonts.googleapis.com/icon?family=Material+Icons\">https://fonts.googleapis.com/icon?family=Material+Icons</a>&quot; rel=&quot;stylesheet&quot;&gt;</li><li>Use either (a) font-icon class names or (b) font ligatures to render the font glyph by using its textual name</li><li>Use &lt;md-icon md-font-icon=&quot;classname&quot; /&gt; or<br>use &lt;md-icon md-font-set=&quot;font library classname or alias&quot;&gt; textual_name &lt;/md-icon&gt; or<br>use &lt;md-icon md-font-set=&quot;font library classname or alias&quot;&gt; numerical_character_reference &lt;/md-icon&gt;</li></ol><p>Full details for these steps can be found:</p><ul><li><a href=\"http://google.github.io/material-design-icons/\">http://google.github.io/material-design-icons/</a></li><li><a href=\"http://google.github.io/material-design-icons/#icon-font-for-the-web\">http://google.github.io/material-design-icons/#icon-font-for-the-web</a></li></ul><p>The Material Design icon style <code>.material-icons</code> and the icon font references are published in Material Design Icons:</p><ul><li><a href=\"http://www.google.com/design/icons/\">http://www.google.com/design/icons/</a></li><li><a href=\"https://www.google.com/design/icons/#ic_accessibility\">https://www.google.com/design/icons/#ic_accessibility</a></li></ul><p></p><h2 id=\"material_design_icons\">Material Design Icons</h2>Using the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and determine its textual name and character reference code. Click on any icon to see the slide-up information panel with details regarding a SVG download or information on the font-icon usage.<p></p><p><a href=\"https://www.google.com/design/icons/#ic_accessibility\" target=\"_blank\" style=\"border-bottom:none;\"><img src=\"https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png\" aria-label=\"Material Design Icon-Selector\" style=\"max-width:75%;padding-left:10%\"></a></p><p><span class=\"image_caption\">Click on the image above to link to the <a href=\"https://www.google.com/design/icons/#ic_accessibility\" target=\"_blank\">Material Design Icon-Selector</a>.</span></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>When using SVGs:</p><hljs lang=\"html\"><md-icon md-svg-icon=\"social:android\" aria-label=\"android\"></md-icon><md-icon md-svg-src=\"/android.svg\" aria-label=\"android\"></md-icon><md-icon md-svg-src=\"{{ getAndroid() }}\" aria-label=\"android\"></md-icon></hljs><p>Use the <code>$mdIconProvider</code> to configure your application with svg iconsets.</p><hljs lang=\"js\">angular.module(&#39;appSvgIconSets&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;DemoCtrl&#39;, function($scope) {}) .config(function($mdIconProvider) { $mdIconProvider .iconSet(&#39;social&#39;, &#39;assets/angular-material-assets/img/icons/sets/social-icons.svg&#39;, 24) .defaultIconSet(&#39;assets/angular-material-assets/img/icons/sets/core-icons.svg&#39;, 24); });</hljs><p>When using Font Icons with classnames:</p><hljs lang=\"html\"><md-icon md-font-icon=\"android\" aria-label=\"android\"></md-icon><md-icon class=\"icon_home\" aria-label=\"Home\"></md-icon></hljs><p>When using Material Font Icons with ligatures:</p><hljs lang=\"html\"><md-icon>face</md-icon><md-icon md-font-set=\"material-icons\">face</md-icon><md-icon>#xE87C;</md-icon><md-icon class=\"material-icons md-light md-48\">face</md-icon></hljs><p>When using other Font-Icon libraries:</p><hljs lang=\"js\">// Specify a font-icon style alias angular.config(function($mdIconProvider) { $mdIconProvider.fontSet(&#39;fa&#39;, &#39;fontawesome&#39;); });</hljs><hljs lang=\"html\"><md-icon md-font-set=\"fa\">email</md-icon></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-font-icon</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>String name of CSS icon associated with the font-face will be used to render the icon. Requires the fonts and the named CSS styles to be preloaded.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-font-set</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>CSS style name associated with the font library; which will be assigned as the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname; internally use <code>$mdIconProvider.fontSet(&lt;alias&gt;)</code> to determine the style name.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-svg-src</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>String URL (or expression) used to load, cache, and display an external SVG.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-svg-icon</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>md-svg-icon String name used for lookup of the icon from the internal cache; interpolated strings or expressions may also be used. Specific set names can be used with the syntax <code>&lt;set name&gt;:&lt;icon name&gt;</code>.<br><br>To use icon sets, developers are required to pre-register the sets using the <code>$mdIconProvider</code> service.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Labels icon for accessibility. If an empty string is provided, icon will be hidden from accessibility layer with <code>aria-hidden=&quot;true&quot;</code>. If there&#39;s no aria-label on the icon nor a label on the parent element, a warning will be logged to the console.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">alt <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Labels icon for accessibility. If an empty string is provided, icon will be hidden from accessibility layer with <code>aria-hidden=&quot;true&quot;</code>. If there&#39;s no alt on the icon nor a label on the parent element, a warning will be logged to the console.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/service/$mdIcon.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>$mdIcon</code> service is a function used to lookup SVG icons.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">function SomeDirective($mdIcon) { // See if the icon has already been loaded, if not // then lookup the icon from the registry cache, load and cache // it for future requests. // NOTE: ID queries require configuration with $mdIconProvider $mdIcon(&#39;android&#39;).then(function(iconEl) { element.append(iconEl); }); $mdIcon(&#39;work:chair&#39;).then(function(iconEl) { element.append(iconEl); }); // Load and cache the external SVG using a URL $mdIcon(&#39;assets/angular-material-assets/img/icons/android.svg&#39;).then(function(iconEl) { element.append(iconEl); }); };</hljs><p>NOTE: The <code>&lt;md-icon /&gt;</code> directive internally uses the <code>$mdIcon</code> service to query, loaded, and instantiate SVG DOM elements.</p></section><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* id</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is performed. The Id may be a unique icon ID or may include an iconSet ID prefix.</p><p>For the <strong>id</strong> query to work properly, this means that all id-to-URL mappings must have been previously configured using the <code>$mdIconProvider</code>.</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>Clone of the initial SVG DOM element; which was created from the SVG markup in the SVG data file.</p></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/service/$mdIconProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdIconProvider</code> is used only to register icon IDs with URLs. These configuration features allow icons and icon sets to be pre-registered and associated with source URLs <strong>before</strong> the <code>&lt;md-icon /&gt;</code> directives are compiled.</p><p>If using font-icons, the developer is responsible for loading the fonts.</p><p>If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded internally by the <code>$mdIcon</code> service using the <code>$http</code> service. When an SVG is requested by name/ID, the <code>$mdIcon</code> service searches its registry for the associated source URL; that URL is used to on-demand load and parse the SVG dynamically.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">app.config(function($mdIconProvider) { // Configure URLs for icons specified by [set:]id. $mdIconProvider .defaultFontSet( &#39;fontawesome&#39; ) .defaultIconSet(&#39;my/app/icons.svg&#39;) // Register a default set of SVG icons .iconSet(&#39;social&#39;, &#39;my/app/social.svg&#39;) // Register a named icon set of SVGs .icon(&#39;android&#39;, &#39;my/app/android.svg&#39;) // Register a specific icon (by name) .icon(&#39;work:chair&#39;, &#39;my/app/chair.svg&#39;); // Register icon in a specific set });</hljs><p>SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime <strong>startup</strong> process (shown below):</p><hljs lang=\"js\">app.config(function($mdIconProvider) { // Register a default set of SVG icon definitions $mdIconProvider.defaultIconSet(&#39;my/app/icons.svg&#39;) }) .run(function($http, $templateCache){ // Pre-fetch icons sources by URL and cache in the $templateCache... // subsequent $http calls will look there first. var urls = [ &#39;imy/app/icons.svg&#39;, &#39;assets/angular-material-assets/img/icons/android.svg&#39;]; angular.forEach(urls, function(url) { $http.get(url, {cache: $templateCache}); }); });</hljs><p>NOTE: the loaded SVG data is subsequently cached internally for future requests.</p></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"icon\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.icon(id, url, [viewBoxSize]);\n</code></h3><div class=\"service-desc\"><p>Register a source URL for a specific icon name; the name may include optional &#39;icon set&#39; name prefix. These icons will later be retrieved from the cache using <code>$mdIcon( &lt;icon name&gt; )</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* id</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Icon name/id used to register the icon</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* url</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>specifies the external location for the data file. Used internally by <code>$http</code> to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">viewBoxSize <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Sets the width and height the icon&#39;s viewBox. It is ignored for icons with an existing viewBox. Default size is 24.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div></li><li id=\"iconSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.iconSet(id, url, [viewBoxSize]);\n</code></h3><div class=\"service-desc\"><p>Register a source URL for a &#39;named&#39; set of icons; group of SVG definitions where each definition has an icon id. Individual icons can be subsequently retrieved from this cached set using <code>$mdIcon(&lt;icon set name&gt;:&lt;icon name&gt;)</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* id</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Icon name/id used to register the iconset</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* url</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>specifies the external location for the data file. Used internally by <code>$http</code> to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">viewBoxSize <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Sets the width and height of the viewBox of all icons in the set. It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size. Default value is 24.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div></li><li id=\"defaultIconSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.defaultIconSet(url, [viewBoxSize]);\n</code></h3><div class=\"service-desc\"><p>Register a source URL for the default &#39;named&#39; set of icons. Unless explicitly registered, subsequent lookups of icons will failover to search this &#39;default&#39; icon set. Icon can be retrieved from this cached, default set using <code>$mdIcon(&lt;name&gt;)</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* url</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>specifies the external location for the data file. Used internally by <code>$http</code> to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">viewBoxSize <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Sets the width and height of the viewBox of all icons in the set. It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size. Default value is 24.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div></li><li id=\"defaultFontSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.defaultFontSet(name);\n</code></h3><div class=\"service-desc\"><p>When using Font-Icons, Angular Material assumes the the Material Design icons will be used and automatically configures the default font-set == &#39;material-icons&#39;. Note that the font-set references the font-icon library class style that should be applied to the <code>&lt;md-icon&gt;</code>.</p><p>Configuring the default means that the attributes <code>md-font-set=&quot;material-icons&quot;</code> or <code>class=&quot;material-icons&quot;</code> do not need to be explicitly declared on the <code>&lt;md-icon&gt;</code> markup. For example:</p><p><code>&lt;md-icon&gt; face &lt;/md-icon&gt;</code> will render as <code>&lt;span class=&quot;material-icons&quot;&gt; face &lt;/span&gt;</code>, and</p><p><code>&lt;md-icon md-font-set=&quot;fa&quot;&gt; face &lt;/md-icon&gt;</code> will render as <code>&lt;span class=&quot;fa&quot;&gt; face &lt;/span&gt;</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* name</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>of the font-library style that should be applied to the md-icon DOM element</p></td></tr></tbody></table></div></li><li id=\"defaultViewBoxSize\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.defaultViewBoxSize([viewBoxSize]);\n</code></h3><div class=\"service-desc\"><p>While <code>&lt;md-icon /&gt;</code> markup can also be style with sizing CSS, this method configures the default width <strong>and</strong> height used for all icons; unless overridden by specific CSS. The default sizing is (24px, 24px).</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">viewBoxSize <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Sets the width and height of the viewBox for an icon or an icon set. All icons in a set should be the same size. The default value is 24.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/directive/mdInput.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>You can use any <code>&lt;input&gt;</code> or <code>&lt;textarea&gt;</code> element as a child of an <code>&lt;md-input-container&gt;</code>. This allows you to build complex forms for data entry.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-input-container><label>Color</label> <input type=\"text\" ng-model=\"color\" required=\"\" md-maxlength=\"10\"></md-input-container></hljs><h3>With Errors</h3><p><code>md-input-container</code> also supports errors using the standard <code>ng-messages</code> directives and animates the messages when they become visible using from the <code>ngEnter</code>/<code>ngLeave</code> events or the <code>ngShow</code>/<code>ngHide</code> events.</p><p>By default, the messages will be hidden until the input is in an error state. This is based off of the <code>md-is-error</code> expression of the <code>md-input-container</code>. This gives the user a chance to fill out the form before the errors become visible.</p><hljs lang=\"html\"><form name=\"colorForm\"><md-input-container><label>Favorite Color</label> <input name=\"favoriteColor\" ng-model=\"favoriteColor\" required=\"\"><div ng-messages=\"userForm.lastName.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container></form></hljs><p>We automatically disable this auto-hiding functionality if you provide any of the following visibility directives on the <code>ng-messages</code> container:</p><ul><li><code>ng-if</code></li><li><code>ng-show</code>/<code>ng-hide</code></li><li><code>ng-switch-when</code>/<code>ng-switch-default</code></li></ul><p>You can also disable this functionality manually by adding the <code>md-auto-hide=&quot;false&quot;</code> expression to the <code>ng-messages</code> container. This may be helpful if you always want to see the error messages or if you are building your own visibilty directive.</p><p><em><b>Note:</b> The <code>md-auto-hide</code> attribute is a static string that is only checked upon initialization of the <code>ng-messages</code> directive to see if it equals the string <code>false</code>.</em></p><hljs lang=\"html\"><form name=\"userForm\"><md-input-container><label>Last Name</label> <input name=\"lastName\" ng-model=\"lastName\" required=\"\" md-maxlength=\"10\" minlength=\"4\"><div ng-messages=\"userForm.lastName.$error\" ng-show=\"userForm.lastName.$dirty\"><div ng-message=\"required\">This is required!</div><div ng-message=\"md-maxlength\">That&#39;s too long!</div><div ng-message=\"minlength\">That&#39;s too short!</div></div></md-input-container><md-input-container><label>Biography</label> <textarea name=\"bio\" ng-model=\"biography\" required=\"\" md-maxlength=\"150\"></textarea><div ng-messages=\"userForm.bio.$error\" ng-show=\"userForm.bio.$dirty\"><div ng-message=\"required\">This is required!</div><div ng-message=\"md-maxlength\">That&#39;s too long!</div></div></md-input-container><md-input-container><input aria-label=\"title\" ng-model=\"title\"></md-input-container><md-input-container><input placeholder=\"title\" ng-model=\"title\"></md-input-container></form></hljs><h3>Notes</h3><ul><li>Requires <a href=\"https://docs.angularjs.org/api/ngMessages\">ngMessages</a>.</li><li>Behaves like the <a href=\"https://docs.angularjs.org/api/ng/directive/input\">AngularJS input directive</a>.</li></ul><p>The <code>md-input</code> and <code>md-input-container</code> directives use very specific positioning to achieve the error animation effects. Therefore, it is <em>not</em> advised to use the Layout system inside of the <code>&lt;md-input-container&gt;</code> tags. Instead, use relative or absolute positioning.</p></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-maxlength <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The maximum number of characters allowed in this input. If this is specified, a character counter will be shown underneath the input.<br><br>The purpose of <strong><code>md-maxlength</code></strong> is exactly to show the max length counter text. If you don&#39;t want the counter text and only need &quot;plain&quot; validation, you can use the &quot;simple&quot; <code>ng-maxlength</code> or maxlength attributes.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Aria-label is required when no label is present. A warning message will be logged in the console if not present.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>An alternative approach to using aria-label when the label is not PRESENT. The placeholder text is copied to the aria-label attribute.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-autogrow <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, textareas will not grow automatically.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-detect-hidden <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, textareas will be sized properly when they are revealed after being hidden. This is off by default for performance reasons because it guarantees a reflow every digest cycle.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/directive/mdInputContainer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>&lt;md-input-container&gt;</code> is the parent of any input or textarea element.</p><p>Input and textarea elements will not behave properly unless the md-input-container parent is provided.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-input-container><label>Username</label> <input type=\"text\" ng-model=\"user.name\"></md-input-container><md-input-container><label>Description</label> <textarea ng-model=\"user.description\"></textarea></md-input-container></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-is-error <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>When the given expression evaluates to true, the input container will go into error state. Defaults to erroring if the input has been touched and is invalid.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-float <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, placeholders will not be converted to floating labels.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu/directive/mdMenu.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Menus are elements that open when clicked. They are useful for displaying additional options within the context of an action.</p><p>Every <code>md-menu</code> must specify exactly two child elements. The first element is what is left in the DOM and is used to open the menu. This element is called the trigger element. The trigger element&#39;s scope has access to <code>$mdOpenMenu($event)</code> which it may call to open the menu. By passing $event as argument, the corresponding event is stopped from propagating up the DOM-tree.</p><p>The second element is the <code>md-menu-content</code> element which represents the contents of the menu when it is open. Typically this will contain <code>md-menu-item</code>s, but you can do custom content as well.</p><hljs lang=\"html\"><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\" aria-label=\"Open sample menu\"><md-icon md-svg-icon=\"call:phone\"></md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=\"doSomething()\">Do Something</md-button></md-menu-item></md-menu-content></md-menu></hljs><h2 id=\"sizing-menus\">Sizing Menus</h2><p>The width of the menu when it is open may be specified by specifying a <code>width</code> attribute on the <code>md-menu-content</code> element. See the <a href=\"http://www.google.com/design/spec/components/menus.html#menus-specs\">Material Design Spec</a> for more information.</p><h2 id=\"aligning-menus\">Aligning Menus</h2><p>When a menu opens, it is important that the content aligns with the trigger element. Failure to align menus can result in jarring experiences for users as content suddenly shifts. To help with this, <code>md-menu</code> provides serveral APIs to help with alignment.</p><h3 id=\"target-mode\">Target Mode</h3><p>By default, <code>md-menu</code> will attempt to align the <code>md-menu-content</code> by aligning designated child elements in both the trigger and the menu content.</p><p>To specify the alignment element in the <code>trigger</code> you can use the <code>md-menu-origin</code> attribute on a child element. If no <code>md-menu-origin</code> is specified, the <code>md-menu</code> will be used as the origin element.</p><p>Similarly, the <code>md-menu-content</code> may specify a <code>md-menu-align-target</code> for a <code>md-menu-item</code> to specify the node that it should try and align with.</p><p>In this example code, we specify an icon to be our origin element, and an icon in our menu content to be our alignment target. This ensures that both icons are aligned when the menu opens.</p><hljs lang=\"html\"><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\" aria-label=\"Open some menu\"><md-icon md-menu-origin=\"\" md-svg-icon=\"call:phone\"></md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=\"doSomething()\" aria-label=\"Do something\"><md-icon md-menu-align-target=\"\" md-svg-icon=\"call:phone\"></md-icon>Do Something</md-button></md-menu-item></md-menu-content></md-menu></hljs><p>Sometimes we want to specify alignment on the right side of an element, for example if we have a menu on the right side a toolbar, we want to right align our menu content.</p><p>We can specify the origin by using the <code>md-position-mode</code> attribute on both the <code>x</code> and <code>y</code> axis. Right now only the <code>x-axis</code> has more than one option. You may specify the default mode of <code>target target</code> or <code>target-right target</code> to specify a right-oriented alignment target. See the position section of the demos for more examples.</p><h3 id=\"menu-offsets\">Menu Offsets</h3><p>It is sometimes unavoidable to need to have a deeper level of control for the positioning of a menu to ensure perfect alignment. <code>md-menu</code> provides the <code>md-offset</code> attribute to allow pixel level specificty of adjusting the exact positioning.</p><p>This offset is provided in the format of <code>x y</code> or <code>n</code> where <code>n</code> will be used in both the <code>x</code> and <code>y</code> axis.</p><p>For example, to move a menu by <code>2px</code> from the top, we can use:</p><hljs lang=\"html\"><md-menu md-offset=\"2 0\"></md-menu></hljs><h3 id=\"preventing-close\">Preventing close</h3><p>Sometimes you would like to be able to click on a menu item without having the menu close. To do this, ngMaterial exposes the <code>md-prevent-menu-close</code> attribute which can be added to a button inside a menu to stop the menu from automatically closing. You can then close the menu programatically by injecting <code>$mdMenu</code> and calling <code>$mdMenu.hide()</code>.</p><hljs lang=\"html\"><md-menu-item><md-button ng-click=\"doSomething()\" aria-label=\"Do something\" md-prevent-menu-close=\"md-prevent-menu-close\"><md-icon md-menu-align-target=\"\" md-svg-icon=\"call:phone\"></md-icon>Do Something</md-button></md-menu-item></hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\"><md-icon md-svg-icon=\"call:phone\"></md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=\"doSomething()\">Do Something</md-button></md-menu-item></md-menu-content></md-menu></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-position-mode</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The position mode in the form of <code>x</code>, <code>y</code>. Default value is <code>target</code>,<code>target</code>. Right now the <code>x</code> axis also suppports <code>target-right</code>.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-offset</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>An offset to apply to the dropdown after positioning <code>x</code>, <code>y</code>. Default value is <code>0</code>,<code>0</code>.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/directive/mdList.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-list&gt;</code> directive is a list container for 1..n <code>&lt;md-list-item&gt;</code> tags.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"item in todos\"><md-checkbox ng-model=\"item.done\"></md-checkbox><div class=\"md-list-item-text\"><h3>{{item.title}}</h3><p>{{item.description}}</p></div></md-list-item></md-list></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/directive/mdListItem.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-list-item&gt;</code> directive is a container intended for row items in a <code>&lt;md-list&gt;</code> container. The <code>md-2-line</code> and <code>md-3-line</code> classes can be added to a <code>&lt;md-list-item&gt;</code> to increase the height with 22px and 40px respectively.</p><h2 id=\"css\">CSS</h2><p><code>.md-avatar</code> - class for image avatars</p><p><code>.md-avatar-icon</code> - class for icon avatars</p><p><code>.md-offset</code> - on content without an avatar</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-list><md-list-item><img class=\"md-avatar\" ng-src=\"path/to/img\"> <span>Item content in list</span></md-list-item><md-list-item><md-icon class=\"md-avatar-icon\" md-svg-icon=\"communication:phone\"></md-icon><span>Item content in list</span></md-list-item></md-list></hljs><p><em><strong>Note:</strong> We automatically apply special styling when the inner contents are wrapped inside of a <code>&lt;md-button&gt;</code> tag. This styling is automatically ignored for <code>class=&quot;md-secondary&quot;</code> buttons and you can include a class of <code>class=&quot;md-exclude&quot;</code> if you need to use a non-secondary button that is inside the list, but does not wrap the contents.</em></p></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu-bar/directive/mdMenuBar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Menu bars are containers that hold multiple menus. They change the behavior and appearence of the <code>md-menu</code> directive to behave similar to an operating system provided menu.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-menu-bar><md-menu><button ng-click=\"$mdOpenMenu()\">File</button><md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'share\', $event)\">Share...</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-menu-item><md-menu><md-button ng-click=\"$mdOpenMenu()\">New</md-button><md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Document\', $event)\">Document</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Spreadsheet\', $event)\">Spreadsheet</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Presentation\', $event)\">Presentation</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Form\', $event)\">Form</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Drawing\', $event)\">Drawing</md-button></md-menu-item></md-menu-content></md-menu></md-menu-item></md-menu-item></md-menu-content></md-menu></md-menu-bar></hljs><h2 id=\"menu-bar-controls\">Menu Bar Controls</h2><p>You may place <code>md-menu-items</code> that function as controls within menu bars. There are two modes that are exposed via the <code>type</code> attribute of the <code>md-menu-item</code>. <code>type=&quot;checkbox&quot;</code> will function as a boolean control for the <code>ng-model</code> attribute of the <code>md-menu-item</code>. <code>type=&quot;radio&quot;</code> will function like a radio button, setting the <code>ngModel</code> to the <code>string</code> value of the <code>value</code> attribute. If you need non-string values, you can use <code>ng-value</code> to provide an expression (this is similar to how angular&#39;s native <code>input[type=radio]</code> works.</p><hljs lang=\"html\"><md-menu-bar><md-menu><button ng-click=\"$mdOpenMenu()\">Sample Menu</button><md-menu-content><md-menu-item type=\"checkbox\" ng-model=\"settings.allowChanges\">Allow changes</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item type=\"radio\" ng-model=\"settings.mode\" ng-value=\"1\">Mode 1</md-menu-item><md-menu-item type=\"radio\" ng-model=\"settings.mode\" ng-value=\"1\">Mode 2</md-menu-item><md-menu-item type=\"radio\" ng-model=\"settings.mode\" ng-value=\"1\">Mode 3</md-menu-item></md-menu-content></md-menu></md-menu-bar></hljs><h3 id=\"nesting-menus\">Nesting Menus</h3><p>Menus may be nested within menu bars. This is commonly called cascading menus. To nest a menu place the nested menu inside the content of the <code>md-menu-item</code>.</p><hljs lang=\"html\"><md-menu-item><md-menu><button ng-click=\"$mdOpenMenu()\">New<md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Document\', $event)\">Document</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Spreadsheet\', $event)\">Spreadsheet</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Presentation\', $event)\">Presentation</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Form\', $event)\">Form</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Drawing\', $event)\">Drawing</md-button></md-menu-item></md-menu-content></button></md-menu></md-menu-item></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressCircular/directive/mdProgressCircular.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The circular progress directive is used to make loading content in your app as delightful and painless as possible by minimizing the amount of visual change a user sees before they can view and interact with content.</p><p>For operations where the percentage of the operation completed can be determined, use a determinate indicator. They give users a quick sense of how long an operation will take.</p><p>For operations where the user is asked to wait a moment while something finishes up, and it’s not necessary to expose what&#39;s happening behind the scenes and how long it will take, use an indeterminate indicator.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-progress-circular md-mode=\"determinate\" value=\"...\"></md-progress-circular><md-progress-circular md-mode=\"determinate\" ng-value=\"...\"></md-progress-circular><md-progress-circular md-mode=\"determinate\" value=\"...\" md-diameter=\"100\"></md-progress-circular><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-mode</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Select from one of two modes: <strong>&#39;determinate&#39;</strong> and <strong>&#39;indeterminate&#39;</strong>.</p><p>Note: if the <code>md-mode</code> value is set as undefined or specified as not 1 of the two (2) valid modes, then <code>.ng-hide</code> will be auto-applied as a style to the component.</p><p>Note: if not configured, the <code>md-mode=&quot;indeterminate&quot;</code> will be auto injected as an attribute. If <code>value=&quot;&quot;</code> is also specified, however, then <code>md-mode=&quot;determinate&quot;</code> would be auto-injected instead.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>In determinate mode, this number represents the percentage of the circular progress. Default: 0</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-diameter <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>This specifies the diamter of the circular progress. The value may be a percentage (eg &#39;25%&#39;) or a pixel-size value (eg &#39;48&#39;). If this attribute is not present then a default value of &#39;48px&#39; is assumed.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressLinear/directive/mdProgressLinear.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The linear progress directive is used to make loading content in your app as delightful and painless as possible by minimizing the amount of visual change a user sees before they can view and interact with content.</p><p>Each operation should only be represented by one activity indicator For example: one refresh operation should not display both a refresh bar and an activity circle.</p><p>For operations where the percentage of the operation completed can be determined, use a determinate indicator. They give users a quick sense of how long an operation will take.</p><p>For operations where the user is asked to wait a moment while something finishes up, and it’s not necessary to expose what&#39;s happening behind the scenes and how long it will take, use an indeterminate indicator.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-progress-linear md-mode=\"determinate\" value=\"...\"></md-progress-linear><md-progress-linear md-mode=\"determinate\" ng-value=\"...\"></md-progress-linear><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><md-progress-linear md-mode=\"buffer\" value=\"...\" md-buffer-value=\"...\"></md-progress-linear><md-progress-linear md-mode=\"query\"></md-progress-linear></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-mode</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Select from one of four modes: determinate, indeterminate, buffer or query.</p><p>Note: if the <code>md-mode</code> value is set as undefined or specified as 1 of the four (4) valid modes, then <code>.ng-hide</code> will be auto-applied as a style to the component.</p><p>Note: if not configured, the <code>md-mode=&quot;indeterminate&quot;</code> will be auto injected as an attribute. If <code>value=&quot;&quot;</code> is also specified, however, then <code>md-mode=&quot;determinate&quot;</code> would be auto-injected instead.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-buffer-value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/directive/mdRadioButton.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-radio-button&gt;</code>directive is the child directive required to be used within <code>&lt;md-radio-group&gt;</code> elements.</p><p>While similar to the <code>&lt;input type=&quot;radio&quot; ng-model=&quot;&quot; value=&quot;&quot;&gt;</code> directive, the <code>&lt;md-radio-button&gt;</code> directive provides ink effects, ARIA support, and supports use within named radio groups.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-radio-button value=\"1\" aria-label=\"Label 1\">Label 1</md-radio-button><md-radio-button ng-model=\"color\" ng-value=\"specialValue\" aria-label=\"Green\">Green</md-radio-button></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ngModel</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Assignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ngValue</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Angular expression which sets the value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* value</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ngChange <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Angular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">name <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Adds label to radio button for accessibility. Defaults to radio button&#39;s text. If no text content is available, a warning will be logged.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/directive/mdRadioGroup.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-radio-group&gt;</code> directive identifies a grouping container for the 1..n grouped radio buttons; specified using nested <code>&lt;md-radio-button&gt;</code> tags.</p><p>As per the <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">material design spec</a> the radio button is in the accent color by default. The primary color palette may be used with the <code>md-primary</code> class.</p><p>Note: <code>&lt;md-radio-group&gt;</code> and <code>&lt;md-radio-button&gt;</code> handle tabindex differently than the native <code>&lt;input type=&#39;radio&#39;&gt;</code> controls. Whereas the native controls force the user to tab through all the radio buttons, <code>&lt;md-radio-group&gt;</code> is focusable, and by default the <code>&lt;md-radio-button&gt;</code>s are not.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-radio-group ng-model=\"selected\"><md-radio-button ng-repeat=\"d in colorOptions\" ng-value=\"d.value\" aria-label=\"{{ d.label }}\">{{ d.label }}</md-radio-button></md-radio-group></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Assignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Use of attribute indicates flag to disable ink ripple effects.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.select/directive/mdSelect.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Displays a select box, bound to an ng-model.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>With a placeholder (label and aria-label are added dynamically)</p><hljs lang=\"html\"><md-input-container><md-select ng-model=\"someModel\" placeholder=\"Select a state\"><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">{{ opt }}</md-option></md-select></md-input-container></hljs><p>With an explicit label</p><hljs lang=\"html\"><md-input-container><label>State</label><md-select ng-model=\"someModel\"><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">{{ opt }}</md-option></md-select></md-input-container></hljs><h2 id=\"selects-and-object-equality\">Selects and object equality</h2><p>When using a <code>md-select</code> to pick from a list of objects, it is important to realize how javascript handles equality. Consider the following example:</p><hljs lang=\"js\">angular.controller(&#39;MyCtrl&#39;, function($scope) { $scope.users = [ { id: 1, name: &#39;Bob&#39; }, { id: 2, name: &#39;Alice&#39; }, { id: 3, name: &#39;Steve&#39; } ]; $scope.selectedUser = { id: 1, name: &#39;Bob&#39; }; });</hljs><hljs lang=\"html\"><div ng-controller=\"MyCtrl\"><md-select ng-model=\"selectedUser\"><md-option ng-value=\"user\" ng-repeat=\"user in users\">{{ user.name }}</md-option></md-select></div></hljs><p>At first one might expect that the select should be populated with &quot;Bob&quot; as the selected user. However, this is not true. To determine whether something is selected, <code>ngModelController</code> is looking at whether <code>$scope.selectedUser == (any user in $scope.users);</code>;</p><p>Javascript&#39;s <code>==</code> operator does not check for deep equality (ie. that all properties on the object are the same), but instead whether the objects are <em>the same object in memory</em>. In this case, we have two instances of identical objects, but they exist in memory as unique entities. Because of this, the select will have no value populated for a selected user.</p><p>To get around this, <code>ngModelController</code> provides a <code>track by</code> option that allows us to specify a different expression which will be used for the equality operator. As such, we can update our <code>html</code> to make use of this by specifying the <code>ng-model-options=&quot;{trackBy: &#39;$value.id&#39;}&quot;</code> on the <code>md-select</code> element. This converts our equality expression to be <code>$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));</code> which results in Bob being selected as desired.</p><p>Working HTML:</p><hljs lang=\"html\"><div ng-controller=\"MyCtrl\"><md-select ng-model=\"selectedUser\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-value=\"user\" ng-repeat=\"user in users\">{{ user.name }}</md-option></md-select></div></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>The model!</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">multiple <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether it&#39;s multiple.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-close <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Expression to be evaluated when the select is closed.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">placeholder <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder hint text.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Optional label for accessibility. Only necessary if no placeholder or explicit label is present.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-container-class <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Class list to get applied to the <code>.md-select-menu-container</code> element (for custom styling).</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/service/$mdSidenav.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdSidenav</code> makes it easy to interact with multiple sidenavs in an app.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">// Async lookup for sidenav instance; will resolve when the instance is available $mdSidenav(componentId).then(function(instance) { $log.debug( componentId + &quot;is now ready&quot; ); }); // Async toggle the given sidenav; // when instance is known ready and lazy lookup is not needed. $mdSidenav(componentId) .toggle() .then(function(){ $log.debug(&#39;toggled&#39;); }); // Async open the given sidenav $mdSidenav(componentId) .open() .then(function(){ $log.debug(&#39;opened&#39;); }); // Async close the given sidenav $mdSidenav(componentId) .close() .then(function(){ $log.debug(&#39;closed&#39;); }); // Sync check to see if the specified sidenav is set to be open $mdSidenav(componentId).isOpen(); // Sync check to whether given sidenav is locked open // If this is true, the sidenav will be open regardless of close() $mdSidenav(componentId).isLockedOpen();</hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/directive/mdSidenav.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>A Sidenav component that can be opened and closed programatically.</p><p>By default, upon opening it will slide out on top of the main content area.</p><p>For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default. It can be overridden with the <code>md-autofocus</code> directive on the child element you want focused.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div layout=\"row\" ng-controller=\"MyController\"><md-sidenav md-component-id=\"left\" class=\"md-sidenav-left\">Left Nav!</md-sidenav><md-content>Center Content<md-button ng-click=\"openLeftMenu()\">Open Left Menu</md-button></md-content><md-sidenav md-component-id=\"right\" md-is-locked-open=\"$mdMedia(\'min-width: 333px\')\" class=\"md-sidenav-right\"><form><md-input-container><label for=\"testInput\">Test input</label> <input id=\"testInput\" type=\"text\" ng-model=\"data\" md-autofocus=\"\"></md-input-container></form></md-sidenav></div></hljs><hljs lang=\"js\">var app = angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdSidenav) { $scope.openLeftMenu = function() { $mdSidenav(&#39;left&#39;).toggle(); }; });</hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-is-open <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>A model bound to whether the sidenav is opened.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-component-id <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>componentId to use with $mdSidenav service.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-is-locked-open <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>When this expression evalutes to true, the sidenav &#39;locks open&#39;: it falls into the content&#39;s flow instead of appearing over it. This overrides the <code>is-open</code> attribute.</p><p>The $mdMedia() service is exposed to the is-locked-open attribute, which can be given a media query or one of the <code>sm</code>, <code>gt-sm</code>, <code>md</code>, <code>gt-md</code>, <code>lg</code> or <code>gt-lg</code> presets. Examples:</p><ul><li><code>&lt;md-sidenav md-is-locked-open=&quot;shouldLockOpen&quot;&gt;&lt;/md-sidenav&gt;</code></li><li><code>&lt;md-sidenav md-is-locked-open=&quot;$mdMedia(&#39;min-width: 1000px&#39;)&quot;&gt;&lt;/md-sidenav&gt;</code></li><li><code>&lt;md-sidenav md-is-locked-open=&quot;$mdMedia(&#39;sm&#39;)&quot;&gt;&lt;/md-sidenav&gt;</code> (locks open on small screens)</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/directive/mdSidenavFocus.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>mdSidenavFocus</code> provides a way to specify the focused element when a sidenav opens. This is completely optional, as the sidenav itself is focused by default.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-sidenav><form><md-input-container><label for=\"testInput\">Label</label> <input id=\"testInput\" type=\"text\" md-sidenav-focus=\"\"></md-input-container></form></md-sidenav></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.slider/directive/mdSlider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-slider&gt;</code> component allows the user to choose from a range of values.</p><p>As per the <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">material design spec</a> the slider is in the accent color by default. The primary color palette may be used with the <code>md-primary</code> class.</p><p>It has two modes: &#39;normal&#39; mode, where the user slides between a wide range of values, and &#39;discrete&#39; mode, where the user slides between only a few select values.</p><p>To enable discrete mode, add the <code>md-discrete</code> attribute to a slider, and use the <code>step</code> attribute to change the distance between values the user is allowed to pick.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p></p><h4>Normal Mode</h4><p></p><hljs lang=\"html\"><md-slider ng-model=\"myValue\" min=\"5\" max=\"500\"></md-slider></hljs><h4>Discrete Mode</h4><hljs lang=\"html\"><md-slider md-discrete=\"\" ng-model=\"myDiscreteValue\" step=\"10\" min=\"10\" max=\"130\"></md-slider></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-discrete <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether to enable discrete mode.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">step <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The distance between values the user is allowed to pick. Default 1.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">min <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The minimum value the user is allowed to pick. Default 0.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">max <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The maximum value the user is allowed to pick. Default 100.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sticky/service/$mdSticky.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>$mdSticky</code>service provides a mixin to make elements sticky.</p></div><div><section class=\"api-section\"><section class=\"api-section\"></section><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td></td><td class=\"description\"><p>A <code>$mdSticky</code> function that takes three arguments:</p><ul><li><code>scope</code></li><li><code>element</code>: The element that will be &#39;sticky&#39;</li><li><code>elementClone</code>: A clone of the element, that will be shown when the user starts scrolling past the original element. If not provided, it will use the result of <code>element.clone()</code>.</li></ul></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.subheader/directive/mdSubheader.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-subheader&gt;</code> directive is a subheader for a section. By default it is sticky. You can make it not sticky by applying the <code>md-no-sticky</code> class to the subheader.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-subheader>Online Friends</md-subheader></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeDown.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The md-swipe-down directive allows you to specify custom behavior when an element is swiped down.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-down=\"onSwipDown()\">Swipe me down!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeLeft.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The md-swipe-left directive allows you to specify custom behavior when an element is swiped left.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-left=\"onSwipeLeft()\">Swipe me left!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeRight.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The md-swipe-right directive allows you to specify custom behavior when an element is swiped right.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-right=\"onSwipeRight()\">Swipe me right!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeUp.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The md-swipe-up directive allows you to specify custom behavior when an element is swiped up.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-up=\"onSwipeUp()\">Swipe me up!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.switch/directive/mdSwitch.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-switch ng-model=\"isActive\" aria-label=\"Finished?\">Finished ?</md-switch><md-switch md-no-ink=\"\" ng-model=\"hasInk\" aria-label=\"No Ink Effects\">No Ink Effects</md-switch><md-switch ng-disabled=\"true\" ng-model=\"isDisabled\" aria-label=\"Disabled\">Disabled</md-switch></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* ng-model</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Assignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">name <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-true-value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>The value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-false-value <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>The value to which the expression should be set when not selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-change <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Angular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-disabled <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>En/Disable based on the expression.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Use of attribute indicates use of ripple ink effects.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">aria-label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Publish the button label used by screen-readers for accessibility. Defaults to the switch&#39;s text.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toast/service/$mdToast.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdToast</code> is a service to build a toast notification on any position on the screen with an optional duration, and provides a simple promise API.</p><h2 id=\"restrictions-on-custom-toasts\">Restrictions on custom toasts</h2><ul><li>The toast&#39;s template must have an outer <code>&lt;md-toast&gt;</code> element.</li><li>For a toast action, use element with class <code>md-action</code>.</li><li>Add the class <code>md-capsule</code> for curved corners.</li></ul><h2 id=\"parent-container-notes\">Parent container notes</h2><p>The toast is positioned using absolute positioning relative to it&#39;s first non-static parent container. Thus, if the requested parent container uses static positioning, we will temporarily set it&#39;s positioning to <code>relative</code> while the toast is visible and reset it when the toast is hidden.</p><p>Because of this, it is usually best to ensure that the parent container has a fixed height and prevents scrolling by setting the <code>overflow: hidden;</code> style. Since the position is based off of the parent&#39;s height, the toast may be mispositioned if you allow the parent to scroll.</p><p>You can, however, have a scrollable element inside of the container; just make sure the container itself does not scroll.</p><hljs lang=\"html\"><div layout-fill=\"\" id=\"toast-container\"><md-content>I can have lots of content and scroll!</md-content></div></hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div ng-controller=\"MyController\"><md-button ng-click=\"openToast()\">Open a Toast!</md-button></div></hljs><hljs lang=\"js\">var app = angular.module(&#39;app&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdToast) { $scope.openToast = function($event) { $mdToast.show($mdToast.simple().textContent(&#39;Hello!&#39;)); // Could also do $mdToast.showSimple(&#39;Hello&#39;); }; });</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"showSimple\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.showSimple(message);\n</code></h3><div class=\"service-desc\"><p>Convenience method which builds and shows a simple toast.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* message</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>The message to display inside the toast</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that can be resolved with <code>$mdToast.hide()</code> or rejected with <code>$mdToast.cancel()</code>.</p></td></tr></tbody></table></div></li><li id=\"simple\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.simple();\n</code></h3><div class=\"service-desc\"><p>Builds a preconfigured toast.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>a <code>$mdToastPreset</code> with the following chainable configuration methods.</p><p><em><strong>Note:</strong> These configuration methods are provided in addition to the methods provided by the <code>build()</code> and <code>show()</code> methods below.</em></p><ul><li><p><code>.textContent(string)</code> - Sets the toast content to the specified string.</p></li><li><p><code>.action(string)</code> - Adds an action button. If clicked, the promise (returned from <code>show()</code>) will resolve with the value <code>&#39;ok&#39;</code>; otherwise, it is resolved with <code>true</code> after a <code>hideDelay</code> timeout.</p></li><li><p><code>.highlightAction(boolean)</code> - Whether or not the action button will have an additional highlight class.</p></li><li><p><code>.capsule(boolean)</code> - Whether or not to add the <code>md-capsule</code> class to the toast to provide rounded corners.</p></li><li><p><code>.theme(string)</code> - Sets the theme on the toast to the requested theme. Default is <code>$mdThemingProvider</code>&#39;s default.</p></li></ul></td></tr></tbody></table></div></li><li id=\"updateTextContent\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.updateTextContent();\n</code></h3><div class=\"service-desc\"><p>Updates the content of an existing toast. Useful for updating things like counts, etc.</p></div><div class=\"method-param-table\"></div></li><li id=\"build\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.build();\n</code></h3><div class=\"service-desc\"><p>Creates a custom <code>$mdToastPreset</code> that you can configure.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>a <code>$mdToastPreset</code> with the chainable configuration methods for shows&#39; options (see below).</p></td></tr></tbody></table></div></li><li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.show(optionsOrPreset);\n</code></h3><div class=\"service-desc\"><p>Shows the toast.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* optionsOrPreset</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Either provide an <code>$mdToastPreset</code> returned from <code>simple()</code> and <code>build()</code>, or an options object with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>: The url of an html template file that will be used as the content of the toast. Restrictions: the template must have an outer <code>md-toast</code> element.</li><li><code>template</code> - <code>{string=}</code>: Same as templateUrl, except this is an actual template string.</li><li><code>scope</code> - <code>{object=}</code>: the scope to link the template / controller to. If none is specified, it will create a new child scope. This scope will be destroyed when the toast is removed unless <code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>: whether to preserve the scope when the element is removed. Default is false</li><li><code>hideDelay</code> - <code>{number=}</code>: How many milliseconds the toast should stay active before automatically closing. Set to 0 or false to have the toast stay open until closed manually. Default: 3000.</li><li><code>position</code> - <code>{string=}</code>: Where to place the toast. Available: any combination of &#39;bottom&#39;, &#39;left&#39;, &#39;top&#39;, &#39;right&#39;. Default: &#39;bottom left&#39;.</li><li><code>controller</code> - <code>{string=}</code>: The controller to associate with this toast. The controller will be injected the local <code>$mdToast.hide( )</code>, which is a function used to hide the toast.</li><li><code>locals</code> - <code>{string=}</code>: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, <code>locals: {three: 3}</code> would inject <code>three</code> into the controller with the value of 3.</li><li><code>bindToController</code> - <code>bool</code>: bind the locals to the controller, instead of passing them in. These values will not be available until after initialization.</li><li><code>resolve</code> - <code>{object=}</code>: Similar to locals, except it takes promises as values and the toast will not open until the promises resolve.</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li><li><code>parent</code> - <code>{element=}</code>: The element to append the toast to. Defaults to appending to the root element of the application.</li></ul></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>A promise that can be resolved with <code>$mdToast.hide()</code> or rejected with <code>$mdToast.cancel()</code>. <code>$mdToast.hide()</code> will resolve either with a Boolean value == &#39;true&#39; or the value passed as an argument to <code>$mdToast.hide()</code>. And <code>$mdToast.cancel()</code> will resolve the promise with a Boolean value == &#39;false&#39;</p></td></tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.hide([response]);\n</code></h3><div class=\"service-desc\"><p>Hide an existing toast and resolve the promise returned from <code>$mdToast.show()</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the resolved promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>a promise that is called when the existing element is removed from the DOM. The promise is resolved with either a Boolean value == &#39;true&#39; or the value passed as the argument to <code>.hide()</code>.</p></td></tr></tbody></table></div></li><li id=\"cancel\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.cancel([response]);\n</code></h3><div class=\"service-desc\"><p><code>DEPRECATED</code> - The promise returned from opening a toast is used only to notify about the closing of the toast. As such, there isn&#39;t any reason to also allow that promise to be rejected, since it&#39;s not clear what the difference between resolve and reject would be.</p><p>Hide the existing toast and reject the promise returned from <code>$mdToast.show()</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">response <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>An argument for the rejected promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>a promise that is called when the existing element is removed from the DOM The promise is resolved with a Boolean value == &#39;false&#39;.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/directive/mdTab.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Use the <code>&lt;md-tab&gt;</code> a nested directive used within <code>&lt;md-tabs&gt;</code> to specify a tab with a <strong>label</strong> and optional <em>view content</em>.</p><p>If the <code>label</code> attribute is not specified, then an optional <code>&lt;md-tab-label&gt;</code> tag can be used to specify more complex tab header markup. If neither the <strong>label</strong> nor the <strong>md-tab-label</strong> are specified, then the nested markup of the <code>&lt;md-tab&gt;</code> is used as the tab header markup.</p><p>Please note that if you use <code>&lt;md-tab-label&gt;</code>, your content <strong>MUST</strong> be wrapped in the <code>&lt;md-tab-body&gt;</code> tag. This is to define a clear separation between the tab content and the tab label.</p><p>This container is used by the TabsController to show/hide the active tab&#39;s content view. This synchronization is automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can be initiated via data binding changes, programmatic invocation, or user gestures.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-tab label=\"\" disabled=\"\" md-on-select=\"\" md-on-deselect=\"\"><h3>My Tab content</h3></md-tab><md-tab><md-tab-label><h3>My Tab content</h3></md-tab-label><md-tab-body><p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p></md-tab-body></md-tab></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">label <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Optional attribute to specify a simple string as the tab label</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">ng-disabled <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If present, disabled tab selection.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-deselect <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Expression to be evaluated after the tab has been de-selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-select <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Expression to be evaluated after the tab has been selected.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-active <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When true, sets the active tab. Note: There can only be one active tab at a time.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/directive/mdTabs.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>&lt;md-tabs&gt;</code> directive serves as the container for 1..n <code>&lt;md-tab&gt;</code> child directives to produces a Tabs components. In turn, the nested <code>&lt;md-tab&gt;</code> directive is used to specify a tab label for the <strong>header button</strong> and a [optional] tab view content that will be associated with each tab button.</p><p>Below is the markup for its simplest usage:</p><hljs lang=\"html\"><md-tabs><md-tab label=\"Tab #1\"></md-tab><md-tab label=\"Tab #2\"></md-tab><md-tab label=\"Tab #3\"></md-tab></md-tabs></hljs><p>Tabs supports three (3) usage scenarios:</p><ol><li>Tabs (buttons only)</li><li>Tabs with internal view content</li><li>Tabs with external view content</li></ol><p><strong>Tab-only</strong> support is useful when tab buttons are used for custom navigation regardless of any other components, content, or views. <strong>Tabs with internal views</strong> are the traditional usages where each tab has associated view content and the view switching is managed internally by the Tabs component. <strong>Tabs with external view content</strong> is often useful when content associated with each tab is independently managed and data-binding notifications announce tab selection changes.</p><p>Additional features also include:</p><ul><li>Content can include any markup.</li><li>If a tab is disabled while active/selected, then the next tab will be auto-selected.</li></ul><h3 id=\"explanation-of-tab-stretching\">Explanation of tab stretching</h3><p>Initially, tabs will have an inherent size. This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS. Calculations will be based on this size.</p><p>On mobile devices, tabs will be expanded to fill the available horizontal space. When this happens, all tabs will become the same size.</p><p>On desktops, by default, stretching will never occur.</p><p>This default behavior can be overridden through the <code>md-stretch-tabs</code> attribute. Here is a table showing when stretching will occur:</p><table><thead><tr><th><code>md-stretch-tabs</code></th><th>mobile</th><th>desktop</th></tr></thead><tbody><tr><td><code>auto</code></td><td>stretched</td><td>---</td></tr><tr><td><code>always</code></td><td>stretched</td><td>stretched</td></tr><tr><td><code>never</code></td><td>---</td><td>---</td></tr></tbody></table></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-tabs md-selected=\"selectedIndex\"><img ng-src=\"assets/angular-material-assets/img/angular.png\" class=\"centered\"><md-tab ng-repeat=\"tab in tabs | orderBy:predicate:reversed\" md-on-select=\"onTabSelected(tab)\" md-on-deselect=\"announceDeselected(tab)\" ng-disabled=\"tab.disabled\"><md-tab-label>{{tab.title}} <img src=\"assets/angular-material-assets/img/removeTab.png\" ng-click=\"removeTab(tab)\" class=\"delete\"></md-tab-label><md-tab-body>{{tab.content}}</md-tab-body></md-tab></md-tabs></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-selected <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-integer\">integer</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-integer\">integer</code></td><td class=\"description\"><p>Index of the active/selected tab</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If present, disables ink ripple effects.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-ink-bar <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If present, disables the selection ink bar.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-align-tabs <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Attribute to indicate position of tab buttons: <code>bottom</code> or <code>top</code>; default is <code>top</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-stretch-tabs <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Attribute to indicate whether or not to stretch tabs: <code>auto</code>, <code>always</code>, or <code>never</code>; default is <code>auto</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-dynamic-height <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When enabled, the tab wrapper will resize based on the contents of the selected tab</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-center-tabs <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When enabled, tabs will be centered provided there is no need for pagination</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-no-pagination <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When enabled, pagination will remain off</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-swipe-content <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When enabled, swipe gestures will be enabled for the content area to jump between tabs</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-enable-disconnect <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When enabled, scopes will be disconnected for tabs that are not being displayed. This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-autoselect <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, any tabs added after the initial load will be automatically selected</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toolbar/directive/mdToolbar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>md-toolbar</code> is used to place a toolbar in your app.</p><p>Toolbars are usually used above a content area to display the title of the current page, and show relevant action buttons for that page.</p><p>You can change the height of the toolbar by adding either the <code>md-medium-tall</code> or <code>md-tall</code> class to the toolbar.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div layout=\"column\" layout-fill=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><span>My App&#39;s Title</span><span flex=\"\"></span><md-button>Right Bar Button</md-button></div></md-toolbar><md-content>Hello!</md-content></div></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-scroll-shrink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether the header should shrink away as the user scrolls down, and reveal itself as the user scrolls up.</p><p><em><strong>Note (1):</strong> for scrollShrink to work, the toolbar must be a sibling of a <code>md-content</code> element, placed before it. See the scroll shrink demo.</em></p><p><em><strong>Note (2):</strong> The <code>md-scroll-shrink</code> attribute is only parsed on component initialization, it does not watch for scope changes.</em></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-shrink-speed-factor <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>How much to change the speed of the toolbar&#39;s shrinking by. For example, if 0.25 is given then the toolbar will shrink at one fourth the rate at which the user scrolls down. Default 0.5.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tooltip/directive/mdTooltip.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Tooltips are used to describe elements that are interactive and primarily graphical (not textual).</p><p>Place a <code>&lt;md-tooltip&gt;</code> as a child of the element it describes.</p><p>A tooltip will activate when the user focuses, hovers over, or touches the parent.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-button class=\"md-fab md-accent\" aria-label=\"Play\"><md-tooltip>Play Music</md-tooltip><md-icon icon=\"assets/angular-material-assets/img/icons/ic_play_arrow_24px.svg\"></md-icon></md-button></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-visible <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>Boolean bound to whether the tooltip is currently visible.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-delay <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>How many milliseconds to wait to show the tooltip after the user focuses, hovers, or touches the parent. Defaults to 300ms.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-autohide <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>If present or provided with a boolean value, the tooltip will hide on mouse leave, regardless of focus</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-direction <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Which direction would you like the tooltip to go? Supports left, right, top, and bottom. Defaults to bottom.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/directive/mdVirtualRepeat.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>md-virtual-repeat</code> specifies an element to repeat using virtual scrolling.</p><p>Virtual repeat is a limited substitute for ng-repeat that renders only enough dom nodes to fill the container and recycling them as the user scrolls. Arrays, but not objects are supported for iteration. Track by, as alias, and (key, value) syntax are not supported.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-virtual-repeat-container><div md-virtual-repeat=\"i in items\">Hello {{i}}!</div></md-virtual-repeat-container><md-virtual-repeat-container md-orient-horizontal=\"\"><div md-virtual-repeat=\"i in items\" md-item-size=\"20\">Hello {{i}}!</div></md-virtual-repeat-container></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-item-size <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>The height or width of the repeated elements (which must be identical for each element). Optional. Will attempt to read the size from the dom if missing, but still assumes that all repeated nodes have same height or width.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-extra-name <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Evaluates to an additional name to which the current iterated item can be assigned on the repeated scope (needed for use in <code>md-autocomplete</code>).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-on-demand <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, treats the md-virtual-repeat argument as an object that can fetch rows rather than an array.</p><p><strong>NOTE:</strong> This object must implement the following interface with two (2) methods:</p><ul><li><code>getItemAtIndex: function(index) [object]</code> The item at that index or null if it is not yet loaded (it should start downloading the item in that case).</li><li><code>getLength: function() [number]</code> The data length to which the repeater container should be sized. Ideally, when the count is known, this method should return it. Otherwise, return a higher number than the currently loaded items to produce an infinite-scroll behavior.</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/directive/mdVirtualRepeatContainer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>md-virtual-repeat-container</code> provides the scroll container for md-virtual-repeat.</p><p>Virtual repeat is a limited substitute for ng-repeat that renders only enough dom nodes to fill the container and recycling them as the user scrolls.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-virtual-repeat-container md-top-index=\"topIndex\"><div md-virtual-repeat=\"i in items\" md-item-size=\"20\">Hello {{i}}!</div></md-virtual-repeat-container></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-top-index <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Binds the index of the item that is at the top of the scroll container to $scope. It can both read and set the scroll position.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-orient-horizontal <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether the container should scroll horizontally (defaults to orientation and scrolling vertically).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-auto-shrink <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, the container will shrink to fit the number of items when that number is less than its original size.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">md-auto-shrink-min <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>Minimum number of items that md-auto-shrink will shrink to (default: 0).</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdButtonInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Provides ripple effects for md-button. See $mdInkRipple service for all possible configuration options.</p></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">scope <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Scope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">options <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>(Optional) Configuration options to override the default ripple configuration</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdCheckboxInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Provides ripple effects for md-checkbox. See $mdInkRipple service for all possible configuration options.</p></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">scope <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Scope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">options <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdListInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Provides ripple effects for md-list. See $mdInkRipple service for all possible configuration options.</p></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">scope <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Scope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">options <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdMedia.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdMedia</code> is used to evaluate whether a given media query is true or false given the current device&#39;s screen / window size. The media query will be re-evaluated on resize, allowing you to register a watch.</p><p><code>$mdMedia</code> also has pre-programmed support for media queries that match the layout breakpoints:</p><table class=\"md-api-table\"><thead><tr><th>Breakpoint</th><th>mediaQuery</th></tr></thead><tbody><tr><td>xs</td><td>(max-width: 599px)</td></tr><tr><td>gt-xs</td><td>(min-width: 600px)</td></tr><tr><td>sm</td><td>(min-width: 600px) and (max-width: 959px)</td></tr><tr><td>gt-sm</td><td>(min-width: 960px)</td></tr><tr><td>md</td><td>(min-width: 960px) and (max-width: 1279px)</td></tr><tr><td>gt-md</td><td>(min-width: 1280px)</td></tr><tr><td>lg</td><td>(min-width: 1280px) and (max-width: 1919px)</td></tr><tr><td>gt-lg</td><td>(min-width: 1920px)</td></tr><tr><td>xl</td><td>(min-width: 1920px)</td></tr></tbody></table><p>See Material Design&#39;s <a href=\"https://www.google.com/design/spec/layout/adaptive-ui.html\">Layout - Adaptive UI</a> for more details.</p><p><a href=\"https://www.google.com/design/spec/layout/adaptive-ui.html\"><img src=\"https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png\" width=\"100%\" height=\"100%\"></a></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">app.controller(&#39;MyController&#39;, function($mdMedia, $scope) { $scope.$watch(function() { return $mdMedia(&#39;lg&#39;); }, function(big) { $scope.bigScreen = big; }); $scope.screenIsSmall = $mdMedia(&#39;sm&#39;); $scope.customQuery = $mdMedia(&#39;(min-width: 1234px)&#39;); $scope.anotherCustom = $mdMedia(&#39;max-width: 300px&#39;); });</hljs></section><section class=\"api-section\"><section class=\"api-section\"></section><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>a boolean representing whether or not the given media query is true or false.</p></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdTabInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Provides ripple effects for md-tabs. See $mdInkRipple service for all possible configuration options.</p></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">scope <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Scope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">options <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.gestures/service/$mdGestureProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>In some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked. <code>$mdGestureProvider</code> is used to configure the Gesture module to ignore or skip click hijacking on mobile devices.</p><hljs lang=\"js\">app.config(function($mdGestureProvider) { // For mobile devices without jQuery loaded, do not // intercept click events during the capture phase. $mdGestureProvider.skipClickHijack(); });</hljs></div><div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/directive/mdInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>The <code>md-ink-ripple</code> directive allows you to specify the ripple color or id a ripple is allowed.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"string-values\">String values</h3><hljs lang=\"html\"><any md-ink-ripple=\"#FF0000\">Ripples in red</any><any md-ink-ripple=\"false\">Not rippling</any></hljs><h3 id=\"interpolated-values\">Interpolated values</h3><hljs lang=\"html\"><any md-ink-ripple=\"{{ randomColor() }}\">Ripples with the return value of &#39;randomColor&#39; function</any><any md-ink-ripple=\"{{ canRipple() }}\">Ripples if &#39;canRipple&#39; function return value is not &#39;false&#39; or &#39;0&#39;</any></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* md-ink-ripple</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>A color string <code>#FF0000</code> or boolean (<code>false</code> or <code>0</code>) for preventing ripple</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/service/$mdInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdInkRipple</code> is a service for adding ripples to any element</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">app.factory(&#39;$myElementInkRipple&#39;, function($mdInkRipple) { return { attach: function (scope, element, options) { return $mdInkRipple.attach(scope, element, angular.extend({ center: false, dimBackground: true }, options)); } }; }); app.controller(&#39;myController&#39;, function ($scope, $element, $myElementInkRipple) { $scope.onClick = function (ev) { $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true }); } });</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"attach\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdInkRipple.attach([scope], [element], [options]);\n</code></h3><div class=\"service-desc\"><p>Attaching given scope, element and options to inkRipple controller</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">scope <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Scope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">options <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultRipple configuration</p><ul><li><code>center</code> - Whether the ripple should start from the center of the container element</li><li><code>dimBackground</code> - Whether the background should be dimmed with the ripple color</li><li><code>colorElement</code> - The element the ripple should take its color from, defined by css property <code>color</code></li><li><code>fitRipple</code> - Whether the ripple should fill the element</li></ul></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.theming/service/$mdThemingProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Provider to configure the <code>$mdTheming</code> service.</p></div><div><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"setDefaultTheme\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdThemingProvider.setDefaultTheme(themeName);\n</code></h3><div class=\"service-desc\"></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* themeName</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Default theme name to be applied to elements. Default value is <code>default</code>.</p></td></tr></tbody></table></div></li><li id=\"alwaysWatchTheme\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdThemingProvider.alwaysWatchTheme(watch);\n</code></h3><div class=\"service-desc\"></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\"><b>* watch</b> <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>Whether or not to always watch themes for changes and re-apply classes when they change. Default is <code>false</code>. Enabling can reduce performance.</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.util/directive/mdAutofocus.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p><code>$mdUtil.findFocusTarget()</code> provides an optional way to identify the focused element when a dialog, bottomsheet, sideNav or other element opens. This is optional attribute finds a nested element with the mdAutoFocus attribute and optional expression. An expression may be specified as the directive value; to enable conditional activation of the autoFocus.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"dialog\">Dialog</h3><hljs lang=\"html\"><md-dialog><form><md-input-container><label for=\"testInput\">Label</label> <input id=\"testInput\" type=\"text\" md-autofocus=\"\"></md-input-container></form></md-dialog></hljs><h3 id=\"bottomsheet\">Bottomsheet</h3><hljs lang=\"html\"><md-bottom-sheet class=\"md-list md-has-header\"><md-subheader>Comment Actions</md-subheader><md-list><md-list-item ng-repeat=\"item in items\"><md-button md-autofocus=\"$index == 2\"><md-icon md-svg-src=\"{{item.icon}}\"></md-icon><span class=\"md-inline-list-icon-label\">{{ item.name }}</span></md-button></md-list-item></md-list></md-bottom-sheet></hljs><h3 id=\"autocomplete\">Autocomplete</h3><hljs lang=\"html\"><md-autocomplete md-autofocus=\"\" md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" md-item-text=\"item.display\"><span md-highlight-text=\"searchText\">{{item.display}}</span></md-autocomplete></hljs><h3 id=\"sidenav\">Sidenav</h3><hljs lang=\"html\"><div layout=\"row\" ng-controller=\"MyController\"><md-sidenav md-component-id=\"left\" class=\"md-sidenav-left\">Left Nav!</md-sidenav><md-content>Center Content<md-button ng-click=\"openLeftMenu()\">Open Left Menu</md-button></md-content><md-sidenav md-component-id=\"right\" md-is-locked-open=\"$mdMedia(\'min-width: 333px\')\" class=\"md-sidenav-right\"><form><md-input-container><label for=\"testInput\">Test input</label> <input id=\"testInput\" type=\"text\" ng-model=\"data\" md-autofocus=\"\"></md-input-container></form></md-sidenav></div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/src/service/$mdTheming.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div class=\"api-profile-description\"><p>Service that makes an element apply theming related classes to itself.</p><pre><code class=\"lang-js\">app.directive(&#39;myFancyDirective&#39;, function($mdTheming) {\n  return {\n    restrict: &#39;e&#39;,\n    link: function(scope, el, attrs) {\n      $mdTheming(el);\n    }\n  };\n});\n</code></pre></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap;\">element <span hide=\"\" show-sm=\"\"><code class=\"api-type label type-hint type-hint-el\">el</code></span></td><td style=\"white-space: nowrap;\"><code class=\"api-type label type-hint type-hint-el\">el</code></td><td class=\"description\"><p>to apply theming to</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");}]);